var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/modules/shippers/pages/new-shipper/new-shipper-page.tsx
import {
  PageLayout as PageLayout2,
  PageContent as PageContent2,
  ToolbarComponent as ToolbarComponent2,
  ToolbarContentComponent as ToolbarContentComponent2,
  ToolbarButtonComponent as ToolbarButtonComponent2,
  BlockContainer as BlockContainer4,
  Block as Block4,
  ErrorMessage as ErrorMessage3
} from "@ontruck/fe-ui";
import { CloseIcon as CloseIcon2 } from "@ontruck/fe-icons";
import React8 from "react";
import { Toaster as Toaster2 } from "sonner";
import useSWR2 from "swr";

// src/modules/shippers/components/shipper-form/shipper-form.tsx
import React5, { useCallback as useCallback5 } from "react";
import {
  FormContainer as FormContainer2,
  Block as Block2,
  BlockContainer as BlockContainer2,
  SectionContainer as SectionContainer2,
  SectionTitle as SectionTitle3,
  SectionBody as SectionBody3,
  SectionLine as SectionLine3,
  Sticky as Sticky2,
  ButtonContainer as ButtonContainer2,
  Half as Half2,
  ButtonComponent as ButtonComponent2,
  Input as Input2,
  ErrorMessage as ErrorMessage2
} from "@ontruck/fe-ui";
import styled4 from "styled-components";

// src/modules/shippers/components/shipper-users-list/shipper-users-table-component.tsx
import React3, { useMemo, useCallback } from "react";
import styled2 from "styled-components";
import { TableComponent } from "@ontruck/fe-ui";

// src/modules/shippers/components/shipper-users-list/get-shipper-users-hook.ts
import useSWR from "swr";

// src/shared/utils/fetch-json.ts
function fetchJson(response) {
  return __async(this, null, function* () {
    const data = yield response.json();
    return data;
  });
}

// src/modules/shippers/components/shipper-users-list/get-shipper-users-api.ts
var getShipperUsersApi = (_0) => __async(void 0, [_0], function* ({
  shipperId,
  config
}) {
  if (!shipperId) {
    return [];
  }
  const endpoint = `${config.api_url}api/users/?shipper=${shipperId}&page_size=0`;
  const response = yield fetch(endpoint, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${config.token}`
    }
  });
  const data = yield fetchJson(response);
  return data;
});

// src/modules/shippers/components/shipper-users-list/get-shipper-users-fetcher.ts
var getShipperUsersFetcher = ({
  config,
  shipperId
}) => {
  return getShipperUsersApi({ shipperId, config });
};

// src/modules/shippers/components/shipper-users-list/get-shipper-users-mapped-service.ts
function getShipperUsersMappedService(shipperUsersDto) {
  if (!shipperUsersDto) {
    return;
  }
  const shipperUsersMapped = shipperUsersDto.map((shipperUserDto) => {
    try {
      const shipperUser = {
        alwaysCc: shipperUserDto.always_cc,
        contactInstructions: shipperUserDto.contact_instructions,
        email: shipperUserDto.email,
        firstName: shipperUserDto.first_name,
        id: shipperUserDto.id,
        isActive: shipperUserDto.is_active,
        lastName: shipperUserDto.last_name,
        name: shipperUserDto.name,
        phoneNumber: shipperUserDto.phone_number,
        userName: shipperUserDto.user_name
      };
      return shipperUser;
    } catch (e) {
      console.error("Error mapping shipper users with id ", shipperUserDto.id);
      console.error(e);
      throw e;
    }
  });
  const count = shipperUsersDto.length === 0 || !shipperUsersDto.length ? 0 : shipperUsersDto.length;
  return {
    shipperUsers: shipperUsersMapped,
    count
  };
}

// src/modules/shippers/components/shipper-users-list/get-shipper-users-hook.ts
var RELOAD_SHIPPER_USERS_LIST_INTERVAL_IN_SECONDS = 30;
var useGetShipperUsersHook = ({
  shipperId,
  config
}) => {
  const fetcher = () => __async(void 0, null, function* () {
    if (!shipperId) {
      return [];
    }
    return getShipperUsersFetcher({ shipperId, config });
  });
  const { data, error, isLoading, mutate } = useSWR(
    `get-shipper-${shipperId}-users`,
    fetcher,
    {
      refreshInterval: RELOAD_SHIPPER_USERS_LIST_INTERVAL_IN_SECONDS * 1e3,
      revalidateIfStale: true
    }
  );
  const shipperUsersMapped = getShipperUsersMappedService(data);
  return {
    shipperUsers: (shipperUsersMapped == null ? void 0 : shipperUsersMapped.shipperUsers) || [],
    count: (shipperUsersMapped == null ? void 0 : shipperUsersMapped.count) || 0,
    isLoading,
    error,
    mutate
  };
};

// src/modules/shippers/components/shipper-users-list/shipper-user-table-row-component.tsx
import React from "react";
import { TableCellComponent, FlexComponent, TextComponent } from "@ontruck/fe-ui";
import styled from "styled-components";

// src/modules/shippers/components/shipper-users-list/shipper-users-table-configuration.ts
var shipperUsersTableColumnsConfiguration = {
  name: {
    label: "Name",
    width: "50%",
    alignment: "left"
  },
  email: {
    label: "email",
    width: "50%",
    alignment: "right"
  }
};

// src/modules/shippers/components/shipper-users-list/shipper-user-table-row-component.tsx
var StyledFlexComponent = styled(FlexComponent)`
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;
function ShipperUserTableRowComponent({
  shipperUser,
  onGoToEditShipperUser,
  shipperId
}) {
  return /* @__PURE__ */ React.createElement(
    StyledFlexComponent,
    {
      alignItems: "center",
      borderBottom: "1px solid var(--otk-theme-color-grey-200, #E2E8EE)",
      borderTop: "1px solid var(--otk-theme-color-grey-200, #E2E8EE)",
      height: "40px",
      onClick: () => {
        onGoToEditShipperUser == null ? void 0 : onGoToEditShipperUser(shipperId, shipperUser.id);
      }
    },
    /* @__PURE__ */ React.createElement(TableCellComponent, { border: false, width: shipperUsersTableColumnsConfiguration.name.width }, /* @__PURE__ */ React.createElement(TextComponent, null, shipperUser.name)),
    /* @__PURE__ */ React.createElement(
      TableCellComponent,
      {
        border: false,
        justifyContent: "end",
        width: shipperUsersTableColumnsConfiguration.email.width
      },
      /* @__PURE__ */ React.createElement(TextComponent, null, shipperUser.email)
    )
  );
}

// src/modules/shippers/components/shipper-users-list/shipper-user-table-row-message-component.tsx
import React2 from "react";
import { TableCellComponent as TableCellComponent2, FlexComponent as FlexComponent2, TextComponent as TextComponent2 } from "@ontruck/fe-ui";
function ShipperUserTableRowMessageComponent({ message }) {
  return /* @__PURE__ */ React2.createElement(
    FlexComponent2,
    {
      alignItems: "center",
      borderBottom: "1px solid var(--otk-theme-color-grey-200, #E2E8EE)",
      borderTop: "1px solid var(--otk-theme-color-grey-200, #E2E8EE)",
      height: "40px"
    },
    /* @__PURE__ */ React2.createElement(TableCellComponent2, { border: false, justifyContent: "center", width: "100%" }, /* @__PURE__ */ React2.createElement(TextComponent2, null, message))
  );
}

// src/modules/shippers/components/shipper-users-list/shipper-users-table-component.tsx
var ShipperUsersTableContainerComponent = styled2.div`
  width: 100%;
`;
function ShipperUsersTableComponent({
  shipperId,
  config,
  shipperFormTranslations,
  onGoToEditShipperUser
}) {
  const { shipperUsers, error, isLoading } = useGetShipperUsersHook({ shipperId, config });
  const getRowsComponents = useCallback(() => {
    if (!shipperId) {
      return {
        numberOfItems: 1,
        rowsComponents: [
          /* @__PURE__ */ React3.createElement(
            ShipperUserTableRowMessageComponent,
            {
              key: "shipper-not-created",
              message: shipperFormTranslations.shipper_users.shipper_not_created
            }
          )
        ]
      };
    }
    if (shipperUsers.length === 0) {
      return {
        numberOfItems: 1,
        rowsComponents: [
          /* @__PURE__ */ React3.createElement(
            ShipperUserTableRowMessageComponent,
            {
              key: "no-users-found",
              message: shipperFormTranslations.shipper_users.no_users_found
            }
          )
        ]
      };
    }
    return {
      numberOfItems: shipperUsers.length,
      rowsComponents: shipperUsers.map((shipperUser) => {
        return /* @__PURE__ */ React3.createElement(
          ShipperUserTableRowComponent,
          {
            key: shipperUser.id,
            onGoToEditShipperUser,
            shipperId,
            shipperUser
          }
        );
      })
    };
  }, [
    onGoToEditShipperUser,
    shipperFormTranslations.shipper_users.no_users_found,
    shipperFormTranslations.shipper_users.shipper_not_created,
    shipperId,
    shipperUsers
  ]);
  const { numberOfItems, rowsComponents } = useMemo(() => getRowsComponents(), [getRowsComponents]);
  return /* @__PURE__ */ React3.createElement(ShipperUsersTableContainerComponent, null, /* @__PURE__ */ React3.createElement(
    TableComponent,
    {
      isError: Boolean(error),
      isLoading,
      numberOfItems,
      rowsComponents
    }
  ));
}

// src/modules/user-management/components/checkboxes.tsx
import { SectionTitle, SectionBody, SectionLine } from "@ontruck/fe-ui";
import styled3 from "styled-components";
var MulticheckboxBodyComponent = styled3(SectionBody)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  padding-top: 16px;
  padding-bottom: 16px;
`;
var MulticheckboxItemComponent = styled3(SectionLine)`
  display: flex;
  align-items: center;
  width: calc(50% - 8px);
  display: flex;
  padding: 8px;
  align-items: center;
  gap: 8px;
  -webkit-align-self: stretch;
  -ms-flex-item-align: stretch;
  align-self: stretch;
  color: var(--grey700);
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  border-radius: 4px;
  background: var(--grey200);
  cursor: pointer;

  label {
    width: 100%;
    justify-content: left;
    color: var(--grey700);
    cursor: pointer;
    flex-direction: row-reverse;
  }
  input {
    margin-right: 8px;
    margin-left: 0px;
    flex-shrink: 0;
    border-radius: 4px;
    background: var(--grey100);
    border: 1px solid var(--grey500);
  }
  input {
    outline: none;
    border: none;
    border-image: none;
    appearance: none;
    background: var(--grey100);
    border: 1px solid var(--grey500);
  }
  input:checked {
    background-color: var(--accent-color-blue);
    border: 1px solid var(--accent-color-blue);
  }
  input:checked::after {
    border: 0;
  }
  &:nth-child(odd) {
    label {
      padding-right: 32px;
    }
  }
  &:nth-child(even) {
  }
`;
var CheckboxListBodyComponent = styled3(SectionBody)`
  display: flex;
  flex-direction: column;
  gap: 0px;
  align-items: start;
`;
var CheckboxListItemComponent = styled3(SectionLine)`
  display: flex;
  align-items: center;
  width: 100%;
  label {
    border-top: 1px solid var(--grey200);
    border-bottom: 1px solid var(--grey200);
    color: var(--grey700);
    cursor: pointer;
    width: 100%;
    padding-bottom: 16px;
    padding-top: 16px;
    padding-left: 24px;
    padding-right: 24px;
  }
  input {
    margin-left: auto;
    flex-shrink: 0;
    border-radius: 4px;
    background: var(--grey100);
    border: 1px solid var(--grey500);
  }
  input {
    outline: none;
    border: none;
    border-image: none;
    appearance: none;
    background: var(--grey100);
    border: 1px solid var(--grey500);
  }
  input:checked {
    background-color: var(--accent-color-blue);
    border: 1px solid var(--accent-color-blue);
  }
  input:checked::after {
    border: 0;
  }
`;
var CheckboxListGroupTitleComponent = styled3(SectionTitle)`
  color: var(--grey700);
  font-weight: 500;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 16px;
  padding-top: 16px;
  color: var(--grey700);
  width: 100%;
  padding-bottom: 16px;
  padding-top: 16px;
  padding-left: 24px;
  padding-right: 24px;
`;
var CategoryInlineCheckboxGroupContainer = styled3.div`
  border-top: 1px solid var(--grey200);
  border-bottom: 1px solid var(--grey200);
  display: flex;
  flex-direction: column;
  gap: 0px;
  align-items: center;
  width: 100%;
  flex-direction: row;
`;
var InlineCheckboxContainer = styled3.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  width: 400px;
  margin-left: auto;
  justify-content: end;
`;
var InlineCheckboxItem = styled3.div`
  label {
    width: 64px;
    padding: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    color: var(--grey700);
    cursor: pointer;
    font-size: 14px;
  }
  input {
    margin-right: 0px;
    flex-shrink: 0;
    border-radius: 4px;
    background: var(--grey100);
    border: 1px solid var(--grey500);
  }
  input {
    outline: none;
    border: none;
    border-image: none;
    appearance: none;
    background: var(--grey100);
    border: 1px solid var(--grey500);
  }
  input:checked {
    background-color: var(--accent-color-blue);
    border: 1px solid var(--accent-color-blue);
  }
  input:checked::after {
    border: 0;
  }
`;
var SingleLineCheckboxItem = styled3(CheckboxListItemComponent)`
  width: 100%;
`;
var CategoryTitleComponent = styled3.div`
  color: var(--grey700);
  font-weight: 500;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 16px;
  padding-top: 16px;
  width: 100%;
`;
var CategoryHeaderComponent = styled3.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  margin-left: auto;
  justify-content: end;
`;
var CategoryHeaderColumnComponent = styled3.div`
  text-align: center;
  font-size: 12px;
  color: var(--grey700);
  width: 64px;
`;
var NonBinaryCheckboxContainer = styled3.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 64px;
`;
var NonBinaryCheckbox = styled3.div`
  width: 20px;
  height: 20px;
  background: var(--grey500);
  border-radius: 4px;
`;

// src/modules/shippers/components/shipper-user-form/shipper-user-form.tsx
import React4, { useCallback as useCallback3 } from "react";
import {
  FormContainer,
  Block,
  BlockContainer,
  SectionContainer,
  SectionTitle as SectionTitle2,
  SectionBody as SectionBody2,
  SectionLine as SectionLine2,
  Sticky,
  ButtonContainer,
  Half,
  ButtonComponent,
  Input,
  ErrorMessage
} from "@ontruck/fe-ui";

// src/modules/shippers/components/shipper-user-form/use-shipper-user-form-hook.ts
import { useCallback as useCallback2, useMemo as useMemo2, useState } from "react";

// src/shared/form/fields/get-form-fields.tsx
var getFormFields = (definitions) => {
  const formFields = {};
  Object.entries(definitions).forEach(([key, definition]) => {
    const formField = {
      definition,
      value: "",
      validationErrors: [],
      isValid: false
    };
    formFields[key] = formField;
  });
  return formFields;
};

// src/shared/utils/validate-phone-number.ts
import { PhoneNumberUtil } from "google-libphonenumber";
var phoneUtil = PhoneNumberUtil.getInstance();
function validatePhoneNumber(phoneNumberString) {
  let isValid = false;
  try {
    const internationalPhoneNumber = phoneUtil.parse(phoneNumberString);
    if (phoneUtil.isValidNumber(internationalPhoneNumber)) {
      isValid = true;
    }
  } catch (error) {
    isValid = false;
  }
  try {
    const spanishPhoneNumber = phoneUtil.parse(phoneNumberString, "ES");
    isValid = phoneUtil.isValidNumber(spanishPhoneNumber);
  } catch (error) {
    isValid = false;
  }
  return isValid;
}

// src/shared/form/fields/get-validated-field.tsx
var getValidatedField = (field) => {
  const { value, definition } = field;
  const validationErrors = [];
  try {
    const isEmpty = value.trim() === "";
    const hasPattern = Boolean(definition.validation_pattern);
    const isPhone = definition.type === "phone";
    const passesValidation = isPhone ? validatePhoneNumber(value) : !hasPattern || definition.validation_pattern && new RegExp(definition.validation_pattern).test(value);
    if (definition.is_required) {
      if (isEmpty) {
        validationErrors.push("Required");
      } else if (!passesValidation) {
        validationErrors.push("Not valid");
      }
    } else if (!isEmpty && !passesValidation) {
      validationErrors.push("Not valid");
    }
  } catch (error) {
    validationErrors.push("Not valid");
  }
  field.validationErrors = validationErrors;
  field.isValid = validationErrors.length === 0;
  return field;
};

// src/shared/form/state/get-validated-form-state.tsx
var getValidatedFormState = (state) => {
  const validatedFields = __spreadValues({}, state.fields);
  Object.entries(validatedFields).forEach(([key, field]) => {
    validatedFields[key] = getValidatedField(field);
  });
  return __spreadProps(__spreadValues({}, state), { fields: validatedFields, submit_errors: {} });
};

// src/shared/form/state/get-initial-state.tsx
var getInitialState = ({
  fieldDefinitions,
  initialValues
}) => {
  const initialState = {
    fields: getFormFields(fieldDefinitions),
    is_submiting: false,
    show_errors: false,
    submit_errors: {}
  };
  if (initialValues) {
    Object.entries(initialValues).forEach(([fieldName, value]) => {
      try {
        initialState.fields[fieldName].value = value;
      } catch (error) {
        console.error(`Error setting initial value for field ${fieldName}:`, error);
      }
    });
  }
  const validatedInitialFormState = getValidatedFormState(initialState);
  return validatedInitialFormState;
};

// src/shared/form/validations/email.tsx
var emailRegex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;

// src/shared/form/validations/not-empty-string.tsx
var notEmptyStringRegex = /[\S\s]+/;

// src/modules/shippers/components/shipper-user-form/shipper-user-form-translations.ts
var BACKEND_ERROR_MAPPING = {
  user_exists_in_other_shipper: "user_exists_in_other_shipper" /* UserExistsInOtherShipper */,
  phone_invalid: "phone_invalid" /* PhoneInvalid */
};
var getErrorTranslation = (errorMessage, translations2) => {
  const errorKey = BACKEND_ERROR_MAPPING[errorMessage];
  switch (errorKey) {
    case "user_exists_in_other_shipper" /* UserExistsInOtherShipper */:
      return translations2.errors.user_exists_in_other_shipper;
    case "phone_invalid" /* PhoneInvalid */:
      return translations2.errors.phone_invalid;
    default:
      return translations2.errors.unexpected_error;
  }
};

// src/modules/shippers/components/shipper-user-form/use-shipper-user-form-hook.ts
var defaultFieldDefinitions = {
  first_name: {
    type: "text",
    is_required: false,
    validation_pattern: notEmptyStringRegex,
    label: "First Name",
    name: "first_name"
  },
  last_name: {
    type: "text",
    is_required: false,
    validation_pattern: notEmptyStringRegex,
    label: "Last Name",
    name: "last_name"
  },
  email: {
    type: "text",
    is_required: true,
    validation_pattern: emailRegex,
    label: "Email",
    name: "email"
  },
  phone: {
    type: "phone",
    is_required: false,
    validation_pattern: notEmptyStringRegex,
    label: "Phone",
    name: "phone"
  },
  language: {
    type: "text",
    is_required: false,
    validation_pattern: notEmptyStringRegex,
    label: "Language",
    name: "language"
  }
};
var getTranslatedFieldDefinitions = ({
  fieldDefinitions,
  translations: translations2
}) => {
  const definitions = {};
  Object.entries(fieldDefinitions).forEach(([key, definition]) => {
    const fieldKey = key;
    definitions[key] = __spreadProps(__spreadValues({}, definition), {
      label: translations2.fields[fieldKey]
    });
  });
  return definitions;
};
function useShipperUserFormHook({
  shipperUserFormTranslations,
  submitForm,
  initialValues = {}
}) {
  const fieldDefinitions = useMemo2(() => {
    const translatedFieldDefintions = getTranslatedFieldDefinitions({
      fieldDefinitions: defaultFieldDefinitions,
      translations: shipperUserFormTranslations
    });
    return translatedFieldDefintions;
  }, [shipperUserFormTranslations]);
  const initialState = getInitialState({
    fieldDefinitions,
    initialValues
  });
  const [formState, setFormState] = useState(initialState);
  const isValid = useMemo2(() => {
    for (const field of Object.values(formState.fields)) {
      if (!field.isValid) {
        return false;
      }
    }
    return true;
  }, [formState.fields]);
  const handleSubmit = useCallback2(
    (e) => __async(this, null, function* () {
      e.preventDefault();
      setFormState((prev) => __spreadProps(__spreadValues({}, prev), {
        show_errors: true,
        submit_errors: {}
      }));
      if (!isValid)
        return;
      try {
        setFormState((prev) => __spreadProps(__spreadValues({}, prev), { is_submiting: true }));
        yield submitForm({ formState });
        setFormState((prev) => __spreadProps(__spreadValues({}, prev), { is_submiting: false }));
      } catch (error) {
        setFormState((prev) => __spreadProps(__spreadValues({}, prev), {
          is_submiting: false,
          submit_errors: {
            uncontrolled: error instanceof Error ? error.message : shipperUserFormTranslations.errors.unexpected_error
          }
        }));
      }
    }),
    [formState, isValid, shipperUserFormTranslations, submitForm]
  );
  const handleChangeValue = useCallback2((fieldName, value) => {
    try {
      if (value === void 0)
        return;
      setFormState((previousState) => {
        const newState = __spreadProps(__spreadValues({}, previousState), {
          fields: __spreadProps(__spreadValues({}, previousState.fields), {
            [fieldName]: __spreadProps(__spreadValues({}, previousState.fields[fieldName]), {
              value
            })
          })
        });
        return getValidatedFormState(newState);
      });
    } catch (error) {
      console.error("\u{1F525} ~ handleChangeValue error:", error);
    }
  }, []);
  const handleChangeEvent = useCallback2(
    (e, fieldName) => {
      const value = e.currentTarget.value;
      handleChangeValue(fieldName, value);
    },
    [handleChangeValue]
  );
  const backendErrors = useMemo2(() => {
    const errors = [];
    Object.values(formState.submit_errors).forEach((errorMessage) => {
      const translatedMessage = getErrorTranslation(errorMessage, shipperUserFormTranslations);
      errors.push(translatedMessage);
    });
    return errors;
  }, [formState.submit_errors, shipperUserFormTranslations]);
  const isSubmitting = formState.is_submiting;
  const fields = formState.fields;
  const showErrors = formState.show_errors;
  return {
    handleSubmit,
    handleChangeValue,
    handleChangeEvent,
    backendErrors,
    isSubmitting,
    fields,
    showErrors
  };
}

// src/modules/shippers/components/shipper-user-form/shipper-user-form.tsx
function FormInput({
  field,
  handleChangeEvent,
  handleChangeValue,
  showErrors
}) {
  return /* @__PURE__ */ React4.createElement(
    Input,
    {
      handleChangeEvent: (e) => {
        handleChangeEvent(e, field.definition.name);
      },
      handleChangeValue,
      hasError: showErrors ? !field.isValid : false,
      isRequired: field.definition.is_required,
      label: field.definition.label,
      name: field.definition.name,
      type: field.definition.type,
      value: field.value
    }
  );
}
var availableCommunicationLanguages = [
  {
    value: "en-GB",
    label: "english"
  },
  {
    value: "fr-FR",
    label: "french"
  },
  {
    value: "it-IT",
    label: "italian"
  },
  {
    value: "pl-PL",
    label: "polish"
  },
  {
    value: "ro-RO",
    label: "romanian"
  },
  {
    value: "es-ES",
    label: "spanish"
  }
];
function ShipperUserForm({
  shipperUserFormTranslations,
  shipperUserFormPageTranslations,
  submitForm,
  initialValues = {}
}) {
  const {
    handleSubmit,
    handleChangeValue,
    handleChangeEvent,
    backendErrors,
    isSubmitting,
    fields,
    showErrors
  } = useShipperUserFormHook({
    shipperUserFormTranslations,
    submitForm,
    initialValues
  });
  const availableCommunicationLanguagesTranslated = availableCommunicationLanguages.map(
    (language) => {
      return {
        value: language.value,
        label: shipperUserFormTranslations.fields.languages[language.label]
      };
    }
  );
  const renderFormInput = useCallback3(
    (field) => {
      return /* @__PURE__ */ React4.createElement(
        FormInput,
        {
          field,
          handleChangeEvent,
          handleChangeValue,
          showErrors
        }
      );
    },
    [handleChangeEvent, handleChangeValue, showErrors]
  );
  return /* @__PURE__ */ React4.createElement(FormContainer, null, /* @__PURE__ */ React4.createElement("form", { autoComplete: "off", onSubmit: (event) => void handleSubmit(event) }, /* @__PURE__ */ React4.createElement(BlockContainer, null, /* @__PURE__ */ React4.createElement(Block, null, /* @__PURE__ */ React4.createElement(SectionContainer, null, /* @__PURE__ */ React4.createElement(SectionTitle2, null, shipperUserFormTranslations.sections.user_section), /* @__PURE__ */ React4.createElement(SectionBody2, null, /* @__PURE__ */ React4.createElement(SectionLine2, null, renderFormInput(fields.email)), /* @__PURE__ */ React4.createElement(SectionLine2, null, renderFormInput(fields.first_name), renderFormInput(fields.last_name)), /* @__PURE__ */ React4.createElement(SectionLine2, null, /* @__PURE__ */ React4.createElement(Half, null, renderFormInput(fields.phone)), /* @__PURE__ */ React4.createElement(Half, null, /* @__PURE__ */ React4.createElement(
    Input,
    {
      handleChangeValue: (name, value) => {
        handleChangeValue(fields.language.definition.name, value);
      },
      label: fields.language.definition.label,
      name: fields.language.definition.name,
      options: availableCommunicationLanguagesTranslated,
      type: "select",
      value: fields.language.value
    }
  ))))), backendErrors.length > 0 && /* @__PURE__ */ React4.createElement(SectionContainer, null, /* @__PURE__ */ React4.createElement(SectionBody2, null, /* @__PURE__ */ React4.createElement(ErrorMessage, null, backendErrors.map((errorMessage) => {
    return /* @__PURE__ */ React4.createElement("div", { key: errorMessage }, errorMessage);
  })))))), /* @__PURE__ */ React4.createElement(Sticky, null, /* @__PURE__ */ React4.createElement(ButtonContainer, null, /* @__PURE__ */ React4.createElement(Half, null, /* @__PURE__ */ React4.createElement(
    ButtonComponent,
    {
      color: "primary",
      disabled: isSubmitting,
      fullWidth: true,
      size: "s",
      type: "submit"
    },
    isSubmitting ? shipperUserFormPageTranslations.form_button_loading_text : shipperUserFormPageTranslations.form_button_text
  ))))));
}

// src/modules/shippers/components/shipper-form/use-shipper-form-hook.ts
import { useCallback as useCallback4, useMemo as useMemo3, useState as useState2 } from "react";

// src/modules/shippers/components/shipper-form/shipper-form-translations.ts
var BACKEND_ERROR_MAPPING2 = {
  email_already_exists: "email_already_exists" /* EmailAlreadyExists */,
  external_id_format: "external_id_format" /* ExternalIdFormat */
};
var getErrorTranslation2 = (errorMessage, translations2) => {
  const errorKey = BACKEND_ERROR_MAPPING2[errorMessage];
  switch (errorKey) {
    case "email_already_exists" /* EmailAlreadyExists */:
      return translations2.errors.email_already_exists;
    case "external_id_format" /* ExternalIdFormat */:
      return translations2.errors.external_id_format;
    default:
      return translations2.errors.unexpected_error;
  }
};

// src/modules/shippers/components/shipper-form/use-shipper-form-hook.ts
var defaultFieldDefinitions2 = {
  company_name: {
    type: "text",
    is_required: true,
    validation_pattern: notEmptyStringRegex,
    label: "Company Name",
    name: "company_name"
  },
  tax_number: {
    type: "text",
    is_required: false,
    validation_pattern: notEmptyStringRegex,
    label: "CIF",
    name: "tax_number"
  },
  external_id: {
    type: "text",
    is_required: false,
    validation_pattern: notEmptyStringRegex,
    label: "External Id",
    name: "external_id"
  },
  email: {
    type: "text",
    is_required: true,
    validation_pattern: emailRegex,
    label: "Email",
    name: "email"
  },
  password: {
    type: "password",
    is_required: false,
    label: "Password",
    name: "password"
  },
  first_name: {
    type: "text",
    is_required: true,
    validation_pattern: notEmptyStringRegex,
    label: "First Name",
    name: "first_name"
  },
  last_name: {
    type: "text",
    is_required: true,
    validation_pattern: notEmptyStringRegex,
    label: "Last Name",
    name: "last_name"
  },
  phone: {
    type: "phone",
    is_required: true,
    validation_pattern: notEmptyStringRegex,
    label: "Phone",
    name: "phone"
  },
  workingAreas: {
    type: "text",
    is_required: true,
    validation_pattern: notEmptyStringRegex,
    label: "Working areas",
    name: "workingAreas"
  },
  language: {
    type: "text",
    is_required: false,
    validation_pattern: notEmptyStringRegex,
    label: "Language",
    name: "language"
  }
};
var getTranslatedFieldDefinitions2 = ({
  fieldDefinitions,
  translations: translations2
}) => {
  const definitions = {};
  Object.entries(fieldDefinitions).forEach(([key, definition]) => {
    const fieldKey = key;
    definitions[key] = __spreadProps(__spreadValues({}, definition), {
      label: String(translations2.fields[fieldKey] || fieldKey)
    });
  });
  return definitions;
};
var getFieldDefinitionsWithHiddenFieldsNotRequired = ({
  fieldDefinitions,
  hiddenFields
}) => {
  const definitions = {};
  Object.entries(fieldDefinitions).forEach(([key, definition]) => {
    if (hiddenFields.includes(definition.name)) {
      definitions[key] = __spreadProps(__spreadValues({}, definition), {
        is_required: false
      });
    } else {
      definitions[key] = definition;
    }
  });
  return definitions;
};
function useShipperFormHook({
  hiddenFields,
  shipperFormTranslations,
  submitForm,
  initialValues = {}
}) {
  const fieldDefinitions = useMemo3(() => {
    const fieldDefinitionsWithHiddenFieldsNotRequired = getFieldDefinitionsWithHiddenFieldsNotRequired({
      fieldDefinitions: defaultFieldDefinitions2,
      hiddenFields
    });
    const translatedFieldDefintions = getTranslatedFieldDefinitions2({
      fieldDefinitions: fieldDefinitionsWithHiddenFieldsNotRequired,
      translations: shipperFormTranslations
    });
    return translatedFieldDefintions;
  }, [shipperFormTranslations, hiddenFields]);
  const initialState = getInitialState({
    fieldDefinitions,
    initialValues
  });
  const [formState, setFormState] = useState2(initialState);
  const isValid = useMemo3(() => {
    for (const field of Object.values(formState.fields)) {
      if (!field.isValid) {
        return false;
      }
    }
    return true;
  }, [formState.fields]);
  const handleSubmit = useCallback4(
    (e) => __async(this, null, function* () {
      e.preventDefault();
      setFormState((prev) => __spreadProps(__spreadValues({}, prev), {
        show_errors: true,
        submit_errors: {}
      }));
      if (!isValid)
        return;
      try {
        setFormState((prev) => __spreadProps(__spreadValues({}, prev), { is_submiting: true }));
        yield submitForm({ formState });
        setFormState((prev) => __spreadProps(__spreadValues({}, prev), { is_submiting: false }));
      } catch (error) {
        setFormState((prev) => __spreadProps(__spreadValues({}, prev), {
          is_submiting: false,
          submit_errors: {
            uncontrolled: error instanceof Error ? error.message : shipperFormTranslations.errors.unexpected_error
          }
        }));
      }
    }),
    [formState, isValid, shipperFormTranslations, submitForm]
  );
  const handleChangeValue = useCallback4((fieldName, value) => {
    try {
      if (value === void 0)
        return;
      setFormState((previousState) => {
        const newState = __spreadProps(__spreadValues({}, previousState), {
          fields: __spreadProps(__spreadValues({}, previousState.fields), {
            [fieldName]: __spreadProps(__spreadValues({}, previousState.fields[fieldName]), {
              value
            })
          })
        });
        return getValidatedFormState(newState);
      });
    } catch (error) {
      console.error("\u{1F525} ~ handleChangeValue error:", error);
    }
  }, []);
  const handleChangeEvent = useCallback4(
    (e, fieldName) => {
      const value = e.currentTarget.value;
      handleChangeValue(fieldName, value);
    },
    [handleChangeValue]
  );
  const backendErrors = useMemo3(() => {
    const errors = [];
    Object.values(formState.submit_errors).forEach((errorMessage) => {
      const translatedMessage = getErrorTranslation2(errorMessage, shipperFormTranslations);
      errors.push(translatedMessage);
    });
    return errors;
  }, [formState.submit_errors, shipperFormTranslations]);
  const shouldShowTaxNumber = !hiddenFields.includes(formState.fields.tax_number.definition.name);
  const shouldShowExternalId = !hiddenFields.includes(formState.fields.external_id.definition.name);
  const shouldShowWorkingAreas = !hiddenFields.includes(
    formState.fields.workingAreas.definition.name
  );
  const isSubmitting = formState.is_submiting;
  const fields = formState.fields;
  const showErrors = formState.show_errors;
  return {
    handleSubmit,
    handleChangeValue,
    handleChangeEvent,
    shouldShowTaxNumber,
    shouldShowExternalId,
    shouldShowWorkingAreas,
    backendErrors,
    isSubmitting,
    fields,
    showErrors,
    formState
  };
}

// src/modules/shippers/components/shipper-form/shipper-form.tsx
var ErrorSubtitleComponent = styled4.div`
  color: var(--error900);
  font-size: 14px;
`;
var WorkingAreasTitleComponent = styled4(SectionTitle3)`
  display: flex;
  align-items: center;
  gap: 16px;
`;
function FormInput2({
  field,
  handleChangeEvent,
  handleChangeValue,
  showErrors
}) {
  return /* @__PURE__ */ React5.createElement(
    Input2,
    {
      handleChangeEvent: (e) => {
        handleChangeEvent(e, field.definition.name);
      },
      handleChangeValue,
      hasError: showErrors ? !field.isValid : false,
      isRequired: field.definition.is_required,
      label: field.definition.label,
      name: field.definition.name,
      type: field.definition.type,
      value: field.value
    }
  );
}
function ShipperForm({
  hiddenFields,
  shipperFormTranslations,
  shipperFormPageTranslations,
  submitForm,
  shipperId = null,
  showAdminSection = true,
  config,
  initialValues = {},
  onAddUser,
  onGoToEditShipperUser,
  workingAreas
}) {
  const {
    handleSubmit,
    handleChangeValue,
    handleChangeEvent,
    shouldShowTaxNumber,
    shouldShowExternalId,
    shouldShowWorkingAreas,
    backendErrors,
    isSubmitting,
    fields,
    showErrors,
    formState
  } = useShipperFormHook({
    hiddenFields,
    shipperFormTranslations,
    submitForm,
    initialValues
  });
  const availableCommunicationLanguagesTranslated = availableCommunicationLanguages.map(
    (language) => {
      return {
        value: language.value,
        label: shipperFormTranslations.fields.languages[language.label]
      };
    }
  );
  const renderFormInput = useCallback5(
    (field) => {
      return /* @__PURE__ */ React5.createElement(
        FormInput2,
        {
          field,
          handleChangeEvent,
          handleChangeValue,
          showErrors
        }
      );
    },
    [handleChangeEvent, handleChangeValue, showErrors]
  );
  const workingAreasChecked = formState.fields.workingAreas.value.trim().split(",").map((workingArea) => workingArea.trim()).filter((workingArea) => workingArea !== "");
  const onWorkingAreaClick = (workingArea) => {
    const isSelected = workingAreasChecked.includes(workingArea);
    if (isSelected) {
      const newWorkingAreasChecked = workingAreasChecked.filter((w) => w !== workingArea);
      handleChangeValue("workingAreas", newWorkingAreasChecked.join(","));
    } else {
      const newWorkingAreasChecked = [...workingAreasChecked, workingArea];
      handleChangeValue("workingAreas", newWorkingAreasChecked.join(","));
    }
  };
  const hasWorkingAreasError = !formState.fields.workingAreas.isValid;
  return /* @__PURE__ */ React5.createElement(FormContainer2, null, /* @__PURE__ */ React5.createElement("form", { autoComplete: "off", onSubmit: (event) => void handleSubmit(event) }, /* @__PURE__ */ React5.createElement(BlockContainer2, null, /* @__PURE__ */ React5.createElement(Block2, null, /* @__PURE__ */ React5.createElement(SectionContainer2, null, /* @__PURE__ */ React5.createElement(SectionTitle3, null, shipperFormTranslations.sections.client_section), /* @__PURE__ */ React5.createElement(SectionBody3, null, /* @__PURE__ */ React5.createElement(SectionLine3, null, renderFormInput(fields.company_name)), shouldShowTaxNumber ? /* @__PURE__ */ React5.createElement(SectionLine3, null, renderFormInput(fields.tax_number)) : null, shouldShowExternalId ? /* @__PURE__ */ React5.createElement(SectionLine3, null, renderFormInput(fields.external_id)) : null)), shouldShowWorkingAreas ? /* @__PURE__ */ React5.createElement(SectionContainer2, null, /* @__PURE__ */ React5.createElement(WorkingAreasTitleComponent, null, shipperFormTranslations.sections.working_areas_section, showErrors && hasWorkingAreasError ? /* @__PURE__ */ React5.createElement(ErrorSubtitleComponent, null, "Select at least one") : null), /* @__PURE__ */ React5.createElement(MulticheckboxBodyComponent, null, workingAreas.map((workingArea) => /* @__PURE__ */ React5.createElement(MulticheckboxItemComponent, { key: workingArea.id }, /* @__PURE__ */ React5.createElement(
    Input2,
    {
      handleChangeValue: (_name, _value) => {
        onWorkingAreaClick(workingArea.name);
      },
      label: workingArea.name,
      name: `working - area - ${workingArea.id} `,
      type: "checkbox",
      value: workingAreasChecked.includes(workingArea.name).toString()
    }
  ))))) : null, showAdminSection ? /* @__PURE__ */ React5.createElement(SectionContainer2, null, /* @__PURE__ */ React5.createElement(SectionTitle3, null, shipperFormTranslations.sections.admin_client_section), /* @__PURE__ */ React5.createElement(SectionBody3, null, /* @__PURE__ */ React5.createElement(SectionLine3, null, renderFormInput(fields.first_name), renderFormInput(fields.last_name)), /* @__PURE__ */ React5.createElement(SectionLine3, null, renderFormInput(fields.email), renderFormInput(fields.phone)), /* @__PURE__ */ React5.createElement(SectionLine3, null, /* @__PURE__ */ React5.createElement(Half2, null, /* @__PURE__ */ React5.createElement(
    Input2,
    {
      handleChangeValue: (name, value) => {
        handleChangeValue(fields.language.definition.name, value);
      },
      label: fields.language.definition.label,
      name: fields.language.definition.name,
      options: availableCommunicationLanguagesTranslated,
      type: "select",
      value: fields.language.value
    }
  )), /* @__PURE__ */ React5.createElement(Half2, null, renderFormInput(fields.password))))) : null, /* @__PURE__ */ React5.createElement(SectionContainer2, null, /* @__PURE__ */ React5.createElement(SectionTitle3, null, "Users"), /* @__PURE__ */ React5.createElement(SectionBody3, null, /* @__PURE__ */ React5.createElement(
    ShipperUsersTableComponent,
    {
      config,
      onGoToEditShipperUser,
      shipperFormTranslations,
      shipperId
    }
  ), shipperId ? /* @__PURE__ */ React5.createElement(
    ButtonComponent2,
    {
      color: "primary",
      onClick: () => {
        onAddUser == null ? void 0 : onAddUser(shipperId);
      },
      size: "s",
      variant: "text"
    },
    "Add user"
  ) : null)), backendErrors.length > 0 && /* @__PURE__ */ React5.createElement(SectionContainer2, null, /* @__PURE__ */ React5.createElement(SectionBody3, null, /* @__PURE__ */ React5.createElement(ErrorMessage2, null, backendErrors.map((errorMessage) => {
    return /* @__PURE__ */ React5.createElement("div", { key: errorMessage }, errorMessage);
  })))))), /* @__PURE__ */ React5.createElement(Sticky2, null, /* @__PURE__ */ React5.createElement(ButtonContainer2, null, /* @__PURE__ */ React5.createElement(Half2, null, /* @__PURE__ */ React5.createElement(
    ButtonComponent2,
    {
      color: "primary",
      disabled: isSubmitting,
      fullWidth: true,
      size: "s",
      type: "submit"
    },
    isSubmitting ? shipperFormPageTranslations.form_button_loading_text : shipperFormPageTranslations.form_button_text
  ))))));
}

// src/modules/user-management/working-area/get-working-areas-mapped-service.ts
function getWorkingAreasMappedService(workingAreasDto) {
  if (!workingAreasDto) {
    return;
  }
  const workingAreasMapped = workingAreasDto.results.map((workingAreaDto) => {
    try {
      const workingArea = {
        id: workingAreaDto.id,
        name: workingAreaDto.slug
      };
      return workingArea;
    } catch (e) {
      console.error("Error mapping working area with id ", workingAreaDto);
      console.error(e);
      throw e;
    }
  });
  return workingAreasMapped;
}

// src/modules/user-management/working-area/get-working-areas-api.ts
var getWorkingAreasApi = (_0) => __async(void 0, [_0], function* ({
  config
}) {
  const endpoint = `${config.api_url}v1/price-negotiation/working-areas?page_size=0`;
  const response = yield fetch(endpoint, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${config.token}`
    }
  });
  const data = yield fetchJson(response);
  return data;
});

// src/modules/shippers/components/shipper-form/shipper-form-skeleton-component.tsx
import { Block as Block3, BlockContainer as BlockContainer3, FormContainer as FormContainer3 } from "@ontruck/fe-ui";
import React6 from "react";
import ContentLoader from "react-content-loader";
function ShipperFormSkeletonComponent() {
  return /* @__PURE__ */ React6.createElement(FormContainer3, null, /* @__PURE__ */ React6.createElement(BlockContainer3, null, /* @__PURE__ */ React6.createElement(Block3, null, /* @__PURE__ */ React6.createElement(ContentLoader, { height: 300, viewBox: "0 0 600 300", width: 600 }, /* @__PURE__ */ React6.createElement("rect", { height: "30", rx: "3", ry: "3", width: "100", x: "0", y: "0" }), /* @__PURE__ */ React6.createElement("rect", { height: "30", rx: "3", ry: "3", width: "600", x: "20", y: "60" }), /* @__PURE__ */ React6.createElement("rect", { height: "30", rx: "3", ry: "3", width: "600", x: "20", y: "110" }), /* @__PURE__ */ React6.createElement("rect", { height: "30", rx: "3", ry: "3", width: "600", x: "20", y: "160" }), /* @__PURE__ */ React6.createElement("rect", { height: "30", rx: "3", ry: "3", width: "600", x: "20", y: "210" })), /* @__PURE__ */ React6.createElement(ContentLoader, { height: 300, viewBox: "0 0 600 300", width: 600 }, /* @__PURE__ */ React6.createElement("rect", { height: "30", rx: "3", ry: "3", width: "100", x: "0", y: "0" }), /* @__PURE__ */ React6.createElement("rect", { height: "30", rx: "3", ry: "3", width: "600", x: "20", y: "60" }), /* @__PURE__ */ React6.createElement("rect", { height: "30", rx: "3", ry: "3", width: "600", x: "20", y: "110" }), /* @__PURE__ */ React6.createElement("rect", { height: "30", rx: "3", ry: "3", width: "600", x: "20", y: "160" }), /* @__PURE__ */ React6.createElement("rect", { height: "30", rx: "3", ry: "3", width: "600", x: "20", y: "210" })))));
}

// src/modules/shippers/pages/new-shipper-user/new-shipper-user-page.tsx
import {
  PageLayout,
  PageContent,
  ToolbarComponent,
  ToolbarContentComponent,
  ToolbarButtonComponent
} from "@ontruck/fe-ui";
import { CloseIcon } from "@ontruck/fe-icons";
import React7 from "react";
import { Toaster } from "sonner";

// src/modules/shippers/pages/new-shipper-user/new-shipper-user-page-hook.ts
import { toast } from "sonner";

// src/modules/shippers/pages/new-shipper-user/create-shipper-user-api.ts
var createShipperUserApi = (_0) => __async(void 0, [_0], function* ({
  createShipperUserDto,
  consumerConfig,
  shipperId
}) {
  try {
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${consumerConfig.token}`);
    const body = JSON.stringify(createShipperUserDto);
    const endpoint = `${consumerConfig.api_url}v1/shippers/${shipperId}/users/`;
    const requestOptions = {
      method: "POST",
      headers,
      body
    };
    const response = yield fetch(endpoint, requestOptions);
    const result = yield response.json();
    if (response.ok) {
      const shipperUserId = result.id;
      return shipperUserId;
    }
    if ("username" in result && result.username) {
      throw new Error("user_exists_in_other_shipper");
    }
    throw new Error("unexpected_error");
  } catch (e) {
    if (e instanceof Error) {
      throw new Error(e.message);
    } else {
      throw new Error("Unexpected error");
    }
  }
});

// src/modules/shippers/pages/new-shipper-user/new-shipper-user-page-hook.ts
var newShipperUserPageHook = ({
  consumerConfig,
  shipperId,
  onGoToShipperDetail,
  shipperUserFormPageTranslations
}) => {
  const submitForm = (_0) => __async(void 0, [_0], function* ({ formState }) {
    try {
      const createShipperUserDto = {
        username: formState.fields.email.value,
        first_name: formState.fields.first_name.value,
        last_name: formState.fields.last_name.value,
        phone: formState.fields.phone.value,
        language: formState.fields.language.value
      };
      yield createShipperUserApi({
        createShipperUserDto,
        consumerConfig,
        shipperId
      });
      toast.success(shipperUserFormPageTranslations.on_success_message);
      onGoToShipperDetail(shipperId);
    } catch (e) {
      if (e instanceof Error) {
        throw new Error(e.message);
      } else {
        throw new Error("Unexpected error");
      }
    }
  });
  return {
    submitForm
  };
};

// src/modules/shippers/pages/new-shipper-user/new-shipper-user-page.tsx
var DEFAULT_NEW_SHIPPER_LANGUAGE = "en-GB";
function NewShipperUserPage({
  consumerConfig,
  shipperUserFormPageTranslations,
  shipperUserFormTranslations,
  onGoToShipperDetail,
  shipperId
}) {
  const { submitForm } = newShipperUserPageHook({
    consumerConfig,
    onGoToShipperDetail,
    shipperUserFormPageTranslations,
    shipperId
  });
  const initialValues = {
    language: DEFAULT_NEW_SHIPPER_LANGUAGE
  };
  return /* @__PURE__ */ React7.createElement(PageLayout, null, /* @__PURE__ */ React7.createElement(ToolbarComponent, null, /* @__PURE__ */ React7.createElement(ToolbarContentComponent, null, /* @__PURE__ */ React7.createElement("div", null, /* @__PURE__ */ React7.createElement(ToolbarButtonComponent, null, shipperUserFormPageTranslations.title)), /* @__PURE__ */ React7.createElement("div", null, /* @__PURE__ */ React7.createElement(
    ToolbarButtonComponent,
    {
      onClick: () => {
        onGoToShipperDetail(shipperId);
      }
    },
    /* @__PURE__ */ React7.createElement(CloseIcon, null)
  )))), /* @__PURE__ */ React7.createElement(PageContent, { withBackground: true }, /* @__PURE__ */ React7.createElement(
    ShipperUserForm,
    {
      config: consumerConfig,
      initialValues,
      shipperUserFormPageTranslations,
      shipperUserFormTranslations,
      submitForm
    }
  )), /* @__PURE__ */ React7.createElement(Toaster, { richColors: true }));
}

// src/modules/shippers/pages/new-shipper/new-shipper-page-hook.ts
import { toast as toast2 } from "sonner";

// src/modules/shippers/pages/new-shipper/create-shipper-api.ts
var createShipperApi = (_0) => __async(void 0, [_0], function* ({
  createShipperDto,
  consumerConfig
}) {
  try {
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${consumerConfig.token}`);
    const body = JSON.stringify(createShipperDto);
    const endpoint = `${consumerConfig.api_url}api/create_shipper/`;
    const requestOptions = {
      method: "POST",
      headers,
      body
    };
    const response = yield fetch(endpoint, requestOptions);
    const result = yield response.json();
    if (response.ok) {
      const shipperId = result.shipper_id;
      return shipperId;
    }
    if (result.email) {
      throw new Error("email_already_exists");
    }
    if (result.external_id) {
      throw new Error("external_id_format");
    }
    throw new Error("unexpected_error");
  } catch (e) {
    if (e instanceof Error) {
      throw new Error(e.message);
    } else {
      throw new Error("Unexpected error");
    }
  }
});

// src/modules/shippers/pages/new-shipper/new-shipper-page-hook.ts
var newShipperPageHook = ({
  consumerConfig,
  hiddenFields,
  onGoToShipperDetail,
  shipperFormPageTranslations
}) => {
  const submitForm = (_0) => __async(void 0, [_0], function* ({ formState }) {
    try {
      const createShipperDto = {
        company_name: formState.fields.company_name.value,
        tax_number: formState.fields.tax_number.value,
        first_name: formState.fields.first_name.value,
        last_name: formState.fields.last_name.value,
        phone: formState.fields.phone.value,
        email: formState.fields.email.value,
        password: formState.fields.password.value,
        external_id: formState.fields.external_id.value,
        language: formState.fields.language.value
      };
      const shouldIncludeWorkingAreas = !hiddenFields.includes("workingAreas");
      if (shouldIncludeWorkingAreas) {
        let workingAreas = formState.fields.workingAreas.value.split(",");
        if (workingAreas[0] === "") {
          workingAreas = [];
        }
        createShipperDto.working_areas = workingAreas;
      }
      const shipperId = yield createShipperApi({ createShipperDto, consumerConfig });
      toast2.success(shipperFormPageTranslations.on_success_message);
      onGoToShipperDetail(shipperId);
    } catch (e) {
      if (e instanceof Error) {
        throw new Error(e.message);
      } else {
        throw new Error("Unexpected error");
      }
    }
  });
  return {
    submitForm
  };
};

// src/modules/shippers/pages/new-shipper/new-shipper-page.tsx
function NewShipperPage({
  consumerConfig,
  hiddenFields,
  shipperFormPageTranslations,
  shipperFormTranslations,
  onGoToShippersList,
  onGoToShipperDetail
}) {
  const workingAreasFetcher = () => __async(this, null, function* () {
    return getWorkingAreasApi({ config: consumerConfig });
  });
  const {
    data: workingAreasData,
    error: workingAreasError,
    isLoading: workingAreasLoading
  } = useSWR2("working-areas", workingAreasFetcher, {
    errorRetryCount: 0,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  });
  const workingAreasMapped = getWorkingAreasMappedService(workingAreasData);
  const error = workingAreasError;
  const isLoading = workingAreasLoading;
  const initialValues = {
    language: DEFAULT_NEW_SHIPPER_LANGUAGE
  };
  const { submitForm } = newShipperPageHook({
    consumerConfig,
    onGoToShipperDetail,
    shipperFormPageTranslations,
    hiddenFields
  });
  return /* @__PURE__ */ React8.createElement(PageLayout2, null, /* @__PURE__ */ React8.createElement(ToolbarComponent2, null, /* @__PURE__ */ React8.createElement(ToolbarContentComponent2, null, /* @__PURE__ */ React8.createElement("div", null, /* @__PURE__ */ React8.createElement(ToolbarButtonComponent2, null, shipperFormPageTranslations.title)), /* @__PURE__ */ React8.createElement("div", null, /* @__PURE__ */ React8.createElement(ToolbarButtonComponent2, { onClick: onGoToShippersList }, /* @__PURE__ */ React8.createElement(CloseIcon2, null))))), /* @__PURE__ */ React8.createElement(PageContent2, { withBackground: true }, (() => {
    if (error) {
      return /* @__PURE__ */ React8.createElement(BlockContainer4, null, /* @__PURE__ */ React8.createElement(Block4, null, /* @__PURE__ */ React8.createElement(ErrorMessage3, null, "There was an error loading the data")));
    }
    if (isLoading) {
      return /* @__PURE__ */ React8.createElement(ShipperFormSkeletonComponent, null);
    }
    return /* @__PURE__ */ React8.createElement(
      ShipperForm,
      {
        config: consumerConfig,
        hiddenFields,
        initialValues,
        shipperFormPageTranslations,
        shipperFormTranslations,
        submitForm,
        workingAreas: workingAreasMapped || []
      }
    );
  })()), /* @__PURE__ */ React8.createElement(Toaster2, { richColors: true }));
}

// src/modules/shippers/pages/edit-shipper/edit-shipper-page.tsx
import {
  PageLayout as PageLayout3,
  PageContent as PageContent3,
  ToolbarComponent as ToolbarComponent3,
  ToolbarContentComponent as ToolbarContentComponent3,
  ToolbarButtonComponent as ToolbarButtonComponent3,
  ErrorMessage as ErrorMessage4,
  BlockContainer as BlockContainer5,
  Block as Block5
} from "@ontruck/fe-ui";
import { CloseIcon as CloseIcon3 } from "@ontruck/fe-icons";
import React9, { useMemo as useMemo4 } from "react";
import useSWR3 from "swr";
import { Toaster as Toaster3 } from "sonner";

// src/modules/shippers/pages/edit-shipper/edit-shipper-page-hook.ts
import { toast as toast3 } from "sonner";

// src/modules/shippers/pages/edit-shipper/edit-shipper-api.ts
var editShipperApi = (_0) => __async(void 0, [_0], function* ({
  shipperId,
  consumerConfig,
  editShipperDto
}) {
  try {
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${consumerConfig.token}`);
    const endpoint = `${consumerConfig.api_url}v1/shippers/${shipperId}/`;
    const requestOptions = {
      method: "PATCH",
      headers,
      body: JSON.stringify(editShipperDto)
    };
    const response = yield fetch(endpoint, requestOptions);
    if (!response.ok) {
      const errors = yield fetchJson(response);
      if (errors.email) {
        throw new Error("email_already_exists");
      }
      if (errors.external_id) {
        throw new Error("external_id_format");
      }
      throw new Error("unexpected_error");
    }
    const shipperDto = yield fetchJson(response);
    return shipperDto;
  } catch (e) {
    if (e instanceof Error) {
      throw new Error(e.message);
    }
    throw new Error("unexpected_error");
  }
});

// src/modules/shippers/pages/edit-shipper/edit-shipper-page-hook.ts
var EditShipperPageHook = ({
  mutate,
  consumerConfig,
  shipperId,
  shipperFormPageTranslations,
  hiddenFields
}) => {
  const submitForm = (_0) => __async(void 0, [_0], function* ({ formState }) {
    try {
      const editShipperDto = {
        company_name: formState.fields.company_name.value,
        tax_number: formState.fields.tax_number.value,
        external_id: formState.fields.external_id.value
      };
      const shouldIncludeWorkingAreas = !hiddenFields.includes("workingAreas");
      if (shouldIncludeWorkingAreas) {
        let workingAreas = formState.fields.workingAreas.value.split(",");
        if (workingAreas[0] === "") {
          workingAreas = [];
        }
        editShipperDto.working_areas = workingAreas;
      }
      yield editShipperApi({
        consumerConfig,
        editShipperDto,
        shipperId
      });
      void mutate();
      toast3.success(shipperFormPageTranslations.on_success_message);
    } catch (e) {
      if (e instanceof Error) {
        throw new Error(e.message);
      } else {
        throw new Error("Unexpected error");
      }
    }
  });
  return {
    submitForm
  };
};

// src/modules/shippers/pages/edit-shipper/get-shipper-api.ts
var getShipperApi = (_0) => __async(void 0, [_0], function* ({
  shipperId,
  consumerConfig
}) {
  try {
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${consumerConfig.token}`);
    const endpoint = `${consumerConfig.api_url}api/shippers/${shipperId}/`;
    const requestOptions = {
      method: "GET",
      headers
    };
    const response = yield fetch(endpoint, requestOptions);
    if (!response.ok) {
      throw new Error("Failed to fetch shipper");
    }
    const shipperDto = yield fetchJson(response);
    return shipperDto;
  } catch (e) {
    if (e instanceof Error) {
      throw new Error(e.message);
    } else {
      throw new Error("Unexpected error");
    }
  }
});

// src/modules/shippers/pages/edit-shipper/edit-shipper-page.tsx
var getShipperApiFetcher = (shipperId, consumerConfig) => {
  return getShipperApi({ shipperId, consumerConfig });
};
var mapShipperDtoToInitialValues = (shipperDto) => {
  var _a;
  if (!shipperDto)
    return {};
  return {
    company_name: shipperDto.company_name,
    tax_number: (_a = shipperDto.tax_number) != null ? _a : "",
    external_id: shipperDto.external_id,
    workingAreas: shipperDto.working_areas.map((workingArea) => workingArea.slug).join(",")
  };
};
function EditShipperPage({
  consumerConfig,
  hiddenFields,
  shipperFormPageTranslations,
  shipperFormTranslations,
  onGoToShippersList,
  shipperId,
  onAddUser,
  onGoToEditShipperUser
}) {
  const hiddenFieldsForEdit = [
    ...hiddenFields,
    "email",
    "phone",
    "password",
    "first_name",
    "last_name"
  ];
  const fetcher = () => __async(this, null, function* () {
    return getShipperApiFetcher(shipperId, consumerConfig);
  });
  const {
    data: shipperDto,
    error: shipperDtoError,
    isLoading: isShipperDtoLoading,
    mutate
  } = useSWR3(shipperId, fetcher, {
    errorRetryCount: 0,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  });
  const workingAreasFetcher = () => __async(this, null, function* () {
    return getWorkingAreasApi({ config: consumerConfig });
  });
  const {
    data: workingAreasData,
    error: workingAreasError,
    isLoading: workingAreasLoading
  } = useSWR3("working-areas", workingAreasFetcher, {
    errorRetryCount: 0,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  });
  const workingAreasMapped = getWorkingAreasMappedService(workingAreasData);
  const initialValues = useMemo4(() => {
    return mapShipperDtoToInitialValues(shipperDto);
  }, [shipperDto]);
  const { submitForm } = EditShipperPageHook({
    mutate,
    consumerConfig,
    shipperId,
    shipperFormPageTranslations,
    hiddenFields
  });
  const error = shipperDtoError || workingAreasError;
  const isLoading = isShipperDtoLoading || workingAreasLoading;
  return /* @__PURE__ */ React9.createElement(PageLayout3, null, /* @__PURE__ */ React9.createElement(ToolbarComponent3, null, /* @__PURE__ */ React9.createElement(ToolbarContentComponent3, null, /* @__PURE__ */ React9.createElement("div", null, /* @__PURE__ */ React9.createElement(ToolbarButtonComponent3, null, shipperFormPageTranslations.title)), /* @__PURE__ */ React9.createElement("div", null, /* @__PURE__ */ React9.createElement(ToolbarButtonComponent3, { onClick: onGoToShippersList }, /* @__PURE__ */ React9.createElement(CloseIcon3, null))))), /* @__PURE__ */ React9.createElement(PageContent3, { withBackground: true }, (() => {
    if (error) {
      return /* @__PURE__ */ React9.createElement(BlockContainer5, null, /* @__PURE__ */ React9.createElement(Block5, null, /* @__PURE__ */ React9.createElement(ErrorMessage4, null, "There was an error loading the customer")));
    }
    if (isLoading) {
      return /* @__PURE__ */ React9.createElement(ShipperFormSkeletonComponent, null);
    }
    return /* @__PURE__ */ React9.createElement(
      ShipperForm,
      {
        config: consumerConfig,
        hiddenFields: hiddenFieldsForEdit,
        initialValues,
        onAddUser,
        onGoToEditShipperUser,
        shipperFormPageTranslations,
        shipperFormTranslations,
        shipperId,
        showAdminSection: false,
        submitForm,
        workingAreas: workingAreasMapped || []
      }
    );
  })()), /* @__PURE__ */ React9.createElement(Toaster3, { richColors: true }));
}

// src/modules/shippers/pages/shippers/shippers-page.tsx
import {
  PageLayout as PageLayout4,
  PageContent as PageContent4,
  ToolbarComponent as ToolbarComponent4,
  ToolbarButtonComponent as ToolbarButtonComponent4,
  FlexComponent as FlexComponent3,
  Input as Input3,
  TableComponent as TableComponent2,
  TableCellComponent as TableCellComponent3,
  TextComponent as TextComponent3
} from "@ontruck/fe-ui";
import { CirclePlusIcon } from "@ontruck/fe-icons";
import React10, { useCallback as useCallback6, useMemo as useMemo5 } from "react";
import styled5 from "styled-components";

// src/modules/shippers/pages/shippers/filters-hook.ts
import { useState as useState3 } from "react";
var DEFAULT_PAGINATION_SIZE_FILTER_OPTION = 100;
var getFiltersOptions = () => {
  return {
    paginationSizes: [100, 200, 500, 1e3]
  };
};
var getDefaultSelectedFilters = () => {
  return {
    search: "",
    includeHidden: false,
    paginationSize: DEFAULT_PAGINATION_SIZE_FILTER_OPTION,
    page: 1
  };
};
var getInitialSelectedFilters = () => {
  const initialSelectedFilters = getDefaultSelectedFilters();
  return initialSelectedFilters;
};
var useFiltersHook = () => {
  const filtersOptions = getFiltersOptions();
  const initialSelectedFilters = getInitialSelectedFilters();
  const [selectedFilters, setSelectedFilters] = useState3(initialSelectedFilters);
  const setPage = (page) => {
    setSelectedFilters(__spreadProps(__spreadValues({}, selectedFilters), {
      page
    }));
  };
  const setPaginationSize = (paginationSize) => {
    setSelectedFilters(__spreadProps(__spreadValues({}, selectedFilters), {
      paginationSize,
      page: 1
    }));
  };
  const setSearch = (search) => {
    setSelectedFilters(__spreadProps(__spreadValues({}, selectedFilters), {
      search,
      page: 1
    }));
  };
  const setIncludeHidden = (includeHidden) => {
    setSelectedFilters(__spreadProps(__spreadValues({}, selectedFilters), {
      includeHidden,
      page: 1
    }));
  };
  return {
    filtersOptions,
    selectedFilters,
    setPage,
    setPaginationSize,
    setSearch,
    setIncludeHidden
  };
};

// src/modules/shippers/pages/shippers/get-shippers-filtered-hook.ts
import useSWR4 from "swr";

// src/modules/shippers/pages/shippers/get-query-params-from-selected-filters.ts
var getPageSizeQuery = (selectedFilters) => {
  return `page_size=${selectedFilters.paginationSize}`;
};
var getPageQuery = (selectedFilters) => {
  return `page=${selectedFilters.page}`;
};
var getSearchQuery = (selectedFilters) => {
  const searchValue = selectedFilters.search;
  if (searchValue.trim() === "") {
    return null;
  }
  return `search=${searchValue}`;
};
var getIncludeHiddenQuery = (selectedFilters) => {
  if (!selectedFilters.includeHidden) {
    return null;
  }
  return `show_all=true`;
};
var getQueryParamsFromSelectedFilters = (selectedFilters) => {
  let query = `?ordering=company_name`;
  const pageSizeQuery = getPageSizeQuery(selectedFilters);
  const searchQuery = getSearchQuery(selectedFilters);
  const pageQuery = getPageQuery(selectedFilters);
  const includeHiddenQuery = getIncludeHiddenQuery(selectedFilters);
  const queries = [pageSizeQuery, searchQuery, pageQuery, includeHiddenQuery];
  queries.forEach((currentQuery) => {
    if (currentQuery) {
      const paramSeparator = "&";
      query = `${query}${paramSeparator}${currentQuery}`;
    }
  });
  return query;
};

// src/modules/shippers/pages/shippers/get-shippers-api.ts
var getShippersApi = (_0) => __async(void 0, [_0], function* ({
  selectedFilters,
  config
}) {
  const query = getQueryParamsFromSelectedFilters(selectedFilters);
  const endpoint = `${config.api_url}v1/mercury/shippers/${query}`;
  const response = yield fetch(endpoint, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${config.token}`
    }
  });
  const data = yield fetchJson(response);
  return data;
});

// src/modules/shippers/pages/shippers/get-shippers-api-fetcher.ts
var getShippersApiFetcher = (cargoItemsKey, config) => {
  const selectedFilters = JSON.parse(cargoItemsKey);
  return getShippersApi({ selectedFilters, config });
};

// src/modules/shippers/pages/shippers/get-shippers-mapped-service.ts
function getShippersMapedService(shippersDto) {
  if (!shippersDto) {
    return;
  }
  const shippersMapped = shippersDto.results.map((shipperDto) => {
    try {
      const shipper = {
        id: shipperDto.id,
        companyName: shipperDto.company_name,
        externalId: shipperDto.external_id,
        workingAreas: shipperDto.working_areas.map((workingArea) => ({
          id: workingArea.id,
          slug: workingArea.slug,
          fullName: workingArea.full_name
        }))
      };
      if (shipperDto.users.length > 0) {
        shipper.email = shipperDto.users[0].email;
      }
      return shipper;
    } catch (e) {
      console.error("Error mapping shipper with id ", shipperDto.id);
      console.error(e);
      throw e;
    }
  });
  const count = shippersDto.count;
  return {
    shippers: shippersMapped,
    count
  };
}

// src/modules/shippers/pages/shippers/settings.ts
var RELOAD_SHIPPERS_LIST_INTERVAL_IN_SECONDS = 30;

// src/modules/shippers/pages/shippers/get-shippers-filtered-hook.ts
var useGetShippersFilteredHook = ({
  selectedFilters,
  config
}) => {
  const cargoItemsKey = JSON.stringify(selectedFilters);
  const fetcher = () => __async(void 0, null, function* () {
    return getShippersApiFetcher(cargoItemsKey, config);
  });
  const { data, error, isLoading, mutate } = useSWR4(cargoItemsKey, fetcher, {
    refreshInterval: RELOAD_SHIPPERS_LIST_INTERVAL_IN_SECONDS * 1e3,
    revalidateIfStale: true
  });
  const shippersMapped = getShippersMapedService(data);
  return {
    shippers: (shippersMapped == null ? void 0 : shippersMapped.shippers) || [],
    count: (shippersMapped == null ? void 0 : shippersMapped.count) || 0,
    isLoading,
    error,
    mutate
  };
};

// src/modules/shippers/pages/shippers/shippers-page.tsx
var ShippersPageLayoutStyled = styled5(PageLayout4)`
  background-color: var(--otk-theme-color-white);
`;
var ShippersToolbarButtonsComponent = styled5(FlexComponent3)`
  border-left: 1px solid var(--accent-color-gray);
  margin-left: auto;
`;
var FiltersComponent = styled5(FlexComponent3)`
  align-items: center;
  background-color: var(--otk-theme-color-white);
  flex-grow: 1;
  gap: 8px;
`;
var ShipperRowStyled = styled5(FlexComponent3)`
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;
var TABLE_COLUMNS = {
  companyName: {
    width: "288px"
  },
  externalId: {
    width: "288px"
  },
  email: {
    width: "288px"
  },
  workingAreas: {
    width: "288px"
  }
};
function ShippersPage({
  consumerConfig,
  shippersPageTranslations,
  onGoToNewShipper,
  onGoToShipperDetail,
  hiddenColumns = [],
  showIncludeHiddenFilter = false,
  showNewShipperButton = false
}) {
  const filters = useFiltersHook();
  const data = useGetShippersFilteredHook({
    selectedFilters: filters.selectedFilters,
    config: consumerConfig
  });
  const handleChangePageSize = (pageSize) => {
    filters.setPaginationSize(pageSize);
  };
  const handleGoToPreviousPage = () => {
    if (filters.selectedFilters.page > 1) {
      filters.setPage(filters.selectedFilters.page - 1);
    }
  };
  const handleGoToPage = (pageIndex) => {
    filters.setPage(pageIndex);
  };
  const handleGoToNextPage = () => {
    if (filters.selectedFilters.page < data.count) {
      filters.setPage(filters.selectedFilters.page + 1);
    }
  };
  const columns = useMemo5(() => {
    const baseColumns = {
      companyName: {
        id: "0",
        width: TABLE_COLUMNS.companyName.width,
        label: shippersPageTranslations.columns.companyName
      }
    };
    const optionalColumns = {
      externalId: {
        id: "1",
        width: TABLE_COLUMNS.externalId.width,
        label: shippersPageTranslations.columns.externalId
      },
      email: {
        id: "2",
        width: TABLE_COLUMNS.email.width,
        label: shippersPageTranslations.columns.email
      },
      workingAreas: {
        id: "3",
        width: TABLE_COLUMNS.workingAreas.width,
        label: shippersPageTranslations.columns.workingAreas
      }
    };
    return Object.entries(optionalColumns).reduce(
      (acc, [key, value]) => {
        if (!hiddenColumns.includes(key)) {
          acc[key] = value;
        }
        return acc;
      },
      __spreadValues({}, baseColumns)
    );
  }, [hiddenColumns, shippersPageTranslations]);
  const getShippersRowsComponents = useCallback6(
    (shippers) => {
      return shippers.map((shipperItem) => {
        return /* @__PURE__ */ React10.createElement(
          ShipperRowStyled,
          {
            alignItems: "center",
            borderTop: "1px solid var(--grey-200, #E2E8EE)",
            key: shipperItem.id,
            onClick: () => {
              onGoToShipperDetail(shipperItem.id);
            }
          },
          /* @__PURE__ */ React10.createElement(
            TableCellComponent3,
            {
              borderLeft: "1px solid var(--grey-200, #E2E8EE)",
              width: TABLE_COLUMNS.companyName.width
            },
            /* @__PURE__ */ React10.createElement(TextComponent3, null, shipperItem.companyName)
          ),
          !hiddenColumns.includes("externalId") && /* @__PURE__ */ React10.createElement(
            TableCellComponent3,
            {
              borderLeft: "1px solid var(--grey-200, #E2E8EE)",
              width: TABLE_COLUMNS.externalId.width
            },
            /* @__PURE__ */ React10.createElement(TextComponent3, null, shipperItem.externalId)
          ),
          !hiddenColumns.includes("email") && /* @__PURE__ */ React10.createElement(
            TableCellComponent3,
            {
              borderLeft: "1px solid var(--grey-200, #E2E8EE)",
              width: TABLE_COLUMNS.email.width
            },
            /* @__PURE__ */ React10.createElement(TextComponent3, null, shipperItem.email)
          ),
          !hiddenColumns.includes("workingAreas") && /* @__PURE__ */ React10.createElement(
            TableCellComponent3,
            {
              borderLeft: "1px solid var(--grey-200, #E2E8EE)",
              width: TABLE_COLUMNS.workingAreas.width
            },
            /* @__PURE__ */ React10.createElement(TextComponent3, null, shipperItem.workingAreas.map((workingArea) => workingArea.slug).join(", "))
          )
        );
      });
    },
    [onGoToShipperDetail, hiddenColumns]
  );
  const rowComponents = useMemo5(
    () => getShippersRowsComponents(data.shippers),
    [data.shippers, getShippersRowsComponents]
  );
  return /* @__PURE__ */ React10.createElement(ShippersPageLayoutStyled, null, /* @__PURE__ */ React10.createElement(ToolbarComponent4, null, /* @__PURE__ */ React10.createElement(FiltersComponent, null, /* @__PURE__ */ React10.createElement(
    Input3,
    {
      handleChangeEvent: (e) => {
        const event = e;
        const newValue = event.target.value;
        filters.setSearch(newValue);
      },
      label: shippersPageTranslations.filters.search,
      name: "search",
      type: "search",
      value: filters.selectedFilters.search,
      width: "280px"
    }
  ), showIncludeHiddenFilter ? /* @__PURE__ */ React10.createElement(
    Input3,
    {
      handleChangeValue: (name, value) => {
        const newValue = value === "true";
        filters.setIncludeHidden(newValue);
      },
      label: shippersPageTranslations.filters.includeHidden,
      name: "include_hidden",
      type: "checkbox",
      value: filters.selectedFilters.includeHidden.toString()
    }
  ) : null, showNewShipperButton ? /* @__PURE__ */ React10.createElement(ShippersToolbarButtonsComponent, null, /* @__PURE__ */ React10.createElement(ToolbarButtonComponent4, { onClick: onGoToNewShipper }, /* @__PURE__ */ React10.createElement(CirclePlusIcon, { color: "var(--accent-color-blue)", sizeInPixels: 20 }), shippersPageTranslations.new_shipper)) : null)), /* @__PURE__ */ React10.createElement(PageContent4, null, /* @__PURE__ */ React10.createElement(
    TableComponent2,
    {
      columns,
      emptyStateMessage: shippersPageTranslations.no_shippers_found,
      isError: data.error !== void 0,
      isLoading: data.isLoading,
      numberOfItems: data.count,
      onChangePageSize: handleChangePageSize,
      onGoToNextPage: handleGoToNextPage,
      onGoToPage: handleGoToPage,
      onGoToPreviousPage: handleGoToPreviousPage,
      pageIndex: filters.selectedFilters.page,
      pageSize: filters.selectedFilters.paginationSize,
      pageSizes: filters.filtersOptions.paginationSizes,
      resultsPerPageLabel: shippersPageTranslations.filters.resultsPerPage,
      rowsComponents: rowComponents
    }
  )));
}

// src/modules/shippers/pages/edit-shipper-user/edit-shipper-user-page.tsx
import {
  PageLayout as PageLayout5,
  PageContent as PageContent5,
  ToolbarComponent as ToolbarComponent5,
  ToolbarContentComponent as ToolbarContentComponent4,
  ToolbarButtonComponent as ToolbarButtonComponent5,
  ErrorMessage as ErrorMessage5,
  BlockContainer as BlockContainer6,
  Block as Block6
} from "@ontruck/fe-ui";
import { CloseIcon as CloseIcon4 } from "@ontruck/fe-icons";
import React11, { useMemo as useMemo6 } from "react";
import useSWR5 from "swr";
import { Toaster as Toaster4 } from "sonner";

// src/modules/shippers/pages/edit-shipper-user/edit-shipper-user-page-hook.ts
import { toast as toast4 } from "sonner";

// src/modules/shippers/pages/edit-shipper-user/edit-shipper-user-api.ts
var editShipperUserApi = (_0) => __async(void 0, [_0], function* ({
  shipperUserId,
  consumerConfig,
  editShipperUserDto
}) {
  try {
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${consumerConfig.token}`);
    const endpoint = `${consumerConfig.api_url}api/users/${shipperUserId}/`;
    const requestOptions = {
      method: "PATCH",
      headers,
      body: JSON.stringify(editShipperUserDto)
    };
    const response = yield fetch(endpoint, requestOptions);
    const result = yield response.json();
    if (response.ok) {
      const id = result.id;
      return id;
    }
    if ("username" in result && result.username) {
      throw new Error("user_exists_in_other_shipper");
    }
    if ("phone" in result && result.phone) {
      throw new Error("phone_invalid");
    }
    throw new Error("unexpected_error");
  } catch (e) {
    if (e instanceof Error) {
      throw new Error(e.message);
    }
    throw new Error("unexpected_error");
  }
});

// src/modules/shippers/pages/edit-shipper-user/edit-shipper-user-page-hook.ts
var EditShipperUserPageHook = ({
  mutate,
  consumerConfig,
  shipperUserId,
  shipperUserFormPageTranslations
}) => {
  const submitForm = (_0) => __async(void 0, [_0], function* ({ formState }) {
    try {
      const editShipperUserDto = {
        username: formState.fields.email.value,
        first_name: formState.fields.first_name.value,
        last_name: formState.fields.last_name.value,
        phone: formState.fields.phone.value,
        language: formState.fields.language.value
      };
      yield editShipperUserApi({
        consumerConfig,
        editShipperUserDto,
        shipperUserId
      });
      void mutate();
      toast4.success(shipperUserFormPageTranslations.on_success_message);
    } catch (e) {
      if (e instanceof Error) {
        throw new Error(e.message);
      } else {
        throw new Error("Unexpected error");
      }
    }
  });
  return {
    submitForm
  };
};

// src/modules/shippers/pages/edit-shipper-user/get-shipper-user-api.ts
var getShipperUserApi = (_0) => __async(void 0, [_0], function* ({
  shipperUserId,
  consumerConfig
}) {
  try {
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${consumerConfig.token}`);
    const endpoint = `${consumerConfig.api_url}api/users/${shipperUserId}/`;
    const requestOptions = {
      method: "GET",
      headers
    };
    const response = yield fetch(endpoint, requestOptions);
    if (!response.ok) {
      throw new Error("Failed to fetch shipper");
    }
    const shipperUserDto = yield fetchJson(response);
    return shipperUserDto;
  } catch (e) {
    if (e instanceof Error) {
      throw new Error(e.message);
    } else {
      throw new Error("Unexpected error");
    }
  }
});

// src/modules/shippers/pages/edit-shipper-user/edit-shipper-user-page.tsx
var getShipperUserApiFetcher = (shipperUserId, consumerConfig) => {
  return getShipperUserApi({ shipperUserId, consumerConfig });
};
var mapShipperUserDtoToInitialValues = (shipperUserDto) => {
  if (!shipperUserDto)
    return {};
  return {
    email: shipperUserDto.email,
    last_name: shipperUserDto.last_name,
    first_name: shipperUserDto.first_name,
    phone: shipperUserDto.phone || "",
    language: shipperUserDto.language
  };
};
function EditShipperUserPage({
  consumerConfig,
  shipperUserFormPageTranslations,
  shipperUserFormTranslations,
  onGoToShipperDetail,
  shipperUserId,
  shipperId
}) {
  const fetcher = () => __async(this, null, function* () {
    return getShipperUserApiFetcher(shipperUserId, consumerConfig);
  });
  const { data, error, isLoading, mutate } = useSWR5(
    shipperUserId,
    fetcher,
    {
      errorRetryCount: 0,
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  );
  const initialValues = useMemo6(() => {
    return mapShipperUserDtoToInitialValues(data);
  }, [data]);
  const { submitForm } = EditShipperUserPageHook({
    mutate,
    consumerConfig,
    shipperUserId,
    shipperUserFormPageTranslations
  });
  return /* @__PURE__ */ React11.createElement(PageLayout5, null, /* @__PURE__ */ React11.createElement(ToolbarComponent5, null, /* @__PURE__ */ React11.createElement(ToolbarContentComponent4, null, /* @__PURE__ */ React11.createElement("div", null, /* @__PURE__ */ React11.createElement(ToolbarButtonComponent5, null, shipperUserFormPageTranslations.title)), /* @__PURE__ */ React11.createElement("div", null, /* @__PURE__ */ React11.createElement(
    ToolbarButtonComponent5,
    {
      onClick: () => {
        onGoToShipperDetail(shipperId);
      }
    },
    /* @__PURE__ */ React11.createElement(CloseIcon4, null)
  )))), /* @__PURE__ */ React11.createElement(PageContent5, { withBackground: true }, (() => {
    if (error) {
      return /* @__PURE__ */ React11.createElement(BlockContainer6, null, /* @__PURE__ */ React11.createElement(Block6, null, /* @__PURE__ */ React11.createElement(ErrorMessage5, null, "There was an error loading the user")));
    }
    if (isLoading) {
      return /* @__PURE__ */ React11.createElement(ShipperFormSkeletonComponent, null);
    }
    return /* @__PURE__ */ React11.createElement(
      ShipperUserForm,
      {
        config: consumerConfig,
        initialValues,
        shipperUserFormPageTranslations,
        shipperUserFormTranslations,
        submitForm
      }
    );
  })()), /* @__PURE__ */ React11.createElement(Toaster4, { richColors: true }));
}

// src/modules/user-management/pages/groups/groups-page.tsx
import {
  PageLayout as PageLayout6,
  PageContent as PageContent6,
  ToolbarComponent as ToolbarComponent6,
  ToolbarButtonComponent as ToolbarButtonComponent6,
  FlexComponent as FlexComponent4,
  TableComponent as TableComponent3,
  TableCellComponent as TableCellComponent4,
  TextComponent as TextComponent4
} from "@ontruck/fe-ui";
import { CirclePlusIcon as CirclePlusIcon2 } from "@ontruck/fe-icons";
import React12, { useCallback as useCallback7, useMemo as useMemo7 } from "react";
import styled6 from "styled-components";

// src/modules/user-management/pages/groups/get-groups-filtered-hook.ts
import useSWR6 from "swr";

// src/modules/user-management/pages/groups/settings.ts
var RELOAD_GROUPS_LIST_INTERVAL_IN_SECONDS = 30;

// src/modules/user-management/pages/groups/get-groups-api.ts
var getGroupsApi = (_0) => __async(void 0, [_0], function* ({ config }) {
  const endpoint = `${config.api_url}api/auth/management/groups/?page_size=0`;
  const response = yield fetch(endpoint, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${config.token}`
    }
  });
  const data = yield fetchJson(response);
  return data;
});

// src/modules/user-management/pages/groups/get-groups-api-fetcher.ts
var getGroupsApiFetcher = (config) => {
  return getGroupsApi({ config });
};

// src/modules/user-management/pages/groups/get-groups-mapped-service.ts
function getGroupsMapedService(groupsDto) {
  if (!groupsDto) {
    return;
  }
  const groupsMapped = groupsDto.map((groupDto) => {
    try {
      const group = {
        id: groupDto.id,
        name: groupDto.name,
        user_count: groupDto.user_count,
        permissions: groupDto.permissions.map((permission) => ({
          id: permission,
          name: permission
        }))
      };
      return group;
    } catch (e) {
      console.error("Error mapping group with id ", groupDto.id);
      console.error(e);
      throw e;
    }
  });
  const count = groupsMapped.length;
  return {
    groups: groupsMapped,
    count
  };
}

// src/modules/user-management/pages/groups/get-groups-filtered-hook.ts
var useGetGroupsFilteredHook = ({
  config
}) => {
  const fetcher = () => __async(void 0, null, function* () {
    return getGroupsApiFetcher(config);
  });
  const { data, error, isLoading, mutate } = useSWR6(
    "groups",
    () => fetcher(),
    {
      refreshInterval: RELOAD_GROUPS_LIST_INTERVAL_IN_SECONDS * 1e3,
      revalidateIfStale: true
    }
  );
  const groupsMapped = getGroupsMapedService(data);
  return {
    groups: (groupsMapped == null ? void 0 : groupsMapped.groups) || [],
    count: (groupsMapped == null ? void 0 : groupsMapped.count) || 0,
    isLoading,
    error,
    mutate
  };
};

// src/modules/user-management/pages/groups/groups-page.tsx
var GroupsPageLayoutStyled = styled6(PageLayout6)`
  background-color: var(--otk-theme-color-white);
`;
var GroupsToolbarButtonsComponent = styled6(FlexComponent4)`
  border-left: 1px solid var(--accent-color-gray);
  margin-left: auto;
`;
var GroupRowStyled = styled6(FlexComponent4)`
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;
var TABLE_COLUMNS2 = {
  userRole: {
    width: "288px"
  },
  appliedTo: {
    width: "288px"
  }
};
function GroupsPage({
  consumerConfig,
  groupsPageTranslations,
  onGoToNewGroup,
  onGoToGroupDetail
}) {
  const data = useGetGroupsFilteredHook({
    config: consumerConfig
  });
  const columns = useMemo7(() => {
    const baseColumns = {
      userRole: {
        id: "0",
        width: TABLE_COLUMNS2.userRole.width,
        label: groupsPageTranslations.columns.userRole
      },
      appliedTo: {
        id: "1",
        width: TABLE_COLUMNS2.appliedTo.width,
        label: groupsPageTranslations.columns.appliedTo
      }
    };
    return baseColumns;
  }, [groupsPageTranslations]);
  const getGroupsRowsComponents = useCallback7(
    (groups) => {
      return groups.map((groupItem) => {
        return /* @__PURE__ */ React12.createElement(
          GroupRowStyled,
          {
            alignItems: "center",
            borderTop: "1px solid var(--grey-200, #E2E8EE)",
            key: groupItem.id,
            onClick: () => {
              onGoToGroupDetail(groupItem.id);
            }
          },
          /* @__PURE__ */ React12.createElement(
            TableCellComponent4,
            {
              borderLeft: "1px solid var(--grey-200, #E2E8EE)",
              width: TABLE_COLUMNS2.userRole.width
            },
            /* @__PURE__ */ React12.createElement(TextComponent4, null, groupItem.name)
          ),
          /* @__PURE__ */ React12.createElement(
            TableCellComponent4,
            {
              borderLeft: "1px solid var(--grey-200, #E2E8EE)",
              width: TABLE_COLUMNS2.appliedTo.width
            },
            /* @__PURE__ */ React12.createElement(TextComponent4, null, groupItem.user_count, " ", groupsPageTranslations.columns.users)
          )
        );
      });
    },
    [onGoToGroupDetail, groupsPageTranslations]
  );
  const rowComponents = useMemo7(
    () => getGroupsRowsComponents(data.groups),
    [data.groups, getGroupsRowsComponents]
  );
  return /* @__PURE__ */ React12.createElement(GroupsPageLayoutStyled, null, /* @__PURE__ */ React12.createElement(ToolbarComponent6, null, /* @__PURE__ */ React12.createElement("div", null, /* @__PURE__ */ React12.createElement(ToolbarButtonComponent6, null, groupsPageTranslations.title)), /* @__PURE__ */ React12.createElement(GroupsToolbarButtonsComponent, null, /* @__PURE__ */ React12.createElement(ToolbarButtonComponent6, { onClick: onGoToNewGroup }, /* @__PURE__ */ React12.createElement(CirclePlusIcon2, { color: "var(--accent-color-blue)", sizeInPixels: 20 }), groupsPageTranslations.new))), /* @__PURE__ */ React12.createElement(PageContent6, null, /* @__PURE__ */ React12.createElement(
    TableComponent3,
    {
      columns,
      emptyStateMessage: groupsPageTranslations.not_found,
      isError: data.error !== void 0,
      isLoading: data.isLoading,
      numberOfItems: data.count,
      rowsComponents: rowComponents
    }
  )));
}

// src/modules/user-management/pages/new-group/new-group-page.tsx
import {
  PageLayout as PageLayout7,
  PageContent as PageContent7,
  ToolbarComponent as ToolbarComponent7,
  ToolbarContentComponent as ToolbarContentComponent5,
  ToolbarButtonComponent as ToolbarButtonComponent7,
  BlockContainer as BlockContainer9,
  Block as Block9,
  ErrorMessage as ErrorMessage7
} from "@ontruck/fe-ui";
import { CloseIcon as CloseIcon5 } from "@ontruck/fe-icons";
import React15 from "react";
import { Toaster as Toaster5 } from "sonner";

// src/modules/user-management/components/group-form/group-form.tsx
import React13, { useCallback as useCallback9 } from "react";
import {
  FormContainer as FormContainer4,
  Block as Block7,
  BlockContainer as BlockContainer7,
  SectionContainer as SectionContainer3,
  SectionTitle as SectionTitle4,
  SectionBody as SectionBody4,
  SectionLine as SectionLine4,
  Sticky as Sticky3,
  ButtonContainer as ButtonContainer3,
  Half as Half3,
  ButtonComponent as ButtonComponent3,
  Input as Input4,
  ErrorMessage as ErrorMessage6
} from "@ontruck/fe-ui";
import {
  CogIcon,
  ContentModulesIcon,
  OtherActionsIcon,
  UserManagementIcon
} from "@ontruck/fe-icons";

// src/modules/user-management/components/group-form/group-form-hook.ts
import { useCallback as useCallback8, useMemo as useMemo8, useState as useState4 } from "react";

// src/modules/user-management/components/group-form/group-form-translations.ts
var BACKEND_ERROR_MAPPING3 = {
  user_exists_in_other_shipper: "user_exists_in_other_shipper" /* UserExistsInOtherShipper */,
  phone_invalid: "phone_invalid" /* PhoneInvalid */
};
var getErrorTranslation3 = (errorMessage, translations2) => {
  const errorKey = BACKEND_ERROR_MAPPING3[errorMessage];
  switch (errorKey) {
    case "user_exists_in_other_shipper" /* UserExistsInOtherShipper */:
      return translations2.errors.user_exists_in_other_shipper;
    case "phone_invalid" /* PhoneInvalid */:
      return translations2.errors.phone_invalid;
    default:
      return translations2.errors.unexpected_error;
  }
};

// src/modules/user-management/components/group-form/group-form-hook.ts
var defaultFieldDefinitions3 = {
  name: {
    type: "text",
    is_required: true,
    validation_pattern: notEmptyStringRegex,
    label: "Role name",
    name: "name"
  },
  permissions: {
    type: "text",
    is_required: false,
    label: "Permissions",
    name: "permissions"
  },
  workingAreas: {
    type: "text",
    is_required: false,
    label: "Working areas",
    name: "workingAreas"
  }
};
var getTranslatedFieldDefinitions3 = ({
  fieldDefinitions,
  translations: translations2
}) => {
  const definitions = {};
  Object.entries(fieldDefinitions).forEach(([key, definition]) => {
    const fieldKey = key;
    definitions[key] = __spreadProps(__spreadValues({}, definition), {
      label: translations2.fields[fieldKey]
    });
  });
  return definitions;
};
function useGroupFormHook({
  groupFormTranslations,
  submitForm,
  initialValues = {}
}) {
  const fieldDefinitions = useMemo8(() => {
    const translatedFieldDefintions = getTranslatedFieldDefinitions3({
      fieldDefinitions: defaultFieldDefinitions3,
      translations: groupFormTranslations
    });
    return translatedFieldDefintions;
  }, [groupFormTranslations]);
  const initialState = getInitialState({
    fieldDefinitions,
    initialValues
  });
  const [formState, setFormState] = useState4(initialState);
  const isValid = useMemo8(() => {
    for (const field of Object.values(formState.fields)) {
      if (!field.isValid) {
        return false;
      }
    }
    return true;
  }, [formState.fields]);
  const handleSubmit = useCallback8(
    (e) => __async(this, null, function* () {
      e.preventDefault();
      setFormState((prev) => __spreadProps(__spreadValues({}, prev), {
        show_errors: true,
        submit_errors: {}
      }));
      if (!isValid)
        return;
      try {
        setFormState((prev) => __spreadProps(__spreadValues({}, prev), { is_submiting: true }));
        yield submitForm({ formState });
        setFormState((prev) => __spreadProps(__spreadValues({}, prev), { is_submiting: false }));
      } catch (error) {
        setFormState((prev) => __spreadProps(__spreadValues({}, prev), {
          is_submiting: false,
          submit_errors: {
            uncontrolled: error instanceof Error ? error.message : groupFormTranslations.errors.unexpected_error
          }
        }));
      }
    }),
    [formState, isValid, groupFormTranslations, submitForm]
  );
  const handleChangeValue = useCallback8((fieldName, value) => {
    try {
      if (value === void 0)
        return;
      setFormState((previousState) => {
        const newState = __spreadProps(__spreadValues({}, previousState), {
          fields: __spreadProps(__spreadValues({}, previousState.fields), {
            [fieldName]: __spreadProps(__spreadValues({}, previousState.fields[fieldName]), {
              value
            })
          })
        });
        return getValidatedFormState(newState);
      });
    } catch (error) {
      console.error("\u{1F525} ~ handleChangeValue error:", error);
    }
  }, []);
  const handleChangeEvent = useCallback8(
    (e, fieldName) => {
      const value = e.currentTarget.value;
      handleChangeValue(fieldName, value);
    },
    [handleChangeValue]
  );
  const backendErrors = useMemo8(() => {
    const errors = [];
    Object.values(formState.submit_errors).forEach((errorMessage) => {
      const translatedMessage = getErrorTranslation3(errorMessage, groupFormTranslations);
      errors.push(translatedMessage);
    });
    return errors;
  }, [formState.submit_errors, groupFormTranslations]);
  const isSubmitting = formState.is_submiting;
  const fields = formState.fields;
  const showErrors = formState.show_errors;
  return {
    handleSubmit,
    handleChangeValue,
    handleChangeEvent,
    backendErrors,
    isSubmitting,
    fields,
    showErrors,
    formState
  };
}

// src/modules/user-management/components/group-form/permission-groups.ts
var PERMISSION_GROUPS = {
  tickets: {
    name: "Tickets",
    displayMode: "inline",
    category: "content_modules",
    permissions: [
      "price_negotiation.ticket.view_ticket",
      "price_negotiation.ticket.add_ticket",
      "price_negotiation.ticket.change_ticket",
      "price_negotiation.ticket.cancel_ticket"
    ]
  },
  quotes: {
    name: "Quotes",
    displayMode: "inline",
    category: "content_modules",
    permissions: [
      "price_negotiation.quote.view_quote",
      "price_negotiation.quote.add_quote",
      "price_negotiation.quote.change_quote"
    ]
  },
  shippers: {
    name: "Customers",
    displayMode: "inline",
    category: "user_management",
    permissions: [
      "core.shipper.view_shipper",
      "core.shipper.add_shipper",
      "core.shipper.change_shipper",
      "core.shipper.delete_shipper"
    ]
  },
  carriers: {
    name: "Carriers",
    displayMode: "inline",
    category: "user_management",
    permissions: [
      "core.carrier.view_carrier",
      "core.carrier.add_carrier",
      "core.carrier.change_carrier",
      "core.carrier.delete_carrier"
    ]
  },
  users: {
    name: "Users",
    displayMode: "inline",
    category: "user_management",
    permissions: ["users.user.view_user", "users.user.add_user", "users.user.change_user"]
  },
  actions: {
    name: "Other specific actions",
    displayMode: "stacked",
    permissions: [
      "price_negotiation.ticket.assign_ticket_to_region",
      "price_negotiation.ticket.assign_ticket",
      "price_negotiation.ticket.move_ticket_to_tms",
      "price_negotiation.ticketcomment.add_ticketcomment",
      "price_negotiation.ticket.provide_ticket_feedback",
      "price_negotiation.quote.accept_quote",
      "price_negotiation.quote.reject_quote",
      "price_negotiation.pricesuggestion.add_pricesuggestion",
      "price_negotiation.pricesuggestion.view_pricesuggestion",
      "fleet.auction.change_auction",
      "fleet.bid.add_bid",
      "price_negotiation.quote.provide_quote_feedback",
      "price_negotiation.ticket.send_ticket_update",
      "price_negotiation.ticket.own_ticket",
      "core.shipper.assign_shipper_to_region,"
    ]
  }
};
var getPermissionTranslation = (permissionId, groupFormTranslations) => {
  if (groupFormTranslations.permissions[permissionId]) {
    return groupFormTranslations.permissions[permissionId];
  }
  return permissionId.split("-").map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
};
var getPermissionCategoryTranslation = (category, groupFormTranslations) => {
  if (groupFormTranslations.categories[category]) {
    return groupFormTranslations.categories[category];
  }
  return category;
};
var getPermissionGroupKeyTranslation = (groupKey, groupFormTranslations) => {
  if (groupFormTranslations.groups[groupKey]) {
    return groupFormTranslations.groups[groupKey];
  }
  return groupKey;
};
var getPermissionTypePriority = (permissionId) => {
  if (permissionId.includes("view"))
    return 1;
  if (permissionId.includes("add"))
    return 2;
  if (permissionId.includes("change") || permissionId.includes("edit"))
    return 3;
  if (permissionId.includes("delete") || permissionId.includes("cancel"))
    return 4;
  return 5;
};
var sortPermissionsByType = (permissions) => {
  return [...permissions].sort((a, b) => {
    const priorityA = getPermissionTypePriority(a.id);
    const priorityB = getPermissionTypePriority(b.id);
    return priorityA - priorityB;
  });
};

// src/modules/user-management/components/group-form/group-form.tsx
var getPermissionCategoryIcon = (category) => {
  switch (category) {
    case "content_modules":
      return /* @__PURE__ */ React13.createElement(ContentModulesIcon, { color: "var(--grey500)", sizeInPixels: 16 });
    case "user_management":
      return /* @__PURE__ */ React13.createElement(UserManagementIcon, { color: "var(--grey500)", sizeInPixels: 16 });
    case "actions":
      return /* @__PURE__ */ React13.createElement(OtherActionsIcon, { color: "var(--grey500)", sizeInPixels: 16 });
    case "others":
      return /* @__PURE__ */ React13.createElement(CogIcon, { color: "var(--grey500)", sizeInPixels: 16 });
    default:
      return /* @__PURE__ */ React13.createElement(CogIcon, { color: "var(--grey500)", sizeInPixels: 16 });
  }
};
function FormInput3({
  field,
  handleChangeEvent,
  handleChangeValue,
  showErrors
}) {
  return /* @__PURE__ */ React13.createElement(
    Input4,
    {
      handleChangeEvent: (e) => {
        handleChangeEvent(e, field.definition.name);
      },
      handleChangeValue,
      hasError: showErrors ? !field.isValid : false,
      isRequired: field.definition.is_required,
      label: field.definition.label,
      name: field.definition.name,
      type: field.definition.type,
      value: field.value
    }
  );
}
function GroupForm({
  groupFormTranslations,
  groupFormPageTranslations,
  submitForm,
  initialValues = {},
  permissions,
  workingAreas
}) {
  const {
    handleSubmit,
    handleChangeValue,
    handleChangeEvent,
    backendErrors,
    isSubmitting,
    fields,
    showErrors,
    formState
  } = useGroupFormHook({
    groupFormTranslations,
    submitForm,
    initialValues
  });
  const permissionsChecked = formState.fields.permissions.value.trim().split(",").map((permission) => permission.trim()).filter((permission) => permission !== "");
  const workingAreasChecked = formState.fields.workingAreas.value.trim().split(",").map((workingArea) => workingArea.trim()).filter((workingArea) => workingArea !== "");
  const onPermissionClick = (permission) => {
    const isSelected = permissionsChecked.includes(permission);
    if (isSelected) {
      const newPermissionsChecked = permissionsChecked.filter((p) => p !== permission);
      handleChangeValue("permissions", newPermissionsChecked.join(","));
    } else {
      const newPermissionsChecked = [...permissionsChecked, permission];
      handleChangeValue("permissions", newPermissionsChecked.join(","));
    }
  };
  const onWorkingAreaClick = (workingArea) => {
    const isSelected = workingAreasChecked.includes(workingArea);
    if (isSelected) {
      const newWorkingAreasChecked = workingAreasChecked.filter((w) => w !== workingArea);
      handleChangeValue("workingAreas", newWorkingAreasChecked.join(","));
    } else {
      const newWorkingAreasChecked = [...workingAreasChecked, workingArea];
      handleChangeValue("workingAreas", newWorkingAreasChecked.join(","));
    }
  };
  const renderFormInput = useCallback9(
    (field) => {
      return /* @__PURE__ */ React13.createElement(
        FormInput3,
        {
          field,
          handleChangeEvent,
          handleChangeValue,
          showErrors
        }
      );
    },
    [handleChangeEvent, handleChangeValue, showErrors]
  );
  const renderPermissionGroup = (groupKey, perms, group) => {
    if (perms.length === 0)
      return null;
    const isInlineGroup = (group == null ? void 0 : group.displayMode) === "inline";
    const sortedPerms = sortPermissionsByType(perms);
    const translatedGroupKey = getPermissionGroupKeyTranslation(groupKey, groupFormTranslations);
    return /* @__PURE__ */ React13.createElement(React13.Fragment, { key: groupKey }, isInlineGroup ? /* @__PURE__ */ React13.createElement(CategoryInlineCheckboxGroupContainer, null, /* @__PURE__ */ React13.createElement(CheckboxListGroupTitleComponent, null, translatedGroupKey), /* @__PURE__ */ React13.createElement(InlineCheckboxContainer, null, sortedPerms.map((permission) => /* @__PURE__ */ React13.createElement(InlineCheckboxItem, { key: permission.id }, /* @__PURE__ */ React13.createElement(
      Input4,
      {
        handleChangeValue: (_name, _value) => {
          onPermissionClick(permission.id);
        },
        name: `permission-${permission.id}`,
        type: "checkbox",
        value: permissionsChecked.includes(permission.id).toString()
      }
    ))), sortedPerms.length < 4 && /* @__PURE__ */ React13.createElement(NonBinaryCheckboxContainer, { key: "more" }, /* @__PURE__ */ React13.createElement(NonBinaryCheckbox, null)))) : /* @__PURE__ */ React13.createElement(React13.Fragment, null, /* @__PURE__ */ React13.createElement(
      CheckboxListGroupTitleComponent,
      {
        style: {
          paddingLeft: groupKey === "actions" || groupKey === "others" ? "0" : "16px"
        }
      },
      getPermissionCategoryIcon(groupKey),
      translatedGroupKey
    ), sortedPerms.map((permission) => /* @__PURE__ */ React13.createElement(SingleLineCheckboxItem, { key: permission.id }, /* @__PURE__ */ React13.createElement(
      Input4,
      {
        handleChangeValue: (_name, _value) => {
          onPermissionClick(permission.id);
        },
        label: getPermissionTranslation(permission.id, groupFormTranslations),
        name: `permission-${permission.id}`,
        type: "checkbox",
        value: permissionsChecked.includes(permission.id).toString()
      }
    )))));
  };
  const renderPermissionsByCategory = (rawPermissions, category) => {
    const groupsInCategory = Object.entries(PERMISSION_GROUPS).filter(
      ([_, group]) => group.category === category
    );
    return /* @__PURE__ */ React13.createElement(React13.Fragment, null, rawPermissions.length > 0 ? /* @__PURE__ */ React13.createElement(CategoryTitleComponent, null, getPermissionCategoryIcon(category), getPermissionCategoryTranslation(category, groupFormTranslations), /* @__PURE__ */ React13.createElement(CategoryHeaderComponent, null, /* @__PURE__ */ React13.createElement(CategoryHeaderColumnComponent, null, groupFormTranslations.view), /* @__PURE__ */ React13.createElement(CategoryHeaderColumnComponent, null, groupFormTranslations.add), /* @__PURE__ */ React13.createElement(CategoryHeaderColumnComponent, null, groupFormTranslations.change), /* @__PURE__ */ React13.createElement(CategoryHeaderColumnComponent, null, category === "content_modules" ? groupFormTranslations.cancel : groupFormTranslations.delete))) : null, groupsInCategory.map(([groupKey, group]) => {
      const perms = rawPermissions.filter((p) => group.permissions.includes(p.id));
      return renderPermissionGroup(groupKey, perms, group);
    }));
  };
  return /* @__PURE__ */ React13.createElement(FormContainer4, null, /* @__PURE__ */ React13.createElement("form", { autoComplete: "off", onSubmit: (event) => void handleSubmit(event) }, /* @__PURE__ */ React13.createElement(BlockContainer7, null, /* @__PURE__ */ React13.createElement(Block7, null, /* @__PURE__ */ React13.createElement(SectionContainer3, null, /* @__PURE__ */ React13.createElement(SectionTitle4, null, groupFormTranslations.sections.rol_section), /* @__PURE__ */ React13.createElement(SectionBody4, null, /* @__PURE__ */ React13.createElement(SectionLine4, null, renderFormInput(fields.name)))), /* @__PURE__ */ React13.createElement(SectionContainer3, null, /* @__PURE__ */ React13.createElement(SectionTitle4, null, groupFormTranslations.sections.working_areas_section), /* @__PURE__ */ React13.createElement(MulticheckboxBodyComponent, null, workingAreas.map((workingArea) => /* @__PURE__ */ React13.createElement(MulticheckboxItemComponent, { key: workingArea.id }, /* @__PURE__ */ React13.createElement(
    Input4,
    {
      handleChangeValue: (_name, _value) => {
        onWorkingAreaClick(workingArea.name);
      },
      label: workingArea.name,
      name: `working-area-${workingArea.id}`,
      type: "checkbox",
      value: workingAreasChecked.includes(workingArea.name).toString()
    }
  ))))), /* @__PURE__ */ React13.createElement(SectionContainer3, null, /* @__PURE__ */ React13.createElement(SectionTitle4, null, groupFormTranslations.sections.permissions_section), /* @__PURE__ */ React13.createElement(CheckboxListBodyComponent, null, renderPermissionsByCategory(permissions, "content_modules"), renderPermissionsByCategory(permissions, "user_management"), Object.entries(PERMISSION_GROUPS).filter(([_, group]) => !group.category).map(([groupKey, group]) => {
    const perms = permissions.filter((p) => group.permissions.includes(p.id));
    return renderPermissionGroup(groupKey, perms, group);
  }), (() => {
    const otherPerms = permissions.filter(
      (p) => !Object.values(PERMISSION_GROUPS).some((g) => g.permissions.includes(p.id))
    );
    return renderPermissionGroup("others", otherPerms);
  })())), backendErrors.length > 0 && /* @__PURE__ */ React13.createElement(SectionContainer3, null, /* @__PURE__ */ React13.createElement(SectionBody4, null, /* @__PURE__ */ React13.createElement(ErrorMessage6, null, backendErrors.map((errorMessage) => {
    return /* @__PURE__ */ React13.createElement("div", { key: errorMessage }, errorMessage);
  })))))), /* @__PURE__ */ React13.createElement(Sticky3, null, /* @__PURE__ */ React13.createElement(ButtonContainer3, null, /* @__PURE__ */ React13.createElement(Half3, null, /* @__PURE__ */ React13.createElement(
    ButtonComponent3,
    {
      color: "primary",
      disabled: isSubmitting,
      fullWidth: true,
      size: "s",
      type: "submit"
    },
    isSubmitting ? groupFormPageTranslations.form_button_loading_text : groupFormPageTranslations.form_button_text
  ))))));
}

// src/modules/user-management/components/group-form/group-form-skeleton-component.tsx
import { Block as Block8, BlockContainer as BlockContainer8, FormContainer as FormContainer5 } from "@ontruck/fe-ui";
import React14 from "react";
import ContentLoader2 from "react-content-loader";
function GroupFormSkeletonComponent() {
  return /* @__PURE__ */ React14.createElement(FormContainer5, null, /* @__PURE__ */ React14.createElement(BlockContainer8, null, /* @__PURE__ */ React14.createElement(Block8, null, /* @__PURE__ */ React14.createElement(ContentLoader2, { height: 300, viewBox: "0 0 600 300", width: 600 }, /* @__PURE__ */ React14.createElement("rect", { height: "30", rx: "3", ry: "3", width: "100", x: "0", y: "0" }), /* @__PURE__ */ React14.createElement("rect", { height: "30", rx: "3", ry: "3", width: "600", x: "20", y: "60" }), /* @__PURE__ */ React14.createElement("rect", { height: "30", rx: "3", ry: "3", width: "600", x: "20", y: "110" }), /* @__PURE__ */ React14.createElement("rect", { height: "30", rx: "3", ry: "3", width: "600", x: "20", y: "160" }), /* @__PURE__ */ React14.createElement("rect", { height: "30", rx: "3", ry: "3", width: "600", x: "20", y: "210" })), /* @__PURE__ */ React14.createElement(ContentLoader2, { height: 300, viewBox: "0 0 600 300", width: 600 }, /* @__PURE__ */ React14.createElement("rect", { height: "30", rx: "3", ry: "3", width: "100", x: "0", y: "0" }), /* @__PURE__ */ React14.createElement("rect", { height: "30", rx: "3", ry: "3", width: "600", x: "20", y: "60" }), /* @__PURE__ */ React14.createElement("rect", { height: "30", rx: "3", ry: "3", width: "600", x: "20", y: "110" }), /* @__PURE__ */ React14.createElement("rect", { height: "30", rx: "3", ry: "3", width: "600", x: "20", y: "160" }), /* @__PURE__ */ React14.createElement("rect", { height: "30", rx: "3", ry: "3", width: "600", x: "20", y: "210" })))));
}

// src/modules/user-management/pages/new-group/new-group-page-hook.ts
import { toast as toast5 } from "sonner";

// src/modules/user-management/components/user-form/user-form-options-hook.ts
import useSWR7 from "swr";

// src/modules/user-management/permissions/get-permissions-api.ts
var getPermissionsApi = (_0) => __async(void 0, [_0], function* ({
  config
}) {
  const endpoint = `${config.api_url}api/auth/management/users/assignable_permissions/`;
  const response = yield fetch(endpoint, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${config.token}`
    }
  });
  const data = yield fetchJson(response);
  return data;
});

// src/modules/user-management/permissions/get-permissions-mapped-service.ts
function getPermissionsMappedService(permissionsDto) {
  if (!permissionsDto) {
    return;
  }
  const permissionsMapped = permissionsDto.map((permissionDto) => {
    try {
      const permission = {
        id: permissionDto,
        name: permissionDto
      };
      return permission;
    } catch (e) {
      console.error("Error mapping permission with id ", permissionDto);
      console.error(e);
      throw e;
    }
  });
  const sortedPermissions = permissionsMapped.sort((a, b) => {
    return a.name.localeCompare(b.name);
  });
  return sortedPermissions;
}

// src/modules/user-management/alert-subscriptions/get-alert-subscriptions-mapped-service.ts
function getAlertSubscriptionsMappedService(alertSubscriptionsDto) {
  if (!alertSubscriptionsDto) {
    return;
  }
  const alertSubscriptionsMapped = alertSubscriptionsDto.map((alertSubscriptionDto) => {
    try {
      const alertSubscription = {
        id: alertSubscriptionDto,
        name: alertSubscriptionDto
      };
      return alertSubscription;
    } catch (e) {
      console.error("Error mapping alert subscription with id ", alertSubscriptionDto);
      console.error(e);
      throw e;
    }
  });
  return alertSubscriptionsMapped;
}

// src/modules/user-management/alert-subscriptions/get-alert-subscriptions-api.ts
var getAlertSubscriptionsApi = (_0) => __async(void 0, [_0], function* ({
  config
}) {
  const endpoint = `${config.api_url}v1/price-negotiation/alerts/alert_types/`;
  const response = yield fetch(endpoint, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${config.token}`
    }
  });
  const data = yield fetchJson(response);
  return data;
});

// src/modules/user-management/components/user-form/user-form-options-hook.ts
var useFormOptionsHook = ({
  consumerConfig
}) => {
  const groupsFetcher = () => __async(void 0, null, function* () {
    return getGroupsApi({ config: consumerConfig });
  });
  const {
    data: groupsData,
    error: groupsError,
    isLoading: groupsLoading
  } = useSWR7("groups", groupsFetcher, {
    errorRetryCount: 0,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  });
  const groupsMapped = getGroupsMapedService(groupsData);
  const permissionsFetcher = () => __async(void 0, null, function* () {
    return getPermissionsApi({ config: consumerConfig });
  });
  const {
    data: permissionsData,
    error: permissionsError,
    isLoading: permissionsLoading
  } = useSWR7("permissions", permissionsFetcher, {
    errorRetryCount: 0,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  });
  const permissionsMapped = getPermissionsMappedService(permissionsData);
  const alertSubscriptionsFetcher = () => __async(void 0, null, function* () {
    return getAlertSubscriptionsApi({ config: consumerConfig });
  });
  const {
    data: alertSubscriptionsData,
    error: alertSubscriptionsError,
    isLoading: alertSubscriptionsLoading
  } = useSWR7("alert-subscriptions", alertSubscriptionsFetcher, {
    errorRetryCount: 0,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  });
  const alertSubscriptionsMapped = getAlertSubscriptionsMappedService(alertSubscriptionsData);
  const workingAreasFetcher = () => __async(void 0, null, function* () {
    return getWorkingAreasApi({ config: consumerConfig });
  });
  const {
    data: workingAreasData,
    error: workingAreasError,
    isLoading: workingAreasLoading
  } = useSWR7("working-areas", workingAreasFetcher, {
    errorRetryCount: 0,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  });
  const workingAreasMapped = getWorkingAreasMappedService(workingAreasData);
  return {
    error: groupsError || permissionsError || alertSubscriptionsError || workingAreasError,
    isLoading: groupsLoading || permissionsLoading || alertSubscriptionsLoading || workingAreasLoading,
    options: {
      groups: (groupsMapped == null ? void 0 : groupsMapped.groups) || [],
      permissions: permissionsMapped || [],
      alertSubscriptions: alertSubscriptionsMapped || [],
      workingAreas: workingAreasMapped || []
    }
  };
};

// src/modules/user-management/pages/new-group/create-group-api.ts
var createGroupApi = (_0) => __async(void 0, [_0], function* ({
  createGroupDto,
  consumerConfig
}) {
  try {
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${consumerConfig.token}`);
    const body = JSON.stringify(createGroupDto);
    const endpoint = `${consumerConfig.api_url}api/auth/management/groups/`;
    const requestOptions = {
      method: "POST",
      headers,
      body
    };
    const response = yield fetch(endpoint, requestOptions);
    const result = yield response.json();
    if (response.ok) {
      const shipperUserId = result.id;
      return shipperUserId;
    }
    if ("username" in result && result.username) {
      throw new Error("user_exists_in_other_shipper");
    }
    throw new Error("unexpected_error");
  } catch (e) {
    if (e instanceof Error) {
      throw new Error(e.message);
    } else {
      throw new Error("Unexpected error");
    }
  }
});

// src/modules/user-management/pages/new-group/new-group-page-hook.ts
var useNewGroupPageHook = ({
  consumerConfig,
  onGoToGroups,
  groupFormPageTranslations
}) => {
  const submitForm = (_0) => __async(void 0, [_0], function* ({ formState }) {
    try {
      let permissions2 = formState.fields.permissions.value.split(",");
      if (permissions2[0] === "") {
        permissions2 = [];
      }
      let workingAreas2 = formState.fields.workingAreas.value.split(",");
      if (workingAreas2[0] === "") {
        workingAreas2 = [];
      }
      const createGroupDto = {
        name: formState.fields.name.value,
        permissions: permissions2,
        working_areas: workingAreas2
      };
      yield createGroupApi({
        createGroupDto,
        consumerConfig
      });
      toast5.success(groupFormPageTranslations.on_success_message);
      onGoToGroups();
    } catch (e) {
      toast5.error(groupFormPageTranslations.on_error_message);
      if (e instanceof Error) {
        throw new Error(e.message);
      } else {
        throw new Error("Unexpected error");
      }
    }
  });
  const {
    options: { permissions, workingAreas },
    error,
    isLoading
  } = useFormOptionsHook({
    consumerConfig
  });
  return {
    submitForm,
    permissions,
    workingAreas,
    error,
    isLoading
  };
};

// src/modules/user-management/pages/new-group/new-group-page.tsx
function NewGroupPage({
  consumerConfig,
  groupFormPageTranslations,
  groupFormTranslations,
  onGoToGroups
}) {
  const { submitForm, permissions, error, isLoading, workingAreas } = useNewGroupPageHook({
    consumerConfig,
    onGoToGroups,
    groupFormPageTranslations
  });
  return /* @__PURE__ */ React15.createElement(PageLayout7, null, /* @__PURE__ */ React15.createElement(ToolbarComponent7, null, /* @__PURE__ */ React15.createElement(ToolbarContentComponent5, null, /* @__PURE__ */ React15.createElement("div", null, /* @__PURE__ */ React15.createElement(ToolbarButtonComponent7, null, groupFormPageTranslations.title)), /* @__PURE__ */ React15.createElement("div", null, /* @__PURE__ */ React15.createElement(
    ToolbarButtonComponent7,
    {
      onClick: () => {
        onGoToGroups();
      }
    },
    /* @__PURE__ */ React15.createElement(CloseIcon5, null)
  )))), /* @__PURE__ */ React15.createElement(PageContent7, { withBackground: true }, (() => {
    if (error) {
      return /* @__PURE__ */ React15.createElement(BlockContainer9, null, /* @__PURE__ */ React15.createElement(Block9, null, /* @__PURE__ */ React15.createElement(ErrorMessage7, null, "There was an error loading the data")));
    }
    if (isLoading) {
      return /* @__PURE__ */ React15.createElement(GroupFormSkeletonComponent, null);
    }
    return /* @__PURE__ */ React15.createElement(
      GroupForm,
      {
        config: consumerConfig,
        groupFormPageTranslations,
        groupFormTranslations,
        permissions,
        submitForm,
        workingAreas
      }
    );
  })()), /* @__PURE__ */ React15.createElement(Toaster5, { richColors: true }));
}

// src/modules/user-management/pages/edit-group/edit-group-page.tsx
import {
  PageLayout as PageLayout8,
  PageContent as PageContent8,
  ToolbarComponent as ToolbarComponent8,
  ToolbarContentComponent as ToolbarContentComponent6,
  ToolbarButtonComponent as ToolbarButtonComponent8,
  ErrorMessage as ErrorMessage8,
  BlockContainer as BlockContainer10,
  Block as Block10
} from "@ontruck/fe-ui";
import { CloseIcon as CloseIcon6 } from "@ontruck/fe-icons";
import React16, { useMemo as useMemo9 } from "react";
import useSWR8 from "swr";
import { Toaster as Toaster6 } from "sonner";

// src/modules/user-management/pages/edit-group/edit-group-page-hook.ts
import { toast as toast6 } from "sonner";

// src/modules/user-management/pages/edit-group/edit-group-api.ts
var editGroupApi = (_0) => __async(void 0, [_0], function* ({
  groupId,
  consumerConfig,
  editGroupDto
}) {
  try {
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${consumerConfig.token}`);
    const endpoint = `${consumerConfig.api_url}api/auth/management/groups/${groupId}/`;
    const requestOptions = {
      method: "PATCH",
      headers,
      body: JSON.stringify(editGroupDto)
    };
    const response = yield fetch(endpoint, requestOptions);
    const result = yield response.json();
    if (response.ok) {
      const id = result.id;
      return id;
    }
    if ("username" in result && result.username) {
      throw new Error("user_exists_in_other_shipper");
    }
    if ("phone" in result && result.phone) {
      throw new Error("phone_invalid");
    }
    throw new Error("unexpected_error");
  } catch (e) {
    if (e instanceof Error) {
      throw new Error(e.message);
    }
    throw new Error("unexpected_error");
  }
});

// src/modules/user-management/pages/edit-group/edit-group-page-hook.ts
var EditGroupPageHook = ({
  mutate,
  consumerConfig,
  groupId,
  groupFormPageTranslations
}) => {
  const submitForm = (_0) => __async(void 0, [_0], function* ({ formState }) {
    let permissions2 = formState.fields.permissions.value.split(",");
    if (permissions2[0] === "") {
      permissions2 = [];
    }
    let workingAreas2 = formState.fields.workingAreas.value.split(",");
    if (workingAreas2[0] === "") {
      workingAreas2 = [];
    }
    try {
      const editGroupDto = {
        name: formState.fields.name.value,
        permissions: permissions2,
        working_areas: workingAreas2
      };
      yield editGroupApi({
        consumerConfig,
        editGroupDto,
        groupId
      });
      void mutate();
      toast6.success(groupFormPageTranslations.on_success_message);
    } catch (e) {
      toast6.error(groupFormPageTranslations.on_error_message);
      if (e instanceof Error) {
        throw new Error(e.message);
      } else {
        throw new Error("Unexpected error");
      }
    }
  });
  const {
    options: { permissions, workingAreas },
    error: optionsError,
    isLoading: optionsLoading
  } = useFormOptionsHook({
    consumerConfig
  });
  return {
    error: optionsError,
    isLoading: optionsLoading,
    submitForm,
    permissions,
    workingAreas
  };
};

// src/modules/user-management/pages/edit-group/get-group-api.ts
var getGroupApi = (_0) => __async(void 0, [_0], function* ({
  groupId,
  consumerConfig
}) {
  try {
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${consumerConfig.token}`);
    const endpoint = `${consumerConfig.api_url}api/auth/management/groups/${groupId}/`;
    const requestOptions = {
      method: "GET",
      headers
    };
    const response = yield fetch(endpoint, requestOptions);
    if (!response.ok) {
      throw new Error("Failed to fetch group");
    }
    const groupDto = yield fetchJson(response);
    return groupDto;
  } catch (e) {
    if (e instanceof Error) {
      throw new Error(e.message);
    } else {
      throw new Error("Unexpected error");
    }
  }
});

// src/modules/user-management/pages/edit-group/edit-group-page.tsx
var getGroupApiFetcher = (groupId, consumerConfig) => {
  return getGroupApi({ groupId, consumerConfig });
};
var mapGroupDtoToInitialValues = (groupDto) => {
  if (!groupDto)
    return {};
  return {
    name: groupDto.name,
    permissions: groupDto.permissions.join(","),
    workingAreas: groupDto.working_areas.join(",")
  };
};
function EditGroupPage({
  consumerConfig,
  groupFormPageTranslations,
  groupFormTranslations,
  onGoToGroups,
  groupId
}) {
  const fetcher = () => __async(this, null, function* () {
    return getGroupApiFetcher(groupId, consumerConfig);
  });
  const {
    data,
    error: dataError,
    isLoading: dataLoading,
    mutate
  } = useSWR8(groupId, fetcher, {
    errorRetryCount: 0,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  });
  const initialValues = useMemo9(() => {
    return mapGroupDtoToInitialValues(data);
  }, [data]);
  const {
    submitForm,
    permissions,
    workingAreas,
    isLoading: optionsLoading,
    error: optionsError
  } = EditGroupPageHook({
    mutate,
    consumerConfig,
    groupId,
    groupFormPageTranslations
  });
  const error = dataError || optionsError;
  const isLoading = dataLoading || optionsLoading;
  return /* @__PURE__ */ React16.createElement(PageLayout8, null, /* @__PURE__ */ React16.createElement(ToolbarComponent8, null, /* @__PURE__ */ React16.createElement(ToolbarContentComponent6, null, /* @__PURE__ */ React16.createElement("div", null, /* @__PURE__ */ React16.createElement(ToolbarButtonComponent8, null, groupFormPageTranslations.title)), /* @__PURE__ */ React16.createElement("div", null, /* @__PURE__ */ React16.createElement(
    ToolbarButtonComponent8,
    {
      onClick: () => {
        onGoToGroups();
      }
    },
    /* @__PURE__ */ React16.createElement(CloseIcon6, null)
  )))), /* @__PURE__ */ React16.createElement(PageContent8, { withBackground: true }, (() => {
    if (error) {
      return /* @__PURE__ */ React16.createElement(BlockContainer10, null, /* @__PURE__ */ React16.createElement(Block10, null, /* @__PURE__ */ React16.createElement(ErrorMessage8, null, "There was an error loading the group")));
    }
    if (isLoading) {
      return /* @__PURE__ */ React16.createElement(GroupFormSkeletonComponent, null);
    }
    return /* @__PURE__ */ React16.createElement(
      GroupForm,
      {
        config: consumerConfig,
        groupFormPageTranslations,
        groupFormTranslations,
        initialValues,
        permissions,
        submitForm,
        workingAreas
      }
    );
  })()), /* @__PURE__ */ React16.createElement(Toaster6, { richColors: true }));
}

// src/modules/user-management/pages/users/users-page.tsx
import {
  PageLayout as PageLayout9,
  PageContent as PageContent9,
  ToolbarComponent as ToolbarComponent9,
  ToolbarButtonComponent as ToolbarButtonComponent9,
  FlexComponent as FlexComponent5,
  Input as Input5,
  TableComponent as TableComponent4,
  TableCellComponent as TableCellComponent5,
  TextComponent as TextComponent5
} from "@ontruck/fe-ui";
import { CirclePlusIcon as CirclePlusIcon3 } from "@ontruck/fe-icons";
import React17, { useCallback as useCallback10, useMemo as useMemo10 } from "react";
import styled7 from "styled-components";
import { toast as toast7, Toaster as Toaster7 } from "sonner";

// src/modules/user-management/pages/users/filters-hook.ts
import { useState as useState5 } from "react";
var DEFAULT_PAGINATION_SIZE_FILTER_OPTION2 = 50;
var getFiltersOptions2 = () => {
  return {
    paginationSizes: [50, 100, 200, 500]
  };
};
var getDefaultSelectedFilters2 = () => {
  return {
    search: "",
    paginationSize: DEFAULT_PAGINATION_SIZE_FILTER_OPTION2,
    page: 1
  };
};
var getInitialSelectedFilters2 = () => {
  const initialSelectedFilters = getDefaultSelectedFilters2();
  return initialSelectedFilters;
};
var useFiltersHook2 = () => {
  const filtersOptions = getFiltersOptions2();
  const initialSelectedFilters = getInitialSelectedFilters2();
  const [selectedFilters, setSelectedFilters] = useState5(initialSelectedFilters);
  const setPage = (page) => {
    setSelectedFilters(__spreadProps(__spreadValues({}, selectedFilters), {
      page
    }));
  };
  const setPaginationSize = (paginationSize) => {
    setSelectedFilters(__spreadProps(__spreadValues({}, selectedFilters), {
      paginationSize,
      page: 1
    }));
  };
  const setSearch = (search) => {
    setSelectedFilters(__spreadProps(__spreadValues({}, selectedFilters), {
      search,
      page: 1
    }));
  };
  return {
    filtersOptions,
    selectedFilters,
    setPage,
    setPaginationSize,
    setSearch
  };
};

// src/modules/user-management/pages/users/get-users-filtered-hook.ts
import useSWR9 from "swr";

// src/modules/user-management/pages/users/get-query-params-from-selected-filters.ts
var getPageSizeQuery2 = (selectedFilters) => {
  return `page_size=${selectedFilters.paginationSize}`;
};
var getPageQuery2 = (selectedFilters) => {
  return `page=${selectedFilters.page}`;
};
var getSearchQuery2 = (selectedFilters) => {
  const searchValue = selectedFilters.search;
  if (searchValue.trim() === "") {
    return null;
  }
  return `search=${searchValue}`;
};
var getQueryParamsFromSelectedFilters2 = (selectedFilters) => {
  const pageSizeQuery = getPageSizeQuery2(selectedFilters);
  let query = `?${pageSizeQuery}`;
  const searchQuery = getSearchQuery2(selectedFilters);
  const pageQuery = getPageQuery2(selectedFilters);
  const queries = [searchQuery, pageQuery];
  queries.forEach((currentQuery) => {
    if (currentQuery) {
      const paramSeparator = "&";
      query = `${query}${paramSeparator}${currentQuery}`;
    }
  });
  return query;
};

// src/modules/user-management/pages/users/get-users-api.ts
var getUsersApi = (_0) => __async(void 0, [_0], function* ({
  selectedFilters,
  config
}) {
  const query = getQueryParamsFromSelectedFilters2(selectedFilters);
  const endpoint = `${config.api_url}api/auth/management/users/${query}`;
  const response = yield fetch(endpoint, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${config.token}`
    }
  });
  const data = yield fetchJson(response);
  return data;
});

// src/modules/user-management/pages/users/get-users-api-fetcher.ts
var getUsersApiFetcher = (cargoItemsKey, config) => {
  const selectedFilters = JSON.parse(cargoItemsKey);
  return getUsersApi({ selectedFilters, config });
};

// src/modules/user-management/pages/users/get-users-mapped-service.ts
function getUsersMapedService(usersDto) {
  if (!usersDto) {
    return;
  }
  const usersMapped = usersDto.results.map((userDto) => {
    try {
      const user = {
        id: userDto.id,
        firstName: userDto.first_name,
        lastName: userDto.last_name,
        email: userDto.email,
        alertSubscriptions: userDto.alert_subscriptions,
        isActive: userDto.is_active
      };
      return user;
    } catch (e) {
      console.error("Error mapping user with id ", userDto.id);
      console.error(e);
      throw e;
    }
  });
  const count = usersDto.count;
  return {
    users: usersMapped,
    count
  };
}

// src/modules/user-management/pages/users/settings.ts
var RELOAD_USERS_LIST_INTERVAL_IN_SECONDS = 30;

// src/modules/user-management/pages/users/get-users-filtered-hook.ts
var useGetUsersFilteredHook = ({
  selectedFilters,
  config
}) => {
  const cargoItemsKey = JSON.stringify(selectedFilters);
  const fetcher = () => __async(void 0, null, function* () {
    return getUsersApiFetcher(cargoItemsKey, config);
  });
  const { data, error, isLoading, mutate } = useSWR9(cargoItemsKey, fetcher, {
    refreshInterval: RELOAD_USERS_LIST_INTERVAL_IN_SECONDS * 1e3,
    revalidateIfStale: true
  });
  const usersMapped = getUsersMapedService(data);
  return {
    users: (usersMapped == null ? void 0 : usersMapped.users) || [],
    count: (usersMapped == null ? void 0 : usersMapped.count) || 0,
    isLoading,
    error,
    mutate
  };
};

// src/modules/user-management/pages/users/users-page.tsx
var UsersPageLayoutStyled = styled7(PageLayout9)`
  background-color: var(--otk-theme-color-white);
`;
var UsersEndToolbarComponent = styled7(FlexComponent5)`
  margin-left: auto;
  align-items: center;
  gap: 16px;
`;
var UsersToolbarButtonsComponent = styled7(FlexComponent5)`
  border-left: 1px solid var(--accent-color-gray);
  align-items: center;
  background-color: var(--otk-theme-color-white);
  flex-grow: 1;
  gap: 8px;
`;
var UserRowStyled = styled7(FlexComponent5)`
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;
var StyledCheckboxWrapper = styled7.div`
  margin-left: auto;
  margin-right: auto;
  input {
    outline: none;
    border: none;
    border-image: none;
    appearance: none;
    background: var(--grey100);
    border: 1px solid var(--grey500);
  }
  input:checked {
    background-color: var(--accent-color-blue);
    border: 1px solid var(--accent-color-blue);
  }
  input:checked::after {
    border: 0;
  }
`;
var TABLE_COLUMNS3 = {
  name: {
    width: "288px"
  },
  email: {
    width: "320px"
  },
  isActive: {
    width: "100px"
  }
};
function UsersPage({
  consumerConfig,
  usersPageTranslations,
  onGoToNewUser,
  onGoToUserDetail
}) {
  const filters = useFiltersHook2();
  const data = useGetUsersFilteredHook({
    selectedFilters: filters.selectedFilters,
    config: consumerConfig
  });
  const handleChangePageSize = (pageSize) => {
    filters.setPaginationSize(pageSize);
  };
  const handleGoToPreviousPage = () => {
    if (filters.selectedFilters.page > 1) {
      filters.setPage(filters.selectedFilters.page - 1);
    }
  };
  const handleGoToPage = (pageIndex) => {
    filters.setPage(pageIndex);
  };
  const handleGoToNextPage = () => {
    if (filters.selectedFilters.page < data.count) {
      filters.setPage(filters.selectedFilters.page + 1);
    }
  };
  const handleIsActiveChange = useCallback10(
    (userId, isActive) => __async(this, null, function* () {
      try {
        const headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Authorization", `Bearer ${consumerConfig.token} `);
        const endpoint = `${consumerConfig.api_url}api/auth/management/users/${userId}/`;
        const requestOptions = {
          method: "PATCH",
          headers,
          body: JSON.stringify({
            is_active: isActive
          })
        };
        const response = yield fetch(endpoint, requestOptions);
        if (response.ok) {
          if (isActive) {
            toast7.success(usersPageTranslations.user_activated_ok);
          } else {
            toast7.success(usersPageTranslations.user_deactivated_ok);
          }
          yield data.mutate();
          return;
        }
        throw new Error("unexpected_error");
      } catch (e) {
        if (isActive) {
          toast7.error(usersPageTranslations.user_activated_error);
        } else {
          toast7.error(usersPageTranslations.user_deactivated_error);
        }
        if (e instanceof Error) {
          throw new Error(e.message);
        }
        throw new Error("unexpected_error");
      }
    }),
    [consumerConfig.api_url, consumerConfig.token, data, usersPageTranslations]
  );
  const columns = useMemo10(() => {
    const baseColumns = {
      name: {
        id: "0",
        width: TABLE_COLUMNS3.name.width,
        label: usersPageTranslations.columns.name
      },
      email: {
        id: "1",
        width: TABLE_COLUMNS3.email.width,
        label: usersPageTranslations.columns.email
      },
      isActive: {
        id: "2",
        width: TABLE_COLUMNS3.isActive.width,
        label: usersPageTranslations.columns.isActive
      }
    };
    return baseColumns;
  }, [usersPageTranslations]);
  const getUsersRowsComponents = useCallback10(
    (users) => {
      return users.map((userItem) => {
        return /* @__PURE__ */ React17.createElement(
          UserRowStyled,
          {
            alignItems: "center",
            borderTop: "1px solid var(--grey-200, #E2E8EE)",
            key: userItem.id,
            onClick: () => {
              onGoToUserDetail(userItem.id);
            }
          },
          /* @__PURE__ */ React17.createElement(
            TableCellComponent5,
            {
              borderLeft: "1px solid var(--grey-200, #E2E8EE)",
              width: TABLE_COLUMNS3.name.width
            },
            /* @__PURE__ */ React17.createElement(TextComponent5, null, userItem.firstName, " ", userItem.lastName)
          ),
          /* @__PURE__ */ React17.createElement(
            TableCellComponent5,
            {
              borderLeft: "1px solid var(--grey-200, #E2E8EE)",
              width: TABLE_COLUMNS3.email.width
            },
            /* @__PURE__ */ React17.createElement(TextComponent5, null, userItem.email)
          ),
          /* @__PURE__ */ React17.createElement(
            TableCellComponent5,
            {
              onClick: (e) => {
                e.stopPropagation();
                void handleIsActiveChange(userItem.id, !userItem.isActive);
              },
              width: TABLE_COLUMNS3.isActive.width
            },
            /* @__PURE__ */ React17.createElement(StyledCheckboxWrapper, null, /* @__PURE__ */ React17.createElement(
              Input5,
              {
                label: "",
                name: `user-activated-${userItem.id}`,
                type: "checkbox",
                value: userItem.isActive.toString()
              }
            ))
          )
        );
      });
    },
    [onGoToUserDetail, handleIsActiveChange]
  );
  const rowComponents = useMemo10(
    () => getUsersRowsComponents(data.users),
    [data.users, getUsersRowsComponents]
  );
  return /* @__PURE__ */ React17.createElement(UsersPageLayoutStyled, null, /* @__PURE__ */ React17.createElement(ToolbarComponent9, null, /* @__PURE__ */ React17.createElement("div", null, /* @__PURE__ */ React17.createElement(ToolbarButtonComponent9, null, usersPageTranslations.title)), /* @__PURE__ */ React17.createElement(UsersEndToolbarComponent, null, /* @__PURE__ */ React17.createElement(
    Input5,
    {
      handleChangeEvent: (e) => {
        const event = e;
        const newValue = event.target.value;
        filters.setSearch(newValue);
      },
      label: usersPageTranslations.filters.search,
      name: "search",
      type: "search",
      value: filters.selectedFilters.search,
      width: "280px"
    }
  ), /* @__PURE__ */ React17.createElement(UsersToolbarButtonsComponent, null, /* @__PURE__ */ React17.createElement(ToolbarButtonComponent9, { onClick: onGoToNewUser }, /* @__PURE__ */ React17.createElement(CirclePlusIcon3, { color: "var(--accent-color-blue)", sizeInPixels: 20 }), usersPageTranslations.new)))), /* @__PURE__ */ React17.createElement(PageContent9, null, /* @__PURE__ */ React17.createElement(
    TableComponent4,
    {
      columns,
      emptyStateMessage: usersPageTranslations.not_found,
      isError: data.error !== void 0,
      isLoading: data.isLoading,
      numberOfItems: data.count,
      onChangePageSize: handleChangePageSize,
      onGoToNextPage: handleGoToNextPage,
      onGoToPage: handleGoToPage,
      onGoToPreviousPage: handleGoToPreviousPage,
      pageIndex: filters.selectedFilters.page,
      pageSize: filters.selectedFilters.paginationSize,
      pageSizes: filters.filtersOptions.paginationSizes,
      resultsPerPageLabel: usersPageTranslations.filters.resultsPerPage,
      rowsComponents: rowComponents
    }
  ), /* @__PURE__ */ React17.createElement(Toaster7, { richColors: true })));
}

// src/modules/user-management/pages/new-user/new-user-page.tsx
import {
  PageLayout as PageLayout10,
  PageContent as PageContent10,
  ToolbarComponent as ToolbarComponent10,
  ToolbarContentComponent as ToolbarContentComponent7,
  ToolbarButtonComponent as ToolbarButtonComponent10,
  BlockContainer as BlockContainer13,
  Block as Block13,
  ErrorMessage as ErrorMessage10
} from "@ontruck/fe-ui";
import { CloseIcon as CloseIcon7 } from "@ontruck/fe-icons";
import React20 from "react";
import { Toaster as Toaster8 } from "sonner";

// src/modules/user-management/components/user-form/user-form.tsx
import React18, { useCallback as useCallback12 } from "react";
import {
  FormContainer as FormContainer6,
  Block as Block11,
  BlockContainer as BlockContainer11,
  SectionContainer as SectionContainer4,
  SectionTitle as SectionTitle5,
  SectionBody as SectionBody5,
  SectionLine as SectionLine5,
  Sticky as Sticky4,
  ButtonContainer as ButtonContainer4,
  Half as Half4,
  ButtonComponent as ButtonComponent4,
  Input as Input6,
  ErrorMessage as ErrorMessage9
} from "@ontruck/fe-ui";
import { CogIcon as CogIcon2, OfferAlertsIcon, QuoteAlertsIcon, TicketAlertsIcon } from "@ontruck/fe-icons";

// src/modules/user-management/components/user-form/user-form-hook.ts
import { useCallback as useCallback11, useMemo as useMemo11, useState as useState6 } from "react";

// src/modules/user-management/components/user-form/user-form-translations.ts
var BACKEND_ERROR_MAPPING4 = {
  user_exists_in_other_shipper: "user_exists_in_other_shipper" /* UserExistsInOtherShipper */,
  phone_invalid: "phone_invalid" /* PhoneInvalid */
};
var getErrorTranslation4 = (errorMessage, translations2) => {
  const errorKey = BACKEND_ERROR_MAPPING4[errorMessage];
  switch (errorKey) {
    case "user_exists_in_other_shipper" /* UserExistsInOtherShipper */:
      return translations2.errors.user_exists_in_other_shipper;
    case "phone_invalid" /* PhoneInvalid */:
      return translations2.errors.phone_invalid;
    default:
      return translations2.errors.unexpected_error;
  }
};

// src/modules/user-management/components/user-form/user-form-hook.ts
var defaultFieldDefinitions4 = {
  email: {
    type: "text",
    is_required: true,
    validation_pattern: emailRegex,
    label: "Email",
    name: "email"
  },
  first_name: {
    type: "text",
    is_required: true,
    validation_pattern: notEmptyStringRegex,
    label: "First name",
    name: "first_name"
  },
  last_name: {
    type: "text",
    is_required: true,
    validation_pattern: notEmptyStringRegex,
    label: "Last name",
    name: "last_name"
  },
  alert_subscriptions: {
    type: "text",
    is_required: false,
    label: "Alert subscriptions",
    name: "alert_subscriptions"
  },
  groups: {
    type: "text",
    is_required: false,
    label: "Groups",
    name: "groups"
  }
};
var getTranslatedFieldDefinitions4 = ({
  fieldDefinitions,
  translations: translations2
}) => {
  const definitions = {};
  Object.entries(fieldDefinitions).forEach(([key, definition]) => {
    const fieldKey = key;
    definitions[key] = __spreadProps(__spreadValues({}, definition), {
      label: translations2.fields[fieldKey] || fieldKey
    });
  });
  return definitions;
};
function useUserFormHook({
  userFormTranslations,
  submitForm,
  initialValues = {}
}) {
  const fieldDefinitions = useMemo11(() => {
    const translatedFieldDefintions = getTranslatedFieldDefinitions4({
      fieldDefinitions: defaultFieldDefinitions4,
      translations: userFormTranslations
    });
    return translatedFieldDefintions;
  }, [userFormTranslations]);
  const initialState = getInitialState({
    fieldDefinitions,
    initialValues
  });
  const [formState, setFormState] = useState6(initialState);
  const isValid = useMemo11(() => {
    for (const field of Object.values(formState.fields)) {
      if (!field.isValid) {
        return false;
      }
    }
    return true;
  }, [formState.fields]);
  const handleSubmit = useCallback11(
    (e) => __async(this, null, function* () {
      e.preventDefault();
      setFormState((prev) => __spreadProps(__spreadValues({}, prev), {
        show_errors: true,
        submit_errors: {}
      }));
      if (!isValid)
        return;
      try {
        setFormState((prev) => __spreadProps(__spreadValues({}, prev), { is_submiting: true }));
        yield submitForm({ formState });
        setFormState((prev) => __spreadProps(__spreadValues({}, prev), { is_submiting: false }));
      } catch (error) {
        setFormState((prev) => __spreadProps(__spreadValues({}, prev), {
          is_submiting: false,
          submit_errors: {
            uncontrolled: error instanceof Error ? error.message : userFormTranslations.errors.unexpected_error
          }
        }));
      }
    }),
    [formState, isValid, userFormTranslations, submitForm]
  );
  const handleChangeValue = useCallback11((fieldName, value) => {
    try {
      if (value === void 0)
        return;
      setFormState((previousState) => {
        const newState = __spreadProps(__spreadValues({}, previousState), {
          fields: __spreadProps(__spreadValues({}, previousState.fields), {
            [fieldName]: __spreadProps(__spreadValues({}, previousState.fields[fieldName]), {
              value
            })
          })
        });
        return getValidatedFormState(newState);
      });
    } catch (error) {
      console.error("\u{1F525} ~ handleChangeValue error:", error);
    }
  }, []);
  const handleChangeEvent = useCallback11(
    (e, fieldName) => {
      const value = e.currentTarget.value;
      handleChangeValue(fieldName, value);
    },
    [handleChangeValue]
  );
  const backendErrors = useMemo11(() => {
    const errors = [];
    Object.values(formState.submit_errors).forEach((errorMessage) => {
      const translatedMessage = getErrorTranslation4(errorMessage, userFormTranslations);
      errors.push(translatedMessage);
    });
    return errors;
  }, [formState.submit_errors, userFormTranslations]);
  const isSubmitting = formState.is_submiting;
  const fields = formState.fields;
  const showErrors = formState.show_errors;
  return {
    handleSubmit,
    handleChangeValue,
    handleChangeEvent,
    backendErrors,
    isSubmitting,
    fields,
    showErrors,
    formState
  };
}

// src/modules/user-management/components/user-form/alert-groups.ts
var ALERT_GROUPS = {
  tickets: {
    name: "Ticket Alerts",
    alerts: [
      "ticket-created",
      "ticket-assigned",
      "ticket-cancelled",
      "ticket-completed",
      "ticket-commented",
      "ticket-notification-send-failed"
    ]
  },
  quotes: {
    name: "Quote Alerts",
    alerts: [
      "quote-created",
      "quote-requested",
      "quote-accepted",
      "quote-rejected",
      "quote-expired",
      "user-interested",
      "quote-notification-send-failed"
    ]
  },
  offers: {
    name: "Offers Alerts",
    alerts: ["ticket-auction-started", "ticket-auction-closed"]
  }
};
var getAlertGroupTranslation = (groupKey, translations2) => {
  return translations2.alert_groups[groupKey] || groupKey;
};
var getAlertTranslation = (alertId, translations2) => {
  return translations2.alerts[alertId] || alertId;
};
var groupAlerts = (alerts) => {
  const groupedAlerts = {
    others: []
  };
  Object.keys(ALERT_GROUPS).forEach((groupKey) => {
    groupedAlerts[groupKey] = [];
  });
  alerts.forEach((alert) => {
    let foundGroup = false;
    for (const [groupKey, group] of Object.entries(ALERT_GROUPS)) {
      if (group.alerts.includes(alert.id)) {
        groupedAlerts[groupKey].push(alert);
        foundGroup = true;
        break;
      }
    }
    if (!foundGroup) {
      groupedAlerts.others.push(alert);
    }
  });
  return groupedAlerts;
};

// src/modules/user-management/components/user-form/user-form.tsx
function FormInput4({
  field,
  handleChangeEvent,
  handleChangeValue,
  showErrors
}) {
  return /* @__PURE__ */ React18.createElement(
    Input6,
    {
      handleChangeEvent: (e) => {
        handleChangeEvent(e, field.definition.name);
      },
      handleChangeValue,
      hasError: showErrors ? !field.isValid : false,
      isRequired: field.definition.is_required,
      label: field.definition.label,
      name: field.definition.name,
      type: field.definition.type,
      value: field.value
    }
  );
}
var getAlertGroupIcon = (groupKey) => {
  switch (groupKey) {
    case "tickets":
      return /* @__PURE__ */ React18.createElement(TicketAlertsIcon, { color: "var(--grey500)", sizeInPixels: 16 });
    case "quotes":
      return /* @__PURE__ */ React18.createElement(QuoteAlertsIcon, { color: "var(--grey500)", sizeInPixels: 16 });
    case "offers":
      return /* @__PURE__ */ React18.createElement(OfferAlertsIcon, { color: "var(--grey500)", sizeInPixels: 16 });
    case "others":
      return /* @__PURE__ */ React18.createElement(CogIcon2, { color: "var(--grey500)", sizeInPixels: 16 });
    default:
      return /* @__PURE__ */ React18.createElement(CogIcon2, { color: "var(--grey500)", sizeInPixels: 16 });
  }
};
function UserForm({
  userFormTranslations,
  userFormPageTranslations,
  submitForm,
  initialValues = {},
  alertSubscriptions,
  groups
}) {
  const defaultInitialAlertSubscriptions = alertSubscriptions.map((alert) => alert.id).join(",");
  const initialAlertSubscriptions = initialValues.alert_subscriptions || defaultInitialAlertSubscriptions;
  const initialValuesWithDefaultAlertSubscriptions = __spreadProps(__spreadValues({}, initialValues), {
    alert_subscriptions: initialAlertSubscriptions
  });
  const {
    handleSubmit,
    handleChangeValue,
    handleChangeEvent,
    backendErrors,
    isSubmitting,
    fields,
    showErrors,
    formState
  } = useUserFormHook({
    userFormTranslations,
    submitForm,
    initialValues: initialValuesWithDefaultAlertSubscriptions
  });
  const renderFormInput = useCallback12(
    (field) => {
      return /* @__PURE__ */ React18.createElement(
        FormInput4,
        {
          field,
          handleChangeEvent,
          handleChangeValue,
          showErrors
        }
      );
    },
    [handleChangeEvent, handleChangeValue, showErrors]
  );
  const alertsChecked = formState.fields.alert_subscriptions.value.trim().split(",").map((alert) => alert.trim()).filter((alert) => alert !== "");
  const onAlertClick = (alert) => {
    const isSubscribed = alertsChecked.includes(alert);
    if (isSubscribed) {
      const newAlertsChecked = alertsChecked.filter((a) => a !== alert);
      handleChangeValue("alert_subscriptions", newAlertsChecked.join(","));
    } else {
      const newAlertsChecked = [...alertsChecked, alert];
      handleChangeValue("alert_subscriptions", newAlertsChecked.join(","));
    }
  };
  const groupsChecked = formState.fields.groups.value.trim().split(",").map((group) => group.trim()).filter((group) => group !== "");
  const onGroupClick = (group) => {
    const isMember = groupsChecked.includes(group);
    if (isMember) {
      const newGroupsChecked = groupsChecked.filter((a) => a !== group);
      handleChangeValue("groups", newGroupsChecked.join(","));
    } else {
      const newGroupsChecked = [...groupsChecked, group];
      handleChangeValue("groups", newGroupsChecked.join(","));
    }
  };
  return /* @__PURE__ */ React18.createElement(FormContainer6, null, /* @__PURE__ */ React18.createElement("form", { autoComplete: "off", onSubmit: (event) => void handleSubmit(event) }, /* @__PURE__ */ React18.createElement(BlockContainer11, null, /* @__PURE__ */ React18.createElement(Block11, null, /* @__PURE__ */ React18.createElement(SectionContainer4, null, /* @__PURE__ */ React18.createElement(SectionTitle5, null, userFormTranslations.sections.main_section), /* @__PURE__ */ React18.createElement(SectionBody5, null, /* @__PURE__ */ React18.createElement(SectionLine5, null, renderFormInput(fields.email)), /* @__PURE__ */ React18.createElement(SectionLine5, null, renderFormInput(fields.first_name), renderFormInput(fields.last_name)))), /* @__PURE__ */ React18.createElement(SectionContainer4, null, /* @__PURE__ */ React18.createElement(SectionTitle5, null, userFormTranslations.sections.roles_section), /* @__PURE__ */ React18.createElement(MulticheckboxBodyComponent, null, groups.map((group) => /* @__PURE__ */ React18.createElement(MulticheckboxItemComponent, { key: group.id }, /* @__PURE__ */ React18.createElement(
    Input6,
    {
      handleChangeValue: (_name, _value) => {
        onGroupClick(group.name);
      },
      label: group.name,
      name: `group-${group.id}`,
      type: "checkbox",
      value: groupsChecked.includes(group.name).toString()
    }
  ))))), /* @__PURE__ */ React18.createElement(SectionContainer4, null, /* @__PURE__ */ React18.createElement(SectionTitle5, null, userFormTranslations.sections.alert_section), /* @__PURE__ */ React18.createElement(CheckboxListBodyComponent, null, Object.entries(groupAlerts(alertSubscriptions)).map(([groupKey, alerts]) => {
    if (alerts.length === 0)
      return null;
    return /* @__PURE__ */ React18.createElement(React18.Fragment, { key: groupKey }, /* @__PURE__ */ React18.createElement(CheckboxListGroupTitleComponent, { style: { paddingLeft: "0" } }, getAlertGroupIcon(groupKey), groupKey === "others" ? userFormTranslations.alerts.other_alerts : getAlertGroupTranslation(
      groupKey,
      userFormTranslations
    )), alerts.map((alertSubscription) => /* @__PURE__ */ React18.createElement(CheckboxListItemComponent, { key: alertSubscription.id }, /* @__PURE__ */ React18.createElement(
      Input6,
      {
        handleChangeValue: (_name, _value) => {
          onAlertClick(alertSubscription.id);
        },
        label: getAlertTranslation(alertSubscription.id, userFormTranslations),
        name: `alert-${alertSubscription.id}`,
        type: "checkbox",
        value: alertsChecked.includes(alertSubscription.id).toString()
      }
    ))));
  }))), backendErrors.length > 0 && /* @__PURE__ */ React18.createElement(SectionContainer4, null, /* @__PURE__ */ React18.createElement(SectionBody5, null, /* @__PURE__ */ React18.createElement(ErrorMessage9, null, backendErrors.map((errorMessage) => {
    return /* @__PURE__ */ React18.createElement("div", { key: errorMessage }, errorMessage);
  })))))), /* @__PURE__ */ React18.createElement(Sticky4, null, /* @__PURE__ */ React18.createElement(ButtonContainer4, null, /* @__PURE__ */ React18.createElement(Half4, null, /* @__PURE__ */ React18.createElement(
    ButtonComponent4,
    {
      color: "primary",
      disabled: isSubmitting,
      fullWidth: true,
      size: "s",
      type: "submit"
    },
    isSubmitting ? userFormPageTranslations.form_button_loading_text : userFormPageTranslations.form_button_text
  ))))));
}

// src/modules/user-management/components/user-form/user-form-skeleton-component.tsx
import { Block as Block12, BlockContainer as BlockContainer12, FormContainer as FormContainer7 } from "@ontruck/fe-ui";
import React19 from "react";
import ContentLoader3 from "react-content-loader";
function UserFormSkeletonComponent() {
  return /* @__PURE__ */ React19.createElement(FormContainer7, null, /* @__PURE__ */ React19.createElement(BlockContainer12, null, /* @__PURE__ */ React19.createElement(Block12, null, /* @__PURE__ */ React19.createElement(ContentLoader3, { height: 300, viewBox: "0 0 600 300", width: 600 }, /* @__PURE__ */ React19.createElement("rect", { height: "30", rx: "3", ry: "3", width: "100", x: "0", y: "0" }), /* @__PURE__ */ React19.createElement("rect", { height: "30", rx: "3", ry: "3", width: "600", x: "20", y: "60" }), /* @__PURE__ */ React19.createElement("rect", { height: "30", rx: "3", ry: "3", width: "600", x: "20", y: "110" }), /* @__PURE__ */ React19.createElement("rect", { height: "30", rx: "3", ry: "3", width: "600", x: "20", y: "160" }), /* @__PURE__ */ React19.createElement("rect", { height: "30", rx: "3", ry: "3", width: "600", x: "20", y: "210" })), /* @__PURE__ */ React19.createElement(ContentLoader3, { height: 300, viewBox: "0 0 600 300", width: 600 }, /* @__PURE__ */ React19.createElement("rect", { height: "30", rx: "3", ry: "3", width: "100", x: "0", y: "0" }), /* @__PURE__ */ React19.createElement("rect", { height: "30", rx: "3", ry: "3", width: "600", x: "20", y: "60" }), /* @__PURE__ */ React19.createElement("rect", { height: "30", rx: "3", ry: "3", width: "600", x: "20", y: "110" }), /* @__PURE__ */ React19.createElement("rect", { height: "30", rx: "3", ry: "3", width: "600", x: "20", y: "160" }), /* @__PURE__ */ React19.createElement("rect", { height: "30", rx: "3", ry: "3", width: "600", x: "20", y: "210" })))));
}

// src/modules/user-management/pages/new-user/new-user-page-hook.ts
import { toast as toast8 } from "sonner";

// src/modules/user-management/pages/new-user/create-user-api.ts
var createUserApi = (_0) => __async(void 0, [_0], function* ({
  createUserDto,
  consumerConfig
}) {
  try {
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${consumerConfig.token}`);
    const body = JSON.stringify(createUserDto);
    const endpoint = `${consumerConfig.api_url}api/auth/management/users/`;
    const requestOptions = {
      method: "POST",
      headers,
      body
    };
    const response = yield fetch(endpoint, requestOptions);
    const result = yield response.json();
    if (response.ok) {
      const userId = result.id;
      return userId;
    }
    if ("username" in result && result.username) {
      throw new Error("user_exists_in_other_shipper");
    }
    throw new Error("unexpected_error");
  } catch (e) {
    if (e instanceof Error) {
      throw new Error(e.message);
    } else {
      throw new Error("Unexpected error");
    }
  }
});

// src/modules/user-management/pages/new-user/new-user-page-hook.ts
var useNewUserPageHook = ({
  consumerConfig,
  onGoToUsers,
  userFormPageTranslations
}) => {
  const submitForm = (_0) => __async(void 0, [_0], function* ({ formState }) {
    try {
      const alertSubscriptionsDto = formState.fields.alert_subscriptions.value.split(",").map((alert) => alert.trim()).filter((alert) => alert !== "");
      const groupsDto = formState.fields.groups.value.split(",").map((group) => group.trim()).filter((group) => group !== "");
      const createUserDto = {
        first_name: formState.fields.first_name.value,
        last_name: formState.fields.last_name.value,
        email: formState.fields.email.value,
        username: formState.fields.email.value,
        alert_subscriptions: alertSubscriptionsDto,
        groups: groupsDto
      };
      yield createUserApi({
        createUserDto,
        consumerConfig
      });
      toast8.success(userFormPageTranslations.on_success_message);
      onGoToUsers();
    } catch (e) {
      toast8.error(userFormPageTranslations.on_error_message);
      if (e instanceof Error) {
        throw new Error(e.message);
      } else {
        throw new Error("Unexpected error");
      }
    }
  });
  const {
    options: { groups, permissions, alertSubscriptions },
    error,
    isLoading
  } = useFormOptionsHook({
    consumerConfig
  });
  return {
    submitForm,
    groups,
    permissions,
    alertSubscriptions,
    error,
    isLoading
  };
};

// src/modules/user-management/pages/new-user/new-user-page.tsx
function NewUserPage({
  consumerConfig,
  userFormPageTranslations,
  userFormTranslations,
  onGoToUsers
}) {
  const { alertSubscriptions, groups, isLoading, error, submitForm } = useNewUserPageHook({
    consumerConfig,
    onGoToUsers,
    userFormPageTranslations
  });
  return /* @__PURE__ */ React20.createElement(PageLayout10, null, /* @__PURE__ */ React20.createElement(ToolbarComponent10, null, /* @__PURE__ */ React20.createElement(ToolbarContentComponent7, null, /* @__PURE__ */ React20.createElement("div", null, /* @__PURE__ */ React20.createElement(ToolbarButtonComponent10, null, userFormPageTranslations.title)), /* @__PURE__ */ React20.createElement("div", null, /* @__PURE__ */ React20.createElement(
    ToolbarButtonComponent10,
    {
      onClick: () => {
        onGoToUsers();
      }
    },
    /* @__PURE__ */ React20.createElement(CloseIcon7, null)
  )))), /* @__PURE__ */ React20.createElement(PageContent10, { withBackground: true }, (() => {
    if (error) {
      return /* @__PURE__ */ React20.createElement(BlockContainer13, null, /* @__PURE__ */ React20.createElement(Block13, null, /* @__PURE__ */ React20.createElement(ErrorMessage10, null, "There was an error loading the data")));
    }
    if (isLoading) {
      return /* @__PURE__ */ React20.createElement(UserFormSkeletonComponent, null);
    }
    return /* @__PURE__ */ React20.createElement(
      UserForm,
      {
        alertSubscriptions,
        config: consumerConfig,
        groups,
        submitForm,
        userFormPageTranslations,
        userFormTranslations
      }
    );
  })()), /* @__PURE__ */ React20.createElement(Toaster8, { richColors: true }));
}

// src/modules/user-management/pages/edit-user/edit-user-page.tsx
import {
  PageLayout as PageLayout11,
  PageContent as PageContent11,
  ToolbarComponent as ToolbarComponent11,
  ToolbarContentComponent as ToolbarContentComponent8,
  ToolbarButtonComponent as ToolbarButtonComponent11,
  ErrorMessage as ErrorMessage11,
  BlockContainer as BlockContainer14,
  Block as Block14
} from "@ontruck/fe-ui";
import { CloseIcon as CloseIcon8 } from "@ontruck/fe-icons";
import React21 from "react";
import { Toaster as Toaster9 } from "sonner";

// src/modules/user-management/pages/edit-user/edit-user-page-hook.ts
import useSWR10 from "swr";
import { toast as toast9 } from "sonner";
import { useMemo as useMemo12 } from "react";

// src/modules/user-management/pages/edit-user/edit-user-api.ts
var editUserApi = (_0) => __async(void 0, [_0], function* ({
  userId,
  consumerConfig,
  editUserDto
}) {
  try {
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${consumerConfig.token}`);
    const endpoint = `${consumerConfig.api_url}api/auth/management/users/${userId}/`;
    const requestOptions = {
      method: "PATCH",
      headers,
      body: JSON.stringify(editUserDto)
    };
    const response = yield fetch(endpoint, requestOptions);
    const result = yield response.json();
    if (response.ok) {
      const id = result.id;
      return id;
    }
    if ("username" in result && result.username) {
      throw new Error("user_exists_in_other_shipper");
    }
    if ("phone" in result && result.phone) {
      throw new Error("phone_invalid");
    }
    throw new Error("unexpected_error");
  } catch (e) {
    if (e instanceof Error) {
      throw new Error(e.message);
    }
    throw new Error("unexpected_error");
  }
});

// src/modules/user-management/pages/edit-user/get-user-api.ts
var getUserApi = (_0) => __async(void 0, [_0], function* ({
  userId,
  consumerConfig
}) {
  try {
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", `Bearer ${consumerConfig.token}`);
    const endpoint = `${consumerConfig.api_url}api/auth/management/users/${userId}/`;
    const requestOptions = {
      method: "GET",
      headers
    };
    const response = yield fetch(endpoint, requestOptions);
    if (!response.ok) {
      throw new Error("Failed to fetch user");
    }
    const userDto = yield fetchJson(response);
    return userDto;
  } catch (e) {
    if (e instanceof Error) {
      throw new Error(e.message);
    } else {
      throw new Error("Unexpected error");
    }
  }
});

// src/modules/user-management/pages/edit-user/edit-user-page-hook.ts
var getUserApiFetcher = (userId, consumerConfig) => {
  return getUserApi({ userId, consumerConfig });
};
var mapUserDtoToInitialValues = (userDto) => {
  if (!userDto)
    return {};
  return {
    email: userDto.email,
    first_name: userDto.first_name,
    last_name: userDto.last_name,
    alert_subscriptions: userDto.alert_subscriptions.join(","),
    groups: userDto.groups.join(",")
  };
};
var EditUserPageHook = ({
  consumerConfig,
  userId,
  userFormPageTranslations
}) => {
  const fetcher = () => __async(void 0, null, function* () {
    return getUserApiFetcher(userId, consumerConfig);
  });
  const {
    data: userDto,
    error: userError,
    isLoading: userLoading,
    mutate
  } = useSWR10(userId, fetcher, {
    errorRetryCount: 0,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  });
  const initialValues = useMemo12(() => {
    return mapUserDtoToInitialValues(userDto);
  }, [userDto]);
  const submitForm = (_0) => __async(void 0, [_0], function* ({ formState }) {
    try {
      const alertSubscriptionsDto = formState.fields.alert_subscriptions.value.split(",").map((alert) => alert.trim()).filter((alert) => alert !== "");
      const groupsDto = formState.fields.groups.value.split(",").map((group) => group.trim()).filter((group) => group !== "");
      const editUserDto = {
        email: formState.fields.email.value,
        first_name: formState.fields.first_name.value,
        last_name: formState.fields.last_name.value,
        username: formState.fields.email.value,
        groups: groupsDto,
        alert_subscriptions: alertSubscriptionsDto
      };
      yield editUserApi({
        consumerConfig,
        editUserDto,
        userId
      });
      void mutate();
      toast9.success(userFormPageTranslations.on_success_message);
    } catch (e) {
      toast9.error(userFormPageTranslations.on_error_message);
      if (e instanceof Error) {
        throw new Error(e.message);
      } else {
        throw new Error("Unexpected error");
      }
    }
  });
  const {
    options: { groups, permissions, alertSubscriptions },
    error: optionsError,
    isLoading: optionsLoading
  } = useFormOptionsHook({
    consumerConfig
  });
  return {
    error: userError || optionsError,
    isLoading: userLoading || optionsLoading,
    initialValues,
    submitForm,
    groups,
    permissions,
    alertSubscriptions
  };
};

// src/modules/user-management/pages/edit-user/edit-user-page.tsx
function EditUserPage({
  consumerConfig,
  userFormPageTranslations,
  userFormTranslations,
  onGoToUsers,
  userId
}) {
  const { submitForm, error, isLoading, initialValues, groups, alertSubscriptions } = EditUserPageHook({
    consumerConfig,
    userId,
    userFormPageTranslations
  });
  return /* @__PURE__ */ React21.createElement(PageLayout11, null, /* @__PURE__ */ React21.createElement(ToolbarComponent11, null, /* @__PURE__ */ React21.createElement(ToolbarContentComponent8, null, /* @__PURE__ */ React21.createElement("div", null, /* @__PURE__ */ React21.createElement(ToolbarButtonComponent11, null, userFormPageTranslations.title)), /* @__PURE__ */ React21.createElement("div", null, /* @__PURE__ */ React21.createElement(
    ToolbarButtonComponent11,
    {
      onClick: () => {
        onGoToUsers();
      }
    },
    /* @__PURE__ */ React21.createElement(CloseIcon8, null)
  )))), /* @__PURE__ */ React21.createElement(PageContent11, { withBackground: true }, (() => {
    if (error) {
      return /* @__PURE__ */ React21.createElement(BlockContainer14, null, /* @__PURE__ */ React21.createElement(Block14, null, /* @__PURE__ */ React21.createElement(ErrorMessage11, null, "There was an error loading the user")));
    }
    if (isLoading) {
      return /* @__PURE__ */ React21.createElement(UserFormSkeletonComponent, null);
    }
    return /* @__PURE__ */ React21.createElement(
      UserForm,
      {
        alertSubscriptions,
        config: consumerConfig,
        groups,
        initialValues,
        submitForm,
        userFormPageTranslations,
        userFormTranslations
      }
    );
  })()), /* @__PURE__ */ React21.createElement(Toaster9, { richColors: true }));
}

// src/modules/carriers/carrier-form.tsx
import React23 from "react";
import {
  FormContainer as FormContainer8,
  Block as Block15,
  BlockContainer as BlockContainer15,
  SectionContainer as SectionContainer6,
  SectionBody as SectionBody7,
  Sticky as Sticky5,
  ButtonContainer as ButtonContainer5,
  Half as Half5,
  ButtonComponent as ButtonComponent5,
  ErrorMessage as ErrorMessage12,
  SectionTitle as SectionTitle7,
  Input as Input8
} from "@ontruck/fe-ui";
import styled8 from "styled-components";
import useSWR11 from "swr";

// src/shared/form/section/form-section.tsx
import React22 from "react";
import { SectionContainer as SectionContainer5, SectionTitle as SectionTitle6, SectionBody as SectionBody6, SectionLine as SectionLine6, Input as Input7 } from "@ontruck/fe-ui";
function FormSection({
  showErrors,
  handleChangeEvent,
  handleChangeValue,
  formSectionData
}) {
  return /* @__PURE__ */ React22.createElement(SectionContainer5, null, /* @__PURE__ */ React22.createElement(SectionTitle6, null, formSectionData.title), /* @__PURE__ */ React22.createElement(SectionBody6, null, formSectionData.rows.map((row, index) => (
    // eslint-disable-next-line react/no-array-index-key -- ^^
    /* @__PURE__ */ React22.createElement(SectionLine6, { key: `section-line-${index}` }, row.map((field) => /* @__PURE__ */ React22.createElement(
      Input7,
      {
        handleChangeEvent,
        handleChangeValue,
        hasError: showErrors ? !field.isValid : false,
        key: `input-${field.definition.name}`,
        label: field.definition.label || "",
        name: field.definition.name || "",
        type: field.definition.type,
        value: field.value
      }
    )))
  ))));
}

// src/modules/carriers/form/use-carrier-form.tsx
import { useCallback as useCallback13, useMemo as useMemo13, useState as useState7, useEffect } from "react";

// src/modules/carriers/form/carrier-form-fields.tsx
var CarrierFormFields = /* @__PURE__ */ ((CarrierFormFields2) => {
  CarrierFormFields2["Name"] = "name";
  CarrierFormFields2["ExternalCarrierId"] = "external_carrier_id";
  CarrierFormFields2["AddressLine"] = "address_line";
  CarrierFormFields2["Zipcode"] = "zipcode";
  CarrierFormFields2["City"] = "city";
  CarrierFormFields2["ContactName"] = "contact_name";
  CarrierFormFields2["Phone"] = "phone";
  CarrierFormFields2["PhoneSecondary"] = "phone_secondary";
  CarrierFormFields2["Email"] = "email";
  CarrierFormFields2["Rating"] = "rating";
  CarrierFormFields2["WorkingAreas"] = "working_areas";
  return CarrierFormFields2;
})(CarrierFormFields || {});

// src/modules/carriers/form/carrier-form-default-field-definitions.tsx
var carrierFormDefaultFieldDefinitions = {
  name: {
    type: "text",
    is_required: true,
    validation_pattern: notEmptyStringRegex,
    label: "Nombre del carrier",
    name: "name"
  },
  external_carrier_id: {
    type: "text",
    is_required: true,
    validation_pattern: notEmptyStringRegex,
    label: "Carrier ID",
    name: "external_carrier_id"
  },
  address_line: {
    type: "text",
    is_required: true,
    validation_pattern: notEmptyStringRegex,
    label: "Direcci\xF3n",
    name: "address_line"
  },
  zipcode: {
    type: "text",
    is_required: true,
    validation_pattern: notEmptyStringRegex,
    label: "Codigo postal",
    name: "zipcode"
  },
  city: {
    type: "text",
    is_required: true,
    validation_pattern: notEmptyStringRegex,
    label: "Ciudad",
    name: "city"
  },
  contact_name: {
    type: "text",
    is_required: true,
    validation_pattern: notEmptyStringRegex,
    label: "Persona de contacto",
    name: "contact_name"
  },
  phone: {
    type: "phone",
    is_required: true,
    validation_pattern: notEmptyStringRegex,
    label: "Tel\xE9fono principal",
    name: "phone"
  },
  phone_secondary: {
    type: "phone",
    is_required: false,
    validation_pattern: notEmptyStringRegex,
    label: "Tel\xE9fono secundario",
    name: "phone_secondary"
  },
  email: {
    type: "text",
    is_required: true,
    validation_pattern: emailRegex,
    label: "Email de comunicaciones",
    name: "email"
  },
  rating: {
    type: "rating",
    is_required: false,
    label: "Rating",
    name: "rating"
  },
  workingAreas: {
    type: "text",
    is_required: false,
    label: "Working areas",
    name: "working_areas"
  }
};

// src/modules/carriers/form/carrier-form-default-layout.tsx
var carrierFormDefaultLayout = [
  {
    rows: [["name" /* Name */, "external_carrier_id" /* ExternalCarrierId */]],
    title: "main_section" /* MainSection */
  },
  {
    rows: [["address_line" /* AddressLine */], ["zipcode" /* Zipcode */, "city" /* City */]],
    title: "address_section" /* AddressSection */
  },
  {
    rows: [
      ["contact_name" /* ContactName */, "phone" /* Phone */, "phone_secondary" /* PhoneSecondary */],
      ["email" /* Email */]
    ],
    title: "contact_section" /* ContactSection */
  },
  {
    rows: [["rating" /* Rating */]],
    title: "rating_section" /* RatingSection */
  }
];

// src/modules/carriers/form/use-carrier-form.tsx
var getTranslatedFieldDefinitions5 = ({
  fieldDefinitions,
  translations: translations2
}) => {
  const translatedFieldDefinitions = {};
  Object.entries(fieldDefinitions).forEach(([key, definition]) => {
    const fieldKey = key;
    const label = translations2.new_carrier.fields[fieldKey];
    const translatedDefinition = __spreadProps(__spreadValues({}, definition), {
      label
    });
    translatedFieldDefinitions[key] = translatedDefinition;
  });
  return translatedFieldDefinitions;
};
var getFieldDefinitionsRemovingHiddenFields = ({
  fieldDefinitions,
  hiddenFields
}) => {
  const fieldDefinitionsRemovingHiddenFields = {};
  Object.entries(fieldDefinitions).forEach(([key, definition]) => {
    const fieldKey = key;
    if (!hiddenFields.includes(fieldKey)) {
      fieldDefinitionsRemovingHiddenFields[key] = definition;
    }
  });
  return fieldDefinitionsRemovingHiddenFields;
};
var getCustomFieldDefinitions = ({
  fieldDefinitions,
  hiddenFields,
  translations: translations2
}) => {
  const translatedFieldDefinitions = getTranslatedFieldDefinitions5({
    fieldDefinitions,
    translations: translations2
  });
  return getFieldDefinitionsRemovingHiddenFields({
    fieldDefinitions: translatedFieldDefinitions,
    hiddenFields
  });
};
var getFormLayoutRemovingHiddenFields = ({
  formLayout,
  hiddenFields
}) => {
  return formLayout.map((section) => {
    const rows = section.rows.map((row) => row.filter((field) => !hiddenFields.includes(field))).filter((row) => row.length > 0);
    return {
      rows,
      title: section.title
    };
  }).filter((section) => section.rows.length > 0);
};
var getCustomSectionsFromLayout = ({
  formLayout,
  formState,
  translations: translations2
}) => {
  const customSections = formLayout.map((sectionWithFieldNames) => {
    const key = sectionWithFieldNames.title;
    const title = translations2.new_carrier.sections[key];
    const sectionWithFormFields = {
      rows: sectionWithFieldNames.rows.map(
        (row) => row.map((fieldName) => formState.fields[fieldName])
      ),
      title
    };
    return sectionWithFormFields;
  });
  return customSections;
};
var getCarrierDtoFromFormState = ({
  formState,
  hiddenFields
}) => {
  const fields = formState.fields;
  const carrierDto = {
    isActive: true,
    status: "active",
    billing_address: {
      country: "es"
    },
    country: "ES",
    drivers: []
  };
  if (!hiddenFields.includes("working_areas" /* WorkingAreas */)) {
    let workingAreas = formState.fields.workingAreas.value.split(",");
    if (workingAreas[0] === "") {
      workingAreas = [];
    }
    carrierDto.working_areas = workingAreas;
  }
  if (!hiddenFields.includes("name" /* Name */)) {
    carrierDto.name = fields.name.value;
  }
  if (!hiddenFields.includes("address_line" /* AddressLine */)) {
    carrierDto.billing_address.address_line = fields.address_line.value;
  }
  if (!hiddenFields.includes("zipcode" /* Zipcode */)) {
    carrierDto.billing_address.zipcode = fields.zipcode.value;
  }
  if (!hiddenFields.includes("city" /* City */)) {
    carrierDto.billing_address.city = fields.city.value;
  }
  if (!hiddenFields.includes("contact_name" /* ContactName */)) {
    carrierDto.contact_name = fields.contact_name.value;
  }
  if (!hiddenFields.includes("phone" /* Phone */)) {
    carrierDto.phone = fields.phone.value;
  }
  if (!hiddenFields.includes("phone_secondary" /* PhoneSecondary */)) {
    carrierDto.phone_secondary = fields.phone_secondary.value;
  }
  if (!hiddenFields.includes("email" /* Email */)) {
    carrierDto.email = fields.email.value;
  }
  if (!hiddenFields.includes("external_carrier_id" /* ExternalCarrierId */)) {
    carrierDto.external_carrier_id = fields.external_carrier_id.value;
  }
  if (!hiddenFields.includes("rating" /* Rating */)) {
    let rating = null;
    if (fields.rating.value !== "") {
      try {
        rating = parseInt(fields.rating.value);
      } catch (e) {
        rating = null;
      }
    }
    carrierDto.rating = rating;
  }
  return carrierDto;
};
var mapCarrierToInitialValues = (carrier) => {
  var _a;
  if (!carrier)
    return {};
  return {
    name: carrier.name || "",
    rating: carrier.rating ? `${carrier.rating}` : "",
    external_carrier_id: carrier.external_carrier_id || "",
    workingAreas: ((_a = carrier.working_areas) == null ? void 0 : _a.join(",")) || ""
  };
};
var useCarrierForm = (consumerConfig) => {
  const [isMounted, setIsMounted] = useState7(true);
  useEffect(() => {
    return () => {
      setIsMounted(false);
    };
  }, []);
  const customFieldDefinitions = useMemo13(() => {
    return getCustomFieldDefinitions({
      fieldDefinitions: carrierFormDefaultFieldDefinitions,
      hiddenFields: consumerConfig.hidden_fields,
      translations: consumerConfig.translations
    });
  }, [consumerConfig.hidden_fields, consumerConfig.translations]);
  const isEdit = consumerConfig.existingCarrier !== void 0;
  const initialValues = useMemo13(() => {
    return mapCarrierToInitialValues(consumerConfig.existingCarrier);
  }, [consumerConfig.existingCarrier]);
  const [formState, setFormState] = useState7(
    getInitialState({
      fieldDefinitions: customFieldDefinitions,
      initialValues
    })
  );
  const customFormLayout = getFormLayoutRemovingHiddenFields({
    formLayout: carrierFormDefaultLayout,
    hiddenFields: consumerConfig.hidden_fields
  });
  const customSections = useMemo13(() => {
    return getCustomSectionsFromLayout({
      formLayout: customFormLayout,
      formState,
      translations: consumerConfig.translations
    });
  }, [consumerConfig.translations, customFormLayout, formState]);
  const backendErrors = useMemo13(() => {
    const errors = [];
    Object.entries(formState.submit_errors).forEach(([, errorMessage]) => {
      let translatedMessage = "";
      try {
        const translatedMessageContent = errorMessage[0];
        if (translatedMessageContent.includes("phone")) {
          translatedMessage = consumerConfig.translations.new_carrier.error.error_possible_wrong_phone;
        } else if (translatedMessageContent.includes("email")) {
          translatedMessage = consumerConfig.translations.new_carrier.error.error_possible_wrong_email;
        } else if (translatedMessageContent.includes("External ID must be a 10-digit")) {
          translatedMessage = consumerConfig.translations.new_carrier.error.error_external_carrier_id;
        } else if (!isEdit) {
          translatedMessage = consumerConfig.translations.new_carrier.error.error_unexpected;
        } else {
          translatedMessage = "There was an error editing the carrier";
        }
      } catch (e) {
        translatedMessage = consumerConfig.translations.new_carrier.error.error_unexpected;
      }
      errors.push(translatedMessage);
    });
    return Array.from(new Set(errors));
  }, [
    formState.submit_errors,
    isEdit,
    consumerConfig.translations.new_carrier.error.error_possible_wrong_phone,
    consumerConfig.translations.new_carrier.error.error_possible_wrong_email,
    consumerConfig.translations.new_carrier.error.error_external_carrier_id,
    consumerConfig.translations.new_carrier.error.error_unexpected
  ]);
  const isValid = useMemo13(() => {
    for (const field of Object.values(formState.fields)) {
      if (!field.isValid) {
        return false;
      }
    }
    return true;
  }, [formState]);
  const createCarrier = useCallback13(
    (createCarrierDTO) => __async(void 0, null, function* () {
      let endpoint = `${consumerConfig.api_url}api/carriers/create_with_driver/`;
      if (!consumerConfig.with_driver) {
        endpoint = `${consumerConfig.api_url}api/mercury/carriers/`;
      }
      const headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Authorization", `Bearer ${consumerConfig.token}`);
      const body = JSON.stringify(createCarrierDTO);
      const requestOptions = {
        method: "POST",
        headers,
        body
      };
      const submitErrors = {};
      try {
        const response = yield fetch(endpoint, requestOptions);
        const result = yield response.json();
        if (response.ok) {
          consumerConfig.on_success(parseInt(result.id));
        } else {
          Object.entries(result).forEach(([key, errorMessage]) => {
            submitErrors[key] = errorMessage;
          });
        }
      } catch (e) {
        if (e instanceof Error) {
          submitErrors.uncontrolled = e.message;
        } else {
          submitErrors.uncontrolled = "Unexpected error";
        }
      }
      return submitErrors;
    }),
    [consumerConfig]
  );
  const editCarrier = useCallback13(
    (editCarrierDTO) => __async(void 0, null, function* () {
      let endpoint = `${consumerConfig.api_url}api/carriers/create_with_driver/`;
      if (!consumerConfig.with_driver) {
        endpoint = `${consumerConfig.api_url}api/mercury/carriers/${consumerConfig.carrier_id}/`;
      }
      const headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Authorization", `Bearer ${consumerConfig.token}`);
      const body = JSON.stringify(editCarrierDTO);
      const requestOptions = {
        method: "PUT",
        headers,
        body
      };
      const submitErrors = {};
      try {
        const response = yield fetch(endpoint, requestOptions);
        const result = yield response.json();
        if (response.ok) {
          consumerConfig.on_success(parseInt(result.id));
        } else {
          Object.entries(result).forEach(([key, errorMessage]) => {
            submitErrors[key] = errorMessage;
          });
        }
      } catch (e) {
        if (e instanceof Error) {
          submitErrors.uncontrolled = e.message;
        } else {
          submitErrors.uncontrolled = "Unexpected error";
        }
      }
      return submitErrors;
    }),
    [consumerConfig]
  );
  const handleSubmitCreate = useCallback13(
    (e) => __async(void 0, null, function* () {
      e.preventDefault();
      if (!isMounted)
        return;
      setFormState((previousState) => __spreadProps(__spreadValues({}, previousState), {
        show_errors: true,
        submit_errors: {}
      }));
      if (isValid) {
        setFormState((previousState) => __spreadProps(__spreadValues({}, previousState), {
          is_submiting: true
        }));
        const createCarrierDto = getCarrierDtoFromFormState({
          formState,
          hiddenFields: consumerConfig.hidden_fields
        });
        const submitErrors = yield createCarrier(createCarrierDto);
        setFormState((previousState) => __spreadProps(__spreadValues({}, previousState), {
          is_submiting: false,
          submit_errors: submitErrors
        }));
      }
    }),
    [isMounted, isValid, formState, consumerConfig.hidden_fields, createCarrier]
  );
  const handleSubmitEdit = useCallback13(
    (e) => __async(void 0, null, function* () {
      e.preventDefault();
      if (!isMounted)
        return;
      setFormState((previousState) => __spreadProps(__spreadValues({}, previousState), {
        show_errors: true,
        submit_errors: {}
      }));
      if (isValid) {
        setFormState((previousState) => __spreadProps(__spreadValues({}, previousState), {
          is_submiting: true
        }));
        const editCarrierDto = getCarrierDtoFromFormState({
          formState,
          hiddenFields: consumerConfig.hidden_fields
        });
        const submitErrors = yield editCarrier(editCarrierDto);
        setFormState((previousState) => __spreadProps(__spreadValues({}, previousState), {
          is_submiting: false,
          submit_errors: submitErrors
        }));
      }
    }),
    [isMounted, isValid, formState, consumerConfig.hidden_fields, editCarrier]
  );
  const handleSubmit = useCallback13(
    (e) => {
      if (isEdit) {
        void handleSubmitEdit(e);
      } else {
        void handleSubmitCreate(e);
      }
    },
    [isEdit, handleSubmitEdit, handleSubmitCreate]
  );
  const handleChangeValue = useCallback13((fieldName, value) => {
    setFormState((previousState) => {
      const newState = __spreadValues({}, previousState);
      if (typeof value !== "undefined") {
        newState.fields[fieldName].value = value;
      }
      const validatedFormState = getValidatedFormState(newState);
      return validatedFormState;
    });
  }, []);
  const handleChangeEvent = (e) => {
    const fieldName = e.currentTarget.name;
    const value = e.currentTarget.value;
    handleChangeValue(fieldName, value);
  };
  return {
    handleSubmit,
    handleChangeValue,
    handleChangeEvent,
    customSections,
    backendErrors,
    formState,
    isEdit
  };
};

// src/modules/carriers/carrier-form.tsx
var WorkingAreasTitleComponent2 = styled8(SectionTitle7)`
  display: flex;
  align-items: center;
  gap: 16px;
`;
function CarrierForm(consumerConfig) {
  const {
    handleSubmit,
    handleChangeValue,
    handleChangeEvent,
    customSections,
    backendErrors,
    formState,
    isEdit
  } = useCarrierForm(consumerConfig);
  const config = {
    api_url: consumerConfig.api_url,
    token: consumerConfig.token,
    // eslint-disable-next-line @typescript-eslint/no-empty-function -- we don't need to do anything here
    on_success: () => {
    },
    // eslint-disable-next-line @typescript-eslint/no-empty-function -- we don't need to do anything here
    on_discard: () => {
    },
    hidden_fields: []
  };
  const workingAreasFetcher = () => __async(this, null, function* () {
    return getWorkingAreasApi({ config });
  });
  const { data: workingAreasData } = useSWR11(
    "working-areas",
    workingAreasFetcher,
    {
      errorRetryCount: 0,
      revalidateOnFocus: false,
      revalidateOnReconnect: false
    }
  );
  const workingAreasMapped = getWorkingAreasMappedService(workingAreasData);
  const workingAreas = workingAreasMapped || [];
  const workingAreasChecked = formState.fields.workingAreas.value.trim().split(",").map((workingArea) => workingArea.trim()).filter((workingArea) => workingArea !== "");
  const onWorkingAreaClick = (workingArea) => {
    const isSelected = workingAreasChecked.includes(workingArea);
    if (isSelected) {
      const newWorkingAreasChecked = workingAreasChecked.filter((w) => w !== workingArea);
      handleChangeValue("workingAreas", newWorkingAreasChecked.join(","));
    } else {
      const newWorkingAreasChecked = [...workingAreasChecked, workingArea];
      handleChangeValue("workingAreas", newWorkingAreasChecked.join(","));
    }
  };
  const showWorkingAreasSection = !consumerConfig.hidden_fields.includes(
    "working_areas" /* WorkingAreas */
  );
  return /* @__PURE__ */ React23.createElement(FormContainer8, null, /* @__PURE__ */ React23.createElement(
    "form",
    {
      autoComplete: "off",
      onSubmit: (event) => {
        handleSubmit(event);
      }
    },
    /* @__PURE__ */ React23.createElement(BlockContainer15, null, /* @__PURE__ */ React23.createElement(Block15, null, customSections.map((section) => {
      return /* @__PURE__ */ React23.createElement(
        FormSection,
        {
          formSectionData: section,
          handleChangeEvent,
          handleChangeValue,
          key: section.title,
          showErrors: formState.show_errors
        }
      );
    }), showWorkingAreasSection ? /* @__PURE__ */ React23.createElement(SectionContainer6, null, /* @__PURE__ */ React23.createElement(WorkingAreasTitleComponent2, null, consumerConfig.translations.new_carrier.sections.working_areas_section), /* @__PURE__ */ React23.createElement(MulticheckboxBodyComponent, null, workingAreas.map((workingArea) => /* @__PURE__ */ React23.createElement(MulticheckboxItemComponent, { key: workingArea.id }, /* @__PURE__ */ React23.createElement(
      Input8,
      {
        handleChangeValue: (_name, _value) => {
          onWorkingAreaClick(workingArea.name);
        },
        label: workingArea.name,
        name: `working - area - ${workingArea.id} `,
        type: "checkbox",
        value: workingAreasChecked.includes(workingArea.name).toString()
      }
    ))))) : null, backendErrors.length > 0 && /* @__PURE__ */ React23.createElement(SectionContainer6, null, /* @__PURE__ */ React23.createElement(SectionBody7, null, /* @__PURE__ */ React23.createElement(ErrorMessage12, null, backendErrors.map((errorMessage) => {
      return /* @__PURE__ */ React23.createElement("div", { key: errorMessage }, errorMessage);
    })))), consumerConfig.children !== void 0 && /* @__PURE__ */ React23.createElement(SectionContainer6, null, consumerConfig.children))),
    /* @__PURE__ */ React23.createElement(Sticky5, null, /* @__PURE__ */ React23.createElement(ButtonContainer5, null, /* @__PURE__ */ React23.createElement(Half5, null, isEdit ? /* @__PURE__ */ React23.createElement(
      ButtonComponent5,
      {
        color: "primary",
        disabled: formState.is_submiting,
        fullWidth: true,
        size: "s",
        type: "submit"
      },
      "Save changes"
    ) : /* @__PURE__ */ React23.createElement(
      ButtonComponent5,
      {
        color: "primary",
        disabled: formState.is_submiting,
        fullWidth: true,
        size: "s",
        type: "submit"
      },
      consumerConfig.translations.new_carrier.add_carrier
    ))))
  ));
}

// src/modules/carriers/new-carrier-page.tsx
import {
  PageLayout as PageLayout12,
  PageContent as PageContent12,
  ToolbarComponent as ToolbarComponent12,
  ToolbarContentComponent as ToolbarContentComponent9,
  ToolbarButtonComponent as ToolbarButtonComponent12
} from "@ontruck/fe-ui";
import { CloseIcon as CloseIcon9 } from "@ontruck/fe-icons";
import React24 from "react";
function NewCarrierPage(consumerConfig) {
  return /* @__PURE__ */ React24.createElement(PageLayout12, null, /* @__PURE__ */ React24.createElement(ToolbarComponent12, null, /* @__PURE__ */ React24.createElement(ToolbarContentComponent9, null, /* @__PURE__ */ React24.createElement("div", null, consumerConfig.pageTitle ? /* @__PURE__ */ React24.createElement(ToolbarButtonComponent12, null, consumerConfig.pageTitle) : null), /* @__PURE__ */ React24.createElement("div", null, /* @__PURE__ */ React24.createElement(ToolbarButtonComponent12, { onClick: consumerConfig.on_discard }, /* @__PURE__ */ React24.createElement(CloseIcon9, null))))), /* @__PURE__ */ React24.createElement(PageContent12, { withBackground: consumerConfig.withBackground }, /* @__PURE__ */ React24.createElement(CarrierForm, __spreadValues({}, consumerConfig))));
}

// src/modules/carriers/edit-carrier-page.tsx
import {
  PageLayout as PageLayout13,
  PageContent as PageContent13,
  ToolbarComponent as ToolbarComponent13,
  ToolbarContentComponent as ToolbarContentComponent10,
  ToolbarButtonComponent as ToolbarButtonComponent13
} from "@ontruck/fe-ui";
import { CloseIcon as CloseIcon10 } from "@ontruck/fe-icons";
import React25, { useEffect as useEffect2, useState as useState8 } from "react";
var getCarrierById = (_0) => __async(void 0, [_0], function* ({
  consumerConfig
}) {
  const endpoint = `${consumerConfig.api_url}api/carriers/${consumerConfig.carrier_id}/`;
  const headers = new Headers();
  headers.append("Content-Type", "application/json");
  headers.append("Authorization", `Bearer ${consumerConfig.token}`);
  const requestOptions = {
    method: "GET",
    headers
  };
  try {
    const response = yield fetch(endpoint, requestOptions);
    const result = yield response.json();
    if (response.ok) {
      return result;
    }
    return null;
  } catch (e) {
    return null;
  }
});
var useGetCarrier = ({
  consumerConfig
}) => {
  const [isLoading, setIsLoading] = useState8(true);
  const [existingCarrier, setExistingCarrier] = useState8(null);
  useEffect2(() => {
    const callGetCarrierByIdAsync = () => __async(void 0, null, function* () {
      const carrierData = yield getCarrierById({ consumerConfig });
      setExistingCarrier(carrierData);
      setIsLoading(false);
    });
    void callGetCarrierByIdAsync();
  }, [consumerConfig]);
  return { isLoading, existingCarrier };
};
function EditCarrierPage(consumerConfig) {
  const { isLoading, existingCarrier } = useGetCarrier({
    consumerConfig
  });
  return /* @__PURE__ */ React25.createElement(PageLayout13, null, /* @__PURE__ */ React25.createElement(ToolbarComponent13, null, /* @__PURE__ */ React25.createElement(ToolbarContentComponent10, null, /* @__PURE__ */ React25.createElement("div", null, consumerConfig.pageTitle ? /* @__PURE__ */ React25.createElement(ToolbarButtonComponent13, null, consumerConfig.pageTitle) : null), /* @__PURE__ */ React25.createElement("div", null, /* @__PURE__ */ React25.createElement(ToolbarButtonComponent13, { onClick: consumerConfig.on_discard }, /* @__PURE__ */ React25.createElement(CloseIcon10, null))))), /* @__PURE__ */ React25.createElement(PageContent13, { withBackground: consumerConfig.withBackground }, !isLoading && !existingCarrier && /* @__PURE__ */ React25.createElement("div", null, "Carrier not found"), !isLoading && existingCarrier ? /* @__PURE__ */ React25.createElement(CarrierForm, __spreadProps(__spreadValues({}, consumerConfig), { existingCarrier })) : null));
}

// src/modules/carriers/carriers-translations-mocks.tsx
var carrierTranslationsMocks = {
  new_carrier: {
    new_carrier: "New Carrier",
    add_carrier: "Add Carrier",
    fields: {
      name: "Carrier name",
      address_line: "Fiscal Address",
      zipcode: "Zipcode",
      city: "City",
      contact_name: "Contact person",
      phone: "Main phone",
      phone_secondary: "Secondary phone",
      email: "Comunications email",
      external_carrier_id: "Carrier ID",
      rating: "Rating",
      working_areas: "Working areas"
    },
    sections: {
      main_section: "Main information",
      address_section: "Fiscal address",
      contact_section: "Contact",
      rating_section: "Carrier rating",
      working_areas_section: "Working areas"
    },
    error: {
      error_unexpected: "There was an error creating the carrier",
      error_possible_wrong_phone: "There was an error creating the carrier, make sure phone is not already in use",
      error_possible_wrong_email: "There was an error creating the carrier, make sure email is not already in use",
      error_external_carrier_id: "ID can not be empty and must have 10 digits"
    }
  }
};

// src/modules/delegation/pages/cargos/cargos-page.tsx
import React47, { useState as useState16, useMemo as useMemo25, useCallback as useCallback15 } from "react";
import styled20 from "styled-components";
import {
  PageContent as PageContent14,
  PageLayout as PageLayout14,
  ToolbarComponent as ToolbarComponent14,
  ToolbarButtonComponent as ToolbarButtonComponent15,
  ToolbarContentComponent as ToolbarContentComponent11,
  TableComponent as TableComponent5,
  FlexComponent as FlexComponent13
} from "@ontruck/fe-ui";
import { QrCodeIcon } from "@ontruck/fe-icons";
import { Toaster as Toaster11 } from "sonner";

// src/modules/delegation/config-provider.tsx
import React26 from "react";

// src/modules/delegation/config-context.ts
import { createContext } from "react";
var delegationConfig = {
  token: "",
  apiBase: "",
  delegations: []
};
var ConfigContext = createContext(delegationConfig);

// src/modules/delegation/config-provider.tsx
function ConfigProvider({
  token,
  apiBase,
  delegations,
  children
}) {
  return /* @__PURE__ */ React26.createElement(
    ConfigContext.Provider,
    {
      value: {
        apiBase,
        delegations,
        token
      }
    },
    children
  );
}

// src/modules/delegation/pages/cargos/filters/filters-hook.ts
import { useState as useState9, useEffect as useEffect3 } from "react";
import { persistentStorageService, useScrollCacheHook } from "@ontruck/fe-ui";

// src/modules/delegation/pages/cargos/cargos-dto.ts
var cargoLatestEventTypes = {
  assigned: "assigned",
  collectedForDelivery: "collected-for-delivery",
  collectedForTransfer: "collected-for-transfer",
  consolidated: "consolidated",
  customsCleared: "customs-cleared",
  created: "created",
  deconsolidated: "deconsolidated",
  delivered: "delivered",
  deliveryAddressUpdated: "delivery-address-updated",
  deliveryFailed: "delivery-failed",
  deliveryInternalUpdated: "delivery-internal-updated",
  incidentReported: "incident-reported",
  received: "received",
  cancelled: "cancelled"
};
var cargoStateDto = {
  customsCleared: "customs-cleared",
  created: "created",
  atOrigin: "at-origin",
  inTransfer: "in-transfer",
  atWarehouse: "at-warehouse",
  outForDelivery: "out-for-delivery",
  delivered: "delivered",
  cancelled: "cancelled"
};

// src/modules/delegation/pages/cargos/filters/filters-hook.ts
var DEFAULT_PAGINATION_SIZE_FILTER_OPTION3 = 100;
var SELECTED_FILTERS_STORAGE_KEY = "cargos_list_selected_filters";
var getFiltersOptions3 = ({ delegations }) => {
  const delegationOptions = [];
  delegationOptions.push({
    id: 0,
    name: "Todas"
  });
  const sortedDelegations = delegations.sort((a, b) => a.name.localeCompare(b.name));
  delegationOptions.push(...sortedDelegations);
  return {
    delegations: delegationOptions,
    states: [
      "all",
      cargoStateDto.created,
      cargoStateDto.customsCleared,
      cargoStateDto.atOrigin,
      cargoStateDto.atWarehouse,
      cargoStateDto.inTransfer,
      cargoStateDto.outForDelivery,
      cargoStateDto.delivered,
      cargoStateDto.cancelled
    ],
    paginationSizes: [100, 200, 500, 1e3]
  };
};
var isValidDateFormat = (dateStr) => {
  if (!dateStr)
    return false;
  try {
    const regex = /^\d{4}-\d{2}-\d{2}$/;
    if (!regex.test(dateStr)) {
      return false;
    }
    const date = new Date(dateStr);
    const timestamp = date.getTime();
    if (isNaN(timestamp)) {
      return false;
    }
    const [year, month, day] = dateStr.split("-").map(Number);
    return date.getUTCFullYear() === year && date.getUTCMonth() + 1 === month && // getUTCMonth is zero-based
    date.getUTCDate() === day;
  } catch (e) {
    return false;
  }
};
var getDefaultSelectedFilters3 = ({
  filtersOptions
}) => {
  const hasMultipleDelegations = filtersOptions.delegations.length > 2;
  const initialDelegation = hasMultipleDelegations ? filtersOptions.delegations[0] : filtersOptions.delegations[1];
  const driverId = void 0;
  const dateFrom = void 0;
  const dateTo = void 0;
  return {
    delegation: initialDelegation,
    state: "all",
    search: "",
    zipcode: "",
    paginationSize: filtersOptions.paginationSizes[0] || DEFAULT_PAGINATION_SIZE_FILTER_OPTION3,
    page: 1,
    driverId,
    dateFrom,
    dateTo
  };
};
var getInitialSelectedFilters3 = ({
  filtersOptions
}) => {
  const initialSelectedFilters = getDefaultSelectedFilters3({ filtersOptions });
  const savedFilters = persistentStorageService.loadItem(
    SELECTED_FILTERS_STORAGE_KEY
  );
  if (savedFilters) {
    const isSavedDelegationValid = filtersOptions.delegations.some(
      (delegation) => delegation.id === savedFilters.delegation.id
    );
    if (isSavedDelegationValid) {
      initialSelectedFilters.delegation = savedFilters.delegation;
    }
    const isSavedStateValid = filtersOptions.states.includes(savedFilters.state);
    if (isSavedStateValid) {
      initialSelectedFilters.state = savedFilters.state;
    }
    const isSavedPaginationSizeValid = filtersOptions.paginationSizes.includes(
      savedFilters.paginationSize
    );
    if (isSavedPaginationSizeValid) {
      initialSelectedFilters.paginationSize = savedFilters.paginationSize;
    }
    const isDateFromValid = isValidDateFormat(savedFilters.dateFrom);
    if (isDateFromValid) {
      initialSelectedFilters.dateFrom = savedFilters.dateFrom;
    }
    const isDateToValid = isValidDateFormat(savedFilters.dateTo);
    if (isDateToValid) {
      initialSelectedFilters.dateTo = savedFilters.dateTo;
    }
    initialSelectedFilters.search = savedFilters.search;
    initialSelectedFilters.zipcode = savedFilters.zipcode;
    initialSelectedFilters.page = savedFilters.page;
    initialSelectedFilters.driverId = savedFilters.driverId;
  }
  return initialSelectedFilters;
};
var useFiltersHook3 = ({ delegations }) => {
  const filtersOptions = getFiltersOptions3({ delegations });
  const initialSelectedFilters = getInitialSelectedFilters3({
    filtersOptions
  });
  const { resetScrollCache } = useScrollCacheHook("cargos-list");
  const [selectedFilters, setSelectedFilters] = useState9(initialSelectedFilters);
  useEffect3(() => {
    persistentStorageService.saveItem(
      SELECTED_FILTERS_STORAGE_KEY,
      selectedFilters
    );
    resetScrollCache();
  }, [selectedFilters, resetScrollCache]);
  const setPage = (page) => {
    setSelectedFilters(__spreadProps(__spreadValues({}, selectedFilters), {
      page
    }));
  };
  const setPaginationSize = (paginationSize) => {
    setSelectedFilters(__spreadProps(__spreadValues({}, selectedFilters), {
      paginationSize,
      page: 1
    }));
  };
  const setZipcode = (zipcode) => {
    setSelectedFilters(__spreadProps(__spreadValues({}, selectedFilters), {
      zipcode,
      page: 1
    }));
  };
  const setSearch = (search) => {
    setSelectedFilters(__spreadProps(__spreadValues({}, selectedFilters), {
      search,
      page: 1
    }));
  };
  const setDelegation = (delegation) => {
    setSelectedFilters(__spreadProps(__spreadValues({}, selectedFilters), {
      delegation,
      page: 1
    }));
  };
  const setState = (state) => {
    setSelectedFilters(__spreadProps(__spreadValues({}, selectedFilters), {
      state,
      page: 1
    }));
  };
  const setDriverId = (driverId) => {
    setSelectedFilters(__spreadProps(__spreadValues({}, selectedFilters), {
      driverId,
      page: 1
    }));
  };
  const setDateFrom = (dateFrom) => {
    setSelectedFilters(__spreadProps(__spreadValues({}, selectedFilters), {
      dateFrom,
      page: 1
    }));
  };
  const setDateTo = (dateTo) => {
    setSelectedFilters(__spreadProps(__spreadValues({}, selectedFilters), {
      dateTo,
      page: 1
    }));
  };
  return {
    filtersOptions,
    selectedFilters,
    setPage,
    setPaginationSize,
    setZipcode,
    setSearch,
    setDelegation,
    setState,
    setDriverId,
    setDateFrom,
    setDateTo
  };
};

// src/modules/delegation/pages/cargos/get-cargo-children-hook.ts
import useSWR12 from "swr";

// src/modules/delegation/pages/cargos/get-query-params-from-selected-filters.ts
var getPageSizeQuery3 = (selectedFilters) => {
  return `page_size=${selectedFilters.paginationSize}`;
};
var getPageQuery3 = (selectedFilters) => {
  return `page=${selectedFilters.page}`;
};
var getZipcodeQuery = (selectedFilters) => {
  const zipcodeValue = selectedFilters.zipcode;
  if (zipcodeValue.trim() === "") {
    return null;
  }
  const zipcodesForQuery = zipcodeValue.split(",").map((zipcode) => zipcode.trim()).filter((zipcode) => zipcode !== "");
  if (zipcodesForQuery.length === 0)
    return null;
  const zipcodesSearchParams = zipcodesForQuery.map((zipcode) => `zipcode=${zipcode}`);
  if (zipcodesSearchParams.length === 1)
    return zipcodesSearchParams[0];
  return zipcodesSearchParams.join("&");
};
var getSearchQuery3 = (selectedFilters) => {
  const searchValue = selectedFilters.search;
  if (searchValue.trim() === "") {
    return null;
  }
  return `search=${searchValue}`;
};
var getQuery = (selectedFilters) => {
  const delegationId = selectedFilters.delegation.id;
  if (delegationId === 0) {
    return null;
  }
  return `delegation=${delegationId}`;
};
var getStateQuery = (selectedFilters) => {
  const state = selectedFilters.state;
  if (state === "all") {
    return null;
  }
  return `state=${state}`;
};
var getDriverQuery = (selectedFilters) => {
  const driverId = selectedFilters.driverId;
  if (!driverId) {
    return null;
  }
  if (driverId === "-1") {
    return `no_driver=true`;
  }
  return `driver=${driverId}`;
};
var getDateFromQuery = (selectedFilters) => {
  const dateFrom = selectedFilters.dateFrom;
  if (!dateFrom) {
    return null;
  }
  return `created_at_from=${dateFrom}`;
};
var getDateToQuery = (selectedFilters) => {
  const dateTo = selectedFilters.dateTo;
  if (!dateTo) {
    return null;
  }
  return `created_at_to=${dateTo}`;
};
var getQueryParamsFromSelectedFilters3 = (selectedFilters) => {
  let query = ``;
  const pageSizeQuery = getPageSizeQuery3(selectedFilters);
  const zipcodeQuery = getZipcodeQuery(selectedFilters);
  const searchQuery = getSearchQuery3(selectedFilters);
  const pageQuery = getPageQuery3(selectedFilters);
  const delegationQuery = getQuery(selectedFilters);
  const stateQuery = getStateQuery(selectedFilters);
  const driverQuery = getDriverQuery(selectedFilters);
  const dateFromQuery = getDateFromQuery(selectedFilters);
  const dateToQuery = getDateToQuery(selectedFilters);
  const queries = [
    pageSizeQuery,
    zipcodeQuery,
    searchQuery,
    pageQuery,
    delegationQuery,
    stateQuery,
    driverQuery,
    dateFromQuery,
    dateToQuery
  ];
  queries.forEach((currentQuery, index) => {
    if (currentQuery) {
      const paramSeparator = index === 0 ? "?" : "&";
      query = `${query}${paramSeparator}${currentQuery}`;
    }
  });
  return query;
};

// src/modules/delegation/pages/cargos/get-cargo-children-api.ts
var getCargoChildrenApi = (_0) => __async(void 0, [_0], function* ({
  cargoId,
  config,
  selectedFilters
}) {
  const selectedFiltersForChildren = __spreadValues({}, selectedFilters);
  selectedFiltersForChildren.page = 1;
  const query = getQueryParamsFromSelectedFilters3(selectedFiltersForChildren);
  const endpoint = `${config.apiBase}/v1/fleet/cargos/${cargoId}/consolidated/${query}`;
  const response = yield fetch(endpoint, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${config.token}`
    }
  });
  const data = yield fetchJson(response);
  return data;
});

// src/modules/delegation/pages/cargos/get-cargo-children-fetcher.ts
var getCargoChildrenApiFetcher = (cargoId, selectedFilters, config) => {
  return getCargoChildrenApi({ cargoId, selectedFilters, config });
};

// src/modules/delegation/pages/cargos/get-cargo-children-mapper-service.ts
function getCargoChildrenMapperService(cargoChildrenDto) {
  if (!cargoChildrenDto) {
    return;
  }
  const cargosMapped = cargoChildrenDto.results.map((cargoChildDto) => {
    return {
      id: cargoChildDto.id,
      externalId: cargoChildDto.external_id,
      destination: {
        city: cargoChildDto.destinations[0].city,
        companyName: cargoChildDto.destinations[0].company_name,
        country: cargoChildDto.destinations[0].country,
        id: cargoChildDto.destinations[0].id,
        zipcode: cargoChildDto.destinations[0].zipcode
      }
    };
  });
  return {
    cargoChildren: cargosMapped
  };
}

// src/modules/delegation/pages/cargos/get-cargo-children-hook.ts
var useGetCargoChildrenHook = ({
  cargoId,
  selectedFilters,
  config
}) => {
  const fetcher = cargoId ? () => __async(void 0, null, function* () {
    return getCargoChildrenApiFetcher(cargoId, selectedFilters, config);
  }) : null;
  const { data, error, isLoading, mutate } = useSWR12(
    cargoId ? ["cargoChildren", selectedFilters, cargoId] : null,
    fetcher
  );
  const cargosMapped = getCargoChildrenMapperService(data);
  return {
    cargoChildren: (cargosMapped == null ? void 0 : cargosMapped.cargoChildren) || [],
    isLoading,
    error,
    mutate
  };
};

// src/modules/delegation/pages/cargos/get-cargos-filtered-hook.ts
import useSWR13 from "swr";

// src/modules/delegation/pages/cargos/get-cargos-api.ts
var getCargosFromApi = (_0) => __async(void 0, [_0], function* ({
  selectedFilters,
  config
}) {
  const query = getQueryParamsFromSelectedFilters3(selectedFilters);
  const endpoint = `${config.apiBase}/v1/fleet/cargos${query}`;
  const response = yield fetch(endpoint, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${config.token}`
    }
  });
  const data = yield fetchJson(response);
  return data;
});

// src/modules/delegation/pages/cargos/get-cargos-fetcher.ts
var getCargosFromApiFetcher = (cargoItemsKey, config) => {
  const selectedFilters = JSON.parse(cargoItemsKey);
  return getCargosFromApi({ selectedFilters, config });
};

// src/modules/delegation/pages/cargos/get-cargos-mapped-service.ts
function getCargosMappedService(cargosDto) {
  if (!cargosDto) {
    return;
  }
  const cargosMapped = cargosDto.results.map((cargoDto) => {
    try {
      return {
        actions: cargoDto.actions,
        state: cargoDto.state || cargoStateDto.created,
        id: cargoDto.id,
        externalId: cargoDto.external_id,
        isConsolidation: cargoDto.is_consolidation,
        numberOfCargos: cargoDto.number_of_cargos,
        filteredNumberOfCargos: cargoDto.filtered_number_of_cargos,
        destination: {
          city: cargoDto.destinations[0].city,
          companyName: cargoDto.destinations[0].company_name,
          country: cargoDto.destinations[0].country,
          id: cargoDto.destinations[0].id,
          zipcode: cargoDto.destinations[0].zipcode
        },
        lastReceivedAt: cargoDto.last_received_at ? {
          city: cargoDto.last_received_at.city,
          companyName: cargoDto.last_received_at.company_name,
          country: cargoDto.last_received_at.country,
          id: cargoDto.last_received_at.id,
          zipcode: cargoDto.last_received_at.zipcode
        } : null,
        lastUpdate: {
          id: cargoDto.latest_event.id,
          date: cargoDto.latest_event.created_at,
          eventType: cargoDto.latest_event.event_type,
          address: {
            id: cargoDto.latest_event.address.id,
            companyName: cargoDto.latest_event.address.company_name,
            addressName: cargoDto.latest_event.address.address_name || ""
          },
          user: {
            id: cargoDto.latest_event.created_by.id,
            username: cargoDto.latest_event.created_by.username,
            firstName: cargoDto.latest_event.created_by.first_name,
            lastName: cargoDto.latest_event.created_by.last_name,
            phone: cargoDto.latest_event.created_by.phone || "",
            type: cargoDto.latest_event.created_by.type || ""
          },
          driver: cargoDto.latest_event.driver !== null ? {
            id: cargoDto.latest_event.driver.id,
            contactName: cargoDto.latest_event.driver.contact_name
          } : null,
          diff: cargoDto.latest_event.diff,
          longitude: cargoDto.latest_event.longitude,
          latitude: cargoDto.latest_event.latitude,
          image: cargoDto.latest_event.image,
          deliveryNotes: cargoDto.latest_event.delivery_notes || "",
          observations: cargoDto.latest_event.observations || "",
          idNumber: cargoDto.latest_event.id_number || "",
          dropOffType: cargoDto.latest_event.dropoff_type || ""
        },
        driver: cargoDto.driver !== null ? {
          id: cargoDto.driver.id,
          contactName: cargoDto.driver.contact_name
        } : null,
        delegation: {
          id: cargoDto.delegation.id
        }
      };
    } catch (e) {
      console.error("Error mapping cargo with id ", cargoDto.id);
      console.error(e);
      throw e;
    }
  });
  const count = cargosDto.count;
  return {
    cargos: cargosMapped,
    count
  };
}

// src/modules/delegation/pages/cargos/settings.ts
var RELOAD_CARGOS_LIST_INTERVAL_IN_SECONDS = 30;

// src/modules/delegation/pages/cargos/get-cargos-filtered-hook.ts
var useGetCargosFilteredHook = ({
  selectedFilters,
  config
}) => {
  const cargoItemsKey = JSON.stringify(selectedFilters);
  const fetcher = () => __async(void 0, null, function* () {
    return getCargosFromApiFetcher(cargoItemsKey, config);
  });
  const { data, error, isLoading, mutate } = useSWR13(cargoItemsKey, fetcher, {
    refreshInterval: RELOAD_CARGOS_LIST_INTERVAL_IN_SECONDS * 1e3,
    revalidateIfStale: true
  });
  const cargosMapped = getCargosMappedService(data);
  return {
    cargos: (cargosMapped == null ? void 0 : cargosMapped.cargos) || [],
    count: (cargosMapped == null ? void 0 : cargosMapped.count) || 0,
    isLoading,
    error,
    mutate
  };
};

// src/modules/delegation/pages/cargos/table/actions-hook.tsx
import React34 from "react";
import { Modal } from "react-async-popup";

// src/modules/delegation/pages/cargos/table/actions/assign-driver-to-cargos/assign-driver-to-cargos-modal.tsx
import React29, { useMemo as useMemo15 } from "react";
import styled10 from "styled-components";
import { ModalComponent } from "@ontruck/fe-ui";

// src/modules/delegation/pages/cargos/table/actions/actions-zip-codes-by-location-summary-component.tsx
import React27 from "react";
import styled9 from "styled-components";
import { FlexComponent as FlexComponent6, TextComponent as TextComponent6 } from "@ontruck/fe-ui";
var SectionComponent = styled9.section`
  width: 100%;
`;
var WrapperComponent = styled9.div`
  width: 100%;
  border-top: ${"1px solid var(--otk-theme-color-grey-300,#ccd6e0)"};
  border-bottom: ${"1px solid var(--otk-theme-color-grey-300,#ccd6e0)"};
  padding-top: ${"var(--delegations-cargos-actions-zip-codes-by-location-summary-padding-vertical, var(--otk-theme-space-m))"};
  padding-bottom: ${"var(--delegations-cargos-actions-zip-codes-by-location-summary-padding-vertical, var(--otk-theme-space-m))"};
  padding-left: ${"var(--otk-theme-space-s, 8px)"};
  padding-right: ${"var(--otk-theme-space-s, 8px);"};
`;
function ActionsZipCodesByLocationsSummaryComponent({
  zipCodesByLocations,
  hasConsolidated
}) {
  const componentKey = "actions-zip-codes-by-location-summary";
  return /* @__PURE__ */ React27.createElement(SectionComponent, null, zipCodesByLocations.map(
    (zipCodesByLocation, z) => {
      if (z === zipCodesByLocations.length - 1) {
        return /* @__PURE__ */ React27.createElement(WrapperComponent, { key: `${componentKey}-${zipCodesByLocation.location}` }, /* @__PURE__ */ React27.createElement(FlexComponent6, { alignItems: "center", justifyContent: "space-between", width: "100%" }, /* @__PURE__ */ React27.createElement(TextComponent6, null, zipCodesByLocation.location), /* @__PURE__ */ React27.createElement(FlexComponent6, { alignItems: "center" }, zipCodesByLocation.zipCodes.map((zipCode, zc) => {
          if (zc === zipCodesByLocation.zipCodes.length - 1) {
            return /* @__PURE__ */ React27.createElement(TextComponent6, { key: `${componentKey}-${zipCode}` }, zipCode);
          }
          return /* @__PURE__ */ React27.createElement(TextComponent6, { key: `${componentKey}-${zipCode}` }, `${zipCode},`, "\xA0");
        }), hasConsolidated ? "..." : null)));
      }
      return void 0;
    }
  ));
}

// src/modules/delegation/pages/cargos/table/actions/get-zip-codes-by-locations.ts
var getZipCodesByLocations = (cargos) => {
  const zipCodesByLocation = [];
  for (const c of cargos) {
    const location = c.destination.city;
    if (!location) {
      continue;
    }
    const zipCode = c.destination.zipcode;
    if (!zipCode) {
      continue;
    }
    const zipCodesLocations = zipCodesByLocation.map((z) => z.location);
    const isLocationInZipCodesLocations = location ? zipCodesLocations.includes(location) : false;
    if (isLocationInZipCodesLocations) {
      const zipCodeLocations = zipCodesByLocation.find((z) => z.location === location);
      const isZipCodeInZipCodeLocations = zipCode ? zipCodeLocations == null ? void 0 : zipCodeLocations.zipCodes.includes(zipCode) : false;
      if (!isZipCodeInZipCodeLocations) {
        zipCodeLocations == null ? void 0 : zipCodeLocations.zipCodes.push(zipCode);
        zipCodeLocations == null ? void 0 : zipCodeLocations.zipCodes.sort();
      }
    } else {
      zipCodesByLocation.push({
        location: location ? location : "Desconocido",
        zipCodes: [zipCode]
      });
    }
  }
  return zipCodesByLocation;
};

// src/modules/delegation/pages/cargos/table/actions/assign-driver-to-cargos/assign-driver-to-cargos-hook.ts
import { useCallback as useCallback14, useMemo as useMemo14, useState as useState10 } from "react";
import { toast as toast10 } from "sonner";

// src/modules/delegation/pages/cargos/table/actions/get-cargos-count-summary.ts
var getCargosCountSummary = (cargoItems) => {
  const hasConsolidated = cargoItems.some((cargo) => cargo.isConsolidation);
  let parentCount = 0;
  let childrenCount = 0;
  cargoItems.forEach((cargo) => {
    parentCount++;
    if (cargo.isConsolidation) {
      childrenCount += cargo.numberOfCargos;
    } else {
      childrenCount++;
    }
  });
  const isSingle = parentCount === 1 && childrenCount === 1;
  return {
    hasConsolidated,
    parentCount,
    childrenCount,
    isSingle
  };
};

// src/modules/delegation/pages/cargos/table/actions/assign-driver-to-cargos/assign-driver-to-cargos-api.ts
function assignDriverToCargosApi(_0) {
  return __async(this, arguments, function* ({
    cargoItems,
    driverId,
    config
  }) {
    const endpoint = `${config.apiBase}/v1/fleet/routes/assign_next/`;
    const body = {
      cargo_ids: cargoItems.map((cargo) => cargo.id),
      driver_id: driverId
    };
    return fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${config.token}`
      },
      body: JSON.stringify(body)
    });
  });
}

// src/modules/delegation/pages/cargos/table/actions/assign-driver-to-cargos/assign-driver-to-cargos-hook.ts
function useAssignDriverToCargosHook({
  cargoItems,
  ok,
  cancel,
  config,
  list
}) {
  const [loading, setLoading] = useState10(false);
  const [selectedDriverId, setSelectedDriverId] = useState10(void 0);
  const canSubmit = selectedDriverId !== void 0 && !loading;
  const cargosCountSummary = useMemo14(() => getCargosCountSummary(cargoItems), [cargoItems]);
  const hasConsolidated = cargosCountSummary.hasConsolidated;
  const headerText = useMemo14(() => {
    if (cargosCountSummary.isSingle) {
      return `Paquete seleccionado: ${cargoItems[0].externalId}`;
    }
    if (cargosCountSummary.hasConsolidated) {
      if (cargosCountSummary.parentCount === 1)
        return `${cargosCountSummary.parentCount} paquete seleccionado (${cargosCountSummary.childrenCount} en total)`;
      return `${cargosCountSummary.parentCount} paquetes seleccionados (${cargosCountSummary.childrenCount} en total)`;
    }
    return `${cargosCountSummary.parentCount} paquetes seleccionados`;
  }, [cargoItems, cargosCountSummary]);
  const onGoback = useCallback14(() => {
    if (loading)
      return;
    cancel && cancel();
  }, [cancel, loading]);
  const onConfirm = useCallback14(() => __async(this, null, function* () {
    const successMessage = cargosCountSummary.isSingle ? "Paquete asignado con \xE9xito" : "Paquetes asignados con \xE9xito";
    const errorMessage = cargosCountSummary.isSingle ? "Error al asignar el paquete" : "Error al asignar los paquetes";
    if (selectedDriverId === void 0)
      return;
    setLoading(true);
    try {
      const response = yield assignDriverToCargosApi({
        cargoItems,
        driverId: selectedDriverId,
        config
      });
      if (!response.ok)
        throw new Error("Bad response");
      yield list.data.mutate();
      if (list.select.selectedCargosCount > 0) {
        list.select.unSelectAllCargos();
      }
      setLoading(false);
      toast10.success(successMessage);
      ok && ok();
    } catch (error) {
      toast10.error(errorMessage);
      setLoading(false);
    }
  }), [
    cargoItems,
    cargosCountSummary.isSingle,
    config,
    list.data,
    list.select,
    ok,
    selectedDriverId
  ]);
  const hookResult = {
    loading,
    selectedDriverId,
    setSelectedDriverId,
    canSubmit,
    onGoback,
    onConfirm,
    headerText,
    hasConsolidated
  };
  return hookResult;
}

// src/modules/delegation/pages/cargos/table/actions/assign-driver-to-cargos/assign-driver-to-cargos-input-component.tsx
import React28 from "react";
import { Input as Input9 } from "@ontruck/fe-ui";

// src/modules/delegation/get-drivers/get-drivers-hook.ts
import useSWR14 from "swr";

// src/modules/delegation/get-drivers/get-drivers-from-api.ts
var getDriversFromApi = (_0) => __async(void 0, [_0], function* ({
  config
}) {
  const endpoint = `${config.apiBase}/api/drivers?page_size=0`;
  const response = yield fetch(endpoint, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${config.token}`
    }
  });
  const data = yield fetchJson(response);
  return data;
});

// src/modules/delegation/get-drivers/get-drivers-from-api-fetcher.ts
var getDriversFromApiFetcher = (config) => {
  return getDriversFromApi({ config });
};

// src/modules/delegation/get-drivers/get-drivers-hook.ts
var getDriversMapped = (data) => {
  if (!data) {
    return;
  }
  return data.map((driver) => ({
    id: driver.id,
    contactName: driver.contact_name
  }));
};
var useGetDriversHook = ({ config }) => {
  const fetcher = () => __async(void 0, null, function* () {
    return getDriversFromApiFetcher(config);
  });
  const driversKey = "drivers";
  const { data, error, isLoading } = useSWR14(driversKey, fetcher);
  const driversMapped = getDriversMapped(data);
  return {
    drivers: driversMapped || [],
    count: (driversMapped == null ? void 0 : driversMapped.length) || 0,
    isLoading,
    error
  };
};

// src/modules/delegation/pages/cargos/table/actions/assign-driver-to-cargos/assign-driver-to-cargos-input-component.tsx
function AssignDriverToCargosInputComponent({
  config,
  value,
  handleChangeValue
}) {
  const { drivers } = useGetDriversHook({ config });
  const driverOptions = drivers.map((driver) => ({
    label: driver.contactName,
    value: driver.id,
    searchValue: driver.contactName
  }));
  return /* @__PURE__ */ React28.createElement(
    Input9,
    {
      handleChangeValue,
      isClearable: true,
      label: "Fleet manager o conductor",
      name: "driver",
      options: driverOptions,
      type: "select-with-internal-search",
      value,
      width: "100%"
    }
  );
}

// src/modules/delegation/pages/cargos/table/actions/assign-driver-to-cargos/assign-driver-to-cargos-modal.tsx
var AssignDriverToCargosModalBodyContainerComponent = styled10.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`;
var AssignDriverToCargosModalBodyRegularText = styled10.div`
  align-self: stretch;
  color: var(--grey700);
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;
function AssignDriverToCargosModal({
  cargoItems,
  ok,
  cancel,
  config,
  list
}) {
  const {
    canSubmit,
    loading,
    onConfirm,
    selectedDriverId,
    onGoback,
    setSelectedDriverId,
    headerText,
    hasConsolidated
  } = useAssignDriverToCargosHook({
    cargoItems,
    ok,
    cancel,
    config,
    list
  });
  const handleChangeValue = (name, value) => {
    setSelectedDriverId(value);
  };
  const zipCodesByLocations = useMemo15(() => getZipCodesByLocations(cargoItems), [cargoItems]);
  return /* @__PURE__ */ React29.createElement(
    ModalComponent,
    {
      bodyComponent: /* @__PURE__ */ React29.createElement(AssignDriverToCargosModalBodyContainerComponent, null, /* @__PURE__ */ React29.createElement(AssignDriverToCargosModalBodyRegularText, null, "Asignar a:"), /* @__PURE__ */ React29.createElement(
        AssignDriverToCargosInputComponent,
        {
          config,
          handleChangeValue,
          value: selectedDriverId
        }
      ), /* @__PURE__ */ React29.createElement(
        ActionsZipCodesByLocationsSummaryComponent,
        {
          hasConsolidated,
          zipCodesByLocations
        }
      )),
      cancelButtonLabel: "Cancelar",
      confirmButtonIsLoadingLabel: "Asignando...",
      confirmButtonLabel: "Asignar",
      description: headerText,
      isCancelDisabled: loading,
      isConfirmDisabled: !canSubmit,
      isConfirmLoading: loading,
      onCancel: onGoback,
      onClose: onGoback,
      onConfirm,
      title: "Asignar conductor"
    }
  );
}

// src/modules/delegation/pages/cargos/table/actions/deconsolidate-cargo/deconsolidate-cargo-modal.tsx
import React30, { useMemo as useMemo17 } from "react";
import { ModalComponent as ModalComponent2 } from "@ontruck/fe-ui";

// src/modules/delegation/pages/cargos/table/actions/deconsolidate-cargo/deconsolidate-cargo-hook.ts
import { useMemo as useMemo16, useState as useState11 } from "react";
import { toast as toast11 } from "sonner";

// src/modules/delegation/pages/cargos/table/actions/deconsolidate-cargo/deconsolidate-cargo-api.ts
function deconsolidateCargoApi(_0) {
  return __async(this, arguments, function* ({
    apiBase,
    apiToken,
    cargoId
  }) {
    const endpoint = `${apiBase}/v1/fleet/cargos/${cargoId}/deconsolidate/`;
    return fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${apiToken}`
      }
    });
  });
}

// src/modules/delegation/pages/cargos/table/actions/deconsolidate-cargo/deconsolidate-cargo-hook.ts
function useDeconsolidateCargoHook({
  apiBase,
  apiToken,
  cargoItem,
  onSuccess,
  onError
}) {
  const [loading, setLoading] = useState11(false);
  const cancel = () => {
    if (loading) {
      setLoading(false);
    }
  };
  const cargosCountSummary = useMemo16(() => getCargosCountSummary([cargoItem]), [cargoItem]);
  const hasConsolidated = cargosCountSummary.hasConsolidated;
  const headerText = useMemo16(() => {
    return `Paquete seleccionado: ${cargoItem.externalId} (${cargosCountSummary.childrenCount} en total)`;
  }, [cargoItem.externalId, cargosCountSummary.childrenCount]);
  const onConfirm = () => __async(this, null, function* () {
    setLoading(true);
    const cargoId = cargoItem.id;
    try {
      const response = yield deconsolidateCargoApi({
        apiBase,
        apiToken,
        cargoId
      });
      if (!response.ok) {
        throw new Error("Bad response");
      }
      if (onSuccess) {
        onSuccess();
      }
      setLoading(false);
      const successMessage = "Paquete desconsolidado con \xE9xito";
      toast11.success(successMessage);
    } catch (error) {
      if (onError) {
        onError(error);
      }
      const errorMessage = "Error al desconsolidar el paquete";
      toast11.error(errorMessage);
      setLoading(false);
    }
  });
  return {
    loading,
    cancel,
    onConfirm,
    headerText,
    hasConsolidated
  };
}

// src/modules/delegation/pages/cargos/table/actions/deconsolidate-cargo/deconsolidate-cargo-modal.tsx
function DeconsolidateCargoModal({
  apiBase,
  apiToken,
  cargoItem,
  onClose,
  onSuccess,
  onError
}) {
  const onDeconsolidateCargoSuccess = () => {
    if (onSuccess) {
      onSuccess();
    }
  };
  const onDeconsolidateCargoError = () => {
    if (onError) {
      onError();
    }
  };
  const { loading, onConfirm, headerText, hasConsolidated } = useDeconsolidateCargoHook({
    apiBase,
    apiToken,
    cargoItem,
    onSuccess: onDeconsolidateCargoSuccess,
    onError: onDeconsolidateCargoError
  });
  const handleCloseDeconsolidateCargoModal = () => {
    if (onClose) {
      onClose();
    }
  };
  const handleConfirmDeconsolidateCargo = () => {
    void onConfirm();
  };
  const zipCodesByLocations = useMemo17(() => getZipCodesByLocations([cargoItem]), [cargoItem]);
  return /* @__PURE__ */ React30.createElement(
    ModalComponent2,
    {
      bodyComponent: /* @__PURE__ */ React30.createElement(
        ActionsZipCodesByLocationsSummaryComponent,
        {
          hasConsolidated,
          zipCodesByLocations
        }
      ),
      cancelButtonLabel: "Cancelar",
      confirmButtonIsLoadingLabel: "Desconsolidando...",
      confirmButtonLabel: "Desconsolidar",
      description: headerText,
      isCancelDisabled: loading,
      isConfirmDisabled: loading,
      isConfirmLoading: loading,
      onCancel: handleCloseDeconsolidateCargoModal,
      onClose: handleCloseDeconsolidateCargoModal,
      onConfirm: handleConfirmDeconsolidateCargo,
      title: "Desconsolidar paquete"
    }
  );
}

// src/modules/delegation/pages/cargos/table/actions/mark-cargo-as-collected/mark-cargo-as-collected-modal.tsx
import React31, { useMemo as useMemo19 } from "react";
import { ModalComponent as ModalComponent3 } from "@ontruck/fe-ui";

// src/modules/delegation/pages/cargos/table/actions/mark-cargo-as-collected/mark-cargo-as-collected-hook.ts
import { useMemo as useMemo18, useState as useState12 } from "react";
import { toast as toast12 } from "sonner";

// src/modules/delegation/pages/cargos/table/actions/mark-cargo-as-collected/mark-cargo-as-collected-api.ts
function markCargoAsCollectedApi(_0) {
  return __async(this, arguments, function* ({
    apiBase,
    apiToken,
    cargoId
  }) {
    const endpoint = `${apiBase}/v1/fleet/cargos/${cargoId}/collect/`;
    return fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${apiToken}`
      }
    });
  });
}

// src/modules/delegation/pages/cargos/table/actions/mark-cargo-as-collected/mark-cargo-as-collected-hook.ts
function useMarkCargoAsCollectedHook({
  apiBase,
  apiToken,
  cargoItem,
  onSuccess,
  onError
}) {
  const [loading, setLoading] = useState12(false);
  const cancel = () => {
    if (loading) {
      setLoading(false);
    }
  };
  const cargosCountSummary = useMemo18(() => getCargosCountSummary([cargoItem]), [cargoItem]);
  const hasConsolidated = cargosCountSummary.hasConsolidated;
  const headerText = useMemo18(() => {
    if (cargosCountSummary.hasConsolidated) {
      return `${cargosCountSummary.parentCount} paquete seleccionado (${cargosCountSummary.childrenCount} en total)`;
    }
    return `Paquete seleccionado: ${cargoItem.externalId}`;
  }, [
    cargoItem.externalId,
    cargosCountSummary.childrenCount,
    cargosCountSummary.hasConsolidated,
    cargosCountSummary.parentCount
  ]);
  const onConfirm = () => __async(this, null, function* () {
    setLoading(true);
    const cargoId = cargoItem.id;
    try {
      const response = yield markCargoAsCollectedApi({
        apiBase,
        apiToken,
        cargoId
      });
      if (!response.ok) {
        throw new Error("Bad response");
      }
      if (onSuccess) {
        onSuccess();
      }
      setLoading(false);
      const successMessage = "Paquete marcado como recogido con \xE9xito";
      toast12.success(successMessage);
    } catch (error) {
      if (onError) {
        onError(error);
      }
      const errorMessage = "Error al marcar como recogido el paquete";
      toast12.error(errorMessage);
      setLoading(false);
    }
  });
  return {
    loading,
    cancel,
    onConfirm,
    headerText,
    hasConsolidated
  };
}

// src/modules/delegation/pages/cargos/table/actions/mark-cargo-as-collected/mark-cargo-as-collected-modal.tsx
function MarkCargoAsCollectedModal({
  apiBase,
  apiToken,
  cargoItem,
  onClose,
  onSuccess,
  onError
}) {
  const onMarkCargoAsCollectedSuccess = () => {
    if (onSuccess) {
      onSuccess();
    }
  };
  const onMarkCargoAsCollectedError = () => {
    if (onError) {
      onError();
    }
  };
  const { loading, onConfirm, headerText, hasConsolidated } = useMarkCargoAsCollectedHook({
    apiBase,
    apiToken,
    cargoItem,
    onSuccess: onMarkCargoAsCollectedSuccess,
    onError: onMarkCargoAsCollectedError
  });
  const handleCloseMarkCargoAsCollectedModal = () => {
    if (onClose) {
      onClose();
    }
  };
  const handleConfirmMarkCargoAsCollected = () => {
    void onConfirm();
  };
  const zipCodesByLocations = useMemo19(() => getZipCodesByLocations([cargoItem]), [cargoItem]);
  return /* @__PURE__ */ React31.createElement(
    ModalComponent3,
    {
      bodyComponent: /* @__PURE__ */ React31.createElement(
        ActionsZipCodesByLocationsSummaryComponent,
        {
          hasConsolidated,
          zipCodesByLocations
        }
      ),
      cancelButtonLabel: "Cancelar",
      confirmButtonIsLoadingLabel: "Marcando como recogido...",
      confirmButtonLabel: "Marcar como recogido",
      description: headerText,
      isCancelDisabled: loading,
      isConfirmDisabled: loading,
      isConfirmLoading: loading,
      onCancel: handleCloseMarkCargoAsCollectedModal,
      onClose: handleCloseMarkCargoAsCollectedModal,
      onConfirm: handleConfirmMarkCargoAsCollected,
      title: "Marcar paquete como recogido"
    }
  );
}

// src/modules/delegation/pages/cargos/table/actions/unassign-driver-to-cargo/unassign-driver-to-cargos-modal.tsx
import React33, { useMemo as useMemo21 } from "react";
import { ModalComponent as ModalComponent4 } from "@ontruck/fe-ui";

// src/modules/delegation/pages/cargos/table/actions/actions-current-driver-component.tsx
import React32 from "react";
import styled11 from "styled-components";
import { IconComponent } from "@ontruck/fe-icons";
import { TextComponent as TextComponent7 } from "@ontruck/fe-ui";
var SectionComponent2 = styled11.section`
  width: 100%;
  gap: 8px;
  display: flex;
  flex-direction: column;
`;
var WrapperComponent2 = styled11.div`
  display: flex;
  height: 40px;
  padding: 0px 8px;
  justify-content: start;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  background: var(--grey-200, #e2e8ee);
`;
function ActionsCurrentDriverComponent({
  currentDrivers
}) {
  const currentDriversText = currentDrivers.map((currentDriver) => currentDriver.contactName).join(", ");
  return /* @__PURE__ */ React32.createElement(SectionComponent2, null, /* @__PURE__ */ React32.createElement(TextComponent7, null, "Desasignar de:"), /* @__PURE__ */ React32.createElement(WrapperComponent2, null, /* @__PURE__ */ React32.createElement(IconComponent, { colorVariant: "primary", name: "unassign", sizeInPixels: 24 }), /* @__PURE__ */ React32.createElement(TextComponent7, null, /* @__PURE__ */ React32.createElement("strong", null, currentDriversText))));
}

// src/modules/delegation/pages/cargos/table/actions/get-drivers-from-cargos.ts
var getDriversFromCargos = (cargos) => {
  const cargosWithDriver = cargos.filter(
    (c) => c.driver !== null
  );
  const drivers = cargosWithDriver.map((c) => c.driver);
  const uniqueDriverIds = /* @__PURE__ */ new Set();
  const driversWithoutDuplicates = drivers.reduce((uniqueDrivers, driver) => {
    if (!uniqueDriverIds.has(driver.id)) {
      uniqueDriverIds.add(driver.id);
      uniqueDrivers.push(driver);
    }
    return uniqueDrivers;
  }, []);
  return driversWithoutDuplicates;
};

// src/modules/delegation/pages/cargos/table/actions/unassign-driver-to-cargo/unassign-driver-to-cargos-hook.ts
import { useMemo as useMemo20, useState as useState13 } from "react";
import { toast as toast13 } from "sonner";

// src/modules/delegation/pages/cargos/table/actions/unassign-driver-to-cargo/unassign-driver-to-cargos-api.ts
function unassignDriverToCargosApi(_0) {
  return __async(this, arguments, function* ({
    apiBase,
    apiToken,
    cargoIds
  }) {
    const endpoint = `${apiBase}/v1/fleet/cargos/declare_addresses/`;
    const cargoIdAddressIds = {};
    cargoIds.forEach((cargoId) => {
      cargoIdAddressIds[cargoId] = null;
    });
    const body = {
      cargo_id_address_ids: cargoIdAddressIds
    };
    return fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${apiToken}`
      },
      body: JSON.stringify(body)
    });
  });
}

// src/modules/delegation/pages/cargos/table/actions/unassign-driver-to-cargo/unassign-driver-to-cargos-hook.ts
function useUnassignDriverToCargoHook({
  apiBase,
  apiToken,
  cargoItems,
  onSuccess,
  onError
}) {
  const [loading, setLoading] = useState13(false);
  const cargosCountSummary = useMemo20(() => getCargosCountSummary(cargoItems), [cargoItems]);
  const hasConsolidated = cargosCountSummary.hasConsolidated;
  const headerText = useMemo20(() => {
    if (cargosCountSummary.isSingle) {
      return `Paquete seleccionado: ${cargoItems[0].externalId}`;
    }
    if (cargosCountSummary.hasConsolidated) {
      if (cargosCountSummary.parentCount === 1)
        return `${cargosCountSummary.parentCount} paquete seleccionado (${cargosCountSummary.childrenCount} en total)`;
      return `${cargosCountSummary.parentCount} paquetes seleccionados (${cargosCountSummary.childrenCount} en total)`;
    }
    return `${cargosCountSummary.parentCount} paquetes seleccionados`;
  }, [cargoItems, cargosCountSummary]);
  const cancel = () => {
    if (loading) {
      setLoading(false);
    }
  };
  const onConfirm = () => __async(this, null, function* () {
    setLoading(true);
    const cargoIds = cargoItems.map((cargo) => cargo.id);
    try {
      const response = yield unassignDriverToCargosApi({
        apiBase,
        apiToken,
        cargoIds
      });
      if (!response.ok) {
        throw new Error("Bad response");
      }
      if (onSuccess) {
        onSuccess();
      }
      setLoading(false);
      const successMessage = cargosCountSummary.isSingle ? "Paquete desasignado con \xE9xito" : "Paquetes desasignados con \xE9xito";
      toast13.success(successMessage);
    } catch (error) {
      if (onError) {
        onError(error);
      }
      const errorMessage = cargosCountSummary.isSingle ? "Error al desasignar el paquete" : "Error al desasignar los paquetes";
      toast13.error(errorMessage);
      setLoading(false);
    }
  });
  return {
    loading,
    cancel,
    onConfirm,
    headerText,
    hasConsolidated
  };
}

// src/modules/delegation/pages/cargos/table/actions/unassign-driver-to-cargo/unassign-driver-to-cargos-modal.tsx
function UnassignDriverToCargoModal({
  apiBase,
  apiToken,
  cargoItems,
  onClose,
  onSuccess,
  onError
}) {
  const onUnassignCargosToDriverSuccess = () => {
    if (onSuccess) {
      onSuccess();
    }
  };
  const onUnassignCargosToDriverError = () => {
    if (onError) {
      onError();
    }
  };
  const { loading, onConfirm, headerText, hasConsolidated } = useUnassignDriverToCargoHook({
    apiBase,
    apiToken,
    cargoItems,
    onSuccess: onUnassignCargosToDriverSuccess,
    onError: onUnassignCargosToDriverError
  });
  const handleCloseUnassignCargoToDriverModal = () => {
    if (onClose) {
      onClose();
    }
  };
  const handleConfirmUnassignCargoToDriver = () => {
    void onConfirm();
  };
  const zipCodesByLocations = useMemo21(() => getZipCodesByLocations(cargoItems), [cargoItems]);
  const currentDrivers = useMemo21(() => getDriversFromCargos(cargoItems), [cargoItems]);
  return /* @__PURE__ */ React33.createElement(
    ModalComponent4,
    {
      bodyComponent: /* @__PURE__ */ React33.createElement(React33.Fragment, null, /* @__PURE__ */ React33.createElement(ActionsCurrentDriverComponent, { currentDrivers }), /* @__PURE__ */ React33.createElement(
        ActionsZipCodesByLocationsSummaryComponent,
        {
          hasConsolidated,
          zipCodesByLocations
        }
      )),
      cancelButtonLabel: "Cancelar",
      confirmButtonIsLoadingLabel: "Desasignando...",
      confirmButtonLabel: "Desasignar",
      description: headerText,
      isCancelDisabled: loading,
      isConfirmDisabled: loading,
      isConfirmLoading: loading,
      onCancel: handleCloseUnassignCargoToDriverModal,
      onClose: handleCloseUnassignCargoToDriverModal,
      onConfirm: handleConfirmUnassignCargoToDriver,
      title: "Desasignar conductor"
    }
  );
}

// src/modules/delegation/pages/cargos/table/actions-hook.tsx
var useActionsHook = ({ config }) => {
  const consolidate = () => {
    console.log("Consolidatinggggggggggggggggg");
  };
  const markCargoAsCollected = (_0) => __async(void 0, [_0], function* ({
    cargoItem,
    list
  }) {
    const handleCloseMarkCargoAsCollectedModal = () => {
      void destroy();
    };
    const handleMarkCargoAsCollectedSuccess = () => {
      void destroy().then(() => __async(void 0, null, function* () {
        yield list.data.mutate();
        if (list.select.selectedCargosCount > 0) {
          list.select.unSelectAllCargos();
        }
      }));
    };
    const { show, destroy } = yield Modal.new({
      content: /* @__PURE__ */ React34.createElement(
        MarkCargoAsCollectedModal,
        {
          apiBase: config.apiBase,
          apiToken: config.token,
          cargoItem,
          onClose: handleCloseMarkCargoAsCollectedModal,
          onSuccess: handleMarkCargoAsCollectedSuccess
        }
      ),
      footer: null
    });
    yield show();
  });
  const deconsolidateCargo = (_0) => __async(void 0, [_0], function* ({
    cargoItem,
    list
  }) {
    const handleCloseDeconsolidateCargoModal = () => {
      void destroy();
    };
    const handleDeconsolidateCargoSuccess = () => {
      void destroy().then(() => __async(void 0, null, function* () {
        yield list.data.mutate();
        if (list.select.selectedCargosCount > 0) {
          list.select.unSelectAllCargos();
        }
      }));
    };
    const { show, destroy } = yield Modal.new({
      content: /* @__PURE__ */ React34.createElement(
        DeconsolidateCargoModal,
        {
          apiBase: config.apiBase,
          apiToken: config.token,
          cargoItem,
          onClose: handleCloseDeconsolidateCargoModal,
          onSuccess: handleDeconsolidateCargoSuccess
        }
      ),
      footer: null
    });
    yield show();
  });
  const unassignDriverToCargos = (_0) => __async(void 0, [_0], function* ({
    cargoItems,
    list
  }) {
    const handleCloseUnassignDriverToCargoModal = () => {
      void destroy();
    };
    const handleUnassignDriverToCargoSuccess = () => {
      void destroy().then(() => __async(void 0, null, function* () {
        yield list.data.mutate();
        if (list.select.selectedCargosCount > 0) {
          list.select.unSelectAllCargos();
        }
      }));
    };
    const { show, destroy } = yield Modal.new({
      content: /* @__PURE__ */ React34.createElement(
        UnassignDriverToCargoModal,
        {
          apiBase: config.apiBase,
          apiToken: config.token,
          cargoItems,
          onClose: handleCloseUnassignDriverToCargoModal,
          onSuccess: handleUnassignDriverToCargoSuccess
        }
      ),
      footer: null
    });
    yield show();
  });
  const assignDriverToCargos = (_0) => __async(void 0, [_0], function* ({
    cargoItems,
    list
  }) {
    const { show } = yield Modal.new({
      content: /* @__PURE__ */ React34.createElement(AssignDriverToCargosModal, { cargoItems, config, list }),
      footer: null
    });
    yield show();
  });
  return {
    assignDriverToCargos,
    consolidate,
    markCargoAsCollected,
    deconsolidateCargo,
    unassignDriverToCargos
  };
};

// src/modules/delegation/pages/cargos/table/select-cargos-hook.ts
import { useEffect as useEffect4, useState as useState14 } from "react";
var useSelectCargosHook = ({
  cargoItems,
  selectedFilters
}) => {
  const [selectedCargos, setSelectedCargos] = useState14([]);
  const selectCargo = (item) => {
    const newSelectedItems = [...selectedCargos, item];
    setSelectedCargos(Array.from(new Set(newSelectedItems)));
  };
  const unSelectCargo = (item) => {
    setSelectedCargos(selectedCargos.filter((cargo) => cargo.id !== item.id));
  };
  const selectAllCargos = () => {
    if (cargoItems === void 0)
      return;
    setSelectedCargos([...cargoItems]);
  };
  const unSelectAllCargos = () => {
    setSelectedCargos([]);
  };
  const selectedCargosCount = selectedCargos.length;
  useEffect4(() => {
    setSelectedCargos([]);
  }, [selectedFilters]);
  return {
    selectedCargos,
    selectedCargosCount,
    selectCargo,
    unSelectCargo,
    selectAllCargos,
    unSelectAllCargos
  };
};

// src/modules/delegation/pages/cargos/table/table-hook.ts
var useTableHook = ({
  selectedFilters,
  config
}) => {
  const actions = useActionsHook({ config });
  const data = useGetCargosFilteredHook({ selectedFilters, config });
  const select = useSelectCargosHook({ cargoItems: data.cargos, selectedFilters });
  return {
    actions,
    data,
    select
  };
};

// src/modules/delegation/pages/cargos/table/table-summary-component.tsx
import React36 from "react";
import { TableCellComponent as TableCellComponent6, FlexComponent as FlexComponent7, TextComponent as TextComponent8 } from "@ontruck/fe-ui";

// src/modules/delegation/pages/cargos/table/actions/bulk-actions-component.tsx
import React35 from "react";
import {
  ToolbarButtonComponent as ToolbarButtonComponent14,
  TooltipComponent,
  TooltipBodyComponent,
  TooltipHeaderComponent,
  TooltipUnorderedListComponent
} from "@ontruck/fe-ui";
import { IconComponent as IconComponent2 } from "@ontruck/fe-icons";

// src/modules/delegation/pages/cargos/cargos.ts
var getAreAllCargoDelegationsTheSame = (delegations) => {
  const delegationIds = Array.from(new Set(delegations.map((delegation) => delegation.id)));
  return delegationIds.length === 1;
};
var cargoEventsTextByEventType = {
  [cargoLatestEventTypes.assigned]: "Asignado",
  [cargoLatestEventTypes.received]: "Recibido",
  [cargoLatestEventTypes.created]: "Creado",
  [cargoLatestEventTypes.collectedForDelivery]: "Recogido para entrega",
  [cargoLatestEventTypes.collectedForTransfer]: "Recogido para transferencia",
  [cargoLatestEventTypes.delivered]: "Entregado",
  [cargoLatestEventTypes.consolidated]: "Consolidado",
  [cargoLatestEventTypes.deconsolidated]: "Desconsolidado",
  [cargoLatestEventTypes.deliveryFailed]: "Fallo en la entrega",
  [cargoLatestEventTypes.deliveryAddressUpdated]: "Direcci\xF3n de entrega actualizada",
  [cargoLatestEventTypes.deliveryInternalUpdated]: "Entrega interna actualizada",
  [cargoLatestEventTypes.incidentReported]: "Incidente",
  [cargoLatestEventTypes.customsCleared]: "Salida de aduanas",
  [cargoLatestEventTypes.cancelled]: "Cancelado"
};
var cargoStatesColorByState = {
  [cargoStateDto.created]: "var(--grey-500, #94A6B8)",
  [cargoStateDto.atOrigin]: "var(--color_05, #214986)",
  [cargoStateDto.inTransfer]: "var(--color_02, #57B1E5)",
  [cargoStateDto.atWarehouse]: "var(--color_04, #1FE4D6)",
  [cargoStateDto.outForDelivery]: "var(--color_02, #57B1E5)",
  [cargoStateDto.delivered]: "var(--color_03, #00B674)",
  [cargoStateDto.cancelled]: "var(--color_01, #D31B1B)",
  [cargoStateDto.customsCleared]: "var(--color_03, #94A6B8)"
};
var cargoStatesTextByState = {
  [cargoStateDto.customsCleared]: "Aduanas",
  [cargoStateDto.created]: "Creado",
  [cargoStateDto.atOrigin]: "En Central",
  [cargoStateDto.inTransfer]: "En transferencia",
  [cargoStateDto.atWarehouse]: "En almac\xE9n",
  [cargoStateDto.outForDelivery]: "En reparto",
  [cargoStateDto.delivered]: "Entregado",
  [cargoStateDto.cancelled]: "Cancelado"
};

// src/modules/delegation/pages/cargos/table/actions/bulk-action-assign-hook.ts
var statesThatCanBeAsssigned = [
  cargoStateDto.customsCleared,
  cargoStateDto.atOrigin,
  cargoStateDto.atWarehouse
];
function useBulkAssign({ list }) {
  const selectedCargos = list.select.selectedCargos;
  const areAllDelegationsTheSame = getAreAllCargoDelegationsTheSame(
    selectedCargos.map((cargo) => cargo.delegation)
  );
  const canAssignSelectedCargos = areAllDelegationsTheSame && selectedCargos.every((cargo) => {
    const canStateBeAssigned = statesThatCanBeAsssigned.includes(
      cargo.state
    );
    const isCargoConsolidated = false;
    const isCargoUnassigned = cargo.driver === null;
    return canStateBeAssigned && isCargoUnassigned && !isCargoConsolidated;
  });
  const isAssignDisabled = selectedCargos.length === 0 || !canAssignSelectedCargos;
  const onBulkAssign = () => {
    if (isAssignDisabled)
      return;
    void list.actions.assignDriverToCargos({
      cargoItems: selectedCargos,
      list
    });
  };
  return {
    isAssignDisabled,
    onBulkAssign
  };
}

// src/modules/delegation/pages/cargos/table/actions/bulk-action-unassign-hook.ts
var statesThatCanBeUnassigned = [
  cargoStateDto.customsCleared,
  cargoStateDto.atOrigin,
  cargoStateDto.atWarehouse,
  cargoStateDto.inTransfer,
  cargoStateDto.outForDelivery
];
function useBulkUnassign({ list }) {
  const selectedCargos = list.select.selectedCargos;
  const canUnassignSelectedCargos = selectedCargos.every((cargo) => {
    const canStateBeUnassigned = statesThatCanBeUnassigned.includes(
      cargo.state
    );
    const isCargoAssigned = cargo.driver !== null;
    const isCargoConsolidated = false;
    return canStateBeUnassigned && isCargoAssigned && !isCargoConsolidated;
  });
  const isUnassignDisabled = selectedCargos.length === 0 || !canUnassignSelectedCargos;
  const onBulkUnassign = () => {
    if (isUnassignDisabled)
      return;
    void list.actions.unassignDriverToCargos({
      cargoItems: selectedCargos,
      list
    });
  };
  return {
    isUnassignDisabled,
    onBulkUnassign
  };
}

// src/modules/delegation/pages/cargos/table/actions/bulk-actions-component.tsx
function BulkActionsComponent({ list }) {
  const { isAssignDisabled, onBulkAssign } = useBulkAssign({ list });
  const { isUnassignDisabled, onBulkUnassign } = useBulkUnassign({ list });
  return /* @__PURE__ */ React35.createElement(React35.Fragment, null, /* @__PURE__ */ React35.createElement(
    TooltipComponent,
    {
      content: /* @__PURE__ */ React35.createElement("div", null, /* @__PURE__ */ React35.createElement(TooltipHeaderComponent, null, "Asignar solo esta disponible para paquetes:"), /* @__PURE__ */ React35.createElement(TooltipBodyComponent, null, /* @__PURE__ */ React35.createElement(TooltipUnorderedListComponent, null, /* @__PURE__ */ React35.createElement("li", null, "Listos para recoger en el mismo lugar"), /* @__PURE__ */ React35.createElement("li", null, "No asignados")))),
      isDisabled: !isAssignDisabled,
      renderOpener: (props) => /* @__PURE__ */ React35.createElement(
        ToolbarButtonComponent14,
        __spreadProps(__spreadValues({}, props), {
          height: "auto",
          isDisabled: isAssignDisabled,
          onClick: onBulkAssign,
          withBorder: true
        }),
        /* @__PURE__ */ React35.createElement(IconComponent2, { colorVariant: "primary", name: "assign", sizeInPixels: 24 }),
        " Asignar"
      )
    }
  ), /* @__PURE__ */ React35.createElement(
    TooltipComponent,
    {
      content: /* @__PURE__ */ React35.createElement("div", null, /* @__PURE__ */ React35.createElement(TooltipHeaderComponent, null, "Desasignar solo esta disponible para paquetes:"), /* @__PURE__ */ React35.createElement(TooltipBodyComponent, null, /* @__PURE__ */ React35.createElement(TooltipUnorderedListComponent, null, /* @__PURE__ */ React35.createElement("li", null, "Ya asignados")))),
      isDisabled: !isUnassignDisabled,
      renderOpener: (props) => /* @__PURE__ */ React35.createElement(
        ToolbarButtonComponent14,
        __spreadProps(__spreadValues({}, props), {
          height: "auto",
          isDisabled: isUnassignDisabled,
          onClick: onBulkUnassign,
          withBorder: true
        }),
        /* @__PURE__ */ React35.createElement(IconComponent2, { color: "#CCD6E0", name: "unassign", sizeInPixels: 24 }),
        " Desasignar"
      )
    }
  ));
}

// src/modules/delegation/pages/cargos/table/table-summary-component.tsx
function TableSummaryComponent({ list }) {
  return /* @__PURE__ */ React36.createElement(FlexComponent7, { alignItems: "center", backgroundColor: "white", height: "40px", width: "100%" }, !list.data.isLoading && !list.data.error && /* @__PURE__ */ React36.createElement(FlexComponent7, { alignItems: "center", justifyContent: "space-between", width: "100%" }, /* @__PURE__ */ React36.createElement(FlexComponent7, null, /* @__PURE__ */ React36.createElement(TableCellComponent6, { borderRight: "1px solid var(--grey-200, #E2E8EE);", padding: "0 16px" }, /* @__PURE__ */ React36.createElement(TextComponent8, { color: "var(--grey-500, #94A6B8)", fontSize: "12px", fontWeight: 500 }, "Total: ", list.data.count, " paquetes")), /* @__PURE__ */ React36.createElement(TableCellComponent6, { padding: "0 16px" }, /* @__PURE__ */ React36.createElement(TextComponent8, { color: "var(--grey-500, #94A6B8)", fontSize: "12px", fontWeight: 500 }, "Seleccionados: ", list.select.selectedCargosCount))), /* @__PURE__ */ React36.createElement(FlexComponent7, null, /* @__PURE__ */ React36.createElement(BulkActionsComponent, { list }))));
}

// src/modules/delegation/pages/cargos/table/rows/row-individual-component.tsx
import React40, { useMemo as useMemo22 } from "react";
import {
  AvatarComponent,
  getAvatarInitialsByUserService,
  getAvatarBackgroundByUserService,
  TableCellComponent as TableCellComponent7,
  FlexComponent as FlexComponent9,
  TextComponent as TextComponent10,
  TooltipComponent as TooltipComponent2,
  TooltipHeaderComponent as TooltipHeaderComponent2
} from "@ontruck/fe-ui";

// src/modules/delegation/pages/cargos/get-cargo-color-by-state-service.ts
var getCargoColorByStateService = (state) => {
  if (state in cargoStatesColorByState) {
    return cargoStatesColorByState[state];
  }
  return "var(--grey-500, #94A6B8)";
};

// src/modules/delegation/pages/cargos/get-state-text-by-state-service.ts
var getCargoStateTextByStateService = (state) => {
  if (state === "all") {
    return "Todos";
  }
  if (state in cargoStatesTextByState) {
    return cargoStatesTextByState[state];
  }
  return state;
};

// src/modules/delegation/pages/cargos/get-cargo-event-text-by-event-type-service.ts
var getCargoEventTextByEventTypeService = (type) => {
  if (type in cargoEventsTextByEventType) {
    return cargoEventsTextByEventType[type];
  }
  return type;
};

// src/shared/utils/get-readable-date.ts
import { format, isToday, isTomorrow } from "date-fns";
import { enUS, es, fr } from "date-fns/locale";
var locales = {
  en: enUS,
  es,
  fr
};
var translations = {
  en: {
    today: "Today",
    tomorrow: "Tomorrow"
  },
  es: {
    today: "Hoy",
    tomorrow: "Ma\xF1ana"
  },
  fr: {
    today: "Aujourd'hui",
    tomorrow: "Demain"
  }
};
var isValidDate = (dateString) => {
  const date = new Date(dateString);
  return !isNaN(date.getTime());
};
var getReadableDate = (dateString, language = "es") => {
  if (!isValidDate(dateString)) {
    return dateString;
  }
  const date = new Date(dateString);
  if (isToday(date)) {
    return `${translations[language].today} ${format(date, "HH:mm")}`;
  }
  if (isTomorrow(date)) {
    return `${translations[language].tomorrow} ${format(date, "HH:mm")}`;
  }
  return format(date, "EEEE d MMMM HH:mm", { locale: locales[language] });
};

// src/modules/delegation/pages/cargos/table/actions/individual-actions-component.tsx
import React38 from "react";
import styled13, { css } from "styled-components";

// src/modules/delegation/components/popover.tsx
import React37, { useRef, useState as useState15, useEffect as useEffect5 } from "react";
import {
  offset,
  shift,
  flip,
  useFloating,
  autoUpdate,
  arrow,
  FloatingArrow
} from "@floating-ui/react";
import styled12 from "styled-components";
var PopoverArrow = styled12(FloatingArrow)`
  fill: var(--white);
  width: 30px;
  height: 30px;
  margin-left: -2px;
`;
function Popover({
  content,
  renderOpener,
  placement,
  isDisabled = false
}) {
  const [isOpen, setIsOpen] = useState15(false);
  const arrowRef = useRef(null);
  const popoverRef = useRef(null);
  const {
    refs: { setReference, setFloating },
    floatingStyles,
    context
  } = useFloating({
    open: isOpen,
    onOpenChange: setIsOpen,
    placement,
    middleware: [
      offset(12),
      flip(),
      shift(),
      arrow({
        element: arrowRef
      })
    ],
    whileElementsMounted: autoUpdate
  });
  const handleOpenerClick = () => {
    setIsOpen((prev) => !prev);
  };
  useEffect5(() => {
    function handleClickOutsideOrScroll(event) {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutsideOrScroll);
      document.addEventListener("scroll", handleClickOutsideOrScroll, true);
    } else {
      document.removeEventListener("mousedown", handleClickOutsideOrScroll);
      document.removeEventListener("scroll", handleClickOutsideOrScroll, true);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutsideOrScroll);
      document.removeEventListener("scroll", handleClickOutsideOrScroll, true);
    };
  }, [isOpen]);
  return /* @__PURE__ */ React37.createElement(React37.Fragment, null, renderOpener({ ref: setReference, onClick: handleOpenerClick }), " ", isOpen && !isDisabled && content ? (
    // the popover content is unstyled
    // we style it where we use it
    // this way we can have different styles for different popovers
    /* @__PURE__ */ React37.createElement(
      "div",
      {
        ref: (node) => {
          setFloating(node);
          popoverRef.current = node;
        },
        style: __spreadProps(__spreadValues({}, floatingStyles), { zIndex: 1e3 })
      },
      /* @__PURE__ */ React37.createElement("div", null, /* @__PURE__ */ React37.createElement(PopoverArrow, { context, height: 8, ref: arrowRef, tipRadius: 2 }), content)
    )
  ) : null);
}

// src/modules/delegation/pages/cargos/table/actions/individual-actions-component.tsx
var ActionsContainerComponent = styled13.div`
  width: 24px;
  height: 100%;
`;
var ActionsShowMenuButtonComponent = styled13.button`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  height: 100%;
  width: 100%;
  cursor: pointer;
  background: var(--grey-200, #e2e8ee);
  border: none;
  &:hover {
    background: var(--grey-300, #d4d4d4);
  }
`;
var ActionsMenuComponent = styled13.div`
  padding: 5px;
  z-index: 100;
  background-color: var(--white);
  display: flex;
  flex-direction: column;
  width: 200px;
  border-radius: 10px;
  border: solid var(--grey100) 1px;
`;
var ActionComponent = styled13.div`
  color: var(--grey800);
  padding: 5px 10px;
  cursor: pointer;

  &:first-of-type {
    border-radius: 5px 5px 0 0;
  }

  &:last-of-type {
    border-radius: 0 0 5px 5px;
  }

  &:hover {
    background-color: var(--grey100);
  }

  & + & {
    border-top: solid var(--grey100) 1px;
  }

  ${(props) => props.enabled !== void 0 && !props.enabled && css`
      cursor: none;
      pointer-events: none;
      background-color: var(--grey100);
      color: var(--grey700);
    `}
`;
function IndividualActionsComponent({
  cargoItem,
  list
}) {
  const canAssignDriver = cargoItem.actions.assign;
  const canUnassignDriver = cargoItem.actions.unassign;
  const canBeMarkedAsCollected = cargoItem.actions.collect;
  const canBeDeconsolidated = cargoItem.actions.deconsolidate;
  return /* @__PURE__ */ React38.createElement(
    Popover,
    {
      content: /* @__PURE__ */ React38.createElement(ActionsMenuComponent, null, /* @__PURE__ */ React38.createElement(
        ActionComponent,
        {
          enabled: canAssignDriver,
          onClick: () => {
            void list.actions.assignDriverToCargos({
              cargoItems: [cargoItem],
              list
            });
          }
        },
        "Asignar conductor"
      ), /* @__PURE__ */ React38.createElement(
        ActionComponent,
        {
          enabled: canUnassignDriver,
          onClick: () => {
            void list.actions.unassignDriverToCargos({
              cargoItems: [cargoItem],
              list
            });
          }
        },
        "Desasignar conductor"
      ), /* @__PURE__ */ React38.createElement(
        ActionComponent,
        {
          enabled: canBeMarkedAsCollected,
          onClick: () => {
            void list.actions.markCargoAsCollected({
              cargoItem,
              list
            });
          }
        },
        "Marcar como recogido"
      ), /* @__PURE__ */ React38.createElement(
        ActionComponent,
        {
          enabled: canBeDeconsolidated,
          onClick: () => {
            void list.actions.deconsolidateCargo({
              cargoItem,
              list
            });
          }
        },
        "Desconsolidar"
      )),
      placement: "left",
      renderOpener: ({ ref, onClick }) => /* @__PURE__ */ React38.createElement(ActionsContainerComponent, null, /* @__PURE__ */ React38.createElement(ActionsShowMenuButtonComponent, { onClick, ref }, /* @__PURE__ */ React38.createElement(
        "svg",
        {
          fill: "none",
          height: "19",
          viewBox: "0 0 18 19",
          width: "18",
          xmlns: "http://www.w3.org/2000/svg"
        },
        /* @__PURE__ */ React38.createElement("g", { clipPath: "url(#clip0_4961_73)" }, /* @__PURE__ */ React38.createElement(
          "path",
          {
            d: "M9 5.375C10.3462 5.375 11.4375 4.28369 11.4375 2.9375C11.4375 1.59131 10.3462 0.5 9 0.5C7.65381 0.5 6.5625 1.59131 6.5625 2.9375C6.5625 4.28369 7.65381 5.375 9 5.375Z",
            fill: "#94A6B8"
          }
        ), /* @__PURE__ */ React38.createElement(
          "path",
          {
            d: "M9 11.9375C10.3462 11.9375 11.4375 10.8462 11.4375 9.5C11.4375 8.15381 10.3462 7.0625 9 7.0625C7.65381 7.0625 6.5625 8.15381 6.5625 9.5C6.5625 10.8462 7.65381 11.9375 9 11.9375Z",
            fill: "#94A6B8"
          }
        ), /* @__PURE__ */ React38.createElement(
          "path",
          {
            d: "M9 18.5C10.3462 18.5 11.4375 17.4087 11.4375 16.0625C11.4375 14.7163 10.3462 13.625 9 13.625C7.65381 13.625 6.5625 14.7163 6.5625 16.0625C6.5625 17.4087 7.65381 18.5 9 18.5Z",
            fill: "#94A6B8"
          }
        )),
        /* @__PURE__ */ React38.createElement("defs", null, /* @__PURE__ */ React38.createElement("clipPath", { id: "clip0_4961_73" }, /* @__PURE__ */ React38.createElement("rect", { fill: "white", height: "18", transform: "translate(0 0.5)", width: "18" })))
      )))
    }
  );
}

// src/modules/delegation/pages/cargos/table/table-columns.ts
var TABLE_COLUMNS4 = {
  consolidatedAccordionState: {
    width: "16px"
  },
  checkbox: {
    width: "45px"
  },
  state: {
    width: "192px"
  },
  item: {
    width: "248px"
  },
  lastReceivedAt: {
    width: "192px"
  },
  destination: {
    width: "192px"
  },
  assignedCarrier: {
    width: "192px"
  },
  lastUpdate: {
    width: "288px"
  },
  actions: {
    width: "192px"
  }
};

// src/modules/delegation/components/labeled-ball-component.tsx
import React39 from "react";
import { FlexComponent as FlexComponent8, BallComponent, TextComponent as TextComponent9 } from "@ontruck/fe-ui";
function LabelledBallComponent({
  ballColor,
  label
}) {
  return /* @__PURE__ */ React39.createElement(FlexComponent8, { alignItems: "center", gap: "var(--otk-theme-space-s)" }, /* @__PURE__ */ React39.createElement(BallComponent, { backgroundColor: ballColor }), /* @__PURE__ */ React39.createElement(TextComponent9, { fontWeight: 500 }, label));
}

// src/modules/delegation/pages/cargos/table/rows/go-to-detail-button-component.tsx
import styled14 from "styled-components";
var GoToDetailButtonComponent = styled14.button`
  background: transparent;
  border: none;
  padding: 0;

  :hover {
    text-decoration: underline;
    text-decoration-color: var(--otk-theme-color-primary-400, #57b1e5);
    cursor: pointer;
  }

  :hover > * {
    color: var(--otk-theme-color-primary-400, #57b1e5);
  }
`;

// src/modules/delegation/pages/cargos/table/rows/row-individual-component.tsx
function RowIndividualComponent({
  cargoItem,
  list,
  onGoToCargoDetail
}) {
  var _a;
  const selectedCargosIds = useMemo22(
    () => list.select.selectedCargos.map((c) => c.id),
    [list.select.selectedCargos]
  );
  const isItemSelected = selectedCargosIds.includes(cargoItem.id);
  const stateText = useMemo22(() => getCargoStateTextByStateService(cargoItem.state), [cargoItem]);
  const stateColor = useMemo22(() => getCargoColorByStateService(cargoItem.state), [cargoItem]);
  const latestEventText = useMemo22(
    () => getCargoEventTextByEventTypeService(cargoItem.lastUpdate.eventType),
    [cargoItem]
  );
  const latestEventUserInitials = useMemo22(
    () => getAvatarInitialsByUserService(cargoItem.lastUpdate.user),
    [cargoItem.lastUpdate.user]
  );
  const latestEventUserBackgroundColor = useMemo22(
    () => getAvatarBackgroundByUserService(cargoItem.lastUpdate.user),
    [cargoItem.lastUpdate.user]
  );
  const latestEventReadableDate = getReadableDate(cargoItem.lastUpdate.date);
  const handleGoToCargoDetail = () => {
    if (onGoToCargoDetail) {
      onGoToCargoDetail(cargoItem.id);
    }
  };
  return /* @__PURE__ */ React40.createElement(FlexComponent9, { alignItems: "center", borderTop: "1px solid var(--grey-200, #E2E8EE)" }, /* @__PURE__ */ React40.createElement(
    TableCellComponent7,
    {
      background: "var(--otk-theme-color-grey-300, #CCD7E0);",
      borderRight: "1px solid var(--otk-theme-color-grey-300, #CCD7E0)",
      justifyContent: "center",
      padding: "unset",
      width: TABLE_COLUMNS4.consolidatedAccordionState.width
    }
  ), /* @__PURE__ */ React40.createElement(
    TableCellComponent7,
    {
      background: "var(--otk-theme-color-grey-100, #F2F5F8);",
      borderRight: "1px solid var(--otk-theme-color-grey-200, #E2E8EE)",
      width: TABLE_COLUMNS4.checkbox.width
    },
    /* @__PURE__ */ React40.createElement(
      "input",
      {
        checked: isItemSelected,
        onChange: () => {
          if (isItemSelected) {
            list.select.unSelectCargo(cargoItem);
          } else {
            list.select.selectCargo(cargoItem);
          }
        },
        type: "checkbox"
      }
    )
  ), /* @__PURE__ */ React40.createElement(
    TableCellComponent7,
    {
      background: "var(--grey-100, #F2F5F8);",
      borderLeft: `4px solid ${stateColor}`,
      width: TABLE_COLUMNS4.state.width
    },
    /* @__PURE__ */ React40.createElement(LabelledBallComponent, { ballColor: stateColor, label: stateText })
  ), /* @__PURE__ */ React40.createElement(
    TableCellComponent7,
    {
      borderLeft: "1px solid var(--grey-200, #E2E8EE)",
      width: TABLE_COLUMNS4.item.width
    },
    /* @__PURE__ */ React40.createElement(GoToDetailButtonComponent, { onClick: handleGoToCargoDetail }, /* @__PURE__ */ React40.createElement(TextComponent10, null, cargoItem.externalId))
  ), /* @__PURE__ */ React40.createElement(
    TableCellComponent7,
    {
      borderLeft: "1px solid var(--grey-200, #E2E8EE)",
      width: TABLE_COLUMNS4.lastReceivedAt.width
    },
    cargoItem.lastReceivedAt ? /* @__PURE__ */ React40.createElement(TextComponent10, { gap: "4px" }, /* @__PURE__ */ React40.createElement("strong", null, cargoItem.lastReceivedAt.city), " ", cargoItem.lastReceivedAt.country, " ", cargoItem.lastReceivedAt.zipcode) : null
  ), /* @__PURE__ */ React40.createElement(
    TableCellComponent7,
    {
      borderLeft: "1px solid var(--grey-200, #E2E8EE)",
      width: TABLE_COLUMNS4.destination.width
    },
    /* @__PURE__ */ React40.createElement(TextComponent10, { gap: "4px" }, /* @__PURE__ */ React40.createElement("strong", null, cargoItem.destination.city), " ", cargoItem.destination.country, " ", cargoItem.destination.zipcode)
  ), /* @__PURE__ */ React40.createElement(
    TableCellComponent7,
    {
      borderLeft: "1px solid var(--grey-200, #E2E8EE)",
      borderRight: "1px solid var(--grey-200, #E2E8EE)",
      width: TABLE_COLUMNS4.assignedCarrier.width
    },
    /* @__PURE__ */ React40.createElement(TextComponent10, null, (_a = cargoItem.driver) == null ? void 0 : _a.contactName)
  ), /* @__PURE__ */ React40.createElement(
    TableCellComponent7,
    {
      background: "var(--grey-100, #F2F5F8);",
      marginLeft: "auto",
      padding: "0",
      width: TABLE_COLUMNS4.lastUpdate.width
    },
    /* @__PURE__ */ React40.createElement(TextComponent10, { alignItems: "start", flexDirection: "column", flexGrow: 1, padding: "5px 16px" }, /* @__PURE__ */ React40.createElement(TextComponent10, { fontWeight: 700 }, latestEventText), /* @__PURE__ */ React40.createElement(TextComponent10, { color: "var(--grey-500, #94A6B8)", fontSize: "12px", fontWeight: 500 }, latestEventReadableDate)),
    /* @__PURE__ */ React40.createElement(
      TooltipComponent2,
      {
        content: /* @__PURE__ */ React40.createElement(TooltipHeaderComponent2, null, cargoItem.lastUpdate.user.firstName, " ", cargoItem.lastUpdate.user.lastName),
        placement: "left",
        renderOpener: (props) => /* @__PURE__ */ React40.createElement("div", __spreadValues({}, props), /* @__PURE__ */ React40.createElement(
          AvatarComponent,
          {
            backgroundColor: latestEventUserBackgroundColor,
            initials: latestEventUserInitials
          }
        ))
      }
    ),
    /* @__PURE__ */ React40.createElement(IndividualActionsComponent, { cargoItem, list })
  ));
}

// src/modules/delegation/pages/cargos/table/rows/row-consolidation-component.tsx
import React43 from "react";
import styled17 from "styled-components";
import {
  AccordionComponent,
  AccordionTriggerComponent,
  AccordionContentComponent
} from "@ontruck/fe-ui";

// src/modules/delegation/pages/cargos/table/rows/row-consolidation-parent-component.tsx
import React41, { useMemo as useMemo23 } from "react";
import styled15 from "styled-components";
import {
  BadgeComponent,
  AccordionIconComponent,
  AvatarComponent as AvatarComponent2,
  getAvatarInitialsByUserService as getAvatarInitialsByUserService2,
  getAvatarBackgroundByUserService as getAvatarBackgroundByUserService2,
  TableCellComponent as TableCellComponent8,
  FlexComponent as FlexComponent10,
  TextComponent as TextComponent11,
  TooltipComponent as TooltipComponent3,
  TooltipHeaderComponent as TooltipHeaderComponent3
} from "@ontruck/fe-ui";
var ROW_CONSOLIDATION_PARENT_MIN_HEIGHT_IN_PIXELS = 45;
var RowConsolidationParentFlexWrapper = styled15(FlexComponent10)`
  background: var(--otk-theme-color-grey-100, #e2e8ee);
  min-height: ${`${ROW_CONSOLIDATION_PARENT_MIN_HEIGHT_IN_PIXELS}px`};

  :first-child {
    border-top: none;
  }
`;
var RowConsolidationParentExternalIdComponent = styled15(
  TableCellComponent8
)`
  :hover {
    cursor: pointer;
  }
`;
function RowConsolidationParentComponent({
  cargo,
  list,
  onClick,
  open = false
}) {
  var _a;
  const { numberOfCargos, filteredNumberOfCargos } = cargo;
  const displayedNumberOfCargos = filteredNumberOfCargos === numberOfCargos ? numberOfCargos : `${filteredNumberOfCargos}/${numberOfCargos}`;
  const selectedCargosIds = useMemo23(
    () => list.select.selectedCargos.map((c) => c.id),
    [list.select.selectedCargos]
  );
  const isItemSelected = selectedCargosIds.includes(cargo.id);
  const stateText = useMemo23(() => getCargoStateTextByStateService(cargo.state), [cargo]);
  const stateColor = useMemo23(() => getCargoColorByStateService(cargo.state), [cargo]);
  const latestEventText = useMemo23(
    () => getCargoEventTextByEventTypeService(cargo.lastUpdate.eventType),
    [cargo]
  );
  const latestEventUserInitials = useMemo23(
    () => getAvatarInitialsByUserService2(cargo.lastUpdate.user),
    [cargo.lastUpdate.user]
  );
  const latestEventUserBackgroundColor = useMemo23(
    () => getAvatarBackgroundByUserService2(cargo.lastUpdate.user),
    [cargo.lastUpdate.user]
  );
  const latestEventReadableDate = getReadableDate(cargo.lastUpdate.date);
  return /* @__PURE__ */ React41.createElement(RowConsolidationParentFlexWrapper, { alignItems: "center" }, /* @__PURE__ */ React41.createElement(
    TableCellComponent8,
    {
      alignItems: "center",
      background: "var(--otk-theme-color-grey-300, #E2E8EE);",
      borderRight: "var(--otk-theme-color-grey-300, #CCD7E0);",
      justifyContent: "center",
      padding: "unset",
      width: TABLE_COLUMNS4.consolidatedAccordionState.width
    },
    /* @__PURE__ */ React41.createElement(AccordionIconComponent, { open })
  ), /* @__PURE__ */ React41.createElement(
    TableCellComponent8,
    {
      background: "var(--otk-theme-color-grey-200, #E2E8EE);",
      borderRight: "var(--otk-theme-color-grey-500, #CCD7E0);",
      width: TABLE_COLUMNS4.checkbox.width
    },
    /* @__PURE__ */ React41.createElement(
      "input",
      {
        checked: isItemSelected,
        onChange: () => {
          if (isItemSelected) {
            list.select.unSelectCargo(cargo);
          } else {
            list.select.selectCargo(cargo);
          }
        },
        type: "checkbox"
      }
    )
  ), /* @__PURE__ */ React41.createElement(
    TableCellComponent8,
    {
      background: "var(--otk-theme-color-grey-200, #E2E8EE);",
      borderLeft: `4px solid ${stateColor}`,
      borderRight: "var(--otk-theme-color-grey-500, #CCD7E0);",
      width: TABLE_COLUMNS4.state.width
    },
    /* @__PURE__ */ React41.createElement(LabelledBallComponent, { ballColor: stateColor, label: stateText })
  ), /* @__PURE__ */ React41.createElement(
    RowConsolidationParentExternalIdComponent,
    {
      background: "var(--otk-theme-color-grey-100, #E2E8EE);",
      borderLeft: "1px solid var(--otk-theme-color-grey-300, #CCD7E0);",
      onClick,
      width: TABLE_COLUMNS4.item.width
    },
    /* @__PURE__ */ React41.createElement(FlexComponent10, { alignItems: "start", justifyContent: "space-between", width: "100%" }, /* @__PURE__ */ React41.createElement(TextComponent11, null, cargo.externalId), /* @__PURE__ */ React41.createElement(BadgeComponent, null, displayedNumberOfCargos))
  ), /* @__PURE__ */ React41.createElement(
    TableCellComponent8,
    {
      background: "var(--otk-theme-color-grey-100, #E2E8EE);",
      borderLeft: "1px solid var(--otk-theme-color-grey-300, #CCD7E0);",
      width: TABLE_COLUMNS4.lastReceivedAt.width
    },
    /* @__PURE__ */ React41.createElement(FlexComponent10, { alignItems: "start", justifyContent: "start", width: "100%" }, cargo.lastReceivedAt ? /* @__PURE__ */ React41.createElement(TextComponent11, { gap: "4px" }, /* @__PURE__ */ React41.createElement("strong", null, cargo.lastReceivedAt.city), " ", cargo.lastReceivedAt.country, " ", cargo.lastReceivedAt.zipcode) : null)
  ), /* @__PURE__ */ React41.createElement(
    TableCellComponent8,
    {
      background: "var(--otk-theme-color-grey-100, #E2E8EE);",
      borderLeft: "1px solid var(--otk-theme-color-grey-300, #CCD7E0);",
      width: TABLE_COLUMNS4.destination.width
    },
    /* @__PURE__ */ React41.createElement(FlexComponent10, { alignItems: "start", justifyContent: "start", width: "100%" }, /* @__PURE__ */ React41.createElement(TextComponent11, { gap: "4px" }, /* @__PURE__ */ React41.createElement("strong", null, cargo.destination.city), " ", cargo.destination.country, " ", cargo.destination.zipcode, " ..."))
  ), /* @__PURE__ */ React41.createElement(
    TableCellComponent8,
    {
      background: "var(--otk-theme-color-grey-100, #E2E8EE);",
      borderLeft: "1px solid var(--otk-theme-color-grey-300, #CCD7E0);",
      borderRight: "1px solid var(--otk-theme-color-grey-300, #CCD7E0);",
      width: TABLE_COLUMNS4.assignedCarrier.width
    },
    /* @__PURE__ */ React41.createElement(TextComponent11, null, (_a = cargo.driver) == null ? void 0 : _a.contactName)
  ), /* @__PURE__ */ React41.createElement(
    TableCellComponent8,
    {
      background: "var(--otk-theme-color-grey-200, #E2E8EE);",
      marginLeft: "auto",
      padding: "0",
      width: TABLE_COLUMNS4.lastUpdate.width
    },
    /* @__PURE__ */ React41.createElement(TextComponent11, { alignItems: "start", flexDirection: "column", flexGrow: 1, padding: "5px 16px" }, /* @__PURE__ */ React41.createElement(TextComponent11, { fontWeight: 700 }, latestEventText), /* @__PURE__ */ React41.createElement(TextComponent11, { color: "var(--grey-500, #94A6B8)", fontSize: "12px", fontWeight: 500 }, latestEventReadableDate)),
    /* @__PURE__ */ React41.createElement(
      TooltipComponent3,
      {
        content: /* @__PURE__ */ React41.createElement(TooltipHeaderComponent3, null, cargo.lastUpdate.user.firstName, " ", cargo.lastUpdate.user.lastName),
        placement: "left",
        renderOpener: (props) => /* @__PURE__ */ React41.createElement("div", __spreadValues({}, props), /* @__PURE__ */ React41.createElement(
          AvatarComponent2,
          {
            backgroundColor: latestEventUserBackgroundColor,
            initials: latestEventUserInitials
          }
        ))
      }
    ),
    /* @__PURE__ */ React41.createElement(IndividualActionsComponent, { cargoItem: cargo, list })
  ));
}

// src/modules/delegation/pages/cargos/table/rows/row-consolidation-child-component.tsx
import React42 from "react";
import styled16 from "styled-components";
import {
  TableCellComponent as TableCellComponent9,
  FlexComponent as FlexComponent11,
  TextComponent as TextComponent12
} from "@ontruck/fe-ui";
var ROW_CONSOLIDATION_CHILD_MIN_HEIGHT_IN_PIXELS = 45;
var RowConsolidationChildTableCellComponent = styled16(
  TableCellComponent9
)`
  height: unset;
  align-items: stretch;
  min-height: ${`${ROW_CONSOLIDATION_CHILD_MIN_HEIGHT_IN_PIXELS}px`};
`;
function RowConsolidationChildComponent({
  cargo,
  onGoToCargoDetail
}) {
  const handleGoToCargoDetail = () => {
    if (onGoToCargoDetail) {
      onGoToCargoDetail(cargo.id);
    }
  };
  return /* @__PURE__ */ React42.createElement(
    FlexComponent11,
    {
      alignItems: "stretch",
      borderTop: "1px solid var(--otk-theme-color-grey-200, #E2E8EE)"
    },
    /* @__PURE__ */ React42.createElement(
      RowConsolidationChildTableCellComponent,
      {
        background: "var(--otk-theme-color-grey-300, #CCD7E0);",
        borderRight: "1px solid var(--otk-theme-color-grey-300, #CCD7E0)",
        justifyContent: "center",
        padding: "unset",
        width: TABLE_COLUMNS4.consolidatedAccordionState.width
      }
    ),
    /* @__PURE__ */ React42.createElement(
      RowConsolidationChildTableCellComponent,
      {
        background: "var(--otk-theme-color-grey-100, #F2F5F8);",
        borderRight: "1px solid var(--otk-theme-color-grey-200, #E2E8EE)",
        width: TABLE_COLUMNS4.checkbox.width
      }
    ),
    /* @__PURE__ */ React42.createElement(
      RowConsolidationChildTableCellComponent,
      {
        background: "var(--otk-theme-color-grey-100, #F2F5F8);",
        borderLeft: "4px solid var(--otk-theme-color-grey-300, #57B1E5)",
        borderRight: "1px solid var(--otk-theme-color-grey-200, #E2E8EE)",
        width: TABLE_COLUMNS4.state.width
      }
    ),
    /* @__PURE__ */ React42.createElement(
      RowConsolidationChildTableCellComponent,
      {
        borderRight: "1px solid var(--otk-theme-color-grey-200, #E2E8EE)",
        width: TABLE_COLUMNS4.item.width
      },
      /* @__PURE__ */ React42.createElement(GoToDetailButtonComponent, { onClick: handleGoToCargoDetail }, /* @__PURE__ */ React42.createElement(TextComponent12, null, cargo.externalId))
    ),
    /* @__PURE__ */ React42.createElement(
      RowConsolidationChildTableCellComponent,
      {
        borderRight: "1px solid var(--otk-theme-color-grey-200, #E2E8EE)",
        width: TABLE_COLUMNS4.lastReceivedAt.width
      }
    ),
    /* @__PURE__ */ React42.createElement(
      RowConsolidationChildTableCellComponent,
      {
        borderRight: "1px solid var(--otk-theme-color-grey-200, #E2E8EE)",
        width: TABLE_COLUMNS4.destination.width
      },
      /* @__PURE__ */ React42.createElement(TextComponent12, { gap: "4px" }, /* @__PURE__ */ React42.createElement("strong", null, cargo.destination.city), " ", cargo.destination.country, " ", cargo.destination.zipcode)
    ),
    /* @__PURE__ */ React42.createElement(
      RowConsolidationChildTableCellComponent,
      {
        borderRight: "1px solid var(--otk-theme-color-grey-200, #E2E8EE)",
        width: TABLE_COLUMNS4.assignedCarrier.width
      }
    ),
    /* @__PURE__ */ React42.createElement(
      RowConsolidationChildTableCellComponent,
      {
        background: "var(--otk-theme-color-grey-100, #F2F5F8);",
        marginLeft: "auto",
        padding: "0",
        width: TABLE_COLUMNS4.lastUpdate.width
      }
    )
  );
}

// src/modules/delegation/pages/cargos/table/rows/row-consolidation-component.tsx
var RowConsolidationWrapperComponent = styled17.div`
  header {
    display: flex;
    padding: unset;
    border-top: none;
    border-bottom: none;

    > div {
      flex: 1;
    }

    :hover {
      cursor: default;
    }
  }
`;
var RowConsolidationParentComponentAccordionTriggerComponent = styled17(AccordionTriggerComponent)`
  padding: unset;
  border-top: 3px solid var(--grey-200, #ccd7e0);
  border-bottom: none;
`;
var RowConsolidationParentComponentAccordionContentComponent = styled17(AccordionContentComponent)`
  padding: unset;
  border-top: none;
  border-bottom: none;

  ${RowConsolidationChildTableCellComponent} {
    display: ${({ open }) => open ? "flex" : "none"};
  }
`;
var RowConsolidationAccordionContentWrapperComponent = styled17.div`
  border-top: ${({ open }) => open ? "3px solid var(--grey-200, #ccd7e0)" : "none"};
  border-bottom: ${({ open }) => open ? "3px solid var(--grey-200, #ccd7e0)" : "none"};
  height: ${({ open }) => open ? "auto" : "0"};
`;
var RowConsolidationAccordionComponent = styled17(AccordionComponent)`
  height: auto;
  border-left: none;
  border-right: none;
`;
function RowConsolidationComponent({
  cargo,
  list,
  open = false,
  onToggleAccordion,
  consolidationCargoChildren,
  onGoToCargoDetail
}) {
  return /* @__PURE__ */ React43.createElement(RowConsolidationWrapperComponent, null, /* @__PURE__ */ React43.createElement(RowConsolidationAccordionComponent, null, /* @__PURE__ */ React43.createElement(RowConsolidationParentComponentAccordionTriggerComponent, { open }, /* @__PURE__ */ React43.createElement(
    RowConsolidationParentComponent,
    {
      cargo,
      list,
      onClick: onToggleAccordion,
      open
    }
  )), /* @__PURE__ */ React43.createElement(RowConsolidationAccordionContentWrapperComponent, { open }, /* @__PURE__ */ React43.createElement(RowConsolidationParentComponentAccordionContentComponent, { open }, consolidationCargoChildren.cargoChildren.map((cargoChild) => /* @__PURE__ */ React43.createElement(
    RowConsolidationChildComponent,
    {
      cargo: cargoChild,
      key: cargoChild.id,
      onGoToCargoDetail
    }
  ))))));
}

// src/modules/delegation/pages/cargos/filters/filters-component.tsx
import React45, { useMemo as useMemo24 } from "react";
import styled18 from "styled-components";
import { Input as Input11, PremiumInputContainer, FlexComponent as FlexComponent12 } from "@ontruck/fe-ui";

// src/modules/delegation/config-hook.ts
import { useContext } from "react";
function useConfigHook() {
  return useContext(ConfigContext);
}

// src/shared/utils/get-date-string-from-javascript-date.ts
var getDateStringFromJavascriptDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

// src/modules/delegation/pages/cargos/filters/driver-no-driver-input-component.tsx
import React44 from "react";
import { Input as Input10 } from "@ontruck/fe-ui";
function DriverNoDriverInputComponent({
  config,
  value,
  handleChangeValue
}) {
  const { drivers } = useGetDriversHook({ config });
  const noDriverOption = {
    label: "** Sin asignar **",
    value: "-1",
    searchValue: "Sin asignar"
  };
  const driverOptions = drivers.map((driver) => ({
    label: driver.contactName,
    value: driver.id,
    searchValue: driver.contactName
  }));
  const driverOptionsWithNoDriverOption = [noDriverOption, ...driverOptions];
  return /* @__PURE__ */ React44.createElement(
    Input10,
    {
      handleChangeValue,
      isClearable: true,
      label: "Fleet manager o conductor",
      name: "driver",
      options: driverOptionsWithNoDriverOption,
      type: "select-with-internal-search",
      value,
      width: "100%"
    }
  );
}

// src/modules/delegation/pages/cargos/filters/filters-component.tsx
var FlexContainerStyled = styled18(FlexComponent12)`
  padding: var(--delegations-cargos-filters-delegation-filter-padding, var(--otk-theme-space-s));
  background-color: var(--otk-theme-color-grey-200, #e2e8ee);
`;
var DateFromInputComponent = styled18(FlexComponent12)`
  ${PremiumInputContainer}:first-child {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
`;
var DateToInputComponent = styled18(FlexComponent12)`
  ${PremiumInputContainer}:first-child {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
`;
var DelegationInputContainerStyled = styled18(FlexComponent12)`
  flex-shrink: 0;
  height: 100%;
`;
var ResponsiveInputsContainerStyled = styled18(FlexComponent12)`
  flex-wrap: wrap;
  padding: 8px;
  min-height: 60px;
  align-items: center;
  background-color: var(--otk-theme-color-white);
  flex-grow: 1;
  gap: 8px;
`;
var FiltersContainerStyled = styled18(FlexComponent12)`
  flex-grow: 1;
  justify-content: 'stretch';
  background-color: 'var(--otk-theme-color-grey-200, #e2e8ee)';
  align-items: center;
`;
function FiltersComponent2({ filters }) {
  const config = useConfigHook();
  const selectedDelegationId = filters.selectedFilters.delegation.id.toString();
  const delegationOptions = filters.filtersOptions.delegations.map((delegation) => ({
    value: delegation.id.toString(),
    label: delegation.name
  }));
  const stateOptions = useMemo24(
    () => filters.filtersOptions.states.map((state) => {
      const option = {
        value: state,
        label: getCargoStateTextByStateService(state),
        component: /* @__PURE__ */ React45.createElement(
          LabelledBallComponent,
          {
            ballColor: getCargoColorByStateService(state),
            label: getCargoStateTextByStateService(state)
          }
        )
      };
      if (state !== "all") {
        option.color = getCargoColorByStateService(state);
      }
      return option;
    }),
    [filters.filtersOptions.states]
  );
  return /* @__PURE__ */ React45.createElement(FiltersContainerStyled, null, /* @__PURE__ */ React45.createElement(DelegationInputContainerStyled, null, /* @__PURE__ */ React45.createElement(FlexContainerStyled, null, /* @__PURE__ */ React45.createElement(
    Input11,
    {
      handleChangeValue: (name, value) => {
        const selectedDelegation = filters.filtersOptions.delegations.find(
          (delegation) => delegation.id.toString() === value
        );
        if (selectedDelegation) {
          filters.setDelegation(selectedDelegation);
        }
      },
      label: "Destino",
      name: "delegation",
      options: delegationOptions,
      type: "select",
      value: selectedDelegationId,
      width: "140px"
    }
  ))), /* @__PURE__ */ React45.createElement(ResponsiveInputsContainerStyled, null, /* @__PURE__ */ React45.createElement(FlexComponent12, { gap: "0" }, /* @__PURE__ */ React45.createElement(DateFromInputComponent, { width: "140px" }, /* @__PURE__ */ React45.createElement(
    Input11,
    {
      handleChangeValue: (name, value) => {
        if (!value) {
          filters.setDateFrom(void 0);
          return;
        }
        const newDate = new Date(value);
        const newDateNormalized = new Date(newDate.setHours(0, 0, 0, 0));
        const newDateFrom = getDateStringFromJavascriptDate(newDateNormalized);
        filters.setDateFrom(newDateFrom);
      },
      label: "Fecha desde",
      name: "date-from",
      type: "date",
      value: filters.selectedFilters.dateFrom
    }
  )), /* @__PURE__ */ React45.createElement(DateToInputComponent, { width: "140px" }, /* @__PURE__ */ React45.createElement(
    Input11,
    {
      handleChangeValue: (name, value) => {
        if (!value) {
          filters.setDateTo(void 0);
          return;
        }
        const newDate = new Date(value);
        const newDateNormalized = new Date(newDate.setHours(23, 59, 59, 999));
        const newDateFrom = getDateStringFromJavascriptDate(newDateNormalized);
        filters.setDateTo(newDateFrom);
      },
      label: "Fecha hasta",
      name: "date-to",
      type: "date",
      value: filters.selectedFilters.dateTo
    }
  ))), /* @__PURE__ */ React45.createElement(
    Input11,
    {
      handleChangeValue: (name, value) => {
        if (value !== void 0)
          filters.setState(value);
      },
      label: "Estado",
      name: "state",
      options: stateOptions,
      type: "select",
      value: filters.selectedFilters.state,
      width: "150px"
    }
  ), /* @__PURE__ */ React45.createElement(
    Input11,
    {
      handleChangeEvent: (e) => {
        const event = e;
        const newValue = event.target.value;
        filters.setZipcode(newValue);
      },
      label: "C\xF3digo postal",
      name: "zipcode",
      type: "text",
      value: filters.selectedFilters.zipcode,
      width: "160px"
    }
  ), /* @__PURE__ */ React45.createElement(FlexComponent12, { width: "220px" }, /* @__PURE__ */ React45.createElement(
    DriverNoDriverInputComponent,
    {
      config,
      handleChangeValue: (name, value) => {
        filters.setDriverId(value);
      },
      value: filters.selectedFilters.driverId
    }
  )), /* @__PURE__ */ React45.createElement(
    Input11,
    {
      handleChangeEvent: (e) => {
        const event = e;
        const newValue = event.target.value;
        filters.setSearch(newValue);
      },
      label: "Buscar",
      name: "search",
      type: "search",
      value: filters.selectedFilters.search,
      width: "280px"
    }
  )));
}

// src/modules/delegation/pages/cargos/get-cargo-is-consolidation-service.ts
function getCargoIsConsolidationService(cargo) {
  return cargo.isConsolidation;
}

// src/modules/delegation/pages/cargos/upload-excel-button.tsx
import React46 from "react";
import styled19 from "styled-components";
import { Toaster as Toaster10, toast as toast14 } from "sonner";
var AttachementLabel = styled19.label`
  color: #fff;
  background-color: #2396dc;
  font-feature-settings:
    'clig' off,
    'liga' off;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px; /* 114.286% */
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 8px 16px;
  border-radius: 4px;
  transition: background-color 0.3s;

  &:hover {
    background-color: #1e7bbf;
  }
`;
var UploadExcelButton = ({ apiBase, token }) => {
  const handleFileChange = (event) => __async(void 0, null, function* () {
    const files = event.target.files;
    if (files && files.length > 0) {
      const formData = new FormData();
      Array.from(files).forEach((file) => {
        formData.append("files", file);
      });
      try {
        const response = yield fetch(`${apiBase}/v1/integrations/upload/`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`
          },
          body: formData
        });
        if (!response.ok) {
          throw new Error("Error uploading file");
        }
        toast14.success("File uploaded successfully");
      } catch (error) {
        toast14.error("Error uploading file");
      }
    }
  });
  const handleFileInputChange = (event) => {
    handleFileChange(event).catch((error) => {
      throw error;
    });
  };
  return /* @__PURE__ */ React46.createElement(React46.Fragment, null, /* @__PURE__ */ React46.createElement(AttachementLabel, { htmlFor: "upload-excel-button" }, /* @__PURE__ */ React46.createElement(
    "input",
    {
      accept: ".xlsx",
      id: "upload-excel-button",
      multiple: true,
      onChange: handleFileInputChange,
      style: { display: "none" },
      type: "file"
    }
  ), "Upload Excel"), /* @__PURE__ */ React46.createElement(Toaster10, { richColors: true }));
};

// src/modules/delegation/pages/cargos/cargos-page.tsx
var CargosPageToolbarComponent = styled20(ToolbarComponent14)`
  padding: 0;
  height: auto;
`;
var CargosPageToolbarContentComponent = styled20(ToolbarContentComponent11)`
  align-items: stretch;
`;
var CargosPageToolbarFiltersComponent = styled20(FlexComponent13)`
  flex-shrink: 1;
  border-left: 1px solid var(--accent-color-gray);
`;
function DelegationCargosPage({
  config,
  onGoToCargoDetail,
  onGoToScanReceive
}) {
  const [openConsolidationCargoId, setOpenConsolidationCargoId] = useState16();
  const [consolidatedCargoId, setConsolidatedCargoId] = useState16();
  const filters = useFiltersHook3({
    delegations: config.delegations
  });
  const list = useTableHook({
    selectedFilters: filters.selectedFilters,
    config
  });
  const consolidationCargoChildren = useGetCargoChildrenHook({
    cargoId: consolidatedCargoId,
    selectedFilters: filters.selectedFilters,
    config
  });
  const isDataReady = !list.data.isLoading && !list.data.error;
  const areAllItemsSelected = isDataReady && list.select.selectedCargosCount === list.data.cargos.length;
  const isChecked = areAllItemsSelected && list.data.cargos.length > 0;
  const columns = useMemo25(
    () => ({
      consolidatedAccordionState: {
        id: "0",
        width: TABLE_COLUMNS4.consolidatedAccordionState.width
      },
      checkbox: {
        id: "1",
        width: TABLE_COLUMNS4.checkbox.width,
        alignment: "center",
        cellComponent: /* @__PURE__ */ React47.createElement(
          "input",
          {
            checked: isChecked,
            onChange: () => {
              if (isChecked) {
                list.select.unSelectAllCargos();
              } else {
                list.select.selectAllCargos();
              }
            },
            type: "checkbox"
          }
        )
      },
      state: {
        id: "2",
        width: TABLE_COLUMNS4.state.width,
        label: "ESTADO"
      },
      item: {
        id: "3",
        width: TABLE_COLUMNS4.item.width,
        label: "PAQUETE"
      },
      lastReceivedAt: {
        id: "4",
        width: TABLE_COLUMNS4.lastReceivedAt.width,
        label: "LOCALIZACI\xD3N"
      },
      destination: {
        id: "5",
        width: TABLE_COLUMNS4.destination.width,
        label: "DESTINO"
      },
      assignedCarrier: {
        id: "6",
        width: TABLE_COLUMNS4.assignedCarrier.width,
        label: "CONDUCTOR ASIGNADO"
      },
      lastUpdate: {
        id: "7",
        width: TABLE_COLUMNS4.lastUpdate.width,
        label: "\xDALTIMA ACTUALIZACI\xD3N",
        group: "right"
      }
    }),
    [isChecked, list.select]
  );
  const isConsolidated = useCallback15((cargo) => {
    return getCargoIsConsolidationService(cargo);
  }, []);
  const isOpen = useCallback15(
    (cargo) => {
      return openConsolidationCargoId === cargo.id;
    },
    [openConsolidationCargoId]
  );
  const handleClickConsolidationCargo = useCallback15(
    (cargoId) => {
      if (openConsolidationCargoId === cargoId) {
        setOpenConsolidationCargoId(void 0);
        return;
      }
      setConsolidatedCargoId(cargoId);
      setOpenConsolidationCargoId(cargoId);
    },
    [openConsolidationCargoId]
  );
  const handleChangePageSize = (pageSize) => {
    filters.setPaginationSize(pageSize);
  };
  const handleGoToPreviousPage = () => {
    if (filters.selectedFilters.page > 1) {
      filters.setPage(filters.selectedFilters.page - 1);
    }
  };
  const handleGoToPage = (pageIndex) => {
    filters.setPage(pageIndex);
  };
  const handleGoToNextPage = () => {
    if (filters.selectedFilters.page < list.data.count) {
      filters.setPage(filters.selectedFilters.page + 1);
    }
  };
  const getCargosRowsComponents = useCallback15(
    (cargos) => {
      return cargos.map((cargoItem) => {
        const cargoIsConsolidated = isConsolidated(cargoItem);
        if (cargoIsConsolidated) {
          return /* @__PURE__ */ React47.createElement(
            RowConsolidationComponent,
            {
              cargo: cargoItem,
              consolidationCargoChildren,
              key: cargoItem.id,
              list,
              onGoToCargoDetail,
              onToggleAccordion: () => {
                handleClickConsolidationCargo(cargoItem.id);
              },
              open: isOpen(cargoItem)
            }
          );
        }
        return /* @__PURE__ */ React47.createElement(
          RowIndividualComponent,
          {
            cargoItem,
            key: cargoItem.id,
            list,
            onGoToCargoDetail
          }
        );
      });
    },
    [
      consolidationCargoChildren,
      handleClickConsolidationCargo,
      isOpen,
      isConsolidated,
      list,
      onGoToCargoDetail
    ]
  );
  const rowComponents = useMemo25(
    () => getCargosRowsComponents(list.data.cargos),
    [list.data.cargos, getCargosRowsComponents]
  );
  return /* @__PURE__ */ React47.createElement(ConfigProvider, { apiBase: config.apiBase, delegations: config.delegations, token: config.token }, /* @__PURE__ */ React47.createElement(PageLayout14, null, /* @__PURE__ */ React47.createElement(CargosPageToolbarComponent, null, /* @__PURE__ */ React47.createElement(CargosPageToolbarContentComponent, null, /* @__PURE__ */ React47.createElement(FiltersComponent2, { filters }), /* @__PURE__ */ React47.createElement(CargosPageToolbarFiltersComponent, null, /* @__PURE__ */ React47.createElement(ToolbarButtonComponent15, null, /* @__PURE__ */ React47.createElement(UploadExcelButton, { apiBase: config.apiBase, token: config.token })), /* @__PURE__ */ React47.createElement(ToolbarButtonComponent15, { onClick: onGoToScanReceive }, /* @__PURE__ */ React47.createElement(QrCodeIcon, null), "Escanear")))), /* @__PURE__ */ React47.createElement(PageContent14, null, /* @__PURE__ */ React47.createElement(
    TableComponent5,
    {
      columns,
      emptyStateMessage: "No se han encontrado paquetes",
      isError: list.data.error !== void 0,
      isLoading: list.data.isLoading,
      numberOfItems: list.data.count,
      onChangePageSize: handleChangePageSize,
      onGoToNextPage: handleGoToNextPage,
      onGoToPage: handleGoToPage,
      onGoToPreviousPage: handleGoToPreviousPage,
      pageIndex: filters.selectedFilters.page,
      pageSize: filters.selectedFilters.paginationSize,
      pageSizes: filters.filtersOptions.paginationSizes,
      rowsComponents: rowComponents,
      scrollCacheKey: "cargos",
      summaryComponent: /* @__PURE__ */ React47.createElement(TableSummaryComponent, { list })
    }
  )), /* @__PURE__ */ React47.createElement(Toaster11, { richColors: true })));
}

// src/modules/delegation/pages/scan/receive/scan-receive-page.tsx
import React52, { useMemo as useMemo27, useCallback as useCallback16 } from "react";
import { PageContent as PageContent15, PageLayout as PageLayout15, TableComponent as TableComponent6 } from "@ontruck/fe-ui";
import { Toaster as Toaster12 } from "sonner";
import { EmptyListScanIcon } from "@ontruck/fe-icons";

// src/modules/delegation/pages/scan/receive/components/scan-receive-toolbar-component.tsx
import React48 from "react";
import {
  ButtonComponent as ButtonComponent6,
  Input as Input12,
  ToolbarComponent as ToolbarComponent15,
  ToolbarButtonComponent as ToolbarButtonComponent16,
  ToolbarContentComponent as ToolbarContentComponent12,
  FlexComponent as FlexComponent14
} from "@ontruck/fe-ui";
import { CloseIcon as CloseIcon11, QrCodeIcon as QrCodeIcon2 } from "@ontruck/fe-icons";
import styled21 from "styled-components";
var ScanReceiveIconToolbarButtonComponent = styled21(ToolbarButtonComponent16)`
  background-color: var(--accent-color-blue);
  height: auto;
  height: 100%;
  cursor: default;
  width: 60px;
  height: 60px;
  justify-content: center;
  align-items: center;
  svg {
    height: 26px;
    width: 26px;
  }
  svg path {
    fill: white;
  }
`;
var CloseIconStyled = styled21(CloseIcon11)`
  width: var(--otk-ui-icon-l-size, 20px);
  height: var(--otk-ui-icon-l-size, 20px);
  path {
    fill: var(--otk-theme-color-primary, #39a0df);
  }

  :hover {
    path {
      fill: var(--otk-theme-color-primary-hover, #2087c6);
    }
  }
`;
var ButtonStyled = styled21(ButtonComponent6)`
  margin: 36px;
  &:hover {
    svg {
      fill: var(--delegations-cargo-detail-header-x-icon-hover-fill);
    }
  }
`;
function ScanReceiveToolbarComponent({
  cargoCode,
  setCargoCode,
  handleKeyDown,
  onGoToCargosList,
  onGoToScanConsolidate
}) {
  const scanTypeOptions = [
    { label: "Recepci\xF3n", value: "receive" },
    { label: "Consolidaci\xF3n", value: "consolidation" }
  ];
  return /* @__PURE__ */ React48.createElement(ToolbarComponent15, { padding: "0px" }, /* @__PURE__ */ React48.createElement(ScanReceiveIconToolbarButtonComponent, null, /* @__PURE__ */ React48.createElement(QrCodeIcon2, null)), /* @__PURE__ */ React48.createElement(ToolbarContentComponent12, null, /* @__PURE__ */ React48.createElement(FlexComponent14, { gap: "8px" }, /* @__PURE__ */ React48.createElement(
    Input12,
    {
      handleChangeValue: (name, value) => {
        if (value === "consolidation") {
          onGoToScanConsolidate();
        }
      },
      label: "Acci\xF3n",
      name: "scan-type",
      options: scanTypeOptions,
      type: "select",
      value: "receive",
      width: "140px"
    }
  ), /* @__PURE__ */ React48.createElement(
    Input12,
    {
      autoFocus: true,
      handleChangeEvent: (e) => {
        const event = e;
        const newValue = event.target.value;
        setCargoCode(newValue);
      },
      icon: /* @__PURE__ */ React48.createElement(QrCodeIcon2, null),
      label: "Escanea un paquete o introduce su c\xF3digo de barras",
      name: "scan-input",
      onKeyDown: handleKeyDown,
      type: "text-with-icon",
      value: cargoCode,
      width: "400px"
    }
  )), /* @__PURE__ */ React48.createElement("div", null, /* @__PURE__ */ React48.createElement(ButtonStyled, { onClick: onGoToCargosList, variant: "icon" }, /* @__PURE__ */ React48.createElement(CloseIconStyled, null)))));
}

// src/modules/delegation/pages/scan/receive/scan-receive-hook.tsx
import { useState as useState17 } from "react";
import { toast as toast15 } from "sonner";

// src/modules/delegation/pages/cargo-detail/get-cargo-detail-mapped-service.ts
function getDeliveryAttempts(events) {
  return events.reduce(
    (acc, event) => event.event_type === cargoLatestEventTypes.deliveryFailed ? acc + 1 : acc,
    0
  );
}
function getCargoDetailMappedService(cargoDetailDto) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  if (!cargoDetailDto) {
    return;
  }
  return {
    id: String(cargoDetailDto.id),
    externalId: String(cargoDetailDto.external_id),
    state: cargoDetailDto.state,
    orderInfo: {
      shipper: ((_a = cargoDetailDto.shipper) == null ? void 0 : _a.company_name) || "",
      serviceType: "Delivery",
      deliveryAttempts: getDeliveryAttempts(cargoDetailDto.events)
    },
    delegation: {
      id: cargoDetailDto.delegation.id
    },
    events: cargoDetailDto.events.sort((a, b) => b.id - a.id).map((event) => ({
      id: event.id,
      date: event.created_at,
      eventType: event.event_type,
      address: {
        id: event.address.id,
        companyName: event.address.company_name,
        addressName: event.address.address_name || ""
      },
      user: {
        id: event.created_by.id,
        username: event.created_by.username,
        firstName: event.created_by.first_name,
        lastName: event.created_by.last_name,
        phone: event.created_by.phone || "",
        type: event.created_by.type || ""
      },
      driver: event.driver !== null ? {
        id: event.driver.id,
        contactName: event.driver.contact_name
      } : null,
      diff: event.diff,
      longitude: event.longitude,
      latitude: event.latitude,
      image: event.image,
      deliveryNotes: event.delivery_notes || "",
      observations: event.observations || "",
      idNumber: event.id_number || "",
      dropOffType: event.dropoff_type || ""
    })),
    deliveryData: {
      finalCustomer: ((_b = cargoDetailDto.destination) == null ? void 0 : _b.contact_name) || "",
      address: {
        addressLine: ((_c = cargoDetailDto.destination) == null ? void 0 : _c.address_line) || "",
        city: ((_d = cargoDetailDto.destination) == null ? void 0 : _d.city) || "",
        zipcode: ((_e = cargoDetailDto.destination) == null ? void 0 : _e.zipcode) || "",
        country: ((_f = cargoDetailDto.destination) == null ? void 0 : _f.country) || ""
      },
      phoneNumber: ((_g = cargoDetailDto.destination) == null ? void 0 : _g.contact_phone) || "",
      additionalAddressInfo: ((_h = cargoDetailDto.destination) == null ? void 0 : _h.address_extra_info) || "",
      email: ((_i = cargoDetailDto.destination) == null ? void 0 : _i.contact_email) || ""
    }
  };
}

// src/modules/delegation/pages/scan/receive/post-scan-receive-api.ts
var postScanReceiveToApi = (_0) => __async(void 0, [_0], function* ({
  cargoCodeWithPrefix,
  config
}) {
  const endpoint = `${config.apiBase}/v1/fleet/cargos/${cargoCodeWithPrefix}/receive/`;
  const body = JSON.stringify({
    deconsolidate: true
  });
  const response = yield fetch(endpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${config.token}`
    },
    body
  });
  if (!response.ok)
    throw new Error("Error fetching cargo by cargoCodeWithPrefix");
  const data = yield fetchJson(response);
  return data;
});

// src/modules/delegation/pages/scan/receive/scan-receive-hook.tsx
function useScanReceiveHook({ config }) {
  const [cargoCode, setCargoCode] = useState17("");
  const [scannedCargos, setScannedCargos] = useState17([]);
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      void scanCargo();
    }
  };
  const scanCargo = () => __async(this, null, function* () {
    const cleanCargoCode = cargoCode.trim();
    if (cleanCargoCode === "") {
      setCargoCode("");
      return;
    }
    setScannedCargos((prevScanedCargos) => [
      ...prevScanedCargos,
      {
        cargoCode: cleanCargoCode,
        state: "loading"
        // Use 'as const' here
      }
    ]);
    setCargoCode("");
    try {
      const prefix = "ext-";
      const cargoCodeWithPrefix = prefix + cleanCargoCode;
      const receivedResponse = yield postScanReceiveToApi({ cargoCodeWithPrefix, config });
      const receivedCargos = receivedResponse.received.map(getCargoDetailMappedService).filter((cargo) => cargo !== void 0);
      setScannedCargos(
        (prevScannedCargos) => prevScannedCargos.filter(
          (scannedCargo) => !(scannedCargo.cargoCode === cleanCargoCode && scannedCargo.state === "loading")
        )
      );
      if (receivedCargos.length === 0) {
        toast15.error(`No se han recibido cargos para el c\xF3digo ${cleanCargoCode}`);
        return;
      }
      setScannedCargos((prevScannedCargos) => {
        const existingCargoCodes = new Set(prevScannedCargos.map((c) => c.cargoCode));
        const newScannedCargos = receivedCargos.filter((receivedCargo) => !existingCargoCodes.has(receivedCargo.externalId)).map((receivedCargo) => ({
          cargoCode: receivedCargo.externalId,
          state: "success",
          receivedCargo
        }));
        return [...prevScannedCargos, ...newScannedCargos];
      });
      toast15.success(
        `Paquete(s) ${receivedCargos.map((cargo) => cargo.externalId).join(", ")} recibido(s) correctamente`
      );
    } catch (error) {
      setScannedCargos(
        (prevScannedCargos) => prevScannedCargos.filter(
          (scannedCargo) => !(scannedCargo.cargoCode === cleanCargoCode && scannedCargo.state === "loading")
        )
      );
      console.error(`No se ha podido marcar el paquete ${cleanCargoCode} como recibido`, error);
      toast15.error(`No se ha podido marcar el paquete ${cleanCargoCode} como recibido`);
    }
  });
  const successfulCargosCount = scannedCargos.filter((cargo) => cargo.state === "success").length;
  return {
    cargoCode,
    setCargoCode,
    handleKeyDown,
    scannedCargos,
    successfulCargosCount
  };
}

// src/modules/delegation/pages/scan/receive/components/table/scan-receive-table-summary-component.tsx
import React49 from "react";
import { TableCellComponent as TableCellComponent10, FlexComponent as FlexComponent15, TextComponent as TextComponent13 } from "@ontruck/fe-ui";
function ScanReceiveTableSummaryComponent({
  successfulCargosCount
}) {
  return /* @__PURE__ */ React49.createElement(FlexComponent15, { alignItems: "center", backgroundColor: "white", padding: "4px 0" }, /* @__PURE__ */ React49.createElement(FlexComponent15, { padding: "4px 0" }, /* @__PURE__ */ React49.createElement(TableCellComponent10, { padding: "0 16px" }, /* @__PURE__ */ React49.createElement(TextComponent13, { color: "var(--grey-500, #94A6B8)", fontSize: "12px", fontWeight: 500 }, "Paquetes recibidos: ", successfulCargosCount))));
}

// src/modules/delegation/pages/scan/receive/components/scan-receive-footer-component.tsx
import React50 from "react";
import { ButtonComponent as ButtonComponent7, ToolbarComponent as ToolbarComponent16, ToolbarContentComponent as ToolbarContentComponent13 } from "@ontruck/fe-ui";
import styled22 from "styled-components";
var ScanReceiveFooterToolbarContent = styled22(ToolbarContentComponent13)`
  border-top: 1px solid var(--grey-200, #e2e8ee);
  border-bottom: 1px solid var(--grey-200, #e2e8ee);
  padding: 16px;
  background-color: white;
`;
function ScanReceiveFooterComponent({
  onGoToCargosList
}) {
  return /* @__PURE__ */ React50.createElement(ToolbarComponent16, { padding: "0px" }, /* @__PURE__ */ React50.createElement(ScanReceiveFooterToolbarContent, null, /* @__PURE__ */ React50.createElement("div", null), /* @__PURE__ */ React50.createElement("div", null, /* @__PURE__ */ React50.createElement(ButtonComponent7, { color: "primary", onClick: onGoToCargosList, size: "s" }, "Finalizar recepci\xF3n"))));
}

// src/modules/delegation/pages/scan/receive/components/table/scan-receive-table-row-component.tsx
import React51, { useMemo as useMemo26 } from "react";
import ContentLoader4 from "react-content-loader";
import { TableCellComponent as TableCellComponent11, FlexComponent as FlexComponent16, TextComponent as TextComponent14 } from "@ontruck/fe-ui";
function subtractWidthAndRemovePx(widthStr, amount) {
  const match = /(\d+)/.exec(widthStr);
  if (!match) {
    throw new Error("Invalid width string");
  }
  const numericValue = parseInt(match[0], 10);
  const newWidth = numericValue - amount;
  return `${newWidth}`;
}
function ScanReceiveTableRowComponent({
  scannedCargo
}) {
  const stateText = useMemo26(
    () => {
      var _a;
      return getCargoStateTextByStateService(((_a = scannedCargo.receivedCargo) == null ? void 0 : _a.state) || "loading");
    },
    [scannedCargo]
  );
  const stateColor = useMemo26(
    () => {
      var _a;
      return getCargoColorByStateService(((_a = scannedCargo.receivedCargo) == null ? void 0 : _a.state) || "loading");
    },
    [scannedCargo]
  );
  return /* @__PURE__ */ React51.createElement(
    FlexComponent16,
    {
      alignItems: "center",
      borderBottom: "1px solid var(--grey-200, #E2E8EE)",
      borderTop: "1px solid var(--grey-200, #E2E8EE)",
      height: "50px"
    },
    /* @__PURE__ */ React51.createElement(
      TableCellComponent11,
      {
        background: "var(--grey-100, #F2F5F8);",
        borderLeft: `4px solid ${scannedCargo.state === "loading" ? "transparent" : stateColor}`,
        borderRight: "1px solid var(--grey-200, #E2E8EE)",
        width: TABLE_COLUMNS4.state.width
      },
      (() => {
        if (scannedCargo.state === "loading") {
          return /* @__PURE__ */ React51.createElement("div", { style: { paddingTop: "5px" } }, /* @__PURE__ */ React51.createElement(
            ContentLoader4,
            {
              backgroundColor: "var(--grey-300, #D4D4D4)",
              height: 20,
              viewBox: `0 0 ${subtractWidthAndRemovePx(TABLE_COLUMNS4.state.width, 30)} 20`,
              width: subtractWidthAndRemovePx(TABLE_COLUMNS4.state.width, 30)
            },
            /* @__PURE__ */ React51.createElement(
              "rect",
              {
                height: "20",
                rx: "0",
                ry: "0",
                width: subtractWidthAndRemovePx(TABLE_COLUMNS4.state.width, 30),
                x: "0",
                y: "0"
              }
            )
          ));
        }
        return /* @__PURE__ */ React51.createElement(LabelledBallComponent, { ballColor: stateColor, label: stateText });
      })()
    ),
    /* @__PURE__ */ React51.createElement(
      TableCellComponent11,
      {
        borderRight: "1px solid var(--grey-200, #E2E8EE)",
        width: TABLE_COLUMNS4.item.width
      },
      /* @__PURE__ */ React51.createElement(TextComponent14, null, scannedCargo.cargoCode)
    ),
    /* @__PURE__ */ React51.createElement(
      TableCellComponent11,
      {
        borderRight: "1px solid var(--grey-200, #E2E8EE)",
        width: TABLE_COLUMNS4.destination.width
      },
      (() => {
        var _a, _b, _c;
        if (scannedCargo.state === "loading")
          return /* @__PURE__ */ React51.createElement("div", { style: { paddingTop: "5px" } }, /* @__PURE__ */ React51.createElement(
            ContentLoader4,
            {
              height: 20,
              viewBox: `0 0 ${subtractWidthAndRemovePx(TABLE_COLUMNS4.destination.width, 30)} 20`,
              width: subtractWidthAndRemovePx(TABLE_COLUMNS4.destination.width, 30)
            },
            /* @__PURE__ */ React51.createElement(
              "rect",
              {
                height: "20",
                rx: "0",
                ry: "0",
                width: subtractWidthAndRemovePx(TABLE_COLUMNS4.destination.width, 30),
                x: "0",
                y: "0"
              }
            )
          ));
        return /* @__PURE__ */ React51.createElement(TextComponent14, { gap: "4px" }, /* @__PURE__ */ React51.createElement("strong", null, (_a = scannedCargo.receivedCargo) == null ? void 0 : _a.deliveryData.address.city), " ", (_b = scannedCargo.receivedCargo) == null ? void 0 : _b.deliveryData.address.country, " ", (_c = scannedCargo.receivedCargo) == null ? void 0 : _c.deliveryData.address.zipcode);
      })()
    )
  );
}

// src/modules/delegation/pages/scan/receive/scan-receive-page.tsx
function DelegationScanReceivePage({
  config,
  onGoToCargosList,
  onGoToScanConsolidate
}) {
  const { cargoCode, handleKeyDown, scannedCargos, setCargoCode, successfulCargosCount } = useScanReceiveHook({ config });
  const columns = {
    state: {
      id: "0",
      width: TABLE_COLUMNS4.state.width,
      label: "ESTADO"
    },
    item: {
      id: "1",
      width: TABLE_COLUMNS4.item.width,
      label: "PAQUETE"
    },
    destination: {
      id: "2",
      width: TABLE_COLUMNS4.destination.width,
      label: "DESTINO"
    }
  };
  const getScannedCargosRowsComponents = useCallback16(() => {
    return scannedCargos.map((scannedCargo) => {
      var _a;
      return /* @__PURE__ */ React52.createElement(
        ScanReceiveTableRowComponent,
        {
          key: `${scannedCargo.cargoCode}${((_a = scannedCargo.receivedCargo) == null ? void 0 : _a.id) ? `-${scannedCargo.receivedCargo.id}` : ""}`,
          scannedCargo
        }
      );
    });
  }, [scannedCargos]);
  const scannedCargosRowsComponents = useMemo27(
    () => getScannedCargosRowsComponents(),
    [getScannedCargosRowsComponents]
  );
  return /* @__PURE__ */ React52.createElement(ConfigProvider, { apiBase: config.apiBase, delegations: config.delegations, token: config.token }, /* @__PURE__ */ React52.createElement(PageLayout15, null, /* @__PURE__ */ React52.createElement(
    ScanReceiveToolbarComponent,
    {
      cargoCode,
      handleKeyDown,
      onGoToCargosList,
      onGoToScanConsolidate,
      setCargoCode
    }
  ), /* @__PURE__ */ React52.createElement(PageContent15, null, /* @__PURE__ */ React52.createElement(
    TableComponent6,
    {
      columns,
      emptyStateIcon: /* @__PURE__ */ React52.createElement(EmptyListScanIcon, null),
      emptyStateMessage: "Empieza a escanear",
      numberOfItems: scannedCargos.length,
      rowsComponents: scannedCargosRowsComponents,
      scrollCacheKey: "scan-receive",
      stickyFooterComponent: /* @__PURE__ */ React52.createElement(ScanReceiveFooterComponent, { onGoToCargosList }),
      summaryComponent: /* @__PURE__ */ React52.createElement(ScanReceiveTableSummaryComponent, { successfulCargosCount })
    }
  )), /* @__PURE__ */ React52.createElement(Toaster12, { richColors: true })));
}

// src/modules/delegation/pages/scan/consolidate/scan-consolidate-page.tsx
import React59, { useMemo as useMemo30, useCallback as useCallback17 } from "react";
import { PageContent as PageContent16, PageLayout as PageLayout16, TableComponent as TableComponent7 } from "@ontruck/fe-ui";
import { Toaster as Toaster13 } from "sonner";
import { EmptyListScanIcon as EmptyListScanIcon2 } from "@ontruck/fe-icons";

// src/modules/delegation/pages/scan/consolidate/components/scan-consolidate-toolbar-component.tsx
import React53 from "react";
import {
  ButtonComponent as ButtonComponent8,
  Input as Input13,
  ToolbarComponent as ToolbarComponent17,
  ToolbarButtonComponent as ToolbarButtonComponent17,
  ToolbarContentComponent as ToolbarContentComponent14,
  FlexComponent as FlexComponent17
} from "@ontruck/fe-ui";
import { CloseIcon as CloseIcon12, QrCodeIcon as QrCodeIcon3 } from "@ontruck/fe-icons";
import styled23 from "styled-components";
var ScanConsolidateIconToolbarButtonContainer = styled23(ToolbarButtonComponent17)`
  background-color: var(--accent-color-blue);
  height: auto;
  height: 100%;
  cursor: default;
  width: 60px;
  height: 60px;
  justify-content: center;
  align-items: center;
  svg {
    height: 26px;
    width: 26px;
  }
  svg path {
    fill: white;
  }
`;
var CloseIconStyled2 = styled23(CloseIcon12)`
  width: var(--otk-ui-icon-l-size, 20px);
  height: var(--otk-ui-icon-l-size, 20px);
  path {
    fill: var(--otk-theme-color-primary, #39a0df);
  }

  :hover {
    path {
      fill: var(--otk-theme-color-primary-hover, #2087c6);
    }
  }
`;
var ButtonStyled2 = styled23(ButtonComponent8)`
  margin: 36px;
`;
function ScanConsolidateToolbarComponent({
  cargoCode,
  setCargoCode,
  handleKeyDown,
  onGoToCargosList,
  onGoToScanReceive
}) {
  const scanTypeOptions = [
    { label: "Recepci\xF3n", value: "receive" },
    { label: "Consolidaci\xF3n", value: "consolidation" }
  ];
  return /* @__PURE__ */ React53.createElement(ToolbarComponent17, { padding: "0px" }, /* @__PURE__ */ React53.createElement(ScanConsolidateIconToolbarButtonContainer, null, /* @__PURE__ */ React53.createElement(QrCodeIcon3, null)), /* @__PURE__ */ React53.createElement(ToolbarContentComponent14, null, /* @__PURE__ */ React53.createElement(FlexComponent17, { gap: "8px" }, /* @__PURE__ */ React53.createElement(
    Input13,
    {
      handleChangeValue: (name, value) => {
        if (value === "receive") {
          onGoToScanReceive();
        }
      },
      label: "Acci\xF3n",
      name: "scan-type",
      options: scanTypeOptions,
      type: "select",
      value: "consolidation",
      width: "140px"
    }
  ), /* @__PURE__ */ React53.createElement(
    Input13,
    {
      autoFocus: true,
      handleChangeEvent: (e) => {
        const event = e;
        const newValue = event.target.value;
        setCargoCode(newValue);
      },
      icon: /* @__PURE__ */ React53.createElement(QrCodeIcon3, null),
      label: "Escanea un paquete o introduce su c\xF3digo de barras",
      name: "scan-input",
      onKeyDown: handleKeyDown,
      type: "text-with-icon",
      value: cargoCode,
      width: "400px"
    }
  )), /* @__PURE__ */ React53.createElement("div", null, /* @__PURE__ */ React53.createElement(ButtonStyled2, { onClick: onGoToCargosList, variant: "icon" }, /* @__PURE__ */ React53.createElement(CloseIconStyled2, null)))));
}

// src/modules/delegation/pages/scan/consolidate/scan-consolidate-hook.tsx
import React55, { useState as useState19 } from "react";
import { Modal as Modal2 } from "react-async-popup";
import { toast as toast17 } from "sonner";

// src/modules/delegation/pages/scan/consolidate/get-cargo-by-external-id-api.ts
var getCargoByExternalIdApi = (_0) => __async(void 0, [_0], function* ({
  externalId,
  config
}) {
  const endpoint = `${config.apiBase}/v1/fleet/tracking/${externalId}/`;
  const response = yield fetch(endpoint, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${config.token}`
    }
  });
  if (!response.ok)
    throw new Error("Error fetching cargo by external id");
  const data = yield fetchJson(response);
  return data;
});

// src/modules/delegation/pages/scan/consolidate/components/modal/consolidate-cargos-modal.tsx
import React54, { useMemo as useMemo28 } from "react";
import { ModalComponent as ModalComponent5 } from "@ontruck/fe-ui";

// src/modules/delegation/pages/scan/consolidate/components/modal/consolidate-cargos-hook.ts
import { useState as useState18 } from "react";
import { toast as toast16 } from "sonner";

// src/modules/delegation/pages/scan/consolidate/components/modal/consolidate-cargos-api.ts
function consolidateCargosApi(_0) {
  return __async(this, arguments, function* ({
    apiBase,
    apiToken,
    cargoIds
  }) {
    const endpoint = `${apiBase}/v1/fleet/cargos/consolidate/`;
    const body = {
      cargo_ids: cargoIds
    };
    return fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${apiToken}`
      },
      body: JSON.stringify(body)
    });
  });
}

// src/modules/delegation/pages/scan/consolidate/components/modal/consolidate-cargos-hook.ts
function useConsolidateCargosHook({
  apiBase,
  apiToken,
  scannedCargos,
  onSuccess,
  onError
}) {
  const [loading, setLoading] = useState18(false);
  const cancel = () => {
    if (loading) {
      setLoading(false);
    }
  };
  const onConfirm = () => __async(this, null, function* () {
    setLoading(true);
    const cargoIds = scannedCargos.map((cargo) => {
      var _a;
      return (_a = cargo.cargoReadyToConsolidate) == null ? void 0 : _a.id;
    }).filter((id) => id !== void 0);
    try {
      const response = yield consolidateCargosApi({
        apiBase,
        apiToken,
        cargoIds
      });
      if (!response.ok) {
        throw new Error("Bad response");
      }
      if (onSuccess) {
        onSuccess();
      }
      setLoading(false);
      const successMessage = "Paquetes consolidados con \xE9xito";
      toast16.success(successMessage);
    } catch (error) {
      if (onError) {
        onError(error);
      }
      const errorMessage = "Error al consolidar los paquetes";
      toast16.error(errorMessage);
      setLoading(false);
    }
  });
  return {
    loading,
    cancel,
    onConfirm
  };
}

// src/modules/delegation/pages/scan/consolidate/components/modal/get-zipcodes-by-scanned-cargo-locations.ts
var getZipCodesByScannedCargoLocations = (scannedCargos) => {
  const zipCodesByLocation = [];
  const scannedCargosAddresses = scannedCargos.map(
    (sc) => {
      var _a;
      return (_a = sc.cargoReadyToConsolidate) == null ? void 0 : _a.deliveryData.address;
    }
  );
  for (const address of scannedCargosAddresses) {
    if (address === void 0) {
      continue;
    }
    const location = address.city;
    if (!location) {
      continue;
    }
    const zipCode = address.zipcode;
    if (!zipCode) {
      continue;
    }
    const zipCodesLocations = zipCodesByLocation.map((z) => z.location);
    const isLocationInZipCodesLocations = location ? zipCodesLocations.includes(location) : false;
    if (isLocationInZipCodesLocations) {
      const zipCodeLocations = zipCodesByLocation.find((z) => z.location === location);
      const isZipCodeInZipCodeLocations = zipCode ? zipCodeLocations == null ? void 0 : zipCodeLocations.zipCodes.includes(zipCode) : false;
      if (!isZipCodeInZipCodeLocations) {
        zipCodeLocations == null ? void 0 : zipCodeLocations.zipCodes.push(zipCode);
        zipCodeLocations == null ? void 0 : zipCodeLocations.zipCodes.sort();
      }
    } else {
      zipCodesByLocation.push({
        location: location ? location : "Desconocido",
        zipCodes: [zipCode]
      });
    }
  }
  return zipCodesByLocation;
};

// src/modules/delegation/pages/scan/consolidate/components/modal/consolidate-cargos-modal.tsx
function ConsolidateCargosModal({
  apiBase,
  apiToken,
  scannedCargos,
  onClose,
  onSuccess,
  onError
}) {
  const onConsolidateCargosModalSuccess = () => {
    if (onSuccess) {
      onSuccess();
    }
  };
  const onConsolidateCargosModalError = () => {
    if (onError) {
      onError();
    }
  };
  const handleCloseConsolidateCargosModal = () => {
    if (onClose) {
      onClose();
    }
  };
  const handleConfirmConsolidateCargos = () => {
    void onConfirm();
  };
  const { loading, onConfirm } = useConsolidateCargosHook({
    apiBase,
    apiToken,
    scannedCargos,
    onSuccess: onConsolidateCargosModalSuccess,
    onError: onConsolidateCargosModalError
  });
  const headerText = `${scannedCargos.length} paquetes seleccionados`;
  const zipCodesByLocations = useMemo28(
    () => getZipCodesByScannedCargoLocations(scannedCargos),
    [scannedCargos]
  );
  return /* @__PURE__ */ React54.createElement(
    ModalComponent5,
    {
      bodyComponent: /* @__PURE__ */ React54.createElement(
        ActionsZipCodesByLocationsSummaryComponent,
        {
          hasConsolidated: false,
          zipCodesByLocations
        }
      ),
      cancelButtonLabel: "Cancelar",
      confirmButtonIsLoadingLabel: "Consolidando...",
      confirmButtonLabel: "Consolidar",
      description: headerText,
      isCancelDisabled: loading,
      isConfirmDisabled: loading,
      isConfirmLoading: loading,
      onCancel: handleCloseConsolidateCargosModal,
      onClose: handleCloseConsolidateCargosModal,
      onConfirm: handleConfirmConsolidateCargos,
      title: "Consolidar paquetes"
    }
  );
}

// src/modules/delegation/pages/scan/consolidate/scan-consolidate-hook.tsx
function useScanConsolidateHook({
  config,
  onGoToCargosList
}) {
  const [cargoCode, setCargoCode] = useState19("");
  const [scannedCargos, setScannedCargos] = useState19([]);
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      void scanCargo();
    }
  };
  const cargoDelegations = scannedCargos.map((cargo) => {
    var _a;
    return (_a = cargo.cargoReadyToConsolidate) == null ? void 0 : _a.delegation;
  }).filter((delegation) => delegation !== void 0);
  const areAllDelegationsTheSame = getAreAllCargoDelegationsTheSame(cargoDelegations);
  const isConfirmConsolidateDisabled = scannedCargos.length < 2 || !areAllDelegationsTheSame;
  const scanCargo = () => __async(this, null, function* () {
    const cleanCargoCode = cargoCode.trim();
    if (cleanCargoCode === "") {
      setCargoCode("");
      return;
    }
    setScannedCargos((prevScannedCargos) => {
      const isCargoAlreadyScanned = prevScannedCargos.some(
        (scannedCargo) => scannedCargo.cargoCode === cleanCargoCode
      );
      if (!isCargoAlreadyScanned) {
        return [
          ...prevScannedCargos,
          {
            cargoCode: cleanCargoCode,
            state: "loading"
            // Set the initial state to "loading"
          }
        ];
      }
      return prevScannedCargos;
    });
    setCargoCode("");
    try {
      const externalId = cargoCode;
      const cargoReadyToConsolidateDto = yield getCargoByExternalIdApi({ externalId, config });
      const cargoReadyToConsolidate = getCargoDetailMappedService(cargoReadyToConsolidateDto);
      setScannedCargos((prevScannedCargos) => {
        const isCargoAlreadyInList = prevScannedCargos.some(
          (scannedCargo) => scannedCargo.cargoCode === cleanCargoCode
        );
        if (isCargoAlreadyInList) {
          return prevScannedCargos.map(
            (scannedCargo) => scannedCargo.cargoCode === cleanCargoCode ? __spreadProps(__spreadValues({}, scannedCargo), {
              state: "success",
              // Mark as successful
              cargoReadyToConsolidate
              // Attach the received cargo data
            }) : scannedCargo
          );
        }
        return [
          ...prevScannedCargos,
          {
            cargoCode: cleanCargoCode,
            state: "success",
            // Set to success as the API call succeeded
            cargoReadyToConsolidate
            // Add the API response data
          }
        ];
      });
      toast17.success(`Paquete ${cleanCargoCode} escaneado correctamente`);
    } catch (error) {
      console.error(`No se ha podido escanear el paquete ${cleanCargoCode}`, error);
      setScannedCargos(
        (prevScannedCargos) => prevScannedCargos.filter(
          (scannedCargo) => (
            // Remove only if the cargo is still "loading" (i.e., it failed while loading)
            !(scannedCargo.cargoCode === cleanCargoCode && scannedCargo.state === "loading")
          )
        )
      );
      toast17.error(`No se ha podido escanear el paquete ${cleanCargoCode}`);
    }
  });
  const successfulCargosCount = scannedCargos.filter((cargo) => cargo.state === "success").length;
  const handleConfirmConsolidateCargos = () => __async(this, null, function* () {
    const handleCloseConsolidateCargosModal = () => {
      void destroy();
    };
    const handleConsolidateCargosSuccess = () => {
      void destroy().then(() => {
        onGoToCargosList();
      });
    };
    const { show, destroy } = yield Modal2.new({
      content: /* @__PURE__ */ React55.createElement(
        ConsolidateCargosModal,
        {
          apiBase: config.apiBase,
          apiToken: config.token,
          onClose: handleCloseConsolidateCargosModal,
          onSuccess: handleConsolidateCargosSuccess,
          scannedCargos
        }
      ),
      footer: null
    });
    yield show();
  });
  const addCargoCode = (code) => {
    setCargoCode(code);
  };
  const removeCargoCode = (code) => {
    try {
      setScannedCargos(
        (prevScannedCargos) => prevScannedCargos.filter((scannedCargo) => scannedCargo.cargoCode !== code)
      );
      toast17.success(`Paquete ${code} eliminado de la lista de consolidaci\xF3n`);
    } catch (error) {
      console.error(
        `No se ha podido eliminar el paquete ${code} de la lista de consolidaci\xF3n`,
        error
      );
      toast17.error(`No se ha podido eliminar el paquete ${code} de la lista de consolidaci\xF3n`);
    }
  };
  return {
    cargoCode,
    addCargoCodeToBeConsolidate: addCargoCode,
    removeCargoCodeToBeConsolidate: removeCargoCode,
    handleKeyDown,
    handleConfirmConsolidateCargos,
    scannedCargos,
    successfulCargosCount,
    isConfirmConsolidateDisabled
  };
}

// src/modules/delegation/pages/scan/consolidate/components/table/scan-consolidate-table-summary-component.tsx
import React56 from "react";
import { TableCellComponent as TableCellComponent12, FlexComponent as FlexComponent18, TextComponent as TextComponent15 } from "@ontruck/fe-ui";
function ScanConsolidateTableSummaryComponent({
  successfulCargosCount
}) {
  return /* @__PURE__ */ React56.createElement(FlexComponent18, { alignItems: "center", backgroundColor: "white", padding: "4px 0" }, /* @__PURE__ */ React56.createElement(FlexComponent18, { padding: "4px 0" }, /* @__PURE__ */ React56.createElement(TableCellComponent12, { padding: "0 16px" }, /* @__PURE__ */ React56.createElement(TextComponent15, { color: "var(--grey-500, #94A6B8)", fontSize: "12px", fontWeight: 500 }, "Paquetes escaneados: ", successfulCargosCount))));
}

// src/modules/delegation/pages/scan/consolidate/components/scan-consolidate-footer-component.tsx
import React57 from "react";
import { ButtonComponent as ButtonComponent9, ToolbarComponent as ToolbarComponent18, ToolbarContentComponent as ToolbarContentComponent15 } from "@ontruck/fe-ui";
import styled24 from "styled-components";
var ScanConsolidateFooterToolbarContentComponent = styled24(ToolbarContentComponent15)`
  border-top: 1px solid var(--grey-200, #e2e8ee);
  border-bottom: 1px solid var(--grey-200, #e2e8ee);
  padding: 16px;
  background-color: white;
`;
function ScanConsolidateFooterComponent({
  onConfirmConsolidation,
  isConfirmConsolidateDisabled
}) {
  return /* @__PURE__ */ React57.createElement(ToolbarComponent18, { padding: "0px" }, /* @__PURE__ */ React57.createElement(ScanConsolidateFooterToolbarContentComponent, null, /* @__PURE__ */ React57.createElement("div", null), /* @__PURE__ */ React57.createElement("div", null, /* @__PURE__ */ React57.createElement(
    ButtonComponent9,
    {
      color: "primary",
      disabled: isConfirmConsolidateDisabled,
      onClick: onConfirmConsolidation,
      size: "s"
    },
    "Consolidar"
  ))));
}

// src/modules/delegation/pages/scan/consolidate/components/table/scan-consolidate-table-row-component.tsx
import React58, { useMemo as useMemo29 } from "react";
import ContentLoader5 from "react-content-loader";
import { ButtonComponent as ButtonComponent10, TableCellComponent as TableCellComponent13, TextComponent as TextComponent16, FlexComponent as FlexComponent19 } from "@ontruck/fe-ui";
import { IconComponent as IconComponent3 } from "@ontruck/fe-icons";
function subtractWidthAndRemovePx2(widthStr, amount) {
  const match = /(\d+)/.exec(widthStr);
  if (!match) {
    throw new Error("Invalid width string");
  }
  const numericValue = parseInt(match[0], 10);
  const newWidth = numericValue - amount;
  return `${newWidth}`;
}
function ScanConsolidateTableRowComponent({
  scannedCargo,
  onRemoveCargoToBeConsolidate
}) {
  const stateText = useMemo29(
    () => {
      var _a;
      return getCargoStateTextByStateService(((_a = scannedCargo.cargoReadyToConsolidate) == null ? void 0 : _a.state) || "loading");
    },
    [scannedCargo]
  );
  const stateColor = useMemo29(
    () => {
      var _a;
      return getCargoColorByStateService(((_a = scannedCargo.cargoReadyToConsolidate) == null ? void 0 : _a.state) || "loading");
    },
    [scannedCargo]
  );
  const handleRemoveCargoToBeConsolidate = () => {
    if (onRemoveCargoToBeConsolidate) {
      onRemoveCargoToBeConsolidate(scannedCargo.cargoCode);
    }
  };
  return /* @__PURE__ */ React58.createElement(
    FlexComponent19,
    {
      alignItems: "center",
      borderBottom: "1px solid var(--grey-200, #E2E8EE)",
      borderTop: "1px solid var(--grey-200, #E2E8EE)",
      height: "50px",
      justifyContent: "space-between"
    },
    /* @__PURE__ */ React58.createElement(FlexComponent19, { height: "100%" }, /* @__PURE__ */ React58.createElement(
      TableCellComponent13,
      {
        background: "var(--grey-100, #F2F5F8);",
        borderLeft: `4px solid ${scannedCargo.state === "loading" ? "transparent" : stateColor}`,
        borderRight: "1px solid var(--grey-200, #E2E8EE)",
        width: TABLE_COLUMNS4.state.width
      },
      (() => {
        if (scannedCargo.state === "loading") {
          return /* @__PURE__ */ React58.createElement("div", { style: { paddingTop: "5px" } }, /* @__PURE__ */ React58.createElement(
            ContentLoader5,
            {
              backgroundColor: "var(--grey-300, #D4D4D4)",
              height: 20,
              viewBox: `0 0 ${subtractWidthAndRemovePx2(TABLE_COLUMNS4.state.width, 30)} 20`,
              width: subtractWidthAndRemovePx2(TABLE_COLUMNS4.state.width, 30)
            },
            /* @__PURE__ */ React58.createElement(
              "rect",
              {
                height: "20",
                rx: "0",
                ry: "0",
                width: subtractWidthAndRemovePx2(TABLE_COLUMNS4.state.width, 30),
                x: "0",
                y: "0"
              }
            )
          ));
        }
        return /* @__PURE__ */ React58.createElement(LabelledBallComponent, { ballColor: stateColor, label: stateText });
      })()
    ), /* @__PURE__ */ React58.createElement(
      TableCellComponent13,
      {
        borderRight: "1px solid var(--grey-200, #E2E8EE)",
        width: TABLE_COLUMNS4.item.width
      },
      /* @__PURE__ */ React58.createElement(TextComponent16, null, scannedCargo.cargoCode)
    ), /* @__PURE__ */ React58.createElement(
      TableCellComponent13,
      {
        borderRight: "1px solid var(--grey-200, #E2E8EE)",
        width: TABLE_COLUMNS4.destination.width
      },
      (() => {
        var _a, _b, _c;
        if (scannedCargo.state === "loading") {
          return /* @__PURE__ */ React58.createElement("div", { style: { paddingTop: "5px" } }, /* @__PURE__ */ React58.createElement(
            ContentLoader5,
            {
              height: 20,
              viewBox: `0 0 ${subtractWidthAndRemovePx2(TABLE_COLUMNS4.destination.width, 30)} 20`,
              width: subtractWidthAndRemovePx2(TABLE_COLUMNS4.destination.width, 30)
            },
            /* @__PURE__ */ React58.createElement(
              "rect",
              {
                height: "20",
                rx: "0",
                ry: "0",
                width: subtractWidthAndRemovePx2(TABLE_COLUMNS4.destination.width, 30),
                x: "0",
                y: "0"
              }
            )
          ));
        }
        return /* @__PURE__ */ React58.createElement(TextComponent16, { gap: "4px" }, /* @__PURE__ */ React58.createElement("strong", null, (_a = scannedCargo.cargoReadyToConsolidate) == null ? void 0 : _a.deliveryData.address.city), " ", (_b = scannedCargo.cargoReadyToConsolidate) == null ? void 0 : _b.deliveryData.address.country, " ", (_c = scannedCargo.cargoReadyToConsolidate) == null ? void 0 : _c.deliveryData.address.zipcode);
      })()
    )),
    /* @__PURE__ */ React58.createElement(FlexComponent19, { height: "100%", width: TABLE_COLUMNS4.actions.width }, /* @__PURE__ */ React58.createElement(TableCellComponent13, null, /* @__PURE__ */ React58.createElement(
      ButtonComponent10,
      {
        color: "primary",
        onClick: handleRemoveCargoToBeConsolidate,
        size: "s",
        variant: "icon"
      },
      /* @__PURE__ */ React58.createElement(
        IconComponent3,
        {
          color: "var(--otk-theme-color-accent-primary)",
          name: "trash-line",
          sizeInPixels: 24
        }
      )
    )))
  );
}

// src/modules/delegation/pages/scan/consolidate/scan-consolidate-page.tsx
function DelegationScanConsolidatePage({
  config,
  onGoToCargosList,
  onGoToScanReceive
}) {
  const {
    cargoCode,
    handleKeyDown,
    scannedCargos,
    addCargoCodeToBeConsolidate,
    removeCargoCodeToBeConsolidate,
    successfulCargosCount,
    handleConfirmConsolidateCargos,
    isConfirmConsolidateDisabled
  } = useScanConsolidateHook({ config, onGoToCargosList });
  const columns = useMemo30(
    () => ({
      state: {
        id: "0",
        width: TABLE_COLUMNS4.state.width,
        label: "ESTADO"
      },
      item: {
        id: "1",
        width: TABLE_COLUMNS4.item.width,
        label: "PAQUETE"
      },
      destination: {
        id: "2",
        width: TABLE_COLUMNS4.destination.width,
        label: "DESTINO"
      },
      actions: {
        id: "3",
        width: TABLE_COLUMNS4.actions.width,
        label: "ACCIONES",
        group: "right"
      }
    }),
    []
  );
  const getConsolidatedCargosRowsComponents = useCallback17(() => {
    return scannedCargos.map((scannedCargo) => {
      var _a;
      return /* @__PURE__ */ React59.createElement(
        ScanConsolidateTableRowComponent,
        {
          key: `${scannedCargo.cargoCode}${((_a = scannedCargo.cargoReadyToConsolidate) == null ? void 0 : _a.id) ? `-${scannedCargo.cargoReadyToConsolidate.id}` : ""}`,
          onRemoveCargoToBeConsolidate: removeCargoCodeToBeConsolidate,
          scannedCargo
        }
      );
    });
  }, [scannedCargos, removeCargoCodeToBeConsolidate]);
  const consolidateCargosRowsComponents = useMemo30(
    () => getConsolidatedCargosRowsComponents(),
    [getConsolidatedCargosRowsComponents]
  );
  return /* @__PURE__ */ React59.createElement(ConfigProvider, { apiBase: config.apiBase, delegations: config.delegations, token: config.token }, /* @__PURE__ */ React59.createElement(PageLayout16, null, /* @__PURE__ */ React59.createElement(
    ScanConsolidateToolbarComponent,
    {
      cargoCode,
      handleKeyDown,
      onGoToCargosList,
      onGoToScanReceive,
      setCargoCode: addCargoCodeToBeConsolidate
    }
  ), /* @__PURE__ */ React59.createElement(PageContent16, null, /* @__PURE__ */ React59.createElement(
    TableComponent7,
    {
      columns,
      emptyStateIcon: /* @__PURE__ */ React59.createElement(EmptyListScanIcon2, null),
      emptyStateMessage: "Empieza a escanear",
      numberOfItems: scannedCargos.length,
      rowsComponents: consolidateCargosRowsComponents,
      scrollCacheKey: "scan-consolidate",
      stickyFooterComponent: scannedCargos.length > 0 ? /* @__PURE__ */ React59.createElement(
        ScanConsolidateFooterComponent,
        {
          isConfirmConsolidateDisabled,
          onConfirmConsolidation: () => void handleConfirmConsolidateCargos()
        }
      ) : void 0,
      summaryComponent: /* @__PURE__ */ React59.createElement(ScanConsolidateTableSummaryComponent, { successfulCargosCount })
    }
  )), /* @__PURE__ */ React59.createElement(Toaster13, { richColors: true })));
}

// src/modules/delegation/pages/cargo-detail/cargo-detail-page.tsx
import React75, { useState as useState21, useEffect as useEffect6 } from "react";
import { Toaster as Toaster14 } from "sonner";
import {
  PageContent as PageContent17,
  PageLayout as PageLayout17,
  FlexComponent as FlexComponent25,
  MonitorComponent
} from "@ontruck/fe-ui";
import styled39 from "styled-components";

// src/modules/delegation/pages/cargo-detail/logs/get-cargo-detail-logs-service.tsx
import React64 from "react";
import { iconNames } from "@ontruck/fe-icons";

// src/modules/delegation/pages/cargo-detail/logs/delivery-failed-event-log-component.tsx
import React60 from "react";

// src/modules/delegation/pages/cargo-detail/logs/list-log-component.tsx
import styled25 from "styled-components";
import { TextComponent as TextComponent17 } from "@ontruck/fe-ui";
var ListLogComponent = styled25.ul`
  padding: 0;
  padding-left: 24px;
  margin: 0;

  ${TextComponent17} {
    font-size: 12px;
  }
`;

// src/modules/delegation/pages/cargo-detail/logs/inline-text-log-component.tsx
import styled26 from "styled-components";
import { TextComponent as TextComponent18 } from "@ontruck/fe-ui";
var InlineTextLogComponent = styled26(TextComponent18)`
  display: inline;
`;

// src/modules/delegation/pages/cargo-detail/logs/link-log-component.tsx
import styled27 from "styled-components";
var LinkLogComponent = styled27.a`
  color: var(--otk-theme-color-primary-400, #57b1e5);
  text-decoration: underline;
`;

// src/modules/delegation/pages/cargo-detail/logs/delivery-failed-event-log-component.tsx
function DeliveryFailedEventLogComponent({ event }) {
  return /* @__PURE__ */ React60.createElement(ListLogComponent, null, event.observations ? /* @__PURE__ */ React60.createElement("li", null, /* @__PURE__ */ React60.createElement(InlineTextLogComponent, { fontWeight: "var(--otk-theme-font-weight-medium)" }, "Observaciones:"), " ", /* @__PURE__ */ React60.createElement(InlineTextLogComponent, { fontWeight: "var(--otk-theme-font-weight)" }, event.observations)) : null, event.latitude && event.longitude ? /* @__PURE__ */ React60.createElement("li", null, /* @__PURE__ */ React60.createElement(InlineTextLogComponent, { fontWeight: "var(--otk-theme-font-weight-medium)" }, "Posici\xF3n gps:"), " ", /* @__PURE__ */ React60.createElement(InlineTextLogComponent, { fontWeight: "var(--otk-theme-font-weight)" }, event.latitude, " - ", event.longitude)) : null, event.image ? /* @__PURE__ */ React60.createElement("li", null, /* @__PURE__ */ React60.createElement(InlineTextLogComponent, { fontWeight: "var(--otk-theme-font-weight-medium)" }, "Imagen:"), " ", /* @__PURE__ */ React60.createElement(InlineTextLogComponent, { fontWeight: "var(--otk-theme-font-weight)" }, /* @__PURE__ */ React60.createElement(LinkLogComponent, { href: event.image, target: "_blank" }, "Enlace a la imagen"))) : null);
}

// src/modules/delegation/pages/cargo-detail/logs/incident-reported-event-log-component.tsx
import React61 from "react";
function IncidentReportedEventLogComponent({ event }) {
  return /* @__PURE__ */ React61.createElement(ListLogComponent, null, event.observations ? /* @__PURE__ */ React61.createElement("li", null, /* @__PURE__ */ React61.createElement(InlineTextLogComponent, { fontWeight: "var(--otk-theme-font-weight-medium)" }, "Observaciones:"), " ", /* @__PURE__ */ React61.createElement(InlineTextLogComponent, { fontWeight: "var(--otk-theme-font-weight)" }, event.observations)) : null, event.latitude && event.longitude ? /* @__PURE__ */ React61.createElement("li", null, /* @__PURE__ */ React61.createElement(InlineTextLogComponent, { fontWeight: "var(--otk-theme-font-weight-medium)" }, "Posici\xF3n gps:"), " ", /* @__PURE__ */ React61.createElement(InlineTextLogComponent, { fontWeight: "var(--otk-theme-font-weight)" }, event.latitude, " - ", event.longitude)) : null);
}

// src/modules/delegation/pages/cargo-detail/logs/delivery-updated-event-log-component.tsx
import React62 from "react";
import { TextComponent as TextComponent19 } from "@ontruck/fe-ui";

// src/modules/delegation/pages/cargo-detail/logs/get-event-clean-diff-service.ts
function getEventCleanDiffService(diff) {
  const cleaned = { new: {}, prev: {} };
  if (!diff) {
    return cleaned;
  }
  for (const key in diff) {
    const { new: newValue, prev: prevValue } = diff[key];
    if (newValue !== prevValue) {
      cleaned.new[key] = newValue;
      cleaned.prev[key] = prevValue;
    }
  }
  return cleaned;
}

// src/modules/delegation/pages/cargo-detail/logs/delivery-updated-event-log-component.tsx
function DeliveryUpdatedEventLogComponent({ event }) {
  const diff = event.diff;
  const cleanedDiff = getEventCleanDiffService(diff);
  return /* @__PURE__ */ React62.createElement(ListLogComponent, null, /* @__PURE__ */ React62.createElement("li", null, /* @__PURE__ */ React62.createElement(InlineTextLogComponent, { fontWeight: "var(--otk-theme-font-weight-medium)" }, "Actualizado:"), /* @__PURE__ */ React62.createElement("div", null, cleanedDiff.prev.address_line ? /* @__PURE__ */ React62.createElement(TextComponent19, { fontWeight: "var(--otk-theme-font-weight)" }, cleanedDiff.prev.address_line) : null, cleanedDiff.prev.city ? /* @__PURE__ */ React62.createElement(TextComponent19, { fontWeight: "var(--otk-theme-font-weight)" }, cleanedDiff.prev.city) : null, cleanedDiff.prev.zipcode ? /* @__PURE__ */ React62.createElement(TextComponent19, { fontWeight: "var(--otk-theme-font-weight)" }, cleanedDiff.prev.zipcode) : null, cleanedDiff.prev.contact_phone ? /* @__PURE__ */ React62.createElement(TextComponent19, { fontWeight: "var(--otk-theme-font-weight)" }, cleanedDiff.prev.contact_phone) : null, cleanedDiff.prev.contact_email ? /* @__PURE__ */ React62.createElement(TextComponent19, { fontWeight: "var(--otk-theme-font-weight)" }, cleanedDiff.prev.contact_email) : null)), /* @__PURE__ */ React62.createElement("li", null, /* @__PURE__ */ React62.createElement(InlineTextLogComponent, { fontWeight: "var(--otk-theme-font-weight-medium)" }, "Anterior:"), /* @__PURE__ */ React62.createElement("div", null, cleanedDiff.new.address_line ? /* @__PURE__ */ React62.createElement(TextComponent19, { fontWeight: "var(--otk-theme-font-weight)" }, cleanedDiff.new.address_line) : null, cleanedDiff.new.city ? /* @__PURE__ */ React62.createElement(TextComponent19, { fontWeight: "var(--otk-theme-font-weight)" }, cleanedDiff.new.city) : null, cleanedDiff.new.zipcode ? /* @__PURE__ */ React62.createElement(TextComponent19, { fontWeight: "var(--otk-theme-font-weight)" }, cleanedDiff.new.zipcode) : null, cleanedDiff.new.contact_phone ? /* @__PURE__ */ React62.createElement(TextComponent19, { fontWeight: "var(--otk-theme-font-weight)" }, cleanedDiff.new.contact_phone) : null, cleanedDiff.new.contact_email ? /* @__PURE__ */ React62.createElement(TextComponent19, { fontWeight: "var(--otk-theme-font-weight)" }, cleanedDiff.new.contact_email) : null)));
}

// src/modules/delegation/pages/cargo-detail/logs/delivery-completed-event-log-component.tsx
import React63 from "react";
function DeliveryCompletedEventLogComponent({
  event,
  externalId
}) {
  return /* @__PURE__ */ React63.createElement(ListLogComponent, null, /* @__PURE__ */ React63.createElement("li", null, /* @__PURE__ */ React63.createElement(InlineTextLogComponent, { fontWeight: "var(--otk-theme-font-weight-medium)" }, "ID:"), " ", /* @__PURE__ */ React63.createElement(InlineTextLogComponent, { fontWeight: "var(--otk-theme-font-weight)" }, externalId)), event.observations ? /* @__PURE__ */ React63.createElement("li", null, /* @__PURE__ */ React63.createElement(InlineTextLogComponent, { fontWeight: "var(--otk-theme-font-weight-medium)" }, "Observaciones:"), " ", /* @__PURE__ */ React63.createElement(InlineTextLogComponent, { fontWeight: "var(--otk-theme-font-weight)" }, event.observations)) : null, event.idNumber ? /* @__PURE__ */ React63.createElement("li", null, /* @__PURE__ */ React63.createElement(InlineTextLogComponent, { fontWeight: "var(--otk-theme-font-weight-medium)" }, "DNI / NIE / Pasaporte:"), " ", /* @__PURE__ */ React63.createElement(InlineTextLogComponent, { fontWeight: "var(--otk-theme-font-weight)" }, event.idNumber)) : null, event.latitude && event.longitude ? /* @__PURE__ */ React63.createElement("li", null, /* @__PURE__ */ React63.createElement(InlineTextLogComponent, { fontWeight: "var(--otk-theme-font-weight-medium)" }, "Posici\xF3n gps:"), " ", /* @__PURE__ */ React63.createElement(InlineTextLogComponent, { fontWeight: "var(--otk-theme-font-weight)" }, event.latitude, " - ", event.longitude)) : null, event.image ? /* @__PURE__ */ React63.createElement("li", null, /* @__PURE__ */ React63.createElement(InlineTextLogComponent, { fontWeight: "var(--otk-theme-font-weight-medium)" }, "POD:"), " ", /* @__PURE__ */ React63.createElement(InlineTextLogComponent, { fontWeight: "var(--otk-theme-font-weight)" }, /* @__PURE__ */ React63.createElement(LinkLogComponent, { href: event.image, target: "_blank" }, "Enlace a la imagen"))) : null);
}

// src/modules/delegation/pages/cargo-detail/logs/get-cargo-detail-logs-service.tsx
var bodyByEventType = {
  [cargoLatestEventTypes.created]: () => null,
  [cargoLatestEventTypes.assigned]: () => null,
  [cargoLatestEventTypes.collectedForDelivery]: () => null,
  [cargoLatestEventTypes.collectedForTransfer]: () => null,
  [cargoLatestEventTypes.consolidated]: () => null,
  [cargoLatestEventTypes.customsCleared]: () => null,
  [cargoLatestEventTypes.deconsolidated]: () => null,
  [cargoLatestEventTypes.received]: () => null,
  [cargoLatestEventTypes.cancelled]: () => null,
  [cargoLatestEventTypes.deliveryFailed]: (event) => /* @__PURE__ */ React64.createElement(DeliveryFailedEventLogComponent, { event }),
  [cargoLatestEventTypes.incidentReported]: (event) => /* @__PURE__ */ React64.createElement(IncidentReportedEventLogComponent, { event }),
  [cargoLatestEventTypes.deliveryAddressUpdated]: (event) => /* @__PURE__ */ React64.createElement(DeliveryUpdatedEventLogComponent, { event }),
  [cargoLatestEventTypes.deliveryInternalUpdated]: (event) => /* @__PURE__ */ React64.createElement(DeliveryUpdatedEventLogComponent, { event }),
  [cargoLatestEventTypes.delivered]: (event, externalId) => /* @__PURE__ */ React64.createElement(DeliveryCompletedEventLogComponent, { event, externalId })
};
var getBodyComponentByEventTypeService = (event, externalId) => {
  return bodyByEventType[event.eventType](event, externalId);
};
var whoTypes = {
  internal: "internal",
  system: "system",
  carrier: "carrier"
};
var whoByType = {
  [whoTypes.internal]: "Interno",
  [whoTypes.system]: "Sistema",
  [whoTypes.carrier]: "Conductor"
};
function getWhoLabelByEventType(type) {
  if (type in whoTypes) {
    return whoByType[type];
  }
  return whoByType.system;
}
function getWhoColorByType(type) {
  if (type === whoTypes.internal) {
    return {
      backgroundColor: "var(--otk-theme-color-grey-300, #ccd6e0)",
      color: "var(--otk-theme-color-primary-400, #57B1E5)"
    };
  }
  if (type === whoTypes.system) {
    return {
      backgroundColor: "var(--otk-theme-color-grey-200, #E2E8EE)",
      color: "var(--otk-theme-color-grey-900)"
    };
  }
  return {
    backgroundColor: "var(--otk-theme-color-primary-500, #2396DC)",
    color: "var(--otk-theme-color-background-color-white,#fff)"
  };
}
var getWhoHandlerByEventType = {
  [cargoLatestEventTypes.created]: (event, shipper) => {
    return __spreadValues({
      type: event.user.type,
      label: getWhoLabelByEventType(event.user.type),
      details: shipper
    }, getWhoColorByType(event.user.type));
  },
  [cargoLatestEventTypes.assigned]: (event) => {
    return __spreadValues({
      type: event.user.type,
      label: getWhoLabelByEventType(event.user.type),
      details: event.user.username
    }, getWhoColorByType(event.user.type));
  },
  [cargoLatestEventTypes.cancelled]: (event, shipper) => {
    return __spreadValues({
      type: event.user.type,
      label: getWhoLabelByEventType(event.user.type),
      details: shipper
    }, getWhoColorByType(event.user.type));
  },
  [cargoLatestEventTypes.collectedForDelivery]: (event) => {
    return __spreadValues({
      type: event.user.type,
      label: getWhoLabelByEventType(event.user.type),
      details: `${event.user.firstName} ${event.user.lastName}`
    }, getWhoColorByType(event.user.type));
  },
  [cargoLatestEventTypes.collectedForTransfer]: (event) => {
    return __spreadValues({
      type: event.user.type,
      label: getWhoLabelByEventType(event.user.type),
      details: `${event.user.firstName} ${event.user.lastName}`
    }, getWhoColorByType(event.user.type));
  },
  [cargoLatestEventTypes.consolidated]: (event) => {
    return __spreadValues({
      type: event.user.type,
      label: getWhoLabelByEventType(event.user.type),
      details: event.user.username
    }, getWhoColorByType(event.user.type));
  },
  [cargoLatestEventTypes.customsCleared]: (event, shipper) => {
    return __spreadValues({
      type: event.user.type,
      label: getWhoLabelByEventType(event.user.type),
      details: shipper
    }, getWhoColorByType(event.user.type));
  },
  [cargoLatestEventTypes.deliveryAddressUpdated]: (event) => {
    return __spreadValues({
      type: event.user.type,
      label: getWhoLabelByEventType(event.user.type),
      details: null
    }, getWhoColorByType(event.user.type));
  },
  [cargoLatestEventTypes.deliveryInternalUpdated]: (event) => {
    return __spreadValues({
      type: event.user.type,
      label: getWhoLabelByEventType(event.user.type),
      details: null
    }, getWhoColorByType(event.user.type));
  },
  [cargoLatestEventTypes.deconsolidated]: (event) => {
    return __spreadValues({
      type: event.user.type,
      label: getWhoLabelByEventType(event.user.type),
      details: null
    }, getWhoColorByType(event.user.type));
  },
  [cargoLatestEventTypes.deliveryFailed]: (event) => {
    return __spreadValues({
      type: event.user.type,
      label: getWhoLabelByEventType(event.user.type),
      details: `${event.user.firstName} ${event.user.lastName}`
    }, getWhoColorByType(event.user.type));
  },
  [cargoLatestEventTypes.delivered]: (event) => {
    return __spreadValues({
      type: event.user.type,
      label: getWhoLabelByEventType(event.user.type),
      details: `${event.user.firstName} ${event.user.lastName}`
    }, getWhoColorByType(event.user.type));
  },
  [cargoLatestEventTypes.incidentReported]: (event) => {
    return __spreadValues({
      type: event.user.type,
      label: getWhoLabelByEventType(event.user.type),
      details: `${event.user.firstName} ${event.user.lastName}`
    }, getWhoColorByType(event.user.type));
  },
  [cargoLatestEventTypes.received]: (event) => {
    return __spreadValues({
      type: event.user.type,
      label: getWhoLabelByEventType(event.user.type),
      details: event.user.username
    }, getWhoColorByType(event.user.type));
  }
};
function getWhoByEventTypeService(event, shipper) {
  const handler = getWhoHandlerByEventType[event.eventType];
  return handler(event, shipper);
}
function getFormattedId(id) {
  return `ID.${id.toString().padStart(8, "0")}`;
}
var getActorHandlerByEventType = {
  [cargoLatestEventTypes.created]: () => null,
  [cargoLatestEventTypes.assigned]: (event) => {
    var _a;
    return `${(_a = event.driver) == null ? void 0 : _a.contactName}`;
  },
  [cargoLatestEventTypes.cancelled]: () => null,
  [cargoLatestEventTypes.collectedForDelivery]: (event) => {
    var _a;
    return `${(_a = event.driver) == null ? void 0 : _a.contactName}`;
  },
  [cargoLatestEventTypes.collectedForTransfer]: (event) => {
    var _a;
    return `${(_a = event.driver) == null ? void 0 : _a.contactName}`;
  },
  [cargoLatestEventTypes.consolidated]: (_, externalId) => getFormattedId(externalId),
  [cargoLatestEventTypes.customsCleared]: () => null,
  [cargoLatestEventTypes.deliveryAddressUpdated]: () => "Direcci\xF3n - Datos de contacto",
  [cargoLatestEventTypes.deliveryInternalUpdated]: () => "Direcci\xF3n - Datos de contacto",
  [cargoLatestEventTypes.deconsolidated]: (_, externalId) => getFormattedId(externalId),
  [cargoLatestEventTypes.deliveryFailed]: (event) => `${event.deliveryNotes}`,
  [cargoLatestEventTypes.delivered]: (event) => `${event.dropOffType}`,
  [cargoLatestEventTypes.incidentReported]: () => null,
  [cargoLatestEventTypes.received]: (event) => {
    var _a;
    return `${(_a = event.address) == null ? void 0 : _a.companyName}`;
  }
};
var getActorByEventTypeService = (event, externalId) => {
  const handler = getActorHandlerByEventType[event.eventType];
  return handler(event, externalId);
};
var iconDescriptionByEventType = {
  [cargoLatestEventTypes.created]: {
    name: iconNames.clipboard,
    color: "var(--otk-theme-color-grey-300, #ccd6e0)"
  },
  [cargoLatestEventTypes.assigned]: {
    name: iconNames.circleUser,
    color: "var(--otk-theme-color-primary-400, #57B1E5)"
  },
  [cargoLatestEventTypes.cancelled]: {
    name: iconNames.circleX,
    color: "var(--otk-theme-color-error-900, #ff4d4f)"
  },
  [cargoLatestEventTypes.collectedForDelivery]: {
    name: iconNames.circleArrowRight,
    color: "var(--otk-theme-color-primary-400, #57B1E5)"
  },
  [cargoLatestEventTypes.collectedForTransfer]: {
    name: iconNames.circleArrowRight,
    color: "var(--otk-theme-color-primary-400, #57B1E5)"
  },
  [cargoLatestEventTypes.consolidated]: {
    name: iconNames.circleInformation,
    color: "var(--otk-theme-color-grey-300, #ccd6e0)"
  },
  [cargoLatestEventTypes.customsCleared]: {
    name: iconNames.circleLineCheck,
    color: "var(--otk-theme-color-primary-400, #57B1E5)"
  },
  [cargoLatestEventTypes.deliveryAddressUpdated]: {
    name: iconNames.circleInformation,
    color: "var(--otk-theme-color-primary-400, #57B1E5)"
  },
  [cargoLatestEventTypes.deliveryInternalUpdated]: {
    name: iconNames.circleInformation,
    color: "var(--otk-theme-color-grey-300, #57B1E5)"
  },
  [cargoLatestEventTypes.deconsolidated]: {
    name: iconNames.circleInformation,
    color: "var(--otk-theme-color-grey-300, #ccd6e0)"
  },
  [cargoLatestEventTypes.deliveryFailed]: {
    name: iconNames.circleExclamation,
    color: "var(--otk-theme-color-red-500, #ff4d4f)"
  },
  [cargoLatestEventTypes.delivered]: {
    name: iconNames.circleCheck,
    color: "var(--otk-theme-color-success-800, #00b573)"
  },
  [cargoLatestEventTypes.incidentReported]: {
    name: iconNames.circleExclamation,
    color: "var(--otk-theme-color-warning-800, #fcb605)"
  },
  [cargoLatestEventTypes.received]: {
    name: iconNames.location,
    color: "var(--otk-theme-color-success-800, ##00b573)"
  }
};
function getIconByEventTypeService(eventType) {
  return iconDescriptionByEventType[eventType];
}
function getActionByEventTypeService(type) {
  const actionByEventType = {
    [cargoLatestEventTypes.assigned]: "Asignado",
    [cargoLatestEventTypes.received]: "Recibido",
    [cargoLatestEventTypes.created]: "Creado",
    [cargoLatestEventTypes.collectedForDelivery]: "Recogido para entrega",
    [cargoLatestEventTypes.collectedForTransfer]: "Recogido para transferencia",
    [cargoLatestEventTypes.delivered]: "Entregado",
    [cargoLatestEventTypes.consolidated]: "Consolidado",
    [cargoLatestEventTypes.deconsolidated]: "Desconsolidado",
    [cargoLatestEventTypes.deliveryFailed]: "Fallo en la entrega",
    [cargoLatestEventTypes.deliveryAddressUpdated]: "Direcci\xF3n de entrega actualizada",
    [cargoLatestEventTypes.deliveryInternalUpdated]: "Entrega interna actualizada",
    [cargoLatestEventTypes.incidentReported]: "Incidente",
    [cargoLatestEventTypes.customsCleared]: "Salida de aduanas",
    [cargoLatestEventTypes.cancelled]: "Cancelado"
  };
  return actionByEventType[type];
}
function getCargoDetailLogsService(cargoDetail) {
  if (!cargoDetail) {
    return [];
  }
  if (cargoDetail.events.length === 0) {
    return [];
  }
  return cargoDetail.events.map((event) => {
    const action = getActionByEventTypeService(event.eventType);
    const icon = getIconByEventTypeService(event.eventType);
    const actor = getActorByEventTypeService(event, cargoDetail.externalId);
    const who = getWhoByEventTypeService(event, cargoDetail.externalId);
    const when = getReadableDate(event.date);
    const bodyComponent = getBodyComponentByEventTypeService(event, cargoDetail.externalId);
    return {
      id: event.id,
      actor,
      action,
      bodyComponent,
      icon,
      who,
      when
    };
  });
}

// src/modules/delegation/pages/cargo-detail/header/header-component.tsx
import React67 from "react";
import styled30 from "styled-components";
import { CloseIcon as CloseIcon13 } from "@ontruck/fe-icons";
import { ButtonComponent as ButtonComponent11, FlexComponent as FlexComponent20 } from "@ontruck/fe-ui";

// src/modules/delegation/pages/cargo-detail/header/header-label-component.tsx
import React65 from "react";
import styled28 from "styled-components";
var HeaderLabelContainer = styled28.span`
  font-family: var(--otk-theme-font-family-primary, Roboto);
  font-size: var(--otk-theme-font-size, 14px);
  color: var(--otk-theme-color-grey-500, #94a6b8);
`;
function HeaderLabelComponent({ children }) {
  return /* @__PURE__ */ React65.createElement(HeaderLabelContainer, null, children);
}

// src/modules/delegation/pages/cargo-detail/header/header-id-component.tsx
import React66 from "react";
import styled29 from "styled-components";
var HeaderIdContainer = styled29.span`
  font-family: var(--otk-theme-font-family-primary, Roboto);
  font-size: var(--otk-theme-font-size-l, 18px);
  color: var(--otk-theme-color-primary-400, #57b1e5);
  text-transform: uppercase;
`;
function HeaderIdComponent({ children }) {
  return /* @__PURE__ */ React66.createElement(HeaderIdContainer, null, "ID:\xA0", children);
}

// src/modules/delegation/pages/cargo-detail/header/header-component.tsx
var CloseIconStyled3 = styled30(CloseIcon13)`
  width: var(--otk-ui-icon-l-size);
  height: var(--otk-ui-icon-l-size);
  path {
    fill: var(--otk-theme-color-primary-400, --otk-theme-color-blue-400);
  }

  :hover {
    path {
      fill: var(--otk-theme-color-primary-500, #2396dc);
    }
  }
`;
var HeaderContainer = styled30.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: var(--delegations-cargo-detail-header-height);
  padding: var(--delegations-cargo-detail-header-padding);
  align-content: center;
  border-bottom: 1px solid var(--otk-theme-color-grey-300);
`;
function HeaderComponent({
  onClose,
  children
}) {
  return /* @__PURE__ */ React67.createElement(HeaderContainer, null, /* @__PURE__ */ React67.createElement(FlexComponent20, { flexDirection: "column" }, children), /* @__PURE__ */ React67.createElement(ButtonComponent11, { onClick: onClose, variant: "icon" }, /* @__PURE__ */ React67.createElement(CloseIconStyled3, null)));
}
HeaderComponent.Label = HeaderLabelComponent;
HeaderComponent.Id = HeaderIdComponent;

// src/modules/delegation/pages/cargo-detail/use-get-cargo-detail-hook.ts
import useSWR15 from "swr";

// src/modules/delegation/pages/cargo-detail/get-cargo-detail-api.ts
var getCargoDetailFromApi = (_0) => __async(void 0, [_0], function* ({
  cargoId,
  config
}) {
  const endpoint = `${config.apiBase}/v1/fleet/cargos/${cargoId}`;
  const response = yield fetch(endpoint, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${config.token}`
    }
  });
  const data = yield fetchJson(response);
  return data;
});

// src/modules/delegation/pages/cargo-detail/get-cargo-detail-fetcher.ts
var getCargoDetailFromApiFetcher = (cargoId, config) => {
  return getCargoDetailFromApi({ cargoId, config });
};

// src/modules/delegation/pages/cargo-detail/use-get-cargo-detail-hook.ts
var useGetCargoDetailHook = ({
  cargoId,
  config,
  key
}) => {
  const getCargoDetailKey = key || `get-cargo-detail-${cargoId}`;
  const fetcher = () => __async(void 0, null, function* () {
    return getCargoDetailFromApiFetcher(cargoId, config);
  });
  const { data, error, isLoading, mutate } = useSWR15(
    getCargoDetailKey,
    fetcher
  );
  const cargoDetailMapped = getCargoDetailMappedService(data);
  return {
    cargoDetail: cargoDetailMapped || {},
    isLoading,
    error,
    mutate
  };
};

// src/modules/delegation/pages/cargo-detail/cargo-detail-skeleton-component.tsx
import React68 from "react";
import ContentLoader6 from "react-content-loader";
function CargoDetailSkeletonComponent() {
  return /* @__PURE__ */ React68.createElement(React68.Fragment, null, /* @__PURE__ */ React68.createElement(ContentLoader6, { height: 300, style: { marginTop: "40px" }, viewBox: "0 0 600 300", width: 600 }, /* @__PURE__ */ React68.createElement("rect", { height: "30", rx: "3", ry: "3", width: "100", x: "0", y: "0" }), /* @__PURE__ */ React68.createElement("rect", { height: "30", rx: "3", ry: "3", width: "600", x: "20", y: "60" }), /* @__PURE__ */ React68.createElement("rect", { height: "30", rx: "3", ry: "3", width: "600", x: "20", y: "110" }), /* @__PURE__ */ React68.createElement("rect", { height: "30", rx: "3", ry: "3", width: "600", x: "20", y: "160" }), /* @__PURE__ */ React68.createElement("rect", { height: "30", rx: "3", ry: "3", width: "600", x: "20", y: "210" })), /* @__PURE__ */ React68.createElement(ContentLoader6, { height: 300, viewBox: "0 0 600 300", width: 600 }, /* @__PURE__ */ React68.createElement("rect", { height: "30", rx: "3", ry: "3", width: "100", x: "0", y: "0" }), /* @__PURE__ */ React68.createElement("rect", { height: "30", rx: "3", ry: "3", width: "600", x: "20", y: "60" }), /* @__PURE__ */ React68.createElement("rect", { height: "30", rx: "3", ry: "3", width: "600", x: "20", y: "110" }), /* @__PURE__ */ React68.createElement("rect", { height: "30", rx: "3", ry: "3", width: "600", x: "20", y: "160" }), /* @__PURE__ */ React68.createElement("rect", { height: "30", rx: "3", ry: "3", width: "600", x: "20", y: "210" })));
}

// src/modules/delegation/pages/cargo-detail/cargo-detail-error-component.tsx
import React69 from "react";
import styled31 from "styled-components";
import { ErrorMessage as ErrorMessage13 } from "@ontruck/fe-ui";
var LinkErrorButtonComponent = styled31.button`
  background: transparent;
  border: none;
  text-decoration: underline;
  font-style: italic;
  color: var(--error-700);

  :hover {
    cursor: pointer;
  }
`;
var ErrorMessageStyledComponent = styled31(ErrorMessage13)`
  width: 600px;
  margin: 20px auto auto auto;
`;
function CargoDetailErrorComponent({
  onGoingBack
}) {
  return /* @__PURE__ */ React69.createElement(ErrorMessageStyledComponent, null, "Ha habido un error al procesar el detalle del cargo,", /* @__PURE__ */ React69.createElement(LinkErrorButtonComponent, { onClick: onGoingBack, type: "button" }, "volver a delegation"));
}

// src/modules/delegation/pages/cargo-detail/content/form/form-component.tsx
import React74, { useReducer, useState as useState20 } from "react";
import { toast as toast18 } from "sonner";
import styled38 from "styled-components";
import {
  ButtonComponent as ButtonComponent12,
  Input as Input14,
  Sticky as Sticky6,
  BoxesSpinnerComponent,
  Half as Half6,
  ButtonContainer as ButtonContainer6,
  FlexComponent as FlexComponent24,
  TextComponent as TextComponent20
} from "@ontruck/fe-ui";
import { CloseIcon as CloseIcon14 } from "@ontruck/fe-icons";

// src/modules/delegation/pages/cargo-detail/content/content-component.tsx
import React70 from "react";
import styled32 from "styled-components";
import { FlexComponent as FlexComponent21 } from "@ontruck/fe-ui";
var ContentContainer = styled32.div`
  background-color: var(--otk-theme-color-grey-100, #f2f5f8);
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  flex: 1;
`;
function ContentComponent({ children }) {
  return /* @__PURE__ */ React70.createElement(ContentContainer, null, /* @__PURE__ */ React70.createElement(
    FlexComponent21,
    {
      alignItems: "center",
      flexDirection: "column",
      height: "100%",
      justifyContent: "start"
    },
    children
  ));
}

// src/modules/delegation/pages/cargo-detail/content/form/post-cargo-detail-api.ts
var postCargoDetailApi = (_0) => __async(void 0, [_0], function* ({
  cargoId,
  config,
  cargoDetailEdit
}) {
  const endpoint = `${config.apiBase}/v1/fleet/cargos/${cargoId}/edit_delivery_address/`;
  return fetch(endpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${config.token}`
    },
    body: JSON.stringify(cargoDetailEdit)
  });
});

// src/modules/delegation/pages/cargo-detail/content/form/fieldset/fieldset-component.tsx
import React72 from "react";
import styled34 from "styled-components";
import { FlexComponent as FlexComponent22 } from "@ontruck/fe-ui";

// src/modules/delegation/pages/cargo-detail/content/form/fieldset/fieldset-legend-component.tsx
import React71 from "react";
import styled33 from "styled-components";
var FieldsetLegendContainer = styled33.legend`
  font-family: var(--otk-theme-font-family-primary, Roboto);
  font-size: var(--otk-theme-font-size-l, 18px);
  font-weight: var(--otk-theme-color-grey-900, #263340);
  color: var(--otk-theme-font-weight-medium, 500);
`;
function FieldsetLegendComponent({ children }) {
  return /* @__PURE__ */ React71.createElement(FieldsetLegendContainer, null, children);
}

// src/modules/delegation/pages/cargo-detail/content/form/fieldset/fieldset-component.tsx
var FieldSetContainer = styled34.div`
  width: 100%;
  padding: var(--otk-theme-space-xl) 0px var(--otk-theme-space-xl) 0px;
  background-color: var(--otk-theme-color-grey-100, #f2f5f8);
  background-color: ${(props) => Boolean(props.negative) && `var(--otk-theme-color-grey-200, #e2e8ee)`};

  :first-child {
    padding-bottom: 0;
  }
`;
var FlexContainerStyled2 = styled34(FlexComponent22)`
  width: 100%;

  legend {
    padding: 0px 0px var(--otk-theme-space-xl) 0px;
  }
`;
function FieldsetComponent({
  legend,
  negative,
  children
}) {
  return /* @__PURE__ */ React72.createElement(FieldSetContainer, { negative }, /* @__PURE__ */ React72.createElement(FlexComponent22, { alignItems: "center", flexDirection: "column", justifyContent: "center" }, /* @__PURE__ */ React72.createElement(FlexContainerStyled2, { flexDirection: "column", justifyContent: "center" }, legend ? /* @__PURE__ */ React72.createElement(FieldsetLegendComponent, null, legend) : null, children)));
}

// src/modules/delegation/pages/cargo-detail/content/form/fieldset/fieldset-label-component.tsx
import styled35 from "styled-components";
var FieldsetLabelComponent = styled35.label`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  font-family: var(--otk-theme-font-family-primary, Roboto);
  font-size: var(--otk-theme-font-size, 14px);
  font-weight: var(--otk-theme-font-weight-medium, 500);
  color: var(--otk-theme-color-grey-700, #54708c);
  width: 200px;
`;

// src/modules/delegation/pages/cargo-detail/content/form/fieldset/fieldset-labeled-value-component.tsx
import React73 from "react";
import styled37 from "styled-components";
import { FlexComponent as FlexComponent23 } from "@ontruck/fe-ui";

// src/modules/delegation/pages/cargo-detail/content/form/fieldset/fieldset-value-component.tsx
import styled36 from "styled-components";
var FieldsetValueComponent = styled36.span`
  font-family: var(--otk-theme-font-family-primary, Roboto);
  font-size: var(--otk-theme-font-size, 14px);
  font-weight: var(--otk-theme-font-weight, 400);
  color: var(--otk-theme-color-grey-700, #54708c);
`;

// src/modules/delegation/pages/cargo-detail/content/form/fieldset/fieldset-labeled-value-component.tsx
var FieldsetLabeledValueContainer = styled37(FlexComponent23)`
  width: 100%;
  border-bottom: 1px solid var(--otk-theme-color-grey-300);
  padding: 12px 0px 12px 12px;

  ${FieldsetLabelComponent} {
    width: 180px;
  }

  ${FieldsetValueComponent} {
    flex: 1;
  }

  :nth-child(2) {
    border-top: 1px solid var(--otk-theme-color-grey-300);
  }
`;
function FieldsetLabeledValueComponent({
  children
}) {
  return /* @__PURE__ */ React73.createElement(FieldsetLabeledValueContainer, { alignItems: "stretch" }, children);
}

// src/modules/delegation/pages/cargo-detail/content/form/post-cargo-detail-mapper-service.ts
function postCargoDetailMapperService({
  address,
  email,
  phoneNumber
}) {
  return {
    address_line: address.addressLine,
    zipcode: address.zipcode,
    city: address.city,
    contact_email: email,
    contact_phone: phoneNumber
  };
}

// src/modules/delegation/pages/cargo-detail/content/form/get-is-cargo-editable-service.ts
function getIsCargoEditableService(cargoState) {
  return cargoState !== cargoStateDto.inTransfer && cargoState !== cargoStateDto.outForDelivery;
}

// src/modules/delegation/pages/cargo-detail/content/form/form-component.tsx
var EDIT_BUTTON_LABEL = "Editar";
var CONTENT_WIDTH = "600px";
var formStateActionType = {
  updateEditAddressState: "update_edit_address_state",
  updateEditPhoneNumberState: "update_edit_phone_number_state",
  updateEditEmailState: "update_edit_email_state",
  updateEditState: "update_edit_state"
};
var FormEditTextButtonComponent = styled38(ButtonComponent12)`
  margin: 0 0 0 10px;
`;
var FormCloseIcon = styled38(CloseIcon14)`
  margin: 0 0 0 10px;
`;
var FormStickyComponent = styled38(Sticky6)`
  height: 80px;
  align-items: center;
  justify-content: center;
`;
var FormBoxesSpinnerComponent = styled38(BoxesSpinnerComponent)`
  path {
    fill: #fff;
  }
`;
var StyledFlexContainer = styled38(FlexComponent24)`
  flex-direction: column;
  width: 100%;
`;
function FormComponent({
  cargoDetail,
  onSaveChangesSuccess
}) {
  const [isSavingChanges, setIsSavingChanges] = useState20(false);
  const [editedFields, setEditedFields] = useState20(false);
  const [editingField, setEditingField] = useState20();
  const isCargoEditable = getIsCargoEditableService(cargoDetail.state);
  const config = useConfigHook();
  const hasEditChanges = editedFields;
  const formStateReducer = (state, action) => {
    if (action.type === formStateActionType.updateEditAddressState) {
      return __spreadProps(__spreadValues({}, state), {
        address: __spreadValues({}, action.payload)
      });
    }
    if (action.type === formStateActionType.updateEditEmailState) {
      return __spreadProps(__spreadValues({}, state), {
        email: action.payload
      });
    }
    if (action.type === formStateActionType.updateEditPhoneNumberState) {
      return __spreadProps(__spreadValues({}, state), {
        phoneNumber: action.payload
      });
    }
    return __spreadValues(__spreadValues({}, state), action.payload);
  };
  const formStateInitialState = {
    address: {
      addressLine: cargoDetail.deliveryData.address.addressLine || "",
      city: cargoDetail.deliveryData.address.city || "",
      zipcode: cargoDetail.deliveryData.address.zipcode || ""
    },
    phoneNumber: cargoDetail.deliveryData.phoneNumber || "",
    email: cargoDetail.deliveryData.email || ""
  };
  const [formState, formStateDispatch] = useReducer(formStateReducer, formStateInitialState);
  const getIsEditFormStateEqualToCargoDetailLessValueTypeEdited = (valueTypeFilter) => {
    if (valueTypeFilter !== "addressLine" && valueTypeFilter !== "address") {
      if (cargoDetail.deliveryData.address.addressLine !== formState.address.addressLine) {
        return false;
      }
    }
    if (valueTypeFilter !== "city" && valueTypeFilter !== "address") {
      if (cargoDetail.deliveryData.address.city !== formState.address.city) {
        return false;
      }
    }
    if (valueTypeFilter !== "zipcode" && valueTypeFilter !== "address") {
      if (cargoDetail.deliveryData.address.zipcode !== formState.address.zipcode) {
        return false;
      }
    }
    if (valueTypeFilter !== "phoneNumber") {
      if (cargoDetail.deliveryData.phoneNumber !== formState.phoneNumber) {
        return false;
      }
    }
    if (valueTypeFilter !== "email") {
      if (cargoDetail.deliveryData.email !== formState.email) {
        return false;
      }
    }
    return true;
  };
  const handleTurnOnEditAddressMode = () => {
    setEditingField("address");
  };
  const handleTurnOnEditPhoneNumberMode = () => {
    setEditingField("phoneNumber");
  };
  const handleTurnOnEditEmailMode = () => {
    setEditingField("email");
  };
  const handleTurnOffAddressMode = () => {
    formStateDispatch({
      type: formStateActionType.updateEditAddressState,
      payload: __spreadProps(__spreadValues({}, formState.address), {
        addressLine: cargoDetail.deliveryData.address.addressLine || "",
        city: cargoDetail.deliveryData.address.city || "",
        zipcode: cargoDetail.deliveryData.address.zipcode || ""
      })
    });
    const isEditFormStateEqualToCargoDetailLessValueTypeEdited = getIsEditFormStateEqualToCargoDetailLessValueTypeEdited("address");
    if (isEditFormStateEqualToCargoDetailLessValueTypeEdited) {
      setEditedFields(false);
    }
    setEditingField(void 0);
  };
  const handleTurnOffPhoneNumberMode = () => {
    formStateDispatch({
      type: formStateActionType.updateEditPhoneNumberState,
      payload: cargoDetail.deliveryData.phoneNumber || ""
    });
    const isEditFormStateEqualToCargoDetailLessValueTypeEdited = getIsEditFormStateEqualToCargoDetailLessValueTypeEdited("phoneNumber");
    if (isEditFormStateEqualToCargoDetailLessValueTypeEdited) {
      setEditedFields(false);
    }
    setEditingField(void 0);
  };
  const handleTurnOffEmailMode = () => {
    formStateDispatch({
      type: formStateActionType.updateEditEmailState,
      payload: cargoDetail.deliveryData.email || ""
    });
    const isEditFormStateEqualToCargoDetailLessValueTypeEdited = getIsEditFormStateEqualToCargoDetailLessValueTypeEdited("email");
    if (isEditFormStateEqualToCargoDetailLessValueTypeEdited) {
      setEditedFields(false);
    }
    setEditingField(void 0);
  };
  const handleChangeAddressLineValue = (e) => {
    const value = e.currentTarget.value;
    formStateDispatch({
      type: formStateActionType.updateEditAddressState,
      payload: __spreadProps(__spreadValues({}, formState.address), {
        addressLine: value
      })
    });
    const isEditFormStateEqualToCargoDetailLessValueTypeEdited = getIsEditFormStateEqualToCargoDetailLessValueTypeEdited("addressLine");
    if (value === cargoDetail.deliveryData.address.addressLine && isEditFormStateEqualToCargoDetailLessValueTypeEdited) {
      setEditedFields(false);
      return;
    }
    setEditedFields(true);
  };
  const handleChangeAddressCityValue = (e) => {
    const value = e.currentTarget.value;
    formStateDispatch({
      type: formStateActionType.updateEditAddressState,
      payload: __spreadProps(__spreadValues({}, formState.address), {
        city: value
      })
    });
    const isEditFormStateEqualToCargoDetailLessValueTypeEdited = getIsEditFormStateEqualToCargoDetailLessValueTypeEdited("city");
    if (value === cargoDetail.deliveryData.address.city && isEditFormStateEqualToCargoDetailLessValueTypeEdited) {
      setEditedFields(false);
      return;
    }
    setEditedFields(true);
  };
  const handleChangeAddressZipcodeValue = (e) => {
    const value = e.currentTarget.value;
    formStateDispatch({
      type: formStateActionType.updateEditAddressState,
      payload: __spreadProps(__spreadValues({}, formState.address), {
        zipcode: value
      })
    });
    const isEditFormStateEqualToCargoDetailLessValueTypeEdited = getIsEditFormStateEqualToCargoDetailLessValueTypeEdited("zipcode");
    if (value === cargoDetail.deliveryData.address.zipcode && isEditFormStateEqualToCargoDetailLessValueTypeEdited) {
      setEditedFields(false);
      return;
    }
    setEditedFields(true);
  };
  const handleChangePhoneNumberValue = (e) => {
    const value = e.currentTarget.value;
    formStateDispatch({
      type: formStateActionType.updateEditPhoneNumberState,
      payload: value
    });
    const isEditFormStateEqualToCargoDetailLessValueTypeEdited = getIsEditFormStateEqualToCargoDetailLessValueTypeEdited("phoneNumber");
    if (value === cargoDetail.deliveryData.phoneNumber && isEditFormStateEqualToCargoDetailLessValueTypeEdited) {
      setEditedFields(false);
      return;
    }
    setEditedFields(true);
  };
  const handleChangeEmailValue = (e) => {
    const value = e.currentTarget.value;
    formStateDispatch({
      type: formStateActionType.updateEditEmailState,
      payload: value
    });
    const isEditFormStateEqualToCargoDetailLessValueTypeEdited = getIsEditFormStateEqualToCargoDetailLessValueTypeEdited("email");
    if (value === cargoDetail.deliveryData.email && isEditFormStateEqualToCargoDetailLessValueTypeEdited) {
      setEditedFields(false);
      return;
    }
    setEditedFields(true);
  };
  const handleSaveChanges = () => __async(this, null, function* () {
    setIsSavingChanges(true);
    try {
      const formStateDto = postCargoDetailMapperService(formState);
      const response = yield postCargoDetailApi({
        cargoId: cargoDetail.id,
        cargoDetailEdit: formStateDto,
        config
      });
      if (!response.ok) {
        throw new Error();
      }
      toast18.success("Detalle del paquete editado con \xE9xito");
      if (onSaveChangesSuccess) {
        yield onSaveChangesSuccess();
      }
    } catch (e) {
      toast18.error("La edici\xF3n del detalle del paquete no se ha podido completar");
    } finally {
      setIsSavingChanges(false);
    }
  });
  return /* @__PURE__ */ React74.createElement(StyledFlexContainer, { alignItems: "stretch" }, /* @__PURE__ */ React74.createElement(ContentComponent, null, /* @__PURE__ */ React74.createElement(
    FlexComponent24,
    {
      alignItems: "center",
      flexDirection: "column",
      justifyContent: "center",
      width: CONTENT_WIDTH
    },
    /* @__PURE__ */ React74.createElement(FieldsetComponent, { legend: "Informaci\xF3n del pedido" }, /* @__PURE__ */ React74.createElement(FieldsetLabeledValueComponent, null, /* @__PURE__ */ React74.createElement(FieldsetLabelComponent, null, "Cliente"), /* @__PURE__ */ React74.createElement(FieldsetValueComponent, null, cargoDetail.orderInfo.shipper)), /* @__PURE__ */ React74.createElement(FieldsetLabeledValueComponent, null, /* @__PURE__ */ React74.createElement(FieldsetLabelComponent, null, "Tipo de servicio"), /* @__PURE__ */ React74.createElement(FieldsetValueComponent, null, cargoDetail.orderInfo.serviceType)), /* @__PURE__ */ React74.createElement(FieldsetLabeledValueComponent, null, /* @__PURE__ */ React74.createElement(FieldsetLabelComponent, null, "Intentos de entrega"), /* @__PURE__ */ React74.createElement(FieldsetValueComponent, null, cargoDetail.orderInfo.deliveryAttempts))),
    /* @__PURE__ */ React74.createElement(FieldsetComponent, { legend: "Informaci\xF3n de entrega" }, /* @__PURE__ */ React74.createElement(FieldsetLabeledValueComponent, null, /* @__PURE__ */ React74.createElement(FieldsetLabelComponent, null, "Cliente final"), /* @__PURE__ */ React74.createElement(FieldsetValueComponent, null, cargoDetail.deliveryData.finalCustomer)), /* @__PURE__ */ React74.createElement(FieldsetLabeledValueComponent, null, /* @__PURE__ */ React74.createElement(FieldsetLabelComponent, null, "Direcci\xF3n"), editingField === "address" ? /* @__PURE__ */ React74.createElement(
      FlexComponent24,
      {
        alignItems: "center",
        flex: "1",
        flexDirection: "row",
        justifyContent: "space-between"
      },
      /* @__PURE__ */ React74.createElement(
        FlexComponent24,
        {
          alignItems: "start",
          flexDirection: "column",
          gap: "5px",
          justifyContent: "center",
          width: "100%"
        },
        /* @__PURE__ */ React74.createElement(FlexComponent24, { width: "100%" }, /* @__PURE__ */ React74.createElement(
          Input14,
          {
            handleChangeEvent: handleChangeAddressLineValue,
            label: "Direcci\xF3n",
            name: "address",
            type: "text",
            value: formState.address.addressLine
          }
        )),
        /* @__PURE__ */ React74.createElement(FlexComponent24, { gap: "5px", width: "100%" }, /* @__PURE__ */ React74.createElement(
          Input14,
          {
            handleChangeEvent: handleChangeAddressCityValue,
            label: "Ciudad",
            name: "address",
            type: "text",
            value: formState.address.city
          }
        ), /* @__PURE__ */ React74.createElement(
          Input14,
          {
            handleChangeEvent: handleChangeAddressZipcodeValue,
            label: "C.P. destino",
            name: "address",
            type: "text",
            value: formState.address.zipcode
          }
        ))
      ),
      /* @__PURE__ */ React74.createElement(ButtonComponent12, { onClick: handleTurnOffAddressMode, type: "button", variant: "icon" }, /* @__PURE__ */ React74.createElement(FormCloseIcon, { sizeInPixels: 12 }))
    ) : /* @__PURE__ */ React74.createElement(
      FlexComponent24,
      {
        alignItems: "center",
        flex: "1",
        flexDirection: "row",
        justifyContent: "space-between",
        width: "100% "
      },
      /* @__PURE__ */ React74.createElement(FieldsetValueComponent, null, formState.address.addressLine, " - ", formState.address.city, " ", formState.address.zipcode),
      isCargoEditable ? /* @__PURE__ */ React74.createElement(
        FormEditTextButtonComponent,
        {
          color: "primary",
          onClick: handleTurnOnEditAddressMode,
          size: "s",
          variant: "text"
        },
        EDIT_BUTTON_LABEL
      ) : null
    )), /* @__PURE__ */ React74.createElement(FieldsetLabeledValueComponent, null, /* @__PURE__ */ React74.createElement(FieldsetLabelComponent, null, "Informaci\xF3n adicional"), /* @__PURE__ */ React74.createElement(FieldsetValueComponent, null, /* @__PURE__ */ React74.createElement(TextComponent20, null, cargoDetail.deliveryData.additionalAddressInfo))), /* @__PURE__ */ React74.createElement(FieldsetLabeledValueComponent, null, /* @__PURE__ */ React74.createElement(FieldsetLabelComponent, null, "Numero de tel\xE9fono"), /* @__PURE__ */ React74.createElement(FieldsetValueComponent, null, editingField === "phoneNumber" ? /* @__PURE__ */ React74.createElement(
      FlexComponent24,
      {
        alignItems: "center",
        flexDirection: "row",
        justifyContent: "space-between"
      },
      /* @__PURE__ */ React74.createElement(
        Input14,
        {
          handleChangeEvent: handleChangePhoneNumberValue,
          name: "phone_number",
          type: "text",
          value: formState.phoneNumber
        }
      ),
      /* @__PURE__ */ React74.createElement(
        ButtonComponent12,
        {
          onClick: handleTurnOffPhoneNumberMode,
          type: "button",
          variant: "icon"
        },
        /* @__PURE__ */ React74.createElement(FormCloseIcon, { sizeInPixels: 12 })
      )
    ) : /* @__PURE__ */ React74.createElement(
      FlexComponent24,
      {
        alignItems: "center",
        flexDirection: "row",
        justifyContent: "space-between"
      },
      /* @__PURE__ */ React74.createElement(TextComponent20, null, formState.phoneNumber),
      isCargoEditable ? /* @__PURE__ */ React74.createElement(
        FormEditTextButtonComponent,
        {
          color: "primary",
          onClick: handleTurnOnEditPhoneNumberMode,
          size: "s",
          variant: "text"
        },
        EDIT_BUTTON_LABEL
      ) : null
    ))), /* @__PURE__ */ React74.createElement(FieldsetLabeledValueComponent, null, /* @__PURE__ */ React74.createElement(FieldsetLabelComponent, null, "Email"), /* @__PURE__ */ React74.createElement(FieldsetValueComponent, null, editingField === "email" ? /* @__PURE__ */ React74.createElement(
      FlexComponent24,
      {
        alignItems: "center",
        flexDirection: "row",
        justifyContent: "space-between"
      },
      /* @__PURE__ */ React74.createElement(
        Input14,
        {
          handleChangeEvent: handleChangeEmailValue,
          name: "email",
          type: "text",
          value: formState.email
        }
      ),
      /* @__PURE__ */ React74.createElement(ButtonComponent12, { onClick: handleTurnOffEmailMode, type: "button", variant: "icon" }, /* @__PURE__ */ React74.createElement(FormCloseIcon, { sizeInPixels: 12 }))
    ) : /* @__PURE__ */ React74.createElement(
      FlexComponent24,
      {
        alignItems: "center",
        flexDirection: "row",
        justifyContent: "space-between"
      },
      /* @__PURE__ */ React74.createElement(TextComponent20, null, formState.email),
      isCargoEditable ? /* @__PURE__ */ React74.createElement(
        FormEditTextButtonComponent,
        {
          color: "primary",
          onClick: handleTurnOnEditEmailMode,
          size: "s",
          variant: "text"
        },
        EDIT_BUTTON_LABEL
      ) : null
    ))), /* @__PURE__ */ React74.createElement(FieldsetLabeledValueComponent, null, /* @__PURE__ */ React74.createElement(FieldsetLabelComponent, null, "Detalles de entrega"), /* @__PURE__ */ React74.createElement(FieldsetValueComponent, null, cargoDetail.deliveryData.deliveryDetails)))
  )), /* @__PURE__ */ React74.createElement(FormStickyComponent, null, isCargoEditable ? /* @__PURE__ */ React74.createElement(ButtonContainer6, null, /* @__PURE__ */ React74.createElement(Half6, null, /* @__PURE__ */ React74.createElement(
    ButtonComponent12,
    {
      color: "primary",
      fullWidth: true,
      isDisabled: !hasEditChanges || isSavingChanges,
      onClick: () => void handleSaveChanges()
    },
    isSavingChanges ? /* @__PURE__ */ React74.createElement(FormBoxesSpinnerComponent, { sizeInPixels: 16 }) : null,
    isSavingChanges ? "Guardando los cambios" : "Guardar los cambios"
  ))) : null));
}

// src/modules/delegation/pages/cargo-detail/cargo-detail-page.tsx
var StyledFlexContainer2 = styled39(FlexComponent25)`
  flex-grow: 1;
  overflow-y: hidden;
`;
var DelegationCargoDetailLogs = styled39(MonitorComponent)`
  width: 400px;
`;
function DelegationCargoDetailPage({
  cargoId,
  pathname,
  config,
  onCloseDetail,
  onGoingBack
}) {
  const [key, setKey] = useState21(pathname);
  const [logEvents, setLogEvents] = useState21([]);
  const { isLoading, cargoDetail, error, mutate } = useGetCargoDetailHook({
    cargoId,
    config,
    key: pathname
  });
  useEffect6(() => {
    if (isLoading || logEvents.length > 0) {
      return;
    }
    const events = getCargoDetailLogsService(cargoDetail);
    setLogEvents(events);
  }, [cargoDetail, isLoading, logEvents]);
  const handleSaveChangesSuccess = () => __async(this, null, function* () {
    yield mutate();
    setKey(key + 1);
  });
  if (error) {
    return /* @__PURE__ */ React75.createElement(CargoDetailErrorComponent, { onGoingBack });
  }
  return /* @__PURE__ */ React75.createElement(ConfigProvider, { apiBase: config.apiBase, delegations: config.delegations, token: config.token }, /* @__PURE__ */ React75.createElement(PageLayout17, null, /* @__PURE__ */ React75.createElement(HeaderComponent, { onClose: onCloseDetail }, /* @__PURE__ */ React75.createElement(HeaderComponent.Label, null, "Detalles"), /* @__PURE__ */ React75.createElement(HeaderComponent.Id, null, cargoDetail.externalId)), isLoading ? /* @__PURE__ */ React75.createElement(PageContent17, null, /* @__PURE__ */ React75.createElement(ContentComponent, null, /* @__PURE__ */ React75.createElement(CargoDetailSkeletonComponent, null))) : /* @__PURE__ */ React75.createElement(PageContent17, null, /* @__PURE__ */ React75.createElement(StyledFlexContainer2, { alignItems: "stretch", flexDirection: "row", gap: "0" }, /* @__PURE__ */ React75.createElement(
    FormComponent,
    {
      cargoDetail,
      key,
      onSaveChangesSuccess: handleSaveChangesSuccess
    }
  ), logEvents.length > 0 ? /* @__PURE__ */ React75.createElement(DelegationCargoDetailLogs, { events: logEvents }) : null)), /* @__PURE__ */ React75.createElement(Toaster14, { richColors: true })));
}

// src/modules/network/config-context.ts
import { createContext as createContext2 } from "react";
var networkConfig = {
  token: "",
  apiBase: ""
};
var NetworkConfigContext = createContext2(networkConfig);

// src/modules/network/config-provider.tsx
import React76 from "react";

// src/modules/network/config-hook.ts
import { useContext as useContext2 } from "react";

// src/modules/network/pages/routes/routes-page.tsx
import React162, { useState as useState43, useMemo as useMemo49, useEffect as useEffect19, useCallback as useCallback21 } from "react";
import { createPortal as createPortal2 } from "react-dom";
import { Toaster as Toaster15 } from "sonner";
import {
  FlexComponent as FlexComponent89,
  DrawerComponent as DrawerComponent3,
  DRAWER_REGION_ID_RIGHT,
  DRAWER_REGION_ID_LEFT
} from "@ontruck/fe-ui";

// src/modules/network/components/page-layout/page-layout-component.tsx
import React83, { useEffect as useEffect9, useState as useState24 } from "react";
import styled43 from "styled-components";
import { createPortal } from "react-dom";
import { FlexComponent as FlexComponent30 } from "@ontruck/fe-ui";

// src/modules/regions.ts
var TOP_BAR_MODULE_REGION_ID = "top-bar-module-region";
var TOP_BAR_MODULE_ACTIVE_EVALUATION_ID = "top-bar-module-active-evaluation-id";

// src/modules/network/components/left-sidebar-navigation/left-sidebar-navigation-component.tsx
import React78 from "react";
import { FlexComponent as FlexComponent27, ButtonComponent as ButtonComponent14 } from "@ontruck/fe-ui";
import { IconComponent as IconComponent5 } from "@ontruck/fe-icons";

// src/modules/network/constants/index.ts
var DEFAULT_DELEGATION_NAME = "Madrid Getafe";
var navigationItemsIds = {
  ROUTES: "ROUTES",
  EVALUATOR: "EVALUATOR",
  SOURCE: "SOURCE"
};
var DEFAULT_TIME_ZONE = "Europe/Madrid";

// src/modules/network/components/left-sidebar-navigation/navigation-item.tsx
import React77 from "react";
import styled40 from "styled-components";
import { FlexComponent as FlexComponent26, ButtonComponent as ButtonComponent13 } from "@ontruck/fe-ui";
import { IconComponent as IconComponent4 } from "@ontruck/fe-icons";
var NavigationItemButton = styled40(ButtonComponent13)`
  padding-top: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid var(--otk-theme-color-grey-700, #54708c);

  &:hover {
    background-color: ${({ isSelected }) => {
  return !isSelected && "var(--otk-theme-color-secondary-900, #000b1a)";
}};

    border: ${({ isSelected }) => {
  return !isSelected && "1px solid var(--otk-theme-color-secondary-900, 1px solid #000b1a)";
}};

    border-bottom: 1px solid var(--otk-theme-color-grey-700, #54708c);
  }
`;
function NavigationItemComponent({
  id,
  icon,
  isSelected = false,
  onClick
}) {
  const handleClick = () => {
    if (onClick) {
      onClick(id);
    }
  };
  return /* @__PURE__ */ React77.createElement(FlexComponent26, { alignItems: "center", justifyContent: "center", width: "100%" }, /* @__PURE__ */ React77.createElement(
    NavigationItemButton,
    {
      color: isSelected ? "primary" : "secondary",
      isSelected,
      onClick: handleClick,
      size: "s"
    },
    /* @__PURE__ */ React77.createElement(IconComponent4, { colorVariant: isSelected ? "primary" : "grey", name: icon, size: "xl" })
  ));
}

// src/modules/network/components/left-sidebar-navigation/left-sidebar-navigation-component.tsx
var LEFT_SIDEBAR_NAVIGATION_WIDTH = 61;
function LeftSideBarNavigationComponent({
  itemIdSelected,
  onClickItem,
  isAvailableCreateNewRoute = false,
  onClickCreateNewRoute
}) {
  const handleChange = (id) => {
    if (onClickItem) {
      onClickItem(id);
    }
  };
  return /* @__PURE__ */ React78.createElement(
    FlexComponent27,
    {
      alignItems: "center",
      backgroundColor: "var(--otk-theme-color-secondary, #00204d)",
      flexDirection: "column",
      height: "100%",
      justifyContent: "space-between",
      width: `${LEFT_SIDEBAR_NAVIGATION_WIDTH}px`
    },
    /* @__PURE__ */ React78.createElement(
      FlexComponent27,
      {
        flexDirection: "column",
        flexGrow: "1",
        height: "auto",
        width: `${LEFT_SIDEBAR_NAVIGATION_WIDTH}px`
      },
      /* @__PURE__ */ React78.createElement(
        NavigationItemComponent,
        {
          icon: "cog-data-report",
          id: navigationItemsIds.SOURCE,
          isSelected: itemIdSelected === navigationItemsIds.SOURCE,
          onClick: handleChange
        }
      ),
      /* @__PURE__ */ React78.createElement(
        NavigationItemComponent,
        {
          icon: "monitor-heart-beat-search",
          id: navigationItemsIds.EVALUATOR,
          isSelected: itemIdSelected === navigationItemsIds.EVALUATOR,
          onClick: handleChange
        }
      ),
      /* @__PURE__ */ React78.createElement(
        NavigationItemComponent,
        {
          icon: "building",
          id: navigationItemsIds.ROUTES,
          isSelected: itemIdSelected === navigationItemsIds.ROUTES,
          onClick: handleChange
        }
      )
    ),
    /* @__PURE__ */ React78.createElement(FlexComponent27, { margin: "0 0 var(--otk-theme-space-l) 0" }, isAvailableCreateNewRoute ? /* @__PURE__ */ React78.createElement(
      ButtonComponent14,
      {
        circle: true,
        color: "primary",
        onClick: onClickCreateNewRoute,
        size: "s",
        variant: "icon"
      },
      /* @__PURE__ */ React78.createElement(IconComponent5, { name: "plus" })
    ) : null)
  );
}

// src/modules/network/components/top-bar-active-evaluation/top-bar-active-evaluation-component.tsx
import { es as es2 } from "date-fns/locale";
import React81 from "react";
import styled41 from "styled-components";
import { formatInTimeZone as formatInTimeZone2 } from "date-fns-tz";
import { ButtonComponent as ButtonComponent15 } from "@ontruck/fe-ui";

// src/modules/network/state/network-state-provider.tsx
import React79, { useState as useState22, useEffect as useEffect7 } from "react";

// src/modules/network/evaluations/get-evaluations-hook.ts
import useSWR16 from "swr";

// src/modules/network/evaluations/get-evaluations-api.ts
import { format as format2, subDays } from "date-fns";
var getEvaluationsApi = (_0) => __async(void 0, [_0], function* ({
  config
}) {
  const initialDate = format2(subDays(/* @__PURE__ */ new Date(), 100), "yyyy-MM-dd");
  const endDate = format2(/* @__PURE__ */ new Date(), "yyyy-MM-dd");
  const query = `?package_date__gte=${initialDate}&package_date__lte=${endDate}&order_by=-package_date&page_size=200`;
  const url = `${config.apiBase}/concordia/v1/networks/networks/${query}`;
  const response = yield fetch(url, {
    method: "GET",
    cache: "no-cache",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${config.token}`
    }
  });
  if (response.ok) {
    const data = yield response.json();
    return data;
  }
  throw new Error("Failed to fetch evaluations");
});

// src/modules/network/evaluations/get-evaluations-fetcher.ts
var getEvaluationsFetcher = (config) => {
  return getEvaluationsApi({ config });
};

// src/modules/network/evaluations/get-evaluations-mapper.ts
function getEvaluationsMapper(evaluationsDto) {
  if (!evaluationsDto) {
    return [];
  }
  return evaluationsDto.results.map((evaluation) => ({
    id: evaluation.id,
    packageDate: evaluation.package_date,
    routeDate: evaluation.route_date,
    scenarioId: evaluation.scenario_id
  }));
}

// src/modules/network/evaluations/get-evaluations-hook.ts
var useGetEvaluationsHook = ({
  config
}) => {
  const fetcher = () => __async(void 0, null, function* () {
    return getEvaluationsFetcher(config);
  });
  const { data, error, isLoading, mutate } = useSWR16(
    "evaluations",
    fetcher,
    {
      revalidateOnFocus: false,
      refreshInterval: 0,
      revalidateIfStale: false
    }
  );
  const evaluationsMapped = getEvaluationsMapper(data);
  return {
    evaluations: evaluationsMapped,
    isLoading,
    error,
    mutate
  };
};

// src/modules/network/evaluations/get-evaluations-with-scenario-api.ts
var getEvaluationsWithScenarioApi = (_0) => __async(void 0, [_0], function* ({
  config
}) {
  const url = `${config.apiBase}/concordia/v1/networks/networks/?page_size=0&scenario_id__isnull=false`;
  const response = yield fetch(url, {
    method: "GET",
    cache: "no-cache",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${config.token}`
    }
  });
  if (response.ok) {
    const data = yield response.json();
    return data;
  }
  throw new Error("Failed to fetch evaluations");
});

// src/modules/network/state/network-state-context.ts
import { createContext as createContext3 } from "react";
var routesViews = {
  map: "map",
  table: "table",
  timeline: "timeline"
};
var NetworkStateContext = createContext3({
  evaluationPackageDate: void 0,
  evaluationRouteDate: void 0,
  evaluations: [],
  launchEvaluation: () => void 0,
  launchScenarioEvaluation: () => void 0,
  networkId: void 0,
  routesView: "map",
  scenarioName: void 0,
  scenarioParentId: void 0,
  selectedDelegationId: void 0,
  setNetworkId: () => void 0,
  setRoutesView: () => void 0,
  setScenarioName: () => void 0,
  setScenarioParentId: () => void 0,
  setSelectedDelegationId: () => void 0
});

// src/modules/network/state/network-state-provider.tsx
function NetworkStateProvider({
  children,
  config
}) {
  const [networkId, setNetworkId] = useState22();
  const [scenarioName, setScenarioName] = useState22();
  const [scenarioParentId, setScenarioParentId] = useState22();
  const [evaluationPackageDate, setEvaluationPackageDate] = useState22();
  const [evaluationRouteDate, setEvaluationRouteDate] = useState22();
  const [selectedDelegationId, setSelectedDelegationId] = useState22();
  const [routesView, setRoutesView] = useState22(routesViews.map);
  const { evaluations } = useGetEvaluationsHook({
    config
  });
  const setEvaluation = (newEvaluation) => {
    setEvaluationPackageDate(newEvaluation.packageDate);
    setEvaluationRouteDate(newEvaluation.routeDate);
    setNetworkId(newEvaluation.id.toString());
  };
  useEffect7(() => {
    if (evaluations.length > 0 && !networkId) {
      setEvaluation(evaluations[0]);
    }
  }, [evaluations, networkId]);
  const launchEvaluation = (nextEvaluationPackageDate, nextEvaluationRouteDate) => {
    const nextEvaluation = evaluations.find(
      (evaluation) => evaluation.packageDate === nextEvaluationPackageDate && evaluation.routeDate === nextEvaluationRouteDate
    );
    if (nextEvaluation) {
      setScenarioName(void 0);
      setSelectedDelegationId(void 0);
      setScenarioParentId(void 0);
      setEvaluation(nextEvaluation);
    }
  };
  const launchScenarioEvaluation = ({
    evaluationId,
    scenarioName: evaluationScenarioName
  }) => {
    getEvaluationsWithScenarioApi({ config }).then((evaluationsResults) => evaluationsResults).then((evaluationsResults) => getEvaluationsMapper(evaluationsResults)).then((evaluationsRefreshedMapped) => {
      const nextEvaluation = evaluationsRefreshedMapped.find(
        (evaluation) => evaluation.id.toString() === evaluationId
      );
      if (!nextEvaluation) {
        console.error(`Not found launch scenario evaluation with id: ${evaluationId}`);
        return;
      }
      setSelectedDelegationId(void 0);
      setScenarioName(evaluationScenarioName);
      setEvaluation(nextEvaluation);
    }).catch((error) => {
      console.error("Error launching evaluation by id", error);
    });
  };
  return /* @__PURE__ */ React79.createElement(
    NetworkStateContext.Provider,
    {
      value: {
        evaluationPackageDate,
        evaluationRouteDate,
        evaluations,
        launchEvaluation,
        launchScenarioEvaluation,
        networkId,
        routesView,
        scenarioName,
        scenarioParentId,
        selectedDelegationId,
        setNetworkId,
        setRoutesView,
        setScenarioName,
        setScenarioParentId,
        setSelectedDelegationId
      }
    },
    children
  );
}

// src/modules/network/state/network-state-hook.ts
import { useContext as useContext3 } from "react";
function useNetworkState() {
  return useContext3(NetworkStateContext);
}

// src/modules/network/scenario/draft-scenarios-store.ts
import { createStore } from "zustand";
import { useZustand } from "use-zustand";

// src/modules/network/scenario/get-draft-scenario-from-routes-changes-service.ts
import uuid from "react-uuid";

// src/modules/network/routes/get-routes-api.ts
var getRoutesApi = (_0) => __async(void 0, [_0], function* ({
  networkId,
  config
}) {
  const url = `${config.apiBase}/concordia/v1/networks/networks/${networkId}/leg_routes/?page_size=0`;
  const response = yield fetch(url, {
    method: "GET",
    cache: "no-cache",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${config.token}`
    }
  });
  if (response.ok) {
    const data = yield response.json();
    return data;
  }
  throw new Error("Failed to fetch routes");
});

// src/modules/network/routes/get-routes-service.ts
function getRoutesService(routesIds, routes) {
  return routes.filter((route) => routesIds.includes(route.id));
}

// src/modules/network/routes/get-routes-by-ids-service.ts
var getRoutesByIdsService = (ids, routes) => {
  if (ids.length === 0) {
    return routes;
  }
  const routesIdentifiers = new Set(ids);
  return routes.filter((route) => routesIdentifiers.has(route.routeIdentifier));
};

// src/modules/network/routes/get-routes-fetcher.ts
var getRoutesFetcher = (networkId, config) => {
  return getRoutesApi({ networkId, config });
};

// src/modules/network/routes/get-routes-hook.ts
import useSWR17 from "swr";

// src/modules/network/services/get-iso-to-local-time-formatted-service.ts
import { parseISO } from "date-fns";
import { formatInTimeZone } from "date-fns-tz";
function getISOToLocalTimeFormatted(isoStringDate) {
  if (!isoStringDate) {
    return "";
  }
  return formatInTimeZone(parseISO(isoStringDate), DEFAULT_TIME_ZONE, "HH:mm");
}

// src/modules/network/networks/network-dto.ts
var networkLegTypes = {
  spot: "spot",
  contract: "contract"
};
var networkLegRouteResultsVehicleTypesDto = {
  trailer: "TRAILER",
  van: "VAN"
};

// src/modules/network/routes/route.ts
var routeTypes = networkLegTypes;
var routeOperations = {
  arrival: "arrival",
  departure: "departure",
  transit: "transit"
};
var routeVehicleTypes = networkLegRouteResultsVehicleTypesDto;

// src/modules/network/routes/get-routes-mapper.ts
function getOrigin(route) {
  var _a;
  const firstStop = route.stops[0];
  return {
    id: String(route.origin.id),
    name: route.origin.name,
    delegationCode: route.origin.delegation_code,
    coordinates: {
      longitude: route.origin.longitude,
      latitude: route.origin.latitude
    },
    operation: routeOperations.departure,
    theoreticalDepartureTime: getISOToLocalTimeFormatted(firstStop.theoretical_departure_time),
    actualDepartureTime: getISOToLocalTimeFormatted(firstStop.actual_departure_time),
    skipped: (_a = firstStop.skipped) != null ? _a : false
  };
}
function getDestination(route) {
  var _a;
  const lastStop = route.stops[route.stops.length - 1];
  return {
    id: String(route.destination.id),
    name: route.destination.name,
    delegationCode: route.destination.delegation_code,
    coordinates: {
      longitude: route.destination.longitude,
      latitude: route.destination.latitude
    },
    operation: routeOperations.arrival,
    theoreticalArrivalTime: getISOToLocalTimeFormatted(lastStop.theoretical_arrival_time),
    actualArrivalTime: !lastStop.skipped ? getISOToLocalTimeFormatted(lastStop.actual_arrival_time) : void 0,
    skipped: (_a = lastStop.skipped) != null ? _a : false
  };
}
function getOriginFromLeg(leg) {
  return {
    id: String(leg.origin.id),
    name: leg.origin.name,
    delegationCode: leg.origin.delegation_code,
    coordinates: {
      longitude: leg.origin.longitude,
      latitude: leg.origin.latitude
    },
    operation: routeOperations.departure,
    theoreticalDepartureTime: getISOToLocalTimeFormatted(leg.theoretical_departure_time),
    actualDepartureTime: getISOToLocalTimeFormatted(leg.actual_departure_time),
    skipped: false
    // Because legs endpoint always return legs with not skipped stops
  };
}
function getDestinationFromLeg(leg) {
  return {
    id: String(leg.destination.id),
    name: leg.destination.name,
    delegationCode: leg.destination.delegation_code,
    coordinates: {
      longitude: leg.destination.longitude,
      latitude: leg.destination.latitude
    },
    operation: routeOperations.arrival,
    theoreticalArrivalTime: getISOToLocalTimeFormatted(leg.theoretical_arrival_time),
    actualArrivalTime: getISOToLocalTimeFormatted(leg.actual_arrival_time),
    skipped: false
    // Because legs endpoint always return legs with not skipped stops
  };
}
function getLegs(route) {
  if (!(route == null ? void 0 : route.legs)) {
    return [];
  }
  return route.legs.map((leg) => {
    const origin = getOriginFromLeg(leg);
    const destination = getDestinationFromLeg(leg);
    return {
      id: String(leg.id),
      alerts: [...leg.alerts].map((a) => getAlertMapper(a)),
      origin,
      destination
    };
  });
}
function getStops(route) {
  if (!(route == null ? void 0 : route.stops)) {
    return [];
  }
  return route.stops.map((stop, i) => {
    var _a, _b, _c;
    return {
      actualArrivalTime: !stop.skipped ? getISOToLocalTimeFormatted(stop.actual_arrival_time) : void 0,
      actualDepartureTime: !stop.skipped ? getISOToLocalTimeFormatted(stop.actual_departure_time) : void 0,
      alerts: [...stop.alerts].map((a) => getAlertMapper(a)),
      arrivalLateness: stop.arrival_lateness,
      coordinates: {
        longitude: stop.vertex.longitude,
        latitude: stop.vertex.latitude
      },
      stopId: `route-${String(route.id)}-vertex-${String(stop.vertex.id)}-position-${i}`,
      declaredOccupancyOnArrival: (_a = stop.declared_occupancy_on_arrival) != null ? _a : void 0,
      declaredOccupancyOnDeparture: (_b = stop.declared_occupancy_on_departure) != null ? _b : void 0,
      departureLateness: stop.departure_lateness,
      id: String(stop.vertex.id),
      delegationCode: stop.vertex.delegation_code,
      name: stop.vertex.name,
      operation: getStopOperation(stop),
      storageOccupancy: stop.storage_occupancy,
      storageOccupancyOnArrival: stop.storage_occupancy_on_arrival,
      storageOccupancyOnDeparture: stop.storage_occupancy_on_departure,
      theoreticalArrivalTime: getISOToLocalTimeFormatted(stop.theoretical_arrival_time),
      theoreticalDepartureTime: getISOToLocalTimeFormatted(stop.theoretical_departure_time),
      timeZone: stop.time_zone,
      vehicleSaturation: stop.vehicle_saturation,
      vehicleSaturationOnArrival: stop.vehicle_saturation_on_arrival,
      vehicleSaturationOnDeparture: stop.vehicle_saturation_on_departure,
      skipped: (_c = stop.skipped) != null ? _c : false
    };
  });
}
function getStopOperation(stop) {
  if (!stop.theoretical_departure_time && stop.theoretical_arrival_time) {
    return routeOperations.arrival;
  }
  if (stop.theoretical_departure_time && !stop.theoretical_arrival_time) {
    return routeOperations.departure;
  }
  return routeOperations.transit;
}
function getDelegations(route) {
  const delegations = [];
  const stops = getStops(route);
  for (const s of stops) {
    const isStored = delegations.find((d) => d.id === s.id);
    if (!isStored) {
      delegations.push(s);
    }
  }
  return delegations;
}
function getAlerts(route) {
  if (!route) {
    return [];
  }
  const { alerts } = route;
  if (!alerts || alerts.length === 0) {
    return [];
  }
  return alerts.map((a) => getAlertMapper(a));
}
function getIsRoundTrip(route) {
  if (!route || route.legs.length < 2) {
    return false;
  }
  const legs = route.legs;
  const firstLeg = legs[0];
  const lastLeg = legs[legs.length - 1];
  if (firstLeg.origin.name !== lastLeg.destination.name) {
    return false;
  }
  for (let i = 0; i < legs.length / 2; i++) {
    const forwardLeg = legs[i];
    const reverseLeg = legs[legs.length - 1 - i];
    if (forwardLeg.origin.name !== reverseLeg.destination.name || forwardLeg.destination.name !== reverseLeg.origin.name) {
      return false;
    }
  }
  return true;
}
function getAlertMapper(alertDto) {
  if (alertDto.data.phase) {
    return {
      indicator: alertDto.type,
      level: alertDto.data.level_name,
      value: alertDto.data.value_str,
      phase: alertDto.data.phase,
      normalisedOrdinal: alertDto.data.normalised_ordinal
    };
  }
  return {
    indicator: alertDto.type,
    level: alertDto.data.level_name,
    value: alertDto.data.value_str,
    normalisedOrdinal: alertDto.data.normalised_ordinal
  };
}
function getRoutesMapper(networkLegRoutesDto) {
  if (!networkLegRoutesDto) {
    console.warn("Error mapping network leg routes because no network legs routes data");
    return;
  }
  const { results: networkLegRoute } = networkLegRoutesDto;
  const routesMapped = [];
  for (const r of networkLegRoute) {
    const routeLegs = getLegs(r);
    const routeStops = getStops(r);
    const routeOrigin = getOrigin(r);
    const routeDestination = getDestination(r);
    const routeDelegations = getDelegations(r);
    const routeIsRoundTrip = getIsRoundTrip(r);
    const routeAlerts = getAlerts(r);
    const routeMapped = {
      alerts: routeAlerts,
      cost: r.cost,
      delegations: routeDelegations,
      destination: routeDestination,
      id: String(r.id),
      isActive: true,
      isDraft: false,
      isEditedDraft: false,
      legs: routeLegs,
      maxLateness: r.max_lateness,
      maxOccupancy: r.max_occupancy,
      maxVehicleSaturation: r.max_vehicle_saturation,
      minOccupancy: r.min_occupancy,
      name: r.name,
      numberOfDelegations: routeDelegations.length,
      origin: routeOrigin,
      providerName: r.carrier_name,
      roundTrip: routeIsRoundTrip,
      routeIdentifier: r.route_identifier,
      stops: routeStops,
      type: r.type,
      vehicleCapacity: r.vehicle_capacity,
      vehicleNumberPlate: r.vehicle_number_plate,
      vehicleType: r.vehicle_type
    };
    routesMapped.push(routeMapped);
  }
  return routesMapped;
}

// src/modules/network/routes/get-routes-hook.ts
var useGetRoutesHook = ({
  networkId,
  config
}) => {
  const fetcher = networkId ? () => __async(void 0, null, function* () {
    return getRoutesFetcher(networkId, config);
  }) : null;
  const { data, error, isLoading, mutate } = useSWR17(
    networkId ? `network-${networkId}-routes` : null,
    fetcher,
    {
      revalidateOnFocus: false,
      refreshInterval: 0,
      revalidateIfStale: false
    }
  );
  const networkLegsRoutesMapped = getRoutesMapper(data);
  return {
    routes: networkLegsRoutesMapped || void 0,
    isLoading,
    error,
    mutate
  };
};

// src/modules/network/routes/get-route-service.ts
function getRouteService(routeId, routes) {
  return routes.find((delegation) => delegation.id === routeId);
}

// src/modules/network/routes/get-routes-delegation-service.ts
function getRoutesDelegationService(delegationId, routes) {
  if (!routes) {
    return [];
  }
  if (!delegationId) {
    return routes;
  }
  return routes.filter((r) => r.delegations.some((d) => d.id === delegationId));
}

// src/modules/network/routes/get-routes-by-operation-type-service.ts
function getRoutesByOperationTypeService(routeType, routes) {
  return routes.filter((r) => r.type === routeType);
}

// src/modules/network/routes/get-routes-by-vehicle-type-service.ts
function getRoutesByVehicleTypeService(vehicleType, routes) {
  return routes.filter((r) => r.vehicleType === vehicleType);
}

// src/modules/network/routes/get-routes-by-provider-name-service.ts
function getRoutesByProviderNameService(providerName, routes) {
  return routes.filter((r) => r.providerName === providerName);
}

// src/modules/network/routes/get-routes-delegation-by-operations-service.ts
function getRoutesDelegationByOperationsService(delegationId, operations, routes) {
  if (!routes || !delegationId) {
    return [];
  }
  if (!operations) {
    return routes;
  }
  let filteredRoutes = [];
  for (const operation of operations) {
    if (operation === routeOperations.arrival) {
      filteredRoutes = [
        ...filteredRoutes,
        ...routes.filter((r) => r.destination.id === delegationId)
      ];
    }
    if (operation === routeOperations.departure) {
      filteredRoutes = [
        ...filteredRoutes,
        ...routes.filter((r) => r.origin.id === delegationId)
      ];
    }
    if (operation === routeOperations.transit) {
      filteredRoutes = [
        ...filteredRoutes,
        ...routes.filter((r) => {
          const stopsWithoutOriginAndDestination = [...r.stops];
          stopsWithoutOriginAndDestination.shift();
          stopsWithoutOriginAndDestination.pop();
          return stopsWithoutOriginAndDestination.some((s) => s.id === delegationId);
        })
      ];
    }
  }
  return filteredRoutes;
}

// src/modules/network/routes/get-is-route-round-trip-service.ts
function getIsRouteRoundTripService(routeLegs) {
  if (!routeLegs || routeLegs.length < 2) {
    return false;
  }
  const legs = routeLegs;
  const firstLeg = legs[0];
  const lastLeg = legs[legs.length - 1];
  if (firstLeg.origin.name !== lastLeg.destination.name) {
    return false;
  }
  for (let i = 0; i < legs.length / 2; i++) {
    const forwardLeg = legs[i];
    const reverseLeg = legs[legs.length - 1 - i];
    if (forwardLeg.origin.name !== reverseLeg.destination.name || forwardLeg.destination.name !== reverseLeg.origin.name) {
      return false;
    }
  }
  return true;
}

// src/modules/network/components/select-indicator/select-indicator-component.tsx
import React80 from "react";
import { FlexComponent as FlexComponent28, Input as InputComponent } from "@ontruck/fe-ui";

// src/modules/network/alerts/alert-dto.ts
var alertsLevelsNamesDto = {
  critical: "CRITICAL",
  error: "ERROR",
  warning: "WARNING",
  info: "INFO"
};
var alertsPhasesNamesDto = {
  departure: "DEPARTURE",
  arrival: "ARRIVAL"
};
var alertsTypesDto = {
  cost_alert: "cost_alert",
  high_density_alert: "high_density_alert",
  high_storage_occupancy_alert: "high_storage_occupancy_alert",
  high_throughput_alert: "high_throughput_alert",
  high_vehicle_saturation_alert: "high_vehicle_saturation_alert",
  lateness_alert: "lateness_alert",
  low_fixed_route_coverage_alert: "low_fixed_route_coverage_alert",
  low_vehicle_occupancy_alert: "low_vehicle_occupancy_alert",
  many_late_routes_alert: "many_late_routes_alert",
  undelivered_packages_alert: "undelivered_packages_alert"
};

// src/modules/network/alerts/alert.ts
var alertsLevels = {
  high: alertsLevelsNamesDto.critical,
  medium: alertsLevelsNamesDto.error,
  low: alertsLevelsNamesDto.warning,
  info: alertsLevelsNamesDto.info
};
var alertLevelColors = {
  [alertsLevels.high]: "#D50000",
  [alertsLevels.medium]: "#F38005",
  [alertsLevels.low]: "#FCB607",
  [alertsLevels.info]: "#c7d2e2"
};
var alertLevelColorsShadow = {
  [alertsLevels.high]: "#ab0000",
  [alertsLevels.medium]: "#8a4700",
  [alertsLevels.low]: "#bd8700",
  [alertsLevels.info]: "#a2b4ce"
};
var alertsPhases = {
  departure: alertsPhasesNamesDto.departure,
  arrival: alertsPhasesNamesDto.arrival
};
var alertsIndicators = {
  cost: alertsTypesDto.cost_alert,
  hightStorageOccupancy: alertsTypesDto.high_storage_occupancy_alert,
  hightThroughput: alertsTypesDto.high_throughput_alert,
  hightVehicleSaturation: alertsTypesDto.high_vehicle_saturation_alert,
  hightDensity: alertsTypesDto.high_vehicle_saturation_alert,
  lateness: alertsTypesDto.lateness_alert,
  lowFixedRouteCoverage: alertsTypesDto.low_fixed_route_coverage_alert,
  lowVehicleOccupancy: alertsTypesDto.low_vehicle_occupancy_alert,
  manyLateRoutes: alertsTypesDto.many_late_routes_alert,
  undeliveredPackages: alertsTypesDto.undelivered_packages_alert
};

// src/modules/network/alerts/get-alert-filtered-by-indicator-service.ts
function getAlertFilteredByIndicatorService(indicator, alerts) {
  if (!alerts) {
    return void 0;
  }
  return alerts.find((alert) => alert.indicator === indicator);
}

// src/modules/network/alerts/get-alerts-filtered-by-indicator-service.ts
function getAlertsFilteredByIndicatorService(indicator, alerts) {
  if (!alerts) {
    return void 0;
  }
  return alerts.filter((alert) => alert.indicator === indicator);
}

// src/modules/network/components/select-indicator/select-indicator-component.tsx
var selectIndicatorOptionsValues = {
  lowVehicleOccupancy: alertsIndicators.lowVehicleOccupancy,
  lateness: alertsIndicators.lateness,
  none: "none",
  hightDensity: alertsIndicators.hightDensity
};
var indicatorSelectorOptions = [
  { label: "Ning\xFAn criterio de evaluaci\xF3n", value: selectIndicatorOptionsValues.none },
  {
    label: "Capacidad estimada en ruta",
    value: selectIndicatorOptionsValues.lowVehicleOccupancy
  },
  {
    label: "Densidad de veh\xEDculos en delegaci\xF3n",
    value: selectIndicatorOptionsValues.hightDensity
  },
  { label: "Retrasos detectados", value: selectIndicatorOptionsValues.lateness }
];
function SelectIndicatorComponent({
  indicator,
  onChangeIndicator
}) {
  const handleChangeIndicator = (name, value) => {
    if (onChangeIndicator) {
      onChangeIndicator(value);
    }
  };
  return /* @__PURE__ */ React80.createElement(
    FlexComponent28,
    {
      alignItems: "center",
      flex: "1",
      flexDirection: "column",
      justifyContent: "center",
      width: "100%"
    },
    /* @__PURE__ */ React80.createElement(
      InputComponent,
      {
        handleChangeValue: handleChangeIndicator,
        label: "Indicador de evaluaci\xF3n",
        name: "evaluator-indicator-selector",
        options: indicatorSelectorOptions,
        type: "select",
        value: indicator,
        width: "100%"
      }
    )
  );
}

// src/modules/network/routes/get-route-vehicle-category-color-helper.ts
var routeVehicleCategoryMapColors = {
  heavy: "#FFCC00",
  light: "#57B1E5"
};
function isRouteVehicleCategoryColorEnabledHelper(indicator) {
  return !indicator || indicator === selectIndicatorOptionsValues.none;
}
function getRouteVehicleCategoryMapColorHelper(vehicleType) {
  return vehicleType === routeVehicleTypes.trailer ? routeVehicleCategoryMapColors.heavy : routeVehicleCategoryMapColors.light;
}

// src/modules/network/scenario/scenario-dto.ts
var scenarioVehicleCategoriesDto = {
  light: "LIGHT",
  heavy: "HEAVY"
};
var scenarioChangeDiscriminatorsDto = {
  add_route: "add_route",
  edit_route: "edit_route",
  delete_route: "delete_route",
  do_nothing: "do_nothing"
};

// src/modules/network/scenario/scenario.ts
var scenarioRouteVehicleTypes = routeVehicleTypes;
var scenarioChangeDiscriminators = {
  addRoute: scenarioChangeDiscriminatorsDto.add_route,
  editRoute: scenarioChangeDiscriminatorsDto.edit_route,
  deleteRoute: scenarioChangeDiscriminatorsDto.delete_route,
  doNothing: scenarioChangeDiscriminatorsDto.do_nothing
};

// src/modules/network/scenario/get-draft-scenario-from-routes-changes-service.ts
function getDraftScenarioDraftId() {
  return uuid();
}
function getDraftScenarioRouteStopChangeService(routeStop) {
  return {
    arrivalTime: routeStop.theoreticalArrivalTime || "",
    departureTime: routeStop.theoreticalDepartureTime || "",
    delegationCode: routeStop.delegationCode
  };
}
function getDraftScenarioAddRouteChangeService(route) {
  const stops = route.stops.map(getDraftScenarioRouteStopChangeService);
  return {
    cost: route.cost || "",
    discriminator: scenarioChangeDiscriminators.addRoute,
    routeIdentifier: route.routeIdentifier,
    stops,
    vehicleType: route.vehicleType
  };
}
function getDraftScenarioEditRouteChangeService(route) {
  const stops = route.stops.map(getDraftScenarioRouteStopChangeService);
  return {
    cost: route.cost || "",
    discriminator: scenarioChangeDiscriminators.editRoute,
    routeIdentifier: route.routeIdentifier,
    stops,
    vehicleType: route.vehicleType
  };
}
function getDraftScenarioDeleteRouteChangeService(route) {
  return {
    discriminator: scenarioChangeDiscriminators.deleteRoute,
    routeIdentifier: route.routeIdentifier
  };
}
function getDraftScenarioFromRouteChangesService({
  name,
  description,
  date,
  parentId,
  addedRoutes,
  editedRoutes,
  deletedRoutes,
  doNothing
}) {
  const changes = [];
  if (!addedRoutes && !editedRoutes && !deletedRoutes) {
    console.warn("Imposible get an scenario, no routes to add, edit or delete");
    return;
  }
  if (addedRoutes) {
    const addedRoutesChanges = addedRoutes.map(getDraftScenarioAddRouteChangeService);
    changes.push(...addedRoutesChanges);
  }
  if (editedRoutes) {
    const editedRoutesChanges = editedRoutes.map(getDraftScenarioEditRouteChangeService);
    changes.push(...editedRoutesChanges);
  }
  if (deletedRoutes) {
    const deletedRoutesChanges = deletedRoutes.map(getDraftScenarioDeleteRouteChangeService);
    changes.push(...deletedRoutesChanges);
  }
  if (doNothing) {
    const doNothingChange = {
      discriminator: scenarioChangeDiscriminators.doNothing
    };
    changes.push(doNothingChange);
  }
  const draftId = getDraftScenarioDraftId();
  return {
    parentId: parentId || void 0,
    isPersisted: void 0,
    evaluationId: void 0,
    isEvaluationCreated: false,
    draftId,
    id: draftId,
    name,
    description,
    date,
    changes
  };
}

// src/modules/network/scenario/draft-scenarios-store.ts
var NEW_DRAFT_SCENARIO_NAME_PLACEHOLDER = "No scenario name yet";
var NEW_DRAFT_SCENARIO_DESCRIPTION_PLACEHOLDER = "No scenario description yet";
var NEW_DRAFT_SCENARIO_DATE_PLACEHOLDER = "No scenario date yet";
var draftScenariosStore = createStore((set, get) => ({
  draftScenarios: [],
  currentDraftScenario: void 0,
  getCurrentDraftScenario: () => {
    return get().currentDraftScenario;
  },
  getDraftScenarioById: (scenarioId) => {
    return get().draftScenarios.find((scenario) => scenario.id === scenarioId);
  },
  getDraftScenarioByEvaluationId: (evaluationId) => {
    return get().draftScenarios.find((scenario) => scenario.evaluationId === evaluationId);
  },
  draftScenariosEvaluationsIdsRunning: [],
  isLoading: false,
  setDraftScenarios: (scenarios) => {
    set((state) => __spreadProps(__spreadValues({}, state), {
      isLoading: true
    }));
    set({
      draftScenarios: scenarios,
      currentDraftScenario: scenarios[scenarios.length - 1],
      isLoading: false
    });
  },
  setDraftScenario: (scenario) => {
    set((state) => __spreadProps(__spreadValues({}, state), {
      isLoading: true
    }));
    set((state) => __spreadProps(__spreadValues({}, state), {
      draftScenarios: state.draftScenarios.map((s) => s.id === scenario.id ? scenario : s),
      currentDraftScenario: state.currentDraftScenario,
      isLoading: false
    }));
  },
  addDraftScenario: (scenario) => {
    set((state) => __spreadProps(__spreadValues({}, state), {
      isLoading: true
    }));
    set((state) => __spreadProps(__spreadValues({}, state), {
      draftScenarios: [...state.draftScenarios, scenario],
      currentDraftScenario: scenario,
      isLoading: false
    }));
  },
  removeDraftScenario: (scenario) => {
    set((state) => __spreadProps(__spreadValues({}, state), {
      isLoading: true
    }));
    set((state) => {
      var _a;
      const isScenarioToBeRemovedTheCurrentScenario = scenario.id === ((_a = state.currentDraftScenario) == null ? void 0 : _a.id);
      if (isScenarioToBeRemovedTheCurrentScenario) {
        const filteredScenarios = state.draftScenarios.filter(
          (s) => s.id !== scenario.id
        );
        const newCurrentScenario = [...filteredScenarios].reverse().find((s) => !s.isPersisted);
        return __spreadProps(__spreadValues({}, state), {
          draftScenarios: filteredScenarios,
          currentDraftScenario: newCurrentScenario,
          isLoading: false
        });
      }
      return __spreadProps(__spreadValues({}, state), {
        draftScenarios: state.draftScenarios.filter((s) => s.id !== scenario.id),
        currentDraftScenario: state.currentDraftScenario,
        isLoading: false
      });
    });
  },
  setCurrentDraftScenario: (scenario) => {
    set((state) => __spreadProps(__spreadValues({}, state), {
      isLoading: true
    }));
    set((state) => __spreadProps(__spreadValues({}, state), {
      draftScenarios: state.draftScenarios.map(
        (s) => s.draftId === scenario.draftId ? scenario : s
      ),
      currentDraftScenario: __spreadValues(__spreadValues({}, state.currentDraftScenario), scenario),
      isLoading: false
    }));
  },
  addDraftScenarioAddingRoutes: ({
    name,
    description,
    date,
    routes,
    parentId
  }) => {
    set((state) => __spreadProps(__spreadValues({}, state), {
      isLoading: true
    }));
    const newScenario = getDraftScenarioFromRouteChangesService({
      name,
      description,
      date,
      addedRoutes: routes,
      parentId
    });
    if (!newScenario) {
      console.error(
        "There is no posible create a new scenario to add the scenario adding routes to"
      );
      set((state) => __spreadProps(__spreadValues({}, state), {
        isLoading: false
      }));
      return;
    }
    set((state) => __spreadProps(__spreadValues({}, state), {
      draftScenarios: [...state.draftScenarios, newScenario],
      currentDraftScenario: newScenario,
      isLoading: false
    }));
    return get().currentDraftScenario;
  },
  addRouteToCurrentDraftScenario: (route) => {
    set((state) => __spreadProps(__spreadValues({}, state), {
      isLoading: true
    }));
    const addRouteChanges = getDraftScenarioAddRouteChangeService(route);
    set((state) => {
      if (!state.currentDraftScenario) {
        console.error("There is no current scenario at the scenarios store to add the route to");
        return __spreadProps(__spreadValues({}, state), {
          isLoading: false
        });
      }
      return __spreadProps(__spreadValues({}, state), {
        draftScenarios: state.draftScenarios.map(
          (scenario) => {
            var _a;
            return scenario.draftId === ((_a = state.currentDraftScenario) == null ? void 0 : _a.draftId) ? __spreadProps(__spreadValues({}, scenario), {
              changes: [...scenario.changes || [], addRouteChanges]
            }) : scenario;
          }
        ),
        currentDraftScenario: __spreadProps(__spreadValues({}, state.currentDraftScenario), {
          changes: [...state.currentDraftScenario.changes || [], addRouteChanges]
        }),
        isLoading: false
      });
    });
  },
  addRouteToDraftScenario: (scenarioDraftId, route) => {
    set((state) => __spreadProps(__spreadValues({}, state), {
      isLoading: true
    }));
    const addRouteChanges = getDraftScenarioAddRouteChangeService(route);
    set((state) => {
      var _a;
      return __spreadProps(__spreadValues({}, state), {
        draftScenarios: state.draftScenarios.map(
          (scenario) => scenario.draftId === scenarioDraftId ? __spreadProps(__spreadValues({}, scenario), {
            changes: [...scenario.changes || [], addRouteChanges]
          }) : scenario
        ),
        currentDraftScenario: scenarioDraftId === ((_a = state.currentDraftScenario) == null ? void 0 : _a.draftId) ? __spreadProps(__spreadValues({}, state.currentDraftScenario), {
          changes: [...state.currentDraftScenario.changes || [], addRouteChanges]
        }) : state.currentDraftScenario,
        isLoading: false
      });
    });
  },
  addDraftScenarioEditingRoute: ({
    name,
    description,
    date,
    editedRoute,
    parentId
  }) => {
    set((state) => __spreadProps(__spreadValues({}, state), {
      isLoading: true
    }));
    const newScenarioWithRouteEdited = getDraftScenarioFromRouteChangesService({
      name,
      description,
      date,
      editedRoutes: [editedRoute],
      parentId
    });
    if (!newScenarioWithRouteEdited) {
      console.error("There is no posible create a new scenario to add the edited routes to");
      set((state) => __spreadProps(__spreadValues({}, state), {
        isLoading: false
      }));
      return;
    }
    set((state) => __spreadProps(__spreadValues({}, state), {
      draftScenarios: [...state.draftScenarios, newScenarioWithRouteEdited],
      currentDraftScenario: newScenarioWithRouteEdited,
      isLoading: false
    }));
    return get().currentDraftScenario;
  },
  editRouteAtCurrentDraftScenario: (editedRoute) => {
    set((state) => __spreadProps(__spreadValues({}, state), {
      isLoading: true
    }));
    const editRouteChanges = getDraftScenarioEditRouteChangeService(editedRoute);
    set((state) => {
      if (!state.currentDraftScenario) {
        console.error("There is no current scenario at the scenarios store to edit the route to");
        return __spreadProps(__spreadValues({}, state), {
          isLoading: false
        });
      }
      return __spreadProps(__spreadValues({}, state), {
        draftScenarios: state.draftScenarios.map(
          (scenario) => {
            var _a;
            return scenario.draftId === ((_a = state.currentDraftScenario) == null ? void 0 : _a.draftId) ? __spreadProps(__spreadValues({}, scenario), {
              changes: [...scenario.changes || [], editRouteChanges]
            }) : scenario;
          }
        ),
        currentDraftScenario: __spreadProps(__spreadValues({}, state.currentDraftScenario), {
          changes: [...state.currentDraftScenario.changes || [], editRouteChanges]
        }),
        isLoading: false
      });
    });
  },
  setDraftScenarioPersisted: (scenarioDraftId) => {
    set((state) => __spreadProps(__spreadValues({}, state), {
      isLoading: true
    }));
    set((state) => {
      var _a;
      return __spreadProps(__spreadValues({}, state), {
        draftScenarios: state.draftScenarios.map(
          (s) => s.draftId === scenarioDraftId ? __spreadProps(__spreadValues({}, s), { isPersisted: true }) : s
        ),
        currentDraftScenario: scenarioDraftId === ((_a = state.currentDraftScenario) == null ? void 0 : _a.draftId) ? __spreadProps(__spreadValues({}, state.currentDraftScenario), { isPersisted: true }) : state.currentDraftScenario,
        isLoading: false
      });
    });
  },
  setDraftScenarioEvaluationId: (scenarioDraftId, scenarioEvaluationId) => {
    set((state) => __spreadProps(__spreadValues({}, state), {
      isLoading: true
    }));
    set((state) => __spreadProps(__spreadValues({}, state), {
      draftScenarios: state.draftScenarios.map(
        (s) => s.draftId === scenarioDraftId ? __spreadProps(__spreadValues({}, s), { evaluationId: scenarioEvaluationId }) : s
      ),
      isLoading: false
    }));
  },
  setDraftScenarioId: (scenarioDraftId, scenarioId) => {
    set((state) => __spreadProps(__spreadValues({}, state), {
      isLoading: true
    }));
    set((state) => __spreadProps(__spreadValues({}, state), {
      draftScenarios: state.draftScenarios.map(
        (s) => s.draftId === scenarioDraftId ? __spreadProps(__spreadValues({}, s), { id: scenarioId }) : s
      ),
      isLoading: false
    }));
  },
  setCurrentDraftScenarioId: (scenarioId) => {
    set((state) => __spreadProps(__spreadValues({}, state), {
      isLoading: true
    }));
    set((state) => {
      if (!state.currentDraftScenario) {
        console.warn(
          "There is no current scenario at the scenarios store to set the id passed so we will update only the scenario with the new id"
        );
        return __spreadProps(__spreadValues({}, state), {
          draftScenarios: state.draftScenarios.map(
            (s) => s.id === scenarioId ? __spreadProps(__spreadValues({}, s), { id: scenarioId }) : s
          ),
          isLoading: false
        });
      }
      return __spreadProps(__spreadValues({}, state), {
        draftScenarios: state.draftScenarios.map(
          (s) => s.id === scenarioId ? __spreadProps(__spreadValues({}, s), { id: scenarioId }) : s
        ),
        currentDraftScenario: __spreadProps(__spreadValues({}, state.currentDraftScenario), { id: scenarioId }),
        isLoading: false
      });
    });
  },
  setCurrentDraftScenarioPersisted: () => {
    set((state) => __spreadProps(__spreadValues({}, state), {
      isLoading: true
    }));
    set((state) => {
      if (!state.currentDraftScenario) {
        console.error("There is no current scenario at the scenarios store to set as persisted to");
        return __spreadProps(__spreadValues({}, state), {
          isLoading: false
        });
      }
      return __spreadProps(__spreadValues({}, state), {
        draftScenarios: state.draftScenarios.map(
          (s) => {
            var _a;
            return s.draftId === ((_a = state.currentDraftScenario) == null ? void 0 : _a.draftId) ? __spreadProps(__spreadValues({}, s), { isPersisted: true }) : s;
          }
        ),
        currentDraftScenario: void 0,
        isLoading: false
      });
    });
  },
  setCurrentDraftScenarioUnpersisted: () => {
    set((state) => __spreadProps(__spreadValues({}, state), {
      isLoading: true
    }));
    set((state) => {
      if (!state.currentDraftScenario) {
        console.error(
          "There is no current scenario at the scenarios store to set as unpersisted to"
        );
        return __spreadProps(__spreadValues({}, state), {
          isLoading: false
        });
      }
      return __spreadProps(__spreadValues({}, state), {
        draftScenarios: state.draftScenarios.map(
          (s) => {
            var _a;
            return s.draftId === ((_a = state.currentDraftScenario) == null ? void 0 : _a.draftId) ? __spreadProps(__spreadValues({}, s), { isPersisted: false }) : s;
          }
        ),
        currentDraftScenario: __spreadProps(__spreadValues({}, state.currentDraftScenario), { isPersisted: false }),
        isLoading: false
      });
    });
  },
  setCurrentDraftScenarioEvaluationId: (scenarioEvaluationId) => {
    set((state) => __spreadProps(__spreadValues({}, state), {
      isLoading: true
    }));
    set((state) => {
      if (!state.currentDraftScenario) {
        console.error("There is no current scenario at the scenarios store to set evaluationId to");
        return __spreadProps(__spreadValues({}, state), {
          isLoading: false
        });
      }
      return __spreadProps(__spreadValues({}, state), {
        draftScenarios: state.draftScenarios.map(
          (s) => {
            var _a;
            return s.draftId === ((_a = state.currentDraftScenario) == null ? void 0 : _a.draftId) ? __spreadProps(__spreadValues({}, s), { evaluationId: scenarioEvaluationId }) : s;
          }
        ),
        currentDraftScenario: __spreadProps(__spreadValues({}, state.currentDraftScenario), {
          evaluationId: scenarioEvaluationId
        }),
        isLoading: false
      });
    });
  },
  setCurrentDraftScenarioEvaluationCreated: (scenarioEvaluationCreated = true) => {
    set((state) => __spreadProps(__spreadValues({}, state), {
      isLoading: true
    }));
    set((state) => {
      if (!state.currentDraftScenario) {
        console.error(
          "There is no current scenario at the scenarios store to set `isEvaluationCreated` to"
        );
        return __spreadProps(__spreadValues({}, state), {
          isLoading: false
        });
      }
      return __spreadProps(__spreadValues({}, state), {
        draftScenarios: state.draftScenarios.map(
          (s) => {
            var _a;
            return s.draftId === ((_a = state.currentDraftScenario) == null ? void 0 : _a.draftId) ? __spreadProps(__spreadValues({}, s), { isEvaluationCreated: scenarioEvaluationCreated }) : s;
          }
        ),
        currentDraftScenario: __spreadProps(__spreadValues({}, state.currentDraftScenario), {
          isEvaluationCreated: scenarioEvaluationCreated
        }),
        isLoading: false
      });
    });
  }
}));
var useDraftScenariosStore = () => {
  const draftScenarios = useZustand(draftScenariosStore, (state) => state.draftScenarios);
  const setDraftScenarios = useZustand(draftScenariosStore, (state) => state.setDraftScenarios);
  const addDraftScenario = useZustand(draftScenariosStore, (state) => state.addDraftScenario);
  const removeDraftScenario = useZustand(draftScenariosStore, (state) => state.removeDraftScenario);
  const addRouteToCurrentDraftScenario = useZustand(
    draftScenariosStore,
    (state) => state.addRouteToCurrentDraftScenario
  );
  const addRouteToDraftScenario = useZustand(
    draftScenariosStore,
    (state) => state.addRouteToDraftScenario
  );
  const addDraftScenarioEditingRoute = useZustand(
    draftScenariosStore,
    (state) => state.addDraftScenarioEditingRoute
  );
  const currentDraftScenario = useZustand(
    draftScenariosStore,
    (state) => state.currentDraftScenario
  );
  const isLoading = useZustand(draftScenariosStore, (state) => state.isLoading);
  const setCurrentDraftScenario = useZustand(
    draftScenariosStore,
    (state) => state.setCurrentDraftScenario
  );
  const setCurrentDraftScenarioId = useZustand(
    draftScenariosStore,
    (state) => state.setCurrentDraftScenarioId
  );
  const setCurrentDraftScenarioPersisted = useZustand(
    draftScenariosStore,
    (state) => state.setCurrentDraftScenarioPersisted
  );
  const setCurrentDraftScenarioUnpersisted = useZustand(
    draftScenariosStore,
    (state) => state.setCurrentDraftScenarioUnpersisted
  );
  const setCurrentDraftScenarioEvaluationId = useZustand(
    draftScenariosStore,
    (state) => state.setCurrentDraftScenarioEvaluationId
  );
  const setCurrentDraftScenarioEvaluationCreated = useZustand(
    draftScenariosStore,
    (state) => state.setCurrentDraftScenarioEvaluationCreated
  );
  const setDraftScenarioId = useZustand(draftScenariosStore, (state) => state.setDraftScenarioId);
  const setDraftScenarioPersisted = useZustand(
    draftScenariosStore,
    (state) => state.setDraftScenarioPersisted
  );
  const addDraftScenarioAddingRoutes = useZustand(
    draftScenariosStore,
    (state) => state.addDraftScenarioAddingRoutes
  );
  const editRouteAtCurrentDraftScenario = useZustand(
    draftScenariosStore,
    (state) => state.editRouteAtCurrentDraftScenario
  );
  const setDraftScenarioEvaluationId = useZustand(
    draftScenariosStore,
    (state) => state.setDraftScenarioEvaluationId
  );
  const getDraftScenarioById = useZustand(
    draftScenariosStore,
    (state) => state.getDraftScenarioById
  );
  const getDraftScenarioByEvaluationId = useZustand(
    draftScenariosStore,
    (state) => state.getDraftScenarioByEvaluationId
  );
  const getCurrentDraftScenario = useZustand(
    draftScenariosStore,
    (state) => state.getCurrentDraftScenario
  );
  const setDraftScenario = useZustand(draftScenariosStore, (state) => state.setDraftScenario);
  return {
    addDraftScenario,
    addDraftScenarioAddingRoutes,
    addDraftScenarioEditingRoute,
    addRouteToCurrentDraftScenario,
    addRouteToDraftScenario,
    currentDraftScenario,
    draftScenarios,
    editRouteAtCurrentDraftScenario,
    getCurrentDraftScenario,
    getDraftScenarioByEvaluationId,
    getDraftScenarioById,
    isLoading,
    removeDraftScenario,
    setCurrentDraftScenario,
    setCurrentDraftScenarioEvaluationCreated,
    setCurrentDraftScenarioEvaluationId,
    setCurrentDraftScenarioId,
    setCurrentDraftScenarioPersisted,
    setCurrentDraftScenarioUnpersisted,
    setDraftScenario,
    setDraftScenarioEvaluationId,
    setDraftScenarioId,
    setDraftScenarioPersisted,
    setDraftScenarios
  };
};

// src/modules/network/components/top-bar-active-evaluation/top-bar-active-evaluation-component.tsx
var TopBarActiveEvaluationWrapperComponent = styled41.div`
  display: flex;
  flex-direction: column;
  margin-left: var(--otk-theme-space-m);
  height: 100%;
`;
var TopBarActiveEvaluationHeaderComponent = styled41.div`
  color: var(--otk-theme-color-grey-500, #94a6b8);
  font-size: 12px;
`;
var TopBarActiveEvaluationContentComponent = styled41.div`
  color: var(--otk-theme-color-grey-700, #54708c);
  font-size: 12px;
  text-transform: capitalize;
  display: flex;
  gap: var(--otk-theme-space-s);
`;
function getISOToUTCDateFormatted(isoStringDate) {
  if (!isoStringDate) {
    console.error("iso string date is undefined to getISOToUTCDateFormatted");
    return "";
  }
  return formatInTimeZone2(isoStringDate, DEFAULT_TIME_ZONE, "dd MMM", { locale: es2 });
}
function TopBarActiveEvaluationComponent({
  onClickUnsavedScenario
}) {
  const { evaluationPackageDate, evaluationRouteDate, scenarioName } = useNetworkState();
  const { currentDraftScenario: currentScenario } = useDraftScenariosStore();
  const formattedEvaluationPackageDate = getISOToUTCDateFormatted(evaluationPackageDate);
  const formattedEvaluationRouteDate = getISOToUTCDateFormatted(evaluationRouteDate);
  const handleClickUnsavedScenario = () => {
    if (onClickUnsavedScenario) {
      onClickUnsavedScenario(currentScenario);
    }
  };
  return /* @__PURE__ */ React81.createElement(TopBarActiveEvaluationWrapperComponent, null, scenarioName ? /* @__PURE__ */ React81.createElement(React81.Fragment, null, /* @__PURE__ */ React81.createElement(TopBarActiveEvaluationHeaderComponent, null, "Escenario:"), /* @__PURE__ */ React81.createElement(TopBarActiveEvaluationContentComponent, null, scenarioName, currentScenario && currentScenario.isPersisted === false ? /* @__PURE__ */ React81.createElement(ButtonComponent15, { color: "primary", onClick: handleClickUnsavedScenario, size: "2xs" }, "Escenario sin guardar") : null)) : null, !scenarioName && evaluationPackageDate && evaluationRouteDate ? /* @__PURE__ */ React81.createElement(React81.Fragment, null, /* @__PURE__ */ React81.createElement(TopBarActiveEvaluationHeaderComponent, null, "Evaluaci\xF3n:"), /* @__PURE__ */ React81.createElement(TopBarActiveEvaluationContentComponent, null, "Rutas: ", formattedEvaluationRouteDate, " | Env\xEDos: ", formattedEvaluationPackageDate, currentScenario && currentScenario.isPersisted === false ? /* @__PURE__ */ React81.createElement(ButtonComponent15, { color: "primary", onClick: handleClickUnsavedScenario, size: "2xs" }, "Escenario sin guardar") : null)) : null);
}

// src/modules/network/components/spinner/spinner-component.tsx
import React82, { useEffect as useEffect8, useState as useState23 } from "react";
import styled42, { keyframes } from "styled-components";
import { FlexComponent as FlexComponent29 } from "@ontruck/fe-ui";
var SPINNER_COLOR_IN_HEXADECIMAL = "#ffcc00";
var SpinnerWrapperComponent = styled42(FlexComponent29)`
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background-color: var(--otk-theme-color-midnight-express-800, #1d2838);
  transition: opacity 1.5s ease;

  opacity: ${({ isVisible }) => {
  if (!isVisible) {
    return `0`;
  }
  return "1";
}};

  @starting-style {
    opacity: 1;
  }

  svg {
    width: 150px;
    height: 150px;
  }
`;
var rotate = keyframes`
  from {
      transform: rotate(0);
    }
    to{
      transform: rotate(359deg);
    }
`;
var SpinnerContainerComponent = styled42(FlexComponent29)`
  position: relative;
`;
var SpinnerCircleBorderComponent = styled42.div`
  width: 200px;
  height: 200px;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: ${SPINNER_COLOR_IN_HEXADECIMAL};
  background: linear-gradient(
    90deg,
    rgba(255, 204, 0, 1) 0%,
    rgba(255, 204, 0, 0.78) 11%,
    rgba(184, 157, 32, 0.57) 20%,
    rgba(136, 125, 54, 0.45) 38%,
    rgba(91, 95, 74, 0.27) 80%,
    rgba(29, 41, 56, 1) 91%
  );
  animation: ${rotate} 1.2s linear 0s infinite;
`;
var SpinnerCircleCoreComponent = styled42.div`
  width: 100%;
  height: 100%;
  background-color: var(--otk-theme-color-midnight-express-800, #1d2838);
  border-radius: 50%;
`;
var SpinnerLogoComponent = styled42.svg`
  position: absolute;
  top: 80px;
  left: 45px;
`;
function SpinnerComponent({
  timeInMilliseconds,
  isLoading
}) {
  const [isVisible, setIsVisible] = useState23(isLoading || true);
  useEffect8(() => {
    if (!timeInMilliseconds) {
      return;
    }
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, timeInMilliseconds);
    return () => {
      clearTimeout(timer);
    };
  }, [isLoading, timeInMilliseconds, isVisible]);
  return /* @__PURE__ */ React82.createElement(SpinnerWrapperComponent, { isVisible }, /* @__PURE__ */ React82.createElement(SpinnerContainerComponent, null, /* @__PURE__ */ React82.createElement(SpinnerCircleBorderComponent, null, /* @__PURE__ */ React82.createElement(SpinnerCircleCoreComponent, null)), /* @__PURE__ */ React82.createElement(
    SpinnerLogoComponent,
    {
      fill: "none",
      height: "40",
      width: "104",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ React82.createElement("path", { d: "M.947 0h102.105v40H.947z", fill: "url(#a)" }),
    /* @__PURE__ */ React82.createElement("defs", null, /* @__PURE__ */ React82.createElement("pattern", { height: "1", id: "a", patternContentUnits: "objectBoundingBox", width: "1" }, /* @__PURE__ */ React82.createElement("use", { transform: "matrix(.00083 0 0 .00213 0 -.005)", xlinkHref: "#b" })), /* @__PURE__ */ React82.createElement(
      "image",
      {
        height: "475",
        id: "b",
        width: "1200",
        xlinkHref: "data:image/png;base64,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"
      }
    ))
  )));
}

// src/modules/network/components/page-layout/page-layout-component.tsx
var PageLayoutWrapperComponent = styled43(FlexComponent30)`
  overflow: hidden;
`;
var PageLayoutRightSectionComponent = styled43.section`
  width: 100%;
`;
var PageLayoutLoadingComponent = styled43(FlexComponent30)`
  width: 100%;
  height: 100%;
  background-color: var(--otk-theme-color-midnight-express-800, #1d2838);
  align-items: center;
  justify-content: center;
`;
function PageLayoutComponent({
  children,
  onClickSideBarNavigationItem,
  sidebarNavigationItemIdSelected = navigationItemsIds.ROUTES,
  onCreateNewRoute,
  networkId,
  onClickUnsavedScenario,
  isAvailableCreateNewRoute = false
}) {
  const [topBarModuleActiveEvaluationNode, setTopBarModuleActiveEvaluationNode] = useState24();
  useEffect9(() => {
    if (topBarModuleActiveEvaluationNode) {
      return;
    }
    const node = document.getElementById(TOP_BAR_MODULE_ACTIVE_EVALUATION_ID);
    if (!node) {
      console.error(`Node with id ${TOP_BAR_MODULE_ACTIVE_EVALUATION_ID} not found`);
      return;
    }
    setTopBarModuleActiveEvaluationNode(node);
  }, [topBarModuleActiveEvaluationNode, setTopBarModuleActiveEvaluationNode]);
  return /* @__PURE__ */ React83.createElement(PageLayoutWrapperComponent, { alignItems: "stretch", height: "calc(100vh - 61px)" }, topBarModuleActiveEvaluationNode ? createPortal(
    /* @__PURE__ */ React83.createElement(TopBarActiveEvaluationComponent, { onClickUnsavedScenario }),
    topBarModuleActiveEvaluationNode
  ) : null, /* @__PURE__ */ React83.createElement("aside", null, /* @__PURE__ */ React83.createElement(
    LeftSideBarNavigationComponent,
    {
      isAvailableCreateNewRoute,
      itemIdSelected: sidebarNavigationItemIdSelected,
      onClickCreateNewRoute: onCreateNewRoute,
      onClickItem: onClickSideBarNavigationItem
    }
  )), /* @__PURE__ */ React83.createElement(PageLayoutRightSectionComponent, null, !networkId ? /* @__PURE__ */ React83.createElement(PageLayoutLoadingComponent, null, /* @__PURE__ */ React83.createElement(SpinnerComponent, { isLoading: true })) : children));
}

// src/modules/network/components/top-bar-switch-view/top-bar-switch-view-component.tsx
import React84 from "react";
import styled44 from "styled-components";
import { ButtonGroupComponent } from "@ontruck/fe-ui";
var TopBarSwitchViewWrapperComponent = styled44.div`
  button {
    font-size: var(--otk-theme-font-size, 14px);
    height: 40px;
  }
`;
function TopBarSwitchViewComponent() {
  const { routesView, setRoutesView } = useNetworkState();
  return /* @__PURE__ */ React84.createElement(TopBarSwitchViewWrapperComponent, null, /* @__PURE__ */ React84.createElement(
    ButtonGroupComponent,
    {
      buttons: [
        {
          id: "1",
          label: "Mapa",
          isActive: routesView === "map",
          isDisabled: false,
          onClick: () => {
            setRoutesView("map");
          }
        },
        {
          id: "2",
          label: "Timeline",
          isActive: routesView === "timeline",
          isDisabled: false,
          onClick: () => {
            setRoutesView("timeline");
          }
        },
        {
          id: "3",
          label: "Tabla",
          isActive: routesView === "table",
          isDisabled: false,
          onClick: () => {
            setRoutesView("table");
          }
        }
      ]
    }
  ));
}

// src/modules/network/components/delegation-dashboards/delegation-dashboards-component.tsx
import React86, { useState as useState25 } from "react";
import styled46 from "styled-components";
import { TextComponent as TextComponent22, FlexComponent as FlexComponent32, ButtonComponent as ButtonComponent16 } from "@ontruck/fe-ui";
import { IconComponent as IconComponent6 } from "@ontruck/fe-icons";

// src/modules/network/components/delegation-dashboards/delegation-dashboard-component.tsx
import React85 from "react";
import styled45 from "styled-components";
import { TextComponent as TextComponent21, FlexComponent as FlexComponent31 } from "@ontruck/fe-ui";
var DelegationDashboardFlexComponent = styled45(FlexComponent31)`
  background-color: var(--otk-theme-color-midnight-express-800, #1d2838);
  padding: var(--otk-theme-space-l, 20px) 0;
`;

// src/modules/network/components/delegation-dashboards/delegation-dashboards-component.tsx
var DelegationDashboardsWrapperComponent = styled46.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  background-color: var(--otk-theme-color-midnight-express-800, #1d2838);
  box-shadow: 0px -9px 5px -7px rgba(0, 0, 0, 0.2);
`;
var DelegationDashboardsHeaderComponent = styled46.header`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 50px;
  width: 100%;
  background-color: var(--otk-theme-color-midnight-express-700, #31435d);
  border-bottom: 5px solid var(--otk-theme-color-primary, #1d2838);
`;
var DelegationDashboardsItemSplitter = styled46.div`
  width: 1px;
  height: 80px;
  background-color: var(--otk-theme-color-midnight-express-600, #3e4e63);
`;
var DelegationDashboardContentComponent = styled46.section`
  width: 100%;
  position: relative;
  transition: height 0.35s ease;

  height: ${({ isOpen }) => {
  if (isOpen) {
    return "120px";
  }
  return "0";
}};

  @starting-style {
    height: 0;
  }
`;
var DelegationDashboardsContentBackdropComponent = styled46.div`
  position: absolute;
  background-color: var(--otk-theme-color-primary, #39a0df);
  width: 100%;
  height: 100%;
  transition: opacity 0.65s ease;
  z-index: 5;

  opacity: ${({ isOpen }) => {
  if (isOpen) {
    return "0";
  }
  return "1";
}};
`;
var DelegationDashboardsArrowIconWrapperComponent = styled46.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;

  & svg {
    transition: rotate 0.5s ease;

    rotate: ${({ isOpen }) => {
  if (isOpen) {
    return "90deg";
  }
  return "-90deg";
}};
  }
`;

// src/modules/network/components/absolute-bottom-container/absolute-bottom-container-component.tsx
import styled47 from "styled-components";
var AbsoluteBottomContainerComponent = styled47.footer`
  position: absolute;
  bottom: 0;
  width: ${({ width }) => width || "100%"};
  height: ${({ height }) => height || "auto"};
`;

// src/modules/network/components/box-header/box-header-component.tsx
import React87 from "react";
import styled48 from "styled-components";
import { FlexComponent as FlexComponent33, TextComponent as TextComponent23 } from "@ontruck/fe-ui";
var BoxHeaderWrapperComponent = styled48(FlexComponent33)`
  background-color: var(--otk-theme-color-primary, #ffcc00);
  border-color: var(--otk-theme-color-primary, #ffcc00);
  padding-left: var(--otk-theme-space-m, 16px);
  padding-right: var(--otk-theme-space-m, 16px);
  height: 70px;
`;
function BoxHeaderComponent({ title }) {
  if (!title) {
    return null;
  }
  return /* @__PURE__ */ React87.createElement(
    BoxHeaderWrapperComponent,
    {
      alignItems: "start",
      flexDirection: "column",
      justifyContent: "center",
      width: "100%"
    },
    /* @__PURE__ */ React87.createElement(TextComponent23, { fontWeight: "bold", size: "2xl", variant: "secondary" }, title)
  );
}

// src/modules/network/components/bottom-panel/bottom-panel-component.tsx
import styled49 from "styled-components";
var BottomPanelComponent = styled49.footer`
  position: absolute;
  bottom: 0;
  width: 100%;
  height: auto;
`;

// src/modules/network/components/dashboards/dashboards-component.tsx
import React89, { useState as useState26 } from "react";
import styled51 from "styled-components";
import { TextComponent as TextComponent25, FlexComponent as FlexComponent35, ButtonComponent as ButtonComponent17 } from "@ontruck/fe-ui";
import { IconComponent as IconComponent7 } from "@ontruck/fe-icons";

// src/modules/network/components/dashboards/dashboard-component.tsx
import React88 from "react";
import styled50 from "styled-components";
import { TextComponent as TextComponent24, FlexComponent as FlexComponent34 } from "@ontruck/fe-ui";
var DashboardFlexComponent = styled50(FlexComponent34)`
  background-color: var(--otk-theme-color-midnight-express-800, #1d2838);
  padding: var(--otk-theme-space-l, 20px) 0;
`;
function DashboardComponent({
  value,
  label
}) {
  return /* @__PURE__ */ React88.createElement(
    DashboardFlexComponent,
    {
      alignItems: "center",
      flex: "1",
      flexDirection: "column",
      justifyContent: "center"
    },
    /* @__PURE__ */ React88.createElement(TextComponent24, { lineHeight: "32px", size: "4xl", variant: "primary" }, value),
    /* @__PURE__ */ React88.createElement(
      TextComponent24,
      {
        alignItems: "center",
        justifyContent: "center",
        lineHeight: "28px",
        size: "l",
        textAlign: "center",
        variant: "light"
      },
      label
    )
  );
}

// src/modules/network/components/dashboards/dashboards-component.tsx
var DashboardsWrapperComponent = styled51.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex-wrap: wrap;
  width: 100%;
  background-color: var(--otk-theme-color-midnight-express-800, #1d2838);
  box-shadow: 0px -9px 5px -7px rgba(0, 0, 0, 0.2);
`;
var DashboardsHeaderComponent = styled51.header`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 50px;
  width: 100%;
  background-color: var(--otk-theme-color-midnight-express-700, #31435d);
  border-bottom: 5px solid var(--otk-theme-color-primary, #1d2838);
`;
var DashboardsItemSplitter = styled51.div`
  width: 1px;
  height: 80px;
  background-color: var(--otk-theme-color-midnight-express-600, #3e4e63);
`;
var DashboardsContentComponent = styled51.section`
  width: 100%;
  position: relative;
  transition: height 0.35s ease;
  padding-right: var(--otk-theme-space-xl, 32px);
  padding-left: var(--otk-theme-space-xl, 32px);

  height: ${({ isOpen }) => {
  if (isOpen) {
    return "120px";
  }
  return "0";
}};

  @starting-style {
    height: 0;
  }
`;
var DashboardsContentBackdropComponent = styled51.div`
  position: absolute;
  background-color: var(--otk-theme-color-primary, #39a0df);
  width: 100%;
  height: 100%;
  transition: opacity 0.65s ease;
  z-index: 5;

  opacity: ${({ isOpen }) => {
  if (isOpen) {
    return "0";
  }
  return "1";
}};
`;
var DashboardsArrowIconWrapperComponent = styled51.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  margin-right: var(--otk-theme-space-l, 20px);

  & svg {
    transition: rotate 0.5s ease;

    rotate: ${({ isOpen }) => {
  if (isOpen) {
    return "90deg";
  }
  return "-90deg";
}};
  }
`;
function DashboardsComponent({
  isOpen,
  metrics,
  description,
  evaluated
}) {
  const [isDashboardOpen, setIsDashboardOpen] = useState26(isOpen);
  const handleToggleDelegationDashboard = () => {
    setIsDashboardOpen(!isDashboardOpen);
  };
  return /* @__PURE__ */ React89.createElement(DashboardsWrapperComponent, null, /* @__PURE__ */ React89.createElement(DashboardsHeaderComponent, null, /* @__PURE__ */ React89.createElement(FlexComponent35, { alignItems: "center", justifyContent: "center", width: "40px" }, /* @__PURE__ */ React89.createElement(IconComponent7, { colorVariant: "secondary", name: "pie" })), /* @__PURE__ */ React89.createElement(FlexComponent35, { alignItems: "center", flex: "1", gap: "10px", justifyContent: "center" }, /* @__PURE__ */ React89.createElement(TextComponent25, { variant: "light" }, description), /* @__PURE__ */ React89.createElement(TextComponent25, { fontWeight: "bold", variant: "light" }, evaluated)), /* @__PURE__ */ React89.createElement(DashboardsArrowIconWrapperComponent, { isOpen: isDashboardOpen }, /* @__PURE__ */ React89.createElement(ButtonComponent17, { onClick: handleToggleDelegationDashboard, variant: "icon" }, /* @__PURE__ */ React89.createElement(IconComponent7, { colorVariant: "secondary", name: "arrow-right", size: "s" })))), /* @__PURE__ */ React89.createElement(DashboardsContentComponent, { isOpen: isDashboardOpen }, /* @__PURE__ */ React89.createElement(DashboardsContentBackdropComponent, { isOpen: isDashboardOpen }), /* @__PURE__ */ React89.createElement(FlexComponent35, { alignItems: "center", gap: "0", justifyContent: "space-between", width: "100%" }, metrics ? metrics.map(({ id, label, value }, i) => {
    return /* @__PURE__ */ React89.createElement(
      FlexComponent35,
      {
        alignItems: "center",
        gap: "10",
        justifyContent: "space-between",
        key: id,
        width: "20%"
      },
      /* @__PURE__ */ React89.createElement(DashboardComponent, { label, value }),
      i !== metrics.length - 1 && /* @__PURE__ */ React89.createElement(DashboardsItemSplitter, null)
    );
  }) : null)));
}

// src/modules/network/delegations/get-delegation-service.ts
function getDelegationService(delegationId, delegations) {
  return delegations.find((delegation) => delegation.id === delegationId);
}

// src/modules/network/delegations/get-delegations-routes-service.ts
function getDelegationsRoutesService(delegations, routes) {
  const routesDelegations = [];
  const delegationsIds = /* @__PURE__ */ new Set();
  if (!routes) {
    return;
  }
  const routesIds = [...new Set(routes.map((r) => r.id))];
  for (const rid of routesIds) {
    const route = getRouteService(rid, routes);
    if (!route) {
      continue;
    }
    const routeDelegations = route.delegations.map((d) => getDelegationService(d.id, delegations));
    if (routeDelegations.length === 0) {
      continue;
    }
    for (const rd of routeDelegations) {
      if (!rd) {
        continue;
      }
      if (!delegationsIds.has(rd.id)) {
        delegationsIds.add(rd.id);
        routesDelegations.push(rd);
      }
    }
  }
  return routesDelegations;
}

// src/modules/network/delegations/get-delegations-hook.ts
import useSWR18 from "swr";

// src/modules/network/delegations/get-delegations-api.ts
var getDelegationsApi = (_0) => __async(void 0, [_0], function* ({
  networkId,
  config
}) {
  const url = `${config.apiBase}/concordia/v1/networks/networks/${networkId}/vertices/?page_size=0`;
  const response = yield fetch(url, {
    method: "GET",
    cache: "no-cache",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${config.token}`
    }
  });
  if (response.ok) {
    const data = yield response.json();
    return data;
  }
  throw new Error("Failed to fetch vertices");
});

// src/modules/network/delegations/get-delegations-fetcher.ts
var getDelegationsFetcher = (networkId, config) => {
  return getDelegationsApi({ networkId, config });
};

// src/modules/network/delegations/get-delegations-mapper.ts
import { formatInTimeZone as formatInTimeZone3 } from "date-fns-tz";

// src/modules/network/services/get-capitalice-string-service.ts
function getCapitalizeStringService(str) {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

// src/modules/network/services/get-are-sets-equals-service.ts
function getAreSetsEqualsService(setA, setB) {
  return setA.size === setB.size && [...setA].every((val) => setB.has(val));
}

// src/modules/network/delegations/get-delegations-mapper.ts
function getISOToLongDateFormatted(isoStringDate) {
  if (!isoStringDate) {
    return "";
  }
  return formatInTimeZone3(isoStringDate, DEFAULT_TIME_ZONE, "yyyy-MM-dd'T'HH:mm:ssXXX");
}
var getDelegationsMapper = (delegationsDto) => {
  if (!delegationsDto) {
    console.warn("Error mapping delegation snapshots because no vertices snapshots data");
    return;
  }
  const delegationsMapped = [];
  const { results } = delegationsDto;
  for (const d of results) {
    const snapshotsAlerts = [];
    for (const s of d.snapshots) {
      const { alerts } = s;
      for (const sa of alerts) {
        snapshotsAlerts.push({
          datetime: getISOToLongDateFormatted(s.datetime),
          indicator: sa.type,
          level: sa.data.level_name,
          value: sa.data.value_str
        });
      }
    }
    const delegationAlerts = [];
    for (const da of d.alerts) {
      delegationAlerts.push({
        indicator: da.type,
        level: da.data.level_name,
        value: da.data.value_str,
        phase: da.data.phase
      });
    }
    delegationsMapped.push({
      alerts: [...delegationAlerts, ...snapshotsAlerts],
      scenario: d.scenario ? { id: d.scenario.id, name: d.scenario.name } : null,
      capacity: d.capacity,
      id: String(d.id),
      delegationCode: d.delegation_code,
      latitude: d.latitude,
      longitude: d.longitude,
      meanVehicleOccupancy: d.mean_vehicle_occupancy,
      name: getCapitalizeStringService(d.name),
      numberOfDocks: d.number_of_docks,
      spotLegPercentage: d.spot_leg_percentage,
      totalContractedRoutes: d.total_contracted_routes,
      totalPackages: d.total_packages,
      totalSpotRoutes: d.total_spot_routes,
      totalUndeliveredPackages: d.total_undelivered_packages
    });
  }
  return delegationsMapped;
};

// src/modules/network/delegations/get-delegations-hook.ts
var useGetDelegationsHook = ({
  networkId,
  config
}) => {
  const fetcher = networkId ? () => __async(void 0, null, function* () {
    return getDelegationsFetcher(networkId, config);
  }) : null;
  const { data, error, isLoading, mutate } = useSWR18(
    networkId ? [`network-${networkId}-delegations-snapshots`, networkId] : null,
    fetcher,
    {
      revalidateOnFocus: false,
      refreshInterval: 0,
      revalidateIfStale: false
    }
  );
  const delegationsMapped = getDelegationsMapper(data);
  return {
    delegations: delegationsMapped || void 0,
    isLoading,
    error,
    mutate
  };
};

// src/modules/network/delegations/get-delegations-filtered-by-alerts-hook.ts
var useGetDelegationsFilteredByAlertsHook = ({
  indicator,
  datetimes,
  delegations
}) => {
  let delegationsFilteredByAlerts = [];
  if (!delegations || delegations.length === 0 || !indicator) {
    return {
      delegationsFilteredByAlerts
    };
  }
  if (!datetimes || datetimes.length === 0) {
    delegationsFilteredByAlerts = [...delegations].filter(
      (d) => d.alerts ? d.alerts.some((a) => a.indicator === indicator) : false
    ).map((d) => {
      const alerts = d.alerts ? d.alerts.filter((a) => a.indicator === indicator) : [];
      return __spreadProps(__spreadValues({}, d), {
        alerts
      });
    });
    return {
      delegationsFilteredByAlerts
    };
  }
  for (const datetime of datetimes) {
    delegationsFilteredByAlerts = [...delegations].filter(
      (d) => d.alerts ? d.alerts.some(
        (a) => a.indicator === indicator && a.datetime === datetime
      ) : false
    ).map((d) => {
      const alerts = d.alerts ? d.alerts.filter(
        (a) => a.indicator === indicator && a.datetime === datetime
      ) : [];
      return __spreadProps(__spreadValues({}, d), {
        alerts
      });
    });
  }
  return {
    delegationsFilteredByAlerts
  };
};

// src/modules/network/delegations/get-delegations-alerts-number-hook.ts
var useGetDelegationsAlertsNumberHook = ({
  indicator,
  datetimes,
  delegations
}) => {
  let numberOfAlertsByIndicatorAndDatetime;
  if (!delegations || delegations.length === 0 || !indicator || !datetimes || indicator === alertsIndicators.undeliveredPackages || indicator === alertsIndicators.lowFixedRouteCoverage || indicator === alertsIndicators.manyLateRoutes || indicator === alertsIndicators.cost) {
    return {
      numberOfAlertsByIndicatorAndDatetime: void 0
    };
  }
  for (const datetime of datetimes) {
    const delegationAlertsFilteredByDatetimeAndIndicator = delegations.filter(
      (d) => d.alerts ? d.alerts.some(
        (a) => a.indicator === indicator && a.datetime === datetime
      ) : false
    );
    if (!numberOfAlertsByIndicatorAndDatetime) {
      numberOfAlertsByIndicatorAndDatetime = {};
    }
    numberOfAlertsByIndicatorAndDatetime[datetime] = delegationAlertsFilteredByDatetimeAndIndicator.length;
  }
  return {
    numberOfAlertsByIndicatorAndDatetime
  };
};

// src/modules/network/components/dashboards/dashboards-hook.ts
var getMetricWithMaxTwoDecimals = (value) => {
  if (value.includes(".")) {
    const decimalIndex = value.indexOf(".");
    let numberEndIndex = decimalIndex + 1;
    while (numberEndIndex < value.length && /\d/.test(value[numberEndIndex])) {
      numberEndIndex++;
    }
    const numberPart = value.substring(0, numberEndIndex);
    const suffix = value.substring(numberEndIndex);
    const formattedNumber = parseFloat(numberPart).toFixed(2);
    const cleanNumber = formattedNumber.replace(/\.?0+$/, "");
    return cleanNumber + suffix;
  }
  return value;
};
function useDashboardsHook({
  selectedDelegationId,
  network
}) {
  if (network && selectedDelegationId) {
    const selectedDelegation = getDelegationService(selectedDelegationId, network.delegations);
    return {
      description: "An\xE1lisis sobre:",
      evaluated: (selectedDelegation == null ? void 0 : selectedDelegation.name) ? `Delegaci\xF3n de ${getCapitalizeStringService(selectedDelegation.name)}` : "",
      metrics: [
        {
          id: `dashboard-metric-${selectedDelegationId}-0`,
          label: "Bultos transportados",
          value: String((selectedDelegation == null ? void 0 : selectedDelegation.totalPackages) || "0")
        },
        {
          id: `dashboard-metric-${selectedDelegationId}-1`,
          label: "Rutas fijas",
          value: String((selectedDelegation == null ? void 0 : selectedDelegation.totalContractedRoutes) || "0")
        },
        {
          id: `dashboard-metric-${selectedDelegationId}-2`,
          label: "Rutas espor\xE1dicas",
          value: String((selectedDelegation == null ? void 0 : selectedDelegation.totalSpotRoutes) || "0")
        },
        {
          id: `dashboard-metric-${selectedDelegationId}-3`,
          label: "Bultos sin cubrir",
          value: String((selectedDelegation == null ? void 0 : selectedDelegation.totalUndeliveredPackages) || "0")
        },
        {
          id: `dashboard-metric-${selectedDelegationId}-4`,
          label: "Capacidad de veh\xEDculos",
          value: (selectedDelegation == null ? void 0 : selectedDelegation.meanVehicleOccupancy) ? getMetricWithMaxTwoDecimals(`${selectedDelegation.meanVehicleOccupancy}%`) : "0%"
        }
      ]
    };
  }
  if (network && !selectedDelegationId) {
    return {
      description: "An\xE1lisis global en:",
      evaluated: `${network.delegations.length} Delegaciones`,
      metrics: [
        {
          id: `dashboard-metric-${network.id}-0`,
          label: "Bultos transportados",
          value: String(network.totalPackages) || "0"
        },
        {
          id: `dashboard-metric-${network.id}-1`,
          label: "Rutas fijas",
          value: String(network.totalContractedRoutes) || "0"
        },
        {
          id: `dashboard-metric-${network.id}-2`,
          label: "Rutas espor\xE1dicas",
          value: String(network.totalSpotRoutes) || "0"
        },
        {
          id: `dashboard-metric-${network.id}-3`,
          label: "Bultos sin cubrir",
          value: String(network.totalUndeliveredPackages) || "0"
        },
        {
          id: `dashboard-metric-${network.id}-4`,
          label: "Capacidad de veh\xEDculos",
          value: network.meanVehicleOccupancy ? `${network.meanVehicleOccupancy}%` : "0%"
        }
      ]
    };
  }
  return {
    description: "",
    evaluated: "",
    metrics: []
  };
}

// src/modules/network/components/left-panel/left-panel-component.tsx
import styled52 from "styled-components";
import { FlexComponent as FlexComponent36 } from "@ontruck/fe-ui";
var MAP_LEFT_PANEL_WIDTH = 370;
var LeftPanelComponent = styled52(FlexComponent36)`
  background-color: var(--otk-theme-color-grey-100, #f2f5f7);
  overflow-y: ${({ overflowY }) => overflowY || "auto"};
  transition: width 0.25s ease;

  width: ${({ isOpen }) => {
  if (isOpen) {
    return `${MAP_LEFT_PANEL_WIDTH}px`;
  }
  return "0";
}};

  @starting-style {
    width: 0;
  }

  > * {
    transition: opacity 0.15s ease;

    opacity: ${({ isOpen }) => {
  if (!isOpen) {
    return `0`;
  }
  return "1";
}};

    @starting-style {
      opacity: 0;
    }
  }
`;

// src/modules/network/components/evaluation-indicators/evaluation-indicators.tsx
import React91 from "react";
import styled54 from "styled-components";
import { FlexComponent as FlexComponent38 } from "@ontruck/fe-ui";

// src/modules/network/components/evaluation-indicators/evaluation-indicator.tsx
import React90 from "react";
import styled53 from "styled-components";
import { IconComponent as IconComponent8 } from "@ontruck/fe-icons";
import { FlexComponent as FlexComponent37, TextComponent as TextComponent26, ButtonComponent as ButtonComponent18 } from "@ontruck/fe-ui";
var EvaluationIndicatorWrapperComponent = styled53(FlexComponent37)`
  border-bottom: var(--otk-theme-border, 1px solid #e0e0e0);
  border-top: var(--otk-theme-border, 1px solid #e0e0e0);

  background-color: ${({ isSelected }) => {
  if (isSelected) {
    return "var(--otk-theme-color-grey-100, #f2f5f8)";
  }
  return "var(--otk-theme-color-white, #fff)";
}};
`;
var EvaluationIndicatorInfoComponent = styled53(FlexComponent37)`
  padding-left: var(--otk-theme-space-m, 16px);
  padding-right: var(--otk-theme-space-m, 16px);
  padding-top: var(--otk-theme-space-m, 16px);
  padding-bottom: var(--otk-theme-space-m, 16px);
`;
var EvaluationIndicatorPlayButtonWrapperComponent = styled53(FlexComponent37)`
  display: block;
  align-content: center;
  width: 70px;

  width: ${({ isSelected }) => {
  if (isSelected) {
    return "70px";
  }
  return "70px";
}};

  border-left: ${({ isSelected }) => {
  if (isSelected) {
    return "1px solid var(--otk-theme-color-grey-400, 1px solid #e2e8ee)";
  }
  return "var(--otk-theme-border, 1px solid #e0e0e0)";
}};

  background-color: ${({ isSelected }) => {
  if (isSelected) {
    return "var(--otk-theme-color-grey-200, #e2e8ee)";
  }
  return "transparent";
}};

  ${ButtonComponent18} {
    display: table;
    align-content: center;
    width: 30px;
    height: 30px;
    padding: unset;
    margin: 0 auto;
    border-radius: 50%;
    background: transparent;

    border: ${({ isSelected }) => {
  if (isSelected) {
    return "3px solid var(--otk-theme-color-yellow-500, #ffcc00)";
  }
  return "3px solid var(--otk-theme-color-primary, #ffcc00)";
}};

    svg {
      display: table;
      margin: 0 auto;
      padding-left: 2px;
    }

    svg path {
      fill: ${({ isSelected }) => {
  if (isSelected) {
    return "var(--otk-theme-color-yellow-500, #ffcc00)";
  }
  return "var(--otk-theme-color-primary, #ffcc00)";
}};
    }
  }
`;
function EvaluationIndicatorComponent({
  indicator,
  title,
  description,
  onClick,
  isSelected = false
}) {
  const handleClick = () => {
    if (onClick) {
      onClick(indicator);
    }
  };
  return /* @__PURE__ */ React90.createElement(
    EvaluationIndicatorWrapperComponent,
    {
      alignItems: "stretch",
      flexDirection: "row",
      isSelected,
      justifyContent: "center",
      width: "100%"
    },
    /* @__PURE__ */ React90.createElement(
      EvaluationIndicatorInfoComponent,
      {
        alignItems: "start",
        flex: "1",
        flexDirection: "column",
        gap: "var(--otk-theme-space-2xs, 2px)"
      },
      /* @__PURE__ */ React90.createElement(TextComponent26, { fontWeight: "bold" }, title),
      description ? /* @__PURE__ */ React90.createElement(TextComponent26, null, description) : null
    ),
    /* @__PURE__ */ React90.createElement(
      EvaluationIndicatorPlayButtonWrapperComponent,
      {
        alignItems: "center",
        flexDirection: "column",
        isSelected
      },
      /* @__PURE__ */ React90.createElement(ButtonComponent18, { onClick: handleClick, size: "s" }, /* @__PURE__ */ React90.createElement(IconComponent8, { colorVariant: "secondary", name: "play", size: "s" }))
    )
  );
}

// src/modules/network/components/evaluation-indicators/evaluation-indicators.tsx
var EvaluationIndicatorsWrapperComponent = styled54(FlexComponent38)`
  > div {
    border-top: none;
  }
`;
function EvaluationIndicatorsComponent({
  evaluationIndicators,
  onClickEvaluationIndicator,
  selectedEvaluatorIndicatorId
}) {
  return /* @__PURE__ */ React91.createElement(EvaluationIndicatorsWrapperComponent, { flexDirection: "column", width: "100%" }, evaluationIndicators.map((evaluationIndicator) => {
    return /* @__PURE__ */ React91.createElement(
      EvaluationIndicatorComponent,
      {
        description: evaluationIndicator.description,
        indicator: evaluationIndicator.id,
        isSelected: selectedEvaluatorIndicatorId === evaluationIndicator.id,
        key: evaluationIndicator.id,
        onClick: onClickEvaluationIndicator,
        title: evaluationIndicator.title
      }
    );
  }));
}

// src/modules/network/components/top-bar-notifications/top-bar-notifications-component.tsx
import React93 from "react";
import { ListIcon } from "@ontruck/fe-icons";
import { ButtonComponent as ButtonComponent19, BallComponent as BallComponent2, FlexComponent as FlexComponent40 } from "@ontruck/fe-ui";
import styled56 from "styled-components";

// src/modules/network/notifications/get-notifications-hook.ts
import useSWR19 from "swr";

// src/modules/network/notifications/get-notifications-api.ts
var getNotificationsApi = (_0) => __async(void 0, [_0], function* ({
  token,
  apiBase,
  category,
  scenarioId
}) {
  let url = `${apiBase}/concordia/v1/notifications/notifications/?page=1&page_size=0`;
  if (category) {
    url += `&category=${category}`;
  }
  if (scenarioId) {
    url += `&scenario_id=${scenarioId}`;
  }
  const response = yield fetch(url, {
    method: "GET",
    cache: "no-cache",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`
    }
  });
  if (response.ok) {
    const data = yield response.json();
    return data;
  }
  throw new Error("Failed to fetch notifications");
});

// src/modules/network/notifications/get-notifications-fetcher.ts
var getNotificationsFetcher = (token, apiBase, category, scenarioId) => {
  return getNotificationsApi({ token, apiBase, category, scenarioId });
};

// src/modules/network/notifications/get-notifications-mapper.tsx
import React92 from "react";
import styled55 from "styled-components";
import { TextComponent as TextComponent27, FlexComponent as FlexComponent39, eventLevels } from "@ontruck/fe-ui";

// src/modules/network/services/get-iso-to-local-date-formatted-service.ts
import { parseISO as parseISO2 } from "date-fns";
import { formatInTimeZone as formatInTimeZone4 } from "date-fns-tz";
function getISOToLocalDateFormatted(isoStringDate) {
  if (!isoStringDate) {
    return "";
  }
  return formatInTimeZone4(parseISO2(isoStringDate), DEFAULT_TIME_ZONE, "dd/MM/yyyy");
}

// src/modules/network/notifications/notifications-dto.ts
var notificationCategoriesDto = {
  alert: "ALERT",
  log: "LOG"
};
var notificationActionsDto = {
  savedScenario: "Escenario guardado",
  generatedEvaluation: "Evaluaci\xF3n generada",
  generatingEvaluation: "Generando evaluaci\xF3n",
  evaluationUpdated: "Evaluaci\xF3n actualizada"
};

// src/modules/network/notifications/notifications.ts
var notificationCategories = notificationCategoriesDto;
var notificationActions = notificationActionsDto;

// src/modules/network/notifications/get-notifications-mapper.tsx
var NotificationContentRootComponent = styled55.ul`
  padding: 0;
  margin: 0 var(--otk-theme-space-m) var(--otk-theme-space-m) var(--otk-theme-space-m);

  ul {
    padding-left: var(--otk-theme-space);
  }
`;
function getNotificationLevel(category) {
  if (!category) {
    return eventLevels.info;
  }
  return category === notificationCategories.alert ? eventLevels.high : eventLevels.info;
}
function getNotificationIcon(category, action) {
  if (!category) {
    return {
      name: "circle-information",
      color: "var(--otk-theme-color-info)"
    };
  }
  if (category === notificationCategories.log) {
    if (action && action === notificationActions.savedScenario) {
      return {
        name: "clipboard",
        color: "var(--otk-theme-color-success)"
      };
    }
    if (action && action === notificationActions.generatedEvaluation) {
      return {
        name: "circle-check",
        color: "var(--otk-theme-color-success)"
      };
    }
    if (action && action === notificationActions.generatingEvaluation) {
      return {
        name: "update-check",
        color: "var(--otk-theme-color-primary-500)"
      };
    }
    return {
      name: "circle-check",
      color: "var(--otk-theme-color-success)"
    };
  }
  return {
    name: "circle-exclamation",
    color: "var(--otk-theme-color-error)"
  };
}
function getNotificationWhoLabel(user) {
  if (user.is_system) {
    return "System";
  }
  if (user.first_name && user.last_name) {
    return `${user.first_name} ${user.last_name}`;
  }
  return user.username;
}
function getNotificationContent(content) {
  const result = {};
  for (const key in content) {
    if (!Object.prototype.hasOwnProperty.call(content, key)) {
      continue;
    }
    const value = content[key];
    if (Array.isArray(value) && value.every((item) => typeof item === "string")) {
      result[key] = value;
    } else if (typeof value === "string") {
      result[key] = value;
    }
  }
  return result;
}
function NotificationContentComponent({
  content
}) {
  return /* @__PURE__ */ React92.createElement(NotificationContentRootComponent, null, Object.entries(content).map(([key, value]) => {
    if (Array.isArray(value)) {
      return /* @__PURE__ */ React92.createElement("li", { key }, /* @__PURE__ */ React92.createElement(TextComponent27, { fontSize: "s", fontWeight: "bold" }, key), /* @__PURE__ */ React92.createElement("ul", null, value.map((item) => /* @__PURE__ */ React92.createElement("li", { key: item }, /* @__PURE__ */ React92.createElement(TextComponent27, { fontSize: "s" }, item)))));
    }
    return /* @__PURE__ */ React92.createElement("li", { key }, /* @__PURE__ */ React92.createElement(FlexComponent39, null, /* @__PURE__ */ React92.createElement(
      TextComponent27,
      {
        flexWrap: "nowrap",
        fontSize: "s",
        fontWeight: "bold",
        style: { marginRight: "var(--otk-theme-space-s)" },
        wordBreak: "break-all"
      },
      key,
      ":"
    ), /* @__PURE__ */ React92.createElement(TextComponent27, { fontSize: "s" }, value)));
  }));
}
function getNotificationsMapper(notificationsDto, category) {
  if (!notificationsDto) {
    console.error("Error mapping notifications because there are not notifications data");
    return;
  }
  return notificationsDto.results.map((notification) => {
    var _a;
    const icon = getNotificationIcon(category, notification.action);
    const when = (_a = getISOToLocalDateFormatted(notification.created_at)) != null ? _a : "";
    const tags = notification.tags.map((tag) => tag.content.toUpperCase());
    const level = getNotificationLevel(category);
    const whoLabel = getNotificationWhoLabel(notification.user);
    const whoType = notification.user.is_system ? "system" : "user";
    return {
      id: notification.id,
      action: notification.action,
      actor: notification.group,
      who: {
        type: whoType,
        label: whoLabel,
        backgroundColor: "var(--otk-theme-color-grey-200)",
        color: "var(--otk-theme-color-grey-900)",
        details: null
      },
      bodyComponent: /* @__PURE__ */ React92.createElement(NotificationContentComponent, { content: getNotificationContent(notification.content) }),
      when,
      tags,
      level,
      icon
    };
  });
}

// src/modules/network/notifications/get-notifications-hook.ts
var useGetNotificationsHook = ({
  token,
  apiBase,
  category,
  scenarioId
}) => {
  const fetcher = () => __async(void 0, null, function* () {
    return getNotificationsFetcher(token, apiBase, category, scenarioId);
  });
  let key = `notifications`;
  if (category) {
    key += `-${category}`;
  }
  if (scenarioId) {
    key += `-${scenarioId}`;
  }
  const { data, error, isLoading, mutate } = useSWR19(key, fetcher, {
    revalidateOnFocus: false,
    refreshInterval: 0,
    revalidateIfStale: false
  });
  const notificationsMapped = getNotificationsMapper(data, category);
  return {
    notifications: notificationsMapped || void 0,
    isLoading,
    error,
    mutate
  };
};

// src/modules/network/components/top-bar-notifications/top-bar-notifications-component.tsx
var TopBarNotificationsRootComponent = styled56(FlexComponent40)`
  position: relative;
`;
var TopBarNotificationsButtonComponent = styled56(ButtonComponent19)`
  height: 56px;
  background-color: ${({ areNotifications }) => areNotifications ? "var(--otk-theme-color-primary, #e6b800)" : "transparent"};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--otk-theme-space-xs, 4px);
  padding: ${({ areNotifications }) => areNotifications ? "var(--otk-theme-space-s, 8px) var(--otk-theme-space-m, 8px)" : 0};

  &:hover {
    background-color: ${({ areNotifications }) => areNotifications ? "var(--otk-theme-color-primary-500, #b38f00)" : "transparent"};
  }
`;
var TopBarNotificationsBallComponent = styled56(BallComponent2)`
  position: absolute;
  top: 6px;
  right: 4px;
`;
function TopBarNotificationsComponent({
  networkConfig: networkConfig2,
  onClickNotifications
}) {
  const { token, apiBase } = networkConfig2;
  const { notifications } = useGetNotificationsHook({ token, apiBase });
  const areNotifications = notifications ? notifications.length > 0 : false;
  const areAllNotificationsRead = false;
  return /* @__PURE__ */ React93.createElement(TopBarNotificationsRootComponent, null, /* @__PURE__ */ React93.createElement(
    TopBarNotificationsButtonComponent,
    {
      areAllNotificationsRead,
      areNotifications,
      onClick: onClickNotifications,
      variant: "icon"
    },
    /* @__PURE__ */ React93.createElement(
      ListIcon,
      {
        color: areNotifications ? "var(--otk-theme-color-white, #FFF)" : "var(--otk-theme-color-primary, #e6b800)"
      }
    ),
    areNotifications ? /* @__PURE__ */ React93.createElement(
      TopBarNotificationsBallComponent,
      {
        backgroundColor: "var(--otk-theme-color-white, #FFF)",
        size: "7px"
      }
    ) : null
  ));
}

// src/modules/network/components/notifications/notifications-component.tsx
import React94 from "react";
import { HorizontalTabsComponent, EventComponent, FlexComponent as FlexComponent41 } from "@ontruck/fe-ui";
function NotificationsComponent({
  token,
  apiBase,
  scenarioId
}) {
  const { notifications: alertsNotifications } = useGetNotificationsHook({
    token,
    apiBase,
    category: notificationCategories.alert,
    scenarioId
  });
  const { notifications: logsNotifications } = useGetNotificationsHook({
    token,
    apiBase,
    category: notificationCategories.log,
    scenarioId
  });
  return /* @__PURE__ */ React94.createElement(
    HorizontalTabsComponent,
    {
      markActive: true,
      maxContentHeight: "100vh",
      tabs: [
        {
          id: "alerts",
          label: "Alertas",
          contentComponent: /* @__PURE__ */ React94.createElement(FlexComponent41, { flexDirection: "column", width: "100%" }, alertsNotifications ? alertsNotifications.map((n) => {
            var _a;
            return /* @__PURE__ */ React94.createElement(
              EventComponent,
              {
                action: n.action,
                actor: n.actor,
                bodyComponent: (_a = n.bodyComponent) != null ? _a : null,
                icon: n.icon,
                key: n.id,
                level: n.level,
                tags: n.tags,
                when: n.when,
                who: n.who
              }
            );
          }) : null)
        },
        {
          id: "logs",
          label: "Logs",
          contentComponent: /* @__PURE__ */ React94.createElement(FlexComponent41, { flexDirection: "column", width: "100%" }, logsNotifications ? logsNotifications.map((l) => {
            var _a;
            return /* @__PURE__ */ React94.createElement(
              EventComponent,
              {
                action: l.action,
                actor: l.actor,
                bodyComponent: (_a = l.bodyComponent) != null ? _a : null,
                icon: l.icon,
                key: l.id,
                level: l.level,
                tags: l.tags,
                when: l.when,
                who: l.who
              }
            );
          }) : null)
        }
      ],
      uppercase: true
    }
  );
}

// src/modules/network/components/route-editor/create-route/create-route-component.tsx
import React107, { useState as useState29, useMemo as useMemo32, useEffect as useEffect10 } from "react";
import {
  DndContext,
  MeasuringStrategy,
  closestCenter,
  KeyboardSensor,
  PointerSensor,
  useSensor,
  useSensors
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  sortableKeyboardCoordinates,
  verticalListSortingStrategy
} from "@dnd-kit/sortable";
import { FlexComponent as FlexComponent51, TextComponent as TextComponent34 } from "@ontruck/fe-ui";

// src/modules/network/networks/get-network-hook.ts
import useSWR20 from "swr";

// src/modules/network/networks/get-network-api.ts
var getNetworkApi = (_0) => __async(void 0, [_0], function* ({
  networkId,
  config
}) {
  const url = `${config.apiBase}/concordia/v1/networks/networks/${networkId}`;
  const response = yield fetch(url, {
    method: "GET",
    cache: "no-cache",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${config.token}`
    }
  });
  if (response.ok) {
    const data = yield response.json();
    return data;
  }
  throw new Error("Failed to fetch network");
});

// src/modules/network/networks/get-network-fetcher.ts
var getNetworkFetcher = (networkId, config) => {
  return getNetworkApi({ networkId, config });
};

// src/modules/network/networks/get-network-mapper.ts
function getDelegationsMapper2(networkVertices) {
  return networkVertices.map((vertex) => ({
    capacity: vertex.capacity,
    id: String(vertex.id),
    incidents: 0,
    delegationCode: vertex.delegation_code,
    latitude: vertex.latitude,
    longitude: vertex.longitude,
    name: vertex.name,
    numberOfDocks: vertex.number_of_docks,
    saturation: 0,
    spotLegPercentage: vertex.spot_leg_percentage,
    totalContractedRoutes: vertex.total_contracted_routes,
    totalPackages: vertex.total_packages,
    totalSpotRoutes: vertex.total_spot_routes,
    totalUndeliveredPackages: vertex.total_undelivered_packages,
    meanVehicleOccupancy: vertex.mean_vehicle_occupancy
  }));
}
function getNetworkMapper(networkDto) {
  if (!networkDto) {
    console.warn("Error mapping network, no network data");
    return;
  }
  const networkDelegations = getDelegationsMapper2(networkDto.vertices);
  const NetworkMapped = {
    id: String(networkDto.id),
    delegations: networkDelegations,
    totalContractedRoutes: networkDto.total_contracted_routes,
    totalSpotRoutes: networkDto.total_spot_routes,
    totalPackages: networkDto.total_packages,
    totalUndeliveredPackages: networkDto.total_undelivered_packages,
    meanVehicleOccupancy: parseFloat(networkDto.mean_vehicle_occupancy.toFixed(2)),
    totalDelegations: networkDto.total_delegations
  };
  return NetworkMapped;
}

// src/modules/network/networks/get-network-hook.ts
var useGetNetworkHook = ({
  networkId,
  config
}) => {
  const fetcher = networkId ? () => __async(void 0, null, function* () {
    return getNetworkFetcher(networkId, config);
  }) : null;
  const { data, error, isLoading, mutate } = useSWR20(
    networkId ? [`network-${networkId}`, networkId] : null,
    fetcher,
    {
      revalidateOnFocus: false,
      refreshInterval: 0,
      revalidateIfStale: false
    }
  );
  const networkMapped = getNetworkMapper(data);
  return {
    network: networkMapped || void 0,
    isLoading,
    error,
    mutate
  };
};

// src/modules/network/components/route-editor/route-editor-body-component.tsx
import React95 from "react";
import styled57 from "styled-components";
import { FlexComponent as FlexComponent42 } from "@ontruck/fe-ui";
var EditRouteBodyRootComponent = styled57(FlexComponent42)`
  background: var(--otk-theme-color-grey-100);
  flex: 1;
  height: 100%;
  width: 100%;
`;
function RouteEditorBodyComponent({ children }) {
  return /* @__PURE__ */ React95.createElement(
    EditRouteBodyRootComponent,
    {
      alignItems: "start",
      flexDirection: "column",
      gap: "0",
      justifyContent: "space-between"
    },
    children
  );
}

// src/modules/network/components/route-editor/create-route-stop/create-route-stop-component.tsx
import React96, { useMemo as useMemo31 } from "react";
import styled58 from "styled-components";
import {
  Input as InputComponent2,
  FlexComponent as FlexComponent43,
  ButtonComponent as ButtonComponent20,
  AccordionComponent as AccordionComponent2,
  TextComponent as TextComponent28,
  TimeInputNativeComponent
} from "@ontruck/fe-ui";
import { IconComponent as IconComponent9 } from "@ontruck/fe-icons";

// src/modules/network/components/route-editor/route-editor-columns-widths.ts
var routeEditorColumnsWidths = {
  leftEmptyColumn: "20px"
};

// src/modules/network/components/route-editor/create-route-stop/create-route-stop-component.tsx
var CreateRouteStopRootComponent = styled58.div`
  width: 100%;
  background: var(--otk-theme-color-grey-200);
  border-left: ${routeEditorColumnsWidths.leftEmptyColumn} solid var(--otk-theme-color-grey-300);
  border-bottom: 1px solid var(--otk-theme-color-grey-300);
  overflow: visible;
`;
var CreateRouteStopContentComponent = styled58(FlexComponent43)`
  min-height: 100px;
  width: 100%;
  padding: 0 var(--otk-theme-space-m) 0 var(--otk-theme-space-m);
  overflow: visible;
`;
function CreateRouteStopComponent({
  arrivalTimeSelected,
  delegations,
  departureTimeSelected,
  isDestination = false,
  isOpen = false,
  isOrigin = false,
  onChangeArrivalTime,
  onChangeDepartureTime,
  onCreateStop,
  onSelectStopDelegationCode,
  onToggle,
  stopDelegationCodeSelected
}) {
  const stops = useMemo31(
    () => delegations == null ? void 0 : delegations.map((delegation) => ({
      value: delegation.delegationCode,
      label: delegation.name
    })).sort((a, b) => a.label.localeCompare(b.label)),
    [delegations]
  );
  const createRouteStopIsEnabled = useMemo31(() => {
    return stopDelegationCodeSelected && stopDelegationCodeSelected !== "" && isOrigin && departureTimeSelected && departureTimeSelected !== "" || stopDelegationCodeSelected && stopDelegationCodeSelected !== "" && isDestination && arrivalTimeSelected && arrivalTimeSelected !== "" || stopDelegationCodeSelected && stopDelegationCodeSelected !== "" && !isOrigin && !isDestination && departureTimeSelected && departureTimeSelected !== "" && arrivalTimeSelected && arrivalTimeSelected !== "";
  }, [
    arrivalTimeSelected,
    departureTimeSelected,
    stopDelegationCodeSelected,
    isOrigin,
    isDestination
  ]);
  return /* @__PURE__ */ React96.createElement(CreateRouteStopRootComponent, null, /* @__PURE__ */ React96.createElement(AccordionComponent2, { backgroundColor: "var(--otk-theme-color-grey-200)" }, /* @__PURE__ */ React96.createElement(AccordionComponent2.Trigger, { onClick: onToggle }, /* @__PURE__ */ React96.createElement(
    FlexComponent43,
    {
      alignItems: "center",
      gap: "var(--otk-theme-space-m)",
      justifyContent: "space-between",
      padding: "var(--otk-theme-space-m)",
      width: "100%"
    },
    /* @__PURE__ */ React96.createElement(FlexComponent43, { alignItems: "center", gap: "var(--otk-theme-space-s)", width: "100%" }, /* @__PURE__ */ React96.createElement(IconComponent9, { color: "var(--otk-theme-color-grey-500)", name: "circle-plus", size: "l" }), /* @__PURE__ */ React96.createElement(TextComponent28, { color: "var(--otk-theme-color-grey-700)", fontWeight: "medium" }, "A\xF1adir parada")),
    /* @__PURE__ */ React96.createElement(AccordionComponent2.Icon, { open: isOpen })
  )), /* @__PURE__ */ React96.createElement(AccordionComponent2.Content, { open: isOpen }, /* @__PURE__ */ React96.createElement(
    CreateRouteStopContentComponent,
    {
      flexDirection: "column",
      gap: "var(--otk-theme-space-s)",
      margin: "var(--otk-theme-space-s) 0 0 0"
    },
    /* @__PURE__ */ React96.createElement(
      InputComponent2,
      {
        handleChangeValue: onSelectStopDelegationCode,
        isRequired: true,
        label: "A\xF1adir parada",
        name: "create-route-add-stop-input-select",
        options: stops,
        portal: true,
        type: "select",
        value: stopDelegationCodeSelected,
        width: "100%"
      }
    ),
    /* @__PURE__ */ React96.createElement(FlexComponent43, { gap: "var(--otk-theme-space-s)", width: "100%" }, /* @__PURE__ */ React96.createElement(
      TimeInputNativeComponent,
      {
        handleChangeValue: onChangeArrivalTime,
        isRequired: true,
        label: "Hora llegada",
        name: "create-route-add-stop-input-arrival-time",
        value: arrivalTimeSelected
      }
    ), /* @__PURE__ */ React96.createElement(
      TimeInputNativeComponent,
      {
        handleChangeValue: onChangeDepartureTime,
        isRequired: true,
        label: "Hora salida",
        name: "create-route-add-stop-input-departure-time",
        value: departureTimeSelected
      }
    ), /* @__PURE__ */ React96.createElement(
      ButtonComponent20,
      {
        color: "primary",
        disabled: !createRouteStopIsEnabled,
        height: "var(--otk-ui-input-height)",
        onClick: onCreateStop,
        size: "s"
      },
      "A\xF1adir parada"
    ))
  ))));
}

// src/modules/network/components/route-editor/create-route/create-route-stops-component.tsx
import React101 from "react";
import styled61 from "styled-components";

// src/modules/network/components/route-editor/create-route/create-route-stops-header-component.tsx
import React97 from "react";
import { FlexComponent as FlexComponent44, TextComponent as TextComponent29 } from "@ontruck/fe-ui";
import { IconComponent as IconComponent10 } from "@ontruck/fe-icons";

// src/modules/network/components/route-editor/route-editor-stop-table-cell-component.tsx
import styled59 from "styled-components";
import { TableCellComponent as TableCellComponent14 } from "@ontruck/fe-ui";
var TABLE_CELL_MIN_HEIGHT_IN_PIXELS = 50;
var RouteEditorStopTableCellComponent = styled59(TableCellComponent14)`
  height: unset;
  align-items: ${({ alignItems }) => alignItems || "stretch"};
  height: ${`${TABLE_CELL_MIN_HEIGHT_IN_PIXELS}px`};
  border-top: ${({ borderTop }) => borderTop || "none"};
  border-bottom: ${({ borderBottom }) => borderBottom || "none"};
`;

// src/modules/network/components/route-editor/create-route/create-route-stops-columns-widths.ts
var createRouteStopsTableColumnsWidths = {
  leftEmptyColumn: routeEditorColumnsWidths.leftEmptyColumn,
  delegationColumn: "250px",
  arrivalTimeColumn: "55px",
  departureTimeColumn: "55px",
  actionsColumn: "55px"
};

// src/modules/network/components/route-editor/create-route/create-route-stops-header-component.tsx
function CreateRouteStopsHeaderComponent() {
  return /* @__PURE__ */ React97.createElement(
    FlexComponent44,
    {
      alignItems: "center",
      backgroundColor: "var(--otk-theme-color-white, #FFFFFF)",
      height: `${TABLE_CELL_MIN_HEIGHT_IN_PIXELS}px`,
      width: "100%"
    },
    /* @__PURE__ */ React97.createElement(
      RouteEditorStopTableCellComponent,
      {
        background: "var(--otk-theme-color-grey-300, #CCD7E0);",
        borderRight: "1px solid var(--otk-theme-color-grey-300, #CCD7E0)",
        justifyContent: "center",
        padding: "unset",
        width: createRouteStopsTableColumnsWidths.leftEmptyColumn
      }
    ),
    /* @__PURE__ */ React97.createElement(
      RouteEditorStopTableCellComponent,
      {
        background: "var(--otk-theme-color-grey-100, #F2F5F8)",
        borderLeft: "unset",
        borderRight: "1px solid var(--otk-theme-color-grey-200, #E2E8EE)",
        justifyContent: "start",
        padding: "0 var(--otk-theme-space-m)",
        width: createRouteStopsTableColumnsWidths.delegationColumn
      },
      /* @__PURE__ */ React97.createElement(TextComponent29, { color: "var(--otk-theme-color-grey-500, #54708C)", fontWeight: "bold", uppercase: true }, "DELEGACI\xD3N")
    ),
    /* @__PURE__ */ React97.createElement(
      RouteEditorStopTableCellComponent,
      {
        background: "rgba(204, 214, 224, 0.3)",
        borderLeft: "unset",
        borderRight: "1px solid var(--otk-theme-color-white, #FFF)",
        justifyContent: "center",
        padding: "unset",
        width: createRouteStopsTableColumnsWidths.arrivalTimeColumn
      },
      /* @__PURE__ */ React97.createElement(TextComponent29, { color: "var( --otk-theme-color-grey-700, #54708C)", fontWeight: "medium" }, /* @__PURE__ */ React97.createElement(
        IconComponent10,
        {
          color: "var(--otk-theme-color-grey-500, #94A6B8)",
          name: "circle-arrow-right",
          sizeInPixels: 22
        }
      ))
    ),
    /* @__PURE__ */ React97.createElement(
      RouteEditorStopTableCellComponent,
      {
        background: "rgba(204, 214, 224, 0.3)",
        borderLeft: "unset",
        borderRight: "unset",
        justifyContent: "center",
        padding: "unset",
        width: createRouteStopsTableColumnsWidths.departureTimeColumn
      },
      /* @__PURE__ */ React97.createElement(TextComponent29, { color: "var( --otk-theme-color-grey-700, #54708C)", fontWeight: "medium" }, /* @__PURE__ */ React97.createElement(
        IconComponent10,
        {
          color: "var(--otk-theme-color-grey-500, #94A6B8)",
          name: "circle-line-arrow-right",
          sizeInPixels: 22
        }
      ))
    ),
    /* @__PURE__ */ React97.createElement(
      RouteEditorStopTableCellComponent,
      {
        background: "var(--otk-theme-color-grey-100, #F2F5F8)",
        borderRight: "1px solid var(--otk-theme-color-grey-100, #F2F5F8)",
        justifyContent: "center",
        padding: "unset",
        width: createRouteStopsTableColumnsWidths.actionsColumn
      }
    )
  );
}

// src/modules/network/components/route-editor/create-route/create-route-stops-body-component.tsx
import React100 from "react";
import { FlexComponent as FlexComponent46, TextComponent as TextComponent30, ButtonComponent as ButtonComponent21 } from "@ontruck/fe-ui";
import { IconComponent as IconComponent11 } from "@ontruck/fe-icons";

// src/modules/network/components/route-editor/route-editor-stops-droppable-component.tsx
import React98 from "react";
import styled60 from "styled-components";
import { useDroppable } from "@dnd-kit/core";
var RouteEditorStopsDroppableRootComponent = styled60.div`
  width: 100%;
  margin: 0;
  padding: 0;
  color: ${({ isOver }) => isOver ? "green" : void 0};
`;
function RouteEditorStopsDroppableComponent({
  id,
  children
}) {
  const { isOver, setNodeRef } = useDroppable({
    id
  });
  return /* @__PURE__ */ React98.createElement(RouteEditorStopsDroppableRootComponent, { id, isOver, ref: setNodeRef }, children);
}

// src/modules/network/components/route-editor/route-editor-stop-sortable-component.tsx
import React99, { useState as useState27, cloneElement } from "react";
import {
  useSortable,
  defaultAnimateLayoutChanges
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { FlexComponent as FlexComponent45 } from "@ontruck/fe-ui";
function animateLayoutChanges(args) {
  const { isSorting, wasDragging } = args;
  if (isSorting || wasDragging) {
    return defaultAnimateLayoutChanges(args);
  }
  return true;
}
function RouteEditorStopSortableComponent({
  children,
  id,
  draggableButtonComponent
}) {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    animateLayoutChanges,
    id
  });
  const [isHovered, setIsHovered] = useState27(false);
  const style = {
    transform: CSS.Transform.toString(transform),
    transition
  };
  return /* @__PURE__ */ React99.createElement("div", __spreadValues({ ref: setNodeRef, style }, attributes), /* @__PURE__ */ React99.createElement(FlexComponent45, { alignItems: "center", width: "100%" }, cloneElement(draggableButtonComponent, __spreadProps(__spreadValues({}, listeners), {
    onMouseEnter: () => {
      setIsHovered(true);
    },
    onMouseLeave: () => {
      setIsHovered(false);
    },
    style: {
      cursor: isHovered ? "grab" : "default"
    }
  })), children));
}

// src/modules/network/components/route-editor/create-route/create-route-stops-body-component.tsx
function CreateRouteStopsBodyComponent({
  onRemoveStop,
  stops
}) {
  const handleRemoveStop = (routeStopDelegationCode) => {
    if (onRemoveStop) {
      onRemoveStop(routeStopDelegationCode);
    }
  };
  return /* @__PURE__ */ React100.createElement(FlexComponent46, { alignItems: "stretch", flexDirection: "column", gap: "0px", height: "100%", width: "100%" }, /* @__PURE__ */ React100.createElement(RouteEditorStopsDroppableComponent, { id: "create-route-stops" }, stops.map((s, index) => {
    const id = `${s.delegationCode}-${index}`;
    const key = `${s.id}-${index}`;
    return /* @__PURE__ */ React100.createElement(
      RouteEditorStopSortableComponent,
      {
        draggableButtonComponent: /* @__PURE__ */ React100.createElement(
          RouteEditorStopTableCellComponent,
          {
            alignItems: "center",
            background: "var(--otk-theme-color-grey-300, #CCD7E0);",
            borderBottom: "1px solid var(--otk-theme-color-grey-400, #CCD7E0)",
            borderRight: "1px solid var(--otk-theme-color-grey-300, #CCD7E0)",
            borderTop: "1px solid var(--otk-theme-color-grey-400, #CCD7E0)",
            justifyContent: "center",
            padding: "unset",
            width: createRouteStopsTableColumnsWidths.leftEmptyColumn
          },
          /* @__PURE__ */ React100.createElement(
            IconComponent11,
            {
              color: "var(--otk-theme-color-grey-600, #94A6B8)",
              name: "drag-indicator",
              sizeInPixels: 22
            }
          )
        ),
        id,
        key
      },
      /* @__PURE__ */ React100.createElement(
        FlexComponent46,
        {
          alignItems: "center",
          height: `${TABLE_CELL_MIN_HEIGHT_IN_PIXELS}px`,
          width: "100%"
        },
        /* @__PURE__ */ React100.createElement(
          RouteEditorStopTableCellComponent,
          {
            background: "var(--otk-theme-color-white, #FFFFFF);",
            borderBottom: "1px solid var(--otk-theme-color-grey-300, #CCD7E0)",
            borderRight: "1px solid var(--otk-theme-color-grey-200, #E2E8EE)",
            borderTop: "1px solid var(--otk-theme-color-grey-300, #CCD7E0)",
            justifyContent: "start",
            padding: "0 var(--otk-theme-space-m)",
            width: createRouteStopsTableColumnsWidths.delegationColumn
          },
          /* @__PURE__ */ React100.createElement(
            TextComponent30,
            {
              color: "var( --otk-theme-color-grey-700, #54708C)",
              fontWeight: "medium"
            },
            s.delegation
          )
        ),
        /* @__PURE__ */ React100.createElement(
          RouteEditorStopTableCellComponent,
          {
            background: "#f0f3f5",
            borderBottom: "1px solid var(--otk-theme-color-grey-300, #CCD7E0)",
            borderLeft: "unset",
            borderRight: "1px solid var(--otk-theme-color-white, #FFF)",
            borderTop: "1px solid var(--otk-theme-color-grey-300, #CCD7E0)",
            justifyContent: "center",
            padding: "unset",
            width: createRouteStopsTableColumnsWidths.arrivalTimeColumn
          },
          /* @__PURE__ */ React100.createElement(
            TextComponent30,
            {
              color: "var( --otk-theme-color-grey-700, #54708C)",
              fontWeight: "medium"
            },
            s.departureTime
          )
        ),
        /* @__PURE__ */ React100.createElement(
          RouteEditorStopTableCellComponent,
          {
            background: "#f0f3f5",
            borderBottom: "1px solid var(--otk-theme-color-grey-300, #CCD7E0)",
            borderLeft: "unset",
            borderRight: "unset",
            borderTop: "1px solid var(--otk-theme-color-grey-300, #CCD7E0)",
            justifyContent: "center",
            padding: "unset",
            width: createRouteStopsTableColumnsWidths.departureTimeColumn
          },
          /* @__PURE__ */ React100.createElement(
            TextComponent30,
            {
              color: "var( --otk-theme-color-grey-700, #54708C)",
              fontWeight: "medium"
            },
            s.arrivalTime
          )
        ),
        /* @__PURE__ */ React100.createElement(
          RouteEditorStopTableCellComponent,
          {
            alignItems: "center",
            background: "var(--otk-theme-color-grey-100, #F2F5F8);",
            borderBottom: "1px solid var(--otk-theme-color-grey-300, #CCD7E0)",
            borderRight: "1px solid var(--otk-theme-color-white, #FFFFFF)",
            borderTop: "1px solid var(--otk-theme-color-grey-300, #CCD7E0)",
            justifyContent: "center",
            padding: "unset",
            width: createRouteStopsTableColumnsWidths.actionsColumn
          },
          /* @__PURE__ */ React100.createElement(
            ButtonComponent21,
            {
              onClick: () => {
                handleRemoveStop(s.delegationCode);
              },
              variant: "icon"
            },
            /* @__PURE__ */ React100.createElement(
              IconComponent11,
              {
                color: "var(--otk-theme-color-grey-500, #94A6B8)",
                name: "trash-line",
                sizeInPixels: 22
              }
            )
          )
        )
      )
    );
  })));
}

// src/modules/network/components/route-editor/create-route/create-route-stops-component.tsx
var CreateRouteStopsRootComponent = styled61.div`
  width: 100%;
  border-bottom: 5px solid var(--otk-theme-color-grey-400);
  border-top: 5px solid var(--otk-theme-color-grey-400);
`;
function CreateRouteStopsComponent({
  routeStops,
  onRemoveRouteStop
}) {
  if (!routeStops) {
    console.warn("No draft route stops provided");
    return null;
  }
  return /* @__PURE__ */ React101.createElement(CreateRouteStopsRootComponent, null, /* @__PURE__ */ React101.createElement(CreateRouteStopsHeaderComponent, null), /* @__PURE__ */ React101.createElement(CreateRouteStopsBodyComponent, { onRemoveStop: onRemoveRouteStop, stops: routeStops }));
}

// src/modules/network/components/route-editor/create-route/create-route-footer-component.tsx
import React104 from "react";
import styled63 from "styled-components";
import { FlexComponent as FlexComponent48, ButtonComponent as ButtonComponent22 } from "@ontruck/fe-ui";

// src/modules/network/components/route-editor/select-route-cost/select-route-cost-component.tsx
import React102 from "react";
import { FlexComponent as FlexComponent47, TextComponent as TextComponent31, Input as InputComponent3 } from "@ontruck/fe-ui";
function SelectRouteCostComponent({
  cost = "",
  onChange
}) {
  return /* @__PURE__ */ React102.createElement(
    FlexComponent47,
    {
      alignItems: "start",
      flexDirection: "column",
      gap: "var(--otk-theme-space-m)",
      height: "100%",
      justifyContent: "center",
      width: "100%"
    },
    /* @__PURE__ */ React102.createElement(TextComponent31, { fontWeight: "medium" }, "Coste"),
    /* @__PURE__ */ React102.createElement(
      InputComponent3,
      {
        handleChangeValue: (name, value) => {
          if (onChange) {
            onChange(name, value);
          }
        },
        isRequired: true,
        name: "create-route-cost-selector",
        type: "number",
        units: "\u20AC",
        value: cost
      }
    )
  );
}

// src/modules/network/components/route-editor/select-route-type/select-route-type-component.tsx
import React103 from "react";
import styled62 from "styled-components";
import { RadiosInputComponent } from "@ontruck/fe-ui";
var routeTypeOptions = [
  { label: "Ligera", value: routeVehicleTypes.van },
  { label: "Pesada", value: routeVehicleTypes.trailer }
];
var SelectRouteTypeRoot = styled62(RadiosInputComponent)`
  gap: var(--otk-theme-space-2xs);
  div label {
    background: var(--otk-theme-color-grey-100);
    border: var(--otk-ui-input-border);
    padding: calc(var(--otk-theme-space-s) * 1.4) var(--otk-theme-space-2xl)
      calc(var(--otk-theme-space-s) * 1.4) var(--otk-theme-space-s);

    &:hover {
      background: var(--otk-theme-color-grey-300);

      input {
        &:focus {
          outline: none;
        }
      }
    }
  }
`;
function SelectRouteTypeComponent({
  type = routeVehicleTypes.van,
  onChange
}) {
  return /* @__PURE__ */ React103.createElement(
    SelectRouteTypeRoot,
    {
      handleChangeValue: (name) => {
        const nameSplit = name.split("-");
        const optionValueChecked = nameSplit[nameSplit.length - 1];
        if (onChange) {
          onChange(name, optionValueChecked);
        }
      },
      layout: "horizontal",
      legend: "Tipo de ruta",
      name: "create-route-type-radios",
      options: routeTypeOptions,
      value: type
    }
  );
}

// src/modules/network/components/route-editor/create-route/create-route-footer-component.tsx
var CreateRouteFooterActionsComponent = styled63(FlexComponent48)`
  background: var(--otk-theme-color-grey-100);
  width: 100%;
  height: 50px;
  border-top: 1px solid var(--otk-theme-color-grey-300);
  padding: var(--otk-theme-space-s);
`;
function CreateRouteFooterComponent({
  routeType,
  onChangeRouteType,
  onChangeRouteCost,
  onCreateRoute,
  routeCost,
  isDisabled = false
}) {
  return /* @__PURE__ */ React104.createElement(
    FlexComponent48,
    {
      alignItems: "center",
      backgroundColor: "var(--otk-theme-color-grey-100)",
      flexDirection: "column",
      justifyContent: "center",
      width: "100%"
    },
    /* @__PURE__ */ React104.createElement(
      FlexComponent48,
      {
        alignItems: "stretch",
        backgroundColor: "var(--otk-theme-color-grey-200)",
        borderLeft: `${createRouteStopsTableColumnsWidths.leftEmptyColumn} solid var(--otk-theme-color-grey-300)`,
        borderTop: "1px solid var(--otk-theme-color-grey-300)",
        height: "110px",
        padding: "var(--otk-theme-space-m)",
        width: "100%"
      },
      /* @__PURE__ */ React104.createElement("div", { style: { width: "70%" } }, /* @__PURE__ */ React104.createElement(SelectRouteTypeComponent, { onChange: onChangeRouteType, type: routeType })),
      /* @__PURE__ */ React104.createElement("div", { style: { width: "30%" } }, /* @__PURE__ */ React104.createElement(SelectRouteCostComponent, { cost: routeCost, onChange: onChangeRouteCost }))
    ),
    /* @__PURE__ */ React104.createElement(CreateRouteFooterActionsComponent, null, /* @__PURE__ */ React104.createElement(
      ButtonComponent22,
      {
        color: "primary",
        disabled: isDisabled,
        fullWidth: true,
        onClick: onCreateRoute,
        size: "s"
      },
      "Crear ruta"
    ))
  );
}

// src/modules/network/components/route-editor/create-route/create-route-success-toaster-hook.tsx
import React105 from "react";
import styled64 from "styled-components";
import { toast as toast19 } from "sonner";
import { FlexComponent as FlexComponent49, TextComponent as TextComponent32 } from "@ontruck/fe-ui";
import { IconComponent as IconComponent12 } from "@ontruck/fe-icons";
var CREATE_ROUTE_SUCCESS_TOASTER_MESSAGE = "La ruta se ha creado correctamente";
var CREATE_ROUTE_SUCCESS_TOASTER_ROUTE_ID_LABEL = "RUTA";
var CREATE_ROUTE_SUCCESS_TOASTER_ROUTE_ID_DEFAULT = "S0000001";
var CREATE_ROUTE_SUCCESS_TOASTER_BORDER_RADIUS_IN_PIXELS = 6;
var CREATE_ROUTE_SUCCESS_TOASTER_LABEL_LEFT_WIDTH_IN_PIXELS = 40;
var CREATE_ROUTE_SUCCESS_TOASTER_HEIGHT_IN_PIXELS = 75;
var CreateRouteSuccessToasterRootComponent = styled64(FlexComponent49)`
  min-height: ${CREATE_ROUTE_SUCCESS_TOASTER_HEIGHT_IN_PIXELS}px;
  background: var(--otk-theme-color-white);
  border: 0;
  border-radius: ${CREATE_ROUTE_SUCCESS_TOASTER_BORDER_RADIUS_IN_PIXELS}px;
  padding: 0;
`;
var CreateRouteSuccessToasterLabelLeftComponent = styled64(FlexComponent49)`
  width: ${CREATE_ROUTE_SUCCESS_TOASTER_LABEL_LEFT_WIDTH_IN_PIXELS}px;
  background: var(--otk-theme-color-primary);
  border-top-left-radius: ${CREATE_ROUTE_SUCCESS_TOASTER_BORDER_RADIUS_IN_PIXELS}px;
  border-bottom-left-radius: ${CREATE_ROUTE_SUCCESS_TOASTER_BORDER_RADIUS_IN_PIXELS}px;
  padding: 0;
`;
var CreateRouteSuccessToasterLabelRightComponent = styled64(FlexComponent49)`
  background: var(--otk-theme-color-grey-100);
  border-top-right-radius: ${CREATE_ROUTE_SUCCESS_TOASTER_BORDER_RADIUS_IN_PIXELS}px;
  border-bottom-right-radius: ${CREATE_ROUTE_SUCCESS_TOASTER_BORDER_RADIUS_IN_PIXELS}px;
`;
function useCreateRouteSuccessToasterHook() {
  return {
    open: (routeId = CREATE_ROUTE_SUCCESS_TOASTER_ROUTE_ID_DEFAULT) => {
      toast19(
        /* @__PURE__ */ React105.createElement(
          CreateRouteSuccessToasterRootComponent,
          {
            alignItems: "stretch",
            gap: "0",
            justifyContent: "center",
            width: "100%"
          },
          /* @__PURE__ */ React105.createElement(
            CreateRouteSuccessToasterLabelLeftComponent,
            {
              alignItems: "center",
              flexDirection: "column",
              justifyContent: "center"
            },
            /* @__PURE__ */ React105.createElement(
              IconComponent12,
              {
                color: "var(--otk-theme-color-grey-900)",
                name: "circle-line-check",
                size: "xl"
              }
            )
          ),
          /* @__PURE__ */ React105.createElement(
            CreateRouteSuccessToasterLabelRightComponent,
            {
              alignItems: "center",
              flexDirection: "column",
              flexGrow: "1",
              gap: "var(--otk-theme-space-s)",
              justifyContent: "start",
              padding: "var(--otk-theme-space-m)",
              width: "100%"
            },
            /* @__PURE__ */ React105.createElement(TextComponent32, { fontWeight: "medium", size: "m", width: "100%" }, CREATE_ROUTE_SUCCESS_TOASTER_MESSAGE),
            /* @__PURE__ */ React105.createElement(TextComponent32, { width: "100%" }, CREATE_ROUTE_SUCCESS_TOASTER_ROUTE_ID_LABEL, ": ", routeId)
          )
        ),
        {
          closeButton: false,
          duration: 1500,
          style: {
            padding: 0,
            border: "none"
          }
        }
      );
    }
  };
}

// src/modules/network/components/route-editor/create-route/create-route-header-component.tsx
import React106 from "react";
import styled65 from "styled-components";
import { DrawerComponent, ButtonComponent as ButtonComponent23, TextComponent as TextComponent33, FlexComponent as FlexComponent50 } from "@ontruck/fe-ui";
import { IconComponent as IconComponent13 } from "@ontruck/fe-icons";
var CreateRouteHeaderRootComponent = styled65(DrawerComponent.Header)`
  background: var(--otk-theme-color-primary);
  height: 70px;
`;
function CreateRouteHeaderComponent({
  onClose
}) {
  return /* @__PURE__ */ React106.createElement(CreateRouteHeaderRootComponent, null, /* @__PURE__ */ React106.createElement(
    FlexComponent50,
    {
      alignItems: "center",
      justifyContent: "space-between",
      padding: "var(--otk-theme-space-s) var(--otk-theme-space-s) var(--otk-theme-space-s) var(--otk-theme-space-l)",
      width: "100%"
    },
    /* @__PURE__ */ React106.createElement(
      FlexComponent50,
      {
        flexDirection: "column",
        gap: "var(--otk-theme-space-xs)",
        justifyContent: "center",
        width: "100%"
      },
      /* @__PURE__ */ React106.createElement(TextComponent33, { fontWeight: "medium", size: "2xl", variant: "secondary" }, "Nueva ruta")
    ),
    /* @__PURE__ */ React106.createElement(ButtonComponent23, { color: "primary", name: "close", onClick: onClose, variant: "icon" }, /* @__PURE__ */ React106.createElement(IconComponent13, { colorVariant: "primary", name: "close" }))
  ));
}

// src/modules/network/components/route-editor/create-route/get-draft-routes-hook.ts
import uuid2 from "react-uuid";
import { useState as useState28 } from "react";
function getNumberOfDigits(number) {
  return number.toString().length;
}
var DRAFT_ROUTE_ID_LENGTH = 7;
var DRAFT_ROUTE_ID_PREFIX = "S";
function getRouteName(stopsChanges) {
  return stopsChanges.map((ds) => {
    return ds.delegation.toUpperCase();
  }).join("-");
}
function getDraftRouteId(index) {
  const numberOfDigits = getNumberOfDigits(index);
  const numberOfZeros = DRAFT_ROUTE_ID_LENGTH - numberOfDigits;
  const zeros = "0".repeat(numberOfZeros);
  return `${DRAFT_ROUTE_ID_PREFIX}${zeros}${index}`;
}
function getDraftLegId() {
  return uuid2();
}
function getDelegation(stopChanges, operation, allDelegations) {
  const delegation = allDelegations.find((d) => d.id === stopChanges.id);
  if (!delegation) {
    console.warn("No delegation found for draft route stop");
    return;
  }
  return {
    id: stopChanges.id,
    delegationCode: stopChanges.delegationCode,
    name: delegation.name,
    operation,
    theoreticalArrivalTime: stopChanges.arrivalTime,
    theoreticalDepartureTime: stopChanges.departureTime,
    coordinates: {
      longitude: delegation.longitude,
      latitude: delegation.latitude
    },
    // REVIEW: We need to get the skipped from the form? if not, what should be the default value?
    skipped: false
  };
}
function getLeg(legOriginChanges, legDestinationChanges, allDelegations) {
  const id = getDraftLegId();
  const origin = getDelegation(legOriginChanges, routeOperations.departure, allDelegations);
  const destination = getDelegation(legDestinationChanges, routeOperations.arrival, allDelegations);
  if (!origin || !destination) {
    return;
  }
  return {
    id,
    origin,
    destination
  };
}
function getOrigin2(isRoundTrip, legs) {
  if (isRoundTrip) {
    return legs[legs.length - 1].destination;
  }
  return legs[0].origin;
}
function getDestination2(isRoundTrip, routeLegs) {
  if (isRoundTrip) {
    return routeLegs[routeLegs.length - 1].origin;
  }
  return routeLegs[routeLegs.length - 1].destination;
}
function getDelegations2(stopsChanges, allDelegations) {
  const delegations = [];
  for (const stopChanges of stopsChanges) {
    const delegation = getDelegation(stopChanges, routeOperations.departure, allDelegations);
    if (!delegation) {
      continue;
    }
    delegations.push(delegation);
  }
  return delegations;
}
var getLegs2 = (stopsChanges, allDelegations) => {
  const legs = [];
  for (let s = 0; s < stopsChanges.length; s++) {
    const stopChanges = stopsChanges[s];
    const isLastStop = s === stopsChanges.length - 1;
    if (isLastStop) {
      continue;
    }
    const legOriginChanges = stopChanges;
    const legDestinationChanges = stopsChanges[s + 1];
    const leg = getLeg(legOriginChanges, legDestinationChanges, allDelegations);
    if (!leg) {
      continue;
    }
    legs.push(leg);
  }
  return legs;
};
var getStops2 = (stopsChanges, allDelegations) => {
  const delegations = [];
  for (const stopChanges of stopsChanges) {
    const delegation = getDelegation(stopChanges, routeOperations.departure, allDelegations);
    if (!delegation) {
      continue;
    }
    delegations.push(delegation);
  }
  return delegations;
};
var getDraftRoute = ({
  id,
  vehicleType,
  cost,
  stopsChanges,
  allDelegations
}) => {
  const draftRouteId = getDraftRouteId(id);
  const routeIdentifier = draftRouteId;
  const legs = getLegs2(stopsChanges, allDelegations);
  const roundTrip = getIsRouteRoundTripService(legs);
  const delegations = getDelegations2(stopsChanges, allDelegations);
  const stops = getStops2(stopsChanges, allDelegations);
  const origin = getOrigin2(roundTrip, legs);
  const destination = getDestination2(roundTrip, legs);
  const name = getRouteName(stopsChanges);
  const numberOfDelegations = delegations.length;
  const type = routeTypes.contract;
  return {
    legs,
    cost,
    routeIdentifier,
    id: draftRouteId,
    delegations,
    destination,
    origin,
    // REVIEW: We need to get the max lateness from the form? if not, what should be the default value?
    maxLateness: null,
    maxOccupancy: 0,
    maxVehicleSaturation: 0,
    minOccupancy: 0,
    // REVIEW: We need to get the min occupancy from the form? if not, what should be the default value?
    name,
    numberOfDelegations,
    type,
    roundTrip,
    stops,
    vehicleCapacity: 0,
    vehicleNumberPlate: "",
    vehicleType,
    providerName: "",
    isDraft: true
  };
};
var useGetDraftRoutesHook = ({
  delegations: allDelegations,
  onAddDraftRouteSuccess
}) => {
  const [draftRoutes, setDraftRoutes] = useState28();
  const addDraftRoute = ({
    id,
    vehicleType,
    cost,
    stops
  }) => {
    if (!stops || stops.length === 0) {
      console.warn("No scenario found you should add a scenario first");
      return;
    }
    if (!allDelegations) {
      console.warn("No network delegations provided to get draft route");
      return;
    }
    const draftRoute = getDraftRoute({
      id,
      vehicleType,
      cost,
      stopsChanges: stops,
      allDelegations
    });
    setDraftRoutes([...draftRoutes || [], draftRoute]);
    if (onAddDraftRouteSuccess) {
      onAddDraftRouteSuccess(draftRoute.id);
    }
    return draftRoute;
  };
  return {
    draftRoutes,
    addDraftRoute
  };
};

// src/modules/network/components/route-editor/create-route/create-route-component.tsx
var measuringConfig = {
  droppable: {
    strategy: MeasuringStrategy.Always
  }
};
function CreateRouteComponent({
  networkId,
  config,
  onClose,
  isClean = false,
  onCreateRoute,
  route,
  numberOfNewRoutesCreated = 0
}) {
  const [routeTypeSelected, setRouteTypeSelected] = useState29(
    routeVehicleTypes.van
  );
  const [routeCostSelected, setRouteCostSelected] = useState29("");
  const [isOpenAddNewStop, setIsOpenAddNewStop] = useState29(false);
  const [newStopsDelegationCodesSelected, setNewStopsDelegationCodesSelected] = useState29(
    []
  );
  const [newStopDelegationCode, setNewStopDelegationCode] = useState29();
  const [newStopArrivalTime, setNewStopArrivalTime] = useState29("");
  const [newStopDepartureTime, setNewStopDepartureTime] = useState29("");
  const [newStopsChanges, setNewStopsChanges] = useState29([]);
  const newStopsDelegationCodes = useMemo32(
    () => newStopsChanges.map((d) => d.delegationCode),
    [newStopsChanges]
  );
  const createRouteIsDisabled = useMemo32(() => {
    return newStopsChanges.length < 2 || !routeCostSelected || routeCostSelected === "" || newStopsDelegationCodesSelected.length === 0;
  }, [newStopsChanges.length, routeCostSelected, newStopsDelegationCodesSelected]);
  const newStopsDelegationCodesMappedToAvoidCollisions = useMemo32(
    () => newStopsChanges.map((d, i) => `${d.delegationCode}-${i}`),
    [newStopsChanges]
  );
  const resetForm = () => {
    setNewStopArrivalTime("");
    setNewStopDepartureTime("");
    setNewStopDelegationCode(void 0);
    setNewStopsChanges([]);
    setNewStopsDelegationCodesSelected([]);
    setIsOpenAddNewStop(false);
    setRouteCostSelected("");
  };
  const resetAddNewStopForm = () => {
    setNewStopArrivalTime("");
    setNewStopDepartureTime("");
    setNewStopDelegationCode(void 0);
  };
  useEffect10(() => {
    if (isClean) {
      resetForm();
    }
  }, [isClean]);
  const {
    network,
    isLoading: networkIsLoading,
    error: networkError
  } = useGetNetworkHook({ networkId, config });
  const sensors = useSensors(
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates
    })
  );
  const handleCreateRouteSuccess = (routeId) => {
    if (onClose) {
      onClose();
    }
    openCreateRouteSuccessToaster(routeId);
  };
  const { addDraftRoute } = useGetDraftRoutesHook({
    delegations: (network == null ? void 0 : network.delegations) || [],
    onAddDraftRouteSuccess: handleCreateRouteSuccess
  });
  const { open: openCreateRouteSuccessToaster } = useCreateRouteSuccessToasterHook();
  const handleChangeNewStopArrivalTime = (name, value) => {
    if (!value) {
      console.warn("No value provided to change arrival time");
      return;
    }
    setNewStopArrivalTime(value);
  };
  const handleChangeNewStopDepartureTime = (name, value) => {
    if (!value) {
      console.warn("No value provided to change departure time");
      return;
    }
    setNewStopDepartureTime(value);
  };
  const handleChangeRouteType = (name, value) => {
    if (!value) {
      console.warn("No value provided to change route type");
      return;
    }
    setRouteTypeSelected(value);
  };
  const handleChangeRouteCost = (name, value) => {
    if (!value) {
      console.warn("No value provided to change route cost");
      return;
    }
    setRouteCostSelected(value);
  };
  useEffect10(() => {
    if (route && newStopsDelegationCodesSelected.length === 0) {
      setNewStopsDelegationCodesSelected(
        route.stops.map((s) => {
          var _a;
          return (_a = network == null ? void 0 : network.delegations.find((d) => d.id === s.id)) == null ? void 0 : _a.delegationCode;
        }).filter((code) => typeof code === "string")
      );
    }
  }, [route, network == null ? void 0 : network.delegations, newStopsDelegationCodesSelected]);
  const handleToggleAddNewStop = () => {
    setIsOpenAddNewStop((prev) => !prev);
  };
  const handleSelectNewStop = (name, value) => {
    if (!value) {
      console.warn("No value provided to select stop");
      return;
    }
    setNewStopDelegationCode(value);
  };
  const handleCreateNewStop = () => {
    if (!newStopDelegationCode) {
      console.warn("No draft stop id selected");
      return;
    }
    const delegationSelected = network == null ? void 0 : network.delegations.find(
      (d) => d.delegationCode === newStopDelegationCode
    );
    if (!delegationSelected) {
      console.warn("No delegation found for draft stop id selected");
      return;
    }
    const newDraftStop = {
      id: delegationSelected.id,
      delegationCode: delegationSelected.delegationCode,
      delegation: delegationSelected.name.toLocaleUpperCase(),
      arrivalTime: newStopArrivalTime,
      departureTime: newStopDepartureTime,
      stopId: `route-${route == null ? void 0 : route.id}-vertex-${delegationSelected.id}-position-${newStopsChanges.length}`
    };
    setNewStopsChanges([...newStopsChanges, newDraftStop]);
    setNewStopsDelegationCodesSelected([...newStopsDelegationCodesSelected, newStopDelegationCode]);
    resetAddNewStopForm();
  };
  const handleRemoveNewStop = (stopDelegationCode) => {
    setNewStopsChanges(newStopsChanges.filter((d) => d.delegationCode !== stopDelegationCode));
    setNewStopsDelegationCodesSelected(
      newStopsDelegationCodesSelected.filter(
        (delegationCode) => delegationCode !== stopDelegationCode
      )
    );
  };
  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (active.id !== (over == null ? void 0 : over.id)) {
      const oldIndex = newStopsDelegationCodesMappedToAvoidCollisions.indexOf(active.id);
      const newIndex = newStopsDelegationCodesMappedToAvoidCollisions.indexOf(over == null ? void 0 : over.id);
      setNewStopsDelegationCodesSelected([
        ...arrayMove(newStopsDelegationCodes, oldIndex, newIndex)
      ]);
      setNewStopsChanges([...arrayMove(newStopsChanges, oldIndex, newIndex)]);
    }
  };
  const handleCloseCreateRoute = () => {
    if (!onClose) {
      return;
    }
    const areUnsavedDraftChanges = newStopsChanges.length > 0;
    onClose(areUnsavedDraftChanges);
  };
  const handleCreateRoute = () => {
    const newDraftRoute = addDraftRoute({
      id: numberOfNewRoutesCreated,
      vehicleType: routeTypeSelected,
      cost: routeCostSelected,
      stops: newStopsChanges
    });
    if (!newDraftRoute) {
      console.warn(`There is a problem saving the route ${numberOfNewRoutesCreated}`);
      return;
    }
    if (onCreateRoute) {
      onCreateRoute(newDraftRoute);
    }
    resetForm();
  };
  const shouldBeAddedStopsListVisible = newStopsChanges.length > 0;
  return /* @__PURE__ */ React107.createElement(
    DndContext,
    {
      collisionDetection: closestCenter,
      measuring: measuringConfig,
      onDragEnd: handleDragEnd,
      sensors
    },
    /* @__PURE__ */ React107.createElement(
      FlexComponent51,
      {
        backgroundColor: "var(--otk-theme-color-grey-100)",
        flexDirection: "column",
        height: "100%",
        width: "100%"
      },
      /* @__PURE__ */ React107.createElement(CreateRouteHeaderComponent, { onClose: handleCloseCreateRoute }),
      networkIsLoading || !(network == null ? void 0 : network.delegations) ? /* @__PURE__ */ React107.createElement(TextComponent34, null, "Cargando delegaciones...") : /* @__PURE__ */ React107.createElement(RouteEditorBodyComponent, null, /* @__PURE__ */ React107.createElement(
        CreateRouteStopComponent,
        {
          arrivalTimeSelected: newStopArrivalTime,
          delegations: network.delegations,
          departureTimeSelected: newStopDepartureTime,
          isDestination: newStopsChanges.length !== 0,
          isOpen: isOpenAddNewStop,
          isOrigin: newStopsChanges.length === 0,
          onChangeArrivalTime: handleChangeNewStopArrivalTime,
          onChangeDepartureTime: handleChangeNewStopDepartureTime,
          onCreateStop: handleCreateNewStop,
          onSelectStopDelegationCode: handleSelectNewStop,
          onToggle: handleToggleAddNewStop,
          stopDelegationCodeSelected: newStopDelegationCode
        }
      ), shouldBeAddedStopsListVisible ? /* @__PURE__ */ React107.createElement(
        FlexComponent51,
        {
          flexDirection: "column",
          gap: "0",
          height: "100%",
          overflowX: "hidden",
          overflowY: "auto",
          width: "100%"
        },
        /* @__PURE__ */ React107.createElement(
          SortableContext,
          {
            items: newStopsDelegationCodesMappedToAvoidCollisions,
            strategy: verticalListSortingStrategy
          },
          /* @__PURE__ */ React107.createElement(
            CreateRouteStopsComponent,
            {
              onRemoveRouteStop: handleRemoveNewStop,
              routeStops: newStopsChanges
            }
          )
        )
      ) : null, networkError ? /* @__PURE__ */ React107.createElement(TextComponent34, null, "Error al cargar las delegaciones") : null, /* @__PURE__ */ React107.createElement(
        CreateRouteFooterComponent,
        {
          isDisabled: createRouteIsDisabled,
          onChangeRouteCost: handleChangeRouteCost,
          onChangeRouteType: handleChangeRouteType,
          onCreateRoute: handleCreateRoute,
          routeCost: routeCostSelected,
          routeType: routeTypeSelected
        }
      ))
    )
  );
}

// src/modules/network/components/route-editor/unsaved-draft-modal/unsaved-draft-modal-hook.tsx
import React109 from "react";
import { Modal as Modal3 } from "react-async-popup";

// src/modules/network/components/route-editor/unsaved-draft-modal/unsaved-draft-modal-component.tsx
import React108 from "react";
import { FlexComponent as FlexComponent52, ModalComponent as ModalComponent6, TextComponent as TextComponent35 } from "@ontruck/fe-ui";
function UnsavedDraftModalComponent({
  isOpen = false,
  onSave,
  onDiscard
}) {
  return /* @__PURE__ */ React108.createElement(
    ModalComponent6,
    {
      bodyComponent: /* @__PURE__ */ React108.createElement(FlexComponent52, { alignSelf: "stretch", flexDirection: "column", gap: "8px" }, /* @__PURE__ */ React108.createElement(TextComponent35, null, "Tienes cambios sin guardar para a\xF1adir o editar una nueva ruta \xBFEst\xE1s seguro de querer descartar el draft?")),
      cancelButtonLabel: "Descartar",
      confirmButtonLabel: "Salvar",
      description: "\xBFEst\xE1s seguro de querer descartar el draft?",
      isOpen,
      onCancel: onDiscard,
      onClose: onDiscard,
      onConfirm: onSave
    }
  );
}

// src/modules/network/components/route-editor/unsaved-draft-modal/unsaved-draft-modal-hook.tsx
var useUnsavedDraftModalHook = ({
  onSave,
  onDiscard
}) => {
  const open = () => __async(void 0, null, function* () {
    const { show, destroy } = yield Modal3.new({
      content: /* @__PURE__ */ React109.createElement(
        UnsavedDraftModalComponent,
        {
          isOpen: true,
          onDiscard: () => {
            void destroy();
            if (onDiscard) {
              onDiscard();
            }
          },
          onSave: () => {
            void destroy();
            if (onSave) {
              onSave();
            }
          }
        }
      ),
      footer: null
    });
    void show();
  });
  return {
    open
  };
};

// src/modules/network/components/route-editor/need-save-current-scenario-toaster/need-save-current-scenario-toaster-hook.tsx
import React110 from "react";
import styled66 from "styled-components";
import { toast as toast20 } from "sonner";
import { FlexComponent as FlexComponent53, TextComponent as TextComponent36, ButtonComponent as ButtonComponent24 } from "@ontruck/fe-ui";
import { IconComponent as IconComponent14 } from "@ontruck/fe-icons";
var NEED_SAVE_CURRENT_SCENARIO_TOASTER_TITLE = "Los par\xE1metros de la red han cambiado";
var NEED_SAVE_CURRENT_SCENARIO_TOASTER_MESSAGE = "Es necesario guardar el escenario para que el sistema pueda actualizar la evaluaci\xF3n";
var NEED_SAVE_CURRENT_SCENARIO_TOASTER_BUTTON_TEXT = "Guardar escenario";
var NEED_SAVE_CURRENT_SCENARIO_TOASTER_BORDER_RADIUS_IN_PIXELS = 6;
var NEED_SAVE_CURRENT_SCENARIO_TOASTER_LABEL_LEFT_WIDTH_IN_PIXELS = 40;
var NEED_SAVE_CURRENT_SCENARIO_TOASTER_HEIGHT_IN_PIXELS = 75;
var NeedSaveCurrentScenarioToasterRootComponent = styled66(FlexComponent53)`
  min-height: ${NEED_SAVE_CURRENT_SCENARIO_TOASTER_HEIGHT_IN_PIXELS}px;
  background: var(--otk-theme-color-white);
  border: 0;
  border-radius: ${NEED_SAVE_CURRENT_SCENARIO_TOASTER_BORDER_RADIUS_IN_PIXELS}px;
  padding: 0;
`;
var NeedSaveCurrentScenarioToasterLabelLeftComponent = styled66(FlexComponent53)`
  width: ${NEED_SAVE_CURRENT_SCENARIO_TOASTER_LABEL_LEFT_WIDTH_IN_PIXELS}px;
  background: var(--otk-theme-color-primary);
  border-top-left-radius: ${NEED_SAVE_CURRENT_SCENARIO_TOASTER_BORDER_RADIUS_IN_PIXELS}px;
  border-bottom-left-radius: ${NEED_SAVE_CURRENT_SCENARIO_TOASTER_BORDER_RADIUS_IN_PIXELS}px;
  padding: 0;
`;
var NeedSaveCurrentScenarioToasterLabelRightComponent = styled66(FlexComponent53)`
  background: var(--otk-theme-color-grey-100);
  border-top-right-radius: ${NEED_SAVE_CURRENT_SCENARIO_TOASTER_BORDER_RADIUS_IN_PIXELS}px;
  border-bottom-right-radius: ${NEED_SAVE_CURRENT_SCENARIO_TOASTER_BORDER_RADIUS_IN_PIXELS}px;
`;
function useNeedSaveCurrentScenarioToasterHook({
  onSave,
  onDismiss,
  onAutoClose
}) {
  const open = (scenario) => {
    const toastId = toast20(
      /* @__PURE__ */ React110.createElement(
        NeedSaveCurrentScenarioToasterRootComponent,
        {
          alignItems: "stretch",
          gap: "0",
          justifyContent: "center",
          width: "100%"
        },
        /* @__PURE__ */ React110.createElement(
          NeedSaveCurrentScenarioToasterLabelLeftComponent,
          {
            alignItems: "center",
            flexDirection: "column",
            justifyContent: "center"
          },
          /* @__PURE__ */ React110.createElement(
            IconComponent14,
            {
              color: "var(--otk-theme-color-grey-900)",
              name: "update-heart-beat",
              size: "xl"
            }
          )
        ),
        /* @__PURE__ */ React110.createElement(
          NeedSaveCurrentScenarioToasterLabelRightComponent,
          {
            alignItems: "center",
            flexDirection: "column",
            flexGrow: "1",
            gap: "var(--otk-theme-space-s)",
            justifyContent: "start",
            padding: "var(--otk-theme-space-m)",
            width: "100%"
          },
          /* @__PURE__ */ React110.createElement(TextComponent36, { fontWeight: "medium", size: "m", variant: "secondary", width: "100%" }, NEED_SAVE_CURRENT_SCENARIO_TOASTER_TITLE),
          /* @__PURE__ */ React110.createElement(TextComponent36, { fontWeight: "medium", size: "m", width: "100%" }, NEED_SAVE_CURRENT_SCENARIO_TOASTER_MESSAGE),
          /* @__PURE__ */ React110.createElement(
            ButtonComponent24,
            {
              color: "primary",
              onClick: () => {
                if (!onSave) {
                  return;
                }
                toast20.dismiss(toastId);
                onSave(scenario);
              },
              size: "s"
            },
            NEED_SAVE_CURRENT_SCENARIO_TOASTER_BUTTON_TEXT
          )
        )
      ),
      {
        closeButton: true,
        duration: 5e3,
        style: {
          padding: 0,
          border: "none"
        },
        onDismiss,
        onAutoClose
      }
    );
  };
  return {
    open
  };
}

// src/modules/network/components/save-scenario/save-scenario-modal-hook.tsx
import React112 from "react";
import { Modal as Modal4 } from "react-async-popup";

// src/modules/network/components/save-scenario/save-scenario-modal-component.tsx
import React111, { useState as useState30 } from "react";
import {
  FlexComponent as FlexComponent54,
  ModalComponent as ModalComponent7,
  TextComponent as TextComponent37,
  Input as InputComponent4
} from "@ontruck/fe-ui";
function SaveScenarioModalComponent({
  isOpen = false,
  onSave,
  onGoBack,
  onClose
}) {
  const [name, setName] = useState30("");
  const [description, setDescription] = useState30("");
  const handleChangeName = (e) => {
    setName(e.target.value);
  };
  const handleChangeDescription = (_, value) => {
    setDescription(value != null ? value : "");
  };
  const handleOnConfirm = () => {
    if (onSave) {
      onSave(name, description);
    }
  };
  return /* @__PURE__ */ React111.createElement(
    ModalComponent7,
    {
      bodyComponent: /* @__PURE__ */ React111.createElement(FlexComponent54, { alignSelf: "stretch", flexDirection: "column", gap: "8px" }, /* @__PURE__ */ React111.createElement(TextComponent37, null, "Guardar escenario"), /* @__PURE__ */ React111.createElement(
        InputComponent4,
        {
          handleChangeEvent: handleChangeName,
          label: "Nombre",
          name: "save-scenario-name",
          type: "text",
          value: name
        }
      ), /* @__PURE__ */ React111.createElement(
        InputComponent4,
        {
          handleChangeValue: handleChangeDescription,
          label: "Descripci\xF3n",
          name: "save-scenario-description",
          type: "textarea",
          value: description
        }
      )),
      cancelButtonLabel: "Volver",
      confirmButtonLabel: "Guardar escenario",
      isOpen,
      onCancel: onGoBack,
      onClose,
      onConfirm: handleOnConfirm
    }
  );
}

// src/modules/network/components/save-scenario/save-scenario-modal-hook.tsx
var useSaveScenarioModalHook = ({
  onSave,
  onGoBack,
  onClose
}) => {
  const open = (scenario) => __async(void 0, null, function* () {
    const { show, destroy } = yield Modal4.new({
      content: /* @__PURE__ */ React112.createElement(
        SaveScenarioModalComponent,
        {
          isOpen: true,
          onClose: () => {
            void destroy();
            if (onClose) {
              onClose();
            }
          },
          onGoBack: () => {
            void destroy();
            if (onClose) {
              onClose();
            }
            if (onGoBack) {
              onGoBack();
            }
          },
          onSave: (name, description) => {
            if (onSave) {
              onSave(__spreadProps(__spreadValues({}, scenario), {
                name,
                description
              }));
            }
            if (onClose) {
              onClose();
            }
            void destroy();
          }
        }
      ),
      footer: null
    });
    yield show();
  });
  return {
    open: (scenario) => void open(scenario)
  };
};

// src/shared/utils/get-date-in-backend-format-by-time.ts
var getDateTimeInBackendFormatByDateAndTime = (time, dateStr) => {
  if (!time) {
    throw new Error("There is no time to get date in backend format by time and date");
  }
  if (!dateStr) {
    throw new Error("There is no date to get date in backend format by time and date");
  }
  const timeRegex = /^(?:[01]?[0-9]|2[0-3]):[0-5][0-9]$/;
  if (!timeRegex.test(time)) {
    throw new Error('Time must be in "HH:MM" format (e.g., "14:00")');
  }
  const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
  if (!dateRegex.test(dateStr)) {
    throw new Error('Date must be in "YYYY-MM-DD" format (e.g., "2025-10-30")');
  }
  const [yearStr, monthStr, dayStr] = dateStr.split("-");
  const [hoursStr, minutesStr] = time.split(":");
  const year = Number(yearStr);
  const month = Number(monthStr);
  const day = Number(dayStr);
  const hours = Number(hoursStr);
  const minutes = Number(minutesStr);
  const date = new Date(Date.UTC(year, month - 1, day, hours, minutes, 0, 0));
  const formattedYear = date.getUTCFullYear();
  const formattedMonth = String(date.getUTCMonth() + 1).padStart(2, "0");
  const formattedDay = String(date.getUTCDate()).padStart(2, "0");
  const formattedHours = String(date.getUTCHours()).padStart(2, "0");
  const formattedMinutes = String(date.getUTCMinutes()).padStart(2, "0");
  const seconds = String(date.getUTCSeconds()).padStart(2, "0");
  const microseconds = String(date.getUTCMilliseconds() * 1e3).padStart(3, "0");
  return `${formattedYear}-${formattedMonth}-${formattedDay}T${formattedHours}:${formattedMinutes}:${seconds}.${microseconds}Z`;
};

// src/modules/network/scenario/save-scenario-mapper.ts
function getChangeStopsMapper(change, scenarioDate) {
  return change.stops.map((stop, s) => {
    const isOrigin = s === 0;
    if (isOrigin) {
      return {
        arrival: null,
        departure: stop.departureTime ? getDateTimeInBackendFormatByDateAndTime(stop.departureTime, scenarioDate) : null,
        delegation_code: stop.delegationCode
      };
    }
    const isDestination = s === change.stops.length - 1;
    if (isDestination) {
      return {
        arrival: stop.arrivalTime ? getDateTimeInBackendFormatByDateAndTime(stop.arrivalTime, scenarioDate) : null,
        departure: null,
        delegation_code: stop.delegationCode
      };
    }
    return {
      arrival: stop.arrivalTime ? getDateTimeInBackendFormatByDateAndTime(stop.arrivalTime, scenarioDate) : null,
      departure: stop.departureTime ? getDateTimeInBackendFormatByDateAndTime(stop.departureTime, scenarioDate) : null,
      delegation_code: stop.delegationCode
    };
  });
}
function getChangesMapper(scenarioDate, changes) {
  if (!changes) {
    return [];
  }
  const changesMapped = changes.map(
    (change) => {
      if (change.discriminator === scenarioChangeDiscriminators.addRoute) {
        const vehicleCategory = change.vehicleType === scenarioRouteVehicleTypes.van ? scenarioVehicleCategoriesDto.light : scenarioVehicleCategoriesDto.heavy;
        return {
          cost: change.cost,
          discriminator: change.discriminator,
          route_identifier: change.routeIdentifier,
          stops: getChangeStopsMapper(change, scenarioDate),
          vehicle_category: vehicleCategory
        };
      }
      if (change.discriminator === scenarioChangeDiscriminators.editRoute) {
        const vehicleCategory = change.vehicleType === scenarioRouteVehicleTypes.van ? scenarioVehicleCategoriesDto.light : scenarioVehicleCategoriesDto.heavy;
        return {
          cost: change.cost,
          discriminator: change.discriminator,
          route_identifier: change.routeIdentifier,
          stops: getChangeStopsMapper(change, scenarioDate),
          vehicle_category: vehicleCategory
        };
      }
      if (change.discriminator === scenarioChangeDiscriminators.deleteRoute) {
        return {
          discriminator: change.discriminator,
          route_identifier: change.routeIdentifier
        };
      }
      return {
        discriminator: change.discriminator
      };
    }
  );
  return changesMapped;
}
function saveScenarioMapper(scenario) {
  const mappedChanges = getChangesMapper(scenario.date, scenario.changes);
  return {
    id: scenario.id,
    parent_id: scenario.parentId ? Number(scenario.parentId) : null,
    name: scenario.name,
    date: scenario.date,
    description: scenario.description,
    changes: mappedChanges
  };
}
function saveScenarioSuccessMapper(newScenarioSuccessDto) {
  const mappedChanges = getChangesMapper(
    newScenarioSuccessDto.date,
    newScenarioSuccessDto.elided_changes
  );
  return {
    date: newScenarioSuccessDto.date,
    id: newScenarioSuccessDto.id,
    name: newScenarioSuccessDto.name,
    elidedChanges: mappedChanges,
    parentId: newScenarioSuccessDto.parent_id ? String(newScenarioSuccessDto.parent_id) : void 0
  };
}
function saveScenarioErrorMapper(newScenarioErrorDto) {
  return {
    detail: newScenarioErrorDto.detail
  };
}

// src/modules/network/scenario/save-scenario-api.ts
var saveScenarioApi = (_0) => __async(void 0, [_0], function* ({
  config,
  scenario
}) {
  const url = `${config.apiBase}/concordia/v1/networks/scenarios`;
  const scenarioDto = saveScenarioMapper(scenario);
  const response = yield fetch(url, {
    method: "POST",
    cache: "no-cache",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${config.token}`
    },
    body: JSON.stringify(scenarioDto)
  });
  if (response.ok) {
    const data2 = yield response.json();
    const newScenarioSuccess = saveScenarioSuccessMapper(data2);
    return newScenarioSuccess;
  }
  const data = yield response.json();
  const newScenarioError = saveScenarioErrorMapper(data);
  return newScenarioError;
});

// src/modules/network/scenario/save-scenario-hook.ts
import { useState as useState31 } from "react";

// src/modules/network/scenario/save-scenario-success-toaster-hook.tsx
import React113 from "react";
import styled67 from "styled-components";
import { toast as toast21 } from "sonner";
import { FlexComponent as FlexComponent55, TextComponent as TextComponent38 } from "@ontruck/fe-ui";
import { IconComponent as IconComponent15 } from "@ontruck/fe-icons";
var SAVE_SCENARIO_SUCCESS_TOASTER_MESSAGE = "El escenario se ha creado correctamente";
var SAVE_SCENARIO_SUCCESS_TOASTER_BORDER_RADIUS_IN_PIXELS = 6;
var SAVE_SCENARIO_SUCCESS_TOASTER_LABEL_LEFT_WIDTH_IN_PIXELS = 40;
var SAVE_SCENARIO_SUCCESS_TOASTER_HEIGHT_IN_PIXELS = 75;
var SaveScenarioSuccessToasterRootComponent = styled67(FlexComponent55)`
  min-height: ${SAVE_SCENARIO_SUCCESS_TOASTER_HEIGHT_IN_PIXELS}px;
  background: var(--otk-theme-color-white);
  border: 0;
  border-radius: ${SAVE_SCENARIO_SUCCESS_TOASTER_BORDER_RADIUS_IN_PIXELS}px;
  padding: 0;
`;
var SaveScenarioSuccessToasterLabelLeftComponent = styled67(FlexComponent55)`
  width: ${SAVE_SCENARIO_SUCCESS_TOASTER_LABEL_LEFT_WIDTH_IN_PIXELS}px;
  background: var(--otk-theme-color-primary);
  border-top-left-radius: ${SAVE_SCENARIO_SUCCESS_TOASTER_BORDER_RADIUS_IN_PIXELS}px;
  border-bottom-left-radius: ${SAVE_SCENARIO_SUCCESS_TOASTER_BORDER_RADIUS_IN_PIXELS}px;
  padding: 0;
`;
var SaveScenarioSuccessToasterLabelRightComponent = styled67(FlexComponent55)`
  background: var(--otk-theme-color-grey-100);
  border-top-right-radius: ${SAVE_SCENARIO_SUCCESS_TOASTER_BORDER_RADIUS_IN_PIXELS}px;
  border-bottom-right-radius: ${SAVE_SCENARIO_SUCCESS_TOASTER_BORDER_RADIUS_IN_PIXELS}px;
`;
function useSaveScenarioSuccessToasterHook() {
  return {
    open: () => {
      toast21(
        /* @__PURE__ */ React113.createElement(
          SaveScenarioSuccessToasterRootComponent,
          {
            alignItems: "stretch",
            gap: "0",
            justifyContent: "center",
            width: "100%"
          },
          /* @__PURE__ */ React113.createElement(
            SaveScenarioSuccessToasterLabelLeftComponent,
            {
              alignItems: "center",
              flexDirection: "column",
              justifyContent: "center"
            },
            /* @__PURE__ */ React113.createElement(
              IconComponent15,
              {
                color: "var(--otk-theme-color-grey-900)",
                name: "circle-line-check",
                size: "xl"
              }
            )
          ),
          /* @__PURE__ */ React113.createElement(
            SaveScenarioSuccessToasterLabelRightComponent,
            {
              alignItems: "center",
              flexDirection: "column",
              flexGrow: "1",
              gap: "var(--otk-theme-space-s)",
              justifyContent: "start",
              padding: "var(--otk-theme-space-m)",
              width: "100%"
            },
            /* @__PURE__ */ React113.createElement(TextComponent38, { fontWeight: "medium", size: "m", width: "100%" }, SAVE_SCENARIO_SUCCESS_TOASTER_MESSAGE)
          )
        ),
        {
          closeButton: false,
          duration: 1500,
          style: {
            padding: 0,
            border: "none"
          }
        }
      );
    }
  };
}

// src/modules/network/scenario/save-scenario-error-toaster-hook.tsx
import React114 from "react";
import styled68 from "styled-components";
import { toast as toast22 } from "sonner";
import { FlexComponent as FlexComponent56, TextComponent as TextComponent39 } from "@ontruck/fe-ui";
import { IconComponent as IconComponent16 } from "@ontruck/fe-icons";
var SAVE_SCENARIO_ERROR_TOASTER_MESSAGE = "El escenario no se ha creado correctamente";
var SAVE_SCENARIO_ERROR_TOASTER_BORDER_RADIUS_IN_PIXELS = 6;
var SAVE_SCENARIO_ERROR_TOASTER_LABEL_LEFT_WIDTH_IN_PIXELS = 40;
var SAVE_SCENARIO_ERROR_TOASTER_HEIGHT_IN_PIXELS = 75;
var SaveScenarioErrorToasterRootComponent = styled68(FlexComponent56)`
  min-height: ${SAVE_SCENARIO_ERROR_TOASTER_HEIGHT_IN_PIXELS}px;
  background: var(--otk-theme-color-white);
  border: 0;
  border-radius: ${SAVE_SCENARIO_ERROR_TOASTER_BORDER_RADIUS_IN_PIXELS}px;
  padding: 0;
`;
var SaveScenarioErrorToasterLabelLeftComponent = styled68(FlexComponent56)`
  width: ${SAVE_SCENARIO_ERROR_TOASTER_LABEL_LEFT_WIDTH_IN_PIXELS}px;
  background: var(--otk-theme-color-primary);
  border-top-left-radius: ${SAVE_SCENARIO_ERROR_TOASTER_BORDER_RADIUS_IN_PIXELS}px;
  border-bottom-left-radius: ${SAVE_SCENARIO_ERROR_TOASTER_BORDER_RADIUS_IN_PIXELS}px;
  padding: 0;
`;
var SaveScenarioErrorToasterLabelRightComponent = styled68(FlexComponent56)`
  background: var(--otk-theme-color-grey-100);
  border-top-right-radius: ${SAVE_SCENARIO_ERROR_TOASTER_BORDER_RADIUS_IN_PIXELS}px;
  border-bottom-right-radius: ${SAVE_SCENARIO_ERROR_TOASTER_BORDER_RADIUS_IN_PIXELS}px;
`;
function useSaveScenarioErrorToasterHook() {
  return {
    open: () => {
      toast22(
        /* @__PURE__ */ React114.createElement(
          SaveScenarioErrorToasterRootComponent,
          {
            alignItems: "stretch",
            gap: "0",
            justifyContent: "center",
            width: "100%"
          },
          /* @__PURE__ */ React114.createElement(
            SaveScenarioErrorToasterLabelLeftComponent,
            {
              alignItems: "center",
              flexDirection: "column",
              justifyContent: "center"
            },
            /* @__PURE__ */ React114.createElement(IconComponent16, { color: "var(--otk-theme-color-grey-900)", name: "circle-x", size: "xl" })
          ),
          /* @__PURE__ */ React114.createElement(
            SaveScenarioErrorToasterLabelRightComponent,
            {
              alignItems: "center",
              flexDirection: "column",
              flexGrow: "1",
              gap: "var(--otk-theme-space-s)",
              justifyContent: "start",
              padding: "var(--otk-theme-space-m)",
              width: "100%"
            },
            /* @__PURE__ */ React114.createElement(TextComponent39, { fontWeight: "medium", size: "m", width: "100%" }, SAVE_SCENARIO_ERROR_TOASTER_MESSAGE)
          )
        ),
        {
          closeButton: false,
          duration: 1500,
          style: {
            padding: 0,
            border: "none"
          }
        }
      );
    }
  };
}

// src/modules/network/scenario/save-scenario-hook.ts
function getIsNewScenarioError(createScenarioResponse) {
  if (createScenarioResponse !== null && typeof createScenarioResponse === "object") {
    return "detail" in createScenarioResponse;
  }
  return false;
}
function getIsNewScenarioSuccess(createScenarioResponse) {
  if (createScenarioResponse !== null && typeof createScenarioResponse === "object") {
    return "elidedChanges" in createScenarioResponse;
  }
  return false;
}
var useSaveScenarioHook = ({
  config,
  onSuccess,
  onError
}) => {
  const [isLoading, setIsLoading] = useState31(false);
  const [error, setError] = useState31(null);
  const { open: openCreateScenarioSuccessToaster } = useSaveScenarioSuccessToasterHook();
  const { open: openCreateScenarioErrorToaster } = useSaveScenarioErrorToasterHook();
  const save = (scenario) => __async(void 0, null, function* () {
    if (!scenario) {
      console.error("There is no scenario to save at time to save scenario");
      return;
    }
    setIsLoading(true);
    try {
      const createNewScenarioResponse = yield saveScenarioApi({
        config,
        scenario
      });
      const isNewScenarioError = getIsNewScenarioError(createNewScenarioResponse);
      if (isNewScenarioError) {
        setIsLoading(false);
        openCreateScenarioErrorToaster();
        if (onError) {
          const responseErrorDetailsMessage = createNewScenarioResponse.detail.map((detail) => detail.msg).join(", ");
          onError(new Error(`Error saving scenario: ${responseErrorDetailsMessage}`));
        }
        return;
      }
      const isNewScenarioSuccess = getIsNewScenarioSuccess(createNewScenarioResponse);
      if (isNewScenarioSuccess) {
        setIsLoading(false);
        openCreateScenarioSuccessToaster();
        if (onSuccess) {
          onSuccess(createNewScenarioResponse);
        }
        return;
      }
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
      setError(e);
      openCreateScenarioErrorToaster();
      if (onError) {
        onError(e);
      }
    }
  });
  return {
    isLoading,
    error,
    save: (scenario) => void save(scenario)
  };
};

// src/modules/network/scenario/scenario-evaluation-has-been-created-success-toaster-hook.tsx
import React115, { useEffect as useEffect11, useState as useState32 } from "react";
import styled69 from "styled-components";
import { toast as toast23 } from "sonner";
import { FlexComponent as FlexComponent57, TextComponent as TextComponent40, ButtonComponent as ButtonComponent25 } from "@ontruck/fe-ui";
import { IconComponent as IconComponent17 } from "@ontruck/fe-icons";
var SCENARIO_EVALUATION_HAS_BEEN_CREATED_SUCCESS_TOASTER_BORDER_RADIUS_IN_PIXELS = 6;
var SCENARIO_EVALUATION_HAS_BEEN_CREATED_SUCCESS_TOASTER_LABEL_LEFT_WIDTH_IN_PIXELS = 40;
var SCENARIO_EVALUATION_HAS_BEEN_CREATED_SUCCESS_TOASTER_HEIGHT_IN_PIXELS = 75;
var SCENARIO_EVALUATION_HAS_BEEN_CREATED_SUCCESS_TOASTER_BUTTON_TEXT = "Lanzar evaluaci\xF3n";
var ScenarioEvaluationHasBeenCreatedSuccessToasterRootComponent = styled69(FlexComponent57)`
  min-height: ${SCENARIO_EVALUATION_HAS_BEEN_CREATED_SUCCESS_TOASTER_HEIGHT_IN_PIXELS}px;
  background: var(--otk-theme-color-white);
  border: 0;
  border-radius: ${SCENARIO_EVALUATION_HAS_BEEN_CREATED_SUCCESS_TOASTER_BORDER_RADIUS_IN_PIXELS}px;
  padding: 0;
`;
var ScenarioEvaluationHasBeenCreatedSuccessToasterLabelLeftComponent = styled69(FlexComponent57)`
  width: ${SCENARIO_EVALUATION_HAS_BEEN_CREATED_SUCCESS_TOASTER_LABEL_LEFT_WIDTH_IN_PIXELS}px;
  background: var(--otk-theme-color-primary);
  border-top-left-radius: ${SCENARIO_EVALUATION_HAS_BEEN_CREATED_SUCCESS_TOASTER_BORDER_RADIUS_IN_PIXELS}px;
  border-bottom-left-radius: ${SCENARIO_EVALUATION_HAS_BEEN_CREATED_SUCCESS_TOASTER_BORDER_RADIUS_IN_PIXELS}px;
  padding: 0;
`;
var ScenarioEvaluationHasBeenCreatedSuccessToasterLabelRightComponent = styled69(FlexComponent57)`
  background: var(--otk-theme-color-grey-100);
  border-top-right-radius: ${SCENARIO_EVALUATION_HAS_BEEN_CREATED_SUCCESS_TOASTER_BORDER_RADIUS_IN_PIXELS}px;
  border-bottom-right-radius: ${SCENARIO_EVALUATION_HAS_BEEN_CREATED_SUCCESS_TOASTER_BORDER_RADIUS_IN_PIXELS}px;
`;
function useScenarioEvaluationHasBeenCreatedSuccessToasterHook() {
  const [toasterId, setToasterId] = useState32(void 0);
  useEffect11(() => {
    return () => {
      if (toasterId) {
        toast23.dismiss(toasterId);
      }
    };
  }, [toasterId]);
  return {
    open: ({
      scenarioName,
      evaluationId,
      onRunEvaluation
    }) => {
      const id = toast23(
        /* @__PURE__ */ React115.createElement(
          ScenarioEvaluationHasBeenCreatedSuccessToasterRootComponent,
          {
            alignItems: "stretch",
            gap: "0",
            justifyContent: "center",
            width: "100%"
          },
          /* @__PURE__ */ React115.createElement(
            ScenarioEvaluationHasBeenCreatedSuccessToasterLabelLeftComponent,
            {
              alignItems: "center",
              flexDirection: "column",
              justifyContent: "center"
            },
            /* @__PURE__ */ React115.createElement(
              IconComponent17,
              {
                color: "var(--otk-theme-color-grey-900)",
                name: "circle-line-check",
                size: "xl"
              }
            )
          ),
          /* @__PURE__ */ React115.createElement(
            ScenarioEvaluationHasBeenCreatedSuccessToasterLabelRightComponent,
            {
              alignItems: "center",
              flexDirection: "column",
              flexGrow: "1",
              gap: "var(--otk-theme-space-s)",
              justifyContent: "start",
              padding: "var(--otk-theme-space-m)",
              width: "100%"
            },
            /* @__PURE__ */ React115.createElement(TextComponent40, { fontWeight: "medium", size: "m", width: "100%" }, "La evaluaci\xF3n\xA0", /* @__PURE__ */ React115.createElement(TextComponent40, { fontWeight: "bold", size: "m", width: "auto" }, evaluationId), "\xA0para el escenario\xA0", /* @__PURE__ */ React115.createElement(TextComponent40, { fontWeight: "bold", size: "m", width: "auto" }, scenarioName), "\xA0se ha creado correctamente."),
            /* @__PURE__ */ React115.createElement(
              ButtonComponent25,
              {
                color: "primary",
                onClick: () => {
                  if (!onRunEvaluation) {
                    return;
                  }
                  toast23.dismiss(toasterId);
                  onRunEvaluation(evaluationId);
                },
                size: "s"
              },
              SCENARIO_EVALUATION_HAS_BEEN_CREATED_SUCCESS_TOASTER_BUTTON_TEXT
            )
          )
        ),
        {
          id: `scenario-evaluation-has-been-created-success-toaster-${evaluationId}`,
          closeButton: true,
          duration: Infinity,
          style: {
            padding: 0,
            border: "none"
          }
        }
      );
      setToasterId(id);
    },
    dismiss: () => {
      if (toasterId) {
        toast23.dismiss(toasterId);
      }
    }
  };
}

// src/modules/network/scenario/get-scenarios-with-evaluation-created-hook.ts
import { useEffect as useEffect12, useState as useState33 } from "react";
import useSWR21 from "swr";

// src/modules/network/networks/get-networks-with-scenario-api.ts
var getNetworksWithScenarioApi = (_0) => __async(void 0, [_0], function* ({
  config
}) {
  const url = `${config.apiBase}/concordia/v1/networks/networks/?page_size=0&scenario_id__isnull=false`;
  const response = yield fetch(url, {
    method: "GET",
    cache: "no-cache",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${config.token}`
    }
  });
  if (response.ok) {
    const data = yield response.json();
    return data;
  }
  throw new Error("Failed to fetch networks with scenario");
});

// src/modules/network/networks/get-networks-with-scenario-fetcher.ts
var getNetworksWithScenarioFetcher = (config) => {
  return getNetworksWithScenarioApi({ config });
};

// src/modules/network/scenario/get-scenarios-with-evaluation-created-hook.ts
var useGetScenariosWithEvaluationCreatedHook = ({
  scenariosIdsEvaluationBuilding,
  config
}) => {
  const _a = config, { shouldRetryOnError } = _a, restConfig = __objRest(_a, ["shouldRetryOnError"]);
  const [scenariosIdsEvaluationCreated, setScenariosIdsEvaluationCreated] = useState33(void 0);
  const fetcher = () => __async(void 0, null, function* () {
    return getNetworksWithScenarioFetcher(restConfig);
  });
  const { data, error, isLoading } = useSWR21(
    `get-all-networks-with-scenario`,
    scenariosIdsEvaluationBuilding && scenariosIdsEvaluationBuilding.length > 0 ? fetcher : null,
    {
      shouldRetryOnError,
      refreshInterval: 1e3
    }
  );
  useEffect12(() => {
    if (data && scenariosIdsEvaluationBuilding && scenariosIdsEvaluationBuilding.length > 0) {
      const { results } = data;
      const scenariosIds = [];
      for (const result of results) {
        for (const scenarioEvaluationId of scenariosIdsEvaluationBuilding) {
          if (result.scenario_id === Number(scenarioEvaluationId)) {
            scenariosIds.push({ scenarioId: scenarioEvaluationId, networkId: String(result.id) });
          }
        }
      }
      setScenariosIdsEvaluationCreated(scenariosIds);
    } else {
      if (!data) {
        console.error(
          "no data coming from api if we try to call by evaluations with scenarios ids"
        );
      }
      if (!scenariosIdsEvaluationBuilding || scenariosIdsEvaluationBuilding.length === 0) {
        console.warn("no scenarios evaluations ids running to filter by");
      }
    }
  }, [data, scenariosIdsEvaluationBuilding]);
  return {
    scenariosIdsEvaluationCreated,
    isLoading,
    error
  };
};

// src/modules/network/components/route-editor/edit-route/edit-route-component.tsx
import {
  closestCenter as closestCenter2,
  DndContext as DndContext2,
  KeyboardSensor as KeyboardSensor2,
  MeasuringStrategy as MeasuringStrategy2,
  PointerSensor as PointerSensor2,
  useSensor as useSensor2,
  useSensors as useSensors2
} from "@dnd-kit/core";
import {
  arrayMove as arrayMove2,
  SortableContext as SortableContext2,
  sortableKeyboardCoordinates as sortableKeyboardCoordinates2,
  verticalListSortingStrategy as verticalListSortingStrategy2
} from "@dnd-kit/sortable";
import { FlexComponent as FlexComponent65, TextComponent as TextComponent47 } from "@ontruck/fe-ui";
import React124, { useCallback as useCallback18, useEffect as useEffect14, useMemo as useMemo33, useState as useState37 } from "react";

// src/modules/network/components/route-editor/edit-route/edit-route-footer-component.tsx
import React117 from "react";
import styled71 from "styled-components";
import { FlexComponent as FlexComponent59, ButtonComponent as ButtonComponent26 } from "@ontruck/fe-ui";

// src/modules/network/components/route-editor/edit-route/edit-route-stops-columns-widths.ts
var editRouteStopsTableColumnsWidths = {
  leftEmptyColumn: routeEditorColumnsWidths.leftEmptyColumn,
  delegationColumn: "195px",
  arrivalTimeColumn: "55px",
  departureTimeColumn: "55px",
  actionDeleteColumn: "55px",
  actionEditColumn: "55px"
};

// src/modules/network/components/route-editor/edit-route/edit-route-select-route-is-active-component.tsx
import React116 from "react";
import styled70 from "styled-components";
import { FlexComponent as FlexComponent58, CheckboxInputComponent, TextComponent as TextComponent41 } from "@ontruck/fe-ui";
var EditRouteSelectRouteIsActiveRootComponent = styled70(FlexComponent58)`
  background: var(--otk-theme-color-grey-200);
  border: var(--otk-ui-input-border);
  border-left: 20px solid var(--otk-theme-color-grey-300);
  border-right: none;
  border-bottom: none;
  padding: var(--otk-theme-space-m);

  & input {
    background: var(--otk-theme-color-white);
  }
`;
function EditRouteSelectRouteIsActiveComponent({
  isActive = false,
  onChange
}) {
  const handleChange = (name, value) => {
    if (onChange) {
      onChange(name, value);
    }
  };
  return /* @__PURE__ */ React116.createElement(
    EditRouteSelectRouteIsActiveRootComponent,
    {
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%"
    },
    /* @__PURE__ */ React116.createElement(FlexComponent58, { gap: "var(--otk-theme-space-xs)" }, /* @__PURE__ */ React116.createElement(TextComponent41, { fontWeight: "medium" }, "Ruta activa"), /* @__PURE__ */ React116.createElement(TextComponent41, null, "- Impacta en la evaluaci\xF3n")),
    /* @__PURE__ */ React116.createElement(
      CheckboxInputComponent,
      {
        isChecked: isActive,
        name: "create-route-is-active-checkbox",
        onToggleCheck: handleChange,
        variant: "primary"
      }
    )
  );
}

// src/modules/network/components/route-editor/edit-route/edit-route-footer-component.tsx
var EditRouteFooterActionsComponent = styled71(FlexComponent59)`
  background: var(--otk-theme-color-grey-100);
  width: 100%;
  height: 50px;
  border-top: 1px solid var(--otk-theme-color-grey-300);
  padding: var(--otk-theme-space-s);
`;
function EditRouteFooterComponent({
  isDisabled = false,
  onChangeRouteCost,
  onChangeRouteIsActive,
  onChangeRouteType,
  onEditRoute,
  routeCost,
  routeIsActive,
  routeType
}) {
  return /* @__PURE__ */ React117.createElement(
    FlexComponent59,
    {
      alignItems: "center",
      backgroundColor: "var(--otk-theme-color-grey-100)",
      flexDirection: "column",
      justifyContent: "center",
      width: "100%"
    },
    /* @__PURE__ */ React117.createElement(
      FlexComponent59,
      {
        alignItems: "stretch",
        backgroundColor: "var(--otk-theme-color-grey-200)",
        borderLeft: `${editRouteStopsTableColumnsWidths.leftEmptyColumn} solid var(--otk-theme-color-grey-300)`,
        borderTop: "1px solid var(--otk-theme-color-grey-300)",
        height: "110px",
        padding: "var(--otk-theme-space-m)",
        width: "100%"
      },
      /* @__PURE__ */ React117.createElement("div", { style: { width: "70%" } }, /* @__PURE__ */ React117.createElement(SelectRouteTypeComponent, { onChange: onChangeRouteType, type: routeType })),
      /* @__PURE__ */ React117.createElement("div", { style: { width: "30%" } }, /* @__PURE__ */ React117.createElement(SelectRouteCostComponent, { cost: routeCost, onChange: onChangeRouteCost }))
    ),
    /* @__PURE__ */ React117.createElement(
      EditRouteSelectRouteIsActiveComponent,
      {
        isActive: routeIsActive,
        onChange: onChangeRouteIsActive
      }
    ),
    /* @__PURE__ */ React117.createElement(EditRouteFooterActionsComponent, null, /* @__PURE__ */ React117.createElement(
      ButtonComponent26,
      {
        color: "primary",
        disabled: isDisabled,
        fullWidth: true,
        onClick: onEditRoute,
        size: "s"
      },
      "Guardar cambios"
    ))
  );
}

// src/modules/network/components/route-editor/edit-route/edit-route-header-component.tsx
import React118 from "react";
import styled72 from "styled-components";
import { DrawerComponent as DrawerComponent2, ButtonComponent as ButtonComponent27, TextComponent as TextComponent42, FlexComponent as FlexComponent60 } from "@ontruck/fe-ui";
import { IconComponent as IconComponent18 } from "@ontruck/fe-icons";
var EditRouteHeaderRootComponent = styled72(DrawerComponent2.Header)`
  background: var(--otk-theme-color-primary);
  height: 70px;
`;
function EditRouteHeaderComponent({
  onClose,
  routeIdentifier = "Editar ruta"
}) {
  return /* @__PURE__ */ React118.createElement(EditRouteHeaderRootComponent, null, /* @__PURE__ */ React118.createElement(
    FlexComponent60,
    {
      alignItems: "center",
      justifyContent: "space-between",
      padding: "var(--otk-theme-space-s) var(--otk-theme-space-s) var(--otk-theme-space-s) var(--otk-theme-space-l)",
      width: "100%"
    },
    /* @__PURE__ */ React118.createElement(
      FlexComponent60,
      {
        flexDirection: "column",
        gap: "var(--otk-theme-space-xs)",
        justifyContent: "center",
        width: "100%"
      },
      /* @__PURE__ */ React118.createElement(TextComponent42, { fontWeight: "normal", size: "s", variant: "secondary" }, "Ruta"),
      /* @__PURE__ */ React118.createElement(TextComponent42, { fontWeight: "medium", size: "2xl", variant: "secondary" }, routeIdentifier)
    ),
    /* @__PURE__ */ React118.createElement(ButtonComponent27, { color: "primary", name: "close", onClick: onClose, variant: "icon" }, /* @__PURE__ */ React118.createElement(IconComponent18, { colorVariant: "primary", name: "close" }))
  ));
}

// src/modules/network/components/route-editor/edit-route/edit-route-stops-component.tsx
import React122 from "react";
import styled74 from "styled-components";

// src/modules/network/components/route-editor/edit-route/edit-route-stops-header-component.tsx
import React119 from "react";
import { FlexComponent as FlexComponent61, TextComponent as TextComponent43 } from "@ontruck/fe-ui";
import { IconComponent as IconComponent19 } from "@ontruck/fe-icons";
function EditRouteStopsHeaderComponent() {
  return /* @__PURE__ */ React119.createElement(
    FlexComponent61,
    {
      alignItems: "center",
      backgroundColor: "var(--otk-theme-color-white, #FFFFFF)",
      height: `${TABLE_CELL_MIN_HEIGHT_IN_PIXELS}px`,
      width: "100%"
    },
    /* @__PURE__ */ React119.createElement(
      RouteEditorStopTableCellComponent,
      {
        background: "var(--otk-theme-color-grey-300, #CCD7E0);",
        borderRight: "1px solid var(--otk-theme-color-grey-300, #CCD7E0)",
        justifyContent: "center",
        padding: "unset",
        width: editRouteStopsTableColumnsWidths.leftEmptyColumn
      }
    ),
    /* @__PURE__ */ React119.createElement(
      RouteEditorStopTableCellComponent,
      {
        background: "var(--otk-theme-color-grey-100, #F2F5F8)",
        borderLeft: "unset",
        borderRight: "1px solid var(--otk-theme-color-grey-200, #E2E8EE)",
        justifyContent: "start",
        padding: "0 var(--otk-theme-space-m)",
        width: editRouteStopsTableColumnsWidths.delegationColumn
      },
      /* @__PURE__ */ React119.createElement(TextComponent43, { color: "var(--otk-theme-color-grey-500, #54708C)", fontWeight: "bold", uppercase: true }, "DELEGACI\xD3N")
    ),
    /* @__PURE__ */ React119.createElement(
      RouteEditorStopTableCellComponent,
      {
        background: "rgba(204, 214, 224, 0.3)",
        borderLeft: "unset",
        borderRight: "1px solid var(--otk-theme-color-white, #FFF)",
        justifyContent: "center",
        padding: "unset",
        width: editRouteStopsTableColumnsWidths.arrivalTimeColumn
      },
      /* @__PURE__ */ React119.createElement(TextComponent43, { color: "var( --otk-theme-color-grey-700, #54708C)", fontWeight: "medium" }, /* @__PURE__ */ React119.createElement(
        IconComponent19,
        {
          color: "var(--otk-theme-color-grey-500, #94A6B8)",
          name: "circle-arrow-right",
          sizeInPixels: 22
        }
      ))
    ),
    /* @__PURE__ */ React119.createElement(
      RouteEditorStopTableCellComponent,
      {
        background: "rgba(204, 214, 224, 0.3)",
        borderLeft: "unset",
        borderRight: "unset",
        justifyContent: "center",
        padding: "unset",
        width: editRouteStopsTableColumnsWidths.departureTimeColumn
      },
      /* @__PURE__ */ React119.createElement(TextComponent43, { color: "var( --otk-theme-color-grey-700, #54708C)", fontWeight: "medium" }, /* @__PURE__ */ React119.createElement(
        IconComponent19,
        {
          color: "var(--otk-theme-color-grey-500, #94A6B8)",
          name: "circle-line-arrow-right",
          sizeInPixels: 22
        }
      ))
    ),
    /* @__PURE__ */ React119.createElement(
      RouteEditorStopTableCellComponent,
      {
        background: "var(--otk-theme-color-grey-100, #F2F5F8)",
        borderRight: "1px solid var(--otk-theme-color-grey-100, #F2F5F8)",
        justifyContent: "center",
        padding: "unset",
        width: editRouteStopsTableColumnsWidths.actionDeleteColumn
      }
    ),
    /* @__PURE__ */ React119.createElement(
      RouteEditorStopTableCellComponent,
      {
        background: "var(--otk-theme-color-grey-100, #F2F5F8)",
        borderRight: "1px solid var(--otk-theme-color-grey-100, #F2F5F8)",
        justifyContent: "center",
        padding: "unset",
        width: editRouteStopsTableColumnsWidths.actionEditColumn
      }
    )
  );
}

// src/modules/network/components/route-editor/edit-route/edit-route-stops-body-component.tsx
import React121, { useState as useState35 } from "react";
import { FlexComponent as FlexComponent63, TextComponent as TextComponent45, ButtonComponent as ButtonComponent29 } from "@ontruck/fe-ui";
import { IconComponent as IconComponent21 } from "@ontruck/fe-icons";

// src/modules/network/components/route-editor/edit-route/edit-route-stop-component.tsx
import React120, { useState as useState34, useEffect as useEffect13 } from "react";
import {
  FlexComponent as FlexComponent62,
  TextComponent as TextComponent44,
  TimeInputNativeComponent as TimeInputNativeComponent2,
  ButtonComponent as ButtonComponent28
} from "@ontruck/fe-ui";
import styled73 from "styled-components";
import { IconComponent as IconComponent20 } from "@ontruck/fe-icons";
var EditRouteStopRootComponent = styled73(FlexComponent62)`
  width: 100%;
  height: 90px;
  padding: 0 var(--otk-theme-space-s);
  background-color: var(--otk-theme-color-grey-200);
  border-left: 20px solid var(--otk-theme-color-grey-300);
  border-top: 1px solid var(--otk-theme-color-grey-400);
`;
function EditRouteStopComponent({
  stopDelegationId,
  stopId,
  stopArrivalTime,
  stopDepartureTime,
  stopDelegationCode,
  stopDelegationName,
  isOrigin = false,
  isDestination = false,
  onFinishEditStop
}) {
  const [editedArrivalTime, setEditedArrivalTime] = useState34(stopArrivalTime || "");
  const [editedDepartureTime, setEditedDepartureTime] = useState34(stopDepartureTime || "");
  const [isEditionDisabled, setIsEditionDisabled] = useState34(false);
  useEffect13(() => {
    if (isOrigin) {
      setEditedArrivalTime("");
    }
    if (isDestination) {
      setEditedDepartureTime("");
    }
  }, [isOrigin, isDestination]);
  useEffect13(() => {
    if (isOrigin) {
      setIsEditionDisabled(editedArrivalTime !== "" || editedDepartureTime === "");
    }
    if (isDestination) {
      setIsEditionDisabled(editedDepartureTime !== "" || editedArrivalTime === "");
    }
  }, [isOrigin, isDestination, editedArrivalTime, editedDepartureTime]);
  const handleChangeArrivalTime = (name, value) => {
    setEditedArrivalTime(value);
  };
  const handleChangeDepartureTime = (name, value) => {
    setEditedDepartureTime(value);
  };
  const handleFinishEditStop = () => {
    if (isEditionDisabled) {
      return;
    }
    if (onFinishEditStop) {
      onFinishEditStop({
        arrivalTime: editedArrivalTime,
        delegation: stopDelegationName,
        delegationCode: stopDelegationCode,
        departureTime: editedDepartureTime,
        id: stopDelegationId,
        stopId
      });
    }
  };
  return /* @__PURE__ */ React120.createElement(
    EditRouteStopRootComponent,
    {
      alignItems: "start",
      flexDirection: "column",
      gap: "10px",
      justifyContent: "center"
    },
    /* @__PURE__ */ React120.createElement(TextComponent44, { fontWeight: "medium", size: "m" }, stopDelegationName),
    /* @__PURE__ */ React120.createElement(FlexComponent62, { gap: "10px", width: "100%" }, /* @__PURE__ */ React120.createElement(FlexComponent62, { flex: "1", gap: "10px" }, /* @__PURE__ */ React120.createElement(
      TimeInputNativeComponent2,
      {
        handleChangeValue: handleChangeArrivalTime,
        isRequired: true,
        label: "Hora llegada",
        name: "create-route-edit-stop-input-arrival-time",
        value: editedArrivalTime
      }
    ), /* @__PURE__ */ React120.createElement(
      TimeInputNativeComponent2,
      {
        handleChangeValue: handleChangeDepartureTime,
        isRequired: true,
        label: "Hora salida",
        name: "create-route-edit-stop-input-departure-time",
        value: editedDepartureTime
      }
    )), /* @__PURE__ */ React120.createElement(
      ButtonComponent28,
      {
        color: "primary",
        disabled: isEditionDisabled,
        height: "40px",
        isDisabled: isEditionDisabled,
        onClick: handleFinishEditStop,
        size: "s",
        variant: "icon"
      },
      /* @__PURE__ */ React120.createElement(IconComponent20, { name: "check", size: "l" })
    ))
  );
}

// src/modules/network/components/route-editor/edit-route/edit-route-stops-body-component.tsx
function EditRouteStopsBodyComponent({
  onEditStop,
  onRemoveStop,
  stops
}) {
  const [stopsEditing, setStopsEditing] = useState35([]);
  const handleStartEditStop = (stopId) => {
    const stopIsEditing = stopsEditing.find((s) => s.stopId === stopId);
    if (stopIsEditing) {
      console.warn("Stop is already being edited");
      return;
    }
    const stop = stops.find((s) => s.stopId === stopId);
    if (!stop) {
      console.warn("Stop to be edited is not found");
      return;
    }
    setStopsEditing((prev) => [...prev, stop]);
  };
  const handleFinishEditStop = (editedDraftStop) => {
    const stopIsEditing = stopsEditing.find((s) => s.stopId === editedDraftStop.stopId);
    if (!stopIsEditing) {
      console.warn("Stop is not being edited to finish editing");
      return;
    }
    const newStopsEditing = stopsEditing.filter((s) => s.stopId !== editedDraftStop.stopId);
    setStopsEditing(newStopsEditing);
    if (onEditStop) {
      onEditStop(editedDraftStop);
    }
  };
  const handleRemoveStop = (stopId, stopDelegationCode) => {
    if (onRemoveStop) {
      onRemoveStop(stopId, stopDelegationCode);
    }
  };
  return /* @__PURE__ */ React121.createElement(FlexComponent63, { alignItems: "stretch", flexDirection: "column", gap: "0px", height: "100%", width: "100%" }, /* @__PURE__ */ React121.createElement(RouteEditorStopsDroppableComponent, { id: "create-route-stops" }, stops.map((s, index) => {
    const id = `${s.delegationCode}-${index}`;
    const key = `${s.id}-${index}`;
    const stopIsEditing = stopsEditing.find((stop) => stop.stopId === s.stopId);
    if (stopIsEditing) {
      const isOrigin = index === 0;
      const isDestination = index === stops.length - 1;
      return /* @__PURE__ */ React121.createElement(
        EditRouteStopComponent,
        {
          isDestination,
          isOrigin,
          key: id,
          onFinishEditStop: handleFinishEditStop,
          stopArrivalTime: s.arrivalTime,
          stopDelegationCode: s.delegationCode,
          stopDelegationId: s.id,
          stopDelegationName: s.delegation,
          stopDepartureTime: s.departureTime,
          stopId: s.stopId
        }
      );
    }
    return /* @__PURE__ */ React121.createElement(
      RouteEditorStopSortableComponent,
      {
        draggableButtonComponent: /* @__PURE__ */ React121.createElement(
          RouteEditorStopTableCellComponent,
          {
            alignItems: "center",
            background: "var(--otk-theme-color-grey-300, #CCD7E0);",
            borderBottom: "1px solid var(--otk-theme-color-grey-400, #CCD7E0)",
            borderRight: "1px solid var(--otk-theme-color-grey-300, #CCD7E0)",
            borderTop: "1px solid var(--otk-theme-color-grey-400, #CCD7E0)",
            justifyContent: "center",
            padding: "unset",
            width: editRouteStopsTableColumnsWidths.leftEmptyColumn
          },
          /* @__PURE__ */ React121.createElement(
            IconComponent21,
            {
              color: "var(--otk-theme-color-grey-600, #94A6B8)",
              name: "drag-indicator",
              sizeInPixels: 22
            }
          )
        ),
        id,
        key
      },
      /* @__PURE__ */ React121.createElement(
        FlexComponent63,
        {
          alignItems: "center",
          height: `${TABLE_CELL_MIN_HEIGHT_IN_PIXELS}px`,
          width: "100%"
        },
        /* @__PURE__ */ React121.createElement(
          RouteEditorStopTableCellComponent,
          {
            background: "var(--otk-theme-color-white, #FFFFFF);",
            borderBottom: "1px solid var(--otk-theme-color-grey-300, #CCD7E0)",
            borderRight: "1px solid var(--otk-theme-color-grey-200, #E2E8EE)",
            borderTop: "1px solid var(--otk-theme-color-grey-300, #CCD7E0)",
            justifyContent: "start",
            padding: "0 var(--otk-theme-space-m)",
            width: editRouteStopsTableColumnsWidths.delegationColumn
          },
          /* @__PURE__ */ React121.createElement(
            TextComponent45,
            {
              color: "var( --otk-theme-color-grey-700, #54708C)",
              fontWeight: "medium"
            },
            s.delegation
          )
        ),
        /* @__PURE__ */ React121.createElement(
          RouteEditorStopTableCellComponent,
          {
            background: "#f0f3f5",
            borderBottom: "1px solid var(--otk-theme-color-grey-300, #CCD7E0)",
            borderLeft: "unset",
            borderRight: "1px solid var(--otk-theme-color-white, #FFF)",
            borderTop: "1px solid var(--otk-theme-color-grey-300, #CCD7E0)",
            justifyContent: "center",
            padding: "unset",
            width: editRouteStopsTableColumnsWidths.arrivalTimeColumn
          },
          /* @__PURE__ */ React121.createElement(
            TextComponent45,
            {
              color: "var( --otk-theme-color-grey-700, #54708C)",
              fontWeight: "medium"
            },
            s.departureTime
          )
        ),
        /* @__PURE__ */ React121.createElement(
          RouteEditorStopTableCellComponent,
          {
            background: "#f0f3f5",
            borderBottom: "1px solid var(--otk-theme-color-grey-300, #CCD7E0)",
            borderLeft: "unset",
            borderRight: "unset",
            borderTop: "1px solid var(--otk-theme-color-grey-300, #CCD7E0)",
            justifyContent: "center",
            padding: "unset",
            width: editRouteStopsTableColumnsWidths.departureTimeColumn
          },
          /* @__PURE__ */ React121.createElement(
            TextComponent45,
            {
              color: "var( --otk-theme-color-grey-700, #54708C)",
              fontWeight: "medium"
            },
            s.arrivalTime
          )
        ),
        /* @__PURE__ */ React121.createElement(
          RouteEditorStopTableCellComponent,
          {
            alignItems: "center",
            background: "var(--otk-theme-color-grey-100, #F2F5F8);",
            borderBottom: "1px solid var(--otk-theme-color-grey-300, #CCD7E0)",
            borderRight: "1px solid var(--otk-theme-color-white, #FFFFFF)",
            borderTop: "1px solid var(--otk-theme-color-grey-300, #CCD7E0)",
            justifyContent: "center",
            padding: "unset",
            width: editRouteStopsTableColumnsWidths.actionDeleteColumn
          },
          /* @__PURE__ */ React121.createElement(
            ButtonComponent29,
            {
              onClick: () => {
                handleRemoveStop(s.stopId, s.delegationCode);
              },
              variant: "icon"
            },
            /* @__PURE__ */ React121.createElement(
              IconComponent21,
              {
                color: "var(--otk-theme-color-grey-500, #94A6B8)",
                name: "trash-line",
                sizeInPixels: 22
              }
            )
          )
        ),
        /* @__PURE__ */ React121.createElement(
          RouteEditorStopTableCellComponent,
          {
            alignItems: "center",
            background: "var(--otk-theme-color-grey-100, #F2F5F8);",
            borderBottom: "1px solid var(--otk-theme-color-grey-300, #CCD7E0)",
            borderRight: "1px solid var(--otk-theme-color-white, #FFFFFF)",
            borderTop: "1px solid var(--otk-theme-color-grey-300, #CCD7E0)",
            justifyContent: "center",
            padding: "unset",
            width: editRouteStopsTableColumnsWidths.actionEditColumn
          },
          /* @__PURE__ */ React121.createElement(
            ButtonComponent29,
            {
              onClick: () => {
                handleStartEditStop(s.stopId);
              },
              variant: "icon"
            },
            /* @__PURE__ */ React121.createElement(
              IconComponent21,
              {
                color: "var(--otk-theme-color-grey-500, #94A6B8)",
                name: "pencil",
                sizeInPixels: 22
              }
            )
          )
        )
      )
    );
  })));
}

// src/modules/network/components/route-editor/edit-route/edit-route-stops-component.tsx
var EditRouteStopsRootComponent = styled74.div`
  width: 100%;
  border-bottom: 5px solid var(--otk-theme-color-grey-400);
  border-top: 5px solid var(--otk-theme-color-grey-400);
`;
function EditRouteStopsComponent({
  onEditRouteStop,
  onRemoveRouteStop,
  routeStops
}) {
  if (!routeStops) {
    console.warn("No draft route stops provided");
    return null;
  }
  const handleEditStop = (editedDraftStop) => {
    if (onEditRouteStop) {
      onEditRouteStop(editedDraftStop);
    }
  };
  return /* @__PURE__ */ React122.createElement(EditRouteStopsRootComponent, null, /* @__PURE__ */ React122.createElement(EditRouteStopsHeaderComponent, null), /* @__PURE__ */ React122.createElement(
    EditRouteStopsBodyComponent,
    {
      onEditStop: handleEditStop,
      onRemoveStop: onRemoveRouteStop,
      stops: routeStops
    }
  ));
}

// src/modules/network/components/route-editor/edit-route/edit-route-success-toaster-hook.tsx
import React123 from "react";
import styled75 from "styled-components";
import { toast as toast24 } from "sonner";
import { FlexComponent as FlexComponent64, TextComponent as TextComponent46 } from "@ontruck/fe-ui";
import { IconComponent as IconComponent22 } from "@ontruck/fe-icons";
var EDIT_ROUTE_SUCCESS_TOASTER_MESSAGE = "La ruta se ha editado correctamente";
var EDIT_ROUTE_SUCCESS_TOASTER_ROUTE_ID_LABEL = "RUTA";
var EDIT_ROUTE_SUCCESS_TOASTER_ROUTE_ID_DEFAULT = "S0000001";
var EDIT_ROUTE_SUCCESS_TOASTER_BORDER_RADIUS_IN_PIXELS = 6;
var EDIT_ROUTE_SUCCESS_TOASTER_LABEL_LEFT_WIDTH_IN_PIXELS = 40;
var EDIT_ROUTE_SUCCESS_TOASTER_HEIGHT_IN_PIXELS = 75;
var EditRouteSuccessToasterRootComponent = styled75(FlexComponent64)`
  min-height: ${EDIT_ROUTE_SUCCESS_TOASTER_HEIGHT_IN_PIXELS}px;
  background: var(--otk-theme-color-white);
  border: 0;
  border-radius: ${EDIT_ROUTE_SUCCESS_TOASTER_BORDER_RADIUS_IN_PIXELS}px;
  padding: 0;
`;
var EditRouteSuccessToasterLabelLeftComponent = styled75(FlexComponent64)`
  width: ${EDIT_ROUTE_SUCCESS_TOASTER_LABEL_LEFT_WIDTH_IN_PIXELS}px;
  background: var(--otk-theme-color-primary);
  border-top-left-radius: ${EDIT_ROUTE_SUCCESS_TOASTER_BORDER_RADIUS_IN_PIXELS}px;
  border-bottom-left-radius: ${EDIT_ROUTE_SUCCESS_TOASTER_BORDER_RADIUS_IN_PIXELS}px;
  padding: 0;
`;
var EditRouteSuccessToasterLabelRightComponent = styled75(FlexComponent64)`
  background: var(--otk-theme-color-grey-100);
  border-top-right-radius: ${EDIT_ROUTE_SUCCESS_TOASTER_BORDER_RADIUS_IN_PIXELS}px;
  border-bottom-right-radius: ${EDIT_ROUTE_SUCCESS_TOASTER_BORDER_RADIUS_IN_PIXELS}px;
`;
function useEditRouteSuccessToasterHook() {
  return {
    open: (routeId = EDIT_ROUTE_SUCCESS_TOASTER_ROUTE_ID_DEFAULT) => {
      toast24(
        /* @__PURE__ */ React123.createElement(
          EditRouteSuccessToasterRootComponent,
          {
            alignItems: "stretch",
            gap: "0",
            justifyContent: "center",
            width: "100%"
          },
          /* @__PURE__ */ React123.createElement(
            EditRouteSuccessToasterLabelLeftComponent,
            {
              alignItems: "center",
              flexDirection: "column",
              justifyContent: "center"
            },
            /* @__PURE__ */ React123.createElement(
              IconComponent22,
              {
                color: "var(--otk-theme-color-grey-900)",
                name: "circle-line-check",
                size: "xl"
              }
            )
          ),
          /* @__PURE__ */ React123.createElement(
            EditRouteSuccessToasterLabelRightComponent,
            {
              alignItems: "center",
              flexDirection: "column",
              flexGrow: "1",
              gap: "var(--otk-theme-space-s)",
              justifyContent: "start",
              padding: "var(--otk-theme-space-m)",
              width: "100%"
            },
            /* @__PURE__ */ React123.createElement(TextComponent46, { fontWeight: "medium", size: "m", width: "100%" }, EDIT_ROUTE_SUCCESS_TOASTER_MESSAGE),
            /* @__PURE__ */ React123.createElement(TextComponent46, { width: "100%" }, EDIT_ROUTE_SUCCESS_TOASTER_ROUTE_ID_LABEL, ": ", routeId)
          )
        ),
        {
          closeButton: false,
          duration: 1500,
          style: {
            padding: 0,
            border: "none"
          }
        }
      );
    }
  };
}

// src/modules/network/components/route-editor/edit-route/get-edited-draft-routes-hook.ts
import { useState as useState36 } from "react";
function getRouteDelegation(stopChanges, operation, delegations) {
  const delegation = delegations.find((d) => d.id === stopChanges.id);
  if (!delegation) {
    console.warn("No delegation found for edited draft route stop");
    return;
  }
  return {
    id: stopChanges.id,
    stopId: stopChanges.stopId,
    actualArrivalTime: stopChanges.arrivalTime,
    actualDepartureTime: stopChanges.departureTime,
    delegationCode: delegation.delegationCode,
    name: delegation.name,
    operation,
    theoreticalArrivalTime: stopChanges.arrivalTime,
    theoreticalDepartureTime: stopChanges.departureTime,
    coordinates: {
      longitude: delegation.longitude,
      latitude: delegation.latitude
    },
    // REVIEW: We need to get the skipped from the form? if not, what should be the default value?
    skipped: false
  };
}
function getEditedRouteLeg(originChanges, destinationChanges, editableLeg, delegations) {
  const origin = getRouteDelegation(originChanges, routeOperations.departure, delegations);
  const destination = getRouteDelegation(destinationChanges, routeOperations.arrival, delegations);
  if (!origin) {
    console.warn("No origin found for edited draft route leg");
    return;
  }
  if (!destination) {
    console.warn("No destination found for edited draft route leg");
    return;
  }
  return __spreadProps(__spreadValues({}, editableLeg), {
    origin,
    destination
  });
}
function getRouteOrigin(isRoundTrip, legs, delegations) {
  var _a;
  let origin = legs[0].origin;
  if (isRoundTrip) {
    origin = legs[legs.length - 1].destination;
  }
  const originDelegationCode = (_a = delegations.find((d) => d.id === origin.id)) == null ? void 0 : _a.delegationCode;
  return __spreadProps(__spreadValues({}, origin), {
    delegationCode: originDelegationCode != null ? originDelegationCode : "",
    theoreticalArrivalTime: void 0
  });
}
function getRouteDestination(isRoundTrip, legs, delegations) {
  var _a;
  let destination = legs[legs.length - 1].destination;
  if (isRoundTrip) {
    destination = legs[legs.length - 1].origin;
  }
  const destinationDelegationCode = (_a = delegations.find(
    (d) => d.id === destination.id
  )) == null ? void 0 : _a.delegationCode;
  return __spreadProps(__spreadValues({}, destination), {
    delegationCode: destinationDelegationCode != null ? destinationDelegationCode : "",
    theoreticalDepartureTime: void 0
  });
}
function getEditedDelegations(originId, destinationId, stopsChanges, allDelegations) {
  const routeDelegations = [];
  for (const stopChanges of stopsChanges) {
    const routeDelegation = getRouteDelegation(
      stopChanges,
      routeOperations.departure,
      allDelegations
    );
    if (!routeDelegation) {
      continue;
    }
    if (routeDelegation.id === originId) {
      routeDelegation.theoreticalArrivalTime = void 0;
    }
    if (routeDelegation.id === destinationId) {
      routeDelegation.theoreticalDepartureTime = void 0;
    }
    routeDelegations.push(routeDelegation);
  }
  return routeDelegations;
}
var getEditedLegs = (stopsChanges, allDelegations, editableLegs) => {
  const editedLegs = [];
  for (let s = 0; s < stopsChanges.length; s++) {
    const stopChanges = stopsChanges[s];
    const isLastStop = s === stopsChanges.length - 1;
    if (isLastStop) {
      continue;
    }
    const legOriginChanges = stopChanges;
    const legDestinationChanges = stopsChanges[s + 1];
    const editableLeg = editableLegs[s === 0 ? 0 : s - 1];
    const leg = getEditedRouteLeg(
      legOriginChanges,
      legDestinationChanges,
      editableLeg,
      allDelegations
    );
    if (!leg) {
      continue;
    }
    editedLegs.push(leg);
  }
  return editedLegs;
};
var getEditedStops = (originId, destinationId, stopsChanges, allDelegations) => {
  const editedDelegations = [];
  for (const stopChanges of stopsChanges) {
    const editedDelegation = getRouteDelegation(
      stopChanges,
      routeOperations.departure,
      allDelegations
    );
    if (!editedDelegation) {
      continue;
    }
    if (editedDelegation.id === originId) {
      editedDelegation.theoreticalArrivalTime = void 0;
    }
    if (editedDelegation.id === destinationId) {
      editedDelegation.theoreticalDepartureTime = void 0;
    }
    editedDelegations.push(editedDelegation);
  }
  return editedDelegations;
};
var getEditedRoute = ({
  vehicleType,
  cost,
  stops,
  isActive,
  allDelegations,
  editableRoute
}) => {
  const { legs: editableLegs } = editableRoute;
  const legs = getEditedLegs(stops, allDelegations, editableLegs);
  const isRoundTrip = getIsRouteRoundTripService(legs);
  const origin = getRouteOrigin(isRoundTrip, legs, allDelegations);
  const destination = getRouteDestination(isRoundTrip, legs, allDelegations);
  const delegations = getEditedDelegations(origin.id, destination.id, stops, allDelegations);
  const routeStops = getEditedStops(origin.id, destination.id, stops, allDelegations);
  const numberOfDelegations = delegations.length;
  return __spreadProps(__spreadValues({}, editableRoute), {
    legs,
    cost,
    delegations,
    destination,
    origin,
    numberOfDelegations,
    roundTrip: isRoundTrip,
    stops: routeStops,
    vehicleType,
    isEditedDraft: true,
    isActive
  });
};
var useGetEditedDraftRoutesHook = ({
  delegations: allDelegations,
  onEditDraftRouteSuccess
}) => {
  const [editedDraftRoutes, setEditedDraftRoutes] = useState36([]);
  const editDraftRoute = ({
    vehicleType,
    cost,
    stops,
    isActive,
    editableRoute
  }) => {
    if (!editableRoute) {
      console.warn("No editable route provided to edit draft route");
      return;
    }
    if (!stops || stops.length === 0) {
      console.warn("No scenario found you should add a scenario first");
      return;
    }
    if (!allDelegations) {
      console.warn("No network delegations provided to get draft route");
      return;
    }
    const editedDraftRoute = getEditedRoute({
      vehicleType,
      cost,
      isActive,
      stops,
      allDelegations,
      editableRoute
    });
    setEditedDraftRoutes([...editedDraftRoutes, editedDraftRoute]);
    if (onEditDraftRouteSuccess) {
      onEditDraftRouteSuccess(editedDraftRoute.id);
    }
    return editedDraftRoute;
  };
  return {
    editedDraftRoutes,
    editDraftRoute
  };
};

// src/modules/network/components/route-editor/edit-route/edit-route-component.tsx
var measuringConfig2 = {
  droppable: {
    strategy: MeasuringStrategy2.Always
  }
};
function EditRouteComponent({
  config,
  isClean = false,
  networkId,
  onClose,
  onEditRoute,
  route
}) {
  const [editedRouteCost, setEditedRouteCost] = useState37("");
  const [editedRouteIsActive, setEditedRouteIsActive] = useState37(true);
  const [editedRouteVehicleType, setEditedRouteVehicleType] = useState37(
    routeVehicleTypes.van
  );
  useEffect14(() => {
    var _a;
    if (!route) {
      return;
    }
    setEditedRouteCost(route.cost || "");
    setEditedRouteIsActive((_a = route.isActive) != null ? _a : true);
    setEditedRouteVehicleType(route.vehicleType);
  }, [route]);
  const [editedStopsChanges, setEditedStopsChanges] = useState37([]);
  useEffect14(() => {
    if (!(route == null ? void 0 : route.stops) || route.stops.length === 0) {
      console.warn("No stops found for route to be editable");
      setEditedStopsChanges([]);
      return;
    }
    const getArrivalTime = (s) => {
      if (s.theoreticalArrivalTime && s.theoreticalArrivalTime !== "") {
        return s.theoreticalArrivalTime;
      }
      if (s.actualArrivalTime && s.actualArrivalTime !== "") {
        return s.actualArrivalTime;
      }
      return "";
    };
    const getDepartureTime = (s) => {
      if (s.theoreticalDepartureTime && s.theoreticalDepartureTime !== "") {
        return s.theoreticalDepartureTime;
      }
      if (s.actualDepartureTime && s.actualDepartureTime !== "") {
        return s.actualDepartureTime;
      }
      return "";
    };
    const stopsChanges = route.stops.map((s, i) => ({
      id: s.id,
      delegationCode: s.delegationCode,
      stopId: s.stopId || `route-${route.id}-vertex-${s.id}-position-${i}`,
      delegation: s.name,
      arrivalTime: getArrivalTime(s),
      departureTime: getDepartureTime(s)
    }));
    setEditedStopsChanges(stopsChanges);
  }, [route]);
  const [editedStopsDelegationCodes, setEditedStopsDelegationCodes] = useState37([]);
  const [isOpenAddNewStop, setIsOpenAddNewStop] = useState37(false);
  const [newStopArrivalTime, setNewStopArrivalTime] = useState37("");
  const [newStopDepartureTime, setNewStopDepartureTime] = useState37("");
  const [newStopDelegationCode, setNewStopDelegationCode] = useState37();
  const shouldBeStopsListVisible = editedStopsChanges.length > 0;
  const areUnsavedDraftChanges = useMemo33(() => {
    const thereAreRouteTypeChanges = editedRouteVehicleType !== (route == null ? void 0 : route.vehicleType);
    const thereAreRouteIsActiveChanges = editedRouteIsActive !== (route == null ? void 0 : route.isActive);
    const thereAreRouteCostChanges = editedRouteCost !== (route == null ? void 0 : route.cost);
    const getArrivalTime = (s) => {
      if (s.theoreticalArrivalTime && s.theoreticalArrivalTime !== "") {
        return s.theoreticalArrivalTime;
      }
      if (s.actualArrivalTime && s.actualArrivalTime !== "") {
        return s.actualArrivalTime;
      }
      return "";
    };
    const getDepartureTime = (s) => {
      if (s.theoreticalDepartureTime && s.theoreticalDepartureTime !== "") {
        return s.theoreticalDepartureTime;
      }
      if (s.actualDepartureTime && s.actualDepartureTime !== "") {
        return s.actualDepartureTime;
      }
      return "";
    };
    const thereAreEditedStopsChanges = (() => {
      if (!(route == null ? void 0 : route.stops) || route.stops.length === 0) {
        return editedStopsChanges.length > 0;
      }
      if (editedStopsChanges.length !== route.stops.length) {
        return true;
      }
      for (let i = 0; i < editedStopsChanges.length; i++) {
        const editedStop = editedStopsChanges[i];
        const originalStop = route.stops[i];
        if (editedStop.delegationCode !== originalStop.delegationCode) {
          return true;
        }
        const originalArrivalTime = getArrivalTime(originalStop);
        if (editedStop.arrivalTime !== originalArrivalTime) {
          return true;
        }
        const originalDepartureTime = getDepartureTime(originalStop);
        if (editedStop.departureTime !== originalDepartureTime) {
          return true;
        }
      }
      return false;
    })();
    return thereAreEditedStopsChanges || thereAreRouteTypeChanges || thereAreRouteIsActiveChanges || thereAreRouteCostChanges;
  }, [route, editedStopsChanges, editedRouteVehicleType, editedRouteIsActive, editedRouteCost]);
  const editRouteIsDisabled = useMemo33(() => {
    var _a, _b, _c, _d;
    if (!areUnsavedDraftChanges) {
      return true;
    }
    const getArrivalTime = (s) => {
      if (s.theoreticalArrivalTime && s.theoreticalArrivalTime !== "") {
        return s.theoreticalArrivalTime;
      }
      if (s.actualArrivalTime && s.actualArrivalTime !== "") {
        return s.actualArrivalTime;
      }
      return "";
    };
    const getDepartureTime = (s) => {
      if (s.theoreticalDepartureTime && s.theoreticalDepartureTime !== "") {
        return s.theoreticalDepartureTime;
      }
      if (s.actualDepartureTime && s.actualDepartureTime !== "") {
        return s.actualDepartureTime;
      }
      return "";
    };
    const stopsHaveChanged = (() => {
      if (!(route == null ? void 0 : route.stops) || route.stops.length === 0) {
        return editedStopsChanges.length > 0;
      }
      if (editedStopsChanges.length !== route.stops.length) {
        return true;
      }
      for (let i = 0; i < editedStopsChanges.length; i++) {
        const editedStop = editedStopsChanges[i];
        const originalStop = route.stops[i];
        if (editedStop.delegationCode !== originalStop.delegationCode) {
          return true;
        }
        const originalArrivalTime = getArrivalTime(originalStop);
        if (editedStop.arrivalTime !== originalArrivalTime) {
          return true;
        }
        const originalDepartureTime = getDepartureTime(originalStop);
        if (editedStop.departureTime !== originalDepartureTime) {
          return true;
        }
      }
      return false;
    })();
    const thereIsRouteCostSelected = editedRouteCost && editedRouteCost !== "";
    const remainingStopsAreValidSubset = (() => {
      if (!(route == null ? void 0 : route.stops) || route.stops.length === 0) {
        return false;
      }
      if (editedStopsChanges.length < route.stops.length && editedStopsChanges.length > 0) {
        const originalStopsMap = /* @__PURE__ */ new Map();
        route.stops.forEach((stop) => {
          originalStopsMap.set(stop.delegationCode, stop);
        });
        return editedStopsChanges.every((editedStop) => {
          const originalStop = originalStopsMap.get(editedStop.delegationCode);
          if (!originalStop) {
            return false;
          }
          const originalArrivalTime = getArrivalTime(originalStop);
          const originalDepartureTime = getDepartureTime(originalStop);
          return editedStop.arrivalTime === originalArrivalTime && editedStop.departureTime === originalDepartureTime;
        });
      }
      return false;
    })();
    if (!stopsHaveChanged) {
      return !thereIsRouteCostSelected;
    }
    if (remainingStopsAreValidSubset) {
      const thereAreMinimumTwoStops2 = editedStopsChanges.length >= 2;
      return !thereAreMinimumTwoStops2 || !thereIsRouteCostSelected;
    }
    const thereAreMinimumTwoStops = editedStopsChanges.length >= 2;
    const thereIsOriginDepartureTime = ((_a = editedStopsChanges[0]) == null ? void 0 : _a.departureTime) !== "";
    const thereIsOriginArrivalTime = ((_b = editedStopsChanges[0]) == null ? void 0 : _b.arrivalTime) !== "";
    const thereIsDestinationArrivalTime = ((_c = editedStopsChanges[editedStopsChanges.length - 1]) == null ? void 0 : _c.arrivalTime) !== "";
    const thereIsDestinationDepartureTime = ((_d = editedStopsChanges[editedStopsChanges.length - 1]) == null ? void 0 : _d.departureTime) !== "";
    const thereIsArrivalAndDepartureTimeAtAllMiddleStops = editedStopsChanges.slice(1, -1).every((stop) => stop.arrivalTime !== "" && stop.departureTime !== "");
    const thereAreDelegationCodesSelected = editedStopsChanges.length > 0 && editedStopsChanges.every((stop) => stop.delegationCode && stop.delegationCode !== "");
    const allValidationsPass = thereAreMinimumTwoStops && thereIsRouteCostSelected && thereAreDelegationCodesSelected && thereIsOriginDepartureTime && !thereIsOriginArrivalTime && thereIsDestinationArrivalTime && !thereIsDestinationDepartureTime && thereIsArrivalAndDepartureTimeAtAllMiddleStops;
    return !allValidationsPass;
  }, [route, editedStopsChanges, editedRouteCost, areUnsavedDraftChanges]);
  const resetAddNewStopForm = useCallback18(() => {
    setNewStopArrivalTime("");
    setNewStopDepartureTime("");
    setNewStopDelegationCode(void 0);
  }, []);
  const resetForm = useCallback18(() => {
    var _a, _b;
    resetAddNewStopForm();
    setEditedRouteCost((route == null ? void 0 : route.cost) || "");
    setEditedRouteIsActive((_a = route == null ? void 0 : route.isActive) != null ? _a : true);
    setEditedRouteVehicleType((_b = route == null ? void 0 : route.vehicleType) != null ? _b : routeVehicleTypes.van);
    setEditedStopsDelegationCodes([]);
    setIsOpenAddNewStop(false);
    setNewStopArrivalTime("");
    setNewStopDepartureTime("");
    setNewStopDelegationCode(void 0);
  }, [resetAddNewStopForm, route]);
  useEffect14(() => {
    if (isClean) {
      resetForm();
    }
  }, [isClean, resetForm]);
  const {
    network,
    isLoading: networkIsLoading,
    error: networkError
  } = useGetNetworkHook({ networkId, config });
  const sensors = useSensors2(
    useSensor2(PointerSensor2),
    useSensor2(KeyboardSensor2, {
      coordinateGetter: sortableKeyboardCoordinates2
    })
  );
  const handleEditRouteSuccess = (routeId) => {
    if (onClose) {
      onClose();
    }
    openEditRouteSuccessToaster(routeId);
  };
  const { open: openEditRouteSuccessToaster } = useEditRouteSuccessToasterHook();
  const handleEditStopArrivalTime = (_, value) => {
    if (!value) {
      console.warn("No value provided to change arrival time");
      return;
    }
    setNewStopArrivalTime(value);
  };
  const handleEditStopDepartureTime = (_, value) => {
    if (!value) {
      console.warn("No value provided to change departure time");
      return;
    }
    setNewStopDepartureTime(value);
  };
  const handleEditRouteType = (_, value) => {
    if (!value) {
      console.warn("No value provided to change route type");
      return;
    }
    setEditedRouteVehicleType(value);
  };
  const handleEditRouteCost = (_, value) => {
    if (!value || value === "") {
      console.warn("No value provided to change route cost");
      return;
    }
    setEditedRouteCost(value);
  };
  const handleEditRouteIsActive = (_, value) => {
    if (value === void 0) {
      console.warn("No value provided to change route is active");
      return;
    }
    setEditedRouteIsActive(value);
  };
  const { editDraftRoute } = useGetEditedDraftRoutesHook({
    delegations: (network == null ? void 0 : network.delegations) || [],
    onEditDraftRouteSuccess: handleEditRouteSuccess
  });
  const editedStopsDelegationCodesMappedToAvoidCollisions = useMemo33(
    () => editedStopsChanges.map((d, i) => `${d.delegationCode}-${i}`),
    [editedStopsChanges]
  );
  const handleToggleAddNewStop = () => {
    setIsOpenAddNewStop((prev) => !prev);
  };
  const handleSelectNewStop = (_, value) => {
    if (!value) {
      console.warn("No value provided to select stop");
      return;
    }
    setNewStopDelegationCode(value);
  };
  const handleCreateNewStop = () => {
    if (!newStopDelegationCode) {
      console.warn("No draft stop id selected");
      return;
    }
    const delegationSelected = network == null ? void 0 : network.delegations.find(
      (d) => d.delegationCode === newStopDelegationCode
    );
    if (!delegationSelected) {
      console.warn("No delegation found for draft stop id selected");
      return;
    }
    const newDraftStopChanges = {
      id: delegationSelected.id,
      delegationCode: delegationSelected.delegationCode,
      stopId: `${route == null ? void 0 : route.id}-${delegationSelected.id}`,
      delegation: delegationSelected.name,
      arrivalTime: newStopArrivalTime,
      departureTime: newStopDepartureTime
    };
    setEditedStopsChanges([...editedStopsChanges, newDraftStopChanges]);
    setEditedStopsDelegationCodes([...editedStopsDelegationCodes, newStopDelegationCode]);
    resetAddNewStopForm();
  };
  const handleRemoveStop = (stopAtRouteId, stopDelegationCode) => {
    setEditedStopsChanges(editedStopsChanges.filter((d) => d.stopId !== stopAtRouteId));
    setEditedStopsDelegationCodes(
      editedStopsDelegationCodes.filter((delegationCode) => delegationCode !== stopDelegationCode)
    );
  };
  const handleEditStop = (editedStopChanges) => {
    setEditedStopsChanges(
      editedStopsChanges.map(
        (d) => d.stopId === editedStopChanges.stopId ? editedStopChanges : d
      )
    );
    setEditedStopsDelegationCodes([
      ...editedStopsDelegationCodes,
      editedStopChanges.delegationCode
    ]);
  };
  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (active.id !== (over == null ? void 0 : over.id)) {
      const oldIndex = editedStopsDelegationCodesMappedToAvoidCollisions.indexOf(
        active.id
      );
      const newIndex = editedStopsDelegationCodesMappedToAvoidCollisions.indexOf(
        over == null ? void 0 : over.id
      );
      setEditedStopsChanges([...arrayMove2(editedStopsChanges, oldIndex, newIndex)]);
      setEditedStopsDelegationCodes([...arrayMove2(editedStopsDelegationCodes, oldIndex, newIndex)]);
    }
  };
  const handleCloseEditRoute = () => {
    if (!onClose) {
      return;
    }
    onClose(areUnsavedDraftChanges);
  };
  const handleEditRoute = () => {
    const editedDraftRoute = editDraftRoute({
      vehicleType: editedRouteVehicleType,
      cost: editedRouteCost || "",
      isActive: editedRouteIsActive || true,
      stops: editedStopsChanges,
      editableRoute: route
    });
    if (!editedDraftRoute) {
      console.warn(`There is a problem editing the route ${route == null ? void 0 : route.routeIdentifier}`);
      return;
    }
    if (onEditRoute) {
      onEditRoute(editedDraftRoute);
    }
  };
  return /* @__PURE__ */ React124.createElement(
    DndContext2,
    {
      collisionDetection: closestCenter2,
      measuring: measuringConfig2,
      onDragEnd: handleDragEnd,
      sensors
    },
    /* @__PURE__ */ React124.createElement(
      FlexComponent65,
      {
        backgroundColor: "var(--otk-theme-color-grey-100)",
        flexDirection: "column",
        height: "100%",
        width: "100%"
      },
      /* @__PURE__ */ React124.createElement(
        EditRouteHeaderComponent,
        {
          onClose: handleCloseEditRoute,
          routeIdentifier: route == null ? void 0 : route.routeIdentifier
        }
      ),
      networkIsLoading || !(network == null ? void 0 : network.delegations) ? /* @__PURE__ */ React124.createElement(TextComponent47, null, "Cargando delegaciones...") : /* @__PURE__ */ React124.createElement(RouteEditorBodyComponent, null, /* @__PURE__ */ React124.createElement(
        CreateRouteStopComponent,
        {
          arrivalTimeSelected: newStopArrivalTime,
          delegations: network.delegations,
          departureTimeSelected: newStopDepartureTime,
          isOpen: isOpenAddNewStop,
          onChangeArrivalTime: handleEditStopArrivalTime,
          onChangeDepartureTime: handleEditStopDepartureTime,
          onCreateStop: handleCreateNewStop,
          onSelectStopDelegationCode: handleSelectNewStop,
          onToggle: handleToggleAddNewStop,
          stopDelegationCodeSelected: newStopDelegationCode
        }
      ), shouldBeStopsListVisible ? /* @__PURE__ */ React124.createElement(
        FlexComponent65,
        {
          flexDirection: "column",
          gap: "0",
          height: "100%",
          overflowX: "hidden",
          overflowY: "auto",
          width: "100%"
        },
        /* @__PURE__ */ React124.createElement(
          SortableContext2,
          {
            items: editedStopsDelegationCodesMappedToAvoidCollisions,
            strategy: verticalListSortingStrategy2
          },
          /* @__PURE__ */ React124.createElement(
            EditRouteStopsComponent,
            {
              onEditRouteStop: handleEditStop,
              onRemoveRouteStop: handleRemoveStop,
              routeStops: editedStopsChanges
            }
          )
        )
      ) : null, networkError ? /* @__PURE__ */ React124.createElement(TextComponent47, null, "Error al cargar las delegaciones") : null, /* @__PURE__ */ React124.createElement(
        EditRouteFooterComponent,
        {
          isDisabled: editRouteIsDisabled,
          onChangeRouteCost: handleEditRouteCost,
          onChangeRouteIsActive: handleEditRouteIsActive,
          onChangeRouteType: handleEditRouteType,
          onEditRoute: handleEditRoute,
          routeCost: editedRouteCost,
          routeIsActive: editedRouteIsActive,
          routeType: editedRouteVehicleType
        }
      ))
    )
  );
}

// src/modules/network/pages/routes/views/routes-map-view-component.tsx
import React146 from "react";
import { FlexComponent as FlexComponent82 } from "@ontruck/fe-ui";

// src/modules/network/pages/routes/components/filters/filters-component.tsx
import React125, { useMemo as useMemo34 } from "react";
import styled76 from "styled-components";
import {
  FlexComponent as FlexComponent66,
  Input as InputComponent5,
  MultiSelectInputComponent
} from "@ontruck/fe-ui";
var routeOperationOptionsIds = {
  arrival: routeOperations.arrival,
  departure: routeOperations.departure,
  transit: routeOperations.transit
};
var routeOperationOptions = [
  { label: "Salida", value: routeOperationOptionsIds.departure },
  { label: "LLegada", value: routeOperationOptionsIds.arrival },
  { label: "Paso", value: routeOperationOptionsIds.transit }
];
var routeTypeOptionsIds = {
  any: "any",
  contract: routeTypes.contract,
  spot: routeTypes.spot
};
var routeTypeOptions2 = [
  { label: "Ninguna", value: routeTypeOptionsIds.any },
  { label: "Fija", value: routeTypeOptionsIds.contract },
  { label: "Espor\xE1dica", value: routeTypeOptionsIds.spot }
];
var routeVehicleTypeOptionsIds = {
  any: "any",
  trailer: routeVehicleTypes.trailer,
  van: routeVehicleTypes.van
};
var vehicleTypeOptions = [
  { label: "Ninguno", value: routeVehicleTypeOptionsIds.any },
  { label: "Pesado", value: routeVehicleTypeOptionsIds.trailer },
  { label: "Ligero", value: routeVehicleTypeOptionsIds.van }
];
var routeProviderNameOptionsIds = {
  any: "any"
};
var FiltersWrappedComponent = styled76(FlexComponent66)`
  width: 100%;
  background-color: var(--otk-theme-color-white, #ffffff);
  padding: 0 var(--otk-theme-space-m, 16px);
`;
function FiltersComponent3({
  allRoutesIdentifiers,
  availableProviderNames,
  availableRoutesIdentifiers,
  isDelegationIdSelected = false,
  onChangeOperations,
  onChangeProviderName,
  onChangeRoutesIdentifiers,
  onChangeRouteType,
  onChangeVehicleType,
  selectedOperationsId,
  selectedProviderNameId,
  selectedRoutesIdentifiers,
  selectedRouteTypeId,
  selectedVehicleTypeId
}) {
  const providerOptions = useMemo34(() => {
    return [
      { label: "Ninguno", value: routeProviderNameOptionsIds.any },
      ...availableProviderNames.map((name) => ({
        label: name,
        value: name
      }))
    ];
  }, [availableProviderNames]);
  const routesIdentifiersOptions = useMemo34(() => {
    if (isDelegationIdSelected) {
      if (!availableRoutesIdentifiers || availableRoutesIdentifiers.length === 0) {
        return [];
      }
      return [
        ...availableRoutesIdentifiers.map((routeId) => ({
          label: routeId,
          value: routeId,
          searchValue: routeId
        }))
      ];
    }
    if (!allRoutesIdentifiers || allRoutesIdentifiers.length === 0) {
      return [];
    }
    return [
      ...allRoutesIdentifiers.map((routeId) => ({
        label: routeId,
        value: routeId,
        searchValue: routeId
      }))
    ];
  }, [availableRoutesIdentifiers, allRoutesIdentifiers, isDelegationIdSelected]);
  const handleChangeRouteType = (name, value) => {
    if (!onChangeRouteType) {
      return;
    }
    onChangeRouteType(name, value);
  };
  const handleChangeProvider = (name, value) => {
    if (!onChangeProviderName) {
      return;
    }
    onChangeProviderName(name, value);
  };
  const handleChangeVehicleType = (name, value) => {
    if (!onChangeVehicleType) {
      return;
    }
    onChangeVehicleType(name, value);
  };
  const handleChangeRoutesIdentifiers = (routesIds) => {
    if (!onChangeRoutesIdentifiers) {
      return;
    }
    onChangeRoutesIdentifiers(routesIds);
  };
  const handleChangeOperations = (operations) => {
    if (!onChangeOperations) {
      return;
    }
    onChangeOperations(operations);
  };
  return /* @__PURE__ */ React125.createElement(
    FiltersWrappedComponent,
    {
      alignItems: "center",
      flexDirection: "row",
      gap: "var(--otk-theme-space-s, 8px)",
      justifyContent: "start"
    },
    /* @__PURE__ */ React125.createElement(FlexComponent66, { alignItems: "center", flexDirection: "row", justifyContent: "center", width: "150px" }, /* @__PURE__ */ React125.createElement(
      InputComponent5,
      {
        handleChangeValue: handleChangeRouteType,
        label: "Tipo de Ruta",
        name: "delegation-map-filters-route-provider-selector",
        options: routeTypeOptions2,
        type: "select",
        value: selectedRouteTypeId,
        width: "100%"
      }
    )),
    /* @__PURE__ */ React125.createElement(FlexComponent66, { alignItems: "center", flexDirection: "row", justifyContent: "center", width: "250px" }, /* @__PURE__ */ React125.createElement(
      InputComponent5,
      {
        handleChangeValue: handleChangeProvider,
        label: "Proveedor",
        name: "delegation-map-filters-provider-selector",
        options: providerOptions,
        type: "select",
        value: selectedProviderNameId,
        width: "100%"
      }
    )),
    /* @__PURE__ */ React125.createElement(FlexComponent66, { alignItems: "center", flexDirection: "row", justifyContent: "center", width: "180px" }, /* @__PURE__ */ React125.createElement(
      InputComponent5,
      {
        handleChangeValue: handleChangeVehicleType,
        label: "Tipo de veh\xEDculo",
        name: "delegation-map-filters-vehicle-type-selector",
        options: vehicleTypeOptions,
        type: "select",
        value: selectedVehicleTypeId,
        width: "100%"
      }
    )),
    /* @__PURE__ */ React125.createElement(FlexComponent66, { alignItems: "center", flexDirection: "row", justifyContent: "center", width: "150px" }, /* @__PURE__ */ React125.createElement(
      MultiSelectInputComponent,
      {
        label: "Tipo de operaci\xF3n",
        name: "delegation-map-filters-delegation-as-type-selector",
        onChange: handleChangeOperations,
        options: routeOperationOptions,
        values: selectedOperationsId
      }
    )),
    /* @__PURE__ */ React125.createElement(FlexComponent66, { alignItems: "center", flexDirection: "row", justifyContent: "center", width: "180px" }, /* @__PURE__ */ React125.createElement(
      MultiSelectInputComponent,
      {
        label: "C\xF3digo de Ruta",
        name: "delegation-map-filters-route-code-selector",
        onChange: handleChangeRoutesIdentifiers,
        options: routesIdentifiersOptions,
        searchable: true,
        values: selectedRoutesIdentifiers
      }
    ))
  );
}

// src/modules/network/pages/routes/components/map/map-component.tsx
import React145, { useState as useState39 } from "react";
import styled87 from "styled-components";
import { ComposableMap, Geographies, Geography, ZoomableGroup } from "react-simple-maps";
import { FlexComponent as FlexComponent79, ButtonComponent as ButtonComponent31 } from "@ontruck/fe-ui";
import { IconComponent as IconComponent23 } from "@ontruck/fe-icons";

// src/modules/network/components/map/custom-delegations.ts
var MADRID_DELEGATION_CODE = "280";
var MADRID_GETAFE_DELEGATION_CODE = "283";
var MADRID_CTC_DELEGATION_CODE = "281";
var SEVILLA_DELEGATION_CODE = "410";
var SEVILLA_CTA_DELEGATION_CODE = "411";
var VALENCIA_DELEGATION_CODE = "460";
var VALENCIA_DELEGATION_SUR_CODE = "461";
var ALICANTE_DELEGATION_CODE = "030";
var ALICANTE_CTA_DELEGATION_CODE = "031";
var BARCELONA_DELEGATION_CODE = "080";
var BARCELONA_2_DELEGATION_CODE = "084";
var MONTIJO_DELEGATION_CODE = "979";
var LISBOA_DELEGATION_CODE = "563";
var PORTO_DELEGATION_CODE = '973"';
var SANTIAGO_DE_COMPOSTELA_DELEGATION_CODE = "151";
var TOLEDO_DELEGATION_CODE = "450";
var LUGO_DELEGATION_CODE = "270";
var MURCIA_DELEGATION_CODE = "300";
var BRAGA_DELEGATION_CODE = "978";
var customDelegationsCodes = {
  madrid: MADRID_DELEGATION_CODE,
  madridGetafe: MADRID_GETAFE_DELEGATION_CODE,
  madridCtc: MADRID_CTC_DELEGATION_CODE,
  sevilla: SEVILLA_DELEGATION_CODE,
  sevillaCta: SEVILLA_CTA_DELEGATION_CODE,
  valencia: VALENCIA_DELEGATION_CODE,
  valenciaSur: VALENCIA_DELEGATION_SUR_CODE,
  alicante: ALICANTE_DELEGATION_CODE,
  alicanteCta: ALICANTE_CTA_DELEGATION_CODE,
  barcelona2: BARCELONA_2_DELEGATION_CODE,
  montijo: MONTIJO_DELEGATION_CODE,
  lisboa: LISBOA_DELEGATION_CODE,
  porto: PORTO_DELEGATION_CODE
};
var customAlertsTopLabel = [
  SEVILLA_CTA_DELEGATION_CODE,
  MADRID_CTC_DELEGATION_CODE,
  BARCELONA_2_DELEGATION_CODE,
  VALENCIA_DELEGATION_CODE,
  LUGO_DELEGATION_CODE,
  ALICANTE_DELEGATION_CODE,
  BRAGA_DELEGATION_CODE,
  LISBOA_DELEGATION_CODE
];
var customDelegationsBottomLabel = [
  MONTIJO_DELEGATION_CODE,
  PORTO_DELEGATION_CODE,
  SANTIAGO_DE_COMPOSTELA_DELEGATION_CODE,
  BARCELONA_DELEGATION_CODE,
  MADRID_DELEGATION_CODE,
  MADRID_GETAFE_DELEGATION_CODE,
  TOLEDO_DELEGATION_CODE,
  ALICANTE_CTA_DELEGATION_CODE,
  MURCIA_DELEGATION_CODE,
  VALENCIA_DELEGATION_SUR_CODE,
  SEVILLA_DELEGATION_CODE
];

// src/modules/network/pages/routes/components/map/delegation-component.tsx
import React126 from "react";
import { Marker } from "react-simple-maps";

// src/modules/network/components/map/get-custom-coordinates-hook.ts
import { useMemo as useMemo35, useState as useState38, useEffect as useEffect15 } from "react";

// src/modules/network/components/map/get-is-custom-delegation-service.ts
function getIsCustomDelegationService(delegationCode) {
  const customDelegationsCodesValues = Object.values(customDelegationsCodes);
  return customDelegationsCodesValues.includes(delegationCode);
}

// src/modules/network/components/map/get-custom-coordinates-service.ts
function getCustomCoordinatesService(latitude, longitude, delegationCode) {
  let customLatitude;
  let customLongitude;
  switch (delegationCode) {
    case customDelegationsCodes.madrid:
      customLatitude = latitude + 0.05;
      customLongitude = longitude - 0.1;
      break;
    case customDelegationsCodes.madridGetafe:
      customLatitude = latitude - 0.15;
      customLongitude = longitude + 0.3;
      break;
    case customDelegationsCodes.madridCtc:
      customLatitude = latitude - 0.05;
      customLongitude = longitude + 0.2;
      break;
    case customDelegationsCodes.sevillaCta:
      customLatitude = latitude + 0.1;
      customLongitude = longitude + 0.15;
      break;
    case customDelegationsCodes.valenciaSur:
      customLatitude = latitude;
      customLongitude = longitude;
      break;
    case customDelegationsCodes.alicante:
      customLatitude = latitude;
      customLongitude = longitude;
      break;
    case customDelegationsCodes.alicanteCta:
      customLatitude = latitude - 0.15;
      customLongitude = longitude - 0.05;
      break;
    case customDelegationsCodes.barcelona2:
      customLatitude = latitude - 0.15;
      customLongitude = longitude;
      break;
    case customDelegationsCodes.montijo:
      customLatitude = latitude - 0.1;
      customLongitude = longitude;
      break;
    case customDelegationsCodes.lisboa:
      customLatitude = latitude + 0.1;
      customLongitude = longitude;
      break;
    default:
      customLatitude = latitude;
      customLongitude = longitude;
      break;
  }
  return {
    latitude: customLatitude,
    longitude: customLongitude
  };
}

// src/modules/network/components/map/get-custom-coordinates-hook.ts
function useGetCustomCoordinatesHook({
  latitude,
  longitude,
  delegationCode
}) {
  const [customLatitude, setCustomLatitude] = useState38(latitude);
  const [customLongitude, setCustomLongitude] = useState38(longitude);
  const isCustomCoordinates = useMemo35(
    () => getIsCustomDelegationService(delegationCode),
    [delegationCode]
  );
  useEffect15(() => {
    if (!isCustomCoordinates || !latitude || !longitude) {
      return;
    }
    const { latitude: la, longitude: lo } = getCustomCoordinatesService(
      latitude,
      longitude,
      delegationCode
    );
    setCustomLatitude(la);
    setCustomLongitude(lo);
  }, [latitude, longitude, delegationCode, isCustomCoordinates]);
  return {
    latitude: customLatitude,
    longitude: customLongitude
  };
}

// src/modules/network/pages/routes/components/map/delegation-component.tsx
var positions = {
  top: "top",
  bottom: "bottom"
};
function DelegationComponent({
  delegationId,
  latitude,
  longitude,
  name,
  enableDelegationNavigation = false,
  onClickDelegation,
  position = positions.top,
  delegationCode
}) {
  const innerRadius = 2.5;
  const outerRadius = 6;
  const fontSize = 7;
  const markerStyle = {
    default: { fill: "#6587aa", cursor: "default" },
    hover: { fill: "#6587aa", cursor: "default" },
    pressed: { fill: "#6587aa", cursor: "default" }
  };
  if (enableDelegationNavigation) {
    markerStyle.hover = { fill: "#a4c6e7", cursor: "pointer" };
    markerStyle.pressed = { fill: "#a4c6e7", cursor: "pointer" };
  }
  const { setSelectedDelegationId } = useNetworkState();
  const { latitude: customLatitude, longitude: customLongitude } = useGetCustomCoordinatesHook({
    latitude,
    longitude,
    delegationCode
  });
  const handleMarkerClick = () => {
    if (enableDelegationNavigation) {
      setSelectedDelegationId(delegationId);
      onClickDelegation == null ? void 0 : onClickDelegation();
    }
  };
  if (!customLatitude || !customLongitude) {
    console.error("Custom coordinates not found for delegation code", delegationCode);
    return null;
  }
  return /* @__PURE__ */ React126.createElement(
    Marker,
    {
      coordinates: [customLongitude, customLatitude],
      onClick: handleMarkerClick,
      style: markerStyle
    },
    position === positions.top && name ? /* @__PURE__ */ React126.createElement("text", { fontSize: `${fontSize}px`, textAnchor: "middle", y: "-5" }, name) : null,
    /* @__PURE__ */ React126.createElement("circle", { cx: 0, cy: 0, opacity: 0.1, r: outerRadius, stroke: "#3c4451", strokeWidth: 1 }),
    /* @__PURE__ */ React126.createElement("circle", { cx: 0, cy: 0, opacity: 0.4, r: innerRadius }),
    position === positions.bottom && name ? /* @__PURE__ */ React126.createElement("text", { fontSize: `${fontSize}px`, textAnchor: "middle", y: "9" }, name) : null
  );
}

// src/modules/network/pages/routes/components/map/routes-component.tsx
import React144 from "react";

// src/modules/network/components/routes-panel/panel-component.tsx
import React139 from "react";
import styled86 from "styled-components";
import { FlexComponent as FlexComponent78 } from "@ontruck/fe-ui";

// src/modules/network/components/select-delegation/select-delegation-component.tsx
import React127, { useMemo as useMemo36 } from "react";
import styled77 from "styled-components";
import {
  FlexComponent as FlexComponent67,
  Input as InputComponent6,
  DropdownContainer,
  DropdownItemContainer
} from "@ontruck/fe-ui";
function getSortDelegationOptions(a, b) {
  if (a.label < b.label) {
    return -1;
  }
  if (b.label > a.label) {
    return 1;
  }
  return 0;
}
var SelectDelegationInputComponent = styled77(InputComponent6)`
  background-color: var(--otk-theme-color-primary, #ffcc00);
  border-color: var(--otk-theme-color-primary, #ffcc00);
  padding-left: var(--otk-theme-space-xl, 32px);
  height: 70px;

  ${DropdownContainer} {
    top: 68px;
    left: -1px;
    overflow: hidden;
    border-radius: 0px;
    border: unset;
    border-bottom: 3px solid var(--otk-theme-color-primary-300, #ffdb4d);
    border-left: 3px solid var(--otk-theme-color-primary-300, #ffdb4d);
    border-right: 3px solid var(--otk-theme-color-primary-300, #ffdb4d);
    max-height: 350px;
    width: 370px;

    > div {
      border: unset;

      > div:first-child {
        border: unset;
        background-color: var(--otk-theme-color-primary-300, #ffdb4d);

        > div {
          border: 1px solid var(--otk-theme-color-primary-100, #fff0b3);
          background-color: var(--otk-theme-color-primary-100, #fff0b3);

          svg {
            width: 16px;
            height: 16px;
          }
        }

        > button {
          background-color: var(--otk-theme-color-primary-500, #e6b800);

          svg {
            path {
              fill: var(--otk-theme-color-primary-700, #806600);
            }
          }
        }
      }

      > div:last-child {
        max-height: 370px;
      }
    }

    ${DropdownItemContainer} {
      border: 0;
      border-bottom: 1px solid var(--otk-theme-color-grey-200, #e2e8ee);
      background-color: var(--otk-theme-color-grey-100, #f2f5f8);
      color: var(--otk-theme-color-grey-800, #47596b);
      padding-left: var(--otk-theme-space-xl, 32px);

      &:last-child {
        border-bottom: 0;
      }
    }
  }

  > div {
    gap: var(--otk-theme-space-s, 8px);

    > div:has(> div > input) {
      color: var(--otk-theme-color-secondary, #00204d);
      font-weight: var(--otk-theme-font-weight-bold, 700);
      font-size: var(--otk-theme-font-size-2xl, 20px);
    }
  }

  & label {
    color: var(--otk-theme-color-primary-800, #4d3d00);
  }

  & svg {
    width: 32px;
    height: 32px;

    path {
      fill: var(--otk-theme-color-secondary, #00204d);
    }
  }
`;
function SelectDelegationComponent({
  delegations,
  isRouteCodeDelegationSelected,
  selected,
  onChange
}) {
  const delegationOptions = useMemo36(() => {
    if (!delegations) {
      console.warn("No delegations provided to be selected");
      return [];
    }
    const options = delegations.map((delegation) => ({
      label: delegation.name,
      value: delegation.id,
      searchValue: delegation.name
    })).sort(getSortDelegationOptions);
    if (isRouteCodeDelegationSelected && !selected) {
      options.unshift({
        label: "Todas las delegaciones",
        value: "all from some routes selected by code",
        searchValue: "Todas las delegaciones"
      });
      options.unshift({
        label: "Varias delegaciones",
        value: "Varias delegaciones",
        searchValue: "Varias delegaciones"
      });
    } else {
      options.unshift({
        label: "Todas las delegaciones",
        value: "all",
        searchValue: "Todas las delegaciones"
      });
    }
    return options;
  }, [delegations, isRouteCodeDelegationSelected, selected]);
  const handleChangeDelegation = (name, value2) => {
    if (onChange) {
      onChange(name, value2);
    }
  };
  const value = useMemo36(() => {
    if (isRouteCodeDelegationSelected && !selected) {
      return "Varias delegaciones";
    }
    if (selected) {
      return selected;
    }
    return void 0;
  }, [isRouteCodeDelegationSelected, selected]);
  return /* @__PURE__ */ React127.createElement(FlexComponent67, { alignItems: "center", flexDirection: "column", justifyContent: "center", width: "100%" }, /* @__PURE__ */ React127.createElement(
    SelectDelegationInputComponent,
    {
      handleChangeValue: handleChangeDelegation,
      isClearable: true,
      label: !selected ? "Seleccione la delegaci\xF3n" : void 0,
      name: "evaluator-indicator-selector",
      options: delegationOptions,
      type: "select-with-internal-search",
      value,
      width: "100%"
    }
  ));
}

// src/modules/network/components/routes-panel/panel-table-component.tsx
import React138, { useCallback as useCallback19, useMemo as useMemo37, useEffect as useEffect16, useRef as useRef2 } from "react";
import styled85 from "styled-components";
import {
  FlexComponent as FlexComponent77,
  TableComponent as TableComponent8,
  AccordionComponent as AccordionComponent3,
  AccordionTriggerComponent as AccordionTriggerComponent2,
  AccordionContentComponent as AccordionContentComponent2
} from "@ontruck/fe-ui";

// src/modules/network/components/routes-panel/get-panel-table-rows-mapper-service.ts
function getPanelTableRowsMapperService(routes) {
  return routes.map((route) => ({
    id: route.id,
    parent: {
      id: route.id,
      isDraft: route.isDraft,
      isEditedDraft: route.isEditedDraft,
      originAndDestiny: route.name,
      origin: route.origin.name,
      originTime: route.stops[0].actualDepartureTime || route.stops[0].theoreticalDepartureTime || "",
      destination: route.destination.name,
      destinationTime: route.stops[route.stops.length - 1].actualArrivalTime || route.stops[route.stops.length - 1].theoreticalArrivalTime || "",
      providerName: route.providerName,
      routeIdentifier: route.routeIdentifier,
      vehicleType: route.vehicleType,
      lowVehicleOccupancyAlert: getAlertFilteredByIndicatorService(
        alertsIndicators.lowVehicleOccupancy,
        route.alerts
      ),
      latenessAlert: getAlertFilteredByIndicatorService(alertsIndicators.lateness, route.alerts),
      hightDensityAlert: getAlertFilteredByIndicatorService(
        alertsIndicators.hightDensity,
        route.alerts
      )
    },
    children: [
      ...route.stops.map((stop) => {
        var _a, _b;
        return {
          id: stop.id,
          isEditedDraft: route.isEditedDraft,
          name: stop.name,
          operation: stop.operation,
          theoreticalArrivalTime: stop.theoreticalArrivalTime,
          theoreticalDepartureTime: stop.theoreticalDepartureTime,
          actualArrivalTime: stop.actualArrivalTime,
          actualDepartureTime: stop.actualDepartureTime,
          declaredOccupancyOnDeparture: (_a = stop.declaredOccupancyOnDeparture) == null ? void 0 : _a.toString(),
          declaredOccupancyOnArrival: (_b = stop.declaredOccupancyOnArrival) == null ? void 0 : _b.toString(),
          latenessAlerts: getAlertsFilteredByIndicatorService(alertsIndicators.lateness, stop.alerts),
          hightDensityAlerts: getAlertsFilteredByIndicatorService(
            alertsIndicators.hightDensity,
            stop.alerts
          ),
          lowVehicleOccupancyAlerts: getAlertsFilteredByIndicatorService(
            alertsIndicators.lowVehicleOccupancy,
            stop.alerts
          )
        };
      })
    ]
  }));
}

// src/modules/network/components/routes-panel/panel-table-row-parent-component.tsx
import React130 from "react";
import styled78 from "styled-components";
import {
  AccordionIconComponent as AccordionIconComponent2,
  FlexComponent as FlexComponent69,
  Input as InputComponent7,
  TableCellComponent as TableCellComponent16
} from "@ontruck/fe-ui";

// src/modules/network/components/routes-panel/panel-table.ts
var panelTableWidths = {
  accordionIcon: "16px",
  checkbox: "41px",
  originColumn: "140px",
  destinationColumn: "140px",
  providerNameColumn: "160px",
  vehicleTypeColumn: "90px"
};

// src/modules/network/components/routes-panel/panel-table-row-description-cell-component.tsx
import React129 from "react";
import { BallComponent as BallComponent3, FlexComponent as FlexComponent68, TableCellComponent as TableCellComponent15, TextComponent as TextComponent48 } from "@ontruck/fe-ui";

// src/modules/network/components/route-editor/create-route/create-route-sim-label-component.tsx
import React128 from "react";
import { BadgeComponent as BadgeComponent2 } from "@ontruck/fe-ui";
var CREATE_ROUTE_SIM_LABEL_COMPONENT_LABEL = "SIM";
function CreateRouteSimLabelComponent() {
  return /* @__PURE__ */ React128.createElement(BadgeComponent2, { variant: "primary" }, CREATE_ROUTE_SIM_LABEL_COMPONENT_LABEL);
}

// src/modules/network/components/routes-panel/panel-table-row-description-cell-component.tsx
function PanelTableRowDescriptionCellComponent({
  isExpanded = false,
  isDraft = false,
  isEditedDraft = false,
  onExpand,
  panelTableRowParent,
  indicator = selectIndicatorOptionsValues.none
}) {
  const {
    originAndDestiny,
    routeIdentifier,
    lowVehicleOccupancyAlert,
    latenessAlert,
    hightDensityAlert
  } = panelTableRowParent;
  const handleToggleExpanded = () => {
    if (!onExpand) {
      return;
    }
    onExpand(panelTableRowParent.id);
  };
  return /* @__PURE__ */ React129.createElement(
    TableCellComponent15,
    {
      background: (() => {
        if (isEditedDraft) {
          return `repeating-conic-gradient(
              var(--otk-theme-color-grey-100, #e2e8ee) 0% 25%,
              var(--otk-theme-color-grey-200, #f2f5f8) 0% 50%
            ) 0 0 / 20px 20px;`;
        }
        if (isExpanded) {
          return "var(--otk-theme-color-grey-100, #f2f5f8);";
        }
        return "var(--otk-theme-color-white, #E2E8EE);";
      })(),
      borderRight: "var(--otk-theme-color-grey-500, #CCD7E0);",
      flex: "1",
      onClick: handleToggleExpanded,
      width: "295px"
    },
    /* @__PURE__ */ React129.createElement(FlexComponent68, { flex: "1", flexDirection: "column", width: "100%" }, /* @__PURE__ */ React129.createElement(FlexComponent68, { flexDirection: "column", gap: "var(--otk-theme-space-xs)" }, /* @__PURE__ */ React129.createElement(TextComponent48, { fontWeight: "bold", truncate: true, width: "280px" }, originAndDestiny), /* @__PURE__ */ React129.createElement(
      TextComponent48,
      {
        color: "var( --otk-theme-color-grey-900, #263340)",
        fontWeight: "bold",
        size: "s",
        truncate: true,
        uppercase: true,
        width: "280px"
      },
      /* @__PURE__ */ React129.createElement(FlexComponent68, { alignItems: "center", gap: "var(--otk-theme-space-s)" }, isDraft ? /* @__PURE__ */ React129.createElement(CreateRouteSimLabelComponent, null) : null, routeIdentifier)
    )), indicator === selectIndicatorOptionsValues.lowVehicleOccupancy && ((lowVehicleOccupancyAlert == null ? void 0 : lowVehicleOccupancyAlert.value) || (lowVehicleOccupancyAlert == null ? void 0 : lowVehicleOccupancyAlert.level)) ? /* @__PURE__ */ React129.createElement(
      FlexComponent68,
      {
        alignItems: "center",
        bottom: "-10px",
        gap: "5px",
        justifyContent: "flex-end",
        position: "absolute",
        width: "100%"
      },
      lowVehicleOccupancyAlert.value ? /* @__PURE__ */ React129.createElement(TextComponent48, { fontWeight: "bold", size: "s" }, lowVehicleOccupancyAlert.value) : null,
      lowVehicleOccupancyAlert.level ? /* @__PURE__ */ React129.createElement(
        BallComponent3,
        {
          backgroundColor: alertLevelColors[lowVehicleOccupancyAlert.level],
          size: "15px"
        }
      ) : null
    ) : null, indicator === selectIndicatorOptionsValues.lateness && ((latenessAlert == null ? void 0 : latenessAlert.value) || (latenessAlert == null ? void 0 : latenessAlert.level)) ? /* @__PURE__ */ React129.createElement(
      FlexComponent68,
      {
        alignItems: "center",
        bottom: "-10px",
        gap: "5px",
        justifyContent: "flex-end",
        position: "absolute",
        width: "100%"
      },
      latenessAlert.value ? /* @__PURE__ */ React129.createElement(TextComponent48, { fontWeight: "bold", size: "s" }, latenessAlert.value) : null,
      latenessAlert.level ? /* @__PURE__ */ React129.createElement(BallComponent3, { backgroundColor: alertLevelColors[latenessAlert.level], size: "15px" }) : null
    ) : null, indicator === selectIndicatorOptionsValues.hightDensity && ((hightDensityAlert == null ? void 0 : hightDensityAlert.value) || (hightDensityAlert == null ? void 0 : hightDensityAlert.level)) ? /* @__PURE__ */ React129.createElement(
      FlexComponent68,
      {
        alignItems: "center",
        bottom: "-10px",
        gap: "5px",
        justifyContent: "flex-end",
        position: "absolute",
        width: "100%"
      },
      hightDensityAlert.value ? /* @__PURE__ */ React129.createElement(TextComponent48, { fontWeight: "bold", size: "s" }, hightDensityAlert.value) : null,
      hightDensityAlert.level ? /* @__PURE__ */ React129.createElement(
        BallComponent3,
        {
          backgroundColor: alertLevelColors[hightDensityAlert.level],
          size: "15px"
        }
      ) : null
    ) : null)
  );
}

// src/modules/network/components/routes-panel/panel-table-row-parent-component.tsx
var ROUTE_ROW_PARENT_MIN_HEIGHT_IN_PIXELS = 70;
var PanelTableRowParentWrapperComponent = styled78(FlexComponent69)`
  background: var(--otk-theme-color-grey-100, #e2e8ee);
  height: ${`${ROUTE_ROW_PARENT_MIN_HEIGHT_IN_PIXELS}px`};

  :first-child {
    border-top: none;
  }
`;
function PanelTableRowParentComponent({
  isExpanded = false,
  isSelected = false,
  onSelect,
  onExpand,
  panelTableRowParent,
  indicator = selectIndicatorOptionsValues.none
}) {
  const handleToggleSelection = () => {
    if (!onSelect) {
      return;
    }
    onSelect(panelTableRowParent.id);
  };
  const handleToggleExpanded = () => {
    if (!onExpand) {
      return;
    }
    onExpand(panelTableRowParent.id);
  };
  return /* @__PURE__ */ React130.createElement(PanelTableRowParentWrapperComponent, { alignItems: "center", justifyContent: "stretch" }, /* @__PURE__ */ React130.createElement(
    TableCellComponent16,
    {
      alignItems: "center",
      background: "var(--otk-theme-color-grey-300, #E2E8EE);",
      borderRight: "var(--otk-theme-color-grey-300, #CCD7E0);",
      justifyContent: "center",
      onClick: handleToggleExpanded,
      padding: "unset",
      width: panelTableWidths.accordionIcon
    },
    /* @__PURE__ */ React130.createElement(AccordionIconComponent2, { open: isExpanded })
  ), /* @__PURE__ */ React130.createElement(
    TableCellComponent16,
    {
      background: (() => {
        if (panelTableRowParent.isEditedDraft) {
          return `repeating-conic-gradient(
              var(--otk-theme-color-grey-100, #e2e8ee) 0% 25%,
              var(--otk-theme-color-grey-200, #f2f5f8) 0% 50%
            ) 0 0 / 20px 20px;`;
        }
        if (isExpanded) {
          return "var(--otk-theme-color-grey-200, #e2e8ee);";
        }
        return "var(--otk-theme-color-grey-100, #e2e8ee);";
      })(),
      borderRight: "var(--otk-theme-color-grey-500, #CCD7E0);",
      padding: "5px 10px",
      width: panelTableWidths.checkbox
    },
    /* @__PURE__ */ React130.createElement(
      InputComponent7,
      {
        handleChangeValue: handleToggleSelection,
        name: `${panelTableRowParent.id}-is-selected`,
        type: "checkbox",
        value: isSelected ? "true" : "false"
      }
    )
  ), /* @__PURE__ */ React130.createElement(
    PanelTableRowDescriptionCellComponent,
    {
      indicator,
      isDraft: panelTableRowParent.isDraft,
      isEditedDraft: panelTableRowParent.isEditedDraft,
      isExpanded,
      onExpand,
      panelTableRowParent
    }
  ));
}

// src/modules/network/components/routes-panel/panel-table-header-component.tsx
import React131 from "react";
import styled79 from "styled-components";
import {
  FlexComponent as FlexComponent70,
  Input as InputComponent8,
  TableCellComponent as TableCellComponent17
} from "@ontruck/fe-ui";
var TABLE_HEADER_MIN_HEIGHT_IN_PIXELS = 70;
var TableHeaderCellComponent = styled79(TableCellComponent17)`
  height: unset;
  align-items: stretch;
  min-height: ${`${TABLE_HEADER_MIN_HEIGHT_IN_PIXELS}px`};
`;
function PanelTableHeaderComponent({
  indicator,
  onChangeEvaluatorIndicator,
  onToggleSelectAllRoutes,
  areAllRoutesSelected = false
}) {
  const handleToggleSelectAll = (name, value) => {
    if (onToggleSelectAllRoutes) {
      if (value === "true") {
        onToggleSelectAllRoutes(true);
        return;
      }
      onToggleSelectAllRoutes(false);
    }
  };
  return /* @__PURE__ */ React131.createElement(
    FlexComponent70,
    {
      alignItems: "stretch",
      borderBottom: "2px solid var(--otk-theme-color-grey-300, #E2E8EE)",
      borderTop: "1px solid var(--otk-theme-color-grey-200, #E2E8EE)",
      width: "100%"
    },
    /* @__PURE__ */ React131.createElement(
      TableHeaderCellComponent,
      {
        background: "var(--otk-theme-color-grey-300, #CCD7E0);",
        borderRight: "1px solid var(--otk-theme-color-grey-300, #CCD7E0)",
        justifyContent: "center",
        padding: "unset",
        width: panelTableWidths.accordionIcon
      }
    ),
    /* @__PURE__ */ React131.createElement(
      TableHeaderCellComponent,
      {
        background: "rgba(204, 214, 224, 0.3)",
        borderRight: "1px solid var(--otk-theme-color-grey-200, #E2E8EE)",
        padding: "5px 10px",
        width: panelTableWidths.checkbox
      },
      /* @__PURE__ */ React131.createElement(
        InputComponent8,
        {
          handleChangeValue: handleToggleSelectAll,
          name: "routes-table-header-select-all",
          type: "checkbox",
          value: areAllRoutesSelected ? "true" : "false"
        }
      )
    ),
    /* @__PURE__ */ React131.createElement(
      TableHeaderCellComponent,
      {
        background: "var(--otk-theme-color-grey-100, #F2F5F8)",
        borderLeft: "unset",
        borderRight: "1px solid var(--otk-theme-color-grey-200, #E2E8EE)",
        flex: "1"
      },
      /* @__PURE__ */ React131.createElement(
        SelectIndicatorComponent,
        {
          indicator,
          onChangeIndicator: onChangeEvaluatorIndicator
        }
      )
    )
  );
}

// src/modules/network/components/routes-panel/panel-table-row-child-header-component.tsx
import React132 from "react";
import styled80 from "styled-components";
import {
  FlexComponent as FlexComponent71,
  TableCellComponent as TableCellComponent18,
  TextComponent as TextComponent49
} from "@ontruck/fe-ui";
import { CircleArrowRightIcon, CircleLineArrowRightIcon } from "@ontruck/fe-icons";
var ROW_CONSOLIDATION_CHILD_MIN_HEIGHT_IN_PIXELS2 = 45;
var PanelTableRowChildHeaderCellComponent = styled80(
  TableCellComponent18
)`
  height: unset;
  align-items: stretch;
  min-height: ${`${ROW_CONSOLIDATION_CHILD_MIN_HEIGHT_IN_PIXELS2}px`};
`;
function PanelTableRowChildHeaderComponent({
  indicator,
  isEditedDraft = false
}) {
  return /* @__PURE__ */ React132.createElement(
    FlexComponent71,
    {
      alignItems: "stretch",
      borderTop: "1px solid var(--otk-theme-color-grey-200, #E2E8EE)",
      width: "100%"
    },
    /* @__PURE__ */ React132.createElement(
      PanelTableRowChildHeaderCellComponent,
      {
        background: "var(--otk-theme-color-grey-300, #CCD7E0)",
        borderRight: "1px solid var(--otk-theme-color-grey-300, #CCD7E0)",
        justifyContent: "center",
        padding: "unset",
        width: panelTableWidths.accordionIcon
      }
    ),
    /* @__PURE__ */ React132.createElement(
      PanelTableRowChildHeaderCellComponent,
      {
        background: (() => {
          if (isEditedDraft) {
            return `repeating-conic-gradient(
              var(--otk-theme-color-grey-100, #e2e8ee) 0% 25%,
              var(--otk-theme-color-grey-200, #f2f5f8) 0% 50%
            ) 0 0 / 20px 20px;`;
          }
          return "var(--otk-theme-color-grey-200, #F2F5F8);";
        })(),
        borderRight: "1px solid var(--otk-theme-color-grey-200, #E2E8EE)",
        padding: "5px 20px",
        width: panelTableWidths.checkbox
      }
    ),
    /* @__PURE__ */ React132.createElement(
      PanelTableRowChildHeaderCellComponent,
      {
        background: (() => {
          if (isEditedDraft) {
            return `repeating-conic-gradient(
              var(--otk-theme-color-grey-100, #e2e8ee) 0% 25%,
              var(--otk-theme-color-grey-200, #f2f5f8) 0% 50%
            ) 0 0 / 20px 20px;`;
          }
          return "var(--otk-theme-color-grey-100, #F2F5F8);";
        })(),
        borderLeft: "unset",
        borderRight: "1px solid var(--otk-theme-color-grey-200, #E2E8EE)",
        flex: "1"
      },
      /* @__PURE__ */ React132.createElement(
        TextComponent49,
        {
          color: "var( --otk-theme-color-grey-500, #94A6B8)",
          fontWeight: "bold",
          uppercase: true
        },
        "PARADAS"
      )
    ),
    indicator === selectIndicatorOptionsValues.none || indicator === selectIndicatorOptionsValues.lateness || indicator === selectIndicatorOptionsValues.hightDensity ? /* @__PURE__ */ React132.createElement(
      PanelTableRowChildHeaderCellComponent,
      {
        alignItems: "center",
        background: (() => {
          if (isEditedDraft) {
            return `repeating-conic-gradient(
                var(--otk-theme-color-grey-100, #e2e8ee) 0% 25%,
                var(--otk-theme-color-grey-200, #f2f5f8) 0% 50%
              ) 0 0 / 20px 20px;`;
          }
          return "rgba(204, 214, 224, 0.3)";
        })(),
        borderLeft: "unset",
        borderRight: "1px solid var(--otk-theme-color-white, #FFF)",
        justifyContent: "center",
        padding: "0",
        width: "55px"
      },
      /* @__PURE__ */ React132.createElement(TextComponent49, { color: "var( --otk-theme-color-grey-700, #54708C)", fontWeight: "medium" }, /* @__PURE__ */ React132.createElement(
        CircleArrowRightIcon,
        {
          color: "var(--otk-theme-color-grey-500, #94A6B8)",
          sizeInPixels: 20
        }
      ))
    ) : null,
    indicator === selectIndicatorOptionsValues.none || indicator === selectIndicatorOptionsValues.lateness || indicator === selectIndicatorOptionsValues.lowVehicleOccupancy ? /* @__PURE__ */ React132.createElement(
      PanelTableRowChildHeaderCellComponent,
      {
        alignItems: "center",
        background: (() => {
          if (isEditedDraft) {
            return `repeating-conic-gradient(
                var(--otk-theme-color-grey-100, #e2e8ee) 0% 25%,
                var(--otk-theme-color-grey-200, #f2f5f8) 0% 50%
              ) 0 0 / 20px 20px;`;
          }
          return "rgba(204, 214, 224, 0.3)";
        })(),
        borderLeft: "unset",
        borderRight: "unset",
        justifyContent: "center",
        padding: "0",
        width: "55px"
      },
      /* @__PURE__ */ React132.createElement(TextComponent49, { color: "var( --otk-theme-color-grey-700, #54708C)", fontWeight: "medium" }, /* @__PURE__ */ React132.createElement(
        CircleLineArrowRightIcon,
        {
          color: "var(--otk-theme-color-grey-500, #94A6B8)",
          sizeInPixels: 22
        }
      ))
    ) : null
  );
}

// src/modules/network/components/routes-panel/panel-table-row-child-body-component.tsx
import React136 from "react";
import styled84 from "styled-components";
import {
  FlexComponent as FlexComponent75,
  TableCellComponent as TableCellComponent22,
  TextComponent as TextComponent53
} from "@ontruck/fe-ui";

// src/modules/network/components/routes-panel/panel-table-row-child-lateness-component.tsx
import React133 from "react";
import styled81 from "styled-components";
import {
  FlexComponent as FlexComponent72,
  TableCellComponent as TableCellComponent19,
  TextComponent as TextComponent50
} from "@ontruck/fe-ui";
var ROW_CHILD_MIN_HEIGHT_IN_PIXELS = 45;
var PanelTableRowChildCellComponent = styled81(TableCellComponent19)`
  height: unset;
  align-items: stretch;
  margin: 0;
  min-height: ${`${ROW_CHILD_MIN_HEIGHT_IN_PIXELS}px`};
`;
var PanelTableRowChildLatenessAlertMarkerComponent = styled81.div`
  background-color: ${({ backgroundColor }) => backgroundColor};
  width: 100%;
  height: 5px;
`;
function PanelTableRowChildLatenessComponent({
  panelTableRowChild,
  indicator = selectIndicatorOptionsValues.none
}) {
  const {
    name: stopName,
    latenessAlerts,
    lowVehicleOccupancyAlerts,
    hightDensityAlerts,
    theoreticalArrivalTime,
    actualArrivalTime,
    theoreticalDepartureTime,
    actualDepartureTime
  } = panelTableRowChild;
  const latenessArrivalAlert = latenessAlerts == null ? void 0 : latenessAlerts.find(
    (alert) => alert.phase === alertsPhases.arrival
  );
  const latenessDepartureAlert = latenessAlerts == null ? void 0 : latenessAlerts.find(
    (alert) => alert.phase === alertsPhases.departure
  );
  const lowVehicleOccupancyArrivalAlert = lowVehicleOccupancyAlerts == null ? void 0 : lowVehicleOccupancyAlerts.find(
    (alert) => alert.phase === alertsPhases.arrival
  );
  const lowVehicleOccupancyDepartureAlert = lowVehicleOccupancyAlerts == null ? void 0 : lowVehicleOccupancyAlerts.find(
    (alert) => alert.phase === alertsPhases.departure
  );
  const hightDensityArrivalAlert = hightDensityAlerts == null ? void 0 : hightDensityAlerts.find(
    (alert) => alert.phase === alertsPhases.arrival
  );
  const hightDensityDepartureAlert = hightDensityAlerts == null ? void 0 : hightDensityAlerts.find(
    (alert) => alert.phase === alertsPhases.departure
  );
  const getAlertLevelColorByPhase = (phase) => {
    if (indicator === selectIndicatorOptionsValues.lateness) {
      if (phase === alertsPhases.departure && latenessDepartureAlert) {
        return alertLevelColors[latenessDepartureAlert.level];
      }
      if (phase === alertsPhases.arrival && latenessArrivalAlert) {
        return alertLevelColors[latenessArrivalAlert.level];
      }
    }
    if (indicator === selectIndicatorOptionsValues.lowVehicleOccupancy) {
      if (phase === alertsPhases.departure && lowVehicleOccupancyDepartureAlert) {
        return alertLevelColors[lowVehicleOccupancyDepartureAlert.level];
      }
      if (phase === alertsPhases.arrival && lowVehicleOccupancyArrivalAlert) {
        return alertLevelColors[lowVehicleOccupancyArrivalAlert.level];
      }
    }
    if (indicator === selectIndicatorOptionsValues.hightDensity) {
      if (phase === alertsPhases.departure && hightDensityDepartureAlert) {
        return alertLevelColors[hightDensityDepartureAlert.level];
      }
      if (phase === alertsPhases.arrival && hightDensityArrivalAlert) {
        return alertLevelColors[hightDensityArrivalAlert.level];
      }
    }
    return void 0;
  };
  return /* @__PURE__ */ React133.createElement(
    FlexComponent72,
    {
      alignItems: "stretch",
      borderTop: "1px solid var(--otk-theme-color-grey-200, #E2E8EE)",
      width: "100%"
    },
    /* @__PURE__ */ React133.createElement(
      PanelTableRowChildCellComponent,
      {
        background: "var(--otk-theme-color-grey-300, #CCD7E0);",
        borderRight: "1px solid var(--otk-theme-color-grey-300, #CCD7E0)",
        justifyContent: "center",
        padding: "unset",
        width: panelTableWidths.accordionIcon
      }
    ),
    /* @__PURE__ */ React133.createElement(
      PanelTableRowChildCellComponent,
      {
        background: (() => {
          if (panelTableRowChild.isEditedDraft) {
            return `repeating-conic-gradient(
              var(--otk-theme-color-grey-100, #e2e8ee) 0% 25%,
              var(--otk-theme-color-grey-200, #f2f5f8) 0% 50%
            ) 0 0 / 20px 20px;`;
          }
          return "var(--otk-theme-color-grey-100, #F2F5F8);";
        })(),
        borderRight: "1px solid var(--otk-theme-color-grey-200, #E2E8EE)",
        padding: "5px 20px",
        width: panelTableWidths.checkbox
      }
    ),
    /* @__PURE__ */ React133.createElement(
      PanelTableRowChildCellComponent,
      {
        background: (() => {
          if (panelTableRowChild.isEditedDraft) {
            return `repeating-conic-gradient(
              var(--otk-theme-color-grey-100, #e2e8ee) 0% 25%,
              var(--otk-theme-color-grey-200, #f2f5f8) 0% 50%
            ) 0 0 / 20px 20px;`;
          }
          return "var(--otk-theme-color-white, #FFF);";
        })(),
        borderLeft: "unset",
        flex: "1"
      },
      /* @__PURE__ */ React133.createElement(TextComponent50, { color: "var( --otk-theme-color-grey-700, #54708C)", fontWeight: "medium" }, stopName)
    ),
    /* @__PURE__ */ React133.createElement(
      PanelTableRowChildCellComponent,
      {
        alignItems: "center",
        background: (() => {
          if (panelTableRowChild.isEditedDraft) {
            return `repeating-conic-gradient(
              var(--otk-theme-color-grey-100, #e2e8ee) 0% 25%,
              var(--otk-theme-color-grey-200, #f2f5f8) 0% 50%
            ) 0 0 / 20px 20px;`;
          }
          if (latenessArrivalAlert) {
            return "var(--otk-theme-color-grey-200, #E2E8EE);";
          }
          return "rgba(204, 214, 224, 0.3)";
        })(),
        borderLeft: "unset",
        borderRight: "1px solid var(--otk-theme-color-white, #FFF)",
        justifyContent: "center",
        padding: "0",
        width: "55px"
      },
      /* @__PURE__ */ React133.createElement(
        FlexComponent72,
        {
          alignItems: "center",
          flexDirection: "column",
          justifyContent: "center",
          margin: "0",
          width: "100%"
        },
        /* @__PURE__ */ React133.createElement(
          TextComponent50,
          {
            color: "var( --otk-theme-color-grey-700, #54708C)",
            flexGrow: 1,
            fontSize: "12px"
          },
          (() => {
            if (latenessAlerts && latenessArrivalAlert && theoreticalArrivalTime) {
              return theoreticalArrivalTime;
            }
            return actualArrivalTime || "-";
          })()
        ),
        indicator === selectIndicatorOptionsValues.lateness && latenessAlerts && latenessArrivalAlert ? /* @__PURE__ */ React133.createElement(
          TextComponent50,
          {
            color: "var( --otk-theme-color-grey-700, #54708C)",
            fontSize: "12px",
            fontWeight: "bold"
          },
          actualArrivalTime || "-"
        ) : null,
        latenessAlerts && latenessArrivalAlert && latenessArrivalAlert.level !== alertsLevels.info ? /* @__PURE__ */ React133.createElement(
          PanelTableRowChildLatenessAlertMarkerComponent,
          {
            backgroundColor: getAlertLevelColorByPhase(alertsPhases.arrival)
          }
        ) : null
      )
    ),
    /* @__PURE__ */ React133.createElement(
      PanelTableRowChildCellComponent,
      {
        alignItems: "center",
        background: (() => {
          if (panelTableRowChild.isEditedDraft) {
            return `repeating-conic-gradient(
              var(--otk-theme-color-grey-100, #e2e8ee) 0% 25%,
              var(--otk-theme-color-grey-200, #f2f5f8) 0% 50%
            ) 0 0 / 20px 20px;`;
          }
          if (latenessDepartureAlert) {
            return "var(--otk-theme-color-grey-200, #E2E8EE);";
          }
          return "rgba(204, 214, 224, 0.3)";
        })(),
        borderLeft: "unset",
        borderRight: "unset",
        justifyContent: "center",
        padding: "0",
        width: "55px"
      },
      /* @__PURE__ */ React133.createElement(
        FlexComponent72,
        {
          alignItems: "center",
          flexDirection: "column",
          justifyContent: "center",
          margin: "0",
          width: "100%"
        },
        /* @__PURE__ */ React133.createElement(
          TextComponent50,
          {
            color: "var( --otk-theme-color-grey-700, #54708C)",
            flexGrow: 1,
            fontSize: "12px",
            fontWeight: "medium"
          },
          (() => {
            if (latenessAlerts && latenessDepartureAlert && theoreticalDepartureTime) {
              return theoreticalDepartureTime;
            }
            return actualDepartureTime || "-";
          })()
        ),
        latenessAlerts && latenessDepartureAlert ? /* @__PURE__ */ React133.createElement(
          TextComponent50,
          {
            color: "var( --otk-theme-color-grey-700, #54708C)",
            fontSize: "12px",
            fontWeight: "bold"
          },
          actualDepartureTime || "-"
        ) : null,
        latenessAlerts && latenessDepartureAlert && latenessDepartureAlert.level !== alertsLevels.info ? /* @__PURE__ */ React133.createElement(
          PanelTableRowChildLatenessAlertMarkerComponent,
          {
            backgroundColor: getAlertLevelColorByPhase(alertsPhases.departure)
          }
        ) : null
      )
    )
  );
}

// src/modules/network/components/routes-panel/panel-table-row-child-low-vehicle-occupancy-component.tsx
import React134 from "react";
import styled82 from "styled-components";
import {
  FlexComponent as FlexComponent73,
  TableCellComponent as TableCellComponent20,
  TextComponent as TextComponent51
} from "@ontruck/fe-ui";
var ROW_CHILD_MIN_HEIGHT_IN_PIXELS2 = 45;
var PanelTableRowChildCellComponent2 = styled82(TableCellComponent20)`
  height: unset;
  align-items: stretch;
  margin: 0;
  min-height: ${`${ROW_CHILD_MIN_HEIGHT_IN_PIXELS2}px`};
`;
var PanelTableRowLowVehicleOccupancyAlertMarkerComponent = styled82.div`
  background-color: ${({ backgroundColor }) => backgroundColor};
  width: 100%;
  height: 5px;
`;
function PanelTableRowLowVehicleOccupancyComponent({
  panelTableRowChild
}) {
  const {
    name: stopName,
    lowVehicleOccupancyAlerts,
    declaredOccupancyOnDeparture
  } = panelTableRowChild;
  const lowVehicleOccupancyDepartureAlert = lowVehicleOccupancyAlerts == null ? void 0 : lowVehicleOccupancyAlerts.find(
    (alert) => alert.phase === alertsPhases.departure
  );
  const getAlertLevelColorByPhase = (phase) => {
    if (phase === alertsPhases.departure && lowVehicleOccupancyDepartureAlert) {
      return alertLevelColors[lowVehicleOccupancyDepartureAlert.level];
    }
    return void 0;
  };
  return /* @__PURE__ */ React134.createElement(
    FlexComponent73,
    {
      alignItems: "stretch",
      borderTop: "1px solid var(--otk-theme-color-grey-200, #E2E8EE)",
      width: "100%"
    },
    /* @__PURE__ */ React134.createElement(
      PanelTableRowChildCellComponent2,
      {
        background: "var(--otk-theme-color-grey-300, #CCD7E0);",
        borderRight: "1px solid var(--otk-theme-color-grey-300, #CCD7E0)",
        justifyContent: "center",
        padding: "unset",
        width: panelTableWidths.accordionIcon
      }
    ),
    /* @__PURE__ */ React134.createElement(
      PanelTableRowChildCellComponent2,
      {
        background: (() => {
          if (panelTableRowChild.isEditedDraft) {
            return `repeating-conic-gradient(
              var(--otk-theme-color-grey-100, #e2e8ee) 0% 25%,
              var(--otk-theme-color-grey-200, #f2f5f8) 0% 50%
            ) 0 0 / 20px 20px;`;
          }
          return "var(--otk-theme-color-grey-100, #F2F5F8);";
        })(),
        borderRight: "1px solid var(--otk-theme-color-grey-200, #E2E8EE)",
        padding: "5px 20px",
        width: panelTableWidths.checkbox
      }
    ),
    /* @__PURE__ */ React134.createElement(
      PanelTableRowChildCellComponent2,
      {
        background: (() => {
          if (panelTableRowChild.isEditedDraft) {
            return `repeating-conic-gradient(
              var(--otk-theme-color-grey-100, #e2e8ee) 0% 25%,
              var(--otk-theme-color-grey-200, #f2f5f8) 0% 50%
            ) 0 0 / 20px 20px;`;
          }
          return "var(--otk-theme-color-white, #FFF);";
        })(),
        borderLeft: "unset",
        flex: "1"
      },
      /* @__PURE__ */ React134.createElement(TextComponent51, { color: "var( --otk-theme-color-grey-700, #54708C)", fontWeight: "medium" }, stopName)
    ),
    /* @__PURE__ */ React134.createElement(
      PanelTableRowChildCellComponent2,
      {
        alignItems: "center",
        background: (() => {
          if (panelTableRowChild.isEditedDraft) {
            return `repeating-conic-gradient(
              var(--otk-theme-color-grey-100, #e2e8ee) 0% 25%,
              var(--otk-theme-color-grey-200, #f2f5f8) 0% 50%
            ) 0 0 / 20px 20px;`;
          }
          return "rgba(204, 214, 224, 0.3)";
        })(),
        borderLeft: "unset",
        borderRight: "unset",
        justifyContent: "center",
        padding: "0",
        width: "55px"
      },
      /* @__PURE__ */ React134.createElement(
        FlexComponent73,
        {
          alignItems: "center",
          flexDirection: "column",
          justifyContent: "center",
          margin: "0",
          width: "100%"
        },
        /* @__PURE__ */ React134.createElement(
          TextComponent51,
          {
            color: "var( --otk-theme-color-grey-700, #54708C)",
            flexGrow: 1,
            fontSize: "12px"
          },
          (() => {
            if (declaredOccupancyOnDeparture) {
              return `${declaredOccupancyOnDeparture}%`;
            }
            return "-";
          })()
        ),
        lowVehicleOccupancyAlerts && lowVehicleOccupancyDepartureAlert ? /* @__PURE__ */ React134.createElement(
          TextComponent51,
          {
            color: "var( --otk-theme-color-grey-700, #54708C)",
            flexGrow: 1,
            fontSize: "12px",
            fontWeight: "bold"
          },
          lowVehicleOccupancyDepartureAlert.value
        ) : null,
        lowVehicleOccupancyAlerts && lowVehicleOccupancyDepartureAlert && lowVehicleOccupancyDepartureAlert.level !== alertsLevels.info ? /* @__PURE__ */ React134.createElement(
          PanelTableRowLowVehicleOccupancyAlertMarkerComponent,
          {
            backgroundColor: getAlertLevelColorByPhase(alertsPhases.departure)
          }
        ) : null
      )
    )
  );
}

// src/modules/network/components/routes-panel/panel-table-row-child-hight-density-component.tsx
import React135 from "react";
import styled83 from "styled-components";
import {
  FlexComponent as FlexComponent74,
  TableCellComponent as TableCellComponent21,
  TextComponent as TextComponent52
} from "@ontruck/fe-ui";
var ROW_CHILD_MIN_HEIGHT_IN_PIXELS3 = 45;
var PanelTableRowChildCellComponent3 = styled83(TableCellComponent21)`
  height: unset;
  align-items: stretch;
  margin: 0;
  min-height: ${`${ROW_CHILD_MIN_HEIGHT_IN_PIXELS3}px`};
`;
var PanelTableRowChildHightDensityAlertMarkerComponent = styled83.div`
  background-color: ${({ backgroundColor }) => backgroundColor};
  width: 100%;
  height: 5px;
`;
function PanelTableRowChildHightDensityComponent({
  panelTableRowChild
}) {
  const { name: stopName, hightDensityAlerts, actualArrivalTime } = panelTableRowChild;
  const hightDensityArrivalAlert = hightDensityAlerts == null ? void 0 : hightDensityAlerts.find(
    (alert) => alert.phase === alertsPhases.arrival
  );
  const getAlertLevelColorByPhase = (phase) => {
    if (phase === alertsPhases.arrival && hightDensityArrivalAlert) {
      return alertLevelColors[hightDensityArrivalAlert.level];
    }
    return void 0;
  };
  return /* @__PURE__ */ React135.createElement(
    FlexComponent74,
    {
      alignItems: "stretch",
      borderTop: "1px solid var(--otk-theme-color-grey-200, #E2E8EE)",
      width: "100%"
    },
    /* @__PURE__ */ React135.createElement(
      PanelTableRowChildCellComponent3,
      {
        background: "var(--otk-theme-color-grey-300, #CCD7E0);",
        borderRight: "1px solid var(--otk-theme-color-grey-300, #CCD7E0)",
        justifyContent: "center",
        padding: "unset",
        width: panelTableWidths.accordionIcon
      }
    ),
    /* @__PURE__ */ React135.createElement(
      PanelTableRowChildCellComponent3,
      {
        background: (() => {
          if (panelTableRowChild.isEditedDraft) {
            return `repeating-conic-gradient(
              var(--otk-theme-color-grey-100, #e2e8ee) 0% 25%,
              var(--otk-theme-color-grey-200, #f2f5f8) 0% 50%
            ) 0 0 / 20px 20px;`;
          }
          return "var(--otk-theme-color-grey-100, #F2F5F8);";
        })(),
        borderRight: "1px solid var(--otk-theme-color-grey-200, #E2E8EE)",
        padding: "5px 20px",
        width: panelTableWidths.checkbox
      }
    ),
    /* @__PURE__ */ React135.createElement(
      PanelTableRowChildCellComponent3,
      {
        background: (() => {
          if (panelTableRowChild.isEditedDraft) {
            return `repeating-conic-gradient(
              var(--otk-theme-color-grey-100, #e2e8ee) 0% 25%,
              var(--otk-theme-color-grey-200, #f2f5f8) 0% 50%
            ) 0 0 / 20px 20px;`;
          }
          return "var(--otk-theme-color-grey-white, #FFF);";
        })(),
        borderLeft: "unset",
        flex: "1"
      },
      /* @__PURE__ */ React135.createElement(TextComponent52, { color: "var( --otk-theme-color-grey-700, #54708C)", fontWeight: "medium" }, stopName)
    ),
    /* @__PURE__ */ React135.createElement(
      PanelTableRowChildCellComponent3,
      {
        alignItems: "center",
        background: (() => {
          if (panelTableRowChild.isEditedDraft) {
            return `repeating-conic-gradient(
              var(--otk-theme-color-grey-100, #e2e8ee) 0% 25%,
              var(--otk-theme-color-grey-200, #f2f5f8) 0% 50%
            ) 0 0 / 20px 20px;`;
          }
          return "rgba(204, 214, 224, 0.3)";
        })(),
        borderLeft: "unset",
        borderRight: "1px solid var(--otk-theme-color-white, #FFF)",
        justifyContent: "center",
        padding: "0",
        width: "55px"
      },
      /* @__PURE__ */ React135.createElement(
        FlexComponent74,
        {
          alignItems: "center",
          flexDirection: "column",
          justifyContent: "center",
          margin: "0",
          width: "100%"
        },
        /* @__PURE__ */ React135.createElement(
          TextComponent52,
          {
            color: "var( --otk-theme-color-grey-700, #54708C)",
            flexGrow: 1,
            fontSize: "12px",
            fontWeight: "medium"
          },
          actualArrivalTime || "-"
        ),
        hightDensityAlerts && hightDensityArrivalAlert && hightDensityArrivalAlert.level !== alertsLevels.info ? /* @__PURE__ */ React135.createElement(
          PanelTableRowChildHightDensityAlertMarkerComponent,
          {
            backgroundColor: getAlertLevelColorByPhase(alertsPhases.arrival)
          }
        ) : null
      )
    )
  );
}

// src/modules/network/components/routes-panel/panel-table-row-child-body-component.tsx
var ROW_CHILD_MIN_HEIGHT_IN_PIXELS4 = 45;
var PanelTableRowChildCellComponent4 = styled84(TableCellComponent22)`
  height: unset;
  align-items: stretch;
  margin: 0;
  min-height: ${`${ROW_CHILD_MIN_HEIGHT_IN_PIXELS4}px`};
`;
var PanelTableRowChildAlertMarkerComponent = styled84.div`
  background-color: ${({ backgroundColor }) => backgroundColor};
  width: 100%;
  height: 5px;
`;
function PanelTableRowChildBodyComponent({
  panelTableRowChild,
  indicator = selectIndicatorOptionsValues.none
}) {
  const { name: stopName, actualArrivalTime, actualDepartureTime } = panelTableRowChild;
  if (indicator === selectIndicatorOptionsValues.lateness) {
    return /* @__PURE__ */ React136.createElement(
      PanelTableRowChildLatenessComponent,
      {
        indicator,
        panelTableRowChild
      }
    );
  }
  if (indicator === selectIndicatorOptionsValues.lowVehicleOccupancy) {
    return /* @__PURE__ */ React136.createElement(
      PanelTableRowLowVehicleOccupancyComponent,
      {
        indicator,
        panelTableRowChild
      }
    );
  }
  if (indicator === selectIndicatorOptionsValues.hightDensity) {
    return /* @__PURE__ */ React136.createElement(PanelTableRowChildHightDensityComponent, { panelTableRowChild });
  }
  return /* @__PURE__ */ React136.createElement(
    FlexComponent75,
    {
      alignItems: "stretch",
      borderTop: "1px solid var(--otk-theme-color-grey-200, #E2E8EE)",
      width: "100%"
    },
    /* @__PURE__ */ React136.createElement(
      PanelTableRowChildCellComponent4,
      {
        background: "var(--otk-theme-color-grey-300, #CCD7E0);",
        borderRight: "1px solid var(--otk-theme-color-grey-300, #CCD7E0)",
        justifyContent: "center",
        padding: "unset",
        width: panelTableWidths.accordionIcon
      }
    ),
    /* @__PURE__ */ React136.createElement(
      PanelTableRowChildCellComponent4,
      {
        background: (() => {
          if (panelTableRowChild.isEditedDraft) {
            return `repeating-conic-gradient(
              var(--otk-theme-color-grey-100, #e2e8ee) 0% 25%,
              var(--otk-theme-color-grey-200, #f2f5f8) 0% 50%
            ) 0 0 / 20px 20px;`;
          }
          return "var(--otk-theme-color-grey-100, #F2F5F8);";
        })(),
        borderRight: "1px solid var(--otk-theme-color-grey-200, #E2E8EE)",
        padding: "5px 20px",
        width: panelTableWidths.checkbox
      }
    ),
    /* @__PURE__ */ React136.createElement(
      PanelTableRowChildCellComponent4,
      {
        background: (() => {
          if (panelTableRowChild.isEditedDraft) {
            return `repeating-conic-gradient(
              var(--otk-theme-color-grey-100, #e2e8ee) 0% 25%,
              var(--otk-theme-color-grey-200, #f2f5f8) 0% 50%
            ) 0 0 / 20px 20px;`;
          }
          return "var(--otk-theme-color-white, #FFF);";
        })(),
        borderLeft: "unset",
        flex: "1"
      },
      /* @__PURE__ */ React136.createElement(TextComponent53, { color: "var( --otk-theme-color-grey-700, #54708C)", fontWeight: "medium" }, stopName)
    ),
    /* @__PURE__ */ React136.createElement(
      PanelTableRowChildCellComponent4,
      {
        alignItems: "center",
        background: (() => {
          if (panelTableRowChild.isEditedDraft) {
            return `repeating-conic-gradient(
              var(--otk-theme-color-grey-100, #e2e8ee) 0% 25%,
              var(--otk-theme-color-grey-200, #f2f5f8) 0% 50%
            ) 0 0 / 20px 20px;`;
          }
          return "rgba(204, 214, 224, 0.3)";
        })(),
        borderLeft: "unset",
        borderRight: "1px solid var(--otk-theme-color-white, #FFF)",
        justifyContent: "center",
        padding: "0",
        width: "55px"
      },
      /* @__PURE__ */ React136.createElement(
        FlexComponent75,
        {
          alignItems: "center",
          flexDirection: "column",
          justifyContent: "center",
          margin: "0",
          width: "100%"
        },
        /* @__PURE__ */ React136.createElement(
          TextComponent53,
          {
            color: "var( --otk-theme-color-grey-700, #54708C)",
            flexGrow: 1,
            fontSize: "12px",
            fontWeight: "medium"
          },
          actualDepartureTime || "-"
        )
      )
    ),
    /* @__PURE__ */ React136.createElement(
      PanelTableRowChildCellComponent4,
      {
        alignItems: "center",
        background: (() => {
          if (panelTableRowChild.isEditedDraft) {
            return `repeating-conic-gradient(
              var(--otk-theme-color-grey-100, #e2e8ee) 0% 25%,
              var(--otk-theme-color-grey-200, #f2f5f8) 0% 50%
            ) 0 0 / 20px 20px;`;
          }
          return "rgba(204, 214, 224, 0.3)";
        })(),
        borderLeft: "unset",
        borderRight: "1px solid var(--otk-theme-color-white, #FFF)",
        justifyContent: "center",
        padding: "0",
        width: "55px"
      },
      /* @__PURE__ */ React136.createElement(
        FlexComponent75,
        {
          alignItems: "center",
          flexDirection: "column",
          justifyContent: "center",
          margin: "0",
          width: "100%"
        },
        /* @__PURE__ */ React136.createElement(
          TextComponent53,
          {
            color: "var( --otk-theme-color-grey-700, #54708C)",
            flexGrow: 1,
            fontSize: "12px",
            fontWeight: "medium"
          },
          actualArrivalTime || "-"
        )
      )
    )
  );
}

// src/modules/network/components/routes-panel/panel-table-row-child-footer-component.tsx
import React137 from "react";
import { FlexComponent as FlexComponent76, ButtonComponent as ButtonComponent30 } from "@ontruck/fe-ui";
function PanelTableRowChildFooterComponent({
  onClick
}) {
  return /* @__PURE__ */ React137.createElement(
    FlexComponent76,
    {
      alignItems: "stretch",
      borderTop: "1px solid var(--otk-theme-color-grey-200, #E2E8EE)",
      padding: "var(--otk-theme-space-s)",
      width: "100%"
    },
    /* @__PURE__ */ React137.createElement(ButtonComponent30, { color: "primary", onClick, size: "s" }, "Editar ruta")
  );
}

// src/modules/network/components/routes-panel/panel-table-component.tsx
var PanelTableRowWrapperComponent = styled85.div`
  header {
    display: flex;
    padding: unset;
    border-top: none;
    border-bottom: none;

    > div {
      flex: 1;
    }

    :hover {
      cursor: default;
    }
  }
`;
var PanelTableRowContentWrapperComponent = styled85.div`
  border-top: ${({ isExpanded }) => isExpanded ? "2px solid var(--otk-theme-color-grey-400, #ccd7e0)" : "none"};
  border-bottom: ${({ isExpanded }) => isExpanded ? "1px solid var(--otk-theme-color-grey-400, #ccd7e0)" : "none"};
  height: ${({ isExpanded }) => isExpanded ? "auto" : "0"};
`;
var PanelTableRowAccordionComponent = styled85(AccordionComponent3)`
  height: auto;
  border-left: none;
  border-right: none;
`;
var PanelTableRowTriggerComponent = styled85(AccordionTriggerComponent2)`
  padding: var(--otk-theme-spacing-xl, 8px);
  border-top: ${({ index }) => index !== 0 ? "3px solid var(--otk-theme-color-grey-200, #ccd7e0)" : "none"};
  border-bottom: none;
`;
var PanelTableRowContentComponent = styled85(AccordionContentComponent2)`
  padding: unset;
  border-top: none;
  border-bottom: none;
`;
function PanelTableComponent({
  routes,
  selectedRoutesIds,
  indicator,
  onChangeRoutesSelection,
  onChangeIndicator,
  expandedRoutesIds,
  handleToggleRouteExpanded,
  onOpenEditRoute
}) {
  const initialSelectionMade = useRef2(false);
  const prevRoutesRef = useRef2();
  const prevRoutesIdsRef = useRef2(/* @__PURE__ */ new Set());
  const routesIds = useMemo37(
    () => routes ? /* @__PURE__ */ new Set([...routes.map((r) => r.id)]) : /* @__PURE__ */ new Set(),
    [routes]
  );
  const numberOfSelectedRoutes = useMemo37(() => selectedRoutesIds.size, [selectedRoutesIds.size]);
  const areAllRoutesSelected = useMemo37(
    () => routes && routes.length > 0 ? numberOfSelectedRoutes === routes.length : false,
    [numberOfSelectedRoutes, routes]
  );
  const routesRows = useMemo37(
    () => routes && routes.length > 0 ? getPanelTableRowsMapperService(routes) : [],
    [routes]
  );
  const handleToggleSelectAllRoutes = useCallback19(
    (toggleSelectAll) => {
      if (toggleSelectAll) {
        if (onChangeRoutesSelection) {
          onChangeRoutesSelection(routesIds);
        }
      } else if (onChangeRoutesSelection) {
        onChangeRoutesSelection(/* @__PURE__ */ new Set([]));
      }
    },
    [routesIds, onChangeRoutesSelection]
  );
  const handleToggleRouteSelection = useCallback19(
    (routeId) => {
      const routeIsSelected = selectedRoutesIds.has(routeId);
      const updatedSelectedRoutesIds = /* @__PURE__ */ new Set([...selectedRoutesIds]);
      if (!routeIsSelected) {
        updatedSelectedRoutesIds.add(routeId);
      } else {
        updatedSelectedRoutesIds.delete(routeId);
      }
      if (onChangeRoutesSelection) {
        onChangeRoutesSelection(updatedSelectedRoutesIds);
      }
    },
    [selectedRoutesIds, onChangeRoutesSelection]
  );
  const handleOpenEditRoute = useCallback19(
    (routeId) => {
      if (onOpenEditRoute) {
        onOpenEditRoute(routeId);
      }
    },
    [onOpenEditRoute]
  );
  const delegationRoutes = useMemo37(() => {
    return routesRows.map((r, i) => {
      const rowId = `table-routes-row-${r.id}-${i}`;
      return /* @__PURE__ */ React138.createElement(PanelTableRowWrapperComponent, { key: rowId }, /* @__PURE__ */ React138.createElement(PanelTableRowAccordionComponent, null, /* @__PURE__ */ React138.createElement(PanelTableRowTriggerComponent, { index: i, open: expandedRoutesIds == null ? void 0 : expandedRoutesIds.has(r.parent.id) }, /* @__PURE__ */ React138.createElement(
        PanelTableRowParentComponent,
        {
          indicator,
          isExpanded: expandedRoutesIds == null ? void 0 : expandedRoutesIds.has(r.parent.id),
          isSelected: selectedRoutesIds.has(r.parent.id),
          onExpand: handleToggleRouteExpanded,
          onSelect: handleToggleRouteSelection,
          panelTableRowParent: r.parent
        }
      )), (expandedRoutesIds == null ? void 0 : expandedRoutesIds.has(r.parent.id)) ? /* @__PURE__ */ React138.createElement(PanelTableRowContentWrapperComponent, { isExpanded: expandedRoutesIds.has(r.parent.id) }, /* @__PURE__ */ React138.createElement(PanelTableRowContentComponent, { open: expandedRoutesIds.has(r.parent.id) }, /* @__PURE__ */ React138.createElement(
        PanelTableRowChildHeaderComponent,
        {
          indicator,
          isEditedDraft: r.parent.isEditedDraft
        }
      ), r.children.map((c, ri) => {
        const childId = `routes-table-row-child-${r.id}-${c.id}-${ri}`;
        return /* @__PURE__ */ React138.createElement(
          PanelTableRowChildBodyComponent,
          {
            indicator,
            key: childId,
            panelTableRowChild: c
          }
        );
      }), /* @__PURE__ */ React138.createElement(
        PanelTableRowChildFooterComponent,
        {
          onClick: () => {
            handleOpenEditRoute(r.parent.id);
          }
        }
      ))) : null));
    });
  }, [
    selectedRoutesIds,
    expandedRoutesIds,
    handleToggleRouteExpanded,
    handleToggleRouteSelection,
    routesRows,
    indicator,
    handleOpenEditRoute
  ]);
  useEffect16(() => {
    if (!routes || routes.length === 0) {
      prevRoutesRef.current = routes;
      prevRoutesIdsRef.current = /* @__PURE__ */ new Set();
      return;
    }
    const currentRoutesIds = new Set(routes.map((r) => r.id));
    const prevRoutesIds = prevRoutesIdsRef.current;
    const routesWereAddedOrRemoved = currentRoutesIds.size !== prevRoutesIds.size || Array.from(currentRoutesIds).some((id) => !prevRoutesIds.has(id)) || Array.from(prevRoutesIds).some((id) => !currentRoutesIds.has(id));
    if (routesWereAddedOrRemoved) {
      initialSelectionMade.current = false;
      handleToggleSelectAllRoutes(true);
    } else if (onChangeRoutesSelection && selectedRoutesIds.size > 0) {
      const preservedSelection = new Set(
        Array.from(selectedRoutesIds).filter((id) => currentRoutesIds.has(id))
      );
      if (preservedSelection.size !== selectedRoutesIds.size) {
        onChangeRoutesSelection(preservedSelection);
      }
    }
    prevRoutesRef.current = routes;
    prevRoutesIdsRef.current = currentRoutesIds;
  }, [routes, handleToggleSelectAllRoutes, onChangeRoutesSelection, selectedRoutesIds]);
  return /* @__PURE__ */ React138.createElement(FlexComponent77, { flex: "1", flexDirection: "column", overflowX: "hidden", overflowY: "auto", width: "100%" }, routesRows.length > 0 && /* @__PURE__ */ React138.createElement(
    PanelTableHeaderComponent,
    {
      areAllRoutesSelected,
      indicator,
      onChangeEvaluatorIndicator: onChangeIndicator,
      onToggleSelectAllRoutes: handleToggleSelectAllRoutes
    }
  ), /* @__PURE__ */ React138.createElement(
    TableComponent8,
    {
      emptyStateMessage: "No se han encontrado rutas",
      numberOfItems: delegationRoutes.length,
      rowsComponents: delegationRoutes
    }
  ));
}

// src/modules/network/components/routes-panel/panel-component.tsx
var RoutesWrapperComponent = styled86(FlexComponent78)`
  overflow: hidden;
`;
function PanelComponent({
  delegations,
  expandedRoutesIds,
  handleToggleRouteExpanded,
  indicator,
  isRouteCodeDelegationSelected,
  onChangeDelegation,
  onChangeIndicator,
  onChangeSelectedRoutes,
  routes,
  selectedDelegationId,
  selectedRoutesIds,
  onOpenEditRoute
}) {
  return /* @__PURE__ */ React139.createElement(RoutesWrapperComponent, { flex: "1", flexDirection: "column", width: "100%" }, /* @__PURE__ */ React139.createElement(
    SelectDelegationComponent,
    {
      delegations,
      isRouteCodeDelegationSelected,
      onChange: onChangeDelegation,
      selected: selectedDelegationId
    }
  ), /* @__PURE__ */ React139.createElement(
    PanelTableComponent,
    {
      expandedRoutesIds,
      handleToggleRouteExpanded,
      indicator,
      onChangeIndicator,
      onChangeRoutesSelection: onChangeSelectedRoutes,
      onOpenEditRoute,
      routes,
      selectedRoutesIds
    }
  ));
}

// src/modules/network/pages/routes/components/map/leg-component.tsx
import React143 from "react";
import { Line } from "react-simple-maps";

// src/modules/network/pages/routes/components/map/stop-component.tsx
import React140 from "react";
import { Marker as Marker2 } from "react-simple-maps";
function getColorService(id, selectedDelegationId) {
  if (!selectedDelegationId || selectedDelegationId === id) {
    return "#ffc439";
  }
  return "var(--otk-theme-color-midnight-express-600)";
}
function getColorShadowService(id, selectedDelegationId) {
  if (!selectedDelegationId || selectedDelegationId === id) {
    return "#8d6300";
  }
  return "var(--otk-theme-color-midnight-express-300)";
}
function StopMarkerComponent({
  latitude,
  longitude,
  id,
  delegationCode
}) {
  const { selectedDelegationId } = useNetworkState();
  const { latitude: customLatitude, longitude: customLongitude } = useGetCustomCoordinatesHook({
    latitude,
    longitude,
    delegationCode
  });
  const color = getColorService(id, selectedDelegationId);
  const colorShadow = getColorShadowService(id, selectedDelegationId);
  if (!customLatitude || !customLongitude) {
    console.error("Custom coordinates not found for delegation code", delegationCode);
    return null;
  }
  return /* @__PURE__ */ React140.createElement(Marker2, { coordinates: [customLongitude, customLatitude] }, /* @__PURE__ */ React140.createElement("circle", { cx: 0, cy: 0, fill: color, opacity: 0.2, r: 3 }, /* @__PURE__ */ React140.createElement("animate", { attributeName: "r", begin: "0.1", dur: "1s", repeatCount: "indefinite", values: "5;6;5" })), /* @__PURE__ */ React140.createElement("circle", { cx: 0, cy: 0, fill: colorShadow, opacity: 1, r: 2, stroke: "#3c4451", strokeWidth: 0 }));
}

// src/modules/network/pages/routes/components/map/origin-component.tsx
import React141 from "react";
import { Marker as Marker3 } from "react-simple-maps";
function getColorService2(id, selectedDelegationId) {
  if (!selectedDelegationId || selectedDelegationId === id) {
    return "#ffc439";
  }
  return "var(--otk-theme-color-midnight-express-600)";
}
function getColorShadowService2(id, selectedDelegationId) {
  if (!selectedDelegationId || selectedDelegationId === id) {
    return "#8d6300";
  }
  return "var(--otk-theme-color-midnight-express-300)";
}
function getTextColorService(id, selectedDelegationId) {
  if (!selectedDelegationId || selectedDelegationId === id) {
    return "#ffc439";
  }
  return "var(--otk-theme-color-midnight-express-400)";
}
var positions2 = {
  top: "top",
  bottom: "bottom"
};
function OriginComponent({
  latitude,
  longitude,
  id,
  name,
  position = positions2.top,
  delegationCode
}) {
  const { selectedDelegationId } = useNetworkState();
  const { latitude: customLatitude, longitude: customLongitude } = useGetCustomCoordinatesHook({
    latitude,
    longitude,
    delegationCode
  });
  const color = getColorService2(id, selectedDelegationId);
  const colorShadow = getColorShadowService2(id, selectedDelegationId);
  const textColor = getTextColorService(id, selectedDelegationId);
  const text = getCapitalizeStringService(name);
  if (!customLatitude || !customLongitude) {
    console.error("Custom coordinates not found for delegation code", delegationCode);
    return null;
  }
  return /* @__PURE__ */ React141.createElement(Marker3, { coordinates: [customLongitude, customLatitude] }, position === positions2.top ? /* @__PURE__ */ React141.createElement("text", { fill: textColor, fontSize: "7px", textAnchor: "middle", y: "-5" }, text) : null, /* @__PURE__ */ React141.createElement("circle", { cx: 0, cy: 0, fill: colorShadow, opacity: 0.5, r: 4 }, /* @__PURE__ */ React141.createElement("animate", { attributeName: "r", begin: "0.1", dur: "1s", repeatCount: "indefinite", values: "5;6;5" })), /* @__PURE__ */ React141.createElement("circle", { cx: 0, cy: 0, fill: color, opacity: 1, r: 2, stroke: "#3c4451", strokeWidth: 0 }), position === positions2.bottom ? /* @__PURE__ */ React141.createElement("text", { fill: textColor, fontSize: "7px", textAnchor: "middle", y: "9" }, text) : null);
}

// src/modules/network/pages/routes/components/map/alert-component.tsx
import React142 from "react";
import { Marker as Marker4 } from "react-simple-maps";
function AlertComponent({
  level,
  longitude,
  latitude,
  code,
  value
}) {
  let color = "#ffc439";
  let colorShadow = "#bd8400";
  switch (level) {
    case alertsLevels.high:
      color = "#ff0000";
      colorShadow = "#8d0000";
      break;
    case alertsLevels.medium:
      color = "#F38005";
      colorShadow = "#8f4a00";
      break;
    case alertsLevels.low:
      color = "#ffc439";
      colorShadow = "#bd8400";
      break;
    case alertsLevels.info:
      color = "#69798f";
      colorShadow = "#404c5c";
      break;
  }
  const markerStyle = {
    default: { cursor: "default" },
    hover: { cursor: "default" },
    pressed: { cursor: "default" }
  };
  return /* @__PURE__ */ React142.createElement(Marker4, { coordinates: [longitude, latitude], style: markerStyle }, /* @__PURE__ */ React142.createElement("style", null, `
          .marker:hover .marker-text { fill: #a4c6e7; }
          .marker:hover .marker-subtext {  fill: #a4c6e7; }
        `), /* @__PURE__ */ React142.createElement("g", { className: "marker" }, /* @__PURE__ */ React142.createElement("circle", { cx: "0", cy: "0", fill: colorShadow, opacity: 0.5, r: "3", style: { zIndex: 1e3 } }, /* @__PURE__ */ React142.createElement("animate", { attributeName: "r", begin: "0.1", dur: "1s", repeatCount: "indefinite", values: "3;6;3" })), /* @__PURE__ */ React142.createElement("circle", { cx: "0", cy: "0", fill: color, r: "3" }), /* @__PURE__ */ React142.createElement("polygon", { fill: "black", points: "-1.5,1 1.5,1 0,-1" }), /* @__PURE__ */ React142.createElement("text", { className: "marker-text", fill: "#fff", fontSize: "7px", textAnchor: "middle", x: "0", y: "10" }, value), /* @__PURE__ */ React142.createElement(
    "text",
    {
      className: "marker-text marker-subtext",
      fill: "#e2e8ee",
      fontSize: "5px",
      textAnchor: "middle",
      x: "0",
      y: "16"
    },
    code
  )));
}

// src/modules/network/pages/routes/components/map/get-curved-paths.ts
function getCurvedPaths(origin, destination, numPoints = 16) {
  const { latitude: originCustomLatitude, longitude: originCustomLongitude } = getCustomCoordinatesService(
    origin.coordinates.latitude,
    origin.coordinates.longitude,
    origin.delegationCode
  );
  const { latitude: destinationCustomLatitude, longitude: destinationCustomLongitude } = getCustomCoordinatesService(
    destination.coordinates.latitude,
    destination.coordinates.longitude,
    destination.delegationCode
  );
  const originPoint = [originCustomLongitude, originCustomLatitude];
  const destPoint = [destinationCustomLongitude, destinationCustomLatitude];
  const dx = destPoint[0] - originPoint[0];
  const dy = destPoint[1] - originPoint[1];
  const distance = Math.sqrt(dx * dx + dy * dy);
  const result = [];
  result.push(originPoint);
  const baseCurvature = 0.15;
  const curvatureFactor = Math.min(baseCurvature, baseCurvature * distance * 0.5);
  for (let i = 1; i < numPoints - 1; i++) {
    const t = i / (numPoints - 1);
    const lineX = originPoint[0] + dx * t;
    const lineY = originPoint[1] + dy * t;
    const offset2 = Math.sin(t * Math.PI) * curvatureFactor;
    const curveX = lineX - dy * offset2;
    const curveY = lineY + dx * offset2;
    result.push([curveX, curveY]);
  }
  result.push(destPoint);
  return result;
}
function getCurvePathMiddlePointService(origin, destination, numPoints = 16) {
  const path = getCurvedPaths(origin, destination, numPoints);
  const middleIndex = Math.floor(path.length / 2);
  return path[middleIndex];
}

// src/modules/network/pages/routes/components/map/leg-component.tsx
function getRouteLineColorService(alert, indicator, vehicleType) {
  if (isRouteVehicleCategoryColorEnabledHelper(indicator)) {
    return getRouteVehicleCategoryMapColorHelper(vehicleType);
  }
  if (alert == null ? void 0 : alert.level) {
    return alertLevelColors[alert.level];
  }
  return "var(--otk-theme-color-midnight-express-500)";
}
function getLineWidthService(hasRoundTrip, isExpanded) {
  if (hasRoundTrip) {
    if (isExpanded) {
      return 2.5;
    }
    return 1;
  }
  if (isExpanded) {
    return 2;
  }
  return 0.5;
}
function getLineOpacityService(isExpanded, hasRoundTrip, indicator) {
  if (indicator === selectIndicatorOptionsValues.none && !hasRoundTrip) {
    if (isExpanded) {
      return 1;
    }
    return 0.75;
  } else if (indicator === selectIndicatorOptionsValues.none && hasRoundTrip) {
    if (isExpanded) {
      return 0.75;
    }
    return 0.5;
  }
  if (hasRoundTrip) {
    if (isExpanded) {
      return 0.9;
    }
    return 0.5;
  }
  if (isExpanded) {
    return 1;
  }
  return 0.75;
}
function LegComponent({
  id,
  origin,
  destination,
  routeOriginId,
  hasRoundTrip = false,
  alert,
  isExpanded = false,
  indicator,
  vehicleType,
  code
}) {
  const lineColor = getRouteLineColorService(alert, indicator, vehicleType);
  const lineWidth = getLineWidthService(hasRoundTrip, isExpanded);
  const lineOpacity = getLineOpacityService(isExpanded, hasRoundTrip, indicator);
  const curvedPaths = getCurvedPaths(origin, destination);
  const [xMiddleCurvePathCoord, yMiddleCurvePathCoord] = getCurvePathMiddlePointService(
    origin,
    destination
  );
  return /* @__PURE__ */ React143.createElement(React143.Fragment, null, /* @__PURE__ */ React143.createElement(
    Line,
    {
      coordinates: curvedPaths,
      key: `network-map-route-${id}-line-${origin.id}-${destination.id}`,
      opacity: lineOpacity,
      stroke: lineColor,
      strokeLinecap: "round",
      strokeWidth: lineWidth
    }
  ), indicator === selectIndicatorOptionsValues.lowVehicleOccupancy && alert ? /* @__PURE__ */ React143.createElement(
    AlertComponent,
    {
      code,
      key: `network-map-route-${id}-leg-alert-${id}${origin.id}-${destination.id}`,
      latitude: yMiddleCurvePathCoord,
      level: alert.level,
      longitude: xMiddleCurvePathCoord,
      value: alert.value
    }
  ) : null, origin.id === routeOriginId ? /* @__PURE__ */ React143.createElement(
    OriginComponent,
    {
      delegationCode: origin.delegationCode,
      id: origin.id,
      key: `network-map-route-${id}-origin-${origin.id}`,
      latitude: origin.coordinates.latitude,
      longitude: origin.coordinates.longitude,
      name: origin.name,
      position: customDelegationsBottomLabel.includes(origin.delegationCode) ? "bottom" : "top"
    }
  ) : /* @__PURE__ */ React143.createElement(
    StopMarkerComponent,
    {
      delegationCode: origin.delegationCode,
      id: origin.id,
      key: `network-map-route-${id}-stop-${origin.id}`,
      latitude: origin.coordinates.latitude,
      longitude: origin.coordinates.longitude
    }
  ), /* @__PURE__ */ React143.createElement(
    StopMarkerComponent,
    {
      delegationCode: destination.delegationCode,
      id: destination.id,
      key: `network-map-route-${id}-stop-${destination.id}`,
      latitude: destination.coordinates.latitude,
      longitude: destination.coordinates.longitude
    }
  ));
}

// src/modules/network/pages/routes/components/map/routes-component.tsx
function RoutesComponent({
  routes,
  indicator,
  expandedRoutesIds
}) {
  return /* @__PURE__ */ React144.createElement(React144.Fragment, null, routes.map((r) => {
    const routeIsExpanded = expandedRoutesIds == null ? void 0 : expandedRoutesIds.has(r.id);
    return r.legs.map((leg) => {
      const origin = leg.origin;
      const destination = leg.destination;
      let alert;
      if (indicator === selectIndicatorOptionsValues.lowVehicleOccupancy) {
        alert = getAlertFilteredByIndicatorService(
          alertsIndicators.lowVehicleOccupancy,
          leg.alerts
        );
      } else if (indicator === selectIndicatorOptionsValues.lateness) {
        alert = getAlertFilteredByIndicatorService(alertsIndicators.lateness, r.alerts);
      } else if (indicator === selectIndicatorOptionsValues.hightDensity) {
        alert = getAlertFilteredByIndicatorService(alertsIndicators.hightDensity, r.alerts);
      } else {
        alert = void 0;
      }
      return /* @__PURE__ */ React144.createElement(
        LegComponent,
        {
          alert,
          code: r.routeIdentifier,
          destination,
          hasRoundTrip: Boolean(r.roundTrip),
          id: r.id,
          indicator,
          isExpanded: routeIsExpanded,
          key: `routes-map-route-${r.id}-${origin.id}-${destination.id}`,
          origin,
          routeOriginId: r.origin.id,
          vehicleType: r.vehicleType
        }
      );
    });
  }));
}

// src/modules/network/pages/routes/components/map/map-component.tsx
var MAP_URL = "/map/network-map-spain-geo.json";
var NetworkMapWrapperComponent = styled87.header`
  background-color: #1e2838;
  width: 100%;
  height: 100%;
  background-color: #1e2838;
  width: 100%;
  height: 100%;
  flex: 1;
  position: relative;
`;
var NetworkMapZoomButtonsComponent = styled87(FlexComponent79)`
  position: absolute;
  top: 10px;
  right: 10px;
  gap: 2px;
`;
var NetworkMapZoomButtonComponent = styled87(ButtonComponent31)`
  border-color: var(--otk-theme-color-midnight-express-700, #31435d);
  background-color: var(--otk-theme-color-midnight-express-700, #31435d);
`;
var NetworkComposableMapComponent = styled87(ComposableMap)`
  height: 100%;

  width: ${({ reduce }) => {
  if (reduce) {
    return "calc(100vw - 370px - 61px)";
  }
  return "calc(100vw - 61px)";
}};

  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
`;
function MapComponent({
  delegations,
  routes,
  reduce = false,
  indicator,
  expandedRoutesIds
}) {
  const [position, setPosition] = useState39({
    coordinates: [-3.7, 40],
    // Madrid coordinates approximately
    zoom: 1
  });
  const handleZoomIn = () => {
    if (position.zoom >= 4) {
      return;
    }
    setPosition((pos) => __spreadProps(__spreadValues({}, pos), { zoom: pos.zoom * 2 }));
  };
  const handleZoomOut = () => {
    if (position.zoom <= 1) {
      return;
    }
    setPosition((pos) => __spreadProps(__spreadValues({}, pos), { zoom: pos.zoom / 2 }));
  };
  const handleMoveEnd = (newPosition) => {
    setPosition(newPosition);
  };
  return /* @__PURE__ */ React145.createElement(NetworkMapWrapperComponent, null, /* @__PURE__ */ React145.createElement(NetworkMapZoomButtonsComponent, null, /* @__PURE__ */ React145.createElement(NetworkMapZoomButtonComponent, { onClick: handleZoomIn, size: "s" }, /* @__PURE__ */ React145.createElement(IconComponent23, { name: "plus", size: "xl" })), /* @__PURE__ */ React145.createElement(NetworkMapZoomButtonComponent, { onClick: handleZoomOut, size: "s" }, /* @__PURE__ */ React145.createElement(IconComponent23, { name: "minus", size: "xl" }))), /* @__PURE__ */ React145.createElement(
    NetworkComposableMapComponent,
    {
      projection: "geoAlbers",
      projectionConfig: {
        scale: 3500,
        rotate: [2, -0.75, 0]
      },
      reduce,
      width: 100
    },
    /* @__PURE__ */ React145.createElement(ZoomableGroup, { center: position.coordinates, onMoveEnd: handleMoveEnd, zoom: position.zoom }, /* @__PURE__ */ React145.createElement(Geographies, { fill: "#1c2636", geography: MAP_URL }, ({ geographies }) => {
      return geographies.map((geo) => /* @__PURE__ */ React145.createElement(
        Geography,
        {
          stroke: "#3c4451",
          geography: geo,
          key: geo.rsmKey,
          style: {
            default: { outline: "none" },
            hover: { outline: "none" },
            pressed: { outline: "none" }
          }
        }
      ));
    }), delegations == null ? void 0 : delegations.map((delegation) => {
      const isSelectedAsOrigin = routes == null ? void 0 : routes.some((route) => route.origin.id === delegation.id);
      return /* @__PURE__ */ React145.createElement(
        DelegationComponent,
        {
          delegationCode: delegation.delegationCode,
          delegationId: delegation.id,
          key: `routes-map-marker-${delegation.name.replace(" ", "")}`,
          latitude: delegation.latitude,
          longitude: delegation.longitude,
          name: !isSelectedAsOrigin ? getCapitalizeStringService(delegation.name) : void 0,
          position: customDelegationsBottomLabel.includes(delegation.delegationCode) ? "bottom" : "top"
        }
      );
    }), routes && delegations && routes.length > 0 && delegations.length > 0 ? /* @__PURE__ */ React145.createElement(
      RoutesComponent,
      {
        expandedRoutesIds,
        indicator,
        routes
      }
    ) : null)
  ));
}

// src/modules/network/pages/routes/components/main-panel/main-panel-component.tsx
import styled88 from "styled-components";
import { FlexComponent as FlexComponent80 } from "@ontruck/fe-ui";
var MainPanelComponent = styled88(FlexComponent80)`
  background-color: var(--otk-theme-color-midnight-express-800, #1d2838);
`;

// src/modules/network/pages/routes/components/main-panel/main-panel-top-bar-component.tsx
import styled89 from "styled-components";
import { FlexComponent as FlexComponent81 } from "@ontruck/fe-ui";

// src/modules/network/pages/routes/components/main-panel/constants.ts
var MAIN_PANEL_TOP_BAR_FILTERS_HEIGHT_IN_PIXELS = 70;
var MAIN_PANEL_TOP_BAR_HOURS_TIMELINE_HEIGHT_IN_PIXELES = 70;

// src/modules/network/pages/routes/components/main-panel/main-panel-top-bar-component.tsx
var MainPanelTopBarComponent = styled89(FlexComponent81)`
  width: 100%;
  background-color: var(--otk-theme-color-white, #ffffff);
  border-bottom: var(--otk-theme-border, #e0e0e0);
  flex: none;

  padding: ${({ verticalHeight }) => {
  if (verticalHeight === `${MAIN_PANEL_TOP_BAR_HOURS_TIMELINE_HEIGHT_IN_PIXELES}px`) {
    return "0";
  }
  return "calc(var(--otk-theme-space-s, 8px) + 1px) var(--otk-theme-space-s, 8px)";
}};

  transition: height 0.2s ease;

  height: ${({ isOpen, verticalHeight }) => {
  if (isOpen) {
    return verticalHeight;
  }
  return "0";
}};

  padding: ${({ isOpen }) => !isOpen && "0"};

  > * {
    display: ${({ isOpen }) => !isOpen && "none"};
    height: ${({ isOpen }) => !isOpen && "0"};
  }

  @starting-style {
    height: ${({ verticalHeight }) => verticalHeight && verticalHeight};
  }
`;

// src/modules/network/pages/routes/views/routes-map-view-component.tsx
function RoutesMapViewComponent({
  allRoutesIdentifiers,
  availableRoutesIdentifiers,
  availableProviderNames,
  dashboardDescription,
  evaluated,
  expandedRoutesIds,
  filteredTableRoutes,
  handleChangeDelegation,
  handleChangeFilterByProviderName,
  handleChangeFilterByRouteType,
  handleChangeFilterByVehicleType,
  handleChangeRoutesEvaluatorIndicator: handleChangeRoutesIndicator,
  handleChangeRoutesSelection: handleChangeSelectedRoutes,
  handleToggleRouteExpanded,
  isLoading,
  shouldShowBottomPanel = true,
  isRouteCodeDelegationSelected,
  leftPanelIsOpen,
  mapDelegations,
  metrics,
  onChangeFilterByOperations,
  onChangeFilterByRoutesIdentifiers,
  selectedDelegationId,
  selectedFilterByOperationsId,
  selectedFilterByProviderName,
  selectedFilterByRoutesIdentifiers,
  selectedFilterByRouteTypeId,
  selectedFilterByVehicleTypeId,
  selectedMapRoutes,
  selectedRoutesIds,
  selectedRoutesIndicatorValue,
  tableDelegations,
  onOpenEditRoute
}) {
  return /* @__PURE__ */ React146.createElement(FlexComponent82, { alignItems: "stretch", height: "100%", justifyContent: "stretch", width: "100%" }, /* @__PURE__ */ React146.createElement(LeftPanelComponent, { flexDirection: "column", isOpen: leftPanelIsOpen }, /* @__PURE__ */ React146.createElement(
    PanelComponent,
    {
      delegations: tableDelegations,
      expandedRoutesIds,
      handleToggleRouteExpanded,
      indicator: selectedRoutesIndicatorValue,
      isRouteCodeDelegationSelected,
      onChangeDelegation: handleChangeDelegation,
      onChangeIndicator: handleChangeRoutesIndicator,
      onChangeSelectedRoutes: handleChangeSelectedRoutes,
      onOpenEditRoute,
      routes: filteredTableRoutes,
      selectedDelegationId,
      selectedRoutesIds
    }
  )), /* @__PURE__ */ React146.createElement(MainPanelComponent, { flex: "1", flexDirection: "column", width: "calc(100% - 370px)" }, /* @__PURE__ */ React146.createElement(
    MainPanelTopBarComponent,
    {
      alignItems: "center",
      isOpen: true,
      verticalHeight: `${MAIN_PANEL_TOP_BAR_FILTERS_HEIGHT_IN_PIXELS}px`,
      width: "100%"
    },
    /* @__PURE__ */ React146.createElement(
      FiltersComponent3,
      {
        allRoutesIdentifiers,
        availableProviderNames,
        availableRoutesIdentifiers,
        isDelegationIdSelected: Boolean(selectedDelegationId),
        onChangeOperations: onChangeFilterByOperations,
        onChangeProviderName: handleChangeFilterByProviderName,
        onChangeRouteType: handleChangeFilterByRouteType,
        onChangeRoutesIdentifiers: onChangeFilterByRoutesIdentifiers,
        onChangeVehicleType: handleChangeFilterByVehicleType,
        selectedOperationsId: selectedFilterByOperationsId,
        selectedProviderNameId: selectedFilterByProviderName,
        selectedRouteTypeId: selectedFilterByRouteTypeId,
        selectedRoutesIdentifiers: selectedFilterByRoutesIdentifiers,
        selectedVehicleTypeId: selectedFilterByVehicleTypeId
      }
    )
  ), isLoading ? /* @__PURE__ */ React146.createElement(SpinnerComponent, { timeInMilliseconds: 1500 }) : null, !isLoading ? /* @__PURE__ */ React146.createElement(
    MapComponent,
    {
      delegations: mapDelegations,
      expandedRoutesIds,
      indicator: selectedRoutesIndicatorValue,
      reduce: leftPanelIsOpen || false,
      routes: selectedMapRoutes
    }
  ) : null, !isLoading && shouldShowBottomPanel ? /* @__PURE__ */ React146.createElement(BottomPanelComponent, null, /* @__PURE__ */ React146.createElement(
    DashboardsComponent,
    {
      description: dashboardDescription,
      evaluated,
      isOpen: true,
      metrics
    }
  )) : null));
}

// src/modules/network/pages/routes/routes-page-hook.tsx
import { useMemo as useMemo39, useState as useState41, useEffect as useEffect17 } from "react";

// src/modules/network/pages/routes/routes-filters-hook.tsx
import { useMemo as useMemo38, useState as useState40 } from "react";

// src/modules/network/routes/get-sorted-routes-by-indicator-alert-service.ts
function getRoutesWithAStopWhenIndicatorAlertWithAnAlertLevel(routes, delegationId, indicator) {
  if (!indicator) {
    return routes;
  }
  return routes.filter((route) => {
    var _a;
    const hasRouteAlert = (_a = route.alerts) == null ? void 0 : _a.some((alert) => alert.indicator === indicator);
    if (!hasRouteAlert) {
      return false;
    }
    if (indicator === alertsIndicators.lateness) {
      return route.stops.some(
        (stop) => {
          var _a2;
          return stop.id === delegationId && ((_a2 = stop.alerts) == null ? void 0 : _a2.some(
            (alert) => alert.indicator === alertsIndicators.lateness && (alert.phase === alertsPhases.departure || alert.phase === alertsPhases.arrival)
          ));
        }
      );
    }
    if (indicator === alertsIndicators.hightDensity) {
      return route.stops.some(
        (stop) => {
          var _a2;
          return stop.id === delegationId && ((_a2 = stop.alerts) == null ? void 0 : _a2.some(
            (alert) => alert.indicator === alertsIndicators.hightDensity && (alert.phase === alertsPhases.departure || alert.phase === alertsPhases.arrival)
          ));
        }
      );
    }
    return route.stops.some(
      (stop) => {
        var _a2;
        return stop.id === delegationId && ((_a2 = stop.alerts) == null ? void 0 : _a2.some((alert) => alert.indicator === indicator));
      }
    );
  });
}
function getSortedRoutesByIndicatorAlertService(indicator, routes) {
  if (!routes) {
    return [];
  }
  if (!indicator) {
    return routes;
  }
  return routes.sort((rA, rB) => {
    var _a, _b, _c, _d, _e, _f;
    const valueA = (_c = (_b = (_a = rA.alerts) == null ? void 0 : _a.find((aA) => aA.indicator === indicator)) == null ? void 0 : _b.normalisedOrdinal) != null ? _c : 0;
    const valueB = (_f = (_e = (_d = rB.alerts) == null ? void 0 : _d.find((aB) => aB.indicator === indicator)) == null ? void 0 : _e.normalisedOrdinal) != null ? _f : 0;
    return valueA < valueB ? 1 : -1;
  });
}

// src/modules/network/pages/routes/routes-filters-hook.tsx
var useRoutesFiltersHook = ({
  routes,
  selectedDelegationId,
  selectedRoutesIndicatorValue
}) => {
  const { routesView } = useNetworkState();
  const [selectedFilterByRouteTypeId, setSelectedFilterByRouteTypeId] = useState40();
  const [selectedFilterByVehicleTypeId, setSelectedFilterByVehicleTypeId] = useState40();
  const [selectedFilterByProviderName, setSelectedFilterByProviderName] = useState40();
  const [selectedFilterByRoutesIdentifiers, setSelectedFilterByRoutesIdentifiers] = useState40();
  const [selectedFilterByOperationsId, setSelectedFilterByOperationsId] = useState40();
  const availableProviderNames = useMemo38(() => {
    if (!routes) {
      return [];
    }
    return Array.from(new Set(routes.map((r) => r.providerName))).sort(
      (a, b) => a.localeCompare(b)
    );
  }, [routes]);
  const filteredTableRoutes = useMemo38(() => {
    if (!routes) {
      return [];
    }
    let processedRoutes = [...routes];
    if (selectedDelegationId) {
      processedRoutes = getRoutesDelegationService(selectedDelegationId, processedRoutes);
    }
    if (selectedFilterByRouteTypeId) {
      processedRoutes = getRoutesByOperationTypeService(
        selectedFilterByRouteTypeId,
        processedRoutes
      );
    }
    if (selectedFilterByVehicleTypeId) {
      processedRoutes = getRoutesByVehicleTypeService(
        selectedFilterByVehicleTypeId,
        processedRoutes
      );
    }
    if (selectedFilterByProviderName) {
      processedRoutes = getRoutesByProviderNameService(
        selectedFilterByProviderName,
        processedRoutes
      );
    }
    if (selectedFilterByRoutesIdentifiers) {
      processedRoutes = getRoutesByIdsService(selectedFilterByRoutesIdentifiers, processedRoutes);
    }
    if (selectedFilterByOperationsId) {
      if (selectedFilterByOperationsId.length === 0) {
        processedRoutes = getRoutesDelegationByOperationsService(
          selectedDelegationId,
          void 0,
          processedRoutes
        );
      } else {
        processedRoutes = getRoutesDelegationByOperationsService(
          selectedDelegationId,
          selectedFilterByOperationsId,
          processedRoutes
        );
      }
    }
    if (selectedRoutesIndicatorValue) {
      if (routesView === routesViews.timeline) {
        processedRoutes = getSortedRoutesByIndicatorAlertService(
          selectedRoutesIndicatorValue,
          processedRoutes
        );
        if (selectedDelegationId) {
          processedRoutes = getRoutesWithAStopWhenIndicatorAlertWithAnAlertLevel(
            processedRoutes,
            selectedDelegationId,
            selectedRoutesIndicatorValue === selectIndicatorOptionsValues.none ? void 0 : selectedRoutesIndicatorValue
          );
        }
      } else {
        processedRoutes = getSortedRoutesByIndicatorAlertService(
          selectedRoutesIndicatorValue === selectIndicatorOptionsValues.none ? void 0 : selectedRoutesIndicatorValue,
          processedRoutes
        );
      }
    }
    return processedRoutes;
  }, [
    routes,
    selectedDelegationId,
    selectedFilterByProviderName,
    selectedFilterByRouteTypeId,
    selectedFilterByVehicleTypeId,
    selectedFilterByOperationsId,
    selectedFilterByRoutesIdentifiers,
    selectedRoutesIndicatorValue,
    routesView
  ]);
  const availableRoutesIdentifiers = useMemo38(() => {
    return Array.from(new Set(filteredTableRoutes.map((r) => r.routeIdentifier))).sort(
      (a, b) => a.localeCompare(b)
    );
  }, [filteredTableRoutes]);
  const availableDelegationRoutesIdentifiers = useMemo38(() => {
    if (!selectedDelegationId) {
      return availableRoutesIdentifiers;
    }
    return Array.from(
      new Set(
        getRoutesDelegationService(selectedDelegationId, routes).map((r) => r.routeIdentifier)
      )
    ).sort((a, b) => a.localeCompare(b));
  }, [selectedDelegationId, routes, availableRoutesIdentifiers]);
  const handleChangeFilterByRouteType = (name, value) => {
    if (value === routeTypeOptionsIds.any) {
      setSelectedFilterByRouteTypeId(void 0);
      return;
    }
    setSelectedFilterByRouteTypeId(value);
  };
  const handleChangeFilterByVehicleType = (name, value) => {
    if (value === routeVehicleTypeOptionsIds.any) {
      setSelectedFilterByVehicleTypeId(void 0);
      return;
    }
    setSelectedFilterByVehicleTypeId(value);
  };
  const handleChangeFilterByProviderName = (name, value) => {
    if (value === routeProviderNameOptionsIds.any) {
      setSelectedFilterByProviderName(void 0);
      return;
    }
    setSelectedFilterByProviderName(value);
  };
  const handleChangeFilterByRoutesIdentifiers = (routesIds) => {
    if (!routesIds) {
      setSelectedFilterByRoutesIdentifiers(void 0);
      return;
    }
    setSelectedFilterByRoutesIdentifiers(routesIds);
  };
  const handleChangeFilterByOperations = (operations) => {
    if ((operations == null ? void 0 : operations.length) === 0) {
      setSelectedFilterByOperationsId(void 0);
      return;
    }
    setSelectedFilterByOperationsId(operations);
  };
  const cleanFilterByRoutesIdentifiers = () => {
    setSelectedFilterByRoutesIdentifiers(void 0);
  };
  return {
    availableProviderNames,
    availableRoutesIdentifiers,
    availableDelegationRoutesIdentifiers,
    cleanFilterByRoutesIdentifiers,
    filteredTableRoutes,
    handleChangeFilterByOperations,
    handleChangeFilterByProviderName,
    handleChangeFilterByRouteType,
    handleChangeFilterByRoutesIdentifiers,
    handleChangeFilterByVehicleType,
    selectedFilterByOperationsId,
    selectedFilterByProviderName,
    selectedFilterByRouteTypeId,
    selectedFilterByRoutesIdentifiers,
    selectedFilterByVehicleTypeId
  };
};

// src/modules/network/pages/routes/routes-page-hook.tsx
function useRoutesPageHook({
  config,
  leftPanelIsOpen = false,
  onClickLeftSidebarNavigationItem,
  toggleLeftPanelIsOpen
}) {
  const {
    evaluationPackageDate,
    evaluationRouteDate,
    launchEvaluation,
    launchScenarioEvaluation,
    networkId,
    scenarioParentId,
    routesView,
    selectedDelegationId,
    setNetworkId,
    setScenarioParentId,
    setSelectedDelegationId
  } = useNetworkState();
  const { network, isLoading: networkIsLoading } = useGetNetworkHook({ networkId, config });
  const { routes, isLoading: routesAreLoading } = useGetRoutesHook({ networkId, config });
  const [draftRoutes, setDraftRoutes] = useState41([]);
  const [editedDraftRoutes, setEditedDraftRoutes] = useState41([]);
  const { description, metrics, evaluated } = useDashboardsHook({
    selectedDelegationId,
    network
  });
  const [selectedRoutesIds, setSelectedRoutesIds] = useState41(/* @__PURE__ */ new Set([]));
  const [expandedRoutesIds, setExpandedRoutesIds] = useState41(/* @__PURE__ */ new Set());
  const [selectedRoutesIndicatorValue, setSelectedRoutesIndicatorValue] = useState41(selectIndicatorOptionsValues.none);
  const [topBarModuleRegionNode, setTopBarModuleRegionNode] = useState41();
  const [baseRoutes, setBaseRoutes] = useState41(routes || []);
  useEffect17(() => {
    if (!routes || baseRoutes.length > 0) {
      return;
    }
    setBaseRoutes(routes);
  }, [routes, baseRoutes]);
  const existingAndDraftAndEditedDraftRoutes = useMemo39(() => {
    if (!routes) {
      return [];
    }
    const routesWithoutEditedDraftRoutes = routes.filter(
      (route) => !editedDraftRoutes.some((r) => r.id === route.id)
    );
    return [...routesWithoutEditedDraftRoutes, ...draftRoutes, ...editedDraftRoutes];
  }, [routes, draftRoutes, editedDraftRoutes]);
  const {
    filteredTableRoutes,
    selectedFilterByRouteTypeId,
    selectedFilterByVehicleTypeId,
    selectedFilterByProviderName,
    selectedFilterByRoutesIdentifiers,
    availableRoutesIdentifiers,
    availableDelegationRoutesIdentifiers,
    availableProviderNames,
    handleChangeFilterByProviderName,
    handleChangeFilterByRouteType,
    handleChangeFilterByVehicleType,
    handleChangeFilterByRoutesIdentifiers,
    handleChangeFilterByOperations,
    selectedFilterByOperationsId,
    cleanFilterByRoutesIdentifiers
  } = useRoutesFiltersHook({
    routes: existingAndDraftAndEditedDraftRoutes,
    selectedDelegationId,
    selectedRoutesIndicatorValue
  });
  const isLoading = useMemo39(() => {
    if (networkIsLoading || routesAreLoading) {
      return true;
    }
    return false;
  }, [networkIsLoading, routesAreLoading]);
  const mapDelegations = useMemo39(() => {
    if (!network || !routes) {
      return [];
    }
    if (selectedDelegationId) {
      const routesDelegation = getRoutesDelegationService(selectedDelegationId, routes);
      const delegationsRoutes = getDelegationsRoutesService(network.delegations, routesDelegation);
      return delegationsRoutes;
    }
    return network.delegations;
  }, [network, routes, selectedDelegationId]);
  const tableDelegations = useMemo39(() => {
    if (!network || !routes) {
      return [];
    }
    return network.delegations;
  }, [network, routes]);
  const selectedMapRoutes = useMemo39(() => {
    if (!routes || selectedRoutesIds.size === 0 || filteredTableRoutes.length === 0 || selectedDelegationId === void 0 && selectedRoutesIds.size === 0) {
      return [];
    }
    if (selectedFilterByRouteTypeId) {
      const filteredMapRoutes = getRoutesByOperationTypeService(
        selectedFilterByRouteTypeId,
        filteredTableRoutes
      );
      return getRoutesService(Array.from(selectedRoutesIds), filteredMapRoutes);
    }
    const mapRoutes = getRoutesService(Array.from(selectedRoutesIds), filteredTableRoutes);
    return mapRoutes;
  }, [
    routes,
    selectedRoutesIds,
    filteredTableRoutes,
    selectedDelegationId,
    selectedFilterByRouteTypeId
  ]);
  const allRoutesIdentifiers = useMemo39(() => {
    if (baseRoutes.length === 0) {
      return [];
    }
    return Array.from(new Set(baseRoutes.map((r) => r.routeIdentifier))).sort(
      (a, b) => a.localeCompare(b)
    );
  }, [baseRoutes]);
  const shouldShowBottomPanel = useMemo39(() => {
    if (selectedFilterByRoutesIdentifiers && selectedFilterByRoutesIdentifiers.length > 0 && !selectedDelegationId) {
      return false;
    }
    return true;
  }, [selectedFilterByRoutesIdentifiers, selectedDelegationId]);
  const handleChangeRoutesSelection = (toggleSelectionRoutesIds) => {
    const areSetsEqual = getAreSetsEqualsService(
      selectedRoutesIds,
      toggleSelectionRoutesIds
    );
    if (areSetsEqual) {
      return;
    }
    setSelectedRoutesIds(toggleSelectionRoutesIds);
  };
  const handleChangeDelegation = (name, value) => {
    if (value === "all") {
      setSelectedDelegationId(void 0);
      setSelectedRoutesIndicatorValue(selectIndicatorOptionsValues.none);
      setSelectedRoutesIds(/* @__PURE__ */ new Set([]));
      cleanFilterByRoutesIdentifiers();
      return;
    }
    if (value === "all from some routes selected by code") {
      setSelectedDelegationId(void 0);
      setSelectedRoutesIds(/* @__PURE__ */ new Set([]));
      setSelectedRoutesIndicatorValue(selectIndicatorOptionsValues.none);
      cleanFilterByRoutesIdentifiers();
      return;
    }
    setSelectedDelegationId(value);
    setSelectedRoutesIndicatorValue(selectIndicatorOptionsValues.none);
    setSelectedRoutesIds(/* @__PURE__ */ new Set([]));
  };
  const handleClickSidebarNavigationItem = (navigationItemId) => {
    setSelectedRoutesIds(/* @__PURE__ */ new Set([]));
    if (onClickLeftSidebarNavigationItem) {
      onClickLeftSidebarNavigationItem(navigationItemId);
    }
  };
  const handleChangeRoutesEvaluatorIndicator = (routeIndicator) => {
    if (!routeIndicator) {
      setSelectedRoutesIndicatorValue(selectIndicatorOptionsValues.none);
      return;
    }
    setSelectedRoutesIndicatorValue(routeIndicator);
  };
  const handleToggleRouteExpanded = (routeId) => {
    const routeIsExpanded = expandedRoutesIds.has(routeId);
    if (!routeIsExpanded) {
      expandedRoutesIds.add(routeId);
      setExpandedRoutesIds(new Set(expandedRoutesIds));
    }
    if (routeIsExpanded) {
      expandedRoutesIds.delete(routeId);
      setExpandedRoutesIds(new Set(expandedRoutesIds));
    }
  };
  const handleAddDraftRoute = (newDraftRoute) => {
    setDraftRoutes([...draftRoutes, newDraftRoute]);
  };
  const handleAddDraftRoutes = (newDraftRoutes) => {
    setDraftRoutes([...draftRoutes, ...newDraftRoutes]);
  };
  const handleRemoveDraftRoutes = () => {
    setDraftRoutes([]);
  };
  const handleAddEditedDraftRoute = (editedDraftRouteToBeAdded) => {
    if (!routes) {
      return;
    }
    const routeToBeEditedIndex = routes.findIndex(
      (route) => route.id === editedDraftRouteToBeAdded.id
    );
    const isEditedDraftRouteAlreadyExistAtBaseRoutes = routeToBeEditedIndex !== -1;
    if (isEditedDraftRouteAlreadyExistAtBaseRoutes) {
      setEditedDraftRoutes([...editedDraftRoutes, editedDraftRouteToBeAdded]);
    }
    const draftRouteToBeEditedIndex = draftRoutes.findIndex(
      (route) => route.id === editedDraftRouteToBeAdded.id
    );
    const isEditedDraftRouteAlreadyExistAtDraftRoutes = draftRouteToBeEditedIndex !== -1;
    if (isEditedDraftRouteAlreadyExistAtDraftRoutes) {
      const draftRoutesWithoutEditedDraftRoute = [...draftRoutes];
      draftRoutesWithoutEditedDraftRoute.splice(draftRouteToBeEditedIndex, 1);
      setDraftRoutes(draftRoutesWithoutEditedDraftRoute);
      setEditedDraftRoutes([...editedDraftRoutes, editedDraftRouteToBeAdded]);
    }
    const editedDraftRouteToBeAddedIndex = editedDraftRoutes.findIndex(
      (route) => route.id === editedDraftRouteToBeAdded.id
    );
    const isEditedDraftRouteAlreadyExistAtEditedDraftRoutes = editedDraftRouteToBeAddedIndex !== -1;
    if (isEditedDraftRouteAlreadyExistAtEditedDraftRoutes) {
      const editedDraftRoutesWithoutEditedDraftRoute = [...editedDraftRoutes];
      editedDraftRoutesWithoutEditedDraftRoute.splice(editedDraftRouteToBeAddedIndex, 1);
      setEditedDraftRoutes([
        ...editedDraftRoutesWithoutEditedDraftRoute,
        editedDraftRouteToBeAdded
      ]);
    }
    if (!isEditedDraftRouteAlreadyExistAtBaseRoutes || !isEditedDraftRouteAlreadyExistAtDraftRoutes || !isEditedDraftRouteAlreadyExistAtEditedDraftRoutes) {
      console.error("route not found to be edited");
    }
  };
  const handleAddEditedDraftRoutes = (editedDraftRoutesToBeAdded) => {
    const editedDraftRoutesFiltered = editedDraftRoutes.filter(
      (route) => !editedDraftRoutesToBeAdded.some((r) => r.id === route.id)
    );
    setEditedDraftRoutes([...editedDraftRoutesFiltered, ...editedDraftRoutesToBeAdded]);
  };
  const handleRemoveEditedDraftRoutes = () => {
    setEditedDraftRoutes([]);
  };
  useEffect17(() => {
    if (topBarModuleRegionNode) {
      return;
    }
    const node = document.getElementById(TOP_BAR_MODULE_REGION_ID);
    if (!node) {
      return;
    }
    setTopBarModuleRegionNode(node);
  }, [topBarModuleRegionNode]);
  useEffect17(() => {
    if (toggleLeftPanelIsOpen && !leftPanelIsOpen) {
      toggleLeftPanelIsOpen();
    }
  }, []);
  useEffect17(() => {
    if (networkIsLoading) {
      return;
    }
    if (selectedDelegationId) {
      return;
    }
    const madridDelegation = network == null ? void 0 : network.delegations.find(
      (delegation) => delegation.name === DEFAULT_DELEGATION_NAME
    );
    if (madridDelegation) {
      setSelectedDelegationId(madridDelegation.id);
    }
  }, [networkIsLoading]);
  const portalKey = `${Boolean(topBarModuleRegionNode)}-${navigationItemsIds.ROUTES}`;
  return {
    addDraftRoute: handleAddDraftRoute,
    addDraftRoutes: handleAddDraftRoutes,
    addEditedDraftRoute: handleAddEditedDraftRoute,
    addEditedDraftRoutes: handleAddEditedDraftRoutes,
    allRoutesIdentifiers,
    availableProviderNames,
    availableRoutesIdentifiers,
    availableDelegationRoutesIdentifiers,
    dashboardDescription: description,
    evaluated,
    evaluationPackageDate,
    evaluationRouteDate,
    expandedRoutesIds,
    filteredTableRoutes,
    handleChangeDelegation,
    handleChangeFilterByOperations,
    handleChangeFilterByProviderName,
    handleChangeFilterByRouteType,
    handleChangeFilterByRoutesIdentifiers,
    handleChangeFilterByVehicleType,
    handleChangeRoutesEvaluatorIndicator,
    handleChangeRoutesSelection,
    handleClickSidebarNavigationItem,
    handleToggleRouteExpanded,
    isLoading,
    launchEvaluation,
    launchScenarioEvaluation,
    leftPanelIsOpen,
    mapDelegations,
    metrics,
    networkId,
    onClickLeftSidebarNavigationItem,
    portalKey,
    removeDraftRoutes: handleRemoveDraftRoutes,
    removeEditedDraftRoutes: handleRemoveEditedDraftRoutes,
    routesView,
    scenarioParentId,
    selectedDelegationId,
    selectedFilterByOperationsId,
    selectedFilterByProviderName,
    selectedFilterByRouteTypeId,
    selectedFilterByRoutesIdentifiers,
    selectedFilterByVehicleTypeId,
    selectedMapRoutes,
    selectedRoutesIds,
    selectedRoutesIndicatorValue,
    setNetworkId,
    setScenarioParentId,
    shouldShowBottomPanel,
    tableDelegations,
    toggleLeftPanelIsOpen,
    topBarModuleRegionNode
  };
}

// src/modules/network/pages/routes/views/routes-table-view-component.tsx
import React152 from "react";
import { FlexComponent as FlexComponent86 } from "@ontruck/fe-ui";

// src/modules/network/pages/routes/components/table/routes-table-view-table-component.tsx
import React151, { useState as useState42, useCallback as useCallback20, useMemo as useMemo41, useEffect as useEffect18, useRef as useRef3 } from "react";
import { FlexComponent as FlexComponent85 } from "@ontruck/fe-ui";

// src/modules/network/pages/routes/components/table/routes-table-view-table-header-component.tsx
import React147 from "react";
import styled90 from "styled-components";
import { FlexComponent as FlexComponent83, TableCellComponent as TableCellComponent23 } from "@ontruck/fe-ui";
var MAP_LEFT_PANEL_WIDTH2 = 370;
var TABLE_HEADER_MIN_HEIGHT_IN_PIXELS2 = 70;
var TableHeaderCellComponent2 = styled90(TableCellComponent23)`
  height: unset;
  align-items: stretch;
  min-height: ${`${TABLE_HEADER_MIN_HEIGHT_IN_PIXELS2}px`};
`;
var FiltersContainerComponent = styled90(FlexComponent83)`
  padding: calc(var(--otk-theme-space-s, 8px) + 1px) var(--otk-theme-space-s, 8px);
  background-color: white;
  flex: 1;
  height: ${`${TABLE_HEADER_MIN_HEIGHT_IN_PIXELS2}px`};
`;
var HeaderColumnCellTextComponent = styled90.div`
  color: var(--otk-theme-color-grey-500, #94a6b8);
  font-size: 12px;
  font-weight: 400;
  padding: 5px 16px;
  width: 100%;
`;
var HeaderColumnCellTextCenteredComponent = styled90(HeaderColumnCellTextComponent)`
  text-align: center;
`;
var HeaderColumnCellComponent = styled90(TableHeaderCellComponent2)`
  border: transparent;
  align-items: center;
  justify-content: start;
  padding: 0;
  ${HeaderColumnCellTextComponent} {
    border-left: 1px solid white;
  }
  &:last-child {
    ${HeaderColumnCellTextComponent} {
      border-right: 1px solid white;
    }
  }
`;
var SecondRow = styled90(FlexComponent83)`
  background-color: var(--otk-theme-color-grey-100, #f2f5f8);
`;
function RoutesTableViewTableHeaderComponent({
  allRoutesIdentifiers,
  availableProviderNames,
  availableRoutesIdentifiers,
  delegations,
  evaluatorIndicator,
  handleChangeFilterByProviderName,
  handleChangeFilterByRouteType,
  handleChangeFilterByVehicleType,
  onChangeDelegation,
  onChangeEvaluatorIndicator,
  onChangeFilterByOperations,
  onChangeFilterByRoutesIdentifiers,
  selectedDelegationId,
  selectedFilterByOperationsId,
  selectedFilterByProviderName,
  selectedFilterByRouteTypeId,
  selectedFilterByVehicleTypeId,
  selectedFilterByRoutesIdentifiers
}) {
  return /* @__PURE__ */ React147.createElement(
    FlexComponent83,
    {
      alignItems: "stretch",
      borderBottom: "2px solid var(--otk-theme-color-grey-300, #E2E8EE)",
      borderTop: "1px solid var(--otk-theme-color-grey-200, #E2E8EE)",
      flexDirection: "column",
      width: "100%"
    },
    /* @__PURE__ */ React147.createElement(FlexComponent83, { flexDirection: "row" }, /* @__PURE__ */ React147.createElement(FlexComponent83, { width: `${MAP_LEFT_PANEL_WIDTH2}px` }, /* @__PURE__ */ React147.createElement(
      SelectDelegationComponent,
      {
        delegations,
        isRouteCodeDelegationSelected: selectedFilterByRoutesIdentifiers ? selectedFilterByRoutesIdentifiers.length > 0 : void 0,
        onChange: onChangeDelegation,
        selected: selectedDelegationId
      }
    )), /* @__PURE__ */ React147.createElement(FiltersContainerComponent, null, /* @__PURE__ */ React147.createElement(
      FiltersComponent3,
      {
        allRoutesIdentifiers,
        availableProviderNames,
        availableRoutesIdentifiers,
        isDelegationIdSelected: Boolean(selectedDelegationId),
        onChangeOperations: onChangeFilterByOperations,
        onChangeProviderName: handleChangeFilterByProviderName,
        onChangeRouteType: handleChangeFilterByRouteType,
        onChangeRoutesIdentifiers: onChangeFilterByRoutesIdentifiers,
        onChangeVehicleType: handleChangeFilterByVehicleType,
        selectedOperationsId: selectedFilterByOperationsId,
        selectedProviderNameId: selectedFilterByProviderName,
        selectedRouteTypeId: selectedFilterByRouteTypeId,
        selectedRoutesIdentifiers: selectedFilterByRoutesIdentifiers,
        selectedVehicleTypeId: selectedFilterByVehicleTypeId
      }
    ))),
    /* @__PURE__ */ React147.createElement(SecondRow, { flexDirection: "row" }, /* @__PURE__ */ React147.createElement(FlexComponent83, { width: `${MAP_LEFT_PANEL_WIDTH2}px` }, /* @__PURE__ */ React147.createElement(
      TableHeaderCellComponent2,
      {
        background: "var(--otk-theme-color-grey-300, #CCD7E0);",
        borderRight: "1px solid var(--otk-theme-color-grey-300, #CCD7E0)",
        justifyContent: "center",
        padding: "unset",
        width: panelTableWidths.accordionIcon
      }
    ), /* @__PURE__ */ React147.createElement(
      TableHeaderCellComponent2,
      {
        background: "rgba(204, 214, 224, 0.3)",
        borderRight: "1px solid var(--otk-theme-color-grey-200, #E2E8EE)",
        padding: "5px 10px",
        width: panelTableWidths.checkbox
      }
    ), /* @__PURE__ */ React147.createElement(
      TableHeaderCellComponent2,
      {
        background: "var(--otk-theme-color-grey-100, #F2F5F8)",
        borderLeft: "unset",
        borderRight: "unset",
        flex: "1"
      },
      /* @__PURE__ */ React147.createElement(
        SelectIndicatorComponent,
        {
          indicator: evaluatorIndicator,
          onChangeIndicator: onChangeEvaluatorIndicator
        }
      )
    )), /* @__PURE__ */ React147.createElement(FlexComponent83, null, /* @__PURE__ */ React147.createElement(HeaderColumnCellComponent, { width: panelTableWidths.originColumn }, /* @__PURE__ */ React147.createElement(HeaderColumnCellTextComponent, null, "ORIGEN")), /* @__PURE__ */ React147.createElement(HeaderColumnCellComponent, { width: panelTableWidths.destinationColumn }, /* @__PURE__ */ React147.createElement(HeaderColumnCellTextComponent, null, "DESTINO")), /* @__PURE__ */ React147.createElement(HeaderColumnCellComponent, { width: panelTableWidths.providerNameColumn }, /* @__PURE__ */ React147.createElement(HeaderColumnCellTextCenteredComponent, null, "PROVEEDOR")), /* @__PURE__ */ React147.createElement(HeaderColumnCellComponent, { width: panelTableWidths.vehicleTypeColumn }, /* @__PURE__ */ React147.createElement(HeaderColumnCellTextCenteredComponent, null, "VEH\xCDCULO"))))
  );
}

// src/modules/network/pages/routes/components/table/routes-table-view-table-body-component.tsx
import React150, { useMemo as useMemo40 } from "react";
import { TableComponent as TableComponent9 } from "@ontruck/fe-ui";

// src/modules/network/pages/routes/components/table/routes-table-view-route-row-component.tsx
import React149 from "react";
import styled92 from "styled-components";
import { AccordionComponent as AccordionComponent4, AccordionTriggerComponent as AccordionTriggerComponent3 } from "@ontruck/fe-ui";

// src/modules/network/pages/routes/components/table/routes-table-view-route-row-parent-component.tsx
import React148 from "react";
import styled91 from "styled-components";
import { FlexComponent as FlexComponent84, TableCellComponent as TableCellComponent24 } from "@ontruck/fe-ui";
import { IconComponent as IconComponent24, VehicleTypeVanIcon } from "@ontruck/fe-icons";
var MAP_LEFT_PANEL_WIDTH3 = 370;
var ROUTE_ROW_PARENT_MIN_HEIGHT_IN_PIXELS2 = 70;
var RouteRowParentWrapper = styled91(FlexComponent84)`
  background: var(--otk-theme-color-grey-100, #e2e8ee);
  height: ${`${ROUTE_ROW_PARENT_MIN_HEIGHT_IN_PIXELS2}px`};

  :first-child {
    border-top: none;
  }
`;
var BodyColumnsWrapperComponent = styled91(FlexComponent84)`
  flex: 1;
  background: ${({ isEditedDraft }) => isEditedDraft ? `repeating-conic-gradient(
              var(--otk-theme-color-grey-100, #e2e8ee) 0% 25%,
              var(--otk-theme-color-grey-200, #f2f5f8) 0% 50%
            ) 0 0 / 20px 20px;` : "var(--otk-theme-color-white, #FFF);"};
`;
var BodyColumnCellContentComponent = styled91.div`
  flex-direction: column;
  align-items: center;
  flex: 1;
  width: 100%;
  padding: 5px 16px;
  display: flex;
  justify-content: start;
`;
var BodyColumnCellBorderComponent = styled91.div`
  border-right: 1px solid var(--otk-theme-color-grey-200, #e2e8ee);
  height: 40px;
`;
var BodyColumnCellContentCenteredComponent = styled91(BodyColumnCellContentComponent)`
  justify-content: center;
`;
var BodyColumnDelegationTextComponent = styled91.div`
  color: var(--otk-theme-color-grey-700, #54708c);
  font-size: 14px;
  font-weight: 500;
  width: 100%;
  text-transform: uppercase;
`;
var BodyColumnTimeTextComponent = styled91.div`
  color: var(--otk-theme-color-grey-500, #ccd7e0);
  font-size: 12px;
  font-weight: 500;
  width: 100%;
`;
var BodyColumnProviderTextComponent = styled91.div`
  color: var(--otk-theme-color-grey-700, #54708c);
  font-size: 12px;
  font-weight: 400;
  width: auto;
  text-align: center;
`;
var BodyColumnVehicleIconWrapperComponent = styled91.div`
  width: auto;
`;
var TableBodyColumnCellComponent = styled91(TableHeaderCellComponent2)``;
var BodyColumnCellComponent = styled91(TableBodyColumnCellComponent)`
  border: transparent;
  align-items: center;
  justify-content: start;
  padding: 0;
`;
function RoutesTableViewRouteRowParentComponent({
  isDraft = false,
  isExpanded = false,
  onExpand,
  route,
  evaluatorIndicator = selectIndicatorOptionsValues.none
}) {
  const handleToggleExpanded = () => {
    if (!onExpand) {
      return;
    }
    onExpand(route.id);
  };
  return /* @__PURE__ */ React148.createElement(RouteRowParentWrapper, { alignItems: "center", justifyContent: "stretch" }, /* @__PURE__ */ React148.createElement(FlexComponent84, { height: "100%", width: `${MAP_LEFT_PANEL_WIDTH3}px` }, /* @__PURE__ */ React148.createElement(
    TableCellComponent24,
    {
      alignItems: "center",
      background: "var(--otk-theme-color-grey-300, #E2E8EE);",
      borderRight: "var(--otk-theme-color-grey-300, #CCD7E0);",
      justifyContent: "center",
      onClick: handleToggleExpanded,
      padding: "unset",
      width: panelTableWidths.accordionIcon
    }
  ), /* @__PURE__ */ React148.createElement(
    TableCellComponent24,
    {
      background: (() => {
        if (route.isEditedDraft) {
          return `repeating-conic-gradient(
              var(--otk-theme-color-grey-100, #e2e8ee) 0% 25%,
              var(--otk-theme-color-grey-200, #f2f5f8) 0% 50%
            ) 0 0 / 20px 20px;`;
        }
        if (isExpanded) {
          return "var(--otk-theme-color-grey-200, #e2e8ee);";
        }
        return "var(--otk-theme-color-grey-100, #f2f5f8);";
      })(),
      borderRight: "var(--otk-theme-color-grey-500, #CCD7E0);",
      padding: "5px 10px",
      width: panelTableWidths.checkbox
    }
  ), /* @__PURE__ */ React148.createElement(
    PanelTableRowDescriptionCellComponent,
    {
      indicator: evaluatorIndicator,
      isDraft,
      isEditedDraft: route.isEditedDraft,
      isExpanded,
      onExpand,
      panelTableRowParent: route
    }
  )), /* @__PURE__ */ React148.createElement(BodyColumnsWrapperComponent, { isEditedDraft: route.isEditedDraft }, /* @__PURE__ */ React148.createElement(FlexComponent84, null, /* @__PURE__ */ React148.createElement(BodyColumnCellComponent, { width: panelTableWidths.originColumn }, /* @__PURE__ */ React148.createElement(BodyColumnCellBorderComponent, null), /* @__PURE__ */ React148.createElement(BodyColumnCellContentComponent, null, /* @__PURE__ */ React148.createElement(BodyColumnDelegationTextComponent, null, route.origin, " "), /* @__PURE__ */ React148.createElement(BodyColumnTimeTextComponent, null, route.originTime)), /* @__PURE__ */ React148.createElement(BodyColumnCellBorderComponent, null)), /* @__PURE__ */ React148.createElement(BodyColumnCellComponent, { width: panelTableWidths.destinationColumn }, /* @__PURE__ */ React148.createElement(BodyColumnCellContentComponent, null, /* @__PURE__ */ React148.createElement(BodyColumnDelegationTextComponent, null, route.destination), /* @__PURE__ */ React148.createElement(BodyColumnTimeTextComponent, null, route.destinationTime)), /* @__PURE__ */ React148.createElement(BodyColumnCellBorderComponent, null)), /* @__PURE__ */ React148.createElement(BodyColumnCellComponent, { width: panelTableWidths.providerNameColumn }, /* @__PURE__ */ React148.createElement(BodyColumnCellContentCenteredComponent, null, /* @__PURE__ */ React148.createElement(BodyColumnProviderTextComponent, null, route.providerName)), /* @__PURE__ */ React148.createElement(BodyColumnCellBorderComponent, null)), /* @__PURE__ */ React148.createElement(BodyColumnCellComponent, { width: panelTableWidths.vehicleTypeColumn }, /* @__PURE__ */ React148.createElement(BodyColumnCellContentCenteredComponent, null, /* @__PURE__ */ React148.createElement(BodyColumnVehicleIconWrapperComponent, null, route.vehicleType === routeVehicleTypes.trailer ? /* @__PURE__ */ React148.createElement(IconComponent24, { color: "#94A6B8", name: "trailer" }) : null, route.vehicleType === routeVehicleTypes.van ? /* @__PURE__ */ React148.createElement(VehicleTypeVanIcon, null) : null)), /* @__PURE__ */ React148.createElement(BodyColumnCellBorderComponent, null)))));
}

// src/modules/network/pages/routes/components/table/routes-table-view-route-row-component.tsx
var RouteRowWrapperComponent = styled92.div`
  header {
    display: flex;
    padding: unset;
    border-top: none;
    border-bottom: none;

    > div {
      flex: 1;
    }

    :hover {
      cursor: default;
    }
  }
`;
var RouteRowTriggerComponent = styled92(AccordionTriggerComponent3)`
  padding: unset;
  border-top: ${({ index }) => index !== 0 ? "3px solid var(--otk-theme-color-grey-200, #ccd7e0)" : "none"};
  border-bottom: none;
`;
var RouteRowAccordionComponent = styled92(AccordionComponent4)`
  height: auto;
  border-left: none;
  border-right: none;
`;
function RoutesTableViewRouteRowComponent({
  onToggleSelection,
  // TODO: remove this once expanded content is defined
  // eslint-disable-next-line @typescript-eslint/no-unused-vars -- remove this once expanded content is defined
  onToggleExpanded,
  isDraft = false,
  isExpanded = false,
  isSelected = false,
  index,
  row,
  evaluatorIndicator
}) {
  return /* @__PURE__ */ React149.createElement(RouteRowWrapperComponent, null, /* @__PURE__ */ React149.createElement(RouteRowAccordionComponent, null, /* @__PURE__ */ React149.createElement(RouteRowTriggerComponent, { index, open: isExpanded }, /* @__PURE__ */ React149.createElement(
    RoutesTableViewRouteRowParentComponent,
    {
      evaluatorIndicator,
      isDraft,
      isExpanded,
      isSelected,
      onSelect: onToggleSelection,
      route: row.parent
    }
  ))));
}

// src/modules/network/pages/routes/components/table/routes-table-view-table-body-component.tsx
function RoutesTableViewTableBodyComponent({
  selectedRoutes = /* @__PURE__ */ new Set(),
  expandedRoutes = /* @__PURE__ */ new Set(),
  onToggleRouteExpanded,
  onToggleRouteSelection,
  rows,
  evaluatorIndicator
}) {
  const delegationRoutesMock = useMemo40(() => {
    return rows.map((r, i) => {
      return /* @__PURE__ */ React150.createElement(
        RoutesTableViewRouteRowComponent,
        {
          evaluatorIndicator,
          index: i,
          isDraft: r.parent.isDraft,
          isExpanded: expandedRoutes.has(r.parent.id),
          isSelected: selectedRoutes.has(r.parent.id),
          key: `routes-table-row-${r.id}`,
          onToggleExpanded: onToggleRouteExpanded,
          onToggleSelection: onToggleRouteSelection,
          row: r
        }
      );
    });
  }, [
    selectedRoutes,
    expandedRoutes,
    onToggleRouteExpanded,
    onToggleRouteSelection,
    rows,
    evaluatorIndicator
  ]);
  return /* @__PURE__ */ React150.createElement(
    TableComponent9,
    {
      emptyStateMessage: "No se han encontrado rutas",
      numberOfItems: delegationRoutesMock.length,
      rowsComponents: delegationRoutesMock
    }
  );
}

// src/modules/network/pages/routes/components/table/routes-table-view-table-component.tsx
function RoutesTableViewTableComponent({
  routes,
  selectedRoutesIds,
  evaluatorIndicator,
  onChangeRoutesSelection,
  onChangeEvaluatorIndicator,
  onChangeFilterByRoutesIdentifiers,
  availableProviderNames,
  handleChangeFilterByProviderName,
  handleChangeFilterByRouteType,
  handleChangeFilterByVehicleType,
  onChangeFilterByOperations,
  selectedFilterByProviderName,
  selectedFilterByRouteTypeId,
  selectedFilterByVehicleTypeId,
  selectedFilterByOperationsId,
  selectedFilterByRoutesIdentifiers,
  delegations,
  onChangeDelegation,
  selectedDelegationId,
  allRoutesIdentifiers,
  availableRoutesIdentifiers
}) {
  const [expandedRoutesIds, setExpandedRoutesIds] = useState42(/* @__PURE__ */ new Set());
  const initialSelectionMade = useRef3(false);
  const prevRoutesRef = useRef3();
  const prevRoutesIdsRef = useRef3(/* @__PURE__ */ new Set());
  const routesIds = useMemo41(
    () => routes ? /* @__PURE__ */ new Set([...routes.map((r) => r.id)]) : /* @__PURE__ */ new Set(),
    [routes]
  );
  const routesRows = useMemo41(
    () => routes && routes.length > 0 ? getPanelTableRowsMapperService(routes) : [],
    [routes]
  );
  const handleToggleSelectAllRoutes = useCallback20(
    (toggleSelectAll) => {
      if (toggleSelectAll) {
        if (onChangeRoutesSelection) {
          onChangeRoutesSelection(routesIds);
        }
      } else if (onChangeRoutesSelection) {
        onChangeRoutesSelection(/* @__PURE__ */ new Set([]));
      }
    },
    [routesIds, onChangeRoutesSelection]
  );
  const handleToggleRouteSelection = useCallback20(
    (routeId) => {
      const routeIsSelected = selectedRoutesIds.has(routeId);
      const updatedSelectedRoutesIds = /* @__PURE__ */ new Set([...selectedRoutesIds]);
      if (!routeIsSelected) {
        updatedSelectedRoutesIds.add(routeId);
      } else {
        updatedSelectedRoutesIds.delete(routeId);
      }
      if (onChangeRoutesSelection) {
        onChangeRoutesSelection(updatedSelectedRoutesIds);
      }
    },
    [selectedRoutesIds, onChangeRoutesSelection]
  );
  const handleToggleRouteExpanded = useCallback20(
    (routeId) => {
      const routeIsExpanded = expandedRoutesIds.has(routeId);
      if (!routeIsExpanded) {
        expandedRoutesIds.add(routeId);
        setExpandedRoutesIds(new Set(expandedRoutesIds));
      }
      if (routeIsExpanded) {
        expandedRoutesIds.delete(routeId);
        setExpandedRoutesIds(new Set(expandedRoutesIds));
      }
    },
    [expandedRoutesIds]
  );
  useEffect18(() => {
    if (!routes || routes.length === 0) {
      prevRoutesRef.current = routes;
      prevRoutesIdsRef.current = /* @__PURE__ */ new Set();
      return;
    }
    const currentRoutesIds = new Set(routes.map((r) => r.id));
    const prevRoutesIds = prevRoutesIdsRef.current;
    const routesWereAddedOrRemoved = currentRoutesIds.size !== prevRoutesIds.size || Array.from(currentRoutesIds).some((id) => !prevRoutesIds.has(id)) || Array.from(prevRoutesIds).some((id) => !currentRoutesIds.has(id));
    if (routesWereAddedOrRemoved) {
      initialSelectionMade.current = false;
      handleToggleSelectAllRoutes(true);
    } else if (onChangeRoutesSelection && selectedRoutesIds.size > 0) {
      const preservedSelection = new Set(
        Array.from(selectedRoutesIds).filter((id) => currentRoutesIds.has(id))
      );
      if (preservedSelection.size !== selectedRoutesIds.size) {
        onChangeRoutesSelection(preservedSelection);
      }
    }
    prevRoutesRef.current = routes;
    prevRoutesIdsRef.current = currentRoutesIds;
  }, [routes, handleToggleSelectAllRoutes, onChangeRoutesSelection, selectedRoutesIds]);
  return /* @__PURE__ */ React151.createElement(FlexComponent85, { flex: "1", flexDirection: "column", overflow: "hidden", width: "100%" }, /* @__PURE__ */ React151.createElement(
    RoutesTableViewTableHeaderComponent,
    {
      allRoutesIdentifiers,
      availableProviderNames,
      availableRoutesIdentifiers,
      delegations,
      evaluatorIndicator,
      handleChangeFilterByProviderName,
      handleChangeFilterByRouteType,
      handleChangeFilterByVehicleType,
      onChangeDelegation,
      onChangeEvaluatorIndicator,
      onChangeFilterByOperations,
      onChangeFilterByRoutesIdentifiers,
      selectedDelegationId,
      selectedFilterByOperationsId,
      selectedFilterByProviderName,
      selectedFilterByRouteTypeId,
      selectedFilterByRoutesIdentifiers,
      selectedFilterByVehicleTypeId
    }
  ), /* @__PURE__ */ React151.createElement(
    RoutesTableViewTableBodyComponent,
    {
      evaluatorIndicator,
      expandedRoutes: expandedRoutesIds,
      onToggleRouteExpanded: handleToggleRouteExpanded,
      onToggleRouteSelection: handleToggleRouteSelection,
      rows: routesRows,
      selectedRoutes: selectedRoutesIds
    }
  ));
}

// src/modules/network/pages/routes/views/routes-table-view-component.tsx
function RoutesTableViewComponent({
  allRoutesIdentifiers,
  availableRoutesIdentifiers,
  tableDelegations,
  selectedRoutesEvaluatorIndicatorValue,
  handleChangeDelegation,
  handleChangeRoutesEvaluatorIndicator,
  handleChangeRoutesSelection,
  filteredTableRoutes,
  selectedDelegationId,
  selectedRoutesIds,
  availableProviderNames,
  handleChangeFilterByProviderName,
  handleChangeFilterByRouteType,
  handleChangeFilterByVehicleType,
  onChangeFilterByOperations,
  onChangeFilterByRoutesIdentifiers,
  selectedFilterByProviderName,
  selectedFilterByRouteTypeId,
  selectedFilterByVehicleTypeId,
  selectedFilterByOperationsId,
  selectedFilterByRoutesIdentifiers,
  isRouteCodeDelegationSelected,
  isLoading
}) {
  return /* @__PURE__ */ React152.createElement(FlexComponent86, { alignItems: "stretch", height: "100%", justifyContent: "stretch", width: "100%" }, isLoading ? /* @__PURE__ */ React152.createElement(SpinnerComponent, { timeInMilliseconds: 1500 }) : null, !isLoading ? /* @__PURE__ */ React152.createElement(
    RoutesTableViewTableComponent,
    {
      allRoutesIdentifiers,
      availableProviderNames,
      availableRoutesIdentifiers,
      delegations: tableDelegations,
      evaluatorIndicator: selectedRoutesEvaluatorIndicatorValue,
      handleChangeFilterByProviderName,
      handleChangeFilterByRouteType,
      handleChangeFilterByVehicleType,
      isRouteCodeDelegationSelected,
      onChangeDelegation: handleChangeDelegation,
      onChangeEvaluatorIndicator: handleChangeRoutesEvaluatorIndicator,
      onChangeFilterByOperations,
      onChangeFilterByRoutesIdentifiers,
      onChangeRoutesSelection: handleChangeRoutesSelection,
      routes: filteredTableRoutes,
      selectedDelegationId,
      selectedFilterByOperationsId,
      selectedFilterByProviderName,
      selectedFilterByRouteTypeId,
      selectedFilterByRoutesIdentifiers,
      selectedFilterByVehicleTypeId,
      selectedRoutesIds
    }
  ) : null);
}

// src/modules/network/pages/routes/views/routes-timeline-view-component.tsx
import React161, { useMemo as useMemo48 } from "react";
import styled104 from "styled-components";

// src/modules/network/pages/routes/components/timeline/timeline-constants.ts
var CONTAINER_RIGHT_PADDING = 50;
var LEFT_PANEL_WIDTH = 370;
var CELL_WIDTH = 120;
var NUMBER_OF_TIME_SLOTS = 24;
var TIMELINE_START_HOUR = 10;
var HEADER_HEIGHT = 70;
var ROW_HEIGHT = 70;
var ROUTE_LINE_HEIGHT = 10;
var ROUTE_STOP_HEIGHT = 30;
var ROUTE_STOP_MIN_WIDTH = 20;
var STOP_ROW_HEIGHT = 45;

// src/modules/network/pages/routes/components/timeline/timeline-header-component.tsx
import React153, { useMemo as useMemo42 } from "react";
import { FlexComponent as FlexComponent87 } from "@ontruck/fe-ui";
import styled94 from "styled-components";

// src/modules/network/pages/routes/components/timeline/normalize-time-to-timeline-helper.ts
var normalizeTimeToTimelineHelper = (hours, minutes = 0) => {
  let timeInDecimal = hours + minutes / 60;
  if (timeInDecimal < TIMELINE_START_HOUR) {
    timeInDecimal += 24;
  }
  return timeInDecimal - TIMELINE_START_HOUR;
};

// src/modules/network/pages/routes/components/timeline/get-max-hour-needed-helper.ts
var getMaxHourNeededHelper = (routes) => {
  let maxTimelinePosition = TIMELINE_START_HOUR + 24;
  routes.forEach((route) => {
    if (route.parent.originTime && route.parent.destinationTime) {
      const [originHours, originMinutes] = route.parent.originTime.split(":").map(Number);
      const [destHours, destMinutes] = route.parent.destinationTime.split(":").map(Number);
      const originPosition = normalizeTimeToTimelineHelper(originHours, originMinutes);
      let destPosition = normalizeTimeToTimelineHelper(destHours, destMinutes);
      if (destPosition < originPosition) {
        destPosition += 24;
      }
      maxTimelinePosition = Math.max(maxTimelinePosition, destPosition + TIMELINE_START_HOUR);
    }
    let previousPosition = route.parent.originTime ? normalizeTimeToTimelineHelper(
      ...route.parent.originTime.split(":").map(Number)
    ) : 0;
    route.children.forEach((stop) => {
      const arrivalTime = stop.actualArrivalTime || stop.theoreticalArrivalTime;
      const departureTime = stop.actualDepartureTime || stop.theoreticalDepartureTime;
      if (arrivalTime) {
        const [hours, minutes] = arrivalTime.split(":").map(Number);
        let position = normalizeTimeToTimelineHelper(hours, minutes);
        if (position < previousPosition && previousPosition - position > 6) {
          position += 24;
        }
        maxTimelinePosition = Math.max(maxTimelinePosition, position + TIMELINE_START_HOUR);
        previousPosition = position;
      }
      if (departureTime) {
        const [hours, minutes] = departureTime.split(":").map(Number);
        let position = normalizeTimeToTimelineHelper(hours, minutes);
        if (position < previousPosition && previousPosition - position > 6) {
          position += 24;
        }
        maxTimelinePosition = Math.max(maxTimelinePosition, position + TIMELINE_START_HOUR);
        previousPosition = position;
      }
    });
  });
  return Math.ceil(maxTimelinePosition);
};

// src/modules/network/pages/routes/components/timeline/format-hour-label-helper.ts
var formatHourLabelHelper = (timeIndex) => {
  const actualHour = (timeIndex + TIMELINE_START_HOUR) % 24;
  return `${actualHour}:00`;
};

// src/modules/network/pages/routes/components/timeline/timeline-header-cell-component.tsx
import styled93 from "styled-components";
var TimelineHeaderCellComponent = styled93.div`
  width: ${CELL_WIDTH}px;
  min-width: ${CELL_WIDTH}px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right: 1px solid var(--otk-theme-color-grey-200, #e2e8ee);
  background-color: var(--otk-theme-color-grey-100, #f2f5f8);
  &:first-of-type {
    border-left: 1px solid var(--otk-theme-color-grey-200, #e2e8ee);
  }
`;

// src/modules/network/pages/routes/components/timeline/get-highest-alert-level-helper.ts
function getAlertLevelPriorityHelper(level) {
  switch (level) {
    case alertsLevels.high:
      return 3;
    case alertsLevels.medium:
      return 2;
    case alertsLevels.low:
      return 1;
    default:
      return 0;
  }
}
function getHighestAlertLevelHelper(levels) {
  if (levels.length === 0) {
    return void 0;
  }
  return [...levels].sort(
    (a, b) => getAlertLevelPriorityHelper(b) - getAlertLevelPriorityHelper(a)
  )[0];
}

// src/modules/network/pages/routes/components/timeline/get-indicator-alerts-at-timeline-hour-helper.ts
function timeMatchesHour(time, actualHour) {
  const [hour] = time.split(":").map(Number);
  return hour === actualHour;
}
function stopTimesMatchHour(times, actualHour) {
  return times.some((time) => time && timeMatchesHour(time, actualHour));
}
function getHighDensityAlertsAtTimelineHourHelper(routesRows, actualHour) {
  return routesRows.flatMap(
    (route) => route.children.filter((child) => child.hightDensityAlerts && child.hightDensityAlerts.length > 0).filter((child) => {
      const arrivalTime = child.actualArrivalTime || child.theoreticalArrivalTime;
      const departureTime = child.actualDepartureTime || child.theoreticalDepartureTime;
      return stopTimesMatchHour([arrivalTime, departureTime], actualHour);
    }).flatMap((child) => child.hightDensityAlerts || [])
  );
}
function getLatenessAlertsAtTimelineHourHelper(routesRows, actualHour) {
  return routesRows.flatMap(
    (route) => route.children.filter((child) => child.latenessAlerts && child.latenessAlerts.length > 0).filter((child) => {
      var _a, _b;
      const latenessArrivalAlert = (_a = child.latenessAlerts) == null ? void 0 : _a.find(
        (alert) => alert.phase === alertsPhases.arrival
      );
      const latenessDepartureAlert = (_b = child.latenessAlerts) == null ? void 0 : _b.find(
        (alert) => alert.phase === alertsPhases.departure
      );
      const timesToCheck = [];
      if (latenessArrivalAlert && latenessArrivalAlert.level !== alertsLevels.info) {
        timesToCheck.push(child.theoreticalArrivalTime, child.actualArrivalTime);
      }
      if (latenessDepartureAlert && latenessDepartureAlert.level !== alertsLevels.info) {
        timesToCheck.push(child.theoreticalDepartureTime, child.actualDepartureTime);
      }
      return stopTimesMatchHour(timesToCheck, actualHour);
    }).flatMap((child) => child.latenessAlerts || [])
  );
}

// src/modules/network/pages/routes/components/timeline/timeline-header-component.tsx
var TimelineHeaderWrapper = styled94.div`
  display: flex;
  flex-direction: column;
  position: sticky;
  top: 0;
  z-index: 1000;
  height: auto;
  border-top: 1px solid var(--otk-theme-color-grey-200, #e2e8ee);
  border-bottom: 2px solid var(--otk-theme-color-grey-300, #e2e8ee);
`;
var FirstTimelineHeader = styled94(FlexComponent87)`
  height: ${HEADER_HEIGHT}px;
  display: flex;
  z-index: 99999;
`;
var SecondTimelineHeader = styled94(FlexComponent87)`
  background-color: var(--otk-theme-color-grey-100, #f2f5f8);
  height: ${HEADER_HEIGHT}px;
  display: flex;
`;
var TimelineHeaderLeftCell = styled94.div`
  width: ${LEFT_PANEL_WIDTH}px;
  height: ${HEADER_HEIGHT}px;
  flex-shrink: 0;
  position: sticky;
  left: 0;
  display: flex;
  align-items: center;
  z-index: 1500;
  background-color: var(--otk-theme-color-grey-100, #f2f5f8);
`;
var FiltersContainerComponent2 = styled94(FlexComponent87)`
  padding: calc(var(--otk-theme-space-s, 8px) + 1px) var(--otk-theme-space-s, 8px);
  background-color: white;
  flex: 1;
  height: ${`${HEADER_HEIGHT}px`};
  width: 100%;
  position: fixed;
  left: calc(${MAP_LEFT_PANEL_WIDTH}px + ${LEFT_SIDEBAR_NAVIGATION_WIDTH}px);
`;
function TimelineHeaderComponent({
  tableDelegations,
  selectedRoutesEvaluatorIndicatorValue,
  handleChangeDelegation,
  handleChangeRoutesEvaluatorIndicator,
  filteredTableRoutes,
  selectedDelegationId,
  availableProviderNames,
  handleChangeFilterByProviderName,
  handleChangeFilterByRouteType,
  handleChangeFilterByVehicleType,
  onChangeFilterByOperations,
  onChangeFilterByRoutesIdentifiers,
  selectedFilterByProviderName,
  selectedFilterByRouteTypeId,
  selectedFilterByVehicleTypeId,
  selectedFilterByOperationsId,
  selectedFilterByRoutesIdentifiers,
  allRoutesIdentifiers,
  availableRoutesIdentifiers
}) {
  const routesRows = useMemo42(
    () => filteredTableRoutes.length > 0 ? getPanelTableRowsMapperService(filteredTableRoutes) : [],
    [filteredTableRoutes]
  );
  const numberOfTimeSlots = useMemo42(() => {
    if (routesRows.length === 0)
      return NUMBER_OF_TIME_SLOTS;
    const maxHour = getMaxHourNeededHelper(routesRows);
    return Math.max(NUMBER_OF_TIME_SLOTS, maxHour - TIMELINE_START_HOUR + 1);
  }, [routesRows]);
  const timeSlots = useMemo42(() => {
    return Array.from({ length: numberOfTimeSlots }).map((_, index) => index);
  }, [numberOfTimeSlots]);
  const timeSlotHeaders = useMemo42(() => {
    return timeSlots.map((timeIndex) => {
      const actualHour = (timeIndex + TIMELINE_START_HOUR) % 24;
      const indicatorAlertsAtThisPosition = selectedRoutesEvaluatorIndicatorValue === selectIndicatorOptionsValues.hightDensity ? getHighDensityAlertsAtTimelineHourHelper(routesRows, actualHour) : selectedRoutesEvaluatorIndicatorValue === selectIndicatorOptionsValues.lateness ? getLatenessAlertsAtTimelineHourHelper(routesRows, actualHour) : [];
      const highestAlertLevel = getHighestAlertLevelHelper(
        indicatorAlertsAtThisPosition.map((alert) => alert.level)
      );
      const borderColor = highestAlertLevel ? alertLevelColors[highestAlertLevel] : "transparent";
      const isDayBoundary = actualHour === TIMELINE_START_HOUR && timeIndex > 0;
      const isNextDaySlot = timeIndex >= 24;
      return /* @__PURE__ */ React153.createElement(
        TimelineHeaderCellComponent,
        {
          key: `time-${timeIndex}`,
          style: {
            backgroundColor: isNextDaySlot ? "var(--otk-theme-color-grey-200, #E2E8EE)" : "var(--otk-theme-color-grey-100, #F2F5F8)",
            borderLeft: isDayBoundary ? "2px solid var(--otk-theme-color-warning-500, #FFCC00)" : void 0,
            borderBottom: indicatorAlertsAtThisPosition.length > 0 ? `3px solid ${borderColor}` : "3px solid transparent"
          }
        },
        formatHourLabelHelper(timeIndex)
      );
    });
  }, [timeSlots, routesRows, selectedRoutesEvaluatorIndicatorValue]);
  return /* @__PURE__ */ React153.createElement(TimelineHeaderWrapper, null, /* @__PURE__ */ React153.createElement(FirstTimelineHeader, null, /* @__PURE__ */ React153.createElement(TimelineHeaderLeftCell, null, /* @__PURE__ */ React153.createElement(FlexComponent87, { width: `${MAP_LEFT_PANEL_WIDTH}px` }, /* @__PURE__ */ React153.createElement(
    SelectDelegationComponent,
    {
      delegations: tableDelegations,
      isRouteCodeDelegationSelected: selectedFilterByRoutesIdentifiers ? selectedFilterByRoutesIdentifiers.length > 0 : void 0,
      onChange: handleChangeDelegation,
      selected: selectedDelegationId
    }
  ))), /* @__PURE__ */ React153.createElement(FiltersContainerComponent2, null, /* @__PURE__ */ React153.createElement(
    FiltersComponent3,
    {
      allRoutesIdentifiers,
      availableProviderNames,
      availableRoutesIdentifiers,
      isDelegationIdSelected: Boolean(selectedDelegationId),
      onChangeOperations: onChangeFilterByOperations,
      onChangeProviderName: handleChangeFilterByProviderName,
      onChangeRouteType: handleChangeFilterByRouteType,
      onChangeRoutesIdentifiers: onChangeFilterByRoutesIdentifiers,
      onChangeVehicleType: handleChangeFilterByVehicleType,
      selectedOperationsId: selectedFilterByOperationsId,
      selectedProviderNameId: selectedFilterByProviderName,
      selectedRouteTypeId: selectedFilterByRouteTypeId,
      selectedRoutesIdentifiers: selectedFilterByRoutesIdentifiers,
      selectedVehicleTypeId: selectedFilterByVehicleTypeId
    }
  ))), /* @__PURE__ */ React153.createElement(SecondTimelineHeader, null, /* @__PURE__ */ React153.createElement(TimelineHeaderLeftCell, null, /* @__PURE__ */ React153.createElement(
    TableHeaderCellComponent,
    {
      background: "var(--otk-theme-color-grey-300, #CCD7E0);",
      borderRight: "1px solid var(--otk-theme-color-grey-300, #CCD7E0)",
      justifyContent: "center",
      padding: "unset",
      width: panelTableWidths.accordionIcon
    }
  ), /* @__PURE__ */ React153.createElement(
    TableHeaderCellComponent,
    {
      background: "rgba(204, 214, 224, 0.3)",
      borderRight: "1px solid var(--otk-theme-color-grey-200, #E2E8EE)",
      padding: "5px 10px",
      width: panelTableWidths.checkbox
    }
  ), /* @__PURE__ */ React153.createElement(
    TableHeaderCellComponent,
    {
      background: "var(--otk-theme-color-grey-100, #F2F5F8)",
      borderLeft: "unset",
      borderRight: "2px solid var(--otk-theme-color-grey-200, #E2E8EE)",
      flex: "1"
    },
    /* @__PURE__ */ React153.createElement(
      SelectIndicatorComponent,
      {
        indicator: selectedRoutesEvaluatorIndicatorValue,
        onChangeIndicator: handleChangeRoutesEvaluatorIndicator
      }
    )
  )), timeSlotHeaders));
}

// src/modules/network/pages/routes/components/timeline/timeline-body-component.tsx
import React160, { useMemo as useMemo47 } from "react";
import {
  AccordionComponent as AccordionComponent5,
  AccordionIconComponent as AccordionIconComponent3,
  AccordionTriggerComponent as AccordionTriggerComponent4,
  TableCellComponent as TableCellComponent25
} from "@ontruck/fe-ui";
import styled103 from "styled-components";

// src/modules/network/pages/routes/components/timeline/timeline-route-line-component.tsx
import React154, { useMemo as useMemo43, memo } from "react";
import styled95 from "styled-components";
var TimeLineRouteLineWrapper = styled95.div`
  position: absolute;
  left: ${({ left }) => left};
  width: ${({ width }) => width};
  height: ${ROUTE_LINE_HEIGHT}px;
  background-color: rgba(148, 166, 184, 30%);
  border-radius: 4px;
  z-index: 2;
  top: calc(50% - ${ROUTE_LINE_HEIGHT / 2}px);
`;
var getRouteLinePosition = (originTime, routeChildren) => {
  if (typeof originTime === "string" && originTime.includes(":")) {
    const [hours, minutes] = originTime.split(":").map(Number);
    const normalizedTime = normalizeTimeToTimelineHelper(hours, minutes);
    return `${normalizedTime * CELL_WIDTH}px`;
  }
  const firstStopWithArrival = routeChildren.find(
    (stop) => stop.actualArrivalTime || stop.theoreticalArrivalTime
  );
  const arrivalTime = (firstStopWithArrival == null ? void 0 : firstStopWithArrival.actualArrivalTime) || (firstStopWithArrival == null ? void 0 : firstStopWithArrival.theoreticalArrivalTime);
  if (arrivalTime) {
    const [hours, minutes] = arrivalTime.split(":").map(Number);
    const normalizedTime = normalizeTimeToTimelineHelper(hours, minutes);
    return `${normalizedTime * CELL_WIDTH}px`;
  }
  const firstStopWithDeparture = routeChildren.find(
    (stop) => stop.actualDepartureTime || stop.theoreticalDepartureTime
  );
  const departureTime = (firstStopWithDeparture == null ? void 0 : firstStopWithDeparture.actualDepartureTime) || (firstStopWithDeparture == null ? void 0 : firstStopWithDeparture.theoreticalDepartureTime);
  if (departureTime) {
    const [hours, minutes] = departureTime.split(":").map(Number);
    const normalizedTime = normalizeTimeToTimelineHelper(hours, minutes);
    return `${normalizedTime * CELL_WIDTH}px`;
  }
  return "0px";
};
var getRouteLineWidth = (originTime, destinationTime, routeChildren) => {
  if (typeof originTime === "string" && typeof destinationTime === "string" && originTime.includes(":") && destinationTime.includes(":")) {
    const [originHours, originMinutes] = originTime.split(":").map(Number);
    const [destHours, destMinutes] = destinationTime.split(":").map(Number);
    const originTimeNormalized = normalizeTimeToTimelineHelper(originHours, originMinutes);
    let destTimeNormalized = normalizeTimeToTimelineHelper(destHours, destMinutes);
    if (destTimeNormalized < originTimeNormalized) {
      destTimeNormalized += 24;
    }
    return `${Math.max(destTimeNormalized - originTimeNormalized, 0.5) * CELL_WIDTH}px`;
  }
  let earliestTime = null;
  let latestTime = null;
  for (const stop of routeChildren) {
    const arrivalTime = stop.actualArrivalTime || stop.theoreticalArrivalTime;
    if (arrivalTime) {
      const [hours, minutes] = arrivalTime.split(":").map(Number);
      const normalizedTime = normalizeTimeToTimelineHelper(hours, minutes);
      if (earliestTime === null || normalizedTime < earliestTime) {
        earliestTime = normalizedTime;
      }
      if (latestTime === null || normalizedTime > latestTime) {
        latestTime = normalizedTime;
      }
    }
    const departureTime = stop.actualDepartureTime || stop.theoreticalDepartureTime;
    if (departureTime) {
      const [hours, minutes] = departureTime.split(":").map(Number);
      const normalizedTime = normalizeTimeToTimelineHelper(hours, minutes);
      if (earliestTime === null || normalizedTime < earliestTime) {
        earliestTime = normalizedTime;
      }
      if (latestTime === null || normalizedTime > latestTime) {
        latestTime = normalizedTime;
      }
    }
  }
  if (earliestTime !== null && latestTime !== null) {
    return `${Math.max(latestTime - earliestTime, 0.5) * CELL_WIDTH}px`;
  }
  return `${CELL_WIDTH}px`;
};
var TimelineRouteLineComponent = memo(function TimelineRouteLineComponent2({
  routeParent,
  routeChildren
}) {
  const position = useMemo43(
    () => getRouteLinePosition(routeParent.originTime, routeChildren),
    [routeParent.originTime, routeChildren]
  );
  const width = useMemo43(
    () => getRouteLineWidth(routeParent.originTime, routeParent.destinationTime, routeChildren),
    [routeParent.originTime, routeParent.destinationTime, routeChildren]
  );
  const hasAnyChildrenWithAtLeastOneTime = routeChildren.some(
    (stop) => stop.actualArrivalTime || stop.theoreticalArrivalTime || stop.actualDepartureTime || stop.theoreticalDepartureTime
  );
  if (!hasAnyChildrenWithAtLeastOneTime) {
    return null;
  }
  return /* @__PURE__ */ React154.createElement(TimeLineRouteLineWrapper, { left: position, width });
});

// src/modules/network/pages/routes/components/timeline/timeline-routes-stop-component.tsx
import React155, { useMemo as useMemo44, memo as memo2 } from "react";
import styled96 from "styled-components";

// src/modules/network/pages/routes/components/timeline/get-stop-position-and-width-helper.ts
var getStopPositionAndWidthHelper = ({
  arrivalTime,
  departureTime,
  previousStops,
  routeOriginTime,
  minWidthHours = 0.5
}) => {
  if (!arrivalTime && !departureTime) {
    return { position: "0px", width: "0px" };
  }
  let isLikelyNextDay = false;
  if (previousStops.length > 0) {
    const lastPreviousStopWithTime = [...previousStops].reverse().find(
      (prevStop) => prevStop.actualDepartureTime || prevStop.theoreticalDepartureTime || prevStop.actualArrivalTime || prevStop.theoreticalArrivalTime
    );
    if (lastPreviousStopWithTime) {
      const lastTime = lastPreviousStopWithTime.actualDepartureTime || lastPreviousStopWithTime.theoreticalDepartureTime || lastPreviousStopWithTime.actualArrivalTime || lastPreviousStopWithTime.theoreticalArrivalTime;
      if (lastTime) {
        const [lastHours, lastMinutes] = lastTime.split(":").map(Number);
        const lastNormalizedTime = normalizeTimeToTimelineHelper(lastHours, lastMinutes);
        const currentTime = arrivalTime || departureTime;
        if (currentTime) {
          const [currentHours, currentMinutes] = currentTime.split(":").map(Number);
          const currentNormalizedTime = normalizeTimeToTimelineHelper(currentHours, currentMinutes);
          if (currentNormalizedTime < lastNormalizedTime && lastNormalizedTime - currentNormalizedTime > 6) {
            isLikelyNextDay = true;
          }
        }
      }
    }
  }
  if (routeOriginTime && !isLikelyNextDay) {
    const [originHours, originMinutes] = routeOriginTime.split(":").map(Number);
    const originNormalizedTime = normalizeTimeToTimelineHelper(originHours, originMinutes);
    const currentTime = arrivalTime || departureTime;
    if (currentTime) {
      const [currentHours, currentMinutes] = currentTime.split(":").map(Number);
      const currentNormalizedTime = normalizeTimeToTimelineHelper(currentHours, currentMinutes);
      if (currentNormalizedTime < originNormalizedTime && originNormalizedTime - currentNormalizedTime > 6) {
        isLikelyNextDay = true;
      }
    }
  }
  let pos = "0px";
  if (arrivalTime) {
    const [hours, minutes] = arrivalTime.split(":").map(Number);
    let normalizedTime = normalizeTimeToTimelineHelper(hours, minutes);
    if (isLikelyNextDay) {
      normalizedTime += 24;
    }
    pos = `${normalizedTime * CELL_WIDTH}px`;
  } else if (departureTime) {
    const [hours, minutes] = departureTime.split(":").map(Number);
    let normalizedTime = normalizeTimeToTimelineHelper(hours, minutes);
    if (isLikelyNextDay) {
      normalizedTime += 24;
    }
    pos = `${normalizedTime * CELL_WIDTH}px`;
  }
  let w = `${ROUTE_STOP_MIN_WIDTH}px`;
  if (arrivalTime && departureTime) {
    const [arrHours, arrMinutes] = arrivalTime.split(":").map(Number);
    const [depHours, depMinutes] = departureTime.split(":").map(Number);
    let arrTimeNormalized = normalizeTimeToTimelineHelper(arrHours, arrMinutes);
    let depTimeNormalized = normalizeTimeToTimelineHelper(depHours, depMinutes);
    if (isLikelyNextDay) {
      arrTimeNormalized += 24;
      depTimeNormalized += 24;
    }
    if (depTimeNormalized < arrTimeNormalized) {
      depTimeNormalized += 24;
    }
    w = `${Math.max(depTimeNormalized - arrTimeNormalized, minWidthHours) * CELL_WIDTH}px`;
  }
  return { position: pos, width: w };
};

// src/modules/network/pages/routes/components/timeline/timeline-routes-stop-component.tsx
var TimelineRouteStopWrapper = styled96.div`
  position: absolute;
  left: ${({ left }) => left};
  width: ${({ width }) => width};
  height: ${ROUTE_STOP_HEIGHT}px;
  background-color: ${({ color }) => color || "var(--otk-theme-color-grey-500, #ccd7e0)"};
  border: ${({ color, borderless }) => borderless ? "none" : color ? `1px solid ${color}` : "1px solid var(--otk-theme-color-grey-300, #e2e8ee)"};
  border-radius: 4px;
  z-index: 4;
  top: calc(50% - ${ROUTE_STOP_HEIGHT / 2}px);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${({ opacity }) => opacity || 1};
`;
var StopLabel = styled96.div`
  font-size: 12px;
  color: var(--otk-theme-color-white, #ffffff);
  white-space: nowrap;
  position: absolute;
  text-align: center;
  width: 100%;
`;
var getStopLabelText = (name) => {
  return name.split(" ").map((word) => word.charAt(0)).join("").toUpperCase();
};
var TimelineRouteStopComponent = memo2(function TimelineRouteStopComponent2({
  arrivalTime,
  departureTime,
  name,
  routeOriginTime,
  previousStops = [],
  color,
  opacity,
  borderless = false
}) {
  const stopLabelText = useMemo44(() => getStopLabelText(name), [name]);
  const { position, width } = useMemo44(
    () => getStopPositionAndWidthHelper({ arrivalTime, departureTime, previousStops, routeOriginTime }),
    [arrivalTime, departureTime, previousStops, routeOriginTime]
  );
  if (!arrivalTime && !departureTime) {
    return null;
  }
  return /* @__PURE__ */ React155.createElement(
    TimelineRouteStopWrapper,
    {
      borderless,
      color,
      left: position,
      opacity,
      width
    },
    stopLabelText ? /* @__PURE__ */ React155.createElement(StopLabel, null, stopLabelText) : null
  );
});

// src/modules/network/pages/routes/components/timeline/timeline-lateness-stop-markers-component.tsx
import React158, { memo as memo5 } from "react";

// src/modules/network/pages/routes/components/timeline/timeline-route-delay-segment-component.tsx
import React156, { useMemo as useMemo45, memo as memo3 } from "react";
import styled97 from "styled-components";

// src/modules/network/pages/routes/components/timeline/get-alert-color-with-opacity-helper.ts
var HEX_COLOR_PATTERN = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;
function getAlertColorWithOpacityHelper(hexColor, opacity = 0.3) {
  const match = HEX_COLOR_PATTERN.exec(hexColor);
  if (!match) {
    return hexColor;
  }
  const r = Number.parseInt(match[1], 16);
  const g = Number.parseInt(match[2], 16);
  const b = Number.parseInt(match[3], 16);
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}

// src/modules/network/pages/routes/components/timeline/timeline-route-delay-segment-component.tsx
var TimelineRouteDelaySegmentWrapper = styled97.div`
  position: absolute;
  left: ${({ left }) => left};
  width: ${({ width }) => width};
  height: ${ROUTE_STOP_HEIGHT}px;
  background-color: ${({ backgroundColor }) => backgroundColor};
  border: none;
  border-radius: 0;
  z-index: 3;
  top: calc(50% - ${ROUTE_STOP_HEIGHT / 2}px);
  pointer-events: none;
`;
var TimelineRouteDelaySegmentComponent = memo3(function TimelineRouteDelaySegmentComponent2({
  startTime,
  endTime,
  alertColor,
  previousStops = [],
  routeOriginTime
}) {
  const backgroundColor = useMemo45(
    () => getAlertColorWithOpacityHelper(alertColor, 0.3),
    [alertColor]
  );
  const { position, width } = useMemo45(
    () => getStopPositionAndWidthHelper({
      arrivalTime: startTime,
      departureTime: endTime,
      previousStops,
      routeOriginTime,
      minWidthHours: 0
    }),
    [startTime, endTime, previousStops, routeOriginTime]
  );
  if (!startTime || !endTime) {
    return null;
  }
  return /* @__PURE__ */ React156.createElement(
    TimelineRouteDelaySegmentWrapper,
    {
      backgroundColor,
      left: position,
      width
    }
  );
});

// src/modules/network/pages/routes/components/timeline/timeline-route-estimated-segment-component.tsx
import React157, { useMemo as useMemo46, memo as memo4 } from "react";
import styled98 from "styled-components";
var ESTIMATED_SEGMENT_BACKGROUND = "rgba(148, 166, 184, 0.3)";
var TimelineRouteEstimatedSegmentWrapper = styled98.div`
  position: absolute;
  left: ${({ left }) => left};
  width: ${({ width }) => width};
  height: ${ROUTE_STOP_HEIGHT}px;
  background-color: ${ESTIMATED_SEGMENT_BACKGROUND};
  border: none;
  border-radius: 0;
  z-index: 2;
  top: calc(50% - ${ROUTE_STOP_HEIGHT / 2}px);
  pointer-events: none;
`;
var TimelineRouteEstimatedSegmentComponent = memo4(
  function TimelineRouteEstimatedSegmentComponent2({
    startTime,
    endTime,
    previousStops = [],
    routeOriginTime
  }) {
    const { position, width } = useMemo46(
      () => getStopPositionAndWidthHelper({
        arrivalTime: startTime,
        departureTime: endTime,
        previousStops,
        routeOriginTime,
        minWidthHours: 0
      }),
      [startTime, endTime, previousStops, routeOriginTime]
    );
    if (!startTime || !endTime) {
      return null;
    }
    return /* @__PURE__ */ React157.createElement(TimelineRouteEstimatedSegmentWrapper, { left: position, width });
  }
);

// src/modules/network/pages/routes/components/timeline/timeline-lateness-stop-markers-component.tsx
var ESTIMATED_DELEGATION_BOX_COLOR = "var(--otk-theme-color-grey-500, #94a6b8)";
function isVisibleLatenessAlert(alert) {
  return Boolean(alert && alert.level !== alertsLevels.info);
}
function getDelayPathStartTime(stop, phase) {
  if (phase === "arrival") {
    return stop.theoreticalArrivalTime;
  }
  return stop.theoreticalDepartureTime;
}
function renderArrivalDelayMarkers({
  stop,
  previousStops,
  routeOriginTime,
  keyPrefix,
  delegationLabel,
  latenessArrivalAlert
}) {
  const markers = [];
  const { theoreticalArrivalTime, theoreticalDepartureTime, actualArrivalTime } = stop;
  const alertColor = alertLevelColors[latenessArrivalAlert.level];
  const estimatedEndTime = theoreticalDepartureTime || theoreticalArrivalTime;
  const delayPathStartTime = getDelayPathStartTime(stop, "arrival");
  if (theoreticalArrivalTime && estimatedEndTime) {
    markers.push(
      /* @__PURE__ */ React158.createElement(
        TimelineRouteEstimatedSegmentComponent,
        {
          endTime: estimatedEndTime,
          key: `${keyPrefix}-arrival-estimated-background`,
          previousStops,
          routeOriginTime,
          startTime: theoreticalArrivalTime
        }
      )
    );
  }
  if (delayPathStartTime && actualArrivalTime) {
    markers.push(
      /* @__PURE__ */ React158.createElement(
        TimelineRouteDelaySegmentComponent,
        {
          alertColor,
          endTime: actualArrivalTime,
          key: `${keyPrefix}-arrival-delay`,
          previousStops,
          routeOriginTime,
          startTime: delayPathStartTime
        }
      )
    );
  }
  if (theoreticalArrivalTime) {
    markers.push(
      /* @__PURE__ */ React158.createElement(
        TimelineRouteStopComponent,
        {
          arrivalTime: theoreticalArrivalTime,
          borderless: true,
          color: ESTIMATED_DELEGATION_BOX_COLOR,
          departureTime: theoreticalDepartureTime,
          key: `${keyPrefix}-arrival-estimated-box`,
          name: delegationLabel,
          previousStops,
          routeOriginTime
        }
      )
    );
  }
  if (actualArrivalTime) {
    markers.push(
      /* @__PURE__ */ React158.createElement(
        TimelineRouteStopComponent,
        {
          arrivalTime: actualArrivalTime,
          borderless: true,
          color: alertColor,
          key: `${keyPrefix}-arrival-actual-box`,
          name: delegationLabel,
          previousStops,
          routeOriginTime
        }
      )
    );
  }
  return markers;
}
function renderDepartureDelayMarkers({
  stop,
  previousStops,
  routeOriginTime,
  keyPrefix,
  delegationLabel,
  latenessDepartureAlert
}) {
  const markers = [];
  const { theoreticalDepartureTime, actualDepartureTime } = stop;
  const alertColor = alertLevelColors[latenessDepartureAlert.level];
  if (theoreticalDepartureTime) {
    markers.push(
      /* @__PURE__ */ React158.createElement(
        TimelineRouteEstimatedSegmentComponent,
        {
          endTime: theoreticalDepartureTime,
          key: `${keyPrefix}-departure-estimated-background`,
          previousStops,
          routeOriginTime,
          startTime: theoreticalDepartureTime
        }
      )
    );
  }
  if (theoreticalDepartureTime && actualDepartureTime) {
    markers.push(
      /* @__PURE__ */ React158.createElement(
        TimelineRouteDelaySegmentComponent,
        {
          alertColor,
          endTime: actualDepartureTime,
          key: `${keyPrefix}-departure-delay`,
          previousStops,
          routeOriginTime,
          startTime: theoreticalDepartureTime
        }
      )
    );
  }
  if (theoreticalDepartureTime) {
    markers.push(
      /* @__PURE__ */ React158.createElement(
        TimelineRouteStopComponent,
        {
          arrivalTime: theoreticalDepartureTime,
          borderless: true,
          color: ESTIMATED_DELEGATION_BOX_COLOR,
          key: `${keyPrefix}-departure-estimated-box`,
          name: delegationLabel,
          previousStops,
          routeOriginTime
        }
      )
    );
  }
  if (actualDepartureTime) {
    markers.push(
      /* @__PURE__ */ React158.createElement(
        TimelineRouteStopComponent,
        {
          arrivalTime: actualDepartureTime,
          borderless: true,
          color: alertColor,
          key: `${keyPrefix}-departure-actual-box`,
          name: delegationLabel,
          previousStops,
          routeOriginTime
        }
      )
    );
  }
  return markers;
}
var TimelineLatenessStopMarkersComponent = memo5(
  function TimelineLatenessStopMarkersComponent2({
    stop,
    previousStops,
    routeOriginTime,
    keyPrefix
  }) {
    var _a, _b;
    const latenessArrivalAlert = (_a = stop.latenessAlerts) == null ? void 0 : _a.find(
      (alert) => alert.phase === alertsPhases.arrival
    );
    const latenessDepartureAlert = (_b = stop.latenessAlerts) == null ? void 0 : _b.find(
      (alert) => alert.phase === alertsPhases.departure
    );
    const showArrivalDelay = isVisibleLatenessAlert(latenessArrivalAlert);
    const showDepartureDelay = isVisibleLatenessAlert(latenessDepartureAlert);
    const delegationLabel = stop.name;
    if (!showArrivalDelay && !showDepartureDelay) {
      return /* @__PURE__ */ React158.createElement(
        TimelineRouteStopComponent,
        {
          arrivalTime: stop.actualArrivalTime || stop.theoreticalArrivalTime,
          borderless: true,
          color: ESTIMATED_DELEGATION_BOX_COLOR,
          departureTime: stop.actualDepartureTime || stop.theoreticalDepartureTime,
          key: `${keyPrefix}-on-time`,
          name: delegationLabel,
          previousStops,
          routeOriginTime
        }
      );
    }
    const markers = [];
    if (showArrivalDelay && latenessArrivalAlert) {
      markers.push(
        ...renderArrivalDelayMarkers({
          stop,
          previousStops,
          routeOriginTime,
          keyPrefix,
          delegationLabel,
          latenessArrivalAlert
        })
      );
    }
    if (showDepartureDelay && latenessDepartureAlert) {
      markers.push(
        ...renderDepartureDelayMarkers({
          stop,
          previousStops,
          routeOriginTime,
          keyPrefix,
          delegationLabel,
          latenessDepartureAlert
        })
      );
    }
    if (markers.length === 0) {
      return null;
    }
    return /* @__PURE__ */ React158.createElement(React158.Fragment, null, markers);
  }
);

// src/modules/network/pages/routes/components/timeline/timeline-body-expanded-route-component.tsx
import React159, { memo as memo6 } from "react";
import { AccordionContentComponent as AccordionContentComponent3, ButtonComponent as ButtonComponent32, FlexComponent as FlexComponent88 } from "@ontruck/fe-ui";
import styled102 from "styled-components";

// src/modules/network/pages/routes/components/timeline/timeline-row-left-cell-component.tsx
import styled99 from "styled-components";
var TimelineRowLeftCellComponent = styled99.div`
  width: ${LEFT_PANEL_WIDTH}px;
  flex-shrink: 0;
  position: sticky;
  left: 0;
  z-index: 500; // Above regular cells but below header
  display: flex;
  align-items: center;
  background-color: var(--otk-theme-color-grey-100, #f2f5f8);
  border-right: 1px solid var(--otk-theme-color-grey-200, #e2e8ee);
`;

// src/modules/network/pages/routes/components/timeline/timeline-grid-cell-component.tsx
import styled100 from "styled-components";
var TimelineGridCellComponent = styled100.div`
  width: ${CELL_WIDTH}px;
  min-width: ${CELL_WIDTH}px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--otk-theme-color-white, #e2e8ee);
  border-right: 1px solid var(--otk-theme-color-grey-200, #e2e8ee);
  border-top: 1px solid var(--otk-theme-color-grey-200, #e2e8ee);
  &:first-child {
    border-left: 1px solid var(--otk-theme-color-grey-200, #e2e8ee);
  }
`;

// src/modules/network/pages/routes/components/timeline/timeline-grid-container-component.tsx
import styled101 from "styled-components";
var TimelineGridContainerComponent = styled101.div`
  display: flex;
  flex: 1;
  position: relative;
  overflow: hidden;
`;

// src/modules/network/pages/routes/components/timeline/timeline-body-expanded-route-component.tsx
var TimelineChildRow = styled102.div`
  height: ${STOP_ROW_HEIGHT}px;
  width: 100%;
  display: flex;
`;
var FooterTimelineChildRow = styled102.div`
  border-top: 1px solid var(--otk-theme-color-grey-200, #e2e8ee);
  height: ${STOP_ROW_HEIGHT + 5}px;
  width: 100%;
  display: flex;
`;
var PanelTableRowContentComponent2 = styled102(AccordionContentComponent3)`
  padding: unset;
  border-top: none;
  border-bottom: none;
`;
var PanelTableRowFooterComponent = styled102(FlexComponent88)`
  align-items: center;
  justify-content: center;
  border-top: 1px solid var(--otk-theme-color-grey-200, #e2e8ee);
  background-color: var(--otk-theme-color-white);
  padding: var(--otk-theme-space-s);
  width: 100%;
`;
var PanelTableRowContentWrapperComponent2 = styled102.div`
  border-top: ${({ isExpanded }) => isExpanded ? "2px solid var(--otk-theme-color-grey-400, #ccd7e0)" : "none"};
  border-bottom: ${({ isExpanded }) => isExpanded ? "1px solid var(--otk-theme-color-grey-400, #ccd7e0)" : "none"};
  height: ${({ isExpanded }) => isExpanded ? "auto" : "0"};
`;
var TimeHeaderCellMemo = memo6(function TimeHeaderCellMemo2({ timeIndex }) {
  const actualHour = (timeIndex + TIMELINE_START_HOUR) % 24;
  const isDayBoundary = actualHour === TIMELINE_START_HOUR && timeIndex > 0;
  const isNextDaySlot = timeIndex >= 24;
  return /* @__PURE__ */ React159.createElement(
    TimelineHeaderCellComponent,
    {
      key: `time-header-cell-${timeIndex}`,
      style: {
        backgroundColor: isNextDaySlot ? "var(--otk-theme-color-grey-200, #E2E8EE)" : "var(--otk-theme-color-grey-100, #F2F5F8)",
        borderLeft: isDayBoundary ? "2px solid var(--otk-theme-color-warning-500, #FFCC00)" : void 0
      }
    },
    formatHourLabelHelper(timeIndex)
  );
});
var TimeHeaderRowMemo = memo6(function TimeHeaderRowMemo2({ timeSlots }) {
  return /* @__PURE__ */ React159.createElement(React159.Fragment, null, timeSlots.map((timeIndex) => /* @__PURE__ */ React159.createElement(TimeHeaderCellMemo, { key: `time-header-cell-${timeIndex}`, timeIndex })));
});
var TimelineChildGridCellMemo = memo6(function TimelineChildGridCellMemo2({
  colIndex
}) {
  const actualHour = (colIndex + TIMELINE_START_HOUR) % 24;
  const isDayBoundary = actualHour === TIMELINE_START_HOUR && colIndex > 0;
  const isNextDaySlot = colIndex >= 24;
  return /* @__PURE__ */ React159.createElement(
    TimelineGridCellComponent,
    {
      key: `timeline-grid-cell-${colIndex}`,
      style: {
        backgroundColor: isNextDaySlot ? "var(--otk-theme-color-grey-50, #F9FAFC)" : "var(--otk-theme-color-white, #FFFFFF)",
        borderLeft: isDayBoundary ? "2px solid var(--otk-theme-color-warning-500, #FFCC00)" : void 0
      }
    }
  );
});
var TimelineChildGridRowMemo = memo6(function TimelineChildGridRowMemo2({
  timeSlots,
  children
}) {
  return /* @__PURE__ */ React159.createElement(TimelineGridContainerComponent, null, timeSlots.map((colIndex) => /* @__PURE__ */ React159.createElement(
    TimelineChildGridCellMemo,
    {
      colIndex,
      key: `timeline-child-grid-row-cell-${colIndex}`
    }
  )), children);
});
var TimelineBodyExpandedRouteComponent = memo6(function TimelineBodyExpandedRouteComponent2({
  route,
  timeSlots,
  isExpanded,
  indicator,
  onOpenEditRoute
}) {
  if (!isExpanded)
    return null;
  const handleOpenEditRoute = (routeId) => {
    if (onOpenEditRoute) {
      onOpenEditRoute(routeId);
    }
  };
  return /* @__PURE__ */ React159.createElement(PanelTableRowContentWrapperComponent2, { isExpanded }, /* @__PURE__ */ React159.createElement(PanelTableRowContentComponent2, { open: isExpanded }, /* @__PURE__ */ React159.createElement(TimelineChildRow, null, /* @__PURE__ */ React159.createElement(TimelineRowLeftCellComponent, null, /* @__PURE__ */ React159.createElement(PanelTableRowChildHeaderComponent, { indicator })), /* @__PURE__ */ React159.createElement(TimeHeaderRowMemo, { timeSlots })), route.children.map((child, ri) => {
    const childId = `routes-table-row-child-${route.id}-${child.id}-${ri}`;
    let alerts = child.hightDensityAlerts || [];
    if (indicator === selectIndicatorOptionsValues.hightDensity) {
      alerts = child.hightDensityAlerts || [];
    }
    const alertLevelForThisStop = getHighestAlertLevelHelper(
      alerts.map((alert) => alert.level)
    );
    return /* @__PURE__ */ React159.createElement(TimelineChildRow, { key: childId }, /* @__PURE__ */ React159.createElement(TimelineRowLeftCellComponent, null, /* @__PURE__ */ React159.createElement(
      PanelTableRowChildBodyComponent,
      {
        indicator,
        key: childId,
        panelTableRowChild: child
      }
    )), /* @__PURE__ */ React159.createElement(TimelineChildGridRowMemo, { timeSlots }, /* @__PURE__ */ React159.createElement(
      TimelineRouteLineComponent,
      {
        routeChildren: route.children,
        routeParent: route.parent
      }
    ), (indicator === selectIndicatorOptionsValues.none || indicator === selectIndicatorOptionsValues.lowVehicleOccupancy) && /* @__PURE__ */ React159.createElement(
      TimelineRouteStopComponent,
      {
        arrivalTime: child.actualArrivalTime || child.theoreticalArrivalTime,
        departureTime: child.actualDepartureTime || child.theoreticalDepartureTime,
        key: `timeline-route-stop-route-${childId}-stop-${ri}-default`,
        name: "",
        previousStops: route.children.slice(0, ri),
        routeOriginTime: route.parent.originTime
      }
    ), indicator === selectIndicatorOptionsValues.lateness && /* @__PURE__ */ React159.createElement(
      TimelineLatenessStopMarkersComponent,
      {
        key: `timeline-route-stop-route-${childId}-stop-${ri}-lateness`,
        keyPrefix: `timeline-route-stop-route-${childId}-stop-${ri}-lateness`,
        previousStops: route.children.slice(0, ri),
        routeOriginTime: route.parent.originTime,
        showStopLabel: false,
        stop: child
      }
    ), indicator === selectIndicatorOptionsValues.hightDensity && alerts.length === 0 && /* @__PURE__ */ React159.createElement(
      TimelineRouteStopComponent,
      {
        arrivalTime: child.actualArrivalTime || child.theoreticalArrivalTime,
        departureTime: child.actualDepartureTime || child.theoreticalDepartureTime,
        key: `timeline-route-stop-route-${childId}-stop-${ri}-indicator-high-density-no-alert`,
        name: "",
        previousStops: route.children.slice(0, ri),
        routeOriginTime: route.parent.originTime
      }
    ), indicator === selectIndicatorOptionsValues.hightDensity && alerts.length > 0 && alertLevelForThisStop ? /* @__PURE__ */ React159.createElement(
      TimelineRouteStopComponent,
      {
        arrivalTime: child.actualArrivalTime || child.theoreticalArrivalTime,
        color: alertLevelColors[alertLevelForThisStop],
        departureTime: child.actualDepartureTime || child.theoreticalDepartureTime,
        key: `timeline-route-stop-route-${childId}-stop-${ri}-indicator-high-density-with-alert`,
        name: "",
        previousStops: route.children.slice(0, ri),
        routeOriginTime: route.parent.originTime
      }
    ) : null));
  }), /* @__PURE__ */ React159.createElement(FooterTimelineChildRow, null, /* @__PURE__ */ React159.createElement(TimelineRowLeftCellComponent, null, /* @__PURE__ */ React159.createElement(PanelTableRowFooterComponent, null, /* @__PURE__ */ React159.createElement(
    ButtonComponent32,
    {
      color: "primary",
      onClick: () => {
        handleOpenEditRoute(route.id);
      },
      size: "s"
    },
    "Editar ruta"
  ))))));
});

// src/modules/network/pages/routes/components/timeline/timeline-body-component.tsx
var TimelineRowsContainer = styled103.div`
  display: flex;
  flex-direction: column;
`;
var TimelineRow = styled103.div`
  height: ${ROW_HEIGHT}px;
  width: 100%;
  display: flex;
`;
var PanelTableRowAccordionComponent2 = styled103(AccordionComponent5)`
  height: auto;
  border: none;
`;
var PanelTableRowTriggerComponent2 = styled103(AccordionTriggerComponent4)`
  padding: unset;
  border-top: ${({ index }) => index !== 0 ? "3px solid var(--otk-theme-color-grey-200, #ccd7e0)" : "none"};
  border-bottom: none;
`;
function TimelineBodyComponent({
  expandedRoutesIds,
  selectedRoutesEvaluatorIndicatorValue,
  filteredTableRoutes,
  handleToggleRouteExpanded,
  onOpenEditRoute
}) {
  const routesRows = useMemo47(
    () => filteredTableRoutes.length > 0 ? getPanelTableRowsMapperService(filteredTableRoutes) : [],
    [filteredTableRoutes]
  );
  const numberOfTimeSlots = useMemo47(() => {
    if (routesRows.length === 0)
      return NUMBER_OF_TIME_SLOTS;
    const maxHour = getMaxHourNeededHelper(routesRows);
    return Math.max(NUMBER_OF_TIME_SLOTS, maxHour - TIMELINE_START_HOUR + 1);
  }, [routesRows]);
  const timeSlots = useMemo47(() => {
    return Array.from({ length: numberOfTimeSlots }).map((_, index) => index);
  }, [numberOfTimeSlots]);
  const renderTimelineGridCells = (rowIndex) => {
    return timeSlots.map((colIndex) => {
      const actualHour = (colIndex + TIMELINE_START_HOUR) % 24;
      const isDayBoundary = actualHour === TIMELINE_START_HOUR && colIndex > 0;
      const isNextDaySlot = colIndex >= 24;
      return /* @__PURE__ */ React160.createElement(
        TimelineGridCellComponent,
        {
          key: `timeline-grid-cell-${rowIndex}-${colIndex}`,
          style: {
            backgroundColor: isNextDaySlot ? "var(--otk-theme-color-grey-50, #F9FAFC)" : "var(--otk-theme-color-white, #FFFFFF)",
            borderLeft: isDayBoundary ? "2px solid var(--otk-theme-color-warning-500, #FFCC00)" : void 0
          }
        }
      );
    });
  };
  return /* @__PURE__ */ React160.createElement(TimelineRowsContainer, null, routesRows.map((route, rowIndex) => {
    const routeId = route.parent.id;
    const isExpanded = (expandedRoutesIds == null ? void 0 : expandedRoutesIds.has(routeId)) || false;
    return /* @__PURE__ */ React160.createElement(PanelTableRowAccordionComponent2, { border: "none", key: `timeline-route-${routeId}` }, /* @__PURE__ */ React160.createElement(PanelTableRowTriggerComponent2, { index: rowIndex }, /* @__PURE__ */ React160.createElement(TimelineRow, { onClick: () => handleToggleRouteExpanded == null ? void 0 : handleToggleRouteExpanded(routeId) }, /* @__PURE__ */ React160.createElement(TimelineRowLeftCellComponent, null, /* @__PURE__ */ React160.createElement(
      TableCellComponent25,
      {
        alignItems: "center",
        background: "var(--otk-theme-color-grey-300, #E2E8EE);",
        borderRight: "var(--otk-theme-color-grey-300, #CCD7E0);",
        justifyContent: "center",
        padding: "unset",
        width: panelTableWidths.accordionIcon
      },
      /* @__PURE__ */ React160.createElement(AccordionIconComponent3, { open: isExpanded })
    ), /* @__PURE__ */ React160.createElement(
      TableCellComponent25,
      {
        background: "var(--otk-theme-color-grey-100, #f2f5f8);",
        borderRight: "var(--otk-theme-color-grey-500, #CCD7E0);",
        padding: "5px 10px",
        width: panelTableWidths.checkbox
      }
    ), /* @__PURE__ */ React160.createElement(
      PanelTableRowDescriptionCellComponent,
      {
        indicator: selectedRoutesEvaluatorIndicatorValue,
        isDraft: route.parent.isDraft,
        isExpanded,
        panelTableRowParent: route.parent
      }
    )), /* @__PURE__ */ React160.createElement(TimelineGridContainerComponent, null, renderTimelineGridCells(rowIndex), /* @__PURE__ */ React160.createElement(
      TimelineRouteLineComponent,
      {
        routeChildren: route.children,
        routeParent: route.parent
      }
    ), (selectedRoutesEvaluatorIndicatorValue === selectIndicatorOptionsValues.none || selectedRoutesEvaluatorIndicatorValue === selectIndicatorOptionsValues.lowVehicleOccupancy) && route.children.map((stop, stopIndex) => /* @__PURE__ */ React160.createElement(
      TimelineRouteStopComponent,
      {
        arrivalTime: stop.actualArrivalTime || stop.theoreticalArrivalTime,
        departureTime: stop.actualDepartureTime || stop.theoreticalDepartureTime,
        key: `timeline-route-stop-route-${routeId}-stop-${stopIndex}-default`,
        name: stop.name,
        previousStops: route.children.slice(0, stopIndex),
        routeOriginTime: route.parent.originTime
      }
    )), selectedRoutesEvaluatorIndicatorValue === selectIndicatorOptionsValues.lateness && route.children.map((stop, stopIndex) => /* @__PURE__ */ React160.createElement(
      TimelineLatenessStopMarkersComponent,
      {
        key: `timeline-route-stop-route-${routeId}-stop-${stopIndex}-lateness`,
        keyPrefix: `timeline-route-stop-route-${routeId}-stop-${stopIndex}-lateness`,
        previousStops: route.children.slice(0, stopIndex),
        routeOriginTime: route.parent.originTime,
        showStopLabel: true,
        stop
      }
    )), selectedRoutesEvaluatorIndicatorValue === selectIndicatorOptionsValues.hightDensity && route.children.map((stop, stopIndex) => {
      if (stop.hightDensityAlerts && stop.hightDensityAlerts.length > 0) {
        return null;
      }
      return /* @__PURE__ */ React160.createElement(
        TimelineRouteStopComponent,
        {
          arrivalTime: stop.actualArrivalTime || stop.theoreticalArrivalTime,
          departureTime: stop.actualDepartureTime || stop.theoreticalDepartureTime,
          key: `timeline-route-stop-route-${routeId}-stop-${stopIndex}-indicator-high-density-no-alert`,
          name: stop.name,
          previousStops: route.children.slice(0, stopIndex),
          routeOriginTime: route.parent.originTime
        }
      );
    }), selectedRoutesEvaluatorIndicatorValue === selectIndicatorOptionsValues.hightDensity && route.children.map((stop, stopIndex) => {
      if (!stop.hightDensityAlerts || stop.hightDensityAlerts.length === 0) {
        return null;
      }
      const alertLevelForThisStop = getHighestAlertLevelHelper(
        stop.hightDensityAlerts.map((alert) => alert.level)
      );
      if (!alertLevelForThisStop) {
        return null;
      }
      return /* @__PURE__ */ React160.createElement(
        TimelineRouteStopComponent,
        {
          arrivalTime: stop.actualArrivalTime || stop.theoreticalArrivalTime,
          color: alertLevelColors[alertLevelForThisStop],
          departureTime: stop.actualDepartureTime || stop.theoreticalDepartureTime,
          key: `timeline-route-stop-route-${routeId}-stop-${stopIndex}-indicator-high-density-with-alert`,
          name: stop.name,
          previousStops: route.children.slice(0, stopIndex),
          routeOriginTime: route.parent.originTime
        }
      );
    })))), /* @__PURE__ */ React160.createElement(
      TimelineBodyExpandedRouteComponent,
      {
        indicator: selectedRoutesEvaluatorIndicatorValue,
        isExpanded,
        onOpenEditRoute,
        route: {
          id: routeId,
          parent: route.parent,
          children: route.children
        },
        timeSlots
      }
    ));
  }));
}

// src/modules/network/pages/routes/views/routes-timeline-view-component.tsx
var TimelineContainer = styled104.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow: hidden;
  padding-right: ${CONTAINER_RIGHT_PADDING}px;
`;
var ScrollableContainer = styled104.div`
  flex-grow: 1;
  overflow: auto;
  position: relative;
`;
var TimelineContentWrapper = styled104.div`
  min-width: calc(${LEFT_PANEL_WIDTH}px + ${(props) => props.totalSlots} * ${CELL_WIDTH}px);
  position: relative;
`;
function RoutesTimelineViewComponent({
  allRoutesIdentifiers,
  availableRoutesIdentifiers,
  expandedRoutesIds,
  tableDelegations,
  selectedRoutesEvaluatorIndicatorValue,
  handleChangeDelegation,
  handleChangeRoutesEvaluatorIndicator,
  handleChangeRoutesSelection,
  filteredTableRoutes,
  selectedDelegationId,
  availableProviderNames,
  handleChangeFilterByProviderName,
  handleChangeFilterByRouteType,
  handleChangeFilterByVehicleType,
  onChangeFilterByOperations,
  selectedFilterByProviderName,
  selectedFilterByRouteTypeId,
  selectedFilterByVehicleTypeId,
  selectedFilterByOperationsId,
  selectedFilterByRoutesIdentifiers,
  onChangeFilterByRoutesIdentifiers,
  handleToggleRouteExpanded,
  onOpenEditRoute
}) {
  const routesRows = useMemo48(
    () => filteredTableRoutes.length > 0 ? getPanelTableRowsMapperService(filteredTableRoutes) : [],
    [filteredTableRoutes]
  );
  const numberOfTimeSlots = useMemo48(() => {
    if (routesRows.length === 0)
      return NUMBER_OF_TIME_SLOTS;
    const maxHour = getMaxHourNeededHelper(routesRows);
    return Math.max(NUMBER_OF_TIME_SLOTS, maxHour - TIMELINE_START_HOUR + 1);
  }, [routesRows]);
  return /* @__PURE__ */ React161.createElement(TimelineContainer, null, /* @__PURE__ */ React161.createElement(ScrollableContainer, null, /* @__PURE__ */ React161.createElement(TimelineContentWrapper, { totalSlots: numberOfTimeSlots }, /* @__PURE__ */ React161.createElement(
    TimelineHeaderComponent,
    {
      allRoutesIdentifiers,
      availableProviderNames,
      availableRoutesIdentifiers,
      filteredTableRoutes,
      handleChangeDelegation,
      handleChangeFilterByProviderName,
      handleChangeFilterByRouteType,
      handleChangeFilterByVehicleType,
      handleChangeRoutesEvaluatorIndicator,
      handleChangeRoutesSelection,
      onChangeFilterByOperations,
      onChangeFilterByRoutesIdentifiers,
      selectedDelegationId,
      selectedFilterByOperationsId,
      selectedFilterByProviderName,
      selectedFilterByRouteTypeId,
      selectedFilterByRoutesIdentifiers,
      selectedFilterByVehicleTypeId,
      selectedRoutesEvaluatorIndicatorValue,
      tableDelegations
    }
  ), /* @__PURE__ */ React161.createElement(
    TimelineBodyComponent,
    {
      expandedRoutesIds,
      filteredTableRoutes,
      handleToggleRouteExpanded,
      onOpenEditRoute,
      selectedRoutesEvaluatorIndicatorValue
    }
  ))));
}

// src/modules/network/pages/routes/routes-page.tsx
function removeItem(arr, value) {
  const index = arr.indexOf(value);
  if (index > -1) {
    arr.splice(index, 1);
  }
  return arr;
}
function RoutesPage({
  leftPanelIsOpen = false,
  onClickLeftSidebarNavigationItem,
  toggleLeftPanelIsOpen,
  config
}) {
  const { token, apiBase } = config;
  const {
    addDraftRoutes,
    addEditedDraftRoute,
    allRoutesIdentifiers,
    availableProviderNames,
    availableDelegationRoutesIdentifiers,
    dashboardDescription,
    evaluated,
    evaluationPackageDate,
    expandedRoutesIds,
    filteredTableRoutes,
    handleChangeDelegation,
    handleChangeFilterByOperations,
    handleChangeFilterByProviderName,
    handleChangeFilterByRouteType,
    handleChangeFilterByRoutesIdentifiers,
    handleChangeFilterByVehicleType,
    handleChangeRoutesEvaluatorIndicator,
    handleChangeRoutesSelection,
    handleClickSidebarNavigationItem,
    handleToggleRouteExpanded,
    isLoading: isLoadingRoutes,
    launchScenarioEvaluation,
    mapDelegations,
    metrics,
    networkId,
    portalKey,
    removeDraftRoutes,
    removeEditedDraftRoutes,
    routesView,
    selectedDelegationId,
    selectedFilterByOperationsId,
    selectedFilterByProviderName,
    selectedFilterByRouteTypeId,
    selectedFilterByRoutesIdentifiers,
    selectedFilterByVehicleTypeId,
    selectedMapRoutes,
    selectedRoutesIds,
    selectedRoutesIndicatorValue,
    scenarioParentId,
    setScenarioParentId,
    shouldShowBottomPanel,
    tableDelegations,
    topBarModuleRegionNode
  } = useRoutesPageHook({
    config: { token, apiBase },
    leftPanelIsOpen,
    onClickLeftSidebarNavigationItem,
    toggleLeftPanelIsOpen
  });
  const [routeToBeEdited, setRouteToBeEdited] = useState43();
  const [isOpenNotificationsDrawer, setIsOpenNotificationsDrawer] = useState43(false);
  const [isOpenCreateNewRouteDrawer, setIsOpenCreateNewRouteDrawer] = useState43(false);
  const [isOpenEditNewRouterDrawer, setIsOpenEditNewRouterDrawer] = useState43(false);
  const [isCreateNewRouteClean, setIsCreateNewRouteClean] = useState43(false);
  const [isEditRouteClean, setIsEditRouteClean] = useState43(false);
  const [numberOfNewRoutesCreated, setNumberOfNewRoutesCreated] = useState43(0);
  const [scenariosIdsEvaluationBuilding, setScenariosIdsEvaluationBuilding] = useState43(void 0);
  const {
    getCurrentDraftScenario,
    addDraftScenarioAddingRoutes,
    addDraftScenarioEditingRoute,
    addRouteToCurrentDraftScenario,
    editRouteAtCurrentDraftScenario,
    setCurrentDraftScenarioUnpersisted,
    getDraftScenarioById,
    setCurrentDraftScenario
  } = useDraftScenariosStore();
  const { save: saveScenario, isLoading: saveScenarioIsLoading } = useSaveScenarioHook({
    config,
    onSuccess: (savedScenarioCreatedSuccessfully) => {
      removeDraftRoutes();
      setNumberOfNewRoutesCreated(0);
      const currentScenario = getCurrentDraftScenario();
      if (currentScenario) {
        setCurrentDraftScenario(__spreadProps(__spreadValues({}, currentScenario), {
          id: savedScenarioCreatedSuccessfully.id,
          name: savedScenarioCreatedSuccessfully.name,
          isPersisted: true
        }));
        setScenarioParentId(savedScenarioCreatedSuccessfully.id);
      } else {
        console.warn(
          "There is no current scenario to set the id and isPersisted to after save the theoretical scenario created"
        );
      }
      setScenariosIdsEvaluationBuilding((prev) => [
        ...prev || [],
        savedScenarioCreatedSuccessfully.id
      ]);
    },
    onError: (error) => {
      console.error(error);
    }
  });
  const handleRunEvaluation = useCallback21(
    ({
      evaluationId,
      scenarioName,
      scenarioId
    }) => {
      setScenarioParentId(scenarioId);
      launchScenarioEvaluation({ evaluationId, scenarioName });
    },
    [launchScenarioEvaluation, setScenarioParentId]
  );
  const { scenariosIdsEvaluationCreated } = useGetScenariosWithEvaluationCreatedHook({
    scenariosIdsEvaluationBuilding,
    config: __spreadProps(__spreadValues({}, config), {
      shouldRetryOnError: true
    })
  });
  const {
    open: openScenarioEvaluationHasBeenCreatedSuccessToaster,
    dismiss: dismissScenarioEvaluationHasBeenCreatedSuccessToaster
  } = useScenarioEvaluationHasBeenCreatedSuccessToasterHook();
  useEffect19(() => {
    if (!scenariosIdsEvaluationBuilding || scenariosIdsEvaluationBuilding.length === 0) {
      return;
    }
    if (scenariosIdsEvaluationCreated && scenariosIdsEvaluationCreated.length > 0) {
      for (const scenarioIdEvaluationCreated of scenariosIdsEvaluationCreated) {
        const scenarioIdEvaluationCreatedIsAtScenariosIdsWithEvaluationBuilding = scenariosIdsEvaluationBuilding.includes(scenarioIdEvaluationCreated.scenarioId);
        if (scenarioIdEvaluationCreatedIsAtScenariosIdsWithEvaluationBuilding) {
          const scenario = getDraftScenarioById(scenarioIdEvaluationCreated.scenarioId);
          const scenariosIdsWithEvaluationBuildingExtractedCreated = removeItem(
            scenariosIdsEvaluationBuilding,
            scenarioIdEvaluationCreated.scenarioId
          );
          setScenariosIdsEvaluationBuilding(scenariosIdsWithEvaluationBuildingExtractedCreated);
          openScenarioEvaluationHasBeenCreatedSuccessToaster({
            scenarioName: (scenario == null ? void 0 : scenario.name) || "",
            evaluationId: scenarioIdEvaluationCreated.networkId,
            onRunEvaluation: (evaluationId) => {
              handleRunEvaluation({
                evaluationId,
                scenarioName: (scenario == null ? void 0 : scenario.name) || "",
                scenarioId: scenario == null ? void 0 : scenario.id
              });
            }
          });
        }
      }
    }
    return () => {
      dismissScenarioEvaluationHasBeenCreatedSuccessToaster();
    };
  }, [
    scenariosIdsEvaluationCreated,
    scenariosIdsEvaluationBuilding,
    dismissScenarioEvaluationHasBeenCreatedSuccessToaster,
    openScenarioEvaluationHasBeenCreatedSuccessToaster,
    getDraftScenarioById,
    handleRunEvaluation
  ]);
  const handleOpenSaveNewScenarioModal = (scenario) => {
    setIsCreateNewRouteClean(true);
    setIsOpenCreateNewRouteDrawer(false);
    if (!scenario) {
      console.error("There is no scenario to save at time to open save new scenario modal");
      return;
    }
    if (!evaluationPackageDate) {
      console.error("There is no evaluation package date to save the scenario");
      return;
    }
    openSaveScenarioModal(scenario);
  };
  const { open: openCreateRouteNeedSaveCurrentScenarioToaster } = useNeedSaveCurrentScenarioToasterHook({
    onSave: handleOpenSaveNewScenarioModal,
    onAutoClose: () => {
      setCurrentDraftScenarioUnpersisted();
    },
    onDismiss: () => {
      setCurrentDraftScenarioUnpersisted();
    }
  });
  const { open: openEditedRouteNeedSaveCurrentScenarioToaster } = useNeedSaveCurrentScenarioToasterHook({
    onSave: handleOpenSaveNewScenarioModal,
    onAutoClose: () => {
      setCurrentDraftScenarioUnpersisted();
    },
    onDismiss: () => {
      setCurrentDraftScenarioUnpersisted();
    }
  });
  const handleDiscardDraftRoute = () => {
    removeDraftRoutes();
    setIsCreateNewRouteClean(true);
    setIsOpenCreateNewRouteDrawer(false);
  };
  const handleDiscardEditDraftRoute = () => {
    removeEditedDraftRoutes();
    setIsEditRouteClean(true);
    setIsOpenEditNewRouterDrawer(false);
  };
  const handleSaveDraftRoute = () => {
    setIsOpenCreateNewRouteDrawer(true);
  };
  const { open: openCreateRouteUnsavedDraftModal } = useUnsavedDraftModalHook({
    onSave: handleSaveDraftRoute,
    onDiscard: handleDiscardDraftRoute
  });
  const handleGoBackFromSaveCurrentScenario = () => {
    setCurrentDraftScenarioUnpersisted();
  };
  const handleSaveCurrentScenario = (scenario) => {
    if (!scenario.draftId) {
      console.error("There is no draft id for the scenario to save");
      return;
    }
    saveScenario(scenario);
  };
  const { open: openSaveScenarioModal } = useSaveScenarioModalHook({
    onSave: handleSaveCurrentScenario,
    onGoBack: handleGoBackFromSaveCurrentScenario
  });
  const handleClickNotifications = () => {
    setIsOpenNotificationsDrawer(Boolean(!isOpenNotificationsDrawer));
  };
  const handleCloseCreateNewRoute = (areUnsavedDraftChanges) => {
    if (areUnsavedDraftChanges) {
      setIsOpenCreateNewRouteDrawer(false);
      void openCreateRouteUnsavedDraftModal();
      return;
    }
    setIsOpenCreateNewRouteDrawer(false);
  };
  const handleOpenCreateNewRoute = () => {
    setIsOpenEditNewRouterDrawer(false);
    setIsOpenCreateNewRouteDrawer(true);
  };
  const handleCreateDraftRoute = (draftRoute) => {
    addDraftRoutes([draftRoute]);
    const currentScenario = getCurrentDraftScenario();
    if (!currentScenario || currentScenario.isPersisted) {
      const newCurrentScenario = addDraftScenarioAddingRoutes({
        name: NEW_DRAFT_SCENARIO_NAME_PLACEHOLDER,
        description: NEW_DRAFT_SCENARIO_DESCRIPTION_PLACEHOLDER,
        date: evaluationPackageDate || NEW_DRAFT_SCENARIO_DATE_PLACEHOLDER,
        routes: [draftRoute],
        parentId: scenarioParentId || void 0
      });
      if (!newCurrentScenario) {
        console.error("There is no posible create a new current scenario to save the draft route");
        return;
      }
      openCreateRouteNeedSaveCurrentScenarioToaster(newCurrentScenario);
    } else {
      if (!currentScenario.draftId) {
        console.error("There is no current scenario draft id to add draft route");
        return;
      }
      addRouteToCurrentDraftScenario(draftRoute);
    }
    setNumberOfNewRoutesCreated(numberOfNewRoutesCreated + 1);
  };
  const handleOpenEditRoute = (routeId) => {
    const route = filteredTableRoutes.find((r) => r.id === routeId);
    if (!route) {
      return;
    }
    setIsEditRouteClean(true);
    setRouteToBeEdited(route);
    setIsOpenCreateNewRouteDrawer(false);
    setIsOpenEditNewRouterDrawer(true);
  };
  const handleEditDraftRoute = (editedDraftRoute) => {
    addEditedDraftRoute(editedDraftRoute);
    const currentScenario = getCurrentDraftScenario();
    if (!currentScenario || currentScenario.isPersisted) {
      const newCurrentScenarioWithEditedRoute = addDraftScenarioEditingRoute({
        name: NEW_DRAFT_SCENARIO_NAME_PLACEHOLDER,
        description: NEW_DRAFT_SCENARIO_DESCRIPTION_PLACEHOLDER,
        date: evaluationPackageDate || NEW_DRAFT_SCENARIO_DATE_PLACEHOLDER,
        editedRoute: editedDraftRoute,
        parentId: scenarioParentId || void 0
      });
      if (!newCurrentScenarioWithEditedRoute) {
        console.error(
          "It was not posible create a new scenario to add it the edited route and set it as the current scenario"
        );
        return;
      }
      openEditedRouteNeedSaveCurrentScenarioToaster(newCurrentScenarioWithEditedRoute);
    } else {
      if (!currentScenario.draftId) {
        console.error("There is no current scenario draft id to add the edited route");
        return;
      }
      editRouteAtCurrentDraftScenario(editedDraftRoute);
    }
  };
  const handleCloseEditRoute = (areUnsavedDraftChanges) => {
    if (areUnsavedDraftChanges) {
      setIsOpenEditNewRouterDrawer(false);
      void openEditRouteUnsavedDraftModal();
      return;
    }
    setIsOpenEditNewRouterDrawer(false);
  };
  const { open: openEditRouteUnsavedDraftModal } = useUnsavedDraftModalHook({
    onSave: handleSaveDraftRoute,
    onDiscard: handleDiscardEditDraftRoute
  });
  const isLoading = useMemo49(() => {
    return isLoadingRoutes || saveScenarioIsLoading;
  }, [isLoadingRoutes, saveScenarioIsLoading]);
  return /* @__PURE__ */ React162.createElement(
    PageLayoutComponent,
    {
      isAvailableCreateNewRoute: true,
      networkId,
      onClickSideBarNavigationItem: handleClickSidebarNavigationItem,
      onClickUnsavedScenario: handleOpenSaveNewScenarioModal,
      onCreateNewRoute: handleOpenCreateNewRoute,
      sidebarNavigationItemIdSelected: navigationItemsIds.ROUTES
    },
    /* @__PURE__ */ React162.createElement(
      DrawerComponent3,
      {
        isOpen: isOpenCreateNewRouteDrawer || isOpenEditNewRouterDrawer,
        nodeRegionId: DRAWER_REGION_ID_LEFT,
        onClose: handleCloseCreateNewRoute,
        opacity: 0.8,
        position: "left",
        scrollable: false,
        size: "435px",
        withHeader: false
      },
      isOpenEditNewRouterDrawer ? /* @__PURE__ */ React162.createElement(
        EditRouteComponent,
        {
          config,
          isClean: isEditRouteClean,
          networkId,
          onClose: handleCloseEditRoute,
          onEditRoute: handleEditDraftRoute,
          route: routeToBeEdited
        }
      ) : null,
      isOpenCreateNewRouteDrawer ? /* @__PURE__ */ React162.createElement(
        CreateRouteComponent,
        {
          config,
          isClean: isCreateNewRouteClean,
          networkId,
          numberOfNewRoutesCreated,
          onClose: handleCloseCreateNewRoute,
          onCreateRoute: handleCreateDraftRoute,
          route: routeToBeEdited
        }
      ) : null
    ),
    topBarModuleRegionNode ? /* @__PURE__ */ React162.createElement(React162.Fragment, { key: portalKey }, createPortal2(
      /* @__PURE__ */ React162.createElement(FlexComponent89, { alignItems: "center", gap: "var(--otk-theme-space-m, 16px)" }, /* @__PURE__ */ React162.createElement(TopBarSwitchViewComponent, null), /* @__PURE__ */ React162.createElement(
        TopBarNotificationsComponent,
        {
          networkConfig: config,
          onClickNotifications: handleClickNotifications
        }
      )),
      topBarModuleRegionNode
    )) : null,
    routesView === "map" ? /* @__PURE__ */ React162.createElement(
      RoutesMapViewComponent,
      {
        allRoutesIdentifiers,
        availableProviderNames,
        availableRoutesIdentifiers: availableDelegationRoutesIdentifiers,
        dashboardDescription,
        evaluated,
        expandedRoutesIds,
        filteredTableRoutes,
        handleChangeDelegation,
        handleChangeFilterByProviderName,
        handleChangeFilterByRouteType,
        handleChangeFilterByVehicleType,
        handleChangeRoutesEvaluatorIndicator,
        handleChangeRoutesSelection,
        handleToggleRouteExpanded,
        isLoading,
        isRouteCodeDelegationSelected: selectedFilterByRoutesIdentifiers ? selectedFilterByRoutesIdentifiers.length > 0 : void 0,
        leftPanelIsOpen,
        mapDelegations,
        metrics,
        onChangeFilterByOperations: handleChangeFilterByOperations,
        onChangeFilterByRoutesIdentifiers: handleChangeFilterByRoutesIdentifiers,
        onOpenEditRoute: handleOpenEditRoute,
        selectedDelegationId,
        selectedFilterByOperationsId,
        selectedFilterByProviderName,
        selectedFilterByRouteTypeId,
        selectedFilterByRoutesIdentifiers,
        selectedFilterByVehicleTypeId,
        selectedMapRoutes,
        selectedRoutesIds,
        selectedRoutesIndicatorValue,
        shouldShowBottomPanel,
        tableDelegations
      }
    ) : null,
    routesView === "table" ? /* @__PURE__ */ React162.createElement(
      RoutesTableViewComponent,
      {
        allRoutesIdentifiers,
        availableProviderNames,
        availableRoutesIdentifiers: availableDelegationRoutesIdentifiers,
        filteredTableRoutes,
        handleChangeDelegation,
        handleChangeFilterByProviderName,
        handleChangeFilterByRouteType,
        handleChangeFilterByVehicleType,
        handleChangeRoutesEvaluatorIndicator,
        handleChangeRoutesSelection,
        isLoading,
        isRouteCodeDelegationSelected: selectedFilterByRoutesIdentifiers ? selectedFilterByRoutesIdentifiers.length > 0 : void 0,
        onChangeFilterByOperations: handleChangeFilterByOperations,
        onChangeFilterByRoutesIdentifiers: handleChangeFilterByRoutesIdentifiers,
        selectedDelegationId,
        selectedFilterByOperationsId,
        selectedFilterByProviderName,
        selectedFilterByRouteTypeId,
        selectedFilterByRoutesIdentifiers,
        selectedFilterByVehicleTypeId,
        selectedRoutesEvaluatorIndicatorValue: selectedRoutesIndicatorValue,
        selectedRoutesIds,
        tableDelegations
      }
    ) : null,
    routesView === "timeline" ? /* @__PURE__ */ React162.createElement(
      RoutesTimelineViewComponent,
      {
        allRoutesIdentifiers,
        availableProviderNames,
        availableRoutesIdentifiers: availableDelegationRoutesIdentifiers,
        expandedRoutesIds,
        filteredTableRoutes,
        handleChangeDelegation,
        handleChangeFilterByProviderName,
        handleChangeFilterByRouteType,
        handleChangeFilterByVehicleType,
        handleChangeRoutesEvaluatorIndicator,
        handleChangeRoutesSelection,
        handleToggleRouteExpanded,
        isLoading,
        onChangeFilterByOperations: handleChangeFilterByOperations,
        onChangeFilterByRoutesIdentifiers: handleChangeFilterByRoutesIdentifiers,
        onOpenEditRoute: handleOpenEditRoute,
        selectedDelegationId,
        selectedFilterByOperationsId,
        selectedFilterByProviderName,
        selectedFilterByRouteTypeId,
        selectedFilterByRoutesIdentifiers,
        selectedFilterByVehicleTypeId,
        selectedRoutesEvaluatorIndicatorValue: selectedRoutesIndicatorValue,
        selectedRoutesIds,
        tableDelegations
      }
    ) : null,
    isOpenNotificationsDrawer ? /* @__PURE__ */ React162.createElement(
      DrawerComponent3,
      {
        isOpen: isOpenNotificationsDrawer,
        nodeRegionId: DRAWER_REGION_ID_RIGHT,
        onClose: handleClickNotifications,
        opacity: 0.5,
        scrollable: false,
        size: "500px"
      },
      /* @__PURE__ */ React162.createElement(NotificationsComponent, { apiBase, scenarioId: scenarioParentId, token })
    ) : null,
    /* @__PURE__ */ React162.createElement(Toaster15, { expand: true, richColors: true })
  );
}

// src/modules/network/pages/evaluator/evaluator-page.tsx
import React169, { useMemo as useMemo50, useState as useState45, useEffect as useEffect20, useLayoutEffect } from "react";
import styled109 from "styled-components";
import { createPortal as createPortal3 } from "react-dom";
import { DRAWER_REGION_ID_RIGHT as DRAWER_REGION_ID_RIGHT2, DrawerComponent as DrawerComponent4, FlexComponent as FlexComponent92 } from "@ontruck/fe-ui";
import { formatInTimeZone as formatInTimeZone5 } from "date-fns-tz";
import { addHours } from "date-fns";

// src/modules/network/metrics/get-metrics-cost-hook.ts
import useSWR22 from "swr";

// src/modules/network/metrics/get-metrics-cost-api.ts
var getMetricsCostApi = (_0) => __async(void 0, [_0], function* ({
  networkId,
  config,
  routeType,
  vehicleCategory
}) {
  const url = new URL(`${config.apiBase}/concordia/v1/networks/networks/${networkId}/cost_metrics`);
  if (routeType) {
    url.searchParams.append("route_type", routeType);
  }
  if (vehicleCategory) {
    url.searchParams.append("vehicle_category", vehicleCategory);
  }
  const response = yield fetch(url.toString(), {
    method: "GET",
    cache: "no-cache",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${config.token}`
    }
  });
  if (response.ok) {
    const data = yield response.json();
    return data;
  }
  throw new Error("Failed to fetch metrics cost");
});

// src/modules/network/metrics/get-metrics-cost-fetcher.ts
var getMetricsCostFetcher = (networkId, config, routeType, vehicleCategory) => {
  return getMetricsCostApi({ networkId, config, routeType, vehicleCategory });
};

// src/modules/network/metrics/get-metrics-cost-mapper.ts
var getMetricsCostMapper = (metricsCostDto) => {
  if (!metricsCostDto) {
    console.warn("Error mapping delegation snapshots because no vertices snapshots data");
    return;
  }
  const metricsCostMapped = {
    totalCost: metricsCostDto.total_cost,
    metricsCosts: [...metricsCostDto.vertex_cost_metrics].map((m) => ({
      cost: {
        value: m.cost,
        level: 0,
        levelName: alertsLevels.info
      },
      meanCostPerCubicMetrePer100Kilometres: {
        value: m.mean_cost_per_cubic_metre_per_100_kilometres.value,
        level: m.mean_cost_per_cubic_metre_per_100_kilometres.level,
        levelName: m.mean_cost_per_cubic_metre_per_100_kilometres.level_name
      },
      meanCostPerKilo: {
        levelName: m.mean_cost_per_kilo.level_name,
        value: m.mean_cost_per_kilo.value,
        level: m.mean_cost_per_kilo.level
      },
      meanCostPerPackage: {
        value: m.mean_cost_per_package.value,
        level: m.mean_cost_per_package.level,
        levelName: m.mean_cost_per_package.level_name
      },
      totalDistance: String(m.total_distance),
      totalPackages: String(m.total_packages),
      totalRouteCost: m.total_route_cost,
      totalWeight: String(m.total_weight),
      vertex: {
        delegation: {
          id: String(m.vertex.delegation.id),
          name: m.vertex.delegation.name,
          code: m.vertex.delegation.code,
          latitude: String(m.vertex.delegation.latitude),
          longitude: String(m.vertex.delegation.longitude)
        },
        id: String(m.vertex.id),
        delegation_code: m.vertex.delegation.code
      }
    }))
  };
  return metricsCostMapped;
};

// src/modules/network/metrics/get-metrics-cost-hook.ts
var useGetMetricsCostHook = ({
  networkId,
  config,
  routeType,
  vehicleCategory
}) => {
  const fetcher = networkId ? () => __async(void 0, null, function* () {
    return getMetricsCostFetcher(networkId, config, routeType, vehicleCategory);
  }) : null;
  const { data, error, isLoading, mutate } = useSWR22(
    networkId ? [`network-${networkId}-metrics-cost`, networkId, routeType, vehicleCategory] : null,
    fetcher,
    {
      revalidateOnFocus: false,
      refreshInterval: 0,
      revalidateIfStale: false
    }
  );
  const metricsCostMapped = getMetricsCostMapper(data);
  const { totalCost, metricsCosts } = metricsCostMapped || {};
  return {
    totalCost,
    metricsCosts,
    isLoading,
    error,
    mutate
  };
};

// src/modules/network/metrics/metrics-cost.ts
var totalCostValues = {
  totalCost: "cost",
  totalRouteCost: "totalRouteCost",
  meanCostPerKilo: "meanCostPerKilo",
  meanCostPerPackage: "meanCostPerPackage",
  meanCostPerCubicMetrePer100Kilometres: "meanCostPerCubicMetrePer100Kilometres"
};

// src/modules/network/metrics/get-delegations-filtered-by-metric-cost-hook.ts
var useGetDelegationsFilteredByMetricCostHook = ({
  metricsCosts,
  metricCostFilter
}) => {
  if (!metricsCosts || !metricCostFilter) {
    return {
      delegationsFilteredByMetricCost: []
    };
  }
  const delegationsFilteredByMetricCost = metricsCosts.filter((metricCost) => {
    let levelName = "";
    if (metricCostFilter === totalCostValues.totalCost) {
      levelName = metricCost.cost.levelName;
    } else if (metricCostFilter === totalCostValues.meanCostPerCubicMetrePer100Kilometres) {
      levelName = metricCost.meanCostPerCubicMetrePer100Kilometres.levelName;
    } else if (metricCostFilter === totalCostValues.meanCostPerKilo) {
      levelName = metricCost.meanCostPerKilo.levelName;
    } else if (metricCostFilter === totalCostValues.meanCostPerPackage) {
      levelName = metricCost.meanCostPerPackage.levelName;
    }
    return levelName === alertsLevels.info || levelName === alertsLevels.low;
  });
  return {
    delegationsFilteredByMetricCost
  };
};

// src/modules/network/pages/evaluator/components/map/map-component.tsx
import React165, { useState as useState44 } from "react";
import styled105 from "styled-components";
import { ComposableMap as ComposableMap2, Geographies as Geographies2, Geography as Geography2, ZoomableGroup as ZoomableGroup2 } from "react-simple-maps";
import { FlexComponent as FlexComponent90, ButtonComponent as ButtonComponent33 } from "@ontruck/fe-ui";
import { IconComponent as IconComponent25 } from "@ontruck/fe-icons";

// src/modules/network/pages/evaluator/components/map/delegation-component.tsx
import React163 from "react";
import { Marker as Marker5 } from "react-simple-maps";
var positions3 = {
  top: "top",
  bottom: "bottom"
};
function DelegationComponent2({
  delegationId,
  delegationCode,
  latitude,
  longitude,
  name,
  enableDelegationNavigation = false,
  onClickDelegation,
  position = positions3.top
}) {
  const innerRadius = 2.5;
  const outerRadius = 6;
  const fontSize = 7;
  const markerStyle = {
    default: { fill: "#6587aa", cursor: "default" },
    hover: { fill: "#6587aa", cursor: "default" },
    pressed: { fill: "#6587aa", cursor: "default" }
  };
  if (enableDelegationNavigation) {
    markerStyle.hover = { fill: "#a4c6e7", cursor: "pointer" };
    markerStyle.pressed = { fill: "#a4c6e7", cursor: "pointer" };
  }
  const { setSelectedDelegationId } = useNetworkState();
  const { latitude: customLatitude, longitude: customLongitude } = useGetCustomCoordinatesHook({
    latitude,
    longitude,
    delegationCode
  });
  const handleMarkerClick = () => {
    if (enableDelegationNavigation) {
      setSelectedDelegationId(delegationId);
      onClickDelegation == null ? void 0 : onClickDelegation();
    }
  };
  if (!customLatitude || !customLongitude) {
    console.error("Custom coordinates not found for delegation code", delegationCode);
    return null;
  }
  return /* @__PURE__ */ React163.createElement(
    Marker5,
    {
      coordinates: [customLongitude, customLatitude],
      onClick: handleMarkerClick,
      style: markerStyle
    },
    position === positions3.top && name ? /* @__PURE__ */ React163.createElement("text", { fontSize: `${fontSize}px`, textAnchor: "middle", y: "-5" }, name) : null,
    /* @__PURE__ */ React163.createElement("circle", { cx: 0, cy: 0, opacity: 0.1, r: outerRadius, stroke: "#3c4451", strokeWidth: 1 }),
    /* @__PURE__ */ React163.createElement("circle", { cx: 0, cy: 0, opacity: 0.4, r: innerRadius }),
    position === positions3.bottom && name ? /* @__PURE__ */ React163.createElement("text", { fontSize: `${fontSize}px`, textAnchor: "middle", y: "9" }, name) : null
  );
}

// src/modules/network/pages/evaluator/components/map/alert-component.tsx
import React164 from "react";
import { Marker as Marker6 } from "react-simple-maps";
var positions4 = {
  top: "top",
  bottom: "bottom"
};
function AlertComponent2({
  indicator,
  level,
  delegationName,
  longitude,
  latitude,
  value,
  delegationId,
  delegationCode,
  enableDelegationNavigation,
  onClickDelegation,
  position = positions4.bottom
}) {
  let color = "#ffc439";
  let colorShadow = "#bd8400";
  let label = "";
  switch (level) {
    case alertsLevels.high:
      color = "#ff0000";
      colorShadow = "#8d0000";
      break;
    case alertsLevels.medium:
      color = "#F38005";
      colorShadow = "#8f4a00";
      break;
    case alertsLevels.low:
      color = "#ffc439";
      colorShadow = "#bd8400";
      break;
    case alertsLevels.info:
      color = "#69798f";
      colorShadow = "#404c5c";
      break;
  }
  switch (indicator) {
    case alertsIndicators.lateness:
      label = `${value}% retrasos`;
      break;
    case alertsIndicators.hightThroughput:
      label = value;
      break;
    case alertsIndicators.hightStorageOccupancy:
      label = value;
      break;
    case alertsIndicators.lowVehicleOccupancy:
      label = value;
      break;
    case alertsIndicators.lowFixedRouteCoverage:
      label = value;
      break;
    case alertsIndicators.undeliveredPackages:
      label = value;
      break;
    case alertsIndicators.hightVehicleSaturation:
      label = value;
      break;
    case alertsIndicators.manyLateRoutes:
      label = value;
      break;
    case alertsIndicators.hightDensity:
      label = value;
      break;
    case alertsIndicators.cost:
      label = `${value}\u20AC`;
      break;
  }
  const { setSelectedDelegationId } = useNetworkState();
  const { latitude: customLatitude, longitude: customLongitude } = useGetCustomCoordinatesHook({
    latitude,
    longitude,
    delegationCode
  });
  const handleMarkerClick = () => {
    if (enableDelegationNavigation) {
      setSelectedDelegationId(delegationId);
      onClickDelegation == null ? void 0 : onClickDelegation();
    }
  };
  const markerStyle = {
    default: { cursor: "default" },
    hover: { cursor: "default" },
    pressed: { cursor: "default" }
  };
  if (enableDelegationNavigation) {
    markerStyle.hover = { cursor: "pointer" };
    markerStyle.pressed = { cursor: "pointer" };
  }
  if (!customLatitude || !customLongitude) {
    console.error("Custom coordinates not found for delegation code", delegationCode);
    return null;
  }
  return /* @__PURE__ */ React164.createElement(
    Marker6,
    {
      coordinates: [customLongitude, customLatitude],
      onClick: handleMarkerClick,
      style: markerStyle
    },
    /* @__PURE__ */ React164.createElement("style", null, `
          .marker:hover .marker-text { fill: #a4c6e7; }
          .marker:hover .marker-subtext {  fill: #a4c6e7; }
        `),
    /* @__PURE__ */ React164.createElement("g", { className: "marker" }, position === positions4.top ? /* @__PURE__ */ React164.createElement(React164.Fragment, null, /* @__PURE__ */ React164.createElement(
      "text",
      {
        className: "marker-text",
        fill: "#fff",
        fontSize: "7px",
        textAnchor: "middle",
        x: "0",
        y: "-10"
      },
      getCapitalizeStringService(delegationName)
    ), /* @__PURE__ */ React164.createElement(
      "text",
      {
        className: "marker-text marker-subtext",
        fill: "#e2e8ee",
        fontSize: "5px",
        textAnchor: "middle",
        x: "0",
        y: "-5"
      },
      label
    )) : null, /* @__PURE__ */ React164.createElement("circle", { cx: "0", cy: "0", fill: colorShadow, opacity: 0.5, r: "3", style: { zIndex: 1e3 } }, /* @__PURE__ */ React164.createElement("animate", { attributeName: "r", begin: "0.1", dur: "1s", repeatCount: "indefinite", values: "3;6;3" })), /* @__PURE__ */ React164.createElement("circle", { cx: "0", cy: "0", fill: color, r: "3" }), /* @__PURE__ */ React164.createElement("polygon", { fill: "black", points: "-1.5,1 1.5,1 0,-1" }), position === positions4.bottom ? /* @__PURE__ */ React164.createElement(React164.Fragment, null, /* @__PURE__ */ React164.createElement(
      "text",
      {
        className: "marker-text",
        fill: "#fff",
        fontSize: "7px",
        textAnchor: "middle",
        x: "0",
        y: "10"
      },
      getCapitalizeStringService(delegationName)
    ), /* @__PURE__ */ React164.createElement(
      "text",
      {
        className: "marker-text marker-subtext",
        fill: "#e2e8ee",
        fontSize: "5px",
        textAnchor: "middle",
        x: "0",
        y: "16"
      },
      label
    )) : null)
  );
}

// src/modules/network/pages/evaluator/components/map/map-component.tsx
var MAP_URL2 = "/map/network-map-spain-geo.json";
var NetworkMapWrapperComponent2 = styled105.header`
  background-color: #1e2838;
  width: 100%;
  height: 100%;
  background-color: #1e2838;
  width: 100%;
  height: 100%;
  flex: 1;
  position: relative;
`;
var NetworkMapZoomButtonsComponent2 = styled105(FlexComponent90)`
  position: absolute;
  top: 10px;
  right: 10px;
  gap: 2px;
`;
var NetworkMapZoomButtonComponent2 = styled105(ButtonComponent33)`
  border-color: var(--otk-theme-color-midnight-express-700, #31435d);
  background-color: var(--otk-theme-color-midnight-express-700, #31435d);
`;
var NetworkComposableMapComponent2 = styled105(ComposableMap2)`
  height: 100%;

  width: ${({ reduce }) => {
  if (reduce) {
    return "calc(100vw - 370px - 61px)";
  }
  return "calc(100vw - 61px)";
}};

  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
`;
function MapComponent2({
  delegations,
  reduce = false,
  delegationsFilteredByAlerts,
  delegationsFilteredByCostMetrics,
  onClickDelegation
}) {
  const [position, setPosition] = useState44({
    coordinates: [-3.7, 40],
    // Madrid coordinates approximately
    zoom: 1
  });
  const allFilteredDelegations = [
    ...delegationsFilteredByAlerts || [],
    ...delegationsFilteredByCostMetrics || []
  ];
  const handleZoomIn = () => {
    if (position.zoom >= 4) {
      return;
    }
    setPosition((pos) => __spreadProps(__spreadValues({}, pos), { zoom: pos.zoom * 2 }));
  };
  const handleZoomOut = () => {
    if (position.zoom <= 1) {
      return;
    }
    setPosition((pos) => __spreadProps(__spreadValues({}, pos), { zoom: pos.zoom / 2 }));
  };
  const handleMoveEnd = (newPosition) => {
    setPosition(newPosition);
  };
  return /* @__PURE__ */ React165.createElement(NetworkMapWrapperComponent2, null, /* @__PURE__ */ React165.createElement(NetworkMapZoomButtonsComponent2, null, /* @__PURE__ */ React165.createElement(NetworkMapZoomButtonComponent2, { onClick: handleZoomIn, size: "s" }, /* @__PURE__ */ React165.createElement(IconComponent25, { name: "plus", size: "xl" })), /* @__PURE__ */ React165.createElement(NetworkMapZoomButtonComponent2, { onClick: handleZoomOut, size: "s" }, /* @__PURE__ */ React165.createElement(IconComponent25, { name: "minus", size: "xl" }))), /* @__PURE__ */ React165.createElement(
    NetworkComposableMapComponent2,
    {
      projection: "geoAlbers",
      projectionConfig: {
        scale: 3500,
        rotate: [2, -0.75, 0]
      },
      reduce,
      width: 100
    },
    /* @__PURE__ */ React165.createElement(ZoomableGroup2, { center: position.coordinates, onMoveEnd: handleMoveEnd, zoom: position.zoom }, /* @__PURE__ */ React165.createElement(Geographies2, { fill: "#1c2636", geography: MAP_URL2 }, ({ geographies }) => {
      return geographies.map((geo) => /* @__PURE__ */ React165.createElement(
        Geography2,
        {
          stroke: "#3c4451",
          geography: geo,
          key: geo.rsmKey,
          style: {
            default: { outline: "none" },
            hover: { outline: "none" },
            pressed: { outline: "none" }
          }
        }
      ));
    }), delegations == null ? void 0 : delegations.map((delegation) => {
      const isSelectedWithAlert = allFilteredDelegations.some((d) => d.id === delegation.id);
      return /* @__PURE__ */ React165.createElement(
        DelegationComponent2,
        {
          delegationCode: delegation.delegationCode,
          delegationId: delegation.id,
          enableDelegationNavigation: true,
          key: `network-map-marker-${delegation.name.replace(" ", "")}`,
          latitude: delegation.latitude,
          longitude: delegation.longitude,
          name: !isSelectedWithAlert ? getCapitalizeStringService(delegation.name) : void 0,
          onClickDelegation,
          position: customDelegationsBottomLabel.includes(delegation.delegationCode) ? "bottom" : "top"
        }
      );
    }), allFilteredDelegations.map((d) => {
      const { alerts } = d;
      if (!alerts) {
        return null;
      }
      return alerts.map((a, i) => {
        const alertId = `${d.id}-${a.indicator}-${i}`;
        return /* @__PURE__ */ React165.createElement(
          AlertComponent2,
          {
            delegationCode: d.delegationCode,
            delegationId: d.id,
            delegationName: d.name,
            enableDelegationNavigation: true,
            indicator: a.indicator,
            key: alertId,
            latitude: d.latitude,
            level: a.level,
            longitude: d.longitude,
            onClickDelegation,
            position: customAlertsTopLabel.includes(d.delegationCode) ? "top" : "bottom",
            value: a.value
          }
        );
      });
    }))
  ));
}

// src/modules/network/pages/evaluator/components/hours-timeline/hours-timeline-component.tsx
import React167 from "react";
import styled107 from "styled-components";

// src/modules/network/pages/evaluator/components/hours-timeline/hour-timeline-component.tsx
import React166 from "react";
import styled106 from "styled-components";
import { TextComponent as TextComponent54, BallComponent as BallComponent4 } from "@ontruck/fe-ui";
var HourTimeLineWrapperComponent = styled106.span`
  display: flex;
  flex-direction: row;
  flex: 1;
  align-items: center;
  justify-content: center;
  border-right: 1px solid var(--otk-theme-color-grey-400, #c4c4c4);
  min-width: 70px;
  position: relative;

  :last-child {
    border-right: none;
  }

  :hover {
    cursor: pointer;
  }

  background-color: ${({ isSelected }) => {
  if (isSelected) {
    return "var(--otk-theme-color-primary, #e2e8ee)";
  }
  return "var(--otk-theme-color-grey-100, #ecf0f5)";
}};
`;
var HourTimeLineBallComponent = styled106(BallComponent4)`
  position: absolute;
  bottom: 8px;
  right: 42%;
`;
function HourTimelineComponent({
  hourTimeline,
  isSelected = false,
  hasAlerts = false,
  onClick
}) {
  const handleClick = () => {
    if (onClick) {
      onClick(hourTimeline.id);
    }
  };
  return /* @__PURE__ */ React166.createElement(
    HourTimeLineWrapperComponent,
    {
      id: hourTimeline.id,
      isSelected,
      onClick: handleClick
    },
    /* @__PURE__ */ React166.createElement(TextComponent54, { fontWeight: "medium" }, hourTimeline.hour),
    hasAlerts ? /* @__PURE__ */ React166.createElement(
      HourTimeLineBallComponent,
      {
        backgroundColor: isSelected ? "#00204d" : "#ffcc00",
        size: "7px"
      }
    ) : null
  );
}

// src/modules/network/pages/evaluator/components/hours-timeline/hours-timeline-component.tsx
var MAP_LEFT_PANEL_WIDTH4 = 370;
var HOURS_TIMELINE_HEIGHT_IN_PIXELES = MAIN_PANEL_TOP_BAR_HOURS_TIMELINE_HEIGHT_IN_PIXELES;
var LEFT_SIDEBARS_WIDTH_IN_PIXELES = `${MAP_LEFT_PANEL_WIDTH4 + LEFT_SIDEBAR_NAVIGATION_WIDTH}px`;
var HoursTimeLineWrapperComponent = styled107.aside`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: start;
  background-color: var(--otk-theme-color-grey-100, #ecf0f5);
  height: ${HOURS_TIMELINE_HEIGHT_IN_PIXELES}px;
  overflow-x: auto;
  max-width: calc(100vw - ${LEFT_SIDEBARS_WIDTH_IN_PIXELES});
  width: 100%;
`;
function HoursTimelineComponent({
  hoursTimeline,
  selectedHourTimelineId,
  onSelectHourTimeline,
  numberOfAlertsByIndicatorAndDatetimes
}) {
  if (hoursTimeline.length === 0) {
    return null;
  }
  return /* @__PURE__ */ React167.createElement(HoursTimeLineWrapperComponent, null, hoursTimeline.map((h) => {
    const isSelected = selectedHourTimelineId === h.id;
    const hasAlerts = numberOfAlertsByIndicatorAndDatetimes && numberOfAlertsByIndicatorAndDatetimes[h.id] > 0;
    return /* @__PURE__ */ React167.createElement(
      HourTimelineComponent,
      {
        hasAlerts,
        hourTimeline: h,
        isSelected,
        key: h.id,
        onClick: onSelectHourTimeline
      }
    );
  }));
}

// src/modules/network/pages/evaluator/components/cost-filters/cost-filters-component.tsx
import { FlexComponent as FlexComponent91, Input as InputComponent9 } from "@ontruck/fe-ui";
import React168 from "react";
import styled108 from "styled-components";
var apiRouteTypes = {
  fixed: "FIXED",
  sporadic: "SPORADIC"
};
var apiVehicleCategories = {
  light: "LIGHT",
  heavy: "HEAVY"
};
var COST_FILTERS_TOTAL_COST_FILTER_WIDTH_IN_PIXELS = "250px";
var COST_FILTERS_TYPE_OF_ROUTE_FILTER_WIDTH_IN_PIXELS = "120px";
var COST_FILTERS_TYPE_OF_VEHICLE_FILTER_WIDTH_IN_PIXELS = "150px";
var totalCostOptions = [
  { label: "Gasto total", value: totalCostValues.totalCost },
  // totalRouteCost
  { label: "Media por peso volum\xE9trico", value: totalCostValues.meanCostPerKilo },
  {
    label: "Media por env\xEDo entregado",
    value: totalCostValues.meanCostPerPackage
  },
  {
    label: "Media por pallet (m3/100km)",
    value: totalCostValues.meanCostPerCubicMetrePer100Kilometres
  }
];
var typeOfRouteOptions = [
  { label: "Ninguna", value: "" },
  { label: "Fijo", value: apiRouteTypes.fixed },
  { label: "Espor\xE1dica", value: apiRouteTypes.sporadic }
];
var typeOfVehicleOptions = [
  { label: "Ninguna", value: "" },
  { label: "Ligero", value: apiVehicleCategories.light },
  { label: "Pesado", value: apiVehicleCategories.heavy }
];
var CostFiltersRootComponent = styled108(FlexComponent91)`
  width: 100%;
  background-color: var(--otk-theme-color-white, #ffffff);
  padding: 0 var(--otk-theme-space-m, 16px) 0 0;
`;
var CostFiltersTotalCostFilterComponent = styled108(FlexComponent91)`
  background-color: var(--otk-theme-color-grey-200, #ffffff);
  padding: var(--otk-theme-space-m, 16px);
`;
function CostFiltersComponent({
  selectedTotalCost = totalCostValues.totalCost,
  // totalRouteCost
  selectedTypeOfRoute = "",
  selectedTypeOfVehicle = "",
  onChangeTotalCost,
  onChangeTypeOfRoute,
  onChangeTypeOfVehicle
}) {
  const handleChangeTotalCost = (name, value) => {
    if (!onChangeTotalCost) {
      return;
    }
    onChangeTotalCost(name, value);
  };
  const handleChangeTypeOfRoute = (name, value) => {
    if (!onChangeTypeOfRoute) {
      return;
    }
    onChangeTypeOfRoute(name, value);
  };
  const handleChangeTypeOfVehicle = (name, value) => {
    if (!onChangeTypeOfVehicle) {
      return;
    }
    onChangeTypeOfVehicle(name, value);
  };
  return /* @__PURE__ */ React168.createElement(
    CostFiltersRootComponent,
    {
      alignItems: "center",
      flexDirection: "row",
      gap: "var(--otk-theme-space-s, 8px)",
      justifyContent: "start"
    },
    /* @__PURE__ */ React168.createElement(
      CostFiltersTotalCostFilterComponent,
      {
        alignItems: "center",
        flexDirection: "row",
        justifyContent: "center",
        width: COST_FILTERS_TOTAL_COST_FILTER_WIDTH_IN_PIXELS
      },
      /* @__PURE__ */ React168.createElement(
        InputComponent9,
        {
          handleChangeValue: handleChangeTotalCost,
          label: "Gasto total",
          name: "evaluator-cost-filters-total-cost-selector",
          options: totalCostOptions,
          type: "select",
          value: selectedTotalCost,
          width: "100%"
        }
      )
    ),
    /* @__PURE__ */ React168.createElement(
      FlexComponent91,
      {
        alignItems: "center",
        flexDirection: "row",
        justifyContent: "center",
        width: COST_FILTERS_TYPE_OF_ROUTE_FILTER_WIDTH_IN_PIXELS
      },
      /* @__PURE__ */ React168.createElement(
        InputComponent9,
        {
          handleChangeValue: handleChangeTypeOfRoute,
          label: "Tipo de ruta",
          name: "evaluator-cost-filters-type-of-route-selector",
          options: typeOfRouteOptions,
          type: "select",
          value: selectedTypeOfRoute,
          width: "100%"
        }
      )
    ),
    /* @__PURE__ */ React168.createElement(
      FlexComponent91,
      {
        alignItems: "center",
        flexDirection: "row",
        justifyContent: "center",
        width: COST_FILTERS_TYPE_OF_VEHICLE_FILTER_WIDTH_IN_PIXELS
      },
      /* @__PURE__ */ React168.createElement(
        InputComponent9,
        {
          handleChangeValue: handleChangeTypeOfVehicle,
          label: "Tipo de veh\xEDculo",
          name: "evaluator-cost-filters-type-of-vehicle-selector",
          options: typeOfVehicleOptions,
          type: "select",
          value: selectedTypeOfVehicle,
          width: "100%"
        }
      )
    )
  );
}

// src/modules/network/pages/evaluator/evaluator-page.tsx
var StyledTotalCostContainer = styled109(FlexComponent92)`
  position: absolute;
  top: 80px;
  pointer-events: none;
  z-index: 1000;
  right: 135px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 12px 12px 8px 12px;
  background-color: rgba(243, 128, 5, 0.7);
  border-radius: 4px;
`;
var StyledTotalCostValue = styled109(FlexComponent92)`
  font-size: 24px;
  color: var(--otk-theme-color-white, #ffffff);
`;
var StyledTotalCostLabel = styled109(FlexComponent92)`
  font-size: 14px;
  color: var(--otk-theme-color-white, #ffffff);
`;
var MAIN_TOP_FILTERS_BAR_HEIGHT_IN_PIXELES = "70px";
var getHourForDatetime = (datetime) => {
  try {
    const calculatedHour = formatInTimeZone5(datetime, DEFAULT_TIME_ZONE, "HH:mm");
    return calculatedHour;
  } catch (error) {
    console.error("\n\nError calculating hour:", error);
    console.error(datetime);
  }
  return "--:--";
};
var MainPanelComponent2 = styled109(FlexComponent92)`
  background-color: var(--otk-theme-color-midnight-express-800, #1d2838);
`;
var MainTopFiltersBarComponent = styled109(FlexComponent92)`
  width: 100%;
  height: ${MAIN_TOP_FILTERS_BAR_HEIGHT_IN_PIXELES};
  background-color: var(--otk-theme-color-white, #ffffff);
  flex: none;
`;
var MainPanelTopBarComponent2 = styled109(FlexComponent92)`
  width: 100%;
  background-color: var(--otk-theme-color-white, #ffffff);
  border-bottom: var(--otk-theme-border, #e0e0e0);
  flex: none;

  padding: ${({ verticalHeight }) => {
  if (verticalHeight === `${MAIN_PANEL_TOP_BAR_HOURS_TIMELINE_HEIGHT_IN_PIXELES}px`) {
    return "0";
  }
  return "calc(var(--otk-theme-space-s, 8px) + 1px) var(--otk-theme-space-s, 8px)";
}};

  transition: height 0.2s ease;

  height: ${({ isOpen, verticalHeight }) => {
  if (isOpen) {
    return verticalHeight;
  }
  return "0";
}};

  padding: ${({ isOpen }) => !isOpen && "0"};

  > * {
    display: ${({ isOpen }) => !isOpen && "none"};
    height: ${({ isOpen }) => !isOpen && "0"};
  }

  @starting-style {
    height: ${({ verticalHeight }) => verticalHeight && verticalHeight};
  }
`;
function EvaluatorPage({
  config,
  leftPanelIsOpen = false,
  onClickLeftSidebarNavigationItem,
  toggleLeftPanelIsOpen,
  onClickDelegation
}) {
  const { token, apiBase } = config;
  const { networkId, evaluationPackageDate, scenarioParentId } = useNetworkState();
  const [selectedRouteType, setSelectedRouteType] = useState45("");
  const [selectedVehicleType, setSelectedVehicleType] = useState45("");
  const {
    totalCost,
    metricsCosts,
    isLoading: metricsCostIsLoading
  } = useGetMetricsCostHook({
    networkId,
    config,
    routeType: selectedRouteType || void 0,
    vehicleCategory: selectedVehicleType || void 0
  });
  const { network, isLoading: networkIsLoading } = useGetNetworkHook({ networkId, config });
  const { delegations, isLoading: delegationsAreLoading } = useGetDelegationsHook({
    networkId,
    config
  });
  const [notificationsAreOpen, setNotificationsAreOpen] = useState45(false);
  const [drawerRegionNode, setDrawerRegionNode] = useState45();
  const [selectedEvaluatorIndicatorDate, setSelectedEvaluatorIndicatorDate] = useState45();
  const [selectedEvaluatorIndicator, setSelectedEvaluatorIndicator] = useState45();
  const [selectedMetricCostFilter, setSelectedMetricCostFilter] = useState45(
    totalCostValues.totalCost
  );
  const { delegationsFilteredByMetricCost } = useGetDelegationsFilteredByMetricCostHook({
    metricsCosts,
    metricCostFilter: selectedMetricCostFilter
  });
  const convertMetricCostsToDelegations = (costs, filter) => {
    const getMetricValueAndLevel = (metricCost, filterType) => {
      switch (filterType) {
        case totalCostValues.totalCost:
          return {
            value: metricCost.cost.value,
            level: metricCost.cost.levelName
          };
        case totalCostValues.meanCostPerKilo:
          return {
            value: metricCost.meanCostPerKilo.value,
            level: metricCost.meanCostPerKilo.levelName
          };
        case totalCostValues.meanCostPerPackage:
          return {
            value: metricCost.meanCostPerPackage.value,
            level: metricCost.meanCostPerPackage.levelName
          };
        case totalCostValues.meanCostPerCubicMetrePer100Kilometres:
          return {
            value: metricCost.meanCostPerCubicMetrePer100Kilometres.value,
            level: metricCost.meanCostPerCubicMetrePer100Kilometres.levelName
          };
        default:
          return {
            value: metricCost.cost.value,
            level: metricCost.cost.levelName
          };
      }
    };
    return costs.map((metricCost) => {
      const { value, level } = getMetricValueAndLevel(metricCost, filter);
      return {
        id: metricCost.vertex.id,
        name: metricCost.vertex.delegation.name,
        latitude: parseFloat(metricCost.vertex.delegation.latitude),
        longitude: parseFloat(metricCost.vertex.delegation.longitude),
        alerts: [
          {
            indicator: alertsIndicators.cost,
            level,
            value
          }
        ],
        delegationCode: metricCost.vertex.delegation_code,
        // Required Delegation fields with defaults
        capacity: 0,
        numberOfDocks: 0,
        spotLegPercentage: 0
      };
    });
  };
  const delegationsFilteredByCostMetrics = convertMetricCostsToDelegations(
    delegationsFilteredByMetricCost,
    selectedMetricCostFilter
  );
  const datetimes = useMemo50(() => {
    if (!evaluationPackageDate)
      return [];
    const initialHour = 10;
    const numberOfHours = 25;
    const timeZone = DEFAULT_TIME_ZONE;
    const offset2 = formatInTimeZone5(
      /* @__PURE__ */ new Date(`${evaluationPackageDate}T00:00:00Z`),
      timeZone,
      "xxx"
    );
    const baseDateString = `${evaluationPackageDate}T${String(initialHour).padStart(2, "0")}:00:00${offset2}`;
    const baseDate = new Date(baseDateString);
    const result = [];
    for (let i = 0; i < numberOfHours; i++) {
      const date = addHours(baseDate, i);
      const formatted = formatInTimeZone5(date, timeZone, "yyyy-MM-dd'T'HH:mm:ssXXX");
      result.push(formatted);
    }
    return result;
  }, [evaluationPackageDate]);
  const EVALUATOR_INDICATOR_DATE_DEFAULT = useMemo50(() => datetimes[0], [datetimes]);
  const [fakeLoading, setFakeLoading] = useState45(false);
  const [topBarModuleRegionNode, setTopBarModuleRegionNode] = useState45();
  const { delegationsFilteredByAlerts } = useGetDelegationsFilteredByAlertsHook({
    indicator: selectedEvaluatorIndicator,
    // datetime: getYesterdayISOStringAtThisHourService(),
    datetimes: selectedEvaluatorIndicatorDate ? [selectedEvaluatorIndicatorDate] : void 0,
    delegations
  });
  const { numberOfAlertsByIndicatorAndDatetime } = useGetDelegationsAlertsNumberHook({
    indicator: selectedEvaluatorIndicator,
    datetimes,
    delegations
  });
  const { description, metrics, evaluated } = useDashboardsHook({
    selectedDelegationId: void 0,
    network
  });
  const isLoading = useMemo50(() => {
    if (networkIsLoading || delegationsAreLoading || metricsCostIsLoading || fakeLoading) {
      return true;
    }
    return false;
  }, [networkIsLoading, delegationsAreLoading, metricsCostIsLoading, fakeLoading]);
  const mapDelegations = useMemo50(() => {
    if (!network) {
      return [];
    }
    return network.delegations;
  }, [network]);
  const evaluationIndicators = useMemo50(() => {
    return [
      {
        id: alertsIndicators.cost,
        title: "Coste",
        description: "Global, por peso y por envio entregado"
      },
      {
        id: alertsIndicators.manyLateRoutes,
        title: "Retrasos detectados",
        description: "Tiempos reales vs te\xF3ricos"
      },
      {
        id: alertsIndicators.hightThroughput,
        title: "Capacidad de manipulaci\xF3n",
        description: "N\xBA bultos / capacidad efectiva"
      },
      {
        id: alertsIndicators.hightStorageOccupancy,
        title: "Capacidad de almacenamiento",
        description: "Estimaci\xF3n m\xB2 bultos / m\xB2 delegaci\xF3n"
      },
      {
        id: alertsIndicators.hightVehicleSaturation,
        title: "Densidad de veh\xEDculos",
        description: "N\xBA de veh\xEDculos / Capacidad de muelles"
      },
      {
        id: alertsIndicators.lowFixedRouteCoverage,
        title: "Nivel de cobertura con rutas fijas",
        description: "Rutas salientes fijas vs espor\xE1dicas"
      },
      {
        id: alertsIndicators.undeliveredPackages,
        title: "Bultos sin cubrir",
        description: "N\xBA bultos que no han llegado a destino"
      }
    ];
  }, []);
  const hoursTimeline = datetimes.map((datetime) => ({
    hour: getHourForDatetime(datetime),
    id: datetime,
    datetime
  }));
  useEffect20(() => {
    if (toggleLeftPanelIsOpen && !leftPanelIsOpen) {
      toggleLeftPanelIsOpen();
    }
  }, []);
  useEffect20(() => {
    if (topBarModuleRegionNode) {
      return;
    }
    const node = document.getElementById(TOP_BAR_MODULE_REGION_ID);
    if (!node) {
      return;
    }
    setTopBarModuleRegionNode(node);
  }, [topBarModuleRegionNode]);
  useEffect20(() => {
    if (!numberOfAlertsByIndicatorAndDatetime) {
      setSelectedEvaluatorIndicatorDate(void 0);
      return;
    }
    const firstDateTimeWithAlerts = datetimes.find(
      (datetime) => numberOfAlertsByIndicatorAndDatetime[datetime] > 0
    );
    const newDateTime = firstDateTimeWithAlerts || EVALUATOR_INDICATOR_DATE_DEFAULT;
    setSelectedEvaluatorIndicatorDate(newDateTime);
    setTimeout(() => {
      const element = document.getElementById(newDateTime);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "nearest" });
      }
    }, 100);
  }, [selectedEvaluatorIndicator]);
  useLayoutEffect(() => {
    if (drawerRegionNode) {
      return;
    }
    const node = document.getElementById(DRAWER_REGION_ID_RIGHT2);
    if (!node) {
      console.error(`Node with id ${DRAWER_REGION_ID_RIGHT2} not found`);
      return;
    }
    setDrawerRegionNode(node);
  }, [drawerRegionNode, setDrawerRegionNode]);
  const handleSelectHourTimeline = (timelineHourId) => {
    setFakeLoading(true);
    setTimeout(() => {
      if (timelineHourId === selectedEvaluatorIndicatorDate) {
        return;
      }
      setSelectedEvaluatorIndicatorDate(timelineHourId);
      setFakeLoading(false);
    }, 300);
  };
  const handleClickEvaluatorIndicator = (indicator) => {
    if (selectedEvaluatorIndicator === indicator) {
      setSelectedEvaluatorIndicator(void 0);
      return;
    }
    setFakeLoading(true);
    setTimeout(() => {
      if (indicator === alertsIndicators.cost || indicator === alertsIndicators.undeliveredPackages || indicator === alertsIndicators.lowFixedRouteCoverage || indicator === alertsIndicators.manyLateRoutes) {
        setSelectedEvaluatorIndicatorDate(void 0);
      } else {
        setSelectedEvaluatorIndicatorDate(EVALUATOR_INDICATOR_DATE_DEFAULT);
      }
      setSelectedEvaluatorIndicator(indicator);
      setFakeLoading(false);
    }, 400);
  };
  const handleClickSidebarNavigationItem = (navigationItemId) => {
    if (onClickLeftSidebarNavigationItem) {
      onClickLeftSidebarNavigationItem(navigationItemId);
    }
  };
  const handleClickNotifications = () => {
    setNotificationsAreOpen(Boolean(!notificationsAreOpen));
  };
  const handleChangeTotalCost = (name, value) => {
    setSelectedMetricCostFilter(value);
  };
  const handleChangeTypeOfRoute = (name, value) => {
    setSelectedRouteType(value || "");
  };
  const handleChangeTypeOfVehicle = (name, value) => {
    setSelectedVehicleType(value || "");
  };
  return /* @__PURE__ */ React169.createElement(
    PageLayoutComponent,
    {
      networkId,
      onClickSideBarNavigationItem: handleClickSidebarNavigationItem,
      sidebarNavigationItemIdSelected: navigationItemsIds.EVALUATOR
    },
    topBarModuleRegionNode ? createPortal3(
      /* @__PURE__ */ React169.createElement(
        TopBarNotificationsComponent,
        {
          networkConfig: config,
          onClickNotifications: handleClickNotifications
        }
      ),
      topBarModuleRegionNode
    ) : null,
    /* @__PURE__ */ React169.createElement(FlexComponent92, { alignItems: "stretch", height: "100%", justifyContent: "stretch", width: "100%" }, /* @__PURE__ */ React169.createElement(LeftPanelComponent, { flexDirection: "column", isOpen: leftPanelIsOpen }, /* @__PURE__ */ React169.createElement(BoxHeaderComponent, { title: "Criterios de evaluaci\xF3n" }), /* @__PURE__ */ React169.createElement(
      EvaluationIndicatorsComponent,
      {
        evaluationIndicators,
        onClickEvaluationIndicator: handleClickEvaluatorIndicator,
        selectedEvaluatorIndicatorId: selectedEvaluatorIndicator
      }
    )), /* @__PURE__ */ React169.createElement(MainPanelComponent2, { flex: "1", flexDirection: "column", width: "100%" }, selectedEvaluatorIndicator === alertsIndicators.cost ? /* @__PURE__ */ React169.createElement(MainTopFiltersBarComponent, { alignItems: "center", justifyContent: "start" }, /* @__PURE__ */ React169.createElement(
      CostFiltersComponent,
      {
        onChangeTotalCost: handleChangeTotalCost,
        onChangeTypeOfRoute: handleChangeTypeOfRoute,
        onChangeTypeOfVehicle: handleChangeTypeOfVehicle,
        selectedTotalCost: selectedMetricCostFilter,
        selectedTypeOfRoute: selectedRouteType,
        selectedTypeOfVehicle: selectedVehicleType
      }
    )) : null, /* @__PURE__ */ React169.createElement(
      MainPanelTopBarComponent2,
      {
        alignItems: "center",
        isOpen: Boolean(numberOfAlertsByIndicatorAndDatetime),
        verticalHeight: `${MAIN_PANEL_TOP_BAR_HOURS_TIMELINE_HEIGHT_IN_PIXELES}px`,
        width: "100%"
      },
      /* @__PURE__ */ React169.createElement(
        HoursTimelineComponent,
        {
          hoursTimeline,
          numberOfAlertsByIndicatorAndDatetimes: numberOfAlertsByIndicatorAndDatetime,
          onSelectHourTimeline: handleSelectHourTimeline,
          selectedHourTimelineId: selectedEvaluatorIndicatorDate
        }
      )
    ), isLoading ? /* @__PURE__ */ React169.createElement(SpinnerComponent, { timeInMilliseconds: 1500 }) : /* @__PURE__ */ React169.createElement(React169.Fragment, null, !metricsCostIsLoading && selectedEvaluatorIndicator === alertsIndicators.cost ? /* @__PURE__ */ React169.createElement(StyledTotalCostContainer, null, /* @__PURE__ */ React169.createElement(StyledTotalCostValue, null, totalCost, " \u20AC"), /* @__PURE__ */ React169.createElement(StyledTotalCostLabel, null, "Total")) : null, /* @__PURE__ */ React169.createElement(
      MapComponent2,
      {
        delegations: mapDelegations,
        delegationsFilteredByAlerts: selectedEvaluatorIndicator ? delegationsFilteredByAlerts : [],
        delegationsFilteredByCostMetrics: selectedEvaluatorIndicator === alertsIndicators.cost ? delegationsFilteredByCostMetrics : [],
        onClickDelegation,
        reduce: leftPanelIsOpen || false
      }
    )), !networkIsLoading && !delegationsAreLoading && !metricsCostIsLoading ? /* @__PURE__ */ React169.createElement(BottomPanelComponent, null, /* @__PURE__ */ React169.createElement(
      DashboardsComponent,
      {
        description,
        evaluated,
        isOpen: true,
        metrics
      }
    )) : null)),
    /* @__PURE__ */ React169.createElement(
      DrawerComponent4,
      {
        isOpen: notificationsAreOpen,
        nodeRegionId: DRAWER_REGION_ID_RIGHT2,
        onClose: handleClickNotifications,
        opacity: 0.5,
        scrollable: false,
        size: "500px"
      },
      /* @__PURE__ */ React169.createElement(NotificationsComponent, { apiBase, scenarioId: scenarioParentId, token })
    )
  );
}

// src/modules/network/pages/source/source-page.tsx
import React179, { useEffect as useEffect22, useLayoutEffect as useLayoutEffect2, useMemo as useMemo52, useState as useState48 } from "react";
import { createPortal as createPortal4 } from "react-dom";
import { FlexComponent as FlexComponent102, DRAWER_REGION_ID_RIGHT as DRAWER_REGION_ID_RIGHT3, DrawerComponent as DrawerComponent5 } from "@ontruck/fe-ui";

// src/modules/network/scenario/get-scenarios-by-name-description-or-created-by-search-hook.ts
import useSWR23 from "swr";

// src/modules/network/scenario/get-scenarios-by-name-description-or-created-by-search-api.ts
var getScenariosByNameDescriptionOrCreatedBySearchApi = (_0) => __async(void 0, [_0], function* ({
  config,
  search
}) {
  let url = `${config.apiBase}/concordia/v1/networks/scenarios?page_size=0`;
  if (search) {
    url = `${url}&search=${search}`;
  }
  const response = yield fetch(url, {
    method: "GET",
    cache: "no-cache",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${config.token}`
    }
  });
  if (response.ok) {
    const data = yield response.json();
    return data;
  }
  return yield response.json();
});

// src/modules/network/scenario/get-scenarios-by-name-description-or-created-by-search-fetcher.ts
var getScenariosByNameDescriptionOrCreatedBySearchFetcher = (config, search) => {
  return getScenariosByNameDescriptionOrCreatedBySearchApi({ config, search });
};

// src/modules/network/scenario/get-scenarios-mapper.ts
function getScenariosMapper(scenariosDto) {
  return scenariosDto.map(
    (scenarioDto) => {
      var _a, _b;
      return {
        id: String(scenarioDto.id),
        isEvaluationCreated: Boolean(scenarioDto.evaluation_id !== null),
        evaluationId: scenarioDto.evaluation_id ? String(scenarioDto.evaluation_id) : void 0,
        name: scenarioDto.name,
        date: scenarioDto.date,
        description: (_a = scenarioDto.description) != null ? _a : void 0,
        createdAt: scenarioDto.created_at ? getISOToLocalDateFormatted(scenarioDto.created_at) : void 0,
        createdBy: (_b = scenarioDto.created_by) != null ? _b : void 0,
        parentId: scenarioDto.parent_id !== null ? String(scenarioDto.parent_id) : void 0
      };
    }
  );
}

// src/modules/network/scenario/get-scenarios-by-name-description-or-created-by-search-hook.ts
function isGetScenariosResponseDto(data) {
  return "results" in data && Array.isArray(data.results);
}
var useGetScenariosByNameDescriptionOrCreatedBySearchHook = ({
  config,
  search
}) => {
  const fetcher = () => __async(void 0, null, function* () {
    return getScenariosByNameDescriptionOrCreatedBySearchFetcher(config, search);
  });
  const key = search ? `get-scenarios-by-name-description-or-created-by-search-${search}` : `get-scenarios`;
  const { data, error, isLoading } = useSWR23(key, fetcher, {
    revalidateOnFocus: false,
    refreshInterval: 0,
    revalidateIfStale: true
  });
  if (!data) {
    return {
      scenarios: [],
      isLoading,
      error
    };
  }
  let scenariosMapped = [];
  const isGetScenariosResponse = isGetScenariosResponseDto(data);
  if (isGetScenariosResponse) {
    scenariosMapped = getScenariosMapper(data.results);
  } else {
    scenariosMapped = [];
  }
  return {
    scenarios: scenariosMapped,
    isLoading,
    error
  };
};

// src/modules/network/pages/source/components/evaluation-scenarios/evaluation-scenarios-component.tsx
import React172, { useState as useState46, useMemo as useMemo51 } from "react";
import styled112 from "styled-components";
import { FlexComponent as FlexComponent95, Input as InputComponent10 } from "@ontruck/fe-ui";

// src/modules/network/pages/source/components/evaluation-scenarios/evaluation-scenarios-action-component.tsx
import React170 from "react";
import styled110 from "styled-components";
import { FlexComponent as FlexComponent93, ButtonComponent as ButtonComponent34 } from "@ontruck/fe-ui";
var EVALUATION_SCENARIOS_ACTION_COMPONENT_HEIGHT_IN_PIXELS = 66;
var EvaluationScenariosActionRootComponent = styled110(FlexComponent93)`
  height: ${EVALUATION_SCENARIOS_ACTION_COMPONENT_HEIGHT_IN_PIXELS} + 'px';
  padding-left: var(--otk-theme-space-xl, 32px);
  padding-right: var(--otk-theme-space-xl, 32px);
  padding-top: var(--otk-theme-space-m, 8px);
  padding-bottom: var(--otk-theme-space-m, 8px);
  background-color: var(--otk-theme-color-grey-200, #e2e8ee);
`;
function EvaluationScenariosActionComponent({
  onClickLaunchScenarioEvaluation,
  scenarioName,
  evaluationId
}) {
  const { launchScenarioEvaluation } = useNetworkState();
  const handleClick = () => {
    if (!evaluationId) {
      console.warn("No evaluation id found to launch scenario evaluation");
      return;
    }
    if (!scenarioName) {
      console.warn("No scenario name found to launch scenario evaluation");
      return;
    }
    launchScenarioEvaluation({ evaluationId, scenarioName });
    if (onClickLaunchScenarioEvaluation) {
      onClickLaunchScenarioEvaluation();
    }
  };
  return /* @__PURE__ */ React170.createElement(EvaluationScenariosActionRootComponent, { width: "100%" }, /* @__PURE__ */ React170.createElement(ButtonComponent34, { color: "primary", onClick: handleClick, size: "s" }, "Lanzar evaluaci\xF3n"));
}

// src/modules/network/pages/source/components/evaluation-scenarios/evaluation-scenario-component.tsx
import React171 from "react";
import styled111 from "styled-components";
import { FlexComponent as FlexComponent94, TextComponent as TextComponent55, RadioInputComponent } from "@ontruck/fe-ui";
var EvaluationScenarioRootComponent = styled111(FlexComponent94)`
  padding-left: var(--otk-theme-space-xl, 32px);
  border-bottom: 1px solid var(--otk-theme-color-grey-200, #e2e8ee);
  background-color: var(--otk-theme-color-white, #ffffff);

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background-color: var(--otk-theme-color-grey-100, #f2f5f8);
    cursor: pointer;
  }
`;
var EvaluationScenarioDetailsComponent = styled111(FlexComponent94)`
  padding-top: var(--otk-theme-space-m, 8px);
  padding-bottom: var(--otk-theme-space-m, 8px);
`;
var EvaluationScenarioRadioInputWrapperComponent = styled111(FlexComponent94)`
  padding-top: var(--otk-theme-space-m, 8px);
  padding-bottom: var(--otk-theme-space-m, 8px);
  border-left: 1px solid var(--otk-theme-color-grey-200, #e2e8ee);
`;
function EvaluationScenarioComponent({
  scenario,
  onSelectScenario,
  isSelected = false
}) {
  const { name, id, description, createdBy, createdAt } = scenario;
  const handleSelectScenario = (scenarioId) => {
    if (onSelectScenario) {
      onSelectScenario(scenarioId);
    }
  };
  return /* @__PURE__ */ React171.createElement(
    EvaluationScenarioRootComponent,
    {
      alignItems: "stretch",
      flexDirection: "row",
      gap: "var(--otk-theme-space-m, 16px)",
      onClick: () => {
        handleSelectScenario(id);
      },
      width: "100%"
    },
    /* @__PURE__ */ React171.createElement(
      EvaluationScenarioDetailsComponent,
      {
        alignItems: "start",
        flex: "1",
        flexDirection: "column",
        gap: "var(--otk-theme-space-s, 8px)",
        justifyContent: "center"
      },
      name && name !== "" ? /* @__PURE__ */ React171.createElement(TextComponent55, { fontWeight: "medium", size: "m", truncate: true, width: "250px" }, name) : null,
      description && description !== "" ? /* @__PURE__ */ React171.createElement(TextComponent55, { maxHeight: "60px", truncateLines: 3 }, description) : null,
      createdBy && createdBy !== "" ? /* @__PURE__ */ React171.createElement(TextComponent55, { fontWeight: "medium" }, createdBy) : null,
      createdAt && createdAt !== "" ? /* @__PURE__ */ React171.createElement(TextComponent55, { fontWeight: "medium" }, createdAt) : null
    ),
    /* @__PURE__ */ React171.createElement(
      EvaluationScenarioRadioInputWrapperComponent,
      {
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        width: "80px"
      },
      /* @__PURE__ */ React171.createElement(
        RadioInputComponent,
        {
          handleChangeValue: handleSelectScenario,
          name: id,
          value: isSelected ? "true" : "false"
        }
      )
    )
  );
}

// src/modules/network/pages/source/components/evaluation-scenarios/evaluation-scenarios-component.tsx
var EvaluationScenariosSearcherComponent = styled112.div`
  width: 100%;
  padding-left: var(--otk-theme-space-xl, 32px);
  padding-right: var(--otk-theme-space-xl, 32px);
  padding-top: var(--otk-theme-space-m, 8px);
  padding-bottom: var(--otk-theme-space-m, 8px);
  background-color: var(--otk-theme-color-grey-200, #e2e8ee);
`;
function EvaluationScenariosComponent({
  evaluationScenarioSearch,
  evaluationScenarios,
  onSearchEvaluationScenario,
  onClickLaunchScenarioEvaluation
}) {
  const [selectedScenarioId, setSelectedScenarioId] = useState46(void 0);
  const selectedEvaluationId = useMemo51(() => {
    var _a;
    return (_a = evaluationScenarios.find(
      (evaluationScenario) => evaluationScenario.id === selectedScenarioId
    )) == null ? void 0 : _a.evaluationId;
  }, [evaluationScenarios, selectedScenarioId]);
  const selectedScenarioName = useMemo51(() => {
    var _a;
    return (_a = evaluationScenarios.find(
      (evaluationScenario) => evaluationScenario.id === selectedScenarioId
    )) == null ? void 0 : _a.name;
  }, [evaluationScenarios, selectedScenarioId]);
  const handleSelectScenario = (scenarioId) => {
    if (scenarioId !== void 0 && scenarioId !== selectedScenarioId) {
      setSelectedScenarioId(scenarioId);
    }
  };
  const handleChangeEvaluationScenarioSearch = (e) => {
    if (onSearchEvaluationScenario) {
      onSearchEvaluationScenario(e.target.value);
    }
  };
  return /* @__PURE__ */ React172.createElement(
    FlexComponent95,
    {
      alignItems: "start",
      flex: "1",
      flexDirection: "column",
      height: "calc(100vh - 130px)",
      justifyContent: "space-between",
      overflowX: "hidden",
      overflowY: "hidden",
      width: "100%"
    },
    /* @__PURE__ */ React172.createElement(FlexComponent95, { flexDirection: "column", overflowY: "hidden", width: "100%" }, /* @__PURE__ */ React172.createElement(EvaluationScenariosSearcherComponent, null, /* @__PURE__ */ React172.createElement(
      InputComponent10,
      {
        handleChangeEvent: handleChangeEvaluationScenarioSearch,
        name: "evaluation-scenario-search",
        type: "search",
        value: evaluationScenarioSearch
      }
    )), /* @__PURE__ */ React172.createElement(FlexComponent95, { flexDirection: "column", overflowY: "auto", width: "100%" }, evaluationScenarios.map((evaluationScenario) => /* @__PURE__ */ React172.createElement(
      EvaluationScenarioComponent,
      {
        isSelected: selectedScenarioId === evaluationScenario.id,
        key: evaluationScenario.id,
        onSelectScenario: handleSelectScenario,
        scenario: evaluationScenario
      }
    )))),
    /* @__PURE__ */ React172.createElement(
      EvaluationScenariosActionComponent,
      {
        evaluationId: selectedEvaluationId,
        onClickLaunchScenarioEvaluation,
        scenarioName: selectedScenarioName
      }
    )
  );
}

// src/modules/network/pages/source/components/select-routes/select-routes.tsx
import React174 from "react";
import { FlexComponent as FlexComponent97, DateInputComponent } from "@ontruck/fe-ui";

// src/modules/network/pages/source/components/box-header/box-header.tsx
import React173 from "react";
import styled113 from "styled-components";
import { FlexComponent as FlexComponent96, TextComponent as TextComponent56 } from "@ontruck/fe-ui";
var BoxHeaderFlexComponent = styled113(FlexComponent96)`
  width: 100%;
  height: 60px;
  background-color: var(--otk-theme-color-grey-100, #f2f5f8);
  padding-left: var(--otk-theme-space-xl, 32px);
  padding-right: var(--otk-theme-space-xl, 32px);
  border: none;
`;
function BoxHeaderComponent2({
  children,
  label
}) {
  return /* @__PURE__ */ React173.createElement(BoxHeaderFlexComponent, { alignItems: "center", flexDirection: "row", justifyContent: "space-between" }, label ? /* @__PURE__ */ React173.createElement(TextComponent56, { fontWeight: "bold" }, label) : null, children);
}

// src/modules/network/pages/source/components/select-routes/select-routes.tsx
function SelectRoutesComponent({
  availableDates,
  handleChangeDate,
  selectedDate
}) {
  return /* @__PURE__ */ React174.createElement(
    FlexComponent97,
    {
      alignItems: "center",
      flex: "none",
      flexDirection: "column",
      height: "400px",
      justifyContent: "center",
      width: "100%"
    },
    /* @__PURE__ */ React174.createElement(BoxHeaderComponent2, { label: "Rutas" }),
    /* @__PURE__ */ React174.createElement(
      DateInputComponent,
      {
        datePickerClassName: "select-shipments-input-date",
        highlightDatepickerDates: availableDates,
        includedDatepickerDates: availableDates,
        name: "select-shipments-input-date",
        onChangeDate: handleChangeDate,
        selectedDatepickerDate: selectedDate,
        shouldCloseOnSelect: false,
        showOnlyDatePicker: true
      }
    )
  );
}

// src/modules/network/pages/source/components/select-shipments/select-shipments.tsx
import React175 from "react";
import styled114 from "styled-components";
import {
  FlexComponent as FlexComponent98,
  Input as InputComponent11
} from "@ontruck/fe-ui";
var SelectShipmentsInputComponent = styled114(InputComponent11)`
  border: none;
`;
function SelectShipmentsComponent({
  availableDates,
  handleChangeDate,
  selectedDate
}) {
  return /* @__PURE__ */ React175.createElement(
    FlexComponent98,
    {
      alignItems: "center",
      flex: "none",
      flexDirection: "column",
      height: "400px",
      justifyContent: "center",
      width: "100%"
    },
    /* @__PURE__ */ React175.createElement(BoxHeaderComponent2, { label: "Env\xEDos" }),
    /* @__PURE__ */ React175.createElement(
      SelectShipmentsInputComponent,
      {
        datePickerClassName: "select-shipments-input-date",
        highlightDatepickerDates: availableDates,
        includedDatepickerDates: availableDates,
        name: "select-shipments-input-date",
        onChangeDate: handleChangeDate,
        selectedDatepickerDate: selectedDate,
        shouldCloseDatepickerOnSelect: false,
        showOnlyDatePicker: true,
        type: "date"
      }
    )
  );
}

// src/modules/network/pages/source/components/trigger-evaluation/trigger-evaluation.tsx
import React176 from "react";
import styled115 from "styled-components";
import { FlexComponent as FlexComponent99, ButtonComponent as ButtonComponent35 } from "@ontruck/fe-ui";
var TriggerEvaluationFlexComponent = styled115(FlexComponent99)`
  padding-left: var(--otk-theme-space-xl, 32px);
  padding-right: var(--otk-theme-space-xl, 32px);
  padding-top: var(--otk-theme-space-m, 8px);
  padding-bottom: var(--otk-theme-space-m, 8px);
  background-color: var(--otk-theme-color-grey-200, #e2e8ee);
`;
function TriggerEvaluationComponent({
  onClickLaunchEvaluation,
  packageDate,
  routeDate
}) {
  const { launchEvaluation } = useNetworkState();
  const handleClick = () => {
    if (packageDate && routeDate) {
      launchEvaluation(packageDate.format("YYYY-MM-DD"), routeDate.format("YYYY-MM-DD"));
      if (onClickLaunchEvaluation) {
        onClickLaunchEvaluation();
      }
    }
  };
  return /* @__PURE__ */ React176.createElement(TriggerEvaluationFlexComponent, { width: "100%" }, /* @__PURE__ */ React176.createElement(ButtonComponent35, { color: "primary", onClick: handleClick, size: "s" }, "Lanzar evaluaci\xF3n"));
}

// src/modules/network/pages/source/components/select-evaluation-source/select-evaluation-source-component.tsx
import React177 from "react";
import { FlexComponent as FlexComponent100, Input as InputComponent12 } from "@ontruck/fe-ui";
import styled116 from "styled-components";
var SelectEvaluationSourceInputComponent = styled116(InputComponent12)`
  background-color: var(--otk-theme-color-primary, #ffcc00);
  border-color: var(--otk-theme-color-primary, #ffcc00);
  padding-left: var(--otk-theme-space-xl, 32px);
  height: 70px;

  > div {
    gap: var(--otk-theme-space-s, 8px);

    > div:has(> div > input) {
      color: var(--otk-theme-color-secondary, #00204d);
      font-weight: var(--otk-theme-font-weight-bold, 700);
      font-size: var(--otk-theme-font-size-xl, 18px);
      line-height: var(--otk-theme-font-line-height-2xl, 20px);
    }
  }

  & label {
    color: var(--otk-theme-color-primary-800, #4d3d00);
  }

  & svg {
    width: 32px;
    height: 32px;

    path {
      fill: var(--otk-theme-color-secondary, #00204d);
    }
  }
`;
var evaluationSources = {
  customEvaluationSource: "custom-evaluation-source",
  scenarioEvaluationSource: "scenario-evaluation-source"
};
var evaluationSourcesOptions = [
  {
    label: "Muestra de evaluaci\xF3n personalizada",
    value: evaluationSources.customEvaluationSource
  },
  {
    label: "Escenario creado",
    value: evaluationSources.scenarioEvaluationSource
  }
];
function SelectEvaluationSourceComponent({
  evaluationSource,
  onChangeEvaluationSource
}) {
  const handleChangeEvaluationSource = (name, value) => {
    if (onChangeEvaluationSource && (value === evaluationSources.customEvaluationSource || value === evaluationSources.scenarioEvaluationSource)) {
      onChangeEvaluationSource(value);
    }
  };
  return /* @__PURE__ */ React177.createElement(FlexComponent100, { alignItems: "center", flexDirection: "column", justifyContent: "center", width: "100%" }, /* @__PURE__ */ React177.createElement(
    SelectEvaluationSourceInputComponent,
    {
      handleChangeValue: handleChangeEvaluationSource,
      name: "select-source",
      options: evaluationSourcesOptions,
      type: "select",
      value: evaluationSource,
      width: "100%"
    }
  ));
}

// src/modules/network/pages/source/components/evaluation-sources/evaluation-sources-component.tsx
import React178, { useEffect as useEffect21, useState as useState47 } from "react";
import moment from "moment";
import { FlexComponent as FlexComponent101 } from "@ontruck/fe-ui";
function EvaluationSourcesComponent({
  onClickLaunchEvaluation
}) {
  const { evaluations, evaluationPackageDate, evaluationRouteDate } = useNetworkState();
  const [selectedPackageDate, setSelectedPackageDate] = useState47();
  const [selectedRouteDate, setSelectedRouteDate] = useState47();
  useEffect21(() => {
    setSelectedPackageDate(evaluationPackageDate ? moment(evaluationPackageDate) : void 0);
    setSelectedRouteDate(evaluationRouteDate ? moment(evaluationRouteDate) : void 0);
  }, [evaluationPackageDate, evaluationRouteDate]);
  const availableDates = evaluations.map((evaluation) => moment(evaluation.packageDate));
  const handleChangePackageDate = (date) => {
    if (!date) {
      return;
    }
    setSelectedPackageDate(date);
    setSelectedRouteDate(date);
  };
  const handleChangeRouteDate = (date) => {
    if (!date) {
      return;
    }
    setSelectedRouteDate(date);
    setSelectedPackageDate(date);
  };
  return /* @__PURE__ */ React178.createElement(
    FlexComponent101,
    {
      flex: "1",
      flexDirection: "column",
      justifyContent: "space-between",
      overflowX: "hidden",
      overflowY: "hidden",
      width: "100%"
    },
    /* @__PURE__ */ React178.createElement(
      FlexComponent101,
      {
        flexDirection: "column",
        height: "calc(100vh - 130px)",
        justifyContent: "space-between",
        overflowX: "hidden",
        overflowY: "auto",
        width: "100%"
      },
      /* @__PURE__ */ React178.createElement(
        SelectRoutesComponent,
        {
          availableDates,
          handleChangeDate: handleChangePackageDate,
          selectedDate: selectedPackageDate
        }
      ),
      /* @__PURE__ */ React178.createElement(
        SelectShipmentsComponent,
        {
          availableDates,
          handleChangeDate: handleChangeRouteDate,
          selectedDate: selectedRouteDate
        }
      )
    ),
    /* @__PURE__ */ React178.createElement(
      TriggerEvaluationComponent,
      {
        onClickLaunchEvaluation,
        packageDate: selectedPackageDate,
        routeDate: selectedRouteDate
      }
    )
  );
}

// src/modules/network/pages/source/source-page.tsx
function SourcePage({
  config,
  leftPanelIsOpen = false,
  onClickLeftSidebarNavigationItem,
  toggleLeftPanelIsOpen,
  onClickLaunchEvaluation
}) {
  const { token, apiBase } = config;
  const { networkId, scenarioParentId } = useNetworkState();
  const [notificationsAreOpen, setNotificationsAreOpen] = useState48(false);
  const [selectedEvaluationSource, setSelectedEvaluationSource] = useState48(
    evaluationSources.customEvaluationSource
  );
  const [selectedEvaluationScenarioSearch, setSelectedEvaluationScenarioSearch] = useState48("");
  const [topBarModuleRegionNode, setTopBarModuleRegionNode] = useState48();
  const [drawerRegionNode, setDrawerRegionNode] = useState48();
  const { scenarios } = useGetScenariosByNameDescriptionOrCreatedBySearchHook({
    config,
    search: selectedEvaluationScenarioSearch
  });
  useLayoutEffect2(() => {
    if (topBarModuleRegionNode) {
      return;
    }
    const node = document.getElementById(TOP_BAR_MODULE_REGION_ID);
    if (!node) {
      console.error(`Node with id ${TOP_BAR_MODULE_ACTIVE_EVALUATION_ID} not found`);
      return;
    }
    setTopBarModuleRegionNode(node);
  }, [topBarModuleRegionNode, setTopBarModuleRegionNode]);
  useLayoutEffect2(() => {
    if (drawerRegionNode) {
      return;
    }
    const node = document.getElementById(DRAWER_REGION_ID_RIGHT3);
    if (!node) {
      console.error(`Node with id ${DRAWER_REGION_ID_RIGHT3} not found`);
      return;
    }
    setDrawerRegionNode(node);
  }, [drawerRegionNode, setDrawerRegionNode]);
  useEffect22(() => {
    if (toggleLeftPanelIsOpen && !leftPanelIsOpen) {
      toggleLeftPanelIsOpen();
    }
  }, []);
  const handleClickSidebarNavigationItem = (navigationItemId) => {
    if (onClickLeftSidebarNavigationItem) {
      onClickLeftSidebarNavigationItem(navigationItemId);
    }
  };
  const handleChangeEvaluationSource = (evaluationSource) => {
    if (!evaluationSource) {
      return;
    }
    if (evaluationSource === selectedEvaluationSource) {
      return;
    }
    setSelectedEvaluationSource(evaluationSource);
  };
  const handleSearchEvaluationScenario = (search) => {
    setSelectedEvaluationScenarioSearch(search);
  };
  const evaluationScenarios = useMemo52(() => {
    return scenarios.filter((scenario) => scenario.evaluationId).map(
      (scenario, i) => {
        var _a, _b, _c;
        return {
          name: scenario.name,
          id: scenario.id,
          description: scenario.description || "",
          createdBy: (_a = scenario.createdBy) != null ? _a : "",
          createdAt: (_b = scenario.createdAt) != null ? _b : "",
          evaluationId: (_c = scenario.evaluationId) != null ? _c : `evaluation-scenario-${i}`
        };
      }
    );
  }, [scenarios]);
  const handleClickNotifications = () => {
    setNotificationsAreOpen(Boolean(!notificationsAreOpen));
  };
  return /* @__PURE__ */ React179.createElement(
    PageLayoutComponent,
    {
      networkId,
      onClickSideBarNavigationItem: handleClickSidebarNavigationItem,
      sidebarNavigationItemIdSelected: navigationItemsIds.SOURCE
    },
    topBarModuleRegionNode ? createPortal4(
      /* @__PURE__ */ React179.createElement(
        TopBarNotificationsComponent,
        {
          networkConfig: config,
          onClickNotifications: handleClickNotifications
        }
      ),
      topBarModuleRegionNode
    ) : null,
    /* @__PURE__ */ React179.createElement(FlexComponent102, { alignItems: "stretch", height: "100%", justifyContent: "stretch", width: "100%" }, /* @__PURE__ */ React179.createElement(
      LeftPanelComponent,
      {
        alignItems: "start",
        flex: "1",
        flexDirection: "column",
        isOpen: leftPanelIsOpen,
        justifyContent: "start",
        overflow: "hidden",
        overflowY: "hidden"
      },
      /* @__PURE__ */ React179.createElement(
        SelectEvaluationSourceComponent,
        {
          evaluationSource: selectedEvaluationSource,
          onChangeEvaluationSource: handleChangeEvaluationSource
        }
      ),
      /* @__PURE__ */ React179.createElement(React179.Fragment, null, selectedEvaluationSource === evaluationSources.customEvaluationSource ? /* @__PURE__ */ React179.createElement(EvaluationSourcesComponent, { onClickLaunchEvaluation }) : /* @__PURE__ */ React179.createElement(
        EvaluationScenariosComponent,
        {
          evaluationScenarioSearch: selectedEvaluationScenarioSearch,
          evaluationScenarios,
          onClickLaunchScenarioEvaluation: onClickLaunchEvaluation,
          onSearchEvaluationScenario: handleSearchEvaluationScenario
        }
      ))
    ), /* @__PURE__ */ React179.createElement(MainPanelComponent, { flex: "1", flexDirection: "column", width: "100%" }, /* @__PURE__ */ React179.createElement(MapComponent2, { delegations: [], reduce: leftPanelIsOpen || false }))),
    /* @__PURE__ */ React179.createElement(
      DrawerComponent5,
      {
        isOpen: notificationsAreOpen,
        nodeRegionId: DRAWER_REGION_ID_RIGHT3,
        onClose: handleClickNotifications,
        opacity: 0.5,
        scrollable: false,
        size: "500px"
      },
      /* @__PURE__ */ React179.createElement(NotificationsComponent, { apiBase, scenarioId: scenarioParentId, token })
    )
  );
}

// src/modules/pricing/contracts/pages/contracts-page.tsx
import { CirclePlusIcon as CirclePlusIcon4 } from "@ontruck/fe-icons";
import {
  FlexComponent as FlexComponent103,
  TableCellComponent as TableCellComponent26,
  TableComponent as TableComponent10,
  TextComponent as TextComponent57,
  ToolbarComponent as ToolbarComponent19,
  Input as Input15,
  PageContent as PageContent18,
  ToolbarButtonComponent as ToolbarButtonComponent18
} from "@ontruck/fe-ui";
import React180, { useCallback as useCallback22, useMemo as useMemo53 } from "react";
import styled117 from "styled-components";

// src/modules/pricing/contracts/hooks/filters-hook.ts
import { useState as useState49 } from "react";
var DEFAULT_PAGINATION_SIZE_FILTER_OPTION4 = 100;
var getFiltersOptions4 = () => {
  return {
    paginationSizes: [100, 200, 500, 1e3]
  };
};
var getDefaultSelectedFilters4 = () => {
  return {
    search: "",
    active: false,
    paginationSize: DEFAULT_PAGINATION_SIZE_FILTER_OPTION4,
    page: 1
  };
};
var getInitialSelectedFilters4 = () => {
  const initialSelectedFilters = getDefaultSelectedFilters4();
  return initialSelectedFilters;
};
var useFiltersHook4 = () => {
  const filtersOptions = getFiltersOptions4();
  const initialSelectedFilters = getInitialSelectedFilters4();
  const [selectedFilters, setSelectedFilters] = useState49(initialSelectedFilters);
  const setPage = (page) => {
    setSelectedFilters(__spreadProps(__spreadValues({}, selectedFilters), {
      page
    }));
  };
  const setPaginationSize = (paginationSize) => {
    setSelectedFilters(__spreadProps(__spreadValues({}, selectedFilters), {
      paginationSize,
      page: 1
    }));
  };
  const setSearch = (search) => {
    setSelectedFilters(__spreadProps(__spreadValues({}, selectedFilters), {
      search,
      page: 1
    }));
  };
  const setActive = (active) => {
    setSelectedFilters(__spreadProps(__spreadValues({}, selectedFilters), {
      active,
      page: 1
    }));
  };
  return {
    filtersOptions,
    selectedFilters,
    setPage,
    setPaginationSize,
    setSearch,
    setActive
  };
};

// src/modules/pricing/contracts/contracts/get-contracts-hooks.ts
import useSWR24 from "swr";

// src/modules/pricing/contracts/contracts/get-contract-mapper.ts
function getContractMapper(contractsDto) {
  if (!contractsDto) {
    return;
  }
  const contracts = contractsDto.results.map((contractDto) => {
    var _a, _b;
    try {
      return {
        id: contractDto.id,
        shipperId: contractDto.shipper.id,
        shipperName: contractDto.shipper.company_name,
        startsAt: contractDto.starts_at,
        endsAt: contractDto.ends_at,
        name: contractDto.name,
        createdByUsername: (_b = (_a = contractDto.created_by) == null ? void 0 : _a.username) != null ? _b : null,
        isActive: contractDto.is_active,
        agreements: contractDto.agreements.map((agreement) => __spreadProps(__spreadValues({}, agreement), {
          priceType: agreement.price_type,
          isActive: agreement.is_active
        })),
        description: contractDto.description,
        operationalRequirements: contractDto.operational_requirements,
        priceType: contractDto.price_type,
        contractType: contractDto.contract_type
      };
    } catch (e) {
      console.error("Error mapping contract with id ", contractDto.id);
      console.error(e);
      throw e;
    }
  }).map((contract) => __spreadProps(__spreadValues({}, contract), {
    agreements: contract.agreements.map((agreement) => __spreadProps(__spreadValues({}, agreement), {
      priceType: agreement.price_type,
      isActive: agreement.is_active
    }))
  }));
  return contracts;
}

// src/modules/pricing/contracts/hooks/get-query-params-from-selected-filters.ts
var getPageSizeQuery4 = (selectedFilters) => {
  return `page_size=${selectedFilters.paginationSize}`;
};
var getPageQuery4 = (selectedFilters) => {
  return `page=${selectedFilters.page}`;
};
var getSearchQuery4 = (selectedFilters) => {
  const searchValue = selectedFilters.search;
  if (searchValue.trim() === "") {
    return null;
  }
  return `search=${searchValue}`;
};
var getActiveQuery = (selectedFilters) => {
  if (!selectedFilters.active) {
    return null;
  }
  return `active=true`;
};
var getQueryParamsFromSelectedFilters4 = (selectedFilters) => {
  let query = `?ordering=starts_at`;
  const pageSizeQuery = getPageSizeQuery4(selectedFilters);
  const searchQuery = getSearchQuery4(selectedFilters);
  const pageQuery = getPageQuery4(selectedFilters);
  const activeQuery = getActiveQuery(selectedFilters);
  const queries = [pageSizeQuery, searchQuery, pageQuery, activeQuery];
  queries.forEach((currentQuery) => {
    if (currentQuery) {
      const paramSeparator = "&";
      query = `${query}${paramSeparator}${currentQuery}`;
    }
  });
  return query;
};

// src/modules/pricing/contracts/contracts/get-contracts-api.ts
var getContractsApi = (_0) => __async(void 0, [_0], function* ({
  selectedFilters,
  config
}) {
  const query = getQueryParamsFromSelectedFilters4(selectedFilters);
  const endpoint = `${config.api_url}v1/pricing/contracts/${query}`;
  const response = yield fetch(endpoint, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${config.token}`
    }
  });
  const data = yield fetchJson(response);
  return data;
});

// src/modules/pricing/contracts/contracts/get-contracts-api-fetcher.ts
var getContractsApiFetcher = (filters, config) => {
  const selectedFilters = JSON.parse(filters);
  return getContractsApi({ selectedFilters, config });
};

// src/modules/pricing/contracts/contracts/get-contracts-hooks.ts
var useContractsService = ({
  selectedFilters,
  config
}) => {
  const filtersKey = JSON.stringify(selectedFilters);
  const fetcher = () => __async(void 0, null, function* () {
    return getContractsApiFetcher(filtersKey, config);
  });
  const { data, error, isLoading, mutate } = useSWR24(filtersKey, fetcher, {
    refreshInterval: 30 * 1e3,
    revalidateIfStale: true
  });
  const contractsMapped = getContractMapper(data);
  return {
    contracts: contractsMapped || [],
    count: (data == null ? void 0 : data.count) || 0,
    isLoading,
    error,
    mutate
  };
};

// src/modules/pricing/contracts/pages/contracts-page.tsx
var ContractsPageLayoutStyled = styled117.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;
var FiltersComponent4 = styled117(FlexComponent103)`
  gap: 16px;
  align-items: center;
`;
var DATA_MAPPER_CONFIG = {
  name: "name",
  shipperName: "shipperName",
  shipperId: "shipperId",
  createdBy: "createdByUsername",
  contractType: "contractType",
  priceType: "priceType",
  startsAt: "startsAt",
  endsAt: "endsAt",
  isActive: "isActive"
};
var TABLE_HEADER_COLUMNS_CONFIG = {
  name: {
    id: "0",
    width: "165px",
    isHidden: false
  },
  shipperName: {
    id: "1",
    width: "165px",
    isHidden: false
  },
  shipperId: {
    id: "2",
    width: "165px",
    isHidden: false
  },
  createdBy: {
    id: "3",
    width: "165px",
    isHidden: false
  },
  contractType: {
    id: "4",
    width: "165px",
    isHidden: false
  },
  startsAt: {
    id: "5",
    width: "165px",
    isHidden: false
  },
  endsAt: {
    id: "6",
    width: "165px",
    isHidden: false
  },
  isActive: {
    id: "7",
    width: "165px",
    isHidden: false
  }
};
function ContractsPage({
  consumerConfig,
  contractsPageTranslations,
  onGoToNew,
  onGotToDetail
}) {
  const filters = useFiltersHook4();
  const data = useContractsService({
    selectedFilters: filters.selectedFilters,
    config: consumerConfig
  });
  const handleChangePageSize = (pageSize) => {
    filters.setPaginationSize(pageSize);
  };
  const handleGoToPreviousPage = () => {
    if (filters.selectedFilters.page > 1) {
      filters.setPage(filters.selectedFilters.page - 1);
    }
  };
  const handleGoToPage = (pageIndex) => {
    filters.setPage(pageIndex);
  };
  const handleGoToNextPage = () => {
    const totalPages = Math.ceil(data.count / filters.selectedFilters.paginationSize);
    if (filters.selectedFilters.page < totalPages) {
      filters.setPage(filters.selectedFilters.page + 1);
    }
  };
  const columns = useMemo53(() => {
    const sortedColumns = Object.entries(TABLE_HEADER_COLUMNS_CONFIG).sort(
      ([, a], [, b]) => Number(a.id) - Number(b.id)
    );
    return sortedColumns.reduce(
      (acc, [columnKey, columnConfig]) => __spreadProps(__spreadValues({}, acc), {
        [columnKey]: __spreadProps(__spreadValues({}, columnConfig), {
          label: String(
            contractsPageTranslations.columns[columnKey]
          )
        })
      }),
      {}
    );
  }, [contractsPageTranslations]);
  const getContractRowsComponents = useCallback22(
    (contracts) => {
      return contracts.map((contractItem) => {
        const contractId = contractItem.id;
        if (!contractId)
          return null;
        const sortedColumns = Object.entries(TABLE_HEADER_COLUMNS_CONFIG).sort(
          ([, a], [, b]) => Number(a.id) - Number(b.id)
        );
        return /* @__PURE__ */ React180.createElement(
          FlexComponent103,
          {
            alignItems: "center",
            borderTop: "1px solid var(--otk-theme-color-grey-200, #E2E8EE)",
            key: contractId,
            onClick: () => {
              onGotToDetail(contractId);
            }
          },
          sortedColumns.map(([key, config]) => {
            if (config.isHidden)
              return null;
            const dataKey = DATA_MAPPER_CONFIG[key];
            const value = contractItem[dataKey];
            return /* @__PURE__ */ React180.createElement(
              TableCellComponent26,
              {
                borderLeft: "1px solid var(--otk-theme-color-grey-200, #E2E8EE)",
                key,
                width: config.width
              },
              /* @__PURE__ */ React180.createElement(TextComponent57, null, value ? String(value) : "")
            );
          })
        );
      }).filter(Boolean);
    },
    [onGotToDetail]
  );
  const rowComponents = useMemo53(
    () => getContractRowsComponents(data.contracts),
    [data.contracts, getContractRowsComponents]
  );
  return /* @__PURE__ */ React180.createElement(ContractsPageLayoutStyled, null, /* @__PURE__ */ React180.createElement(ToolbarComponent19, null, /* @__PURE__ */ React180.createElement(FiltersComponent4, null, /* @__PURE__ */ React180.createElement(
    Input15,
    {
      handleChangeEvent: (e) => {
        const newValue = e.target.value;
        filters.setSearch(newValue);
      },
      label: contractsPageTranslations.filters.search,
      name: "search",
      type: "search",
      value: filters.selectedFilters.search,
      width: "200px"
    }
  ), /* @__PURE__ */ React180.createElement(
    Input15,
    {
      handleChangeValue: (name, value) => {
        const newValue = value === "true";
        filters.setActive(newValue);
      },
      label: contractsPageTranslations.filters.active,
      name: "active",
      type: "checkbox",
      value: filters.selectedFilters.active.toString()
    }
  ), /* @__PURE__ */ React180.createElement(ToolbarButtonComponent18, { onClick: onGoToNew }, /* @__PURE__ */ React180.createElement(CirclePlusIcon4, { color: "var(--accent-color-blue)", sizeInPixels: 20 }), contractsPageTranslations.new_contract))), /* @__PURE__ */ React180.createElement(PageContent18, null, /* @__PURE__ */ React180.createElement(
    TableComponent10,
    {
      columns,
      emptyStateMessage: contractsPageTranslations.no_contracts_found,
      isError: data.error !== void 0,
      isLoading: data.isLoading,
      numberOfItems: data.count,
      onChangePageSize: handleChangePageSize,
      onGoToNextPage: handleGoToNextPage,
      onGoToPage: handleGoToPage,
      onGoToPreviousPage: handleGoToPreviousPage,
      pageIndex: filters.selectedFilters.page,
      pageSize: filters.selectedFilters.paginationSize,
      pageSizes: filters.filtersOptions.paginationSizes,
      resultsPerPageLabel: contractsPageTranslations.filters.resultsPerPage,
      rowsComponents: rowComponents
    }
  )));
}

// src/modules/detail-something/detail-something-component.tsx
import React189 from "react";
import { FlexComponent as FlexComponent109 } from "@ontruck/fe-ui";

// src/modules/detail-something/header/header-component.tsx
import React183 from "react";
import styled120 from "styled-components";
import { CloseIcon as CloseIcon15 } from "@ontruck/fe-icons";
import { ButtonComponent as ButtonComponent36, FlexComponent as FlexComponent104 } from "@ontruck/fe-ui";

// src/modules/detail-something/header/header-label-component.tsx
import React181 from "react";
import styled118 from "styled-components";
var HeaderLabelContainer2 = styled118.span`
  font-family: var(--otk-theme-font-family-primary, Roboto);
  font-size: var(--otk-theme-font-size, 14px);
  color: var(--otk-theme-color-grey-500, #94a6b8);
`;
function HeaderLabelComponent2({ children }) {
  return /* @__PURE__ */ React181.createElement(HeaderLabelContainer2, null, children);
}

// src/modules/detail-something/header/header-title-component.tsx
import React182 from "react";
import styled119 from "styled-components";
var HeaderTitleContainer = styled119.span`
  font-family: var(--otk-theme-font-family-primary, Roboto);
  font-size: var(--otk-theme-font-size-l, 18px);
  color: var(--otk-theme-color-primary-400, #57b1e5);
  text-transform: uppercase;
`;
function HeaderTitleComponent({ children }) {
  return /* @__PURE__ */ React182.createElement(HeaderTitleContainer, null, children);
}

// src/modules/detail-something/header/header-component.tsx
var CloseIconStyled4 = styled120(CloseIcon15)`
  width: var(--otk-ui-icon-l-size);
  height: var(--otk-ui-icon-l-size);
  path {
    fill: var(--otk-theme-color-primary-400, --otk-theme-color-blue-400);
  }

  :hover {
    path {
      fill: var(--otk-theme-color-primary-500, #2396dc);
    }
  }
`;
var HeaderContainer2 = styled120.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: calc(var(--otk-theme-space-5xl) + calc(var(--otk-theme-space-s) / 2));
  padding: 0 var(--otk-theme-space-xl) 0 var(--otk-theme-space-xl);
  align-content: center;
  border-bottom: 1px solid var(--otk-theme-color-grey-300);
`;
function HeaderComponent2({
  onClose,
  children
}) {
  return /* @__PURE__ */ React183.createElement(HeaderContainer2, null, /* @__PURE__ */ React183.createElement(FlexComponent104, { flexDirection: "column" }, children), /* @__PURE__ */ React183.createElement(ButtonComponent36, { onClick: onClose, variant: "icon" }, /* @__PURE__ */ React183.createElement(CloseIconStyled4, null)));
}
HeaderComponent2.Label = HeaderLabelComponent2;
HeaderComponent2.Title = HeaderTitleComponent;

// src/modules/detail-something/content/content-component.tsx
import React184 from "react";
import { FlexComponent as FlexComponent105 } from "@ontruck/fe-ui";
function ContentComponent2({ children }) {
  return /* @__PURE__ */ React184.createElement(
    FlexComponent105,
    {
      alignItems: "stretch",
      backgroundColor: "var(--otk-theme-color-grey-100, #f2f5f8)",
      flex: "1",
      height: "100%",
      justifyContent: "space-between",
      overflowY: "auto",
      width: "100%"
    },
    children
  );
}

// src/modules/detail-something/footer/footer-component.tsx
import React185 from "react";
import styled121 from "styled-components";
import {
  ButtonComponent as ButtonComponent37,
  ButtonContainer as ButtonContainer7,
  Half as HalfComponent,
  Sticky as StickyComponent,
  BoxesSpinnerComponent as BoxesSpinnerComponent2
} from "@ontruck/fe-ui";
var FooterBoxesSpinnerComponent = styled121(BoxesSpinnerComponent2)`
  path {
    fill: #fff;
  }
`;
var FooterWrapperStickyComponent = styled121(StickyComponent)`
  width: 100%;
  height: 80px;
  align-items: center;
  justify-content: center;
`;
function FooterComponent({
  hasChangesToBeSaved = false,
  isEditMode = false,
  isSaving = false,
  onSave,
  isNewMode = false,
  onNew,
  newButtonText = "Nuevo",
  isDisabled = false
}) {
  return /* @__PURE__ */ React185.createElement(FooterWrapperStickyComponent, null, isEditMode ? /* @__PURE__ */ React185.createElement(ButtonContainer7, null, /* @__PURE__ */ React185.createElement(HalfComponent, null, /* @__PURE__ */ React185.createElement(
    ButtonComponent37,
    {
      color: "primary",
      fullWidth: true,
      isDisabled: !hasChangesToBeSaved || isSaving,
      onClick: onSave
    },
    isSaving ? /* @__PURE__ */ React185.createElement(FooterBoxesSpinnerComponent, { sizeInPixels: 16 }) : null,
    isSaving ? "Guardando" : "Guardar"
  ))) : null, isNewMode ? /* @__PURE__ */ React185.createElement(ButtonContainer7, null, /* @__PURE__ */ React185.createElement(ButtonComponent37, { color: "primary", fullWidth: true, isDisabled, onClick: onNew }, isSaving ? /* @__PURE__ */ React185.createElement(FooterBoxesSpinnerComponent, { sizeInPixels: 16 }) : null, newButtonText)) : null);
}

// src/modules/detail-something/section/section-component.tsx
import React186 from "react";
import styled123 from "styled-components";
import { FlexComponent as FlexComponent106 } from "@ontruck/fe-ui";

// src/modules/detail-something/section/section-title-component.tsx
import styled122 from "styled-components";
var SectionTitleComponent = styled122.h3`
  font-family: var(--otk-theme-font-family-primary, Roboto);
  font-size: var(--otk-theme-font-size-l, 18px);
  font-weight: var(--otk-theme-color-grey-900, #263340);
  color: var(--otk-theme-font-weight-medium, 500);
  margin: 0 0 var(--otk-theme-space-m, 16px) 0;
`;

// src/modules/detail-something/section/section-component.tsx
var SectionWrapperComponent = styled123.div`
  width: 100%;
  max-width: ${({ maxWidth }) => maxWidth || "unset"};
  padding: var(--otk-theme-space-l) var(--otk-theme-space-m) var(--otk-theme-space-l)
    var(--otk-theme-space-m);
  background-color: ${({ dark }) => dark && `var(--otk-theme-color-grey-200, #e2e8ee)`};
  background-color: ${({ light }) => light && `var(--otk-theme-color-grey-100, #f2f5f8)`};
`;
var SectionFlexComponent = styled123(FlexComponent106)`
  width: 100%;

  legend {
    padding: 0px 0px var(--otk-theme-space-xl) 0px;
  }
`;
function SectionComponent3({
  light = false,
  dark = false,
  maxWidth = "640px",
  children
}) {
  return /* @__PURE__ */ React186.createElement(SectionWrapperComponent, { dark, light, maxWidth }, /* @__PURE__ */ React186.createElement(FlexComponent106, { alignItems: "center", flexDirection: "column", justifyContent: "center" }, /* @__PURE__ */ React186.createElement(SectionFlexComponent, { flexDirection: "column", justifyContent: "center" }, children)));
}
SectionComponent3.Title = SectionTitleComponent;

// src/modules/detail-something/section/sections-component.tsx
import React187 from "react";
import { FlexComponent as FlexComponent107 } from "@ontruck/fe-ui";
function SectionsComponent({ children }) {
  return /* @__PURE__ */ React187.createElement(
    FlexComponent107,
    {
      alignItems: "center",
      flex: "1",
      flexDirection: "column",
      height: "auto",
      justifyContent: "stretch",
      overflowY: "auto"
    },
    children
  );
}

// src/modules/detail-something/right-sidebar/right-sidebar-component.tsx
import React188 from "react";
import { FlexComponent as FlexComponent108 } from "@ontruck/fe-ui";
function RightSidebarComponent({ children }) {
  return /* @__PURE__ */ React188.createElement(
    FlexComponent108,
    {
      flex: "1",
      flexDirection: "column",
      height: "100%",
      maxWidth: "400px",
      overflow: "hidden",
      overflowY: "hidden"
    },
    children
  );
}

// src/modules/detail-something/detail-something-component.tsx
function DetailSomethingComponent({ children }) {
  return /* @__PURE__ */ React189.createElement(
    FlexComponent109,
    {
      flexDirection: "column",
      height: "100%",
      overflow: "hidden",
      overflowY: "hidden",
      width: "100%"
    },
    children
  );
}
DetailSomethingComponent.Header = HeaderComponent2;
DetailSomethingComponent.Content = ContentComponent2;
DetailSomethingComponent.Footer = FooterComponent;
DetailSomethingComponent.Section = SectionComponent3;
DetailSomethingComponent.Sections = SectionsComponent;
DetailSomethingComponent.RightSidebar = RightSidebarComponent;
export {
  CarrierForm,
  CarrierFormFields,
  ContractsPage,
  DelegationCargoDetailPage,
  DelegationCargosPage,
  DelegationScanConsolidatePage,
  DelegationScanReceivePage,
  DetailSomethingComponent,
  EditCarrierPage,
  EditGroupPage,
  EditShipperPage,
  EditShipperUserPage,
  EditUserPage,
  GroupsPage,
  EvaluatorPage as NetworkEvaluatorPage,
  RoutesPage as NetworkRoutesPage,
  SourcePage as NetworkSourcePage,
  NetworkStateProvider,
  NewCarrierPage,
  NewGroupPage,
  NewShipperPage,
  NewShipperUserPage,
  NewUserPage,
  ShippersPage,
  TOP_BAR_MODULE_ACTIVE_EVALUATION_ID,
  TOP_BAR_MODULE_REGION_ID,
  UsersPage,
  carrierTranslationsMocks,
  getReadableDate,
  navigationItemsIds
};
